(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history.orderDetails', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history.orderDetails')
        .directive('eventBox', eventBox);

    /* @ngInject */
    function eventBox() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/user/history/order-details/event-box/event-box.html',
            scope: {
                events: '=',
                loading: '='
            }
        };

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool', [
            "ngMaterial",
            "ngAria",
            "ngMessages",
            "ngAnimate",
            "ngSanitize",
            "ngResource",
            "ui.router",
            "pascalprecht.translate",
            "ngStorage",
            "ui.mask",
            "ui.select",
            'ui.bootstrap',
            'cwill747.phonenumber',
            'monospaced.qrcode',


            'onlineShippingTool.landing',
            'onlineShippingTool.address',
            'onlineShippingTool.payment',
            'onlineShippingTool.receipt',
            'onlineShippingTool.sidebar',
            'onlineShippingTool.user',
            'onlineShippingTool.banners',
            'onlineShippingTool.customs',
            'onlineShippingTool.customsNew',
            'onlineShippingTool.signup',
        ]);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('productTableSender', productTableSender);

    /* @ngInject */
    function productTableSender() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/common/product-table/sender/sender.directive.html',
            scope: {
                sender: '=',
                isCustomerCompany: '='
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('productTableReceiver', productTableReceiver);

    /* @ngInject */
    function productTableReceiver() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/common/product-table/receiver/receiver.directive.html',
            scope: {
                product: '=',
                country: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watchGroup(['product', 'country'], setInternational);

            function setInternational(newVals) {
                if (scope.country && scope.product) {
                    scope.isInternational = scope.country !== scope.product.receiver.address.countryCode;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('productTableLetters', productTableLetters);

    /* @ngInject */
    function productTableLetters() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/common/product-table/letters/letters.directive.html',
            scope: {
                letters: '=',
                isSubmitting: '=',
                isCustomerCompany: '=',
                isReceipt: '=',
                confirmDelete: '<',
                showErrorDialog: '<'
            },
            controller: ProductTableLettersController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }

    ProductTableLettersController.$inject = ['$state', '$timeout', 'Common', 'CartFactory'];

    /* @ngInject */
    function ProductTableLettersController($state, $timeout, Common, CartFactory) {
        var vm = this;
        var productUpdateInProgress = false;
        var productToUpdate = null;

        vm.increase = increase;
        vm.decrease = decrease;
        vm.onBlur = onBlur;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;

        ///////////////////

        function decrease(ev, product) {
            if (product && product.quantity > 1) {
                product.quantity--;
                updateProduct(product);
            } else if (product && product.quantity === 1) {
                vm.confirmDelete(ev, product);
            } else {
                product.quantity = 1;
                updateProduct(product);
            }

            return product;
        }

        function increase(product) {
            if (product.quantity >= 1) {
                product.quantity++;
            } else {
                product.quantity = 1;
            }

            updateProduct(product);

            return product;
        }

        function onBlur(product) {
            if (product.quantity < 1 || !product.quantity) {
                product.quantity = 1;
            }
            updateProduct(product);
        }

        function updateProduct(product) {
            productToUpdate = product;

            if (!productUpdateInProgress) {
                productUpdateInProgress = true;
                $timeout(function () {
                    productUpdateInProgress = false;
                    CartFactory.updateProduct(productToUpdate)
                        .catch(function (error) {
                            vm.showErrorDialog(false);
                        });
                }, 1000);
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkSliderInput', dkSliderInput);

    /* @ngInject */
    function dkSliderInput() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-selector/dk-slider/slider-input.directive.html',
            scope: {
                weight: '='
            },
            link: linkFunc,
            controller: SliderInputController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.weight', scope.ctrl.setWeight);
        }
    }

    SliderInputController.$inject = [];

    /* @ngInject */
    function SliderInputController() {
        var vm = this;

        vm.unit = "g";
        vm.value = 50;
        vm._weight = { value: 50, unit: 'g' };
        vm.isFocussed = false;

        vm.setWeight = setWeight;
        vm.onChange = onChange;
        vm.onFocus = onFocus;
        vm.onBlur = onBlur;
        vm.onKeydown = onKeydown;

        //////////////

        function setWeight(weight) {
            if (weight) {
                vm._weight = angular.copy(weight);
            }
        }

        function onChange(value) {
            vm.hasUnitInValue = value.indexOf('k') !== -1 || value.indexOf('g') !== -1;

            var numberValue = parseFloat(value.replace(/[^0-9,.]/g, ''));
            var unitType = value.replace(/[^a-z]/g, '');
            var hasKg = value.indexOf('kg') !== -1;
            var hasG = value.indexOf('g') !== -1;

            if (numberValue) {
                if(hasKg || hasG) {
                    vm._weight.unit = hasKg ? 'kg' : 'g';
                } else {
                    vm._weight.unit = numberValue < 35 ? 'kg' : 'g';
                }
            }
        }

        function onFocus(value) {
            vm.isFocussed = true;
            vm.previousValue = value;
        }

        function onBlur(value) {
            vm.isFocussed = false;
            value = value.replace(/[,]/g,'.');
            var numberValue = parseFloat(('' + value).replace(/[^0-9,.]/g, ''));
            vm._weight.value = (!numberValue || numberValue.length === 0) ? vm.previousValue : numberValue;
            vm.hasUnitInValue = false;

            update();
        }

        function onKeydown(e) {
            if (e.keyCode == 13) {
                vm.isFocussed = false;
                document.getElementById('dkSliderWeightInput').blur();
                update();
            }
        }

        function update(value) {
            vm.weight = angular.copy(vm._weight);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('dkSlider', dkSlider);

    function dkSlider() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-selector/dk-slider/dk-slider.directive.html',
            scope: {
                weight: '=',
                receiverCountryCode: '='
            },
            link: linkFunc,
            controller: SliderController,
            controllerAs: 'slider',
            bindToController: true
        };
        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('slider.weight', scope.slider.setWeight, true);
            scope.$watch('slider.receiverCountryCode', scope.slider.activate, true);
        }
    }


    SliderController.$inject = ['$log', '$sessionStorage', '$timeout'];

    /* @ngInject */
    function SliderController($log, $sessionStorage, $timeout) {
        var vm = this;

        vm.updateIndex = updateIndex;
        vm.setWeight = setWeight;
        vm.activate = activate;

        vm.slideroptionsDomestic = [
            {value: 50, label: '50', unit: 'g'},
            {value: 100, label: '100', unit: 'g'},
            {value: 250, label: '250', unit: 'g'},
            {value: 500, label: '500', unit: 'g'},
            {value: 1000, label: '1', unit: 'kg'},
            {value: 2000, label: '2', unit: 'kg'},
            {value: 5000, label: '5', unit: 'kg'},
            {value: 10000, label: '10', unit: 'kg'},
            {value: 15000, label: '15', unit: 'kg'},
            {value: 20000, label: '20', unit: 'kg'},
            {value: 25000, label: '25', unit: 'kg'},
            {value: 30000, label: '30', unit: 'kg'},
            {value: 35000, label: '35', unit: 'kg'},
        ];
        vm.slideroptionsInternational = [
            {value: 100, label: '100', unit: 'g'},
            {value: 250, label: '250', unit: 'g'},
            {value: 500, label: '500', unit: 'g'},
            {value: 1000, label: '1', unit: 'kg'},
            {value: 2000, label: '2', unit: 'kg'},
            {value: 5000, label: '5', unit: 'kg'},
            {value: 10000, label: '10', unit: 'kg'},
            {value: 15000, label: '15', unit: 'kg'},
            {value: 20000, label: '20', unit: 'kg'},
        ];

        function activate() {

            if(vm.receiverCountryCode) {
                if(vm.receiverCountryCode !== 'DK') {
                    vm.slideroptions = vm.slideroptionsInternational;
                } else {
                    vm.slideroptions = vm.slideroptionsDomestic;
                }
                if (!vm.weight) {
                    updateIndex(0);
                } else {
                    setWeight(vm.weight);
                }
            }
        }

        function updateIndex(index) {
            vm.selectedWeightView = vm.slideroptions[index];

            vm.weight = {
                value: vm.selectedWeightView.label,
                unit: vm.selectedWeightView.unit
            };
        }

        function setWeight(weight) {

            if (weight && vm.slideroptions) {
                var parsedWeight = parseFloat(weight.value);
                var normalizedWeight = weight.unit === 'kg' ? (parsedWeight * 1000) : parsedWeight;

                var option = _.find(vm.slideroptions, function (option){
                    return normalizedWeight <= option.value;
                }) || _.last(vm.slideroptions);
                vm.weight = {
                    value: option.label,
                    unit: option.unit
                };
                $timeout(
                    function() {
                        vm.selectedIndex = _.indexOf(vm.slideroptions, option);
                }, 0
                );

            }

        }


    }


})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('dkProductViewer', dkProductViewer);

    function dkProductViewer() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-selector/dk-product-viewer/dk-product-viewer.directive.html',
            controller: ProductviewerController,
            scope: {
                products: '=',
                weight: '=',
                selectedProduct: '=',
                isCustomerCompany: '='
            },
            link: function(scope){
                scope.$watch('productViewer.weight', scope.productViewer.updatePossibleProducts);
                scope.$watch('productViewer.products', scope.productViewer.updatePossibleProducts);
            },
            controllerAs: 'productViewer',
            bindToController: true
        };
        return directive;
    }



    ProductviewerController.$inject = ['$log', '$scope'];

    /* @ngInject */
    function ProductviewerController($log, $scope) {
        var vm = this;

        vm.updatePossibleProducts = updatePossibleProducts;
        vm.selectProduct = selectProduct;
        vm.filteredProducts = [];
        ////////////////

        function updatePossibleProducts(weight) {
            var normalizedInputWeight = vm.weight && (vm.weight.unit === 'kg' ? vm.weight.value * 1000 : vm.weight.value);

            vm.filteredProducts = [];
            _.forEach(vm.products, function(product) {
                var normalizedMinWeight = product.minWeight.unit === 'kg' ? product.minWeight.value * 1000 : product.minWeight.value;
                var normalizedMaxWeight = product.maxWeight.unit === 'kg' ? product.maxWeight.value * 1000 : product.maxWeight.value;

                if(normalizedMaxWeight >= normalizedInputWeight && normalizedMinWeight <= normalizedInputWeight){
                    vm.filteredProducts.push(product);
                }
            });

            if (vm.filteredProducts.length > 0) {
                var selectedProduct = _.find(vm.filteredProducts, function (product) {
                    return product.name === vm.selectedProduct.name;
                }) || vm.filteredProducts[0];
                if (selectedProduct.productId !== vm.selectedProduct.productId) {
                    vm.selectedProduct = angular.copy(selectedProduct);
                }
            }
        }

        function selectProduct(product) {
            if (product.productId !== vm.selectedProduct.productId) {
                vm.selectedProduct = angular.copy(product);
            }
        }
    }


})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductListProduct', dkProductListProduct());

    /* @ngInject */
    function dkProductListProduct() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-selector/product-list/product.html',
            controller: ProductListProductController,
            bindings: {
                isCustomerCompany: '<',
                productGroup: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductListProductController($log) {
        var vm = this;

        vm.$onChanges = $onChanges;

        // ///////////////////

        function $onChanges() {
            if (vm.productGroup) {
                var firstProduct = vm.productGroup.products[0];
                var name = (vm.productGroup.products.length > 1 && firstProduct.group) ? firstProduct.group.name : firstProduct.name;

                var price = calculatePrice(vm.productGroup.products);

                vm.product = {
                    name: name,
                    type: firstProduct.group ? firstProduct.group.type : firstProduct.type,
                    imageUrl: firstProduct.imageUrl,
                    price: price,
                    priceUnit: firstProduct.priceUnit,
                    isTraceable: !firstProduct.nonTraceable
                };
            }
        }

        function calculatePrice(products) {
            return _.chain(products)
                .map(getPriceForProduct)
                .min()
                .value();
        }

        function getPriceForProduct(product) {
            var price = product.price;

            if (!vm.isCustomerCompany) {
                price = price * (1 + product.vat / 10000);
            }

            return price;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductList', dkProductList());

    /* @ngInject */
    function dkProductList() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-selector/product-list/product-list.html',
            controller: ProductListController,
            bindings: {
                isCustomerCompany: '<',
                productGroups: '<',
                selectedProduct: '=',
                selectedProductGroup: '=',
                selectedWeight: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductListController($log, $stateParams, $timeout) {
        var vm = this;

        vm.$onInit = $onInit;
        vm.$onChanges = filterProductGroups;
        vm.selectProduct = selectProduct;

        function $onInit() {
            // vm.filteredProductGroups = vm.productGroups;
        }

        function filterProductGroups() {
            $timeout(function () {
                if (vm.selectedWeight && vm.productGroups && vm.productGroups.length > 0) {
                    var inputWeight = normalizeWeight(vm.selectedWeight);

                    vm.filteredProductGroups = _.filter(vm.productGroups, function (productGroup) {
                        var minWeight = normalizeWeight(productGroup.minWeight);
                        var maxWeight = normalizeWeight(productGroup.maxWeight);

                        return maxWeight >= inputWeight && minWeight <= inputWeight;
                    });

                    setSelectedProduct(vm.filteredProductGroups);
                    setSelectedProductGroup(vm.filteredProductGroups);
                }
            });
        }

        function setSelectedProduct(productGroups) {
            var hasSelectedProduct = vm.selectedProduct && _.some(productGroups, function (productGroup) {
                return _.some(productGroup.products, { productId: vm.selectedProduct.productId });
            });

            if (!hasSelectedProduct) {
                var matchingProduct;

                _.each(productGroups, function (productGroup) {
                    var _matchingProduct = vm.selectedProduct && _.find(productGroup.products, { name: vm.selectedProduct.name });

                    if (_matchingProduct) {
                        matchingProduct = _matchingProduct;
                    }
                });

                if (matchingProduct) {
                    vm.selectedProduct = angular.copy(matchingProduct);
                } else if (productGroups && productGroups.length > 0 && productGroups[0].products && productGroups[0].products.length > 0) {
                    vm.selectedProduct = angular.copy(productGroups[0].products[0]);
                } else {
                    vm.selectedProduct = null;
                }
            }
        }

        function setSelectedProductGroup(productGroups) {
            _.each(productGroups, function (productGroup) {
                var hasSelectedProduct = _.some(productGroup.products, { productId: vm.selectedProduct.productId });
                productGroup.selected = hasSelectedProduct;

                if (hasSelectedProduct) {
                    vm.selectedProductGroup = angular.copy(productGroup);
                }
            });
        }

        function normalizeWeight(weightObj) {
            return weightObj.unit === 'kg' ? weightObj.value * 1000 : weightObj.value;
        }

        function selectProduct(productGroup) {
            vm.selectedProductGroup = angular.copy(productGroup);
            vm.selectedProduct = angular.copy(productGroup.products[0]);

            setSelectedProductGroup(vm.filteredProductGroups);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductGroupProductParcelValue', dkProductGroupProductParcelValue());

    /* @ngInject */
    function dkProductGroupProductParcelValue() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-product-selector/parcel-value/parcel-value.html',
            controller: ProductGroupProductParcelValueController,
            bindings: {
                product: '=',
                isCustomerCompany: '<',
                isProductSubmitted: '=',
                isValid: '=',
                selectProduct: '&'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductGroupProductParcelValueController($log, $timeout) {
        var vm = this;

        vm.isVerifyingParcelValue = false;
        // vm.isValid = false;

        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;

        vm.verifyParcelValue = verifyParcelValue;
        vm.handleParcelValueChange = handleParcelValueChange;

        // /////////////////////

        function $onInit() {
            setHighestInsuranceAmount(vm.product);
            setValidity(vm.product);
        }

        function $onChanges() {
            if (vm.product) {
                verifyParcelValue(vm.product);
                setHighestInsuranceAmount(vm.product);
                setValidity(vm.product);
            }
        }

        function verifyParcelValue(product) {
            vm.isVerifyingParcelValue = true;

            var parcelValue = parseFloat(product.parcelValue);

            $timeout(function () {
                if (parcelValue) {
                    var insuranceService = selectInsurance(product, parcelValue);

                    product.hasVerifiedParcelValue = true;
                    vm.insurancePrice = getSelectedInsurancePrice(product.additionalServices);
                }

                vm.isVerifyingParcelValue = false;

                var tmp = angular.copy(product);
                setAdditionalServices(product, tmp);
                vm.selectProduct(product);
                setValidity(product);
            }, 1000);
        }

        function handleParcelValueChange(product) {
            delete product.hasVerifiedParcelValue;
            vm.isTooExpensive = false;

            deselectInsurances(product);
            setValidity(product);
        }

        function selectInsurance(product, parcelValue) {
            deselectInsurances(product);

            var insuranceService;

            if (parcelValue) {
                if (parcelValue <= vm.highestInsuranceAmount) {
                    insuranceService = _.find(product.additionalServices, function (service) {
                        return service.type === 'valuableTypeInsurance' && parcelValue >= service.minInsurance.value && parcelValue <= service.maxInsurance.value;
                    });

                    if (insuranceService) {
                        insuranceService.selected = true;
                        insuranceService.parcelValue = parcelValue;

                        if (insuranceService.included) {
                            delete insuranceService.override;
                        } else {
                            var includedInsuranceService = _.find(product.additionalServices, { type: 'valuableTypeInsurance', included: true });
                            if (includedInsuranceService) {
                                includedInsuranceService.override = true;
                            }
                        }
                    }
                } else {
                    vm.isTooExpensive = true;
                }
            }
        }

        function deselectInsurances(product) {
            _.each(product.additionalServices, function (service) {
                if (service.type === 'valuableTypeInsurance') {
                    delete service.selected;
                }
            });
        }

        function getSelectedInsurancePrice(additionalServices) {
            var insuranceService = _.find(additionalServices, { type: 'valuableTypeInsurance', selected: true });
            return insuranceService ? insuranceService.price : 0;
        }

        function setHighestInsuranceAmount(product) {
            vm.highestInsuranceAmount = product.maxInsurance / 100;
            vm.insuranceInputPlaceholder = Math.min(vm.highestInsuranceAmount, '10000');
        }

        function setValidity(product) {
            if (product) {
                vm.isValid = !!product.hasVerifiedParcelValue && !vm.isTooExpensive;
            }
        }

        function setAdditionalServices(product, tmp) {
            product.additionalServices = _.map(product.additionalServices, function (service) {
                if (service.type !== 'valuablesDeliveryTime') {
                    return _.find(tmp.additionalServices, { additionalServiceId: service.additionalServiceId }) || service;
                } else {
                    return service;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('nextWeekdayValidator', nextWeekdayValidator);

    nextWeekdayValidator.$inject = ['ExpressValidatorFactory'];

    function nextWeekdayValidator(ExpressValidatorFactory) {
       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/delivery-option-selector/next-weekday-validator/next-weekday-validator.directive.html',
            scope: {
                productCode: '=',
            },
            controller: NextWeekdayValidatorController,
            controllerAs: 'nextWeekdayValidator',
            bindToController: true
        };
        return directive;

        function NextWeekdayValidatorController() {
            var vm = this;

            vm.isValid = false;
            vm.isValidating = false;
            vm.isSubmitted = false;

            vm.validateNextWeekday = validateNextWeekday;

            //////////////////////

            function validateNextWeekday(fromZipcode, zipcode, productCode) {
                if(zipcode) {
                    vm.isValidating = true;
                    vm.isSubmitted = false;

                    setTimeout(function(){
                        ExpressValidatorFactory.checkDeliverytime(fromZipcode, zipcode, productCode).then(function(response){
                            vm.validatedData = _.get(response, 'data["se.posten.loab.lisp.notis.publicapi.serviceapi.TransitTimeResponse"].transitTimes[0]');                        ;
                            vm.isSubmitted = true;
                            vm.isValidating = false;

                            // check if express is available
                            vm.isValid = vm.validatedData && vm.validatedData.transitTimeInDays === 1;
                        }).catch(function(e){
                            if(e === 'error'){
                                vm.isValid = false;
                                vm.isSubmitted = true;
                                vm.isValidating = false;
                            }
                        });
                    }, 750);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('responsibility', responsibility);

    responsibility.$inject = ['$window', '$http'];

    function responsibility($window, $http) {

       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/responsibility/responsibility.directive.html',
            scope: {
                product: '=',
                maxAmountInput: '=',
            },
            controller: responsibilityController,
            controllerAs: 'responsibility',
            bindToController: true
        };
        return directive;

        function responsibilityController() {
            var vm = this;

            vm.maxValue = vm.maxAmountInput / 100;
            vm.validate = validate;
            vm.changeValue = changeValue;
            vm.valueChanged = valueChanged;
            changeValue()

            function validate(value) {
                vm.valueError = false;
                
                if (value <= vm.maxValue) {
                    vm.hasValue = true;
                    vm.product.responsibilityValue = value * 100;
                    vm.form.value.$setValidity('max', true);
                } else {
                    vm.valueError = true;
                    vm.form.value.$setValidity('max', false);
                }
            }
           
            function changeValue() {
                vm.hasValue = false;
                delete vm.product['responsibilityValue'];
            }

            function valueChanged() {
                delete vm.product['responsibilityValue'];
                vm.form.value.$setValidity('max', true);
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('homePickup', homePickup);

        homePickup.$inject = ['$http'];

    function homePickup($http) {
       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/home-pickup/home-pickup.directive.html',
            scope: {
                product: '=',
                isValid: '='
            },
            controller: homePickupController,
            controllerAs: 'homePickup',
            bindToController: true
        };
        return directive;

        function homePickupController($scope) {
            var vm = this;

            $scope.$watch('homePickup.locationInstruction', setValue);

            function setValue() {
                vm.isValid = Boolean(vm.locationInstruction);
                _.set(vm.product, 'sender.pickup.locationInstruction', vm.locationInstruction);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('homeDeliveryZipcodeValidator', homeDeliveryZipcodeValidator);

    homeDeliveryZipcodeValidator.$inject = ['$http'];

    function homeDeliveryZipcodeValidator($http) {
       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/home-delivery-zipcode-validator/home-delivery-zipcode-validator.directive.html',
            link: linkFunc,
            scope: {
                isValid: '=',
                zipCode: '='
            },
            controller: homeDeliveryZipcodeValidatorController,
            controllerAs: 'zipcodeValidator',
            bindToController: true
        };
        return directive;

         function linkFunc(scope, el, attr, ctrl) {
            el.addClass('zipcode-validator');
        }

        function homeDeliveryZipcodeValidatorController($log) {
            var vm = this;

            vm.isValid = false;
            vm.isValidating = false;
            vm.isSubmitted = false;

            vm.validateZipcode = validateZipcode;

            activate();

            //////////////////////

            function activate() {
                if (vm.zipCode) {
                    validateZipcode(vm.zipCode);
                }
            }

            function validateZipcode(zipcode) {
                if(zipcode){
                    vm.isValidating = true;
                    $http({
                        method: 'GET',
                        headers: OnlineShippingTool.env.bap_key,
                        url: 'https://api2.postnord.com/rest/customer/v1/timeslot/timeslots?serviceGroupCode=SE&serviceCode=17&toAddressPostalCode='+zipcode+'&toAddressCountryCode=SE'
                    }).then(function successCallback(response) {
                        var eveningSlot = _.find(response.data.data[0].timeslots, function (date) {
                            return _.find(date.slot, function (slot) {
                                return slot.from >= '17:00' && slot.to >= '17:00';
                            });
                        });
                        vm.isValidating = false;
                        vm.isSubmitted = true;
                        vm.isValid = !!eveningSlot;
                    }), function errorCallback(response) {
                        $log.debug('Error' + response)
                    };
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .factory('ExpressValidatorFactory', ExpressValidatorFactory)

    ExpressValidatorFactory.$inject = ['$q', '$http'];

    function ExpressValidatorFactory($q, $http) {
        var service = {
            checkZipcode: checkZipcode,
            getnoDeliveryExceptions: getnoDeliveryExceptions,
            getnormalDeliveryExceptions: getnormalDeliveryExceptions,
            checkDeliverytime: checkDeliverytime
        };

        return service;

        function checkDeliverytime(fromZipcode, zipcode, productCode) {
            if (parseInt(moment().format('HH'), 10) > 13) {
                var date = moment().add(1, 'day').format('YYYY-MM-DD');
            } else {
                var date = moment().format('YYYY-MM-DD');
            }

            return $http({
                method: 'GET',
                url: OnlineShippingTool.env.transitTimeURL,
                params: {
                    start_time: date,
                    service_code: productCode,
                    origin_postal_code: fromZipcode,
                    origin_country_code: 'SE',
                    destination_postal_code: zipcode,
                    destination_country_code: 'SE',
                }
            }).then(function (response) {
                return response;
            });
        }
        function checkZipcode(zipcode) {
            var deferred = $q.defer();
            var noDeliveryExceptions = getnoDeliveryExceptions();
            var normalDeliveryExceptions = getnormalDeliveryExceptions();


            if (zipcode.substring(0, 2) > '81' && zipcode.substring(0, 2) < '99') {
                var data = _.find(noDeliveryExceptions, function (exception) {
                    return (zipcode >= exception.lowerbound && zipcode <= exception.upperbound);
                })
                if (data) {
                    deferred.resolve(data);
                } else {
                    deferred.reject('error');
                }
            } else {
                var data = _.find(normalDeliveryExceptions, function (exception) {
                    return (zipcode >= exception.lowerbound && zipcode <= exception.upperbound);
                })
                if (data) {
                    deferred.resolve(data);
                } else {
                    deferred.resolve();
                }
            }
            return deferred.promise;
        }
        function getnormalDeliveryExceptions() {
            var normalDeliveryExceptions = [
                { lowerbound: '13033', upperbound: '13033', deliverytime: '16.00', name: 'Gällnöby' },
                { lowerbound: '13036', upperbound: '13036', deliverytime: '16.00', name: 'Nämndö' },
                { lowerbound: '13038', upperbound: '13038', deliverytime: '16.00', name: 'Runmarö' },
                { lowerbound: '13039', upperbound: '13039', deliverytime: '16.00', name: 'Sandhamn' },
                { lowerbound: '13042', upperbound: '13042', deliverytime: '16.00', name: 'Stavsudda' },
                { lowerbound: '13043', upperbound: '13043', deliverytime: '16.00', name: 'Möja' },
                { lowerbound: '13055', upperbound: '13055', deliverytime: '16.00', name: 'Ornö' },
                { lowerbound: '13056', upperbound: '13056', deliverytime: '16.00', name: 'Utö' },
                { lowerbound: '13770', upperbound: '13771', deliverytime: '11.00', name: 'Dalarö' },
                { lowerbound: '31421', upperbound: '31422', deliverytime: '12.00', name: 'Hyltebruk' },
                { lowerbound: '31431', upperbound: '31434', deliverytime: '12.00', name: 'Hyltebruk' },
                { lowerbound: '31441', upperbound: '31441', deliverytime: '12.00', name: 'Hyltebruk' },
                { lowerbound: '33015', upperbound: '33015', deliverytime: '11.00', name: 'Bor' },
                { lowerbound: '33017', upperbound: '33017', deliverytime: '11.00', name: 'Rydaholm' },
                { lowerbound: '33018', upperbound: '33018', deliverytime: '11.00', name: 'Horda' },
                { lowerbound: '34252', upperbound: '34252', deliverytime: '12.00', name: 'Vislanda' },
                { lowerbound: '34260', upperbound: '34261', deliverytime: '12.00', name: 'Moheda' },
                { lowerbound: '36010', upperbound: '36010', deliverytime: '12.00', name: 'Ryd' },
                { lowerbound: '36013', upperbound: '36013', deliverytime: '12.00', name: 'Urshult' },
                { lowerbound: '36023', upperbound: '36024', deliverytime: '12.00', name: 'Älmeboda' },
                { lowerbound: '36032', upperbound: '36032', deliverytime: '12.00', name: 'Gemla' },
                { lowerbound: '36042', upperbound: '36042', deliverytime: '11.00', name: 'Braås' },
                { lowerbound: '36044', upperbound: '36044', deliverytime: '12.00', name: 'Ingelstad' },
                { lowerbound: '36050', upperbound: '36050', deliverytime: '12.00', name: 'Lessebo' },
                { lowerbound: '36051', upperbound: '36051', deliverytime: '11.00', name: 'Hovmantorp' },
                { lowerbound: '36060', upperbound: '36060', deliverytime: '12.00', name: 'Lammhult' },
                { lowerbound: '36071', upperbound: '36071', deliverytime: '12.00', name: 'Norrhult' },
                { lowerbound: '36073', upperbound: '36073', deliverytime: '12.00', name: 'Lenhovda' },
                { lowerbound: '36075', upperbound: '36075', deliverytime: '12.00', name: 'Alstermo' },
                { lowerbound: '36230', upperbound: '36232', deliverytime: '11.00', name: 'Tingsryd' },
                { lowerbound: '36333', upperbound: '36333', deliverytime: '12.00', name: 'Rottne' },
                { lowerbound: '36433', upperbound: '36433', deliverytime: '11.00', name: 'Åseda' },
                { lowerbound: '46260', upperbound: '46260', deliverytime: '11.00', name: 'Frändefors' },
                { lowerbound: '46371', upperbound: '46371', deliverytime: '11.00', name: 'Lödöse' },
                { lowerbound: '52105', upperbound: '52105', deliverytime: '11.00', name: 'Vartofta' },
                { lowerbound: '52175', upperbound: '52175', deliverytime: '11.00', name: 'Vartofta' },
                { lowerbound: '52104', upperbound: '52104', deliverytime: '11.00', name: 'Gudhem' },
                { lowerbound: '52174', upperbound: '52174', deliverytime: '11.00', name: 'Gudhem' },
                { lowerbound: '52160', upperbound: '52161', deliverytime: '11.30', name: 'Stenstorp' },
                { lowerbound: '52170', upperbound: '52170', deliverytime: '11.00', name: 'Åsarp' },
                { lowerbound: '52172', upperbound: '52172', deliverytime: '11.00', name: 'Slutarp' },
                { lowerbound: '52173', upperbound: '52173', deliverytime: '11.00', name: 'Kinnarp' },
                { lowerbound: '52360', upperbound: '52361', deliverytime: '12.00', name: 'Gällstad' },
                { lowerbound: '52372', upperbound: '52372', deliverytime: '12.00', name: 'Timmele' },
                { lowerbound: '52374', upperbound: '52374', deliverytime: '11.00', name: 'Dalum' },
                { lowerbound: '52376', upperbound: '52377', deliverytime: '12.00', name: 'Blidsberg' },
                { lowerbound: '53171', upperbound: '53171', deliverytime: '11.00', name: 'Vinninga' },
                { lowerbound: '53173', upperbound: '53173', deliverytime: '11.00', name: 'Källby' },
                { lowerbound: '53175', upperbound: '53175', deliverytime: '11.00', name: 'Järpås' },
                { lowerbound: '53272', upperbound: '53272', deliverytime: '12.00', name: 'Axvall' },
                { lowerbound: '53274', upperbound: '53274', deliverytime: '12.00', name: 'Skara' },
                { lowerbound: '53372', upperbound: '53372', deliverytime: '11.00', name: 'Lundsbrunn' },
                { lowerbound: '53374', upperbound: '53374', deliverytime: '12.00', name: 'Hällekis' },
                { lowerbound: '53460', upperbound: '53460', deliverytime: '11.00', name: 'Vedum' },
                { lowerbound: '53473', upperbound: '53473', deliverytime: '11.00', name: 'Stora Leverne' },
                { lowerbound: '53530', upperbound: '53530', deliverytime: '10.30', name: 'Kvänum' },
                { lowerbound: '54672', upperbound: '54672', deliverytime: '11.00', name: 'Mölltorp' },
                { lowerbound: '54931', upperbound: '54931', deliverytime: '11.00', name: 'Tidan' },
                { lowerbound: '54941', upperbound: '54941', deliverytime: '11.00', name: 'Moholm' },
                { lowerbound: '57730', upperbound: '57739', deliverytime: '11.00', name: 'Hultsfred' },
                { lowerbound: '57830', upperbound: '57833', deliverytime: '11.00', name: 'Aneby' },
                { lowerbound: '59430', upperbound: '59432', deliverytime: '11.00', name: 'Gamleby' },
                { lowerbound: '59870', upperbound: '59870', deliverytime: '11.00', name: 'Storebro' },
                { lowerbound: '62170', upperbound: '62199', deliverytime: '12.00', name: 'Gotland' },
                { lowerbound: '62200', upperbound: '62258', deliverytime: '12.00', name: 'Gotland' },
                { lowerbound: '62262', upperbound: '62499', deliverytime: '12.00', name: 'Gotland' },
                { lowerbound: '64033', upperbound: '64033', deliverytime: '12.00', name: 'Bettna' },
                { lowerbound: '64260', upperbound: '64261', deliverytime: '11.00', name: 'Malmköping' },
                { lowerbound: '64650', upperbound: '64651', deliverytime: '12.30', name: 'Stjärnhov' },
                { lowerbound: '64831', upperbound: '64831', deliverytime: '11.00', name: 'Sparreholm' },
                { lowerbound: '64990', upperbound: '64991', deliverytime: '11.00', name: 'Hälleforsnäs' },
                { lowerbound: '66057', upperbound: '66057', deliverytime: '12.00', name: 'Väse' },
                { lowerbound: '68096', upperbound: '68096', deliverytime: '10.30', name: 'Lesjöfors' },
                { lowerbound: '68831', upperbound: '68832', deliverytime: '10.30', name: 'Storfors' },
                { lowerbound: '69373', upperbound: '69373', deliverytime: '11.00', name: 'Svartå' },
                { lowerbound: '72630', upperbound: '72631', deliverytime: '10.30', name: 'Skultuna' },
                { lowerbound: '73060', upperbound: '73060', deliverytime: '11.30', name: 'Ramnäs' },
                { lowerbound: '76231', upperbound: '76231', deliverytime: '11.00', name: 'Rimbo' },
                { lowerbound: '76241', upperbound: '76241', deliverytime: '11.00', name: 'Rimbo' },
                { lowerbound: '76261', upperbound: '76261', deliverytime: '11.00', name: 'Rimbo' },
                { lowerbound: '76430', upperbound: '76431', deliverytime: '11.00', name: 'Väddö' },
            ]
            return normalDeliveryExceptions;
        };
        function getnoDeliveryExceptions() {
            var noDeliveryExceptions = [
                { lowerbound: '82070', upperbound: '82070', deliverytime: '', name: 'Bergsjö' },
                { lowerbound: '82100', upperbound: '82100', deliverytime: '', name: 'Bollnäs' },
                { lowerbound: '82400', upperbound: '82400', deliverytime: '', name: 'Hudiksvall' },
                { lowerbound: '82600', upperbound: '82600', deliverytime: '', name: 'Söderhamn' },
                { lowerbound: '82700', upperbound: '82700', deliverytime: '', name: 'Ljusdal' },
                { lowerbound: '82800', upperbound: '82800', deliverytime: '', name: 'Edsbyn' },
                { lowerbound: '83100', upperbound: '83100', deliverytime: '', name: 'Östersund' },
                { lowerbound: '83200', upperbound: '83200', deliverytime: '', name: 'Frösön' },
                { lowerbound: '83300', upperbound: '83300', deliverytime: '', name: 'Strömsund' },
                { lowerbound: '83500', upperbound: '83500', deliverytime: '', name: 'Krokom' },
                { lowerbound: '84040', upperbound: '84040', deliverytime: '', name: 'Svenstavik' },
                { lowerbound: '84060', upperbound: '84060', deliverytime: '', name: 'Bräcke' },
                { lowerbound: '84070', upperbound: '84070', deliverytime: '', name: 'Hammarstrand' },
                { lowerbound: '84093', upperbound: '84093', deliverytime: '', name: 'Hede' },
                { lowerbound: '84100', upperbound: '84100', deliverytime: '', name: 'Ånge' },
                { lowerbound: '84200', upperbound: '84200', deliverytime: '', name: 'Sveg' },
                { lowerbound: '85000', upperbound: '85700', deliverytime: '', name: 'Sundsvall' },
                { lowerbound: '86191', upperbound: '86191', deliverytime: '', name: 'Timrå' },
                { lowerbound: '86400', upperbound: '86400', deliverytime: '', name: 'Matfors' },
                { lowerbound: '87100', upperbound: '87100', deliverytime: '', name: 'Härnösand' },
                { lowerbound: '87200', upperbound: '87200', deliverytime: '', name: 'Kramfors' },
                { lowerbound: '88040', upperbound: '88040', deliverytime: '', name: 'Ramsele' },
                { lowerbound: '88100', upperbound: '88100', deliverytime: '', name: 'Sollefteå' },
                { lowerbound: '89051', upperbound: '89051', deliverytime: '', name: 'Långviksmon' },
                { lowerbound: '89100', upperbound: '89100', deliverytime: '', name: 'Örnsköldsvik' },
                { lowerbound: '89200', upperbound: '89200', deliverytime: '', name: 'Domsjö' },
                { lowerbound: '89500', upperbound: '89500', deliverytime: '', name: 'Bredbyn' },
                { lowerbound: '90000', upperbound: '90700', deliverytime: '', name: 'Umeå' },
                { lowerbound: '91100', upperbound: '91100', deliverytime: '', name: 'Vännäs' },
                { lowerbound: '91400', upperbound: '91400', deliverytime: '', name: 'Nordmaling' },
                { lowerbound: '91500', upperbound: '91500', deliverytime: '', name: 'Robertsfors' },
                { lowerbound: '91600', upperbound: '91600', deliverytime: '', name: 'Bjurholm' },
                { lowerbound: '91931', upperbound: '91931', deliverytime: '', name: 'Åsele' },
                { lowerbound: '92100', upperbound: '92100', deliverytime: '', name: 'Lycksele' },
                { lowerbound: '92200', upperbound: '92200', deliverytime: '', name: 'Vindeln' },
                { lowerbound: '93010', upperbound: '93010', deliverytime: '', name: 'Lövånger' },
                { lowerbound: '93047', upperbound: '93047', deliverytime: '', name: 'Byske' },
                { lowerbound: '93100', upperbound: '93100', deliverytime: '', name: 'Skellefteå' },
                { lowerbound: '93231', upperbound: '93231', deliverytime: '', name: 'Skelleftehamn' },
                { lowerbound: '93251', upperbound: '93251', deliverytime: '', name: 'Bureå' },
                { lowerbound: '93300', upperbound: '93300', deliverytime: '', name: 'Arvidsjaur' },
                { lowerbound: '93431', upperbound: '93431', deliverytime: '', name: 'Kåge' },
                { lowerbound: '93500', upperbound: '93500', deliverytime: '', name: 'Norsjö' },
                { lowerbound: '93632', upperbound: '93632', deliverytime: '', name: 'Boliden' },
                { lowerbound: '93700', upperbound: '93700', deliverytime: '', name: 'Burträsk' },
                { lowerbound: '94101', upperbound: '94101', deliverytime: '', name: 'Piteå' },
                { lowerbound: '94200', upperbound: '94200', deliverytime: '', name: 'Älvsbyn' },
                { lowerbound: '94321', upperbound: '94321', deliverytime: '', name: 'Öjebyn' },
                { lowerbound: '94473', upperbound: '94473', deliverytime: '', name: 'Piteå' },
                { lowerbound: '95200', upperbound: '95200', deliverytime: '', name: 'Kalix' },
                { lowerbound: '95431', upperbound: '95431', deliverytime: '', name: 'Gammelstad' },
                { lowerbound: '95442', upperbound: '95442', deliverytime: '', name: 'Södra Sunderbyn' },
                { lowerbound: '95600', upperbound: '95600', deliverytime: '', name: 'Överkalix' },
                { lowerbound: '96100', upperbound: '96100', deliverytime: '', name: 'Boden' },
                { lowerbound: '96200', upperbound: '96200', deliverytime: '', name: 'Jokkmokk' },
                { lowerbound: '97100', upperbound: '97700', deliverytime: '', name: 'Luleå' },
                { lowerbound: '98100', upperbound: '98100', deliverytime: '', name: 'Kiruna' },
                { lowerbound: '98200', upperbound: '98200', deliverytime: '', name: 'Gällivare' },
                { lowerbound: '98400', upperbound: '98400', deliverytime: '', name: 'Pajala' },
            ]
            return noDeliveryExceptions;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('expressDeliveryValidator', expressDeliveryValidator);

    expressDeliveryValidator.$inject = ['$http', 'ExpressValidatorFactory', '$translate'];

    function expressDeliveryValidator($http, ExpressValidatorFactory, $translate) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/expressdelivery-validator/expressdelivery-validator.directive.html',
            scope: {
                isValid: '=',
                zipCode: '=',
                productCode: '='
            },
            controller: expressDeliveryValidatorController,
            controllerAs: 'expressValidator',
            bindToController: true
        };
        return directive;

        function expressDeliveryValidatorController() {
            var vm = this;
            pnTopbar.market === 'SE' ? vm.locale = 'sv' : vm.locale = 'en';
            vm.isValid = false;
            vm.isValidating = false;
            vm.isSubmitted = false;

            vm.validateExpress = validateExpress;

            //////////////////////

            function validateExpress(fromZipcode, zipcode, productCode) {
                if (zipcode) {
                    vm.isValidating = true;
                    vm.isSubmitted = false;

                    setTimeout(function () {
                        ExpressValidatorFactory.checkDeliverytime(fromZipcode, zipcode, productCode).then(function (response) {
                            moment().locale(vm.locale);
                            vm.validatedData = response.data;
                            vm.isSubmitted = true;
                            vm.isValidating = false;
                            
                            vm.validatedData.dropOffTime = getTimeFromDate(response.data.handover_date);
                            vm.validatedData.deliveryDate = moment(vm.validatedData.delivery_date).format("YYYY-MM-DD");
                            vm.validatedData.deliveryText = convertDateToText(vm.validatedData.deliveryDate);
                            vm.validatedData.dropOffText = convertDateToText(response.data.handover_date);
                            vm.validatedData.deliveryTime = getTimeFromDate(response.data.delivery_date, vm.locale);
                            // check if express is available
                            vm.isValid = vm.validatedData && vm.validatedData.valid;
                        }).catch(function (e) {
                            if (e === 'error') {
                                vm.isValid = false;
                                vm.isSubmitted = true;
                                vm.isValidating = false;
                            }
                        });
                    }, 750);
                }
            }
        }
        function convertDateToText(date) {
            return date === moment().format('YYYY-MM-DD') ? $translate.instant('TODAY') : date === moment().add(1, 'days').format('YYYY-MM-DD') ? $translate.instant('TOMORROW') : moment(date).format('dddd');
        }

        function getTimeFromDate (fullDate, locale) {
            const date = new Date(fullDate);

            return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('expressLetterDeliveryValidator', expressLetterDeliveryValidator);

    expressLetterDeliveryValidator.$inject = ['$http', 'ExpressValidatorFactory'];

    function expressLetterDeliveryValidator($http, ExpressValidatorFactory) {
       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/expressdelivery-validator/express-letter-delivery-validator.directive.html',
            scope: {
                isValid: '=',
                zipCode: '='
            },
            controller: ExpressLetterDeliveryValidatorController,
            controllerAs: 'expressValidator',
            bindToController: true
        };
        return directive;

        function ExpressLetterDeliveryValidatorController() {
            var vm = this;

            vm.isValid = false;
            vm.isValidating = false;
            vm.isSubmitted = false;

            vm.validateExpress = validateExpress;

            //////////////////////

            function validateExpress(zipcode) {
                /* --- Future lookup that zipcode exists before we continue... --- */
                if(zipcode) {
                    vm.isValidating = true;
                    setTimeout(function(){
                        ExpressValidatorFactory.checkZipcode(zipcode).then(function(data){
                            vm.validatedData = data;
                            vm.isValid = true;
                            vm.isSubmitted = true;
                            vm.isValidating = false;
                        }).catch(function(e){
                            if(e === 'error'){
                                vm.isValid = false;
                                vm.isSubmitted = true;
                                vm.isValidating = false;
                            }
                        });
                    }, 750);
                }
            }
        }
    }

})();

var unsupportedZipCodes = ['13025','13032','13033','13034','13036','13038','13041','13042','13043','13044','13055','13056','13791','13792','13793','13794','13795','13796','13797','13941','13950','13954','13956','13960','13990','14791','14792','14860','14870','14871','14891','14892','14893','14895','14896','14897','14991','14992','14995','15166','15196','15295','15297','15331','15391','15392','15393','15394','15395','15396','15591','15592','15593','15594','17891','17892','18491','18492','18493','18494','18495','18496','18497','18499','18591','18592','18593','18594','18595','18599','18660','18691','18692','18693','18694','18695','18696','18697','19391','19491','19492','19591','19592','19593','19594','19595','19596','19691','19692','19693','19791','19792','19793','22591','22592','22594','22657','23041','23167','23169','23172','23173','23176','23178','23191','23192','23193','23194','23195','23196','23197','23198','23199','23291','23338','23363','23364','23375','23376','23391','23392','23393','23394','23541','23591','23592','23593','23594','23599','23741','23791','24040','24161','24162','24164','24165','24171','24172','24174','24175','24191','24192','24193','24194','24195','24196','24271','24272','24291','24292','24293','24294','24295','24296','24297','24298','24371','24372','24373','24391','24392','24393','24394','24395','24396','24397','24491','24493','24494','24495','24591','24592','24593','24655','24657','24791','24792','24793','24794','24795','24796','24797','24798','24799','25341','25342','25351','25353','25354','25355','25356','25470','25471','25476','25477','25478','25591','25592','25600','26013','26163','26165','26176','26191','26192','26193','26194','26291','26292','26293','26294','26295','26296','26362','26363','26365','26372','26373','26375','26376','26391','26392','26394','26395','26453','26454','26470','26491','26492','26493','26494','26572','26590','26655','26691','26692','26693','26694','26695','26697','26698','26771','26772','26774','26775','26776','26777','26790','26868','26871','26872','26873','26874','26875','26876','26877','26878','26890','26971','26972','26973','26974','26991','26992','26993','26994','26995','26996','27021','27031','27160','27171','27172','27173','27174','27176','27177','27178','27191','27192','27193','27194','27195','27196','27197','27198','27199','27238','27291','27292','27293','27294','27295','27296','27297','27355','27356','27357','27391','27392','27393','27394','27395','27396','27397','27398','27453','27454','27462','27463','27491','27492','27493','27494','27563','27564','27567','27568','27570','27571','27572','27575','27575','27591','27592','27593','27594','27595','27596','27635','27636','27637','27655','27656','27660','27732','27735','27736','27737','27745','28010','28020','28022','28023','28040','28060','28064','28070','28072','28144','28191','28192','28193','28195','28197','28291','28292','28293','28294','28295','28391','28395','28434','28491','28492','28591','28593','28672','28691','28692','28695','28791','28792','28793','28890','28893','28941','28943','28946','28947','28971','28972','28973','28990','28992','28993','28994','29034','29037','29038','29060','29062','29155','29156','29157','29167','29168','29169','29191','29192','29193','29194','29195','29197','29391','29392','29393','29472','29474','29475','29491','29492','29493','29494','29495','29591','29594','29686','29691','29692','29731','29791','29792','29794','29795','29891','29892','29893','29894','29896','30561','30572','30577','30578','30591','30592','30593','30594','30595','30596','30597','31151','31152','31161','31162','31163','31165','31167','31169','31170','31171','31190','31191','31192','31193','31194','31195','31196','31197','31198','31199','31251','31252','31253','31291','31292','31293','31294','31295','31296','31297','31298','31391','31392','31393','31394','31395','31396','31397','31442','31452','31491','31492','31493','31494','31495','31496','31497','31498','33010','33012','33015','33017','33018','33021','33026','33027','33031','33033','33171','33172','33173','33174','33176','33177','33191','33192','33193','33194','33195','33196','33197','33198','33291','33292','33371','33372','33373','33374','33375','33376','33377','33378','33391','33392','33393','33491','33571','33572','33573','33574','33591','33592','33593','33594','34010','34012','34013','34032','34037','34152','34155','34170','34171','34172','34173','34176','34177','34191','34193','34194','34196','34252','34253','34262','34263','34264','34290','34291','34292','34293','34294','34295','34333','34371','34372','34373','34374','34390','34391','34392','34393','34394','34395','34396','34397','35250','35571','35572','35573','35591','35592','35593','35594','35595','35596','35597','35598','35599','36010','36013','36023','36024','36030','36032','36042','36043','36044','36047','36050','36051','36052','36053','36060','36065','36071','36073','36074','36075','36076','36077','36153','36154','36191','36192','36193','36194','36195','36196','36240','36250','36251','36252','36253','36254','36256','36257','36291','36292','36293','36294','36295','36296','36333','36334','36335','36341','36342','36344','36345','36391','36392','36393','36394','36433','36441','36442','36443','36491','36492','36493','36531','36532','36533','36541','36542','36591','36592','36593','37011','37012','37017','37024','37030','37033','37042','37043','37044','37045','37191','37192','37193','37194','37262','37263','37291','37292','37294','37295','37297','37300','37302','37330','37331','37332','37333','37334','37335','37336','37337','37338','37341','37342','37343','37344','37345','37351','37352','37353','37354','37365','37366','37372','37373','37374','37375','37377','37378','37379','37491','37492','37493','37494','37495','37496','37590','37591','37692','37693','38040','38041','38042','38044','38052','38053','38290','38291','38292','38293','38294','38296','38297','38391','38392','38491','38492','38493','38590','38591','38592','38593','38594','38595','38597','38598','38599','38660','38661','38662','38663','38664','38690','38692','38693','38694','38695','38696','38770','38771','38772','38773','38774','38775','38790','38791','38792','38793','38794','38795','38796','38891','38892','38893','38894','38895','38896','38897','38898','38899','39590','39591','39594','39595','39597','39598','42352','42354','42355','42356','42359','42361','42363','42370','42371','42372','42373','42456','42457','42472','42490','42491','43247','43248','43264','43265','43266','43268','43269','43276','43277','43291','43292','43293','43294','43295','43296','43297','43298','43299','43479','43490','43491','43492','43493','43494','43495','43496','43497','43498','43499','43891','43892','43893','43894','43895','43896','43897','43898','43951','43952','43955','43961','43963','43964','43965','43972','43973','43974','43975','43991','43992','43993','44160','44163','44172','44173','44174','44175','44191','44192','44193','44194','44195','44196','44239','44270','44271','44272','44273','44274','44275','44277','44290','44291','44292','44293','44294','44295','44296','44297','44298','44340','44345','44370','44371','44372','44373','44374','44391','44392','44395','44465','44491','44492','44493','44494','44495','44496','44497','44691','44692','44693','44694','44695','44696','44697','44791','44792','44793','44794','44795','44891','44892','44895','44896','44970','44990','45178','45179','45190','45191','45192','45193','45194','45195','45196','45197','45198','45204','45205','45260','45290','45291','45292','45293','45294','45295','45296','45297','45391','45392','45393','45491','45492','45493','45494','45495','45591','45592','45593','45595','45596','45597','45598','45642','45655','45691','45692','45693','45694','45740','45741','45742','45743','45745','45746','45747','45748','45750','45751','45755','45756','45761','45773','45791','45793','45795','45796','45797','45870','45891','45892','45893','45896','45897','45991','45993','45994','46177','46178','46179','46191','46192','46193','46194','46195','46196','46197','46198','46199','46291','46293','46294','46295','46296','46297','46375','46391','46392','46393','46394','46395','46396','46397','46440','46450','46463','46464','46465','46466','46471','46472','46491','46492','46493','46494','46495','46591','46593','46594','46595','46596','46597','46598','46791','46792','46793','46794','46795','46796','46831','46890','47170','47171','47172','47173','47190','47191','47192','47193','47194','47195','47196','47197','47198','47291','47292','47293','47294','47295','47296','47297','47298','47391','47392','47393','47394','47395','47396','47397','47398','47399','47470','47491','47492','47493','47494','47495','47496','50478','50490','50491','50492','50493','50494','50495','50496','50497','50790','51159','51168','51169','51170','51172','51173','51174','51191','51192','51193','51194','51195','51196','51197','51198','51199','51260','51261','51262','51263','51264','51265','51276','51290','51291','51292','51293','51294','51295','51370','51391','51392','51393','51394','51395','51396','51397','51450','51452','51453','51454','51455','51460','51461','51462','51463','51470','51491','51492','51493','51494','51495','51591','51592','51593','51650','51677','51690','51691','51692','51693','51694','51695','51696','51770','51791','51792','51793','51794','51795','51796','51890','51891','51990','51991','51992','51993','51994','51995','51996','51997','52011','52025','52026','52153','52154','52155','52156','52162','52163','52164','52171','52191','52192','52193','52194','52195','52196','52197','52198','52291','52292','52293','52294','52331','52338','52360','52361','52375','52377','52390','52391','52392','52393','52394','52395','52396','52397','52398','52399','52491','52492','52493','52495','52496','53030','53032','53170','53191','53192','53193','53194','53195','53196','53197','53198','53199','53273','53274','53292','53293','53294','53295','53296','53391','53392','53394','53395','53396','53397','53461','53462','53473','53490','53491','53492','53493','53494','53495','53496','53591','53592','53593','54016','54017','54066','54176','54177','54178','54191','54192','54193','54194','54196','54198','54272','54273','54274','54275','54291','54292','54293','54294','54295','54391','54392','54393','54394','54395','54491','54492','54493','54494','54590','54591','54592','54593','54673','54691','54692','54693','54694','54695','54772','54791','54792','54793','54874','54891','54892','54893','54941','54991','54992','54993','55592','55593','55594','56013','56029','56030','56031','56034','56191','56192','56193','56195','56196','56291','56391','56392','56393','56491','56576','56591','56592','56593','56594','56596','56597','56691','56692','56693','56791','56792','56891','56892','56893','57001','57002','57003','57010','57012','57013','57015','57016','57019','57021','57031','57032','57034','57060','57061','57062','57063','57072','57075','57076','57080','57081','57082','57083','57084','57091','57162','57163','57164','57165','57166','57167','57172','57173','57174','57175','57176','57191','57192','57193','57194','57195','57197','57291','57292','57293','57295','57296','57340','57343','57361','57373','57391','57392','57393','57394','57395','57396','57397','57398','57399','57474','57491','57492','57493','57494','57495','57496','57497','57498','57591','57592','57593','57594','57595','57596','57691','57692','57790','57791','57792','57793','57794','57874','57875','57891','57892','57893','57894','57895','57990','57991','57992','57993','58335','58337','58360','58561','58562','58563','58591','58592','58593','58594','58595','58596','58597','58598','58599','58963','58964','58965','59014','59015','59016','59017','59022','59028','59032','59033','59034','59039','59042','59045','59046','59047','59048','59051','59052','59053','59074','59075','59076','59077','59078','59092','59095','59096','59098','59191','59192','59193','59194','59195','59196','59197','59198','59199','59291','59292','59293','59294','59370','59371','59373','59374','59376','59391','59392','59393','59395','59396','59397','59491','59492','59493','59494','59591','59592','59593','59594','59595','59596','59691','59692','59693','59742','59791','59794','59796','59797','59872','59873','59891','59892','59893','59894','59895','59896','59897','59898','59991','59992','59993','59994','60560','60570','60580','60591','60592','60593','60594','60595','60596','60597','60599','61010','61011','61012','61014','61020','61021','61025','61026','61027','61028','61029','61030','61031','61032','61033','61040','61041','61042','61074','61075','61190','61191','61192','61193','61194','61195','61196','61197','61198','61199','61234','61238','61291','61292','61293','61294','61295','61296','61490','61492','61493','61494','61495','61496','61497','61498','61499','61591','61592','61593','61594','61595','61690','61691','61731','61790','61833','61834','61835','61892','61893','61895','61991','61992','62170','62171','62173','62174','62175','62176','62177','62178','62179','62191','62192','62193','62194','62195','62196','62199','62230','62232','62234','62236','62238','62240','62242','62244','62246','62248','62250','62252','62254','62256','62258','62265','62266','62270','62275','62276','62330','62331','62332','62333','62335','62336','62337','62338','62340','62341','62342','62343','62344','62346','62347','62348','62349','62350','62352','62353','62354','62355','62356','62357','62359','62360','62361','62362','62363','62364','62365','62366','62367','62368','62369','62370','62371','62372','62374','62375','62376','62378','62379','62430','62432','62434','62436','62438','62440','62442','62444','62446','62450','62453','62454','62455','62456','62458','62460','62464','62466','62467','63502','63503','63504','63505','63506','63507','63508','63509','63510','63511','63512','63513','63514','63517','63518','63519','63520','63531','64010','64020','64024','64031','64033','64040','64043','64162','64191','64192','64193','64194','64195','64196','64197','64291','64292','64293','64294','64295','64296','64360','64391','64392','64393','64394','64395','64396','64397','64398','64591','64592','64593','64594','64596','64597','64691','64692','64693','64694','64695','64696','64791','64792','64793','64795','64930','64991','65591','65592','65593','65594','66010','66040','66050','66052','66057','66060','66191','66192','66193','66194','66195','66196','66250','66291','66295','66296','66297','66298','66391','66392','66491','66492','66495','66591','66592','66593','66594','66691','66692','66693','66791','66891','66892','66893','66894','66895','66991','66992','67010','67020','67035','67040','67041','67043','67191','67192','67193','67194','67195','67196','67291','67292','67293','67294','67295','67391','67392','67393','68051','68052','68060','68061','68063','68065','68090','68096','68160','68191','68192','68193','68194','68195','68196','68291','68292','68293','68340','68361','68362','68391','68392','68393','68394','68395','68491','68492','68493','68495','68591','68592','68593','68594','68597','68691','68692','68693','68694','68695','68696','68697','68698','68891','68892','69191','69192','69193','69194','69291','69292','69293','69391','69392','69393','69394','69395','69450','69460','69491','69492','69493','69494','69495','69496','69497','69498','69499','69591','69592','69593','69594','69595','69596','69597','69691','69692','69693','69694','69695','69696','69697','69791','69792','69793','69794','70510','70591','70592','70593','70594','70595','70596','70597','70598','71172','71176','71177','71178','71191','71192','71193','71194','71195','71196','71197','71198','71291','71293','71294','71295','71391','71392','71393','71394','71472','71491','71492','71493','71494','71591','71592','71593','71594','71595','71596','71691','71692','71693','71694','71840','71891','71892','71893','71894','71895','71896','71897','71991','71992','71993','71994','71995','72591','72592','72593','72594','72595','72596','72597','72598','72691','72692','73060','73091','73111','73113','73114','73115','73170','73191','73192','73193','73194','73195','73196','73197','73198','73250','73272','73273','73291','73292','73293','73294','73295','73296','73297','73298','73338','73360','73361','73362','73363','73375','73391','73392','73393','73394','73395','73396','73397','73398','73399','73491','73492','73493','73494','73591','73691','73692','73693','73790','73791','73792','73891','73892','73991','73992','74010','74011','74012','74020','74045','74046','74047','74145','74190','74191','74192','74193','74194','74195','74196','74250','74291','74292','74293','74294','74295','74296','74297','74371','74372','74373','74374','74381','74382','74386','74387','74391','74392','74393','74394','74491','74492','74493','74494','74495','74496','74497','74571','74592','74593','74594','74595','74596','74597','74598','74599','74691','74692','74693','74694','74695','74696','74791','74792','74793','74794','74795','74850','74891','74892','74893','74894','74895','74896','74946','74948','74950','74951','74962','74963','74970','74971','74972','75591','75592','75593','75594','75595','75596','75597','75598','76010','76015','76017','76018','76019','76021','76031','76040','76041','76042','76045','76049','76111','76112','76113','76141','76171','76172','76173','76174','76175','76176','76191','76192','76193','76194','76196','76197','76198','76291','76292','76293','76294','76295','76296','76297','76298','76391','76392','76393','76394','76430','76453','76454','76456','76457','76491','76492','76493','77010','77012','77013','77014','77070','77071','77165','77190','77192','77194','77270','77290','77294','77468','77491','77492','77493','77494','77497','77498','77499','77595','77596','77690','77691','77692','77693','77695','77696','77697','77698','77790','77791','77793','77794','78050','78051','78053','78054','78064','78066','78067','78068','78069','78168','78169','78190','78191','78192','78193','78194','78195','78196','78197','78198','78199','78290','78291','78390','78391','78392','78393','78395','78530','78542','78543','78544','78545','78550','78560','78561','78563','78591','78592','79015','79020','79021','79022','79023','79024','79025','79026','79070','79090','79091','79191','79192','79193','79194','79195','79196','79277','79290','79291','79292','79293','79294','79295','79296','79297','79298','79341','79350','79360','79370','79390','79391','79392','79394','79397','79433','79490','79491','79492','79493','79495','79498','79536','79590','79591','79592','79595','79596','79690','79691','79699','80272','80293','80591','80592','80595','80596','80597','80598','80647','81020','81021','81022','81040','81191','81192','81193','81194','81195','81241','81290','81292','81293','81294','81391','81394','81395','81396','81491','81492','81493','81494','81495','81591','81592','81593','81594','81595','81596','81690','81691','81692','81693','81694','81695','81730','81791','81792','81793','81794','81891','81892','81961','81962','81963','81964','81965','81966','82010','82011','82020','82021','82022','82023','82026','82029','82040','82041','82042','82043','82046','82050','82051','82060','82062','82064','82065','82070','82071','82072','82074','82075','82076','82077','82078','82158','82191','82192','82193','82194','82195','82198','82240','82291','82292','82299','82330','82391','82392','82393','82491','82492','82493','82494','82591','82592','82593','82595','82596','82661','82670','82691','82692','82693','82694','82695','82740','82791','82792','82793','82794','82795','82891','82892','82893','82894','82895','82899','83001','83002','83004','83005','83010','83012','83013','83015','83019','83021','83022','83023','83024','83047','83051','83060','83067','83070','83076','83080','83081','83086','83090','83093','83191','83192','83293','83294','83296','83392','83393','83394','83395','83396','83497','83498','83541','83591','83592','83593','83594','83595','83691','83692','83693','83694','83695','84010','84012','84013','84024','84030','84031','84032','84034','84040','84050','84058','84060','84064','84067','84070','84073','84080','84085','84090','84091','84093','84094','84095','84096','84097','84098','84144','84191','84192','84193','84194','84196','84197','84291','84292','84293','84294','84299','85590','86013','86025','86035','86040','86041','86191','86192','86193','86291','86292','86294','86295','86296','86491','86492','86551','86591','86592','87010','87011','87015','87016','87030','87031','87032','87033','87052','87166','87191','87192','87193','87194','87263','87264','87275','87291','87292','87293','87294','87295','87296','87297','87298','87391','87392','88030','88031','88037','88040','88041','88050','88051','88191','88192','88193','88194','88195','88291','88293','88295','89050','89051','89054','89190','89192','89195','89196','89292','89301','89391','89392','89395','89396','89399','89491','89493','89495','89540','89591','89592','89593','89595','89597','89598','89599','89691','89693','90532','90571','90572','90580','90581','90582','90583','90586','90587','90588','90591','90592','90593','90594','90595','90596','91088','91191','91192','91193','91194','91290','91291','91292','91293','91294','91295','91297','91298','91299','91441','91490','91491','91492','91493','91494','91495','91496','91497','91534','91591','91592','91593','91594','91595','91596','91597','91598','91691','91692','91693','91695','91702','91703','91704','91791','91793','91794','91795','91799','91891','91892','91931','91932','91991','91992','91993','91994','91995','92034','92039','92040','92041','92042','92051','92064','92066','92129','92191','92192','92193','92194','92195','92199','92261','92262','92263','92266','92267','92273','92275','92276','92277','92278','92291','92292','92293','92294','92295','92341','92394','92395','92396','92397','92398','92399','92492','92493','92494','92495','93010','93027','93047','93052','93055','93061','93070','93071','93072','93081','93082','93086','93091','93191','93192','93193','93194','93195','93196','93197','93198','93199','93291','93391','93399','93491','93492','93493','93494','93495','93496','93591','93592','93593','93632','93651','93691','93692','93693','93694','93695','93733','93791','93792','93793','93794','93795','93796','93892','93893','93894','93895','93896','94191','94192','94199','94203','94204','94205','94291','94292','94293','94294','94295','94473','94491','94492','94493','94494','94534','94591','94592','94593','94640','94691','94692','94699','95042','95204','95243','95244','95250','95270','95271','95272','95291','95292','95293','95294','95295','95296','95297','95391','95392','95393','95394','95395','95591','95592','95595','95596','95599','95691','95692','95693','95698','95699','95723','95791','95792','95793','95794','95795','95799','96024','96030','96032','96147','96191','96192','96193','96194','96195','96196','96197','96198','96202','96203','96298','96299','97499','97561','97591','97592','97593','97594','97595','97596','97597','97598','98010','98013','98016','98041','98042','98045','98060','98061','98062','98107','98193','98194','98195','98199','98203','98204','98205','98206','98207','98260','98291','98292','98299','98303','98491','98492','98494','98495','98499'];
(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('companyExpressValidator', companyExpressValidator);

    companyExpressValidator.$inject = ['$http', '$timeout'];

    function companyExpressValidator($http, $timeout) {
       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/company-express-validator/company-express-validator.directive.html',
            link: linkFunc,
            scope: {
                isValid: '=',
                zipCode: '='
            },
            controller: companyExpressValidatorController,
            controllerAs: 'companyExpressValidator',
            bindToController: true
        };
        return directive;

         function linkFunc(scope, el, attr, ctrl) {
            el.addClass('zipcode-validator');
        }

        function companyExpressValidatorController() {
            var vm = this;

            vm.isValid = false;
            vm.isValidating = false;
            vm.isSubmitted = false;

            vm.validateZipcode = validateZipcode;

            activate();

            //////////////////////

            function activate() {
                if (vm.zipCode) {
                    validateZipcode(vm.zipCode);
                }
                var unsupportedZipCodes = ['13025','13032','13033','13034','13036','13038','13041','13042','13043','13044','13055','13056','13791','13792','13793','13794','13795','13796','13797','13941','13950','13954','13956','13960','13990','14791','14792','14860','14870','14871','14891','14892','14893','14895','14896','14897','14991','14992','14995','15166','15196','15295','15297','15331','15391','15392','15393','15394','15395','15396','15591','15592','15593','15594','17891','17892','18491','18492','18493','18494','18495','18496','18497','18499','18591','18592','18593','18594','18595','18599','18660','18691','18692','18693','18694','18695','18696','18697','19391','19491','19492','19591','19592','19593','19594','19595','19596','19691','19692','19693','19791','19792','19793','22591','22592','22594','22657','23041','23167','23169','23172','23173','23176','23178','23191','23192','23193','23194','23195','23196','23197','23198','23199','23291','23338','23363','23364','23375','23376','23391','23392','23393','23394','23541','23591','23592','23593','23594','23599','23741','23791','24040','24161','24162','24164','24165','24171','24172','24174','24175','24191','24192','24193','24194','24195','24196','24271','24272','24291','24292','24293','24294','24295','24296','24297','24298','24371','24372','24373','24391','24392','24393','24394','24395','24396','24397','24491','24493','24494','24495','24591','24592','24593','24655','24657','24791','24792','24793','24794','24795','24796','24797','24798','24799','25341','25342','25351','25353','25354','25355','25356','25470','25471','25476','25477','25478','25591','25592','25600','26013','26163','26165','26176','26191','26192','26193','26194','26291','26292','26293','26294','26295','26296','26362','26363','26365','26372','26373','26375','26376','26391','26392','26394','26395','26453','26454','26470','26491','26492','26493','26494','26572','26590','26655','26691','26692','26693','26694','26695','26697','26698','26771','26772','26774','26775','26776','26777','26790','26868','26871','26872','26873','26874','26875','26876','26877','26878','26890','26971','26972','26973','26974','26991','26992','26993','26994','26995','26996','27021','27031','27160','27171','27172','27173','27174','27176','27177','27178','27191','27192','27193','27194','27195','27196','27197','27198','27199','27238','27291','27292','27293','27294','27295','27296','27297','27355','27356','27357','27391','27392','27393','27394','27395','27396','27397','27398','27453','27454','27462','27463','27491','27492','27493','27494','27563','27564','27567','27568','27570','27571','27572','27575','27575','27591','27592','27593','27594','27595','27596','27635','27636','27637','27655','27656','27660','27732','27735','27736','27737','27745','28010','28020','28022','28023','28040','28060','28064','28070','28072','28144','28191','28192','28193','28195','28197','28291','28292','28293','28294','28295','28391','28395','28434','28491','28492','28591','28593','28672','28691','28692','28695','28791','28792','28793','28890','28893','28941','28943','28946','28947','28971','28972','28973','28990','28992','28993','28994','29034','29037','29038','29060','29062','29155','29156','29157','29167','29168','29169','29191','29192','29193','29194','29195','29197','29391','29392','29393','29472','29474','29475','29491','29492','29493','29494','29495','29591','29594','29686','29691','29692','29731','29791','29792','29794','29795','29891','29892','29893','29894','29896','30561','30572','30577','30578','30591','30592','30593','30594','30595','30596','30597','31151','31152','31161','31162','31163','31165','31167','31169','31170','31171','31190','31191','31192','31193','31194','31195','31196','31197','31198','31199','31251','31252','31253','31291','31292','31293','31294','31295','31296','31297','31298','31391','31392','31393','31394','31395','31396','31397','31442','31452','31491','31492','31493','31494','31495','31496','31497','31498','33010','33012','33015','33017','33018','33021','33026','33027','33031','33033','33171','33172','33173','33174','33176','33177','33191','33192','33193','33194','33195','33196','33197','33198','33291','33292','33371','33372','33373','33374','33375','33376','33377','33378','33391','33392','33393','33491','33571','33572','33573','33574','33591','33592','33593','33594','34010','34012','34013','34032','34037','34152','34155','34170','34171','34172','34173','34176','34177','34191','34193','34194','34196','34252','34253','34262','34263','34264','34290','34291','34292','34293','34294','34295','34333','34371','34372','34373','34374','34390','34391','34392','34393','34394','34395','34396','34397','35250','35571','35572','35573','35591','35592','35593','35594','35595','35596','35597','35598','35599','36010','36013','36023','36024','36030','36032','36042','36043','36044','36047','36050','36051','36052','36053','36060','36065','36071','36073','36074','36075','36076','36077','36153','36154','36191','36192','36193','36194','36195','36196','36240','36250','36251','36252','36253','36254','36256','36257','36291','36292','36293','36294','36295','36296','36333','36334','36335','36341','36342','36344','36345','36391','36392','36393','36394','36433','36441','36442','36443','36491','36492','36493','36531','36532','36533','36541','36542','36591','36592','36593','37011','37012','37017','37024','37030','37033','37042','37043','37044','37045','37191','37192','37193','37194','37262','37263','37291','37292','37294','37295','37297','37300','37302','37330','37331','37332','37333','37334','37335','37336','37337','37338','37341','37342','37343','37344','37345','37351','37352','37353','37354','37365','37366','37372','37373','37374','37375','37377','37378','37379','37491','37492','37493','37494','37495','37496','37590','37591','37692','37693','38040','38041','38042','38044','38052','38053','38290','38291','38292','38293','38294','38296','38297','38391','38392','38491','38492','38493','38590','38591','38592','38593','38594','38595','38597','38598','38599','38660','38661','38662','38663','38664','38690','38692','38693','38694','38695','38696','38770','38771','38772','38773','38774','38775','38790','38791','38792','38793','38794','38795','38796','38891','38892','38893','38894','38895','38896','38897','38898','38899','39590','39591','39594','39595','39597','39598','42352','42354','42355','42356','42359','42361','42363','42370','42371','42372','42373','42456','42457','42472','42490','42491','43247','43248','43264','43265','43266','43268','43269','43276','43277','43291','43292','43293','43294','43295','43296','43297','43298','43299','43479','43490','43491','43492','43493','43494','43495','43496','43497','43498','43499','43891','43892','43893','43894','43895','43896','43897','43898','43951','43952','43955','43961','43963','43964','43965','43972','43973','43974','43975','43991','43992','43993','44160','44163','44172','44173','44174','44175','44191','44192','44193','44194','44195','44196','44239','44270','44271','44272','44273','44274','44275','44277','44290','44291','44292','44293','44294','44295','44296','44297','44298','44340','44345','44370','44371','44372','44373','44374','44391','44392','44395','44465','44491','44492','44493','44494','44495','44496','44497','44691','44692','44693','44694','44695','44696','44697','44791','44792','44793','44794','44795','44891','44892','44895','44896','44970','44990','45178','45179','45190','45191','45192','45193','45194','45195','45196','45197','45198','45204','45205','45260','45290','45291','45292','45293','45294','45295','45296','45297','45391','45392','45393','45491','45492','45493','45494','45495','45591','45592','45593','45595','45596','45597','45598','45642','45655','45691','45692','45693','45694','45740','45741','45742','45743','45745','45746','45747','45748','45750','45751','45755','45756','45761','45773','45791','45793','45795','45796','45797','45870','45891','45892','45893','45896','45897','45991','45993','45994','46177','46178','46179','46191','46192','46193','46194','46195','46196','46197','46198','46199','46291','46293','46294','46295','46296','46297','46375','46391','46392','46393','46394','46395','46396','46397','46440','46450','46463','46464','46465','46466','46471','46472','46491','46492','46493','46494','46495','46591','46593','46594','46595','46596','46597','46598','46791','46792','46793','46794','46795','46796','46831','46890','47170','47171','47172','47173','47190','47191','47192','47193','47194','47195','47196','47197','47198','47291','47292','47293','47294','47295','47296','47297','47298','47391','47392','47393','47394','47395','47396','47397','47398','47399','47470','47491','47492','47493','47494','47495','47496','50478','50490','50491','50492','50493','50494','50495','50496','50497','50790','51159','51168','51169','51170','51172','51173','51174','51191','51192','51193','51194','51195','51196','51197','51198','51199','51260','51261','51262','51263','51264','51265','51276','51290','51291','51292','51293','51294','51295','51370','51391','51392','51393','51394','51395','51396','51397','51450','51452','51453','51454','51455','51460','51461','51462','51463','51470','51491','51492','51493','51494','51495','51591','51592','51593','51650','51677','51690','51691','51692','51693','51694','51695','51696','51770','51791','51792','51793','51794','51795','51796','51890','51891','51990','51991','51992','51993','51994','51995','51996','51997','52011','52025','52026','52153','52154','52155','52156','52162','52163','52164','52171','52191','52192','52193','52194','52195','52196','52197','52198','52291','52292','52293','52294','52331','52338','52360','52361','52375','52377','52390','52391','52392','52393','52394','52395','52396','52397','52398','52399','52491','52492','52493','52495','52496','53030','53032','53170','53191','53192','53193','53194','53195','53196','53197','53198','53199','53273','53274','53292','53293','53294','53295','53296','53391','53392','53394','53395','53396','53397','53461','53462','53473','53490','53491','53492','53493','53494','53495','53496','53591','53592','53593','54016','54017','54066','54176','54177','54178','54191','54192','54193','54194','54196','54198','54272','54273','54274','54275','54291','54292','54293','54294','54295','54391','54392','54393','54394','54395','54491','54492','54493','54494','54590','54591','54592','54593','54673','54691','54692','54693','54694','54695','54772','54791','54792','54793','54874','54891','54892','54893','54941','54991','54992','54993','55592','55593','55594','56013','56029','56030','56031','56034','56191','56192','56193','56195','56196','56291','56391','56392','56393','56491','56576','56591','56592','56593','56594','56596','56597','56691','56692','56693','56791','56792','56891','56892','56893','57001','57002','57003','57010','57012','57013','57015','57016','57019','57021','57031','57032','57034','57060','57061','57062','57063','57072','57075','57076','57080','57081','57082','57083','57084','57091','57162','57163','57164','57165','57166','57167','57172','57173','57174','57175','57176','57191','57192','57193','57194','57195','57197','57291','57292','57293','57295','57296','57340','57343','57361','57373','57391','57392','57393','57394','57395','57396','57397','57398','57399','57474','57491','57492','57493','57494','57495','57496','57497','57498','57591','57592','57593','57594','57595','57596','57691','57692','57790','57791','57792','57793','57794','57874','57875','57891','57892','57893','57894','57895','57990','57991','57992','57993','58335','58337','58360','58561','58562','58563','58591','58592','58593','58594','58595','58596','58597','58598','58599','58963','58964','58965','59014','59015','59016','59017','59022','59028','59032','59033','59034','59039','59042','59045','59046','59047','59048','59051','59052','59053','59074','59075','59076','59077','59078','59092','59095','59096','59098','59191','59192','59193','59194','59195','59196','59197','59198','59199','59291','59292','59293','59294','59370','59371','59373','59374','59376','59391','59392','59393','59395','59396','59397','59491','59492','59493','59494','59591','59592','59593','59594','59595','59596','59691','59692','59693','59742','59791','59794','59796','59797','59872','59873','59891','59892','59893','59894','59895','59896','59897','59898','59991','59992','59993','59994','60560','60570','60580','60591','60592','60593','60594','60595','60596','60597','60599','61010','61011','61012','61014','61020','61021','61025','61026','61027','61028','61029','61030','61031','61032','61033','61040','61041','61042','61074','61075','61190','61191','61192','61193','61194','61195','61196','61197','61198','61199','61234','61238','61291','61292','61293','61294','61295','61296','61490','61492','61493','61494','61495','61496','61497','61498','61499','61591','61592','61593','61594','61595','61690','61691','61731','61790','61833','61834','61835','61892','61893','61895','61991','61992','62170','62171','62173','62174','62175','62176','62177','62178','62179','62191','62192','62193','62194','62195','62196','62199','62230','62232','62234','62236','62238','62240','62242','62244','62246','62248','62250','62252','62254','62256','62258','62265','62266','62270','62275','62276','62330','62331','62332','62333','62335','62336','62337','62338','62340','62341','62342','62343','62344','62346','62347','62348','62349','62350','62352','62353','62354','62355','62356','62357','62359','62360','62361','62362','62363','62364','62365','62366','62367','62368','62369','62370','62371','62372','62374','62375','62376','62378','62379','62430','62432','62434','62436','62438','62440','62442','62444','62446','62450','62453','62454','62455','62456','62458','62460','62464','62466','62467','63502','63503','63504','63505','63506','63507','63508','63509','63510','63511','63512','63513','63514','63517','63518','63519','63520','63531','64010','64020','64024','64031','64033','64040','64043','64162','64191','64192','64193','64194','64195','64196','64197','64291','64292','64293','64294','64295','64296','64360','64391','64392','64393','64394','64395','64396','64397','64398','64591','64592','64593','64594','64596','64597','64691','64692','64693','64694','64695','64696','64791','64792','64793','64795','64930','64991','65591','65592','65593','65594','66010','66040','66050','66052','66057','66060','66191','66192','66193','66194','66195','66196','66250','66291','66295','66296','66297','66298','66391','66392','66491','66492','66495','66591','66592','66593','66594','66691','66692','66693','66791','66891','66892','66893','66894','66895','66991','66992','67010','67020','67035','67040','67041','67043','67191','67192','67193','67194','67195','67196','67291','67292','67293','67294','67295','67391','67392','67393','68051','68052','68060','68061','68063','68065','68090','68096','68160','68191','68192','68193','68194','68195','68196','68291','68292','68293','68340','68361','68362','68391','68392','68393','68394','68395','68491','68492','68493','68495','68591','68592','68593','68594','68597','68691','68692','68693','68694','68695','68696','68697','68698','68891','68892','69191','69192','69193','69194','69291','69292','69293','69391','69392','69393','69394','69395','69450','69460','69491','69492','69493','69494','69495','69496','69497','69498','69499','69591','69592','69593','69594','69595','69596','69597','69691','69692','69693','69694','69695','69696','69697','69791','69792','69793','69794','70510','70591','70592','70593','70594','70595','70596','70597','70598','71172','71176','71177','71178','71191','71192','71193','71194','71195','71196','71197','71198','71291','71293','71294','71295','71391','71392','71393','71394','71472','71491','71492','71493','71494','71591','71592','71593','71594','71595','71596','71691','71692','71693','71694','71840','71891','71892','71893','71894','71895','71896','71897','71991','71992','71993','71994','71995','72591','72592','72593','72594','72595','72596','72597','72598','72691','72692','73060','73091','73111','73113','73114','73115','73170','73191','73192','73193','73194','73195','73196','73197','73198','73250','73272','73273','73291','73292','73293','73294','73295','73296','73297','73298','73338','73360','73361','73362','73363','73375','73391','73392','73393','73394','73395','73396','73397','73398','73399','73491','73492','73493','73494','73591','73691','73692','73693','73790','73791','73792','73891','73892','73991','73992','74010','74011','74012','74020','74045','74046','74047','74145','74190','74191','74192','74193','74194','74195','74196','74250','74291','74292','74293','74294','74295','74296','74297','74371','74372','74373','74374','74381','74382','74386','74387','74391','74392','74393','74394','74491','74492','74493','74494','74495','74496','74497','74571','74592','74593','74594','74595','74596','74597','74598','74599','74691','74692','74693','74694','74695','74696','74791','74792','74793','74794','74795','74850','74891','74892','74893','74894','74895','74896','74946','74948','74950','74951','74962','74963','74970','74971','74972','75591','75592','75593','75594','75595','75596','75597','75598','76010','76015','76017','76018','76019','76021','76031','76040','76041','76042','76045','76049','76111','76112','76113','76141','76171','76172','76173','76174','76175','76176','76191','76192','76193','76194','76196','76197','76198','76291','76292','76293','76294','76295','76296','76297','76298','76391','76392','76393','76394','76430','76453','76454','76456','76457','76491','76492','76493','77010','77012','77013','77014','77070','77071','77165','77190','77192','77194','77270','77290','77294','77468','77491','77492','77493','77494','77497','77498','77499','77595','77596','77690','77691','77692','77693','77695','77696','77697','77698','77790','77791','77793','77794','78050','78051','78053','78054','78064','78066','78067','78068','78069','78168','78169','78190','78191','78192','78193','78194','78195','78196','78197','78198','78199','78290','78291','78390','78391','78392','78393','78395','78530','78542','78543','78544','78545','78550','78560','78561','78563','78591','78592','79015','79020','79021','79022','79023','79024','79025','79026','79070','79090','79091','79191','79192','79193','79194','79195','79196','79277','79290','79291','79292','79293','79294','79295','79296','79297','79298','79341','79350','79360','79370','79390','79391','79392','79394','79397','79433','79490','79491','79492','79493','79495','79498','79536','79590','79591','79592','79595','79596','79690','79691','79699','80272','80293','80591','80592','80595','80596','80597','80598','80647','81020','81021','81022','81040','81191','81192','81193','81194','81195','81241','81290','81292','81293','81294','81391','81394','81395','81396','81491','81492','81493','81494','81495','81591','81592','81593','81594','81595','81596','81690','81691','81692','81693','81694','81695','81730','81791','81792','81793','81794','81891','81892','81961','81962','81963','81964','81965','81966','82010','82011','82020','82021','82022','82023','82026','82029','82040','82041','82042','82043','82046','82050','82051','82060','82062','82064','82065','82070','82071','82072','82074','82075','82076','82077','82078','82158','82191','82192','82193','82194','82195','82198','82240','82291','82292','82299','82330','82391','82392','82393','82491','82492','82493','82494','82591','82592','82593','82595','82596','82661','82670','82691','82692','82693','82694','82695','82740','82791','82792','82793','82794','82795','82891','82892','82893','82894','82895','82899','83001','83002','83004','83005','83010','83012','83013','83015','83019','83021','83022','83023','83024','83047','83051','83060','83067','83070','83076','83080','83081','83086','83090','83093','83191','83192','83293','83294','83296','83392','83393','83394','83395','83396','83497','83498','83541','83591','83592','83593','83594','83595','83691','83692','83693','83694','83695','84010','84012','84013','84024','84030','84031','84032','84034','84040','84050','84058','84060','84064','84067','84070','84073','84080','84085','84090','84091','84093','84094','84095','84096','84097','84098','84144','84191','84192','84193','84194','84196','84197','84291','84292','84293','84294','84299','85590','86013','86025','86035','86040','86041','86191','86192','86193','86291','86292','86294','86295','86296','86491','86492','86551','86591','86592','87010','87011','87015','87016','87030','87031','87032','87033','87052','87166','87191','87192','87193','87194','87263','87264','87275','87291','87292','87293','87294','87295','87296','87297','87298','87391','87392','88030','88031','88037','88040','88041','88050','88051','88191','88192','88193','88194','88195','88291','88293','88295','89050','89051','89054','89190','89192','89195','89196','89292','89301','89391','89392','89395','89396','89399','89491','89493','89495','89540','89591','89592','89593','89595','89597','89598','89599','89691','89693','90532','90571','90572','90580','90581','90582','90583','90586','90587','90588','90591','90592','90593','90594','90595','90596','91088','91191','91192','91193','91194','91290','91291','91292','91293','91294','91295','91297','91298','91299','91441','91490','91491','91492','91493','91494','91495','91496','91497','91534','91591','91592','91593','91594','91595','91596','91597','91598','91691','91692','91693','91695','91702','91703','91704','91791','91793','91794','91795','91799','91891','91892','91931','91932','91991','91992','91993','91994','91995','92034','92039','92040','92041','92042','92051','92064','92066','92129','92191','92192','92193','92194','92195','92199','92261','92262','92263','92266','92267','92273','92275','92276','92277','92278','92291','92292','92293','92294','92295','92341','92394','92395','92396','92397','92398','92399','92492','92493','92494','92495','93010','93027','93047','93052','93055','93061','93070','93071','93072','93081','93082','93086','93091','93191','93192','93193','93194','93195','93196','93197','93198','93199','93291','93391','93399','93491','93492','93493','93494','93495','93496','93591','93592','93593','93632','93651','93691','93692','93693','93694','93695','93733','93791','93792','93793','93794','93795','93796','93892','93893','93894','93895','93896','94191','94192','94199','94203','94204','94205','94291','94292','94293','94294','94295','94473','94491','94492','94493','94494','94534','94591','94592','94593','94640','94691','94692','94699','95042','95204','95243','95244','95250','95270','95271','95272','95291','95292','95293','95294','95295','95296','95297','95391','95392','95393','95394','95395','95591','95592','95595','95596','95599','95691','95692','95693','95698','95699','95723','95791','95792','95793','95794','95795','95799','96024','96030','96032','96147','96191','96192','96193','96194','96195','96196','96197','96198','96202','96203','96298','96299','97499','97561','97591','97592','97593','97594','97595','97596','97597','97598','98010','98013','98016','98041','98042','98045','98060','98061','98062','98107','98193','98194','98195','98199','98203','98204','98205','98206','98207','98260','98291','98292','98299','98303','98491','98492','98494','98495','98499'];
            }

            function validateZipcode(zipcode) {
                if(zipcode) {
                    vm.isValidating = true;
                    $timeout(function(){
                        if (_.contains(unsupportedZipCodes, zipcode)) {
                            vm.isValidating = false;
                            vm.isSubmitted = true;
                            vm.isValid = false;

                        } else {
                            vm.isValidating = false;
                            vm.isSubmitted = true;
                            vm.isValid = true;
                        };
                    }, 750);
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('cashOnDelivery', cashOnDelivery);

    cashOnDelivery.$inject = ['$window', '$http'];

    function cashOnDelivery($window, $http) {

       var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/cash-on-delivery/cash-on-delivery.directive.html',
            scope: {
                product: '=',
                maxAmountInput: '='
            },
            controller: cashOnDeliveryController,
            controllerAs: 'cashOnDelivery',
            bindToController: true
        };
        return directive;

        function cashOnDeliveryController() {
            var vm = this;

            vm.checkAccountNumberValidity = checkAccountNumberValidity;
            vm.changeCOD = changeCOD;
            vm.amountChanged = amountChanged;

            activate();

            function activate() {
                // Temporary fix: Refer to PNOST-222
                // if(vm.product.cashOnDelivery){
                //     vm.cod = angular.copy(vm.product.cashOnDelivery);
                //     vm.codIsAdded = true;
                // }
            }

            function checkAccountNumberValidity(cashOnDelivery) {
                vm.isValidating = true;
                vm.accountError = false;
                vm.referenceError = false;
                cashOnDelivery.accountNumber = cashOnDelivery.accountNumber.split(' ').join('');

                setTimeout(function(){
                    var POSTdetails = {accountNumber: cashOnDelivery.accountNumber, reference: cashOnDelivery.reference, amount: cashOnDelivery.amount + ''};
                    return $http.post(OnlineShippingTool.env.giroValidationUrl, POSTdetails).then(function(response) {

                        if((response.data.isPlusGiro || response.data.isBankGiro) && !response.data.validReference) {
                            vm.referenceError = true;
                            vm.isValidating = false;
                        }

                        if(!response.data.isPlusGiro && !response.data.isBankGiro) {
                            vm.accountError = true;
                            vm.isValidating = false;
                        }

                        if(!response.data.validAmount) {
                            vm.isValidating = false;
                            vm.form.amount.$setValidity('max', false);
                        }

                        if(response.data.valid) {
                            vm.accountError = false;
                            vm.referenceError = false;
                            cashOnDelivery.accountHolder = response.data.accountHolder;

                            if(response.data.isPlusGiro) {
                                cashOnDelivery.isPlusGiro = true;
                            } else if(response.data.isBankGiro){
                                cashOnDelivery.isBankGiro = true;
                            }

                            // Store amount to a different variable for display purposes
                            // There's a display glitch where amount is multiplied by 100 after clicking "Send" button
                            vm.displayedAmount = cashOnDelivery.amount;
                            vm.product.cashOnDelivery = cashOnDelivery;
                            vm.codIsAdded = true;
                            vm.isValidating = false;
                        }

                    })
                }, 500);
            }

            function changeCOD() {
                vm.codIsAdded = false;
                vm.product.cashOnDelivery = null;
            }

            function amountChanged() {
                vm.form.amount.$setValidity('max', true);
            };
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('additionalServicePrice', additionalServicePrice);

    /* @ngInject */
    function additionalServicePrice($log, Common) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/additional-service-price/additional-service-price.directive.html',
            scope: {
                isCustomerCompany: '=',
                product: '=',
                additionalService: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('product.additionalServices', updatePrice, true);
            scope.$watch('isCustomerCompany', updatePrice);
            scope.calculateMorphTotalPrice = Common.calculateMorphTotalPrice;

            function updatePrice() {
                if (scope.additionalService) {
                    scope.showTotalPrice = (scope.additionalService.validForAdditionalServiceIds || [])[0] === 'delivery-to-mailbox';

                    if (scope.showTotalPrice) {
                        var newProduct = angular.copy(scope.product);
                        selectAddon(newProduct, scope.additionalService);
                        deselectIncompatibleAddons(newProduct, scope.additionalService);
                        var prices = Common.calculatePriceForProduct(newProduct);
                        scope.totalPrice = scope.isCustomerCompany ? prices.totalPrice : prices.totalPriceWithVAT;
                    }
                }
            }

            function selectAddon(newProduct, additionalService) {
                var newProductAdditionalService = _.find(newProduct.additionalServices, { additionalServiceId: additionalService.additionalServiceId });
                if (newProductAdditionalService) {
                    newProductAdditionalService.selected = true;

                    if (additionalService.grouping) {
                        _.each(newProduct.additionalServices, function (service) {
                            if (service.grouping === additionalService.grouping) {
                                service.selected = true;
                            }
                        });
                    }
                }
            }

            function deselectIncompatibleAddons(newProduct, additionalService) {
                _.each(newProduct.additionalServices, function (service) {
                    if ((service.additionalServiceId !== additionalService.additionalServiceId && service.type === additionalService.type) ||
                        (service.disabledForAdditionalServiceIds && service.disabledForAdditionalServiceIds.indexOf(additionalService.additionalServiceId) !== -1)) {
                        delete service.selected;
                        if (service.grouping) {
                            deselectGroupedAddons(newProduct, service);
                        }
                    }
                });
            }

            function deselectGroupedAddons(newProduct, additionalService) {
                _.each(newProduct.additionalServices, function (service) {
                    if (service.grouping === additionalService.grouping) {
                        delete service.selected;
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('additionalService', additionalService);

    /* @ngInject */
    function additionalService() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/additional-service/additional-service.directive.html',
            scope: {
                product: '=',
                additionalServiceGroup: '=',
                isCustomerCompany: '=',
                multipleChoice: '=',
                isRoll: '=',
                onSelect: '&',
                onMultipleChoiceSelect: '=',
                hidden: '=isHidden'
            },
            link: linkFunc,
            controller: AdditionalServiceController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.additionalServiceGroup', scope.ctrl.activate, true);

            scope.$watch('ctrl.product', scope.ctrl.checkIfHidden, true);
            scope.$watch('ctrl.service', scope.ctrl.checkIfHidden, true);
            scope.$watch('ctrl.isRoll', scope.ctrl.checkIfHidden);
            scope.$watch('ctrl.isCustomerCompany', scope.ctrl.checkIfHidden);
        }
    }

    AdditionalServiceController.$inject = ['$filter', 'AdditionalServiceHelper'];

    /* @ngInject */
    function AdditionalServiceController($filter, AdditionalServiceHelper) {
        var vm = this;

        vm.hidden = false;

        vm.activate = activate;
        vm.checkIfHidden = checkIfHidden;

        vm.isPending = isPending;
        vm.isChecked = isChecked;
        vm.isDisabled = isDisabled;

        vm.isExpressDeliveryService = isExpressDeliveryService;
        vm.isCashOnDeliveryService = isCashOnDeliveryService;
        vm.isResponsibilityService = isResponsibilityService;
        vm.isEveningHomeDeliveryService = isEveningHomeDeliveryService;
        vm.isCompanyExpressService = isCompanyExpressService;
        vm.isResponsibilityService = isResponsibilityService;

        vm.isDisabledVisually = isDisabledVisually;

        ///////////////////

        function activate(additionalServiceGroup) {
            var services = _.get(additionalServiceGroup, 'services');
            if (services) {
                vm.service = _.find(services, {selected: true}) || services[0];
            }
        }

        function checkIfHidden() {
            if (vm.product && vm.service) {
                vm.hidden = !isValidForSelectedProduct(vm.product, vm.service) ||
                    !isValidForSelectedAdditionalServices(vm.product, vm.service) ||
                    !isValidForRoll(vm.service, vm.isRoll) ||
                    !isValidForSelectedWeightChoice(vm.product, vm.service) ||
                    !isValidForCustomerType(vm.service);
            } else {
                vm.hidden = true;
            }
        }

        function isPending(product, service) {
            var isInvalidZipCode = (isEveningHomeDeliveryService(service) || isExpressDeliveryService(service) || isCompanyExpressService(service)) && !service.isValidZipCode;
            var isInvalidCashOnDelivery = isCashOnDeliveryService(service) && !product.cashOnDelivery;
            var isInvalidResponsibility = isResponsibilityService(service) && !product.responsibilityValue;
            return service.selected && (isInvalidZipCode || isInvalidCashOnDelivery || isInvalidResponsibility);
        }

        function isChecked(service) {
            return service.selected || (service.included && !service.override);
        }

        function isDisabledVisually(product, service) {
            return product && (
                isDisabledExpressDeliveryService(service, product.additionalServices) ||
                !isEnabledForBaseProductId(product, service)
            );
        }

        function isDisabled(service) {
            return (service.included && !service.override);
        }

        function isEveningHomeDeliveryService(service) {
            return service.selected && AdditionalServiceHelper.isEveningHomeDeliveryService(service);
        }

        function isExpressDeliveryService(service) {
            return service.selected && AdditionalServiceHelper.isExpressDeliveryService(service);
        }

        function isCashOnDeliveryService(service) {
            return service.selected && AdditionalServiceHelper.isCashOnDeliveryService(service);
        }

        function isResponsibilityService(service) {
            return service.selected && AdditionalServiceHelper.isResponsibilityService(service);
        }

        function isCompanyExpressService(service) {
            return service.selected && AdditionalServiceHelper.isCompanyExpressService(service);
        }

        function isDisabledExpressDeliveryService(service, additionalServices) {
            return service.additionalServiceId === 'Expresspaket' && _.some(additionalServices, function(_service) {
                return _service.selected && _service.additionalServiceId === '1001051'
            });
        }

        function isEnabledForBaseProductId(product, service) {
            if (service.enabledForBaseProductIds) {
                var chosenBaseProductId = AdditionalServiceHelper.getSelectedBaseProductIdForAdditionalServices(product.additionalServices, product);
                return service.enabledForBaseProductIds.indexOf(chosenBaseProductId) !== -1;
            } else {
                return true;
            }
        }

        function isValidForSelectedProduct(product, service) {
            if (!!service.validForBaseProductIds) {
                var chosenBaseProductId = AdditionalServiceHelper.getSelectedBaseProductIdForAdditionalServices(product.additionalServices, product);

                //Only included services that have different valid baseProducts, everything else is valid/should be shown
                if (!!service.included) {
                    return service.validForBaseProductIds.indexOf(chosenBaseProductId) !== -1;
                } else {
                    var otherServicesOfSameType = _.filter(product.additionalServices, function (_service) {
                        return service !== _service && service.type && service.type === _service.type;
                    });

                    var hasOtherServiceOfSameTypeValid = _.some(otherServicesOfSameType, function (_service) {
                        return _service.validForBaseProductIds
                            && (_service.validForBaseProductIds.indexOf(chosenBaseProductId) !== -1)
                            && !_service.override;
                    });

                    if (hasOtherServiceOfSameTypeValid) {
                        return false;
                    } else {
                        return service.validForBaseProductIds.indexOf(chosenBaseProductId) !== -1;
                    }

                    return !hasOtherServiceOfSameTypeValid;
                }
            } else {
                return true;
            };
        }

        function isValidForSelectedAdditionalServices(product, service) {
            var currentAdditionalServiceIds = _.chain(product.additionalServices)
                .filter({ selected: true })
                .map('additionalServiceId')
                .value();
            return !service.validForAdditionalServiceIds || _.intersection(service.validForAdditionalServiceIds, currentAdditionalServiceIds).length > 0;
        }

        function isValidForSelectedWeightChoice(product, service) {
            var selectedWeightChoice = _.find(product.additionalServices, function (_service) {
                return _.get(_service, 'multipleChoiceAddOn.name') === 'weightChoice' && !!_service.selected;
            }) || _.find(vm.product.additionalServices, function (_service) {
                return _.get(_service, 'multipleChoiceAddOn.name') === 'weightChoice' && _service.included;
            });

            return !service.validForWeightChoice || (selectedWeightChoice && selectedWeightChoice.additionalServiceId === service.validForWeightChoice);
        }

        function isValidForRoll(service, isRoll) {
            return $filter('nonRollService')([service], isRoll).length > 0;
        }

        function isValidForCustomerType(service) {
            return !service.validForBusinessCustomerOnly || vm.isCustomerCompany;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('additionalServiceDropdown', additionalServiceDropdown);

    /* @ngInject */
    function additionalServiceDropdown() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/additional-service/additional-service-dropdown.directive.html',
            scope: {
                product: '=',
                additionalServiceGroup: '=',
                isCustomerCompany: '=',
                onSelect: '&'
            },
            link: linkFunc,
            controller: AdditionalServiceDropdownController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

        }
    }

    AdditionalServiceDropdownController.$inject = ['Common'];

    /* @ngInject */
    function AdditionalServiceDropdownController(Common) {
        var vm = this;

        vm.setSelectedServiceInGroup = setSelectedServiceInGroup;

        function setSelectedServiceInGroup(group, selectedService) {
            _.each(group.services, function (service) {
                service.selected = service.multipleChoiceAddOn === selectedService.multipleChoiceAddOn;
            });

            vm.onSelect()(group, selectedService);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.user.history.orderDetails')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.user.orderDetails', {
          url: '/history/order?cartId&itemId',
          templateUrl: 'components/user/history/order-details/order-details.html',
          controller: 'OrderDetailsController',
          controllerAs: 'orderDetails'
      });
  }

})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool.user.history.orderDetails')
        .controller('OrderDetailsController', OrderDetailsController)

    OrderDetailsController.$inject = ['OrderHistoryFactory', '$stateParams', 'PrintingFactory', 'ShipmentFactory'];

    function OrderDetailsController(OrderHistoryFactory, $stateParams, PrintingFactory, ShipmentFactory) {
        /* jshint validthis:true */
        var vm = this;

        vm.cartId = $stateParams.cartId;
        vm.itemId = $stateParams.itemId;
        vm.printWaybill = PrintingFactory.printWaybill;
        vm.getDigitalStampsExpiryDate = getDigitalStampsExpiryDate;
        vm.claimsUrl = OnlineShippingTool.env.claimsUrl;

        activate();

        function activate() {
            vm.loadingEvents = true;

            getConsignmentInfo($stateParams.cartId, $stateParams.itemId)
                .then(getShipment);

            checkIfWaybillIsAvailable($stateParams.cartId);
        }

        function getConsignmentInfo(cartId, itemId) {
            return OrderHistoryFactory.getConsignmentInfo($stateParams.cartId, $stateParams.itemId).then(function(response) {
                vm.parcel = response;
                return response;
            });
        }

        function getShipment(parcel) {
            return ShipmentFactory.getShipment(parcel.consignmentNumber).then(function (shipment) {
                vm.shipment = shipment;
                vm.loadingEvents = false;
                return shipment;
            });
        }

        function checkIfWaybillIsAvailable(cartId) {
            PrintingFactory.checkWaybillAvailability(cartId).then(function (res) {
                vm.waybillIsAvailable = true;
            }, function (error) {
                vm.waybillIsAvailable = false;
            });
        }

        function getDigitalStampsExpiryDate() {
            if (vm.parcel.content.digitalStamps && vm.parcel.content.digitalStamps.stamps.length) {
                var stamp = vm.parcel.content.digitalStamps.stamps[0];
                console.log(stamp);
                return moment(stamp.userCommunicatedStampExpiryDateTime).format('LL');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.measurement', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.measurement')
        .directive('seSidebarMeasurement', seSidebarMeasurement);

    /* @ngInject */
    function seSidebarMeasurement() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/se/measurement/sidebar-measurement.directive.html',
            controller: SidebarMeasurementController,
            controllerAs: 'sidebarMeasurement',
            bindToController: true
        };

        return directive;
    }

    SidebarMeasurementController.$inject = [];

    /* @ngInject */
    function SidebarMeasurementController() {
        var vm = this;

        vm.setActiveTab = setActiveTab;

        activate();

        ////////////////////////

        function activate() {
            vm.activeTab = 'measure';
        }

        function setActiveTab(tab) {
            vm.activeTab = tab;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.dkmeasurements', []);
})();
(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.sidebar.dkmeasurements')
        .directive ('dkMeasurements', dkMeasurements);

    function dkMeasurements($window) {
        // Usage:
        //     <dk-measurements></dk-measurements>
        // Creates:
        //
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/dk/measurements/measurements.directive.html',
            controller: dkMeasurementsController,
            controllerAs: 'measurements',
            bindToController: true
        };
        return directive;

        dkMeasurementsController.$inject = [];

        function dkMeasurementsController() {
            var vm = this;

            vm.setActiveTab = setActiveTab;

            activate();

                    ////////////////////////

                function activate() {
                    vm.activeTab = 'measure';
                }

                function setActiveTab(tab) {
                    vm.activeTab = tab;
                }
        }
    }

})();

(function() {
    'use strict';
    
    angular
        .module('onlineShippingTool.sidebar.dkClimateCompensation', []);
})();
(function () {
  'use strict';

    angular
        .module ('onlineShippingTool.sidebar.dkClimateCompensation')
        .directive ('dkClimateCompensation', dkClimateCompensation);

    function dkClimateCompensation() {
        // Usage:
        //     <dk-climate-compensation></dk-climate-compensation>
        // Creates:
        //
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/dk/climate-compensation/climate-compensation.directive.html',
            scope: {
                product: '=?',
                products: '=?',
            },
            link: linkFunc,
            controller: dkClimateCompensationController,
            controllerAs: 'vm',
            bindToController: true
        };
        dkClimateCompensationController.$inject = ['$translate'];

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.vm;
            
            scope.$watch('vm.product', scope.vm.activate, true);
            scope.$watch('vm.products', function(products){
                vm.setProduct(products)
            }, true);

            scope.$on('changeLanguage', function(events, lang) {
                vm.isDk = lang === 'da' ? true : false;
            });
        }
    }
    function dkClimateCompensationController($translate) {
        var vm = this;

        vm.activate = activate;
        vm.setProduct = setProduct;
      
        function activate() {
            if (vm.product) {
                vm.climateCompensatedProduct = 
                vm.product.showCO2sign
                ? true 
                : false
            }
            vm.isDk = $translate.proposedLanguage() === 'da' || $translate.use() === 'da' ? true : false;
        }
          
        function setProduct(products) {
            if (products && products.length === 1) {
                vm.product = products[0]
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.selectedProduct', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.selectedProduct')
        .directive('cmnSidebarSelectedProduct', cmnSidebarSelectedProduct);

    /* @ngInject */
    function cmnSidebarSelectedProduct(Common) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/selected-product/selected-product.directive.html',
            scope: {
                product: '=',
                isCustomerCompany: '=',
                selectedWeight: '=',
                editCallback: '&?',
                heading: '='
            },
            link: linkFunc,
            controller: SelectedProductController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('vm.product', scope.vm.updateProduct, true);
            scope.$watch('vm.isCustomerCompany', function () {
                scope.vm.updateProduct(scope.vm.product);
            });
        }
    }

    /* @ngInject */
    function SelectedProductController($localStorage, $log, $translate, appOptions, AdditionalServiceHelper, Common, $scope) {
        var vm = this;

        vm.country = appOptions.country;
        vm.updateProduct = updateProduct;
        vm.expanded = false;
        vm.hasCustomsDocuments = hasCustomsDocuments;
        vm.market = Common.getMarket();

        $scope.$on('main:customerTypeChanged', function() {
            setProductPrice();
            setDeliveryTime(vm.product);
        });

        // ///////////////

        function updateProduct(product) {
            if (product) {
                setProduct(product);
                setDeliveryTime(product);
                setAdditionalServices(product);
            }
        }

        function setProductPrice() {
            vm.productPrice = $localStorage.isCustomerCompany ? Common.getPriceForParcel(vm.product) : Common.getVatPriceForParcel(vm.product);
            return vm.productPrice;
        }

        function setProduct(product) {
            var _product = angular.copy(product);

            setProductDimensions(_product);

            var weightChoice = _.find(_product.additionalServices, function (service) {
                return service.selected && _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
            });

            vm.baseProductName = getBaseProductName(_product);
            setProductPrice(_product);
            if (weightChoice) {
                vm.productName = _product.name + ' &ndash; ' + weightChoice.additionalWeight.value + ' ' + weightChoice.additionalWeight.unit;
                vm.productWeight = weightChoice.additionalWeight;
            } else {
                vm.productName = _product.name;
                vm.productWeight = _product.maxWeight;
            }
            if (product.quantity > 1) {
                vm.productName = _product.quantity + ' &times; ' + vm.productName;
            }
        }

        function setProductDimensions(product) {
            var dimensionsAddOn = _.find(product.additionalServices, function (service) {
                return service.selected && (_.get(service, 'dimensions') !== undefined );
            });

            if (product.isRoll) {
                vm.productDimensions = (dimensionsAddOn && dimensionsAddOn.dimensions.roll) || product.dimensions.roll;
            }
            else {
                vm.productDimensions = (dimensionsAddOn && dimensionsAddOn.dimensions) || product.dimensions;
            }

            vm.productDimensions.dimensionDescriptions = _.map(vm.productDimensions.dimensionDescriptions, function (description) {
                if (description.text) {
                    var matchingDimension = vm.productDimensions['length'];

                    if (matchingDimension) {
                        return {
                            description: description.description,
                            maxValue: matchingDimension.max,
                            unit: matchingDimension.unit
                        };
                    } else {
                        return description;
                    }
                } else {
                    return description;
                }
            });
        }

        function calcVAT(vat) {
            return vat ? 1 + vat/10000 : 1;
        }

        function calcShipmentCost(product, shipmentService, vat) {
            var weightChoice = _.find(product.additionalServices, function (_service) {
                return _.get(_service, 'multipleChoiceAddOn.name') === 'weightChoice' && !!_service.selected;
            }) || _.find(vm.product.additionalServices, function (_service) {
                return _.get(_service, 'multipleChoiceAddOn.name') === 'weightChoice' && _service.included;
            });
            return (product.price + (weightChoice ? weightChoice.price : 0) + shipmentService.price) * (vat || 1) - (product.price * calcVAT(product.vat) + (weightChoice ? weightChoice.price : 0) * calcVAT((weightChoice ? weightChoice.vat : null)));
        }


        function setDeliveryTime(product) {
            var deliveryTimeService = _.find(product.additionalServices, function (service) {
                return service.selected && isDeliveryTime(service);
            });
            var shipmentDaysService = _.find(product.additionalServices, function (service) {
                return service.selected && service.type === 'EMS';
            });
            var serviceWithDeliveryTime = _.find(product.additionalServices, function (service) {
                return service.selected && typeof(service.deliveryTime) !== 'undefined';
            });
            var serviceWithShipmentDays = _.find(product.additionalServices, function (service) {
                return service.selected && typeof(service.shipmentDays) !== 'undefined';
            });


            if (deliveryTimeService && shipmentDaysService) {
                vm.deliveryTime = {
                    text: deliveryTimeService.shortName,
                    price: $localStorage.isCustomerCompany 
                        ? calcShipmentCost(product, deliveryTimeService) 
                        : calcShipmentCost(product, deliveryTimeService, 1 + deliveryTimeService.vat/10000),
                    currency: deliveryTimeService.priceUnit
                };
            } else if (serviceWithDeliveryTime) {
                vm.deliveryTime = {
                    text: serviceWithDeliveryTime.deliveryTime
                };
            } 
            else if (shipmentDaysService) {
                var daysString = shipmentDaysService.shipmentDays === '1' ? 'WEEKDAY' : 'WEEKDAYS';
                vm.deliveryTime = {
                    text: shipmentDaysService.shipmentDays + ' ' + $translate.instant(daysString),
                    price: $localStorage.isCustomerCompany ? calcShipmentCost(product, shipmentDaysService) : calcShipmentCost(product, shipmentDaysService, 1 + shipmentDaysService.vat/10000),
                    currency: shipmentDaysService.priceUnit
                };
            } else if (serviceWithShipmentDays) {
                var daysString = serviceWithShipmentDays.shipmentDays === '1' ? 'WEEKDAY' : 'WEEKDAYS';
                vm.deliveryTime = {
                    text: serviceWithShipmentDays.shipmentDays + ' ' + $translate.instant(daysString),
                };
            } else if (product.shipmentDays) {
                var daysString = product.shipmentDays === '1' ? 'WEEKDAY' : 'WEEKDAYS';
                vm.deliveryTime = {
                    text: product.shipmentDays + ' ' + $translate.instant(daysString)
                };
            } else {
                delete vm.deliveryTime;
            }
        }

        function setAdditionalServices(product) {
            var additionalServices = angular.copy(product.additionalServices);

            vm.additionalServices = _.chain(additionalServices)
                .filter(isSelectedOrIncluded)
                .filter(isNotWeightChoice)
                .filter(isNotDeliveryTimeOrShipmentDaysService)
                .map(function (service) {
                    var price,
                        hidden = checkIfHiddenService(product, service);
                    if (service.grouping && !service.hidden) {
                        var hiddenClone = _.findWhere(additionalServices, { grouping: service.grouping, hidden: true });
                        price = vm.isCustomerCompany
                            ? (service.price + hiddenClone.price)
                            : (service.price + hiddenClone.price * (1 + hiddenClone.vat / 10000));
                    } else {
                        price = vm.isCustomerCompany
                            ? service.price
                            : Common.calculateMorphTotalPrice(product, service);
                    }

                    if (product.quantity > 1) {
                        price = product.quantity * price;
                    }

                    return {
                      title: getAdditionalServiceTitle(service),
                      subtitle: getAdditionalServiceSubtitle(service),
                      parcelValue: service.parcelValue,
                      price: price,
                      currency: service.priceUnit,
                      included: service.included,
                      hidden: service.hidden || hidden
                    }
                })
                .value();

        }

        function isSelectedOrIncluded(service) {
            return service.selected || (service.included && !service.override);
        }

        function isNotWeightChoice(service) {
            return _.get(service, 'multipleChoiceAddOn.name') !== 'weightChoice';
        }

        function isDeliveryTime(service) {
            return ['standard_delivery', 'faster_delivery'].indexOf(service.additionalServiceId) !== -1;
        }

        function isNotDeliveryTimeOrShipmentDaysService(service) {
            return ['standard_delivery', 'faster_delivery'].indexOf(service.additionalServiceId) === -1
                && service.type !== 'EMS';
        }

        function getAdditionalServiceTitle(service) {
            return service.multipleChoiceAddOn ? service.multipleChoiceAddOn.title : (service.shortName || service.name);
        }

        function getAdditionalServiceSubtitle(service) {
            return service.multipleChoiceAddOn && service.multipleChoiceAddOn.value;
        }

        function getBaseProductName(product) {
            return (_.find(product.additionalServices, function(service) {
                return (service.selected || (service.included && !service.override)) && service.baseProductName;
            }) || product).baseProductName;
        }

        function checkIfHiddenService(product, service) {
            if (service.grouping) {
                var currentAdditionalServiceIds = AdditionalServiceHelper.getSelectedAdditionalServiceIds(product.additionalServices);
                var groupedService = _.findWhere(product.additionalServices, { grouping: service.grouping });
                var isValid = (!groupedService.validForAdditionalServiceIds || _.intersection(groupedService.validForAdditionalServiceIds, currentAdditionalServiceIds).length > 0)
                    && (!groupedService.disabledForAdditionalServiceIds || _.intersection(groupedService.disabledForAdditionalServiceIds, currentAdditionalServiceIds).length === 0);

                return !isValid;
            }
            return false;
        }

        function hasCustomsDocuments(product) {
            if (!product) return;
            var documents = Common.getDocumentsForParcel(product);
            return _.chain(documents).find({ type: 'customsLabel' }).value();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.productDetails', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.productDetails')
        .directive('cmnSidebarProductDetails', cmnSidebarProductDetails);

    /* @ngInject */
    function cmnSidebarProductDetails() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/product-details/sidebar-product-details.directive.html',
            scope: {
                product: '='
            },
            controller: SidebarProductDetailsController,
            controllerAs: 'ctrl',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watch('ctrl.product', scope.ctrl.activate);
        }
    }

    SidebarProductDetailsController.$inject = ['$sessionStorage'];

    /* @ngInject */
    function SidebarProductDetailsController($sessionStorage) {
        var vm = this;

        vm.activate = activate;

        ////////////////////

        function activate() {
            setMaxWeight(vm.product);
            setMeasurements(vm.product);
        }

        function setMaxWeight(product) {
            if (product && product.content) {
                var weightAddOn = _.find(product.content.additionalServices, function (service) {
                    return !!service.selected && (_.get(service, 'multipleChoiceAddOn.name') === 'weightChoice');
                });

                vm.maxWeight = weightAddOn ? weightAddOn.additionalWeight : product.content.maxWeight;
            }
        }
        function setMeasurements(product) {
            if (product && product.content) {
                var measurement = _.find(product.content.additionalServices, function (service) {
                    return !!service.selected && (_.get(service, 'dimensions') !== undefined );
                });

                vm.measurements = measurement ? measurement.dimensions : product.content.isRoll ? product.content.dimensions.roll : product.content.dimensions;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.overview', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.overview')
        .directive('cmnSidebarOverview', cmnSidebarOverview);

    /* @ngInject */
    function cmnSidebarOverview() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/overview/overview.directive.html',
            scope: {
                cart: '=',
                isCustomerCompany: '='
            },
            controller: SidebarOverviewController,
            controllerAs: 'ctrl',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watch('ctrl.cart', scope.ctrl.activate, true);
        }
    }

    SidebarOverviewController.$inject = ['Common', '$localStorage'];

    /* @ngInject */
    function SidebarOverviewController(Common, $localStorage) {
        var vm = this;

        vm.activate = activate;

        function activate() {
            if (vm.cart) {
                var cart = angular.copy(vm.cart);

                vm.totalPriceForParcels = vm.isCustomerCompany
                    ? Common.getTotalPriceForParcels(cart)
                    : Common.getTotalVatPriceForParcels(cart);

                vm.items = _.chain(cart)
                    .map(function (item) {
                        var weightChoice = _.find(item.additionalServices, function (service) {
                            return service.selected && _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
                        });

                        var name = weightChoice
                            ? item.name + ' &ndash; ' + weightChoice.additionalWeight.value + ' ' + weightChoice.additionalWeight.unit
                            : item.name;

                        if (item.quantity > 1) {
                            name = item.quantity + ' &times; ' + name;
                        }

                        var price = vm.isCustomerCompany
                            ? Common.getPriceForParcel(item)
                            : Common.getVatPriceForParcel(item);

                        var additionalServices = filterAdditionalServices(item.additionalServices);

                        return {
                            receiverName: item.receiver.company || item.receiver.name,
                            name: name,
                            price: price,
                            priceUnit: item.priceUnit,
                            additionalServices: additionalServices
                        }
                    })
                    .value();
            }
        }

        function filterAdditionalServices(additionalServices) {
            return _.filter(additionalServices, function (service) {
                return _.get(service, 'multipleChoiceAddOn.name') !== 'weightChoice';
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.measurementLimits', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.measurementLimits')
        .directive('cmnSidebarMeasurementLimits', cmnSidebarMeasurementLimits);

    /* @ngInject */
    function cmnSidebarMeasurementLimits() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/measurement-limits/measurement-limits.directive.html',
            scope: {
                cart: '=',
                collapsible: '='
            },
            controller: SidebarMeasurementLimitsController,
            controllerAs: 'ctrl',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watch('ctrl.cart', scope.ctrl.activate);
        }
    }

    SidebarMeasurementLimitsController.$inject = ['Common', 'appOptions'];

    /* @ngInject */
    function SidebarMeasurementLimitsController(Common, appOptions) {
        var vm = this;

        vm.activate = activate;
        vm.country = appOptions.country;

        function activate() {
            vm.parcelInfo = groupParcels(vm.cart);

            checkParcelTypes(vm.cart);
        }

        function groupParcels(parcels) {
            return _.chain(parcels)
                .groupBy(groupingFunction)
                .map(function (parcels, key) {
                    var parcel = parcels[0];
                    var hasPossibleWeightAddons = _.some(parcel.additionalServices, function (service) {
                        return _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
                    });

                    var maxWeight = getMaxWeightForParcel(parcel);
                    var name = parcel.name;

                    if (appOptions.country === 'DK') {
                        name += ' &ndash; ' + parcel.selectedWeight.value + ' ' + parcel.selectedWeight.unit;
                    } else {
                        name += (hasPossibleWeightAddons ? ' &ndash; ' + maxWeight.value + ' ' + maxWeight.unit : '');
                    }
                    var dimensionModifyingService = getDimensionModifyingServiceForParcel(parcel);

                    return {
                        name: name,
                        parcels: parcels,
                        dimensions: getDimensionsForParcel(parcel),
                        maxWeight: maxWeight,
                        dimensionModifyingService: dimensionModifyingService,
                        isRoll: parcel.isRoll
                    }
                })
                .value();
        }

        function groupingFunction(parcel) {
            var dimensions = getDimensionsForParcel(parcel);
            var dimensionsString
                = (dimensions.length ? (dimensions.length.max + dimensions.length.unit + 'x') : '')
                + (dimensions.width ? (dimensions.width.max + dimensions.width.unit + 'x') : '')
                + (dimensions.height ? (dimensions.height.max + dimensions.height.unit) : '');
            var rollDimensionsString
                 = (dimensions.diameter ? (dimensions.diameter.max + dimensions.diameter.unit) : '');

            var maxWeight = getMaxWeightForParcel(parcel);
            var maxWeightString = maxWeight.value + maxWeight.unit;

            return parcel.name + '|' + maxWeightString + '|' + (dimensionsString || rollDimensionsString);
        }

        function checkParcelTypes(cart) {
            vm.hasNonLetterParcels = _.some(cart, function (parcel) {
                return parcel.baseProductId !== '2006980' && parcel.baseProductId !== '2003742' && parcel.type !== 'letter';
            });

            vm.hasLetterParcels = _.some(cart, function (parcel) {
                return parcel.baseProductId === '2006980' || parcel.baseProductId === '2003742' || parcel.type === 'letter';
            });
        }

        function getMaxWeightForParcel(parcel) {
            var weightAddOn = _.find(parcel.additionalServices, function (service) {
                return !!service.selected && (_.get(service, 'multipleChoiceAddOn.name') === 'weightChoice');
            });

            return weightAddOn ? weightAddOn.additionalWeight : (parcel.selectedWeight ? parcel.selectedWeight : parcel.maxWeight);
            ;
        }

        function getDimensionsForParcel(parcel) {
            var dimensionsAddon = getDimensionModifyingServiceForParcel(parcel);

            var dimensions = null;
            if (parcel.isRoll) {
                dimensions = (dimensionsAddon && dimensionsAddon.dimensions.roll) || parcel.dimensions.roll;
            }
            else {
                dimensions = (dimensionsAddon && dimensionsAddon.dimensions) || parcel.dimensions;
            }

            dimensions.dimensionDescriptions = _.map(dimensions.dimensionDescriptions, function (description) {
                if (description.text) {
                    var matchingDimension = parcel.dimensions['length'];

                    if (matchingDimension) {
                        return {
                            description: description.description,
                            maxValue: matchingDimension.max,
                            unit: matchingDimension.unit
                        };
                    } else {
                        return description;
                    }
                } else {
                    return description;
                }
            });

            return dimensions;
        }

        function getDimensionModifyingServiceForParcel(parcel) {
            return _.find(parcel.additionalServices, function (service) {
                return !!service.selected && (_.get(service, 'dimensions') !== undefined);
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.dropoffMap', []);
})();
(function() {
  'use strict';

  angular
    .module('onlineShippingTool.sidebar.dropoffMap')
    .directive('cmnSidebarDropoffMap', cmnSidebarDropoffMap);

  /* @ngInject */
  function cmnSidebarDropoffMap() {
    var directive = {
      restrict: 'E',
      templateUrl: 'components/sidebar/common/dropoff-map/sidebar-dropoff-map.directive.html',
      controller: sidebarDropoffMapController,
      controllerAs: 'sidebarDropoffMap',
      bindToController: true
    };

    return directive;
  }

  /* @ngInject */
  function sidebarDropoffMapController($element, $sessionStorage, $window, $q, ServicePointFactory, SERVICE_POINT_LOCATIONS) {
    var vm = this;
    vm.lat = null;
    vm.lng = null;
    vm.loading = true;
    vm.isOpen = false;
    vm.showInGoogleMaps = showInGoogleMaps;

    if($sessionStorage.cart == undefined && $sessionStorage.lastPurchase != undefined) {
      vm.sender = $sessionStorage.lastPurchase[0].sender;
      vm.cart = $sessionStorage.lastPurchase;
    } else {
      vm.sender = $sessionStorage.cart[0].sender;
      vm.cart = $sessionStorage.cart;
    }

    getServicePoint()
      .then(initMap)
      .then(addMarker)
      .catch(hideBox);

    var map;

    function getServicePoint() {
      const { countryCode } = vm.sender.address;
      const servicePointType =
        vm.cart.some((item) => (
          item.sender.address.countryCode === 'DK' &&
          item.selectedWeight?.unit === 'kg' &&
          parseInt(item.selectedWeight?.value) > 20
        )) ?
          '46' : // Heavy parcels in Denmark needs to be handed in at Business Center (46)
          countryCode === 'SE' ?
          $sessionStorage.lastPurchase[0].servicePointTypes :
          SERVICE_POINT_LOCATIONS.DROPOFF[countryCode];

      return ServicePointFactory.getServicePointByAddress(vm.sender.address, servicePointType)
        .then(function (servicePoint) {
          vm.servicepoint = servicePoint;

          vm.isOpen = isServicePointOpen(servicePoint.openingHours);

          return servicePoint;
        });
    }

    function initMap(servicePoint) {
      map = new google.maps.Map(document.getElementById('dropoffMap'), {
        center: { lat: servicePoint.coordinates.lat, lng: servicePoint.coordinates.lng },
        zoom: 14,
        disableDefaultUI: true,
        zoomControl: false,
        scrollwheel: false,
        clickableIcons: false
      });

      return servicePoint;
    };

    function addMarker(servicePoint) {
      var size = new google.maps.Size(60, 72);

      if (window.devicePixelRatio >= 2) {
        size = new google.maps.Size(120, 144);
      }

      var markerIcon = {
        url:'assets/images/graphics-map-pin-ombud@2x.png',
        size: size,
        scaledSize: new google.maps.Size(60, 72),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(30, 36),
        labelOrigin: new google.maps.Point(0, 0)
      };

      //place a marker at the location
      var marker = new google.maps.Marker({
        map: map,
        icon: markerIcon,
        position: { lat: servicePoint.coordinates.lat, lng: servicePoint.coordinates.lng }
      });

      marker.addListener('click', showInGoogleMaps);
      // google.maps.event.trigger(map, 'resize');

      vm.loading = false;
    }

    function isServicePointOpen(openingHours) {
      var isOpen = false;

      var days = _.flatten(_.values(openingHours));
      var today = _.find(days, function (day) {
        return moment().locale('en').day(day.name).isSame(moment(), 'day');
      });

      if (today) {
        isOpen = _.some(today.hours, function (slot) {
          var currentTime = moment().format('HH:mm');
          return currentTime >= slot.from && currentTime <= slot.to;
        });
      }

      return isOpen;
    }

    function hideBox() {
      $element.css({display: 'none'});
    }

    function showInGoogleMaps() {
      var query = vm.servicepoint.name + ', ' + vm.servicepoint.visitingAddress.streetName + ' ' + vm.servicepoint.visitingAddress.streetNumber + ', ' + vm.servicepoint.visitingAddress.city;
      $window.open('https://maps.google.com/?q=' + encodeURIComponent(query));
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.cart', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.cart')
        .directive('cmnSidebarCart', cmnSidebarCart);

    /* @ngInject */
    function cmnSidebarCart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/cart/sidebar-cart.directive.html',
            scope: {
                cart: '=',
                isCustomerCompany: '=',
                showButton: '='
            },
            controller: SidebarCartController,
            controllerAs: 'sidebarCart',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watch('sidebarCart.cart', scope.sidebarCart.updateCart, true);
        }
    }

    SidebarCartController.$inject = ['$scope', 'Common'];

    /* @ngInject */
    function SidebarCartController($scope, Common) {
        var vm = this;

        vm.updateCart = updateCart;

        $scope.$on('product-removed', updateCart);

        // ///////////////////

        function updateCart() {
            if (vm.cart) {
                var cart = angular.copy(vm.cart);

                vm.items = _.chain(cart)
                    .map(function (item) {
                        var weightChoice = _.find(item.additionalServices, function (service) {
                            return service.selected && _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
                        });

                        var name = weightChoice
                            ? item.name + ' &ndash; ' + weightChoice.additionalWeight.value + ' ' + weightChoice.additionalWeight.unit
                            : item.name;

                        if (item.quantity > 1) {
                            name = item.quantity + ' &times; ' + name;
                        }

                        var price = vm.isCustomerCompany
                            ? Common.getPriceForParcel(item)
                            : Common.getVatPriceForParcel(item);

                        var additionalServices = filterAdditionalServices(item.additionalServices);

                        return {
                            receiverName: item.receiver.company || item.receiver.name,
                            name: name,
                            price: price,
                            priceUnit: item.priceUnit,
                            additionalServices: additionalServices
                        }
                    })
                    .value();
            }
        }

        function filterAdditionalServices(additionalServices) {
            return _.filter(additionalServices, function (service) {
                return _.get(service, 'multipleChoiceAddOn.name') !== 'weightChoice';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.addressSelectedProduct', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar.addressSelectedProduct')
        .directive('cmnAddressSidebarSelectedProduct', cmnAddressSidebarSelectedProduct);

    /* @ngInject */
    function cmnAddressSidebarSelectedProduct() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/sidebar/common/address-selected-product/address-selected-product.directive.html',
            scope: {
                product: '=',
                editParcelCallback: '&'
            },
            link: linkFunc,
            controller: AddressSelectedProductController,
            controllerAs: 'selectedProduct',
            bindToController: true
        };

        return directive;


        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.selectedProduct;

            attr.$observe('country', handleCountryChange);
            scope.$watch('selectedProduct.product', handleProductChange, true);

            function handleCountryChange(country) {
                if (country) {
                    vm.country = country;
                }
            }

            function handleProductChange(product) {
                if (product) {
                    vm.activate();
                }
            }
        }
    }

    AddressSelectedProductController.$inject = ['$log', '$sessionStorage', '$localStorage', '$state', 'Common'];

    /* @ngInject */
    function AddressSelectedProductController($log, $sessionStorage, $localStorage, $state, Common) {
        var vm = this;

        vm.editParcel = editParcel;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        vm.activate = activate;

        ////////////////////

        function activate() {
            setMaxWeight(vm.product);
            setMeasurements(vm.product);
            setTotalPrice(vm.product, vm.isCustomerCompany);
        }

        function editParcel(parcel) {
            if (vm.editParcelCallback) {
                vm.editParcelCallback()(vm.product);
            }
        }

        function setTotalPrice(parcel, isCustomerCompany) {
            var quantity = parcel.quantity || 1;

            if (isCustomerCompany) {
                vm.totalPrice = quantity * Common.getPriceForParcel(parcel);
            } else {
                vm.totalPrice = quantity * Common.getVatPriceForParcel(parcel);
            }
        }

        function setMaxWeight(parcel) {
            if (parcel) {
                var weightAddOn = _.find(parcel.additionalServices, function (service) {
                    return !!service.selected && (_.get(service, 'multipleChoiceAddOn.name') === 'weightChoice');
                });

                vm.maxWeight = weightAddOn ? weightAddOn.additionalWeight : (parcel.selectedWeight ? parcel.selectedWeight : parcel.maxWeight);
            }
        }
        function setMeasurements(parcel) {
            if (parcel) {
                var measurement = _.find(parcel.additionalServices, function (service) {
                    return !!service.selected && (_.get(service, 'dimensions') !== undefined );
                });

                vm.measurements = measurement ? measurement.dimensions : parcel.isRoll ? parcel.dimensions.roll : parcel.dimensions;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('seProductTable', seProductTable);

    /* @ngInject */
    function seProductTable() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/se/product-table/product-table.directive.html',
            scope: {
                cart: '=',
                isCustomerCompany: '=',
                isReceipt: '='
            },
            link: linkFunc,
            controller: ProductTableController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.cart', ctrl.activate);
        }
    }

    ProductTableController.$inject = ['$mdDialog', '$rootScope', '$sessionStorage', '$state', 'appOptions', 'CartFactory', 'Common', 'LocalCartFactory', 'Topbar', 'AdditionalServiceHelper'];

    /* @ngInject */
    function ProductTableController($mdDialog, $rootScope, $sessionStorage, $state, appOptions, CartFactory, Common, LocalCartFactory, Topbar, AdditionalServiceHelper) {
        var vm = this;

        vm.activate = activate;
        vm.editProduct = editProduct;
        vm.confirmDelete = confirmDelete;
        vm.showErrorDialog = showErrorDialog;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.getTotalPriceForParcels = Common.getTotalPriceForParcels;
        vm.getTotalVatPriceForParcels = Common.getTotalVatPriceForParcels;
        vm.changeSender = changeSender;
        vm.changeReceiver = changeReceiver;

        ///////////////////

        function activate() {
            setExpandedRows(vm.cart);
            setProductLists();

            vm.country = appOptions.country;
        }

        function setProductLists() {
            var partitions = _.partition(vm.cart, function (o) {
                return o.type === 'letter' && AdditionalServiceHelper.hasSelectedAdditionalServiceId(o.additionalServices, 'digitalStamps');
            });

            vm.letters = partitions[0];
            vm.packages = partitions[1];
        }

        function setExpandedRows(cart) {
            if(cart.length === 1) {
                cart[0].expand = true;
            } else {
                _.each(cart, function (item) {
                    item.expand = false;
                });
            }
        }

        function editProduct(product, state) {
            var countryCode = product.receiver.address.countryCode;
            $sessionStorage.editingFromState = $state.current.name;
            $sessionStorage.receiverCountryCode = countryCode;
            $sessionStorage.editParcel = product;
            var editingProduct = _.find($sessionStorage.cart, {itemId: product.itemId});
            editingProduct.isEditing = true;
            $rootScope.$broadcast('main:reloadCart');
            $rootScope.$broadcast('main:loadParcelTypes', countryCode);
            $state.go(state, { from: $state.current.name.replace('main.', '') });
        }

        function confirmDelete(ev, product) {
            // Appending dialog to document.body to cover sidenav in docs app
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'components/shared/common/product-table/delete.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            }).then(function() {
                removeProduct(product);
            });
        };

        function showErrorDialog(isDelete) {
            var templateUrl = isDelete ? 'components/shared/common/product-table/delete-error.dialog.html' : 'components/shared/common/product-table/update-error.dialog.html';

            $mdDialog.show({
                controller: DialogController,
                templateUrl: templateUrl,
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function () {
                LocalCartFactory.emptyCart();
                Topbar.updateCart();
                $rootScope.$broadcast('main:reloadCart');
                $state.go('main.landing');
            });
        }

        function DialogController($scope, $mdDialog, appOptions) {
            $scope.country = appOptions.country;

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.confirm = function() {
                $mdDialog.hide();
            };
        }

        function removeProduct(product) {
            CartFactory.removeProduct(product).then(function () {
                $rootScope.$broadcast('product-removed');
                LocalCartFactory.removeProduct(product);
                vm.cart = _.without(vm.cart, product);
                $sessionStorage.cart = _.without($sessionStorage.cart, product);
                $rootScope.$broadcast('main:reloadCart');
                Topbar.updateCart();
            }, function (error) {
                showErrorDialog(true);
            });
        }

        function changeSender(product){
            $mdDialog.show({
                controller: 'ChangeSenderModalControllerSE',
                controllerAs: 'ctrl',
                templateUrl: 'components/shared/se/change-sender-modal/change-sender-modal.html',
                parent: angular.element(document.body),
                targetEvent: null,
                locals: {
                    sender: product.sender,
                    parcel: product,
                },
            });
        }

        function changeReceiver(product){
            $mdDialog.show({
                controller: 'ChangeReceiverModalControllerSE',
                controllerAs: 'ctrl',
                templateUrl: 'components/shared/se/change-receiver-modal/change-receiver-modal.html',
                parent: angular.element(document.body),
                targetEvent: null,
                locals: {
                    receiver: product.receiver,
                    parcel: product,
                },
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .controller('ChangeSenderModalControllerSE', ChangeSenderModalControllerSE)

    /** @ngInject */
    function ChangeSenderModalControllerSE($scope, $mdDialog, $localStorage, appOptions, Common, sender, parcel, CartFactory, $rootScope) {
        var vm = this;

        vm.country = appOptions.country;
        vm.sender = angular.copy(sender);
        vm.product = parcel;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;

        $scope.cancel = function () {

            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            vm.senderForm.$setSubmitted();
            if (vm.senderForm.$valid) {
                parcel.sender = vm.sender;
                CartFactory.updateProduct(parcel).then(function () {
                    $rootScope.$emit('sender:updated');
                    $mdDialog.hide();
                });
            }
        };
    }
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .controller('ChangeReceiverModalControllerSE', ChangeReceiverModalControllerSE)

    /** @ngInject */
    function ChangeReceiverModalControllerSE($scope, $mdDialog, appOptions, Common, receiver, parcel, CartFactory) {
        var vm = this;

        vm.country = appOptions.country;
        vm.receiver = angular.copy(receiver);
        vm.parcel = parcel;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            vm.receiverForm.$setSubmitted();
            if(vm.receiverForm.$valid){
                parcel.receiver= vm.receiver;
                CartFactory.updateProduct(parcel).then(function() {
                    $mdDialog.hide();
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('dkProductTable', dkProductTable);



    function dkProductTable() {

        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/dk/product-table/product-table.directive.html',
            scope: {
                cart: '=',
                isCustomerCompany: '=',
                isReceipt: '=',
                isSubmitting: '=',
            },
            link: linkFn,
            controller: ProductTableController,
            controllerAs: 'productTable',
            bindToController: true
        };
        return directive;

        function linkFn(scope) {
            scope.$watch('productTable.cart', scope.productTable.activate);
        }
    }

    ProductTableController.$inject = ['$mdDialog', '$rootScope', '$sessionStorage', '$state', '$timeout', 'appOptions', 'CartFactory', 'Common', 'FeatureToggleFactory', 'LocalCartFactory', 'Topbar'];

    /* @ngInject */
    function ProductTableController($mdDialog, $rootScope, $sessionStorage, $state, $timeout, appOptions, CartFactory, Common, FeatureToggleFactory, LocalCartFactory, Topbar) {
        var vm = this;

        vm.activate = activate;
        vm.editProduct = editProduct;
        vm.confirmDelete = confirmDelete;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.changeSender = changeSender;
        vm.changeReceiver = changeReceiver;

        ///////////////////

        function activate() {
            setExpandedRows(vm.cart);

            vm.letters = _.filter(vm.cart, function (o) {
                return o.type === 'letter';
            });
            vm.packages = _.filter(vm.cart, function (o) {
                return o.type !== 'letter';
            });

            vm.country = appOptions.country;
            vm.customsState = appOptions.country === 'DK' && !FeatureToggleFactory.isFeatureEnabled('danishNewCustoms') ? 'main.customs' : 'main.customsNew';
        }

        function setExpandedRows(cart) {
            if (cart.length === 1) {
                cart[0].expand = true;
            } else {
                _.each(cart, function (item) {
                    item.expand = false;
                });
            }
        }

        function editProduct(product, state) {
            var countryCode = product.receiver.address.countryCode;
            $sessionStorage.editingFromState = $state.current.name;
            $sessionStorage.receiverCountryCode = countryCode;
            $sessionStorage.editParcel = product;
            var editingProduct = _.find($sessionStorage.cart, { itemId: product.itemId });
            editingProduct.isEditing = true;
            $rootScope.$broadcast('main:reloadCart');
            $rootScope.$broadcast('main:loadParcelTypes', countryCode);
            $state.go(state);
        }

        function confirmDelete(ev, product) {
            // Appending dialog to document.body to cover sidenav in docs app
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'components/shared/common/product-table/delete.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function () {
                removeProduct(product);
            });
        };

        function removeProduct(product) {
            CartFactory.removeProduct(product).then(function () {
                $rootScope.$broadcast('product-removed');
                vm.cart = _.without(vm.cart, product);
                LocalCartFactory.removeProduct(product);
                $rootScope.$broadcast('main:reloadCart');
                Topbar.updateCart();
            }, function (error) {
                showErrorDialog(true);
            });
        }

        function showErrorDialog(isDelete) {
            var templateUrl = isDelete ? 'components/shared/common/product-table/delete-error.dialog.html' : 'components/shared/common/product-table/update-error.dialog.html';

            $mdDialog.show({
                controller: DialogController,
                templateUrl: templateUrl,
                parent: angular.element(document.body),
                clickOutsideToClose: true
            }).then(function () {
                LocalCartFactory.emptyCart();
                Topbar.updateCart();
                $rootScope.$broadcast('main:reloadCart');
                $state.go('main.landing');
            });
        }

        function DialogController($scope, $mdDialog, appOptions) {
            $scope.country = appOptions.country;

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                $mdDialog.hide();
            };
        }

        function changeSender(product) {
            $mdDialog.show({
                controller: 'ChangeSenderModalControllerDK',
                controllerAs: 'ctrl',
                templateUrl: 'components/shared/dk/change-sender-modal/change-sender-modal.html',
                parent: angular.element(document.body),
                targetEvent: null,
                locals: {
                    sender: product.sender,
                    parcel: product,
                },
            });
        }

        function changeReceiver(product) {
            $mdDialog.show({
                controller: 'ChangeReceiverModalControllerDK',
                controllerAs: 'ctrl',
                templateUrl: 'components/shared/dk/change-receiver-modal/change-receiver-modal.html',
                parent: angular.element(document.body),
                targetEvent: null,
                locals: {
                    receiver: product.receiver,
                    parcel: product,
                },
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .controller('ChangeSenderModalControllerDK', ChangeSenderModalController)

    /** @ngInject */
    function ChangeSenderModalController($scope, $rootScope, $mdDialog, $localStorage, appOptions, Common, sender, parcel, CartFactory) {
        var vm = this;

        vm.country = appOptions.country;
        vm.sender = angular.copy(sender);
        vm.product = parcel;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;

        $scope.cancel = function () {

            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            vm.senderForm.$setSubmitted();
            if (vm.senderForm.$valid) {
                parcel.sender = vm.sender;
                CartFactory.updateProduct(parcel).then(function () {
                    $rootScope.$emit('sender:updated');
                    $mdDialog.hide();
                });
            }
        };
    }
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .controller('ChangeReceiverModalControllerDK', ChangeReceiverModalControllerDK)

    /** @ngInject */
    function ChangeReceiverModalControllerDK($scope, $mdDialog, appOptions, Common, receiver, parcel, CartFactory) {
        var vm = this;

        vm.country = appOptions.country;
        vm.receiver = angular.copy(receiver);
        vm.parcel = parcel;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            vm.receiverForm.$setSubmitted();
            if(vm.receiverForm.$valid){
                parcel.receiver= vm.receiver;
                CartFactory.updateProduct(parcel).then(function() {
                    $mdDialog.hide();
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.receipt', []);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.receipt')
        .directive('cmnReceiptSum', cmnReceiptSum);

    /* @ngInject */
    function cmnReceiptSum() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/receipt/common/sum/sum.directive.html',
            scope: {
                cart: '=',
                country: "=",
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: ReceiptSumController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.cart', scope.ctrl.activate);
            scope.$watch('ctrl.isCustomerCompany', scope.ctrl.activate);
        }
    }

    ReceiptSumController.$inject = ['Common'];

    /* @ngInject */
    function ReceiptSumController(Common) {
        var vm = this;

        vm.activate = activate;
        vm.getTotalPriceForParcels = Common.getTotalPriceForParcels;
        vm.getTotalVatPriceForParcels = Common.getTotalVatPriceForParcels;

        ////////////////

        function activate() {
            if (vm.cart) {
                vm.totalPriceForParcels = Common.getTotalPriceForParcels(vm.cart);
                vm.totalVatPriceForParcels = Common.getTotalVatPriceForParcels(vm.cart);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment', [
            'ngFileUpload'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .directive('dkLetterCodeSettings', dkLetterCodeSettings);

    /* @ngInject */
    function dkLetterCodeSettings() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/payment/dk/letter-code-settings/letter-code-settings.html',
            scope: {
                cartId: '='
            },
            controller: LetterCodeSettingsController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }

    LetterCodeSettingsController.$inject = ['$log', '$scope', '$timeout', 'LetterCodeImageUploadFactory'];

    /* @ngInject */
    function LetterCodeSettingsController($log, $scope, $timeout, LetterCodeImageUploadFactory) {
        var vm = this;

        vm.layout = 'standard';

        vm.reset = reset;
        vm.uploadImage = uploadImage;

        activate();

        function activate() {
            vm.isLoading = true;
            LetterCodeImageUploadFactory.getImageForCart(vm.cartId).then(function (image) {
                vm.isLoading = false;
                vm.imageUrl = image.preSignedUrl;
                vm.layout = 'image';
            }, function () {
                vm.isLoading = false;
            });
        }

        function reset() {
            LetterCodeImageUploadFactory.resetImageForCart(vm.cartId);
            vm.imageUrl = null;
        }

        function uploadImage(file) {
            if (file) {
                vm.isLoading = true;
                return LetterCodeImageUploadFactory.uploadImage(vm.cartId, file).then(function (image) {
                    vm.imageUrl = image.preSignedUrl;
                    vm.isLoading = false;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .factory('LetterCodeImageUploadFactory', LetterCodeImageUploadFactory);

    LetterCodeImageUploadFactory.$inject = ['$http', 'Upload', '$q'];

    /* @ngInject */
    function LetterCodeImageUploadFactory($http, Upload, $q) {
        var service = {
            uploadImage: uploadImage,
            getImageForCart: getImageForCart,
            resetImageForCart: resetImageForCart
        };

        return service;

        function uploadImage(cartId, file) {
            return generatePreSignedUrl(cartId, file.type).then(function (preSignedUrl) {
                var config = {
                    url: preSignedUrl,
                    headers: {
                        'Content-Type': file.type,
                        'x-file-upload-header': 'file_upload'
                    },
                    method: 'PUT',
                    data: file
                };

                return Upload.http(config).then(function (response) {
                    return pollResizeStatus(cartId).then(function (success) {
                        return getImageForCart(cartId);
                    });
                })
            });
        }

        function generatePreSignedUrl(cartId, fileType) {
            return $http.post(OnlineShippingTool.env.portoCodeImageUrl + '/generatePreSignedUrl/' + cartId, {
                contentType: fileType
            },{
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
                return _.get(response, 'data.preSignedUrl');
            }).catch(function (errorResponse) {
                console.log('LetterCodeImageUploadFactory : generatePreSignedUrl : errorResponse', errorResponse);
            });
        }

        function pollResizeStatus(cartId) {
            var timestamp = new Date().getTime();

            return $http.get(OnlineShippingTool.env.portoCodeImageUrl + '/pollResizeStatus/' + cartId + '?rev=' + timestamp).then(function(pollResponse) {
                if (_.get(pollResponse, 'data.resizedImageAvailable')) {
                    return pollResponse;
                } else {
                    return pollResizeStatus(cartId);
                }
            });
        }

        function getImageForCart(cartId) {
            var timestamp = new Date().getTime();

            return $http.get(OnlineShippingTool.env.portoCodeImageUrl + '/getPreSignedUrl/' + cartId + '?rev=' + timestamp).then(function(response) {
                if (_.get(response, 'data.preSignedUrl')) {
                    return response.data;
                } else {
                    return $q.reject();
                }
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function resetImageForCart(cartId) {
            return $http.post(OnlineShippingTool.env.portoCodeImageUrl + '/resetImage/' + cartId, {}, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        }
    }
})();

(function () {
  "use strict";

  angular.module("onlineShippingTool.payment").directive("cmnTerms", cmnTerms);

  /* @ngInject */
  function cmnTerms() {
    var directive = {
      restrict: "E",
      templateUrl: "components/payment/common/terms/terms.directive.html",
      scope: {
        agreement: "=",
        form: "=",
        receivercountry: "=",
        cart: "=",
      },
      controller: TermsController,
      controllerAs: "ctrl",
      bindToController: true,
    };

    return directive;
  }

  TermsController.$inject = ["$localStorage", "appOptions", "$mdDialog"];

  /* @ngInject */
  function TermsController($localStorage, appOptions, $mdDialog) {
    var vm = this;

    vm.fromCountry = appOptions.country;
    vm.wantsOffersToggle = wantsOffersToggle;
    vm.showTerms = showTerms;

    activate();

    //////////////////

    function activate() {
      // initWantsOffersCheckbox();
    }

    function initWantsOffersCheckbox() {
      vm.wantsOffers =
        typeof $localStorage.wantsOffers !== "undefined"
          ? $localStorage.wantsOffers
          : false;
      $localStorage.wantsOffers = vm.wantsOffers;
    }
    function wantsOffersToggle() {
      $localStorage.wantsOffers = vm.wantsOffers;
    }
    function showTerms(ev) {
      // Appending dialog to document.body to cover sidenav in docs app
      $mdDialog.show({
        controller: termsController,
        templateUrl: "components/payment/termsandconditions.html",
        parent: angular.element(document.body),
        targetEvent: null,
        clickOutsideToClose: true,
        locals: {
          cart: vm.cart,
        },
      });
    }

    function termsController($scope, $mdDialog, cart) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.confirm = function () {
        $mdDialog.hide();
      };

      var termsParcels = cart;
      var parcelsArray = [];

      var activate = function () {
        _.each(termsParcels, function (parcel) {
          var newParcel = {};
          newParcel.name = parcel.name;
          newParcel.baseProductName = parcel.baseProductName;
          newParcel.productTerms = parcel.productTerms;

          _.each(parcel.additionalServices, function (service) {
            if (service.selected === true && service.baseProductId) {
              newParcel.baseProductName = service.baseProductName;
              newParcel.productTerms = service.productTerms;
              newParcel.iconUrl = service.iconUrl;
              newParcel.serviceName = service.additionalServiceName;
            }
          });

          parcelsArray.push(newParcel);
        });

        $scope.parcelsArray = parcelsArray;
      };

      activate();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .directive('cmnPaymentSum', cmnPaymentSum);

    /* @ngInject */
    function cmnPaymentSum() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/payment/common/sum/sum.directive.html',
            scope: {
                cart: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: PaymentSumController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.cart', scope.ctrl.activate, true);
            scope.$watch('ctrl.isCustomerCompany', scope.ctrl.activate);
        }
    }

    PaymentSumController.$inject = ['Common', '$scope'];

    /* @ngInject */
    function PaymentSumController(Common, $scope) {
        var vm = this;

        vm.activate = activate;
        vm.getTotalPriceForParcels = Common.getTotalPriceForParcels;
        vm.getTotalVatPriceForParcels = Common.getTotalVatPriceForParcels;
        document.body.onscroll = onScroll;
        vm.stickySumYposition = 0;
        vm.scrollToCart = scrollToCart;

        ////////////////

        function activate() {
            if (vm.cart) {
                vm.totalPriceForParcels = Common.getTotalPriceForParcels(vm.cart);
                vm.totalVatPriceForParcels = Common.getTotalVatPriceForParcels(vm.cart);
            }
        }

        function getStickySumYposition() {
            var topbar = document.getElementById('pnSideMenuContent');
            if(topbar) {
                return topbar.offsetHeight;
            }
            return 0;
        }

        function onScroll() {
            var paymentSum = document.getElementsByClassName('payment-sum')[0];
            if(!!paymentSum){
                var paymentSumBottomY = paymentSum.offsetHeight + paymentSum.offsetTop;
                $scope.$apply(function() {
                    vm.sumSticky = document.scrollingElement.scrollTop > paymentSumBottomY;
                    if(vm.stickySumYposition === 0){
                        vm.stickySumYposition = getStickySumYposition();
                    }
                });
            }
        }

        function scrollToCart() {
            var form = document.getElementsByName('payment.form')[0]; 
            if(!!form){
                scrollTo({ top: form.offsetTop - 15, behavior: 'smooth'});
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .service('sortPaymentService', sortPaymentService)

        sortPaymentService.$inject = ['$http', '$filter', 'FeatureToggleFactory'];

    function sortPaymentService($http, $filter, FeatureToggleFactory) {
        this.sort = sort;

        function sort(methods) {

            _.each(methods, function(method){
                method.iconUrls = []
                if(method.paymentMethodId === 'CARD') {
                    method.name = $filter('translate')('PAYMENT_WITH_CARD');
                    _.each(method.subMethods, function(card){
                        console.log(card);
                       if(card === 'Visa'){
                         method.iconUrls.push('assets/images/icon-pay-visa@2x.png');
                       } else if(card === 'MasterCard') {
                        method.iconUrls.push('assets/images/icon-pay-mastercard@2x.png');
                       }  else if(card === 'Maestro') {
                        method.iconUrls.push('assets/images/icon-pay-maestro@2x.png');
                       }
                       else if(card === 'NetsCardDankort') {
                        method.iconUrls.push('assets/images/icon-pay-dankort@2x.png');
                       }
                       else if(card === 'NetsCardJCB') {
                        method.iconUrls.push('assets/images/icon-pay-jcb@2x.png');
                       }
                    })
                    return method;
                }
                if(method.paymentMethodId === 'DIRECT-BANK') {
                    method.name = $filter('translate')('PAYMENT_WITH_DIRECT_BANK');
                    _.each(method.subPaymentMethodIds, function(bank){
                        if(bank === 'NetsSwedishBankNordea'){
                          method.iconUrls.push('assets/images/icon-pay-nordea@2x.png');
                        }   else if(bank === 'NetsSwedishBankSEB') {
                         method.iconUrls.push('assets/images/icon-pay-seb@2x.png');
                        }   else if(bank === 'NetsSwedishBankHandelsbanken') {
                         method.iconUrls.push('assets/images/icon-pay-handelsbanken@2x.png');
                        }   else if(bank === 'NetsSwedishBankSwedbank') {
                         method.iconUrls.push('assets/images/icon-pay-swedbank@2x.png');
                        }
                     })
                    return method;
                }

                if (method.paymentMethodId === 'MOBILE-PAY' && (true || FeatureToggleFactory.isFeatureEnabled('danishMobilePay'))) {
                    method.name = $filter('translate')('PAYMENT_WITH_MOBILE_PAY');
                    method.iconUrls.push('assets/images/icon-pay-mobilepay@2x.png');
                }

                if (method.paymentMethodId === 'SWISH-ECOMMERCE' && FeatureToggleFactory.isFeatureEnabled('swish')) {
                    method.name = 'Swish - eCommerce';
                }

                if (method.paymentMethodId === 'SWISH-MCOMMERCE' && FeatureToggleFactory.isFeatureEnabled('swish')) {
                    method.name = 'Swish - mCommerce';
                }
                if (method.paymentMethodId === 'GOOGLE-PAY' && FeatureToggleFactory.isFeatureEnabled('googlePay')) {
                    method.name = 'Google Pay';
                }
                if (method.paymentMethodId === 'APPLE-PAY' && FeatureToggleFactory.isFeatureEnabled('applePay')) {
                    method.name = 'Apple Pay';
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .factory('PaymentMethodFactory', PaymentMethodFactory);

    /* @ngInject */
    function PaymentMethodFactory($filter, FeatureToggleFactory) {
        var service = {
            filterPaymentMethods: filterPaymentMethods
        };

        var icons = {
            Visa: 'assets/images/icon-pay-visa@2x.png',
            MasterCard: 'assets/images/icon-pay-mastercard@2x.png',
            Maestro: 'assets/images/icon-pay-maestro@2x.png',
            NetsCardDankort: 'assets/images/icon-pay-dankort@2x.png',
            NetsCardJCB: 'assets/images/icon-pay-jcb@2x.png',
            NetsSwedishBankNordea: 'assets/images/icon-pay-nordea@2x.png',
            NetsSwedishBankSEB: 'assets/images/icon-pay-seb@2x.png',
            NetsSwedishBankHandelsbanken: 'assets/images/icon-pay-handelsbanken@2x.png',
            NetsSwedishBankSwedbank: 'assets/images/icon-pay-swedbank@2x.png',
            MobilePay: 'assets/images/icon-pay-mobilepay@2x.png',
            Swish: 'assets/images/swish.png',
            ApplePay: 'assets/images/apple-pay.svg',
            GooglePay: 'assets/images/google-pay.png',
        };

        return service;

        function filterPaymentMethods(paymentMethods) {
            if (FeatureToggleFactory.isFeatureEnabled('sePaymentSystemVersion2', 'SE') || FeatureToggleFactory.isFeatureEnabled('dkPaymentSystemVersion2', 'DK')) {
                return getValidPaymentMethodsV2(paymentMethods);
            }

            return getValidPaymentMethods(paymentMethods);
        }
        
        function getValidPaymentMethods(paymentMethods) {
            var validPaymentMethods = [];

            _.each(paymentMethods, function (paymentMethod) {
                var validMethod;

                switch (paymentMethod.paymentMethodId) {
                    case 'CARD':
                        validMethod = {
                            paymentMethodId: paymentMethod.paymentMethodId,
                            name: $filter('translate')('PAYMENT_WITH_CARD'),
                            icons: getIconsForSubPaymentMethods(paymentMethod.subPaymentMethodIds),
                            iconHeight: 36
                        };
                        break;
                    case 'DIRECT-BANK':
                        validMethod = {
                            paymentMethodId: paymentMethod.paymentMethodId,
                            name: $filter('translate')('PAYMENT_WITH_DIRECT_BANK'),
                            icons: getIconsForSubPaymentMethods(paymentMethod.subPaymentMethodIds),
                            iconHeight: 25
                        }
                        break;
                    case 'MOBILE-PAY':
                        validMethod = {
                            paymentMethodId: paymentMethod.paymentMethodId,
                            name: $filter('translate')('PAYMENT_WITH_MOBILE_PAY'),
                            icons: [icons['MobilePay']],
                            iconHeight: 25
                        }
                        break;
                    case 'SWISH-ECOMMERCE':
                        validMethod = FeatureToggleFactory.isFeatureEnabled('swish')
                            && {
                                paymentMethodId: paymentMethod.paymentMethodId,
                                name: $filter('translate')('PAYMENT_WITH_SWISH'),
                                icons: [icons['Swish']],
                                iconHeight: 25
                            }
                        break;
                }

                if (validMethod) {
                    validPaymentMethods.push(validMethod);
                }
            });

            return validPaymentMethods;
        }

        function getValidPaymentMethodsV2(paymentMethods) {
            var validPaymentMethods = [];

            _.each(paymentMethods, function (paymentMethod) {
                var validMethod;

                switch (paymentMethod.method) {
                    case 'CARD':
                        validMethod = {
                            paymentMethodId: paymentMethod.method,
                            name: $filter('translate')('PAYMENT_WITH_CARD'),
                            icons: getIconsForSubPaymentMethods(paymentMethod.subMethods),
                            iconHeight: 36
                        };
                        break;
                    case 'DIRECT-BANK':
                        validMethod = {
                            paymentMethodId: paymentMethod.method,
                            name: $filter('translate')('PAYMENT_WITH_DIRECT_BANK'),
                            icons: getIconsForSubPaymentMethods(paymentMethod.subMethods),
                            iconHeight: 25
                        }
                        break;
                    case 'MOBILE-PAY':
                        validMethod = {
                            paymentMethodId: paymentMethod.method,
                            name: $filter('translate')('PAYMENT_WITH_MOBILE_PAY'),
                            icons: [icons['MobilePay']],
                            iconHeight: 25
                        }
                        break;
                    case 'SWISH-ECOMMERCE':
                        validMethod = FeatureToggleFactory.isFeatureEnabled('swish')
                            && {
                                paymentMethodId: paymentMethod.method,
                                name: $filter('translate')('PAYMENT_WITH_SWISH'),
                                icons: [icons['Swish']],
                                iconHeight: 25
                            }
                        break;
                    case 'APPLE-PAY':
                        validMethod = FeatureToggleFactory.isFeatureEnabled('applePay')
                            && {
                                paymentMethodId: paymentMethod.method,
                                name: $filter('translate')('PAYMENT_WITH_APPLE_PAY'),
                                icons: [icons['ApplePay']],
                                iconHeight: 25
                           }
                        break;
                    case 'GOOGLE-PAY':
                        validMethod = FeatureToggleFactory.isFeatureEnabled('googlePay')
                            && {
                                paymentMethodId: paymentMethod.method,
                                name: $filter('translate')('PAYMENT_WITH_GOOGLE_PAY'),
                                icons: [icons['GooglePay']],
                                iconHeight: 25
                            }
                        break;  
                }

                if (validMethod && paymentMethod.active) {
                    validPaymentMethods.push(validMethod);
                }
            });

            return validPaymentMethods;
        }

        function getIconsForSubPaymentMethods(subPaymentMethodIds) {
            return _.chain(subPaymentMethodIds)
                .map(function (subPaymentMethodId) {
                    return icons[subPaymentMethodId];
                })
                .compact()
                .value();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .directive('paymentMethod', paymentMethod);

    /* @ngInject */
    function paymentMethod() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/payment/common/payment-method/payment-method.directive.html',
            scope: {
                paymentForm: '=',
                selectedPaymentMethod: '=',
                invoiceInfo: '='
            },
            controller: PaymentMethodController,
            controllerAs: 'ctrl',
            bindToController: true,
        };

        return directive;

    }

    PaymentMethodController.$inject = ['sortPaymentService', 'PaymentFactory', 'PaymentMethodFactory', 'appOptions'];

    /* @ngInject */
    function PaymentMethodController(sortPaymentService, PaymentFactory, PaymentMethodFactory, appOptions) {
        var vm = this;

        vm.checkMethod = checkMethod;
        vm.selectMethod = selectMethod;

        activate()
        //////////////////

        function activate() {
            var fromCountry = appOptions.country;
           
            PaymentFactory.getPaymentMethods(fromCountry).then(function(response) {
                sortPaymentService.sort(response);
                vm.paymentMethods = response;
                vm.validPaymentMethods = PaymentMethodFactory.filterPaymentMethods(vm.paymentMethods);
                const preferedMethod = vm.validPaymentMethods.find(method => method.paymentMethodId === (fromCountry === 'SE' ? 'SWISH-ECOMMERCE' : 'MOBILE-PAY'));
                
                preferedMethod ? vm.selectedPaymentMethod = preferedMethod.paymentMethodId : vm.selectedPaymentMethod = vm.validPaymentMethods[0].paymentMethodId;
            });
        }

        function checkMethod(method) {
            document.getElementById(method).checked = true;
            vm.selectedPaymentMethod = method;
        }

        function selectMethod(method) {
            vm.selectedPaymentMethod = method;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .directive('cmnInvoiceAddress', cmnInvoiceAddress);

    /* @ngInject */
    function cmnInvoiceAddress() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/payment/common/invoice-address/invoice-address.directive.html',
            scope: {
                invoiceAddress: '=',
                form: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: InvoiceAddressController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

        }
    }

    InvoiceAddressController.$inject = ['appOptions', 'Common'];

    /* @ngInject */
    function InvoiceAddressController(appOptions, Common) {
        var vm = this;

        vm.isInvoiceFormValid = isInvoiceFormValid;
        vm.country = appOptions.country;
        vm.isSE = Common.getMarket() === 'SE';

        activate();

        //////////////////

        function activate() {
            vm.showInvoiceForm = !isInvoiceFormValid(vm.invoiceAddress);
        }

        function isInvoiceFormValid(sender) {
            var requiredProperties = ['address.zipCode', 'address.city', 'email'];

            if(vm.isCustomerCompany) {
                requiredProperties = _.union(requiredProperties, ['company.name', 'company.organizationNumber']);
            } else {
                requiredProperties = _.union(requiredProperties, ['name','address.street']);
            }
            var res = _.every(requiredProperties, function (p) {
                return _.has(sender, p) && _.get(sender, p) !== '';
            });
            return res;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool')
        .directive ('cmnAddressEmail', cmnAddressEmail);

    function cmnAddressEmail() {
        
        var directive = {
            restrict: 'E',
            templateUrl: 'components/payment/common/address-email/address-email.directive.html',
            scope: {
                cart: '=',
                invoiceAddress: '='
            },
            controller: AddressEmailController,
            controllerAs: 'ctrl',
            bindToController: true
        };
        return directive;

    }

    AddressEmailController.$inject = [];
    
    /* @ngInject */
    function AddressEmailController() {
        var vm = this;

        vm.letters = _.filter(vm.cart, function(o){
            return o.type === 'letter';
        });
        vm.packages = _.filter(vm.cart, function(o){
            return o.type !== 'letter';
        });
    }

})();
(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seWeightChoiceSelector', seWeightChoiceSelector);

    /* @ngInject */
    function seWeightChoiceSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/weight-choice-selector/weight-choice-selector.directive.html',
            scope: {
                additionalServices: '=',
                selectedType: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: WeightChoiceSelectorController,
            controllerAs: 'weightChoiceSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('weightChoiceSelector.additionalServices', scope.weightChoiceSelector.activate, true);
        }
    }

    WeightChoiceSelectorController.$inject = ['$log', 'Common'];

    /* @ngInject */
    function WeightChoiceSelectorController($log, Common) {
        var vm = this;
        vm.activate = activate;
        vm.calculateMorphTotalPrice = Common.calculateMorphTotalPrice;
        vm.selectWeightChoice = selectWeightChoice;

        //////////////////////////

        function activate(newVal, oldVal) {
            if (newVal && (newVal !== oldVal || !vm.weightChoices)) {
                vm.weightChoices = _.chain(vm.additionalServices)
                    .filter(isWeightChoice)
                    .filter(isValidForAdditionalServices)
                    .sort(sortByWeight)
                    .value();

                if (vm.weightChoices.length > 0) {
                    var includedWeightChoice = _.find(vm.weightChoices, {included: true});
                    var selectedWeightChoice = _.find(vm.weightChoices, {selected: true});
                    vm.hasVisibleWeightChoices = !_.every(vm.weightChoices, {hidden: true});

                    if (!includedWeightChoice && !selectedWeightChoice) {
                        vm.weightChoices[0].selected = true;
                    }

                    if (includedWeightChoice) {
                        if (selectedWeightChoice) {
                            includedWeightChoice.override = includedWeightChoice !== selectedWeightChoice;
                        } else {
                            includedWeightChoice.selected = true;
                        }
                    }
                }
            }

            if ((_.find(vm.additionalServices, { additionalServiceId: 'Express_bas' }) || {}).selected){
                selectWeightChoice(_.find(vm.weightChoices, { additionalServiceId: 'SkickaHemMaxVikt1000' }));
            }
        }

        function isWeightChoice(service) {
            return _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
        }

        function isValidForAdditionalServices(service) {
            var currentAdditionalServiceIds = _.chain(vm.additionalServices)
                .filter({selected: true})
                .map('additionalServiceId')
                .value();
            var isValid = (!service.validForAdditionalServiceIds || _.intersection(service.validForAdditionalServiceIds, currentAdditionalServiceIds).length > 0)
                && (!service.disabledForAdditionalServiceIds || _.intersection(service.disabledForAdditionalServiceIds, currentAdditionalServiceIds).length === 0)

            if (!isValid) {
                service.selected = false;

                if (service.included) {
                    service.override = true;
                }
            }

            return isValid;
        }

        function selectWeightChoice(weightChoice) {
            _.each(vm.weightChoices, function (_service) {
                _service.selected = _service.additionalServiceId === weightChoice.additionalServiceId;
                if (_service.included) {
                    _service.override = !weightChoice.included;
                }
            });

            var selectedTypes = _.chain(vm.additionalServices)
                .filter('selected')
                .filter('validForWeightChoice')
                .map('type')
                .value();

            _.each(vm.additionalServices, function (_service) {
                if(_service.type === 'weightChoice') {
                    if(_service.additionalServiceId === weightChoice.additionalServiceId) {
                        _service.selected = weightChoice.selected;
                    } else {
                        _service.selected = false;
                    }
                }
                if (!!_service.validForWeightChoice) {
                    if (_service.validForWeightChoice !== weightChoice.additionalServiceId) {
                        _service.selected = false;
                    } else {
                        _service.selected = selectedTypes.indexOf(_service.type) !== -1;
                    }
                }
            });
        }
        function sortByWeight(choice1, choice2){
            return choice1.price - choice2.price;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seTraceabilityIndicator', seTraceabilityIndicator);

    /* @ngInject */
    function seTraceabilityIndicator() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/traceability-indicator/traceability-indicator.directive.html',
            scope: {
                selectedType: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('selectedType', setIsTraceable, true);
            scope.isTraceable = true;

            function setIsTraceable(val) {
                if (val) {
                    var isTraceableByAdditionalServices = _.some(val.additionalServices, function (service) {
                        return !!service.selected && typeof (service.nonTraceable) !== 'undefined' && !service.nonTraceable;
                    });
                    var isNonTraceableByAdditionalServices = _.some(val.additionalServices, function (service) {
                        return !!service.selected && typeof (service.nonTraceable) !== 'undefined' && !!service.nonTraceable;
                    });

                    var isTraceable = (!val.nonTraceable && !isNonTraceableByAdditionalServices) || (val.nonTraceable && isTraceableByAdditionalServices);
                    scope.isTraceable = isTraceable;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seSendProductButton', seSendProductButton);

    /* @ngInject */
    function seSendProductButton() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/send-product-button/send-product-button.directive.html',
            scope: {
                product: '=',
                editingProduct: '=',
                isDisabled: '=',
                isSubmitting: '=',
                onClick: '&'
            },
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('rekOptionSelector', rekOptionSelector);

    /* @ngInject */
    function rekOptionSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/rek-option-selector/rek-option-selector.directive.html',
            scope: {
                product: '=',
                additionalServices: '='
            },
            link: linkFunc,
            controller: rekOptionSelectorController,
            controllerAs: 'rekOptionSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('rekOptionSelector.additionalServices', scope.rekOptionSelector.activate);
            scope.$watch('rekOptionSelector.additionalServices', scope.rekOptionSelector.setRekOptionstates, true);
        }
    }

    /* @ngInject */
    function rekOptionSelectorController($filter, $log, AdditionalServiceHelper) {
        var vm = this;
        

        vm.activate = activate;
        vm.setRekOptionstates = setRekOptionstates;
        vm.selectOption = selectOption;

        activate();

        ///////////////////////////

        function activate(newVal) {
            vm.rekOptions = $filter('filter')(vm.additionalServices, {type: 'rekOption'});
            if(!!vm.rekOptions){
                sortOptions()
            }
        }

        function selectOption(option) {
            _.each(vm.rekOptions, function (o) {
                if (o.additionalServiceId !== option.additionalServiceId) {
                    o.selected = false;

                    if (o.included) {
                        o.override = true;
                    }
                } else {
                    o.selected = true;
                    delete o.override;
                    if(!o.dimensions.roll){
                        vm.product.isRoll = false;
                    }
                }
            });
        }

        function setRekOptionstates() {
            if (vm.rekOptions && vm.rekOptions.length > 0) {
                var currentAdditionalServiceIds = _.chain(vm.additionalServices)
                    .filter({selected: true})
                    .map('additionalServiceId')
                    .value();

                _.each(vm.rekOptions, function (deliveryOption) {
                    deliveryOption.disabled = _.intersection(deliveryOption.disabledForAdditionalServiceIds, currentAdditionalServiceIds).length > 0
                        || (deliveryOption.validForAdditionalServiceIds && !_.intersection(deliveryOption.validForAdditionalServiceIds, currentAdditionalServiceIds).length > 0);

                    if (deliveryOption.disabled) {
                        deliveryOption.selected = false;

                        if (deliveryOption.included) {
                            deliveryOption.override = true;
                        }
                    } else if (deliveryOption.selected) {
                        delete deliveryOption.override;
                    }

                    setFromPrice(deliveryOption);
                    setMaxWeight(deliveryOption);
                });

                var selectedOption = _.find(vm.rekOptions, { selected: true });
                if (!selectedOption) {
                    var availableOptions = _.filter(vm.rekOptions, function (option) {
                        return !option.disabled;
                    });

                    if (availableOptions.length > 0) {
                        availableOptions[0].selected = true;
                    }
                }
            }
        }

        function sortOptions() {
            vm.rekOptions.sort(function(a,b) {
                if ( a.proxioAddonCode < b.proxioAddonCode ){
                return -1;
              }
              if ( a.proxioAddonCode > b.proxioAddonCode ){
                return 1;
              }
              return 0;
            })
        }

        function setFromPrice(rekOption){
            var weightChoises = vm.additionalServices.filter(function(service) {
                var isWeightOption = service.type === "weightChoice";
                var isCurrentRekOptionService = service.validForAdditionalServiceIds && service.validForAdditionalServiceIds.indexOf(rekOption.additionalServiceId) !== -1;
                return isWeightOption && isCurrentRekOptionService;
            });

            rekOption.fromPrice = Math.min.apply(Math, weightChoises.map(function(choise) {
                return choise.price + vm.product.price;
            })); 
        }

        function setMaxWeight(rekOption){
            var weightChoises = vm.additionalServices.filter(function(service) {
                var isWeightOption = service.type === "weightChoice";
                var isCurrentRekOptionService = service.validForAdditionalServiceIds && service.validForAdditionalServiceIds.indexOf(rekOption.additionalServiceId) !== -1;
                return isWeightOption && isCurrentRekOptionService;
            });
            var maxWeight;
            weightChoises.forEach(function(choise) {
                if(!maxWeight){
                    maxWeight = choise;
                    return;
                }
                maxWeight = choise.price > maxWeight.price ? choise : maxWeight;
            }); 
            rekOption.maxWeight = maxWeight.additionalWeight;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seProductSelector', seProductSelector);

    /* @ngInject */
    function seProductSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/product-selector/product-selector.directive.html',
            scope: {
                selectedProduct: '=',
                products: '=',
                isCustomerCompany: '=',
                isEditingProduct: '='
            },
            link: linkFunc,
            controller: ProductSelectorController,
            controllerAs: 'productSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.productSelector;

            scope.$watch('productSelector.products', scope.productSelector.activate);
        }
    }

    ProductSelectorController.$inject = ['$log', '$stateParams', '$scope'];

    /* @ngInject */
    function ProductSelectorController($log, $stateParams, $scope) {
        var vm = this;

        vm.selectProduct = selectProduct;
        vm.nextProduct = nextProduct;
        vm.prevProduct = prevProduct;
        vm.isFurthestRight = false;
        vm.isFurthestLeft = true;
        vm.activate = activate;
        vm.productSticky = false;
        document.body.onscroll = onScroll;
        vm.stickyProductYposition = 0;
        ///////////////////////////////

        function activate() {
            if (vm.products && vm.products.length > 0) {
                vm.slider = window.tns({
                    container: '.my-slider',
                    items: 1.5,
                    slideBy: 1,
                    autoplay: false,
                    rewind: false,
                    loop: false,
                    mouseDrag: true,
                    preventScrollOnTouch: 'auto',
                    controlsContainer: "#buttons-container",
                    prevButton: '.product-selector__handle--left',
                    nextButton: '.product-selector__handle--right',
                    nav: false,
                    swipeAngle: false,
                    gutter: 5,
                    responsive: {
                        500: {
                            items: 3.2,
                            slideBy: 3
                        }
                    },
                  });

                  vm.slider.events.on('indexChanged', function(info) {
                            vm.isFurthestLeft = info.displayIndex === 1;
                            vm.isFurthestRight = info.displayIndex > vm.products.length - info.items;
                            $scope.$applyAsync();
                    });

                if (!vm.selectedProduct) {
                    var selectedType = findProductToPreselect(vm.products);
                    vm.selectedProduct = angular.copy(selectedType);
                    initAdditionalServices(vm.selectedProduct);
                } else {
                    var tmp = angular.copy(vm.selectedProduct);

                    var selectedType = findProductToPreselect(vm.products, tmp);
                    vm.selectedProduct = angular.copy(selectedType);

                    initAdditionalServices(vm.selectedProduct, tmp);
                }
            }
        }

        function initAdditionalServices(selectedType, tmp) {
            var additionalServiceIdsFromQuery = getAdditionalServiceIdsFromQuery();

            if (additionalServiceIdsFromQuery.length > 0) {
                _.each(additionalServiceIdsFromQuery, function (additionalServiceId) {
                    var service = _.find(selectedType.additionalServices, { additionalServiceId: additionalServiceId });
                    if (service) {
                        service.selected = true;

                        var includedServiceOfSameType = _.find(selectedType.additionalServices, { type: service.type, included: true });

                        if (includedServiceOfSameType) {
                            includedServiceOfSameType.override = true;
                        }
                    }
                })
            } else if (tmp) {
                _.each(selectedType.additionalServices, function (service) {
                    var tmpService = _.find(tmp.additionalServices, function (_service) {
                        return compareAdditionalServices(_service, service);
                    });
                    service.selected = tmpService && tmpService.selected;

                    var hasSelectedServiceOfSameType = _(tmp.additionalServices)
                        .chain()
                        .filter(function (_service) {
                            return _.find(selectedType.additionalServices, {additionalServiceId: _service.additionalServiceId});
                        })
                        .some({type: service.type, selected: true})
                        .value();
                    service.override = tmpService ? tmpService.override : undefined;
                });
            }
        }

        function findProductToPreselect(products, tmp) {

            var selectedType;

            if (!vm.isEditingProduct) {
                selectedType = _.find(products, {productId: parseInt($stateParams.productId)});
            }

            if (!selectedType && tmp) {
                selectedType = _.find(products, {productId: tmp.productId});
            }

            if (!selectedType) {
                selectedType =_.find(products, {productId: 2000}) || products[1] || products[0];
            }

            var currentIndex = vm.products.map(function(p) { return p.productId }).indexOf(selectedType.productId);
            vm.slider.goTo(currentIndex >= 1 ? currentIndex-1 : 0);
            return selectedType;
        }


        function selectProduct (product) {
            vm.selectedProduct = angular.copy(product);
            if (dataLayer) {
                dataLayer.push({
                    event: 'weightOption',
                    maxWeight: product.maxWeight.value
                });
            }
            updateNextPrevDisabled();
        }

        function getAdditionalServiceIdsFromQuery() {
            return $stateParams.additionalServiceIds ? $stateParams.additionalServiceIds.split(',') : [];
        }

        function compareAdditionalServices(service1, service2) {
            var isSameService = service1.additionalServiceId === service2.additionalServiceId;
            var hasSameType = !service1.type || !service2.type || (service1.type === service2.type) || (service1.type.name === service2.type.name && service1.type.value === service2.type.value);
            var hasSameValidForWeightChoice = service1.validForWeightChoice === service2.validForWeightChoice;
            var hasSameGrouping = service1.grouping === service2.grouping;
            var hasSameValidForBaseProductIds = _.isEqual(service1.validForBaseProductIds, service2.validForBaseProductIds);
            return isSameService && hasSameType && hasSameValidForWeightChoice && hasSameGrouping && hasSameValidForBaseProductIds;
        }

        function onScroll() {
            var productSelector = document.getElementsByClassName('product-selector')[0];
            if(!!productSelector){
                var productSelectorBottomY = productSelector.offsetHeight + productSelector.offsetTop;
                $scope.$apply(function() {
                    vm.productSticky = document.scrollingElement.scrollTop > productSelectorBottomY;
                    if(vm.stickyProductYposition === 0){
                        vm.stickyProductYposition = getStickyProductYposition();
                    }
                });
            }
        }

        function nextProduct(){
            var currentIndex = vm.products.map(function(p) { return p.productId }).indexOf(vm.selectedProduct.productId);
            if(currentIndex < vm.products.length-1) {
                selectProduct(vm.products[currentIndex+1]);
                vm.slider.goTo(currentIndex+1);
            }
        }

        function prevProduct(){
            var currentIndex = vm.products.map(function(p) { return p.productId }).indexOf(vm.selectedProduct.productId);
            if(currentIndex > 0) {
                selectProduct(vm.products[currentIndex-1]);
                vm.slider.goTo(currentIndex-1);
            }
        }

        function updateNextPrevDisabled() {
            var currentIndex = vm.products.map(function(p) { return p.productId }).indexOf(vm.selectedProduct.productId);
            vm.isNextDisabled = currentIndex >= vm.products.length -1;
            vm.isPrevDisabled = currentIndex <= 0;
        }

        function getStickyProductYposition() {
            var topbar = document.getElementById('pnSideMenuContent');
            if(topbar) {
                return topbar.offsetHeight;
            }
            return 0;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seProductInformationHeader', seProductInformationHeader);

    /* @ngInject */
    function seProductInformationHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/product-information-header/product-information-header.directive.html',
            scope: {
                product: '=',
                isSendingRoll: '='
            },
            link: linkFunc,
            controller: ProductInformationHeaderController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.ctrl;

            scope.$watch('ctrl.product', vm.setDimensions, true);
            scope.$watch('ctrl.isSendingRoll', vm.setDimensions);
        }
    }

    ProductInformationHeaderController.$inject = [];

    /* @ngInject */
    function ProductInformationHeaderController() {
        var vm = this;

        var selectedServicesPriorToRoll = [];

        vm.setDimensions = setDimensions;
        vm.setRollOption = setRollOption;

        ///////////////////

        function setDimensions() {
            if (vm.product) {
                var dimensionsAddOn = _.find(vm.product.additionalServices, function (service) {
                    return service.selected && (_.get(service, 'dimensions') !== undefined );
                });

                if (vm.product.isRoll) {
                    vm.dimensions = (dimensionsAddOn && dimensionsAddOn.dimensions.roll) || vm.product.dimensions.roll
                }
                else {
                    vm.dimensions = (dimensionsAddOn && dimensionsAddOn.dimensions) || vm.product.dimensions
                }

                vm.showRollOption = !!vm.product.dimensions.roll;

                vm.showDimensions = !hasRekOptions();
            }
        }

        function setRollOption(value) {
            vm.isSendingRoll = value;

            var nonRollAdditionalServices = _.filter(vm.product.additionalServices, function (service) {
                return ['Utkörning-till-företag', 'Utkörning-till-företag-09', 'Utkörning-till-företag-12'].indexOf(service.additionalServiceId) !== -1;
            });

            if (nonRollAdditionalServices.length > 0) {
                if (value) {
                    selectedServicesPriorToRoll = [];
                    _.each(nonRollAdditionalServices, function (service) {
                        if (!!service.selected) {
                            selectedServicesPriorToRoll.push(service);
                            service.selected = false;
                        }
                    });
                } else {
                    _.each(selectedServicesPriorToRoll, function (service) {
                        var _service = _.find(vm.product.additionalServices, {additionalServiceId: service.additionalServiceId});
                        _service.selected = true;
                    });
                    selectedServicesPriorToRoll = [];
                }
            }
        }

        function hasRekOptions(){
            var rekOptions = vm.product.additionalServices.filter(function(s){
                return s.type === 'rekOption';
            });

            return rekOptions.length > 0;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seProductInformation', seProductInformation);

    /* @ngInject */
    function seProductInformation() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/product-information/product-information.directive.html',
            scope: {
                product: '=',
                isCustomerCompany: '=',
                numberOfServices: '=',
                editingProduct: '=',
                isSubmitDisabled: '=',
                isSubmitting: '=',
                onSubmit: '=',
                selectedCountry: '=',
                isProductSubmitted: '=isSubmitted',
            },
            link: linkFunc,
            controller: ProductInformationController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.product', function() {
                ctrl.checkForDeliveryToMailbox();
                ctrl.checkForEms();
                ctrl.checkForDigitalStamps();
                ctrl.isInternationalExpress();
            }, true);
            scope.$watchGroup(
                ['ctrl.isInternationalReturnValid']
            , scope.ctrl.setValidity);
        }
    }

    ProductInformationController.$inject = ['$log', '$filter', 'Common', 'FeatureToggleFactory', 'AdditionalServiceHelper'];

    /* @ngInject */
    function ProductInformationController($log, $filter, Common, FeatureToggleFactory, AdditionalServiceHelper) {
        var vm = this;
        vm.checkForEms = checkForEms;
        vm.checkForDeliveryToMailbox = checkForDeliveryToMailbox;
        vm.checkForDigitalStamps = checkForDigitalStamps;
        vm.showDeliveryOptions = showDeliveryOptions;
        vm.setValidity = setValidity;
        vm.isInternationalExpress = isInternationalExpress;

        activate();

        function activate() {
           vm.customsEnabled = FeatureToggleFactory.isFeatureEnabled('swedishCustoms');
        }

        function checkForDeliveryToMailbox() {
            if(vm.product) {
                vm.deliveryToMailbox = _.find(vm.product.additionalServices, function(service) {
                    return service.additionalServiceId === 'delivery-to-mailbox';
                });
                vm.deliveryToMailboxSelected = vm.deliveryToMailbox && vm.deliveryToMailbox.selected
            }
        }

        function checkForEms() {
            if(vm.product) {
                vm.productHasEms = _.some(vm.product.additionalServices, { additionalServiceName: 'Express' })
                if(vm.productHasEms) {
                    vm.isValid = true;
                }
            }
        }
        function isInternationalExpress() {
            if(vm.product) {
                vm.ems = _.find(vm.product.additionalServices, function(service) { 
                    return service.additionalServiceName === 'Express';
                });
                if(vm.ems && vm.ems.selected) {
                    vm.isEms = vm.ems.selected;
                } else {
                    vm.isEms = false;
                }
            }
        }

        function checkForDigitalStamps() {
            if(vm.product) {
                vm.productHasDigitalStamps = AdditionalServiceHelper.hasSelectedAdditionalServiceId(vm.product.additionalServices, 'digitalStamps');
            }
        }

        function showDeliveryOptions() {
            return vm.product && !(!FeatureToggleFactory.isFeatureEnabled('portokoder') && vm.product.type === 'letter' && vm.selectedCountry !== 'SE');
        }

        function setValidity(group) {
            vm.isValid = !_.includes(group, false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('seEmsExpressSelector', seEmsExpressSelector);

    /* @ngInject */
    function seEmsExpressSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/se/ems-express-selector/ems-express-selector.directive.html',
            scope: {
                product: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: EmsExpressSelectorController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.product', scope.ctrl.activate, true);
        }

        /* @ngInject */
        function EmsExpressSelectorController($log) {
            var vm = this;
            var selectedServices = [];

            vm.activate = activate;
            vm.selectExpress = selectExpress;

            function activate() {
                if (vm.product) {
                    selectedServices = _.filter(vm.product.additionalServices, { selected: true });
                    var weightChoice = _.find(selectedServices, { multipleChoiceAddOn: { name: 'weightChoice' } });

                    if (weightChoice) {
                        vm.service = _.find(vm.product.additionalServices, { type: 'EMS', validForWeightChoice: weightChoice.additionalServiceId });
                    } else {
                        vm.service = _.find(vm.product.additionalServices, { type: 'EMS' });
                    }

                    setDisabled();
                }
            }

            function selectExpress(status) {
                if (vm.service && status === true) {
                    vm.service.selected = status;
                } else {
                    vm.service.selected = status;
                }
            }

            function setDisabled() {
                vm.disabled = _.some((vm.service.disabledForAdditionalServiceIds || {}), function (id) {
                    return _.map(selectedServices, 'additionalServiceId').indexOf(id) !== -1;
                });

                if (vm.disabled) {
                    delete vm.service.selected;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkValuableTypeSelector', dkValuableTypeSelector);

    /* @ngInject */
    function dkValuableTypeSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/valuable-type-selector/valuable-type-selector.directive.html',
            scope: {
                product: '=',
                additionalServices: '=',
                isCustomerCompany: '=',
                isValid: '=',
                isProductSubmitted: '='
            },
            link: linkFunc,
            controller: ValuableTypeSelectorController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.product', scope.ctrl.reset);
            scope.$watch('ctrl.additionalServices', scope.ctrl.activate, true);
        }
    }

    ValuableTypeSelectorController.$inject = ['$filter', '$timeout', 'AdditionalServiceHelper', 'FeatureToggleFactory'];

    /* @ngInject */
    function ValuableTypeSelectorController($filter, $timeout, AdditionalServiceHelper, FeatureToggleFactory) {
        var vm = this;

        vm.isVerifyingParcelValue = false;
        vm.isValid = false;

        vm.reset = reset;
        vm.activate = activate;
        vm.setValidity = setValidity;
        vm.isOptionActive = isOptionActive;
        vm.isTypePending = isTypePending;
        vm.selectType = selectType;
        vm.selectTypeOption = selectTypeOption;
        vm.isOptionAlone = isOptionAlone;
        vm.verifyParcelValue = verifyParcelValue;
        vm.isParcelValueButtonDisabled = isParcelValueButtonDisabled;
        vm.handleParcelValueChange = handleParcelValueChange;

        ///////////////////////////

        function reset(newVal, oldVal) {
            if (newVal && oldVal && isDifferentProduct(newVal, oldVal)) {
                vm.valuableTypes = [];
            }
        }

        function activate(newVal, oldVal) {
            if (!vm.valuableTypes || vm.valuableTypes.length === 0) {
                var valuableTypes = _.chain(vm.additionalServices)
                    .filter({type: 'valuableType'})
                    .filter(danishRekEnabled)
                    .groupBy(groupMultipleChoiceAddOns)
                    .map(formatGroup)
                    .cloneDeep()
                    .value();

                var selectedType = _.find(valuableTypes, {selected: true});
                if (valuableTypes && valuableTypes.length > 0 && !selectedType) {
                    valuableTypes[0].selected = true;
                }

                var hasSelectedValuableType = false;
                // Reset previous option selection, if other option has not been selected
                _.each(valuableTypes, function (type) {
                    var hasSelectedOption = _.some(type.services, {selected: true});
                    if (!hasSelectedOption) {
                        _.each(type.services, function (option) {
                            var previousOption = _.find(_.flatten(_.map(vm.valuableTypes, 'services')), {additionalServiceId: option.additionalServiceId});
                            option.selected = previousOption && previousOption.selected;
                        });
                    } else {
                        hasSelectedValuableType = true;
                    }
                });

                if (!hasSelectedValuableType) {
                    var includedValuableType = _.find(vm.additionalServices, {type: 'valuableType', included: true});
                    if (includedValuableType) {
                        includedValuableType.selected = true;
                    }
                }


                // If we only have one valuable type additional service, make sure it's selected
                if (valuableTypes.length === 1 && valuableTypes[0].services.length === 1) {
                    selectAdditionalService(valuableTypes[0].services[0]);
                }

                vm.valuableTypes = angular.copy(valuableTypes);
                vm.highestInsuranceAmount = getHighestInsuranceAmount(vm.additionalServices);
            }

            setValidity(newVal);
        }

        function isDifferentProduct(newProduct, oldProduct) {
            var newProductAdditionalServiceIds = _.map(newProduct.additionalServices, 'additionalServiceId');
            var oldProductAdditionalServiceIds = _.map(oldProduct.additionalServices, 'additionalServiceId');
            return (newProduct.productId !== oldProduct.productId || !_.isEqual(newProductAdditionalServiceIds, oldProductAdditionalServiceIds));
        }

        function danishRekEnabled(service) {
            var res = FeatureToggleFactory.isFeatureEnabled('danishREK');

            // If feature is enabled or additional service isn't toMailbox, return true
            return res || (['REK1day', 'REK5days'].indexOf(service.additionalServiceId) === -1);
        }

        function groupMultipleChoiceAddOns(service, index) {
            var groupName = _.get(service, 'multipleChoiceAddOn.name');
            //If groupName, return index of the first choice in the correct multipleChoiceAddOn (making the list sorted the same way as in backend)
            if (groupName) {
                var indexes = vm.additionalServices.map(function (obj, index) {
                    if (obj.multipleChoiceAddOn && obj.multipleChoiceAddOn.name === groupName) {
                        return index;
                    }
                }).filter(isFinite);

                return indexes[0];
            } else {
                return _.findIndex(vm.additionalServices, service);
            };
        }

        function formatGroup(group) {
            return {
                services: _.sortBy(group, 'price'),
                selected: _.some(group, {selected: true})
            };
        }

        function isOptionAlone(group) {
            return group.services.length < 2;
        }

        function isOptionActive(service, group, isFirst) {
            var selectedService = _.findWhere(group.services, {selected: true});
            var hasGroupSelectedService = _.some(group.services, {selected: true});
            return service.selected || (!hasGroupSelectedService && (service.included || isFirst));
        }

        function isTypePending(group, service) {
            return group.selected && service.type === 'valuePackage' && (!service.hasVerifiedParcelValue || vm.isTooExpensive);
        }

        function selectType(type) {
            if (!type.selected) {
                _.each(vm.valuableTypes, function (t) {
                    t.selected = false;
                });

                type.selected = true;

                // Select correct service in vm.additionalServices
                var includedOption = _.findWhere(type.services, {included: true});
                var selectedOption = _.findWhere(type.services, {selected: true}) || includedOption || type.services[0];

                selectAdditionalService(selectedOption);
                handleAffectedAdditionalServices();

                if (type.services[0].hasVerifiedParcelValue) {
                    selectValuableTypeInsurance(type.services[0].parcelValue);
                } else {
                    deselectValuableTypeInsurances();
                }
            }
        }

        function selectTypeOption(option, group) {
            _.each(group.services, function (o) {
                o.selected = false;
            });

            option.selected = true;

            _.each(vm.valuableTypes, function (t) {
                t.selected = false;
            });

            group.selected = true;

            deselectValuableTypeInsurances();
            selectAdditionalService(option);
            handleAffectedAdditionalServices();
        }

        function selectAdditionalService(option) {
            if (option.included) {
                delete option.override;
            }

            _.each(vm.additionalServices, function (service) {
                if (service.type === 'valuableType') {
                    if (option.additionalServiceId === service.additionalServiceId) {
                        service.selected = true;

                        if (service.included) {
                            delete service.override;
                        }
                    } else {
                        service.selected = false;

                        if (service.included) {
                            service.override = true;
                        }
                    }
                }
            });
        }

        function handleAffectedAdditionalServices() {
            var selectedBaseProductId = AdditionalServiceHelper.getSelectedBaseProductIdForAdditionalServices(vm.additionalServices, vm.product);

            _.each(vm.additionalServices, function (service) {
                if (service.validForBaseProductIds && service.validForBaseProductIds.indexOf(selectedBaseProductId) === -1) {
                    service.selected = false;
                }
            });
        }

        function handleParcelValueChange(service) {
            var additionalService = _.find(vm.additionalServices, {additionalServiceId: service.additionalServiceId});
            delete service.hasVerifiedParcelValue;
            delete additionalService.hasVerifiedParcelValue;
            vm.isTooExpensive = false;

            deselectValuableTypeInsurances();
        }

        function verifyParcelValue(service) {

            vm.isVerifyingParcelValue = true;

            var parcelValue = parseFloat(service.parcelValue);
            $timeout(function () {
                if (parcelValue) {
                    var insuranceService = selectValuableTypeInsurance(parcelValue);

                    service.hasVerifiedParcelValue = true;

                    var additionalService = _.find(vm.additionalServices, {additionalServiceId: service.additionalServiceId});
                    additionalService.hasVerifiedParcelValue = true;
                    additionalService.parcelValue = parcelValue;
                    vm.insurancePrice = getSelectedInsurancePrice(vm.additionalServices);
                }

                vm.isVerifyingParcelValue = false;
            }, 1000);
        }

        function isParcelValueButtonDisabled(group, service) {
            return !group.selected || !service.parcelValue;
        }

        function selectValuableTypeInsurance(parcelValue) {
            deselectValuableTypeInsurances();
            var insuranceService;

            if (parcelValue) {
                if (parcelValue <= vm.highestInsuranceAmount) {
                    insuranceService = _.find(vm.additionalServices, function (service) {
                        return service.type === 'valuableTypeInsurance' && parcelValue >= service.minInsurance.value && parcelValue <= service.maxInsurance.value;
                    });

                    if (insuranceService) {
                        insuranceService.selected = true;
                        insuranceService.parcelValue = parcelValue;

                        if (insuranceService.included) {
                            delete insuranceService.override;
                        } else {
                            var includedInsuranceService = _.find(vm.additionalServices, {type: 'valuableTypeInsurance', included: true});
                            if (includedInsuranceService) {
                                includedInsuranceService.override = true;
                            }
                        }
                    }

                } else {
                    vm.isTooExpensive = true;
                }
            }

            return insuranceService;
        }

        function deselectValuableTypeInsurances() {
            _.each(vm.additionalServices, function (service) {
                if (service.type === 'valuableTypeInsurance') {
                    delete service.selected;
                }
            });
        }

        function getSelectedInsurancePrice(additionalServices) {
            var insuranceService = _.find(vm.additionalServices, {type: 'valuableTypeInsurance', selected: true});
            return insuranceService ? insuranceService.price : 0;
        }

        function setValidity(additionalServices) {
            if (additionalServices) {
                vm.isValid = !_.some(additionalServices, function (service) {
                    return (service.selected || service.included) && service.type === 'valuePackage' && (!service.hasVerifiedParcelValue || vm.isTooExpensive);
                });
            }
        }

        function getHighestInsuranceAmount(additionalServices) {
            return _.chain(additionalServices)
                .filter({type: 'valuableTypeInsurance'})
                .last()
                .get('maxInsurance.value')
                .value();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkSendProductButton', dkSendProductButton);

    /* @ngInject */
    function dkSendProductButton() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/send-product-button/send-product-button.directive.html',
            scope: {
                product: '=',
                editingProduct: '=',
                weight: '=',
                isDisabled: '=',
                isSubmitting: '=',
                onClick: '&'
            },
        };

        return directive;
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkProductSelector', dkProductSelector);

    function dkProductSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-selector/product-selector.directive.html',
            scope: {
                products: '=',
                selectedProduct: '=',
                selectedWeight: '=',
                weight: '=?',
                isEditingProduct: '=',
                receiverCountryCode: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: ProductSelectorController,
            controllerAs: 'productSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.productSelector;

            scope.$watch('productSelector.products', scope.productSelector.activate);
        }
    }


    ProductSelectorController.$inject = ['$log', '$stateParams'];

    /* @ngInject */
    function ProductSelectorController($log, $stateParams) {
        var vm = this;

        vm.activate = activate;

        activate();

        /////////////////

        function activate() {
            if (vm.products && vm.products.length > 0) {
                if (!vm.selectedProduct) {
                    var selectedProduct = findProductToPreselect(vm.products);
                    vm.selectedProduct = angular.copy(selectedProduct);
                } else {
                    var tmp = angular.copy(vm.selectedProduct);

                    var selectedProduct = findProductToPreselect(vm.products, tmp);
                    vm.selectedProduct = angular.copy(selectedProduct);

                    initAdditionalServices(vm.selectedProduct, tmp);
                    initAdditionalData(vm.selectedProduct, tmp);
                    initSelectedWeigth(vm.selectedProduct, tmp);
                }
            }
        }

        function findProductToPreselect(products, tmp) {
            var selectedProduct;

            if (!vm.isEditingProduct) {
                selectedProduct = _.find(products, {productId: parseInt($stateParams.productId)});
            }

            if (!selectedProduct && tmp) {
                selectedProduct = _.find(products, {productId: tmp.productId});
            }

            return selectedProduct || products[0];
        }

        function initAdditionalServices(selectedProduct, tmp) {
            _.each(selectedProduct.additionalServices, function (service) {
                var tmpService = _.find(tmp.additionalServices, function (_service) {
                    return _service.additionalServiceId === service.additionalServiceId;
                });
                service.selected = tmpService && tmpService.selected;

                var hasSelectedServiceOfSameType = _(tmp.additionalServices)
                    .chain()
                    .filter(function (_service) {
                        return _.find(selectedProduct.additionalServices, {additionalServiceId: _service.additionalServiceId});
                    })
                    .some({type: service.type, selected: true})
                    .value();
                service.override = tmpService ? hasSelectedServiceOfSameType && tmpService.override : undefined;
            });
        }

        function initAdditionalData(selectedProduct, tmp) {
            selectedProduct.quantity = angular.copy(tmp.quantity);
        }

        function initSelectedWeigth(selectedProduct, tmp) {
            if (tmp && tmp.selectedWeight && tmp.productId === selectedProduct.productId) {
                vm.selectedWeight = angular.copy(tmp.selectedWeight);
            } else if ($stateParams.productId) {
                vm.selectedWeight = angular.copy(selectedProduct.maxWeight);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkProductInformationHeader',  dkProductInformationHeader);

    /* @ngInject */
    function dkProductInformationHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-information-header/product-information-header.directive.html',
            scope: {
                product: '=',
                selectedWeight: '=',
                receiverCountry: '='
            },
            link: linkFunc,
            controller: ProductInformationHeaderController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.ctrl;

            scope.$watch('ctrl.product', vm.activate, true);
        }
    }

    /* @ngInject */
    function ProductInformationHeaderController($translate, Common) {
        var vm = this;

        vm.activate = activate;
        vm.hasCustomsDocuments = hasCustomsDocuments;

        function activate() {
            if (vm.product) {
                vm.dimensions = _.get(vm.product, 'dimensions.dimensionDescriptions');

                var selectedServiceWithDeliveryTime = _.find(vm.product.additionalServices, function (service) {
                    return service.selected && service.deliveryTime;
                });

                var selectedServiceWithShipmentDays = _.find(vm.product.additionalServices, function (service) {
                    return service.selected && service.shipmentDays;
                });

                var shipmentDays = _.get(selectedServiceWithShipmentDays, 'shipmentDays') || _.get(vm.product, 'shipmentDays');

                vm.deliveryTime = _.get(selectedServiceWithDeliveryTime, 'deliveryTime') || _.get(vm.product, 'description.deliveryTime');

                var hasDeliveryTimeOptions = _.find(vm.product.additionalServices, {type: 'deliveryTimeOption'});

                if (!vm.deliveryTime && shipmentDays && !hasDeliveryTimeOptions) {
                    var daysString = shipmentDays === '1' ? 'DELIVERY_TIME_OPTION_SELECTOR_DAY' : 'DELIVERY_TIME_OPTION_SELECTOR_DAYS';
                    vm.deliveryTime = shipmentDays + ' ' + $translate.instant(daysString);
                }
            }
        }

        function hasCustomsDocuments(product) {
            if (!product) return;
            var documents = Common.getDocumentsForParcel(product);
            return _.chain(documents).find({ type: 'customsLabel' }).value();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkProductInformation', dkProductInformation);

    /* @ngInject */
    function dkProductInformation() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-information/product-information.directive.html',
            scope: {
                product: '=',
                productGroup: '=',
                selectedWeight: '=',
                isCustomerCompany: '=',
                numberOfServices: '=',
                editingProduct: '=',
                isSubmitDisabled: '=',
                isSubmitting: '=',
                onSubmit: '=',
                isProductSubmitted: '=isSubmitted',
                receiverCountry: "="
            },
            link: linkFunc,
            controller: ProductInformationController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.product.additionalServices', scope.ctrl.handleAdditionalServiceChange, true);
            scope.$watch('ctrl.product', scope.ctrl.handleProductChange);
            scope.$watchGroup([
                'ctrl.isValuableTypeValid',
                'ctrl.isValuablesProductValid',
                'ctrl.isProductGroupProductValid',
                'ctrl.isInternationalReturnValid'
            ], scope.ctrl.setValidity);
        }
    }

    ProductInformationController.$inject = ['Common'];

    /* @ngInject */
    function ProductInformationController(Common) {
        var vm = this;

        vm.handleAdditionalServiceChange = handleAdditionalServiceChange;
        vm.handleProductChange = handleProductChange;
        vm.setValidity = setValidity;

        ////////////////////

        function handleAdditionalServiceChange(services) {
            // If changing the products additional services, we'll regard the product as unsubmitted
            vm.isProductSubmitted = false;

            if (vm.productGroup) {
                setAdditionalServicesToProductInGroup(vm.product, vm.productGroup);
            }
        }

        function handleProductChange(product) {
            if (!product || !product.group || product.group.type !== 'valuables') {
                vm.isValuablesProductValid = true;
            }

            vm.isProductSubmitted = false;
        }

        function setValidity(group) {
            vm.isValid = !_.includes(group, false);
        }

        function setAdditionalServicesToProductInGroup(product, productGroup) {
            if (product) {
                var p = _.find(productGroup.products, {productId: product.productId});

                if (p) {
                    p.additionalServices = angular.copy(product.additionalServices);
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductGroupSelector', dkProductGroupSelector());

    /* @ngInject */
    function dkProductGroupSelector() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-selector/product-group-selector.html',
            controller: ProductGroupSelectorController,
            bindings: {
                isCustomerCompany: '<',
                productGroups: '<',
                selectedProduct: '=',
                selectedProductGroup: '=',
                selectedWeight: '=',
                toCountry: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductGroupSelectorController($log, $scope, $stateParams) {
        var vm = this;

        vm.$onInit = $onInit;
        vm.$onChanges = $onChanges;

        // ///////////////////

        function $onInit() {
            $log.debug('ProductGroupSelectorController : $onInit : vm.productGroups', vm.productGroups);
            $log.debug('ProductGroupSelectorController : $onInit : vm.selectedProduct', vm.selectedProduct);
            if (vm.selectedProduct) {
                setWeight(vm.selectedProduct);
            }
        }

        function $onChanges() {
            var productFromQuery = getProductFromQuery(vm.productGroups);
            if (productFromQuery) {
                vm.selectedProduct = productFromQuery;
                vm.selectedWeight = angular.copy(productFromQuery.maxWeight);
            }

            if (vm.productGroups && vm.productGroups.length > 0 && vm.selectedProduct) {
                var tmp = productFromQuery ? angular.copy(productFromQuery) : angular.copy(vm.selectedProduct);
                vm.selectedProduct.selectedWeight = angular.copy(tmp.selectedWeight);
                vm.selectedProduct.parcelValue = tmp.parcelValue;
                var selectedProductInProductGroups;

                _.each(vm.productGroups, function (productGroup) {
                    var selectedProductInProductGroup = _.find(productGroup.products, { productId: tmp.productId })

                    selectedProductInProductGroups = selectedProductInProductGroup || selectedProductInProductGroups;
                });

                if (selectedProductInProductGroups) {
                    selectedProductInProductGroups.selectedWeight = angular.copy(tmp.selectedWeight);
                    selectedProductInProductGroups.parcelValue = tmp.parcelValue;
                    setAdditionalServices(selectedProductInProductGroups, tmp);
                    setAdditionalServicesFromQuery(selectedProductInProductGroups);
                    vm.selectedProduct = angular.copy(selectedProductInProductGroups);
                } else {
                    vm.selectedProduct = angular.copy(vm.productGroups[0].products[0]);
                }
            }
        }

        function getProductFromQuery() {
            var matchingProduct;

            _.each(vm.productGroups, function (productGroup) {
                var _matchingProduct = _.find(productGroup.products, { productId: parseInt($stateParams.productId) });

                if (_matchingProduct) {
                    matchingProduct = _matchingProduct;
                }
            });

            return matchingProduct;
        }

        function setAdditionalServicesFromQuery(product) {
            var additionalServiceIdsFromQuery = getAdditionalServiceIdsFromQuery();
            product.additionalServices = _.each(product.additionalServices, function (service) {
                if (additionalServiceIdsFromQuery.indexOf(service.additionalServiceId) !== -1) {
                    service.selected = true;

                    var serviceWithSameType = _.find(product.additionalServices, { type: service.type });
                    if (serviceWithSameType) {
                        serviceWithSameType.override = true;
                    }
                }
            });
        }

        function setAdditionalServices(product, tmp) {
            product.additionalServices = _.map(product.additionalServices, function (service) {
                return _.find(tmp.additionalServices, { additionalServiceId: service.additionalServiceId, price: service.price }) || service;
            });
        }

        function getAdditionalServiceIdsFromQuery() {
            return $stateParams.additionalServiceIds ? $stateParams.additionalServiceIds.split(',') : [];
        }

        function setWeight(product) {
            if (product.selectedWeight) {
                vm.selectedWeight = angular.copy(product.selectedWeight);
            } else {
                vm.selectedWeight = angular.copy(product.maxWeight);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductGroupProductSelector', dkProductGroupProductSelector());

    /* @ngInject */
    function dkProductGroupProductSelector() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-product-selector/product-group-product-selector.html',
            controller: ProductGroupProductSelectorController,
            bindings: {
                product: '=',
                productGroup: '<',
                isCustomerCompany: '<',
                isValid: '=',
                isProductSubmitted: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductGroupProductSelectorController($log, $scope, $timeout) {
        var vm = this;

        vm.$onChanges = $onChanges;
        vm.selectProduct = selectProduct;

        $scope.$watchGroup([
            function () { return vm.product && vm.product.type !== 'valuePackage' || vm.isParcelValueValid }
        ], setValidity);

        // /////////////////////

        function $onChanges() {
            if (vm.productGroup) {
                setBasePrice(vm.productGroup.products);
            }
        }

        function selectProduct(product) {
            vm.product = angular.copy(product);
        }

        function setBasePrice(products) {
            vm.basePrice = _.chain(products)
                .map(getPriceForProduct)
                .min()
                .value();
        }

        function getPriceForProduct(product) {
            var price = product.price;

            if (!vm.isCustomerCompany) {
                price = price * (1 + product.vat / 10000);
            }

            return price;
        }

        function setValidity(group) {
            vm.isValid = !_.includes(group, false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('productGroupProductPrice', productGroupProductPrice());

    /* @ngInject */
    function productGroupProductPrice() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-product-selector/product-group-product-price.html',
            controller: ProductGroupProductPriceController,
            bindings: {
                basePrice: '<',
                product: '<',
                isCustomerCompany: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductGroupProductPriceController() {
        this.$onChanges = function () {
            if (this.isCustomerCompany) {
                this.price = this.product.price;
            } else {
                this.price = this.product.price * (1 + this.product.vat / 10000);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductGroupProductDimensions', dkProductGroupProductDimensions());

    /* @ngInject */
    function dkProductGroupProductDimensions() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-product-selector/product-group-product-dimensions.html',
            bindings: {
                product: '=',
            }
        };

        return component;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .component('dkProductGroupProductDeliveryTime', dkProductGroupProductDeliveryTime());

    /* @ngInject */
    function dkProductGroupProductDeliveryTime() {
        var component = {
            templateUrl: 'components/landing/dk/product-group-product-selector/product-group-product-delivery-time.html',
            controller: ProductGroupProductDeliveryTimeController,
            bindings: {
                product: '=',
                isCustomerCompany: '<',
                selectProduct: '&'
            }
        };

        return component;
    }

    /* @ngInject */
    function ProductGroupProductDeliveryTimeController($log, $timeout, Common) {
        var vm = this;

        vm.selectDeliveryTime = selectDeliveryTime;
        vm.hasCustomsDocuments = hasCustomsDocuments;

        // /////////////////////

        function selectDeliveryTime(product, service) {
            _.each(product.additionalServices, function (_service) {
                if (_service.type === 'valuablesDeliveryTime') {
                    _service.selected = _service.additionalServiceId === service.additionalServiceId;

                    if (_service.included) {
                        _service.override = !_service.selected;
                    }
                }
            });

            vm.selectProduct(product);
        }

        function hasCustomsDocuments(product) {
            if (!product) return;
            var documents = Common.getDocumentsForParcel(product);
            return _.chain(documents).find({ type: 'customsLabel' }).value();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkProductDescription', dkProductDescription);

    /* @ngInject */
    function dkProductDescription() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/product-description/product-description.directive.html',
            scope: {
               product: '=',
               receiverCountry: '='
            },
            link: linkFunc,
            controller: ProductDescriptionController,
            controllerAs: 'productDescription',
            bindToController: true
        };
        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('productDescription.product', scope.productDescription.setText, true);
        }
    }

    /* @ngInject */
    function ProductDescriptionController($log, Common) {
        var vm = this;

        vm.setText = setText;

        function setText() {
            if (vm.product) {
                var productCapabilities = Common.getProductCapabilities(vm.product);
                vm.text = '';
                vm.text += productCapabilities.printAtDescription ? productCapabilities.printAtDescription + ' ' : '';
                vm.text += productCapabilities.handinAtDescription ? productCapabilities.handinAtDescription + ' ' : '';
                vm.text += productCapabilities.deliveredToDescription ? productCapabilities.deliveredToDescription + ' ' : '';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('dkCustomsText', dkCustomsText);

    /* @ngInject */
    function dkCustomsText() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/dk/customs-text/customs-text.directive.html',
            scope: {
                product: '='
            },
            link: linkFunc,
            controller: CustomsTextController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('vm.product', scope.vm.activate, true);
        }
    }

    /* @ngInject */
    function CustomsTextController($log, Common) {
        var vm = this;

        vm.activate = activate;

        function activate() {
            if (vm.product){
                vm.unfilteredDocuments = Common.getDocumentsForParcel(vm.product);
                vm.documents = _.filter(vm.unfilteredDocuments, {type: 'customsLabel'});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnSidebarProductPrice', cmnSidebarProductPrice);

    /* @ngInject */
    function cmnSidebarProductPrice() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/sidebar-product-price/sidebar-product-price.directive.html',
            scope: {
                product: '=',
                isCustomerCompany: '=',
                currency: '=',
                cart: '=',
                cartItems: '='
            },
            link: linkFunc,
            controller: SidebarProductPriceController,
            controllerAs: 'productPrice',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.productPrice;

            scope.$watch('productPrice.product', vm.activate, true);
            scope.$watch('productPrice.isCustomerCompany', vm.activate);
        }
    }

    SidebarProductPriceController.$inject = ['Common'];

    /* @ngInject */
    function SidebarProductPriceController(Common) {
        var vm = this;

        vm.label = 'TOTAL_AMOUNT';
        vm.sublabel = 'INCL_VAT'

        vm.activate = activate;

        ////////////////

        function activate() {
            if (vm.product) {
                var vatPrice = Common.getVatPriceForParcel(vm.product);
                var price = Common.getPriceForParcel(vm.product);

                vm.sublabel = price === vatPrice ? 'VAT_FREE' : 
                vm.isCustomerCompany ? 'EXCL_VAT' : 'INCL_VAT';
                vm.price = vm.isCustomerCompany ? price : vatPrice;
            }
            if (vm.cart && vm.cartItems) {
                var totalPrice = vm.isCustomerCompany
                    ? Common.getTotalPriceForParcels(vm.cart)
                    : Common.getTotalVatPriceForParcels(vm.cart);

                var isVatFree = Common.getTotalPriceForParcels(vm.cart) === Common.getTotalVatPriceForParcels(vm.cart);
                vm.sublabel = isVatFree ? 'VAT_FREE' : 
                vm.isCustomerCompany ? 'EXCL_VAT' : 'INCL_VAT';
                vm.price = totalPrice;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnReturnOptionSelector', cmnReturnOptionSelector);

    /* @ngInject */
    function cmnReturnOptionSelector(FeatureToggleFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/return-option-selector/return-option-selector.directive.html',
            scope: {
                additionalServices: '=',
                isCustomerCompany: '=',
                isValid: '=',
                isProductSubmitted: '='
            },
            link: linkFunc,
            controller: ReturnOptionSelectorController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

            scope.$watch('vm.additionalServices', scope.vm.activate, true);
            scope.$watch('vm.returnOption', scope.vm.validate, true);
        }
    }

    ReturnOptionSelectorController.$inject = ['Common'];

    /* @ngInject */
    function ReturnOptionSelectorController(Common) {
        var vm = this;

        vm.activate = activate;
        vm.setOption = setOption;
        vm.validate = validate;

        activate();

        /////////////////////////

        function activate() {
            validate();
            vm.returnOption = _.findWhere(vm.additionalServices, {type: 'returnOption'});
            vm.market = Common.getMarket();
        }

        function setOption(value) {
            var returnOption = _.findWhere(vm.additionalServices, {type: 'returnOption'});
            returnOption.selected = value;
            vm.returnOption.selected = value;
        }

        function validate() {
            vm.isValid = typeof(vm.returnOption) === 'undefined' || typeof(vm.returnOption.selected) !== 'undefined';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnProductQuantity', cmnProductQuantity);

    /* @ngInject */
    function cmnProductQuantity() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/product-quantity/product-quantity.directive.html',
            scope: {
                quantity: '='
            },
            link: linkFunc,
            controller: ProductQuantityController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.quantity', scope.ctrl.activate);
        }

    }

    ProductQuantityController.$inject = [];

    /* @ngInject */
    function ProductQuantityController() {
        var vm = this;

        vm.activate = activate;
        vm.decrease = decrease;
        vm.increase = increase;
        vm.onBlur = onBlur;

        function activate(value) {
            if (!value) {
                vm.quantity = 1;
            }
        }

        function decrease(value) {
            value = parseInt(value);
            if (value && value > 1) {
                vm.quantity = value - 1;
            } else {
                vm.quantity = 1;
            }
        }

        function increase(value) {
            value = parseInt(value);
            if (value) {
                vm.quantity = value + 1;
            } else {
                vm.quantity = 1;
            }
        }

        function onBlur() {
            if(vm.quantity < 1 || !vm.quantity) {
                vm.quantity = 1;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnProductPrice', cmnProductPrice);

    /* @ngInject */
    function cmnProductPrice() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/product-price/product-price.directive.html',
            scope: {
                product: '=',
                isCustomerCompany: '=',
                currency: '='
            },
            link: linkFunc,
            controller: ProductPriceController,
            controllerAs: 'productPrice',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var vm = scope.productPrice;

            scope.$watch('productPrice.product', vm.activate, true);
            scope.$watch('productPrice.isCustomerCompany', vm.activate);
        }
    }

    ProductPriceController.$inject = ['Common'];

    /* @ngInject */
    function ProductPriceController(Common) {
        var vm = this;

        vm.label = 'LANDING_PAGE_YOUR_PRICE_INCL_VAT';

        vm.activate = activate;

        ////////////////

        function activate() {
            if (vm.product) {
                var vatPrice = Common.getVatPriceForParcel(vm.product);

                if (vm.isCustomerCompany) {
                    vm.price = Common.getPriceForParcel(vm.product);
                    vm.label = vm.price === vatPrice ? 'LANDING_PAGE_YOUR_PRICE_VAT_FREE' : 'LANDING_PAGE_YOUR_PRICE_EXCL_VAT';
                } else {
                    vm.price = vatPrice;
                    vm.label = 'LANDING_PAGE_YOUR_PRICE_INCL_VAT';
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.landing')
        .directive ('cmnProductDocuments', cmnProductDocuments);

    cmnProductDocuments.$inject = [];

    function cmnProductDocuments() {
        // Usage:
        //     <directive></directive>
        // Creates:
        //
        var directive = {
            link: link,
            templateUrl: 'components/landing/common/product-documents/product-documents.directive.html',
            scope: {
                parcel: '=',
                isCustomerCompany: '=',
                filter: '@',
                label: '@',
                description: '@'
            },
            restrict: 'EA',
            controller: productDocumentsController,
            controllerAs: 'productDocumentsCtrl',
            bindToController: true
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch('productDocumentsCtrl.parcel', scope.productDocumentsCtrl.activate, true);
            scope.$watch('productDocumentsCtrl.isCustomerCompany', scope.productDocumentsCtrl.setReadMoreUrl);
        }



        // activate();
    }
    productDocumentsController.$inject = ['Common', 'appOptions'];

    /* @ngInject */
    function productDocumentsController(Common, appOptions) {
        var vm = this;

        vm.activate = activate;
        vm.setReadMoreUrl = setReadMoreUrl;

        function activate() {
            if (vm.parcel){
                vm.unfilteredDocuments = Common.getDocumentsForParcel(vm.parcel);
                vm.documents =  _.filter(vm.unfilteredDocuments, {type: vm.filter});
            }
        }

        function setReadMoreUrl(isCustomerCompany) {
            if (appOptions.country === 'SE') {
                vm.readMoreUrl = isCustomerCompany
                    ? 'http://www.postnord.se/foretag/skicka/utrikes/tullinformation/dokumentsammanstallning'
                    : 'http://www.postnord.se/skicka-brev-och-paket/utrikes/tullinformation/dokumentsammanstallning';
            } else {
                vm.readMoreUrl = isCustomerCompany
                    ? 'http://www.postnord.se/foretag/skicka/utrikes/tullinformation/dokumentsammanstallning'
                    : 'http://www.postnord.se/skicka-brev-och-paket/utrikes/tullinformation/dokumentsammanstallning';
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnDeliveryTimeOptionSelector', cmnDeliveryTimeOptionSelector);

    /* @ngInject */
    function cmnDeliveryTimeOptionSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/delivery-time-option-selector/delivery-time-option-selector.directive.html',
            scope: {
                product: '=',
                additionalServices: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: DeliveryTimeOptionSelectorController,
            controllerAs: 'deliveryTimeOptionSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('deliveryTimeOptionSelector.additionalServices', scope.deliveryTimeOptionSelector.activate);

        }
    }

    DeliveryTimeOptionSelectorController.$inject = ['$filter'];

    /* @ngInject */
    function DeliveryTimeOptionSelectorController($filter) {
        var vm = this;

        vm.activate = activate;
        vm.selectOption = selectOption;

        // activate();

        ///////////////////////////

        function activate(newVal) {
            vm.deliveryTimeOptions = $filter('filter')(vm.additionalServices, {type: 'deliveryTimeOption'});

            var selectedOption = _.find(vm.deliveryTimeOptions, {selected: true});
            if (vm.deliveryTimeOptions && vm.deliveryTimeOptions.length > 0 && !selectedOption) {
                vm.deliveryTimeOptions[0].selected = true;
            }
        }

        function selectOption(option) {
            _.each(vm.deliveryTimeOptions, function (o) {
                if (o.additionalServiceId !== option.additionalServiceId) {
                    o.selected = false;

                    if (o.included) {
                        o.override = true;
                    }
                } else {
                    o.selected = true;
                    delete o.override;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnDeliveryPointSelector', cmnDeliveryPointSelector);

    /* @ngInject */
    function cmnDeliveryPointSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/delivery-point-selector/delivery-point-selector.directive.html',
            scope: {
                product: '=',
                additionalServices: '=',
                isCustomerCompany: '='
            },
            link: linkFunc,
            controller: DeliveryPointSelectorController,
            controllerAs: 'deliveryPointSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('deliveryPointSelector.additionalServices', scope.deliveryPointSelector.activate);
            scope.$watch('deliveryPointSelector.additionalServices', scope.deliveryPointSelector.setDeliveryPointStates, true);
        }
    }

    /* @ngInject */
    function DeliveryPointSelectorController($filter, $log, AdditionalServiceHelper) {
        var vm = this;

        vm.activate = activate;
        vm.setDeliveryPointStates = setDeliveryPointStates;
        vm.selectPoint = selectPoint;

        ///////////////////////////

        function activate(newVal) {
            vm.deliveryPoints = $filter('filter')(vm.additionalServices, {type: 'deliveryPointOption'});
            calculateGroupedPrices();

            if (!_.some(vm.deliveryPoints, { selected: true })) {
                selectPoint(vm.deliveryPoints[0]);
            }
        }

        function calculateGroupedPrices() {
            _.each(vm.deliveryPoints, function (deliveryPoint) {
                if (deliveryPoint.grouping) {
                    var hiddenClone = _.findWhere(vm.additionalServices, { grouping: deliveryPoint.grouping, hidden: true });
                    deliveryPoint.displayPrice = deliveryPoint.price + hiddenClone.price;
                    deliveryPoint.displayPriceVat = deliveryPoint.price + hiddenClone.price * (1 + hiddenClone.vat / 10000);
                }
            });
        }

        function selectPoint(deliveryPoint) {
            _.each(vm.deliveryPoints, function (o) {
                if (o.additionalServiceId !== deliveryPoint.additionalServiceId) {
                    o.selected = false;

                    if (o.included) {
                        o.override = true;
                    }
                } else {
                    o.selected = true;
                    delete o.override;
                }
            });
        }

        function clearAdditionalServices() {
            vm.additionalServices.forEach(function(service){
                service.selected = false;
            })
        }

        function setDeliveryPointStates() {
            if (vm.deliveryPoints && vm.deliveryPoints.length > 0) {
                var currentAdditionalServiceIds = _.chain(vm.additionalServices)
                    .filter({selected: true})
                    .map('additionalServiceId')
                    .value();

                _.each(vm.deliveryPoints, function (deliveryPoint) {
                    deliveryPoint.disabled = _.intersection(deliveryPoint.disabledForAdditionalServiceIds, currentAdditionalServiceIds).length > 0;

                    if (deliveryPoint.disabled) {
                        deliveryPoint.selected = false;

                        if (deliveryPoint.included) {
                            deliveryPoint.override = true;
                        }
                    } else if (deliveryPoint.selected) {
                        delete deliveryPoint.override;
                    }
                });

                var selectedPoint = _.find(vm.deliveryPoints, { selected: true });
                if (vm.deliveryPoints && vm.deliveryPoints.length > 0) {
                    if (!selectedPoint) {
                        var availablePoints = _.filter(vm.deliveryPoints, { disabled: false });

                        if (availablePoints.length > 0) {
                            availablePoints[0].selected = true;
                        }
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('deliveryTime', deliveryTime);

    /* @ngInject */
    function deliveryTime() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/delivery-time/delivery-time.directive.html',
            scope: {
                selectedType: '='
            },
            link: linkFunc,
            controller: DeliveryTimeController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('ctrl.selectedType', ctrl.activate, true);
        }

        /* @ngInject */
        function DeliveryTimeController() {
            var vm = this;
            vm.activate = activate;


            function activate() {
                if(vm.selectedType) {

                }
            }
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.landing')
    .directive('cmnDeliveryOptionSelector', cmnDeliveryOptionSelector);

  /* @ngInject */
  function cmnDeliveryOptionSelector() {
    var directive = {
      restrict: 'E',
      templateUrl: 'components/landing/common/delivery-option-selector/delivery-option-selector.directive.html',
      scope: {
        product: '=',
        additionalServices: '=',
        isCustomerCompany: '='
      },
      link: linkFunc,
      controller: DeliveryOptionSelectorController,
      controllerAs: 'deliveryOptionSelector',
      bindToController: true
    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {
      scope.$watch('deliveryOptionSelector.additionalServices', scope.deliveryOptionSelector.activate);
      scope.$watch('deliveryOptionSelector.additionalServices', scope.deliveryOptionSelector.setDeliveryOptionStates, true);
    }
  }

  /* @ngInject */
  function DeliveryOptionSelectorController($filter, $log, AdditionalServiceHelper) {
    var vm = this;

    vm.activate = activate;
    vm.setDeliveryOptionStates = setDeliveryOptionStates;
    vm.selectOption = selectOption;
    vm.selectedOption = null;

    ///////////////////////////

    function activate(newVal) {
      vm.deliveryOptions = $filter('filter')(vm.additionalServices, {
        type: 'deliveryOption',
        additionalServiceId: '!CustomServicePointDelivery'
      }) || [];

      vm.deliveryOptionsRender = vm.deliveryOptions.filter(function(option) {
        return !option.hidden;
      });
    }

    function selectOption(option) {
      _.each(vm.deliveryOptions, function (o) {
        if (o.additionalServiceId !== option.additionalServiceId) {
          o.selected = false;

          if (o.included) {
            o.override = true;
          }
        } else {
          o.selected = true;
          delete o.override;
        }
      });
    }

    function setDeliveryOptionStates() {
      if (vm.deliveryOptions && vm.deliveryOptions.length > 0) {
        var currentAdditionalServiceIds = _.chain(vm.additionalServices)
          .filter({ selected: true })
          .map('additionalServiceId')
          .value();

        _.each(vm.deliveryOptions, function (deliveryOption) {
          deliveryOption.disabled = _.intersection(deliveryOption.disabledForAdditionalServiceIds, currentAdditionalServiceIds).length > 0
          || (deliveryOption.validForAdditionalServiceIds && !_.intersection(deliveryOption.validForAdditionalServiceIds, currentAdditionalServiceIds).length > 0);

          if (deliveryOption.disabled) {
            deliveryOption.selected = false;

            if (deliveryOption.included) {
              deliveryOption.override = true;
            }
          } else if (deliveryOption.selected) {
            delete deliveryOption.override;
          }
        });

        vm.selectedOption = _.find(vm.deliveryOptions, { selected: true });

        if (!vm.selectedOption) {
          var availableOptions = _.filter(vm.deliveryOptions, function (option) {
            return !option.disabled;
          });

          if (availableOptions.length > 0) {
            availableOptions[0].selected = true;
          }
        }
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnCountrySelector', cmnCountrySelector);

    /* @ngInject */
    function cmnCountrySelector($document, $timeout, $sessionStorage) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/country-selector/country-selector.directive.html',
            scope: {
                countries: '=',
                selectedCountry: '=',
                onSelect: '&',
                isEditing: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr) {
            var inputElement = el[0].querySelectorAll('.cmn-country-selector__search__input')[0];

            scope.isOpen = false;

            scope.onKeyDown = onKeyDown;
            scope.openDropdown = openDropdown;
            scope.selectCountry = selectCountry;
            scope.close = closeDropdown;
            scope.getCountryNameWithDecoration = getCountryNameWithDecoration;

            $document.on('click', onDocumentClick);

            scope.$on('$destroy', function () {
                $document.off('click', onDocumentClick);
            });

            scope.$watch('countries', function() {
                scope.filteredCountries = scope.countries;
            });

            scope.$watch('searchString', function() {
                scope.countryToSelect = null;
                if(!scope.countries){
                    return;
                }
                scope.filteredCountries = scope.countries.filter(function(country) {
                    if(!scope.searchString){
                        return true;
                    }
                    return country.name.toLowerCase().indexOf(scope.searchString.toLowerCase()) > - 1;
                });
            });
            

            //////////////////

            function onDocumentClick(e) {
                if (!scope.isOpen) return;

                var contains = false;

                if (window.jQuery) {
                    contains = window.jQuery.contains(el[0], e.target);
                } else {
                    contains = el[0].contains(e.target);
                }

                if (!contains) {
                    closeDropdown();
                    scope.$digest();
                }
            }

            function openDropdown() {
                scope.isOpen = true;
                $timeout(function(){
                    inputElement.focus();
                  },100);
                }

            function closeDropdown() {
                scope.countryToSelect = null;
                scope.isOpen = false;
                inputElement.blur();
                var listElement =el[0].querySelectorAll('.cmn-country-selector__dropdown__list')[0];
                listElement.scrollTop = 0;
            }

            function selectCountry(country) {
                scope.searchString = '';
                scope.selectedCountry = country;
                $sessionStorage.receiverCountry = country;
                scope.onSelect()(country);

                closeDropdown();
            }

            function getCountryNameWithDecoration(countryName) {
                if(!scope.searchString){
                    return countryName;
                }
                var startIndex = countryName.toLowerCase().indexOf(scope.searchString.toLowerCase());
                var subStringToReplace = countryName.substr(startIndex, scope.searchString.length)
                return countryName.replace(subStringToReplace, '<u>'+subStringToReplace+'</u>');
            }

            function onKeyDown(event) {
                if (event.key === 'Enter' && scope.countryToSelect) {
                    selectCountry(scope.countryToSelect);
                } else if (event.key === 'Escape' || event.key === 'Esc') {
                    closeDropdown();
                } else if (['ArrowUp', 'Up'].indexOf(event.key) > -1) {
                    arrowUp();
                } else if (['ArrowDown', 'Down'].indexOf(event.key) > -1) {
                    arrowDown()
                } 
            }

            function arrowDown() {
                if(!scope.countryToSelect){
                    scope.countryToSelect = scope.filteredCountries[0];
                    return;
                }
                var currentIndex = scope.filteredCountries.indexOf(scope.countryToSelect);
                if(scope.filteredCountries.length > currentIndex+1) {
                    scope.countryToSelect = scope.filteredCountries[currentIndex+1];
                    scrollCountryIntoView(currentIndex+1);
                }
            }

            function arrowUp() {
                if(!scope.countryToSelect){
                    scope.countryToSelect = scope.filteredCountries[0];
                    return;
                }
                var currentIndex = scope.filteredCountries.indexOf(scope.countryToSelect);
                if(currentIndex > 0) {
                    scope.countryToSelect = scope.filteredCountries[currentIndex-1];
                    scrollCountryIntoView(currentIndex-1);
                }
            }

            function scrollCountryIntoView(index){
                var listElement =el[0].querySelectorAll('.cmn-country-selector__dropdown__list')[0];
                    var country = listElement.children[index];
                    var outsideTop = country.offsetTop - listElement.offsetTop < listElement.scrollTop;
                    var outsideBottom = (country.offsetTop - listElement.offsetTop + country.clientHeight) > (listElement.scrollTop + listElement.clientHeight);
                    if(outsideTop || outsideBottom) {
                        listElement.scrollTop = country.offsetTop - listElement.offsetTop - listElement.clientHeight / 2 + country.clientHeight / 2;
                    }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('cmnAdditionalServiceSelector', cmnAdditionalServiceSelector);

    /* @ngInject */
    function cmnAdditionalServiceSelector($log) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/landing/common/additional-service-selector/additional-service-selector.directive.html',
            scope: {
                additionalServices: '=',
                isCustomerCompany: '=',
                selectedType: '=',
                numberOfServices: '=',
                isRoll: '='
            },
            link: linkFunc,
            controller: AdditionalServiceSelectorController,
            controllerAs: 'additionalServiceSelector',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('additionalServiceSelector.additionalServices', scope.additionalServiceSelector.activate);
            scope.$watch('additionalServiceSelector.additionalServices', function() {
                scope.additionalServiceSelector.setOverrides();
                scope.additionalServiceSelector.clearInvalidAdditionalServices();
            }, true);
            scope.$watch('additionalServiceSelector.hiddenServices', scope.additionalServiceSelector.updateNumberOfServices, true);

            // Temporary fix: Refer to PNOST-222
            scope.$on('$destroy', function() {
                if (ctrl.selectedType && ctrl.selectedType.cashOnDelivery) {
                    ctrl.selectedType.cashOnDelivery = null;
                }
            });
        }
    }

    AdditionalServiceSelectorController.$inject = ['$log', 'Common', 'AdditionalServiceHelper', 'FeatureToggleFactory'];

    /* @ngInject */
    function AdditionalServiceSelectorController($log, Common, AdditionalServiceHelper, FeatureToggleFactory) {
        var vm = this;

        vm.hiddenServices = [];

        vm.activate = activate;
        vm.setSelectedServiceInGroup = setSelectedServiceInGroup;
        vm.checkAdditionalServices = checkAdditionalServices;
        vm.validForSelectedProduct = validForSelectedProduct;
        vm.updateNumberOfServices = updateNumberOfServices;

        vm.setOverrides = setOverrides;
        vm.clearInvalidAdditionalServices = clearInvalidAdditionalServices;

        //////////////////////////

        function activate(newVal, oldVal) {
            if (newVal && (newVal !== oldVal || !vm.groupedServices)) {
                vm.hiddenServices = [];
                vm.groupedServices = _.chain(vm.additionalServices)
                    .filter(notDeliveryOption)
                    .filter(notDeliveryPointOption)
                    .filter(notValuableType)
                    .filter(notWeightChoice)
                    .filter(notLetterNotification)
                    .filter(notEmsIfShipmentDaysExists)
                    .filter(notReturnOption)
                    .filter(notDeliveryTimeOption)
                    .filter(notValuablesDeliveryTime)
                    .filter(notRekOption)
                    .reduce(mergeGroupings, [])
                    .groupBy(groupMultipleChoiceAddOns)
                    .map(formatGroup)
                    .value();
            }
        }

        function updateNumberOfServices (hiddenServices) {
            if (hiddenServices) {
                vm.numberOfServices = _.reduce(hiddenServices, function (result, value) {
                    if (value === false) {
                        return result + 1;
                    }
                }, 0) || 0;
            }
        }

        function notDeliveryOption(service) {
            return service.type !== 'deliveryOption';
        }

        function notLetterNotification(service) {
            return service.additionalServiceId !== 'LetterNotification';
        }

        function notValuableType(service) {
            return service.type !== 'valuableType' && service.type !== 'valuableTypeInsurance';
        }

        function notWeightChoice(service) {
            return _.get(service, 'multipleChoiceAddOn.name') !== 'weightChoice';
        }

        function notEmsIfShipmentDaysExists(service) {
            return !vm.selectedType.shipmentDays || service.type !== 'EMS';
        }

        function notReturnOption(service) {
            return service.type !== 'returnOption';
        }

        function notDeliveryTimeOption(service) {
            return service.type !== 'deliveryTimeOption';
        }

        function notDeliveryPointOption(service) {
            return service.type !== 'deliveryPointOption';
        }

        function notValuablesDeliveryTime(service) {
            return service.type !== 'valuablesDeliveryTime';
        }

        function mergeGroupings(services, service, a) {
            if (!service.hidden) {
                if (service.grouping) {
                    var hiddenClone = _.findWhere(vm.additionalServices, { grouping: service.grouping, hidden: true });
                    service.displayPrice = service.price + hiddenClone.price;
                    service.displayPriceVat = service.price + hiddenClone.price * (1 + hiddenClone.vat / 10000);
                }

                services.push(service);
            }

            return services;
        }

        function groupMultipleChoiceAddOns(service, index) {
            var groupName = _.get(service, 'multipleChoiceAddOn.name');
            //If groupName, return index of the first choice in the correct multipleChoiceAddOn (making the list sorted the same way as in backend)
            if (groupName) {
                var indexes = vm.additionalServices.map(function (obj, index) {
                    if (obj.multipleChoiceAddOn && obj.multipleChoiceAddOn.name === groupName) {
                        return index;
                    }
                }).filter(isFinite);

                return indexes[0];
            } else {
                return _.findIndex(vm.additionalServices, service);
            };
        }

        function formatGroup(group) {
            var res = {
                services: group
            };

            if (group[0].multipleChoiceAddOn && group[0].multipleChoiceAddOn.group) {
                res.selectedService = _.find(group, { selected: true }) || group[0];
            }

            return res;
        }

        function setSelectedServiceInGroup(group, selectedService) {
            _.each(group.services, function (service, index) {
                var additionalService = _.find(vm.additionalServices, { multipleChoiceAddOn: service.multipleChoiceAddOn });
                service.selected = service.multipleChoiceAddOn === selectedService.multipleChoiceAddOn;
                additionalService.selected = service.selected;
            });

            _.each(vm.additionalServices, function (_service) {
                if (_service.type === selectedService.type) {
                    if (_service.additionalServiceId !== selectedService.additionalServiceId) {
                        _service.selected = false;

                        if (_service.included) {
                            _service.override = true;
                        }

                        if (_service.grouping) {
                            _.each(vm.additionalServices, function (_groupedService) {
                                if (_groupedService.grouping === _service.grouping) {
                                    _groupedService.selected = false;
                                }
                            });
                        }
                    } else {
                        _service.selected = true;
                        vm.selectedMultipleChoiceAddOn = _service;
                    }
                } else {
                    if (!!_service.included && !!_service.validForBaseProductIds) {
                        if (validForSelectedProduct(_service)) {
                            _service.override = false;
                        } else {
                            _service.override = true;
                        };
                    }
                }
            });

            if (selectedService.grouping) {
                _.each(vm.additionalServices, function (_service) {
                    if (_service.grouping === selectedService.grouping) {
                        _service.selected = selectedService.selected;
                    }
                });
            }
        }

        function checkAdditionalServices(service) {
            if(typeof service.multipleChoiceAddOn !== 'undefined'){
                service = setServiceToCorrectDropdownValue(service);
            }

            if (service.included) {
                delete service.override;
            }

            if (typeof service.type !== 'undefined') {
                if (!!service.selected) {
                    _.each(vm.additionalServices, function (_service) {
                        if (_service.type === service.type) {
                            if (_service.additionalServiceId !== service.additionalServiceId || (!!_service.validForWeightChoice && _service.validForWeightChoice !== service.validForWeightChoice)) {
                                _service.selected = false;

                                if (_service.included) {
                                    _service.override = true;
                                }

                                if (_service.grouping) {
                                    _.each(vm.additionalServices, function (_groupedService) {
                                        if (_groupedService.grouping === _service.grouping) {
                                            _groupedService.selected = false;
                                        }
                                    });
                                }
                            } else {
                                _service.selected = true;
                            }
                        }
                    });
                } else {
                    _.each(vm.additionalServices, function (_service) {
                        if (_service.included && _service.type === service.type) {
                            _service.override = false;
                        }

                        if (_service.additionalServiceId === service.additionalServiceId) {
                            _service.selected = false;
                        }
                    });
                }
            } else {
                var additionalService = _.findWhere(vm.additionalServices, { additionalServiceId: service.additionalServiceId });
                additionalService.selected = service.selected;
            }

            if (service.grouping) {
                _.each(vm.additionalServices, function (_service) {
                    if (_service.grouping === service.grouping) {
                        _service.selected = service.selected;
                    }
                });
            }

            _.each(vm.additionalServices, function (_service) {
                if (_service.validForBaseProductIds) {
                    if (validForSelectedProduct(_service)) {
                        _service.override = false;
                    } else {
                        _service.override = true;
                        _service.selected = false;
                    };
                };
            });

            if (service.selected && service.additionalServiceId === '1001051') {
                _.each(vm.additionalServices, function (_service) {
                    if (_service.selected && _service.additionalServiceId === "Expresspaket") {
                        _service.selected = false;
                    }
                })
            }
        }

        function setServiceToCorrectDropdownValue(service){
            if (typeof vm.selectedMultipleChoiceAddOn !== 'undefined' &&
                service.multipleChoiceAddOn.name === vm.selectedMultipleChoiceAddOn.multipleChoiceAddOn.name &&
                service.selected === true) {

                service = vm.selectedMultipleChoiceAddOn;
                service.selected = true;
            }
            return service;
        }

        function validForSelectedProduct(service) {
            //Only included services that have different valid baseProducts, everything else is valid/should be shown
            if (!!service.included && !!service.validForBaseProductIds) {
                var chosenBaseProductId;
                _.each(vm.additionalServices, function (_service) {
                    if (!!_service.selected && !!_service.baseProductId) {
                        chosenBaseProductId = _service.baseProductId;
                    };
                });

                //If the chosenBaseProductId is one of the valid ones for the service, return true
                //Else if no chosenBaseProduct and the service is valid for the standardBase, return true
                //Else return false
                if (service.validForBaseProductIds.indexOf(chosenBaseProductId) > -1) {
                    return true;
                } else if (!chosenBaseProductId && service.validForBaseProductIds.indexOf("standardBase") > -1) {
                    return true;
                } else {
                    return false;
                };
            } else if (!!service.validForBaseProductIds) {
                var isValid = true;
                var otherServicesOfSameType = _.filter(vm.additionalServices, function (_service) {
                    return service.additionalServiceId !== _service.additionalServiceId && service.type && service.type === _service.type;
                });

                var hasOtherServiceOfSameTypeValid = _.some(otherServicesOfSameType, function (_service) {
                    return _service.validForBaseProductIds
                        && (_service.validForBaseProductIds.indexOf(chosenBaseProductId) > 1
                            || (!chosenBaseProductId && service.validForBaseProductIds.indexOf("standardBase") > -1))
                        && !_service.override;
                });


                return !hasOtherServiceOfSameTypeValid;
            } else {
                return true;
            };
        }

        function setOverrides() {
            if (vm.additionalServices && vm.additionalServices.length > 0) {
                var baseProductId = AdditionalServiceHelper.getSelectedBaseProductIdForAdditionalServices(vm.additionalServices, vm.selectedType);

                _.each(vm.additionalServices, function (service) {
                    if (service.included && service.validForBaseProductIds) {
                        var validForBaseProductId = service.validForBaseProductIds.indexOf(baseProductId) !== -1;

                        if (validForBaseProductId) {
                            delete service.override;
                        } else {
                            service.override = true;
                        }
                    }
                });
            }
        }

        function clearInvalidAdditionalServices() {
            var currentAdditionalServiceIds = _.chain(vm.additionalServices)
                .filter({ selected: true })
                .map('additionalServiceId')
                .value();
            if (vm.additionalServices && vm.additionalServices.length > 0) {
                _.each(vm.additionalServices, function (service) {
                    if (service.selected && service.validForAdditionalServiceIds && _.intersection(currentAdditionalServiceIds, service.validForAdditionalServiceIds).length === 0) {
                        service.selected = false;
                    }
                })
            }
            // For handling previously selected additional services when an additional service changes the baseProductId of an product.
            var selectedBaseProductId = AdditionalServiceHelper.getSelectedBaseProductIdForAdditionalServices(vm.additionalServices, vm.selectedType);
            _.each(vm.additionalServices, function (service) {
                if (service.validForBaseProductIds && service.validForBaseProductIds.indexOf(selectedBaseProductId) === -1) {
                    service.selected = false;
                }
            });
        }
        function notRekOption(service) {
           return service.type !== 'rekOption';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address', [
            'onlineShippingTool.user.receivers'
        ]);
})();

(function () {
  'use strict';

  angular
    .module ('onlineShippingTool.address')
    .directive ('receiverServicePoint', receiverServicePoint);

  function receiverServicePoint($document) {

    var directive = {
      restrict: 'E',
      templateUrl: 'components/address/dk/receiver-service-point/receiver-service-point.directive.html',
      scope: {
        address: '=',
        parcel: '=',
        servicePoint: '=',
        additionalService: '='
      },
      link: linkFunc,
      controller: ReceiverServicePointController,
      controllerAs: 'receiverServicePoint',
      bindToController: true
    };
    return directive;


    function linkFunc(scope, el, attr, ctrl) {
      var vm = scope.receiverServicePoint;

      scope.$watch('receiverServicePoint.address', vm.handleAddressChange, true);

      $document.on('click', onDocumentClick);

      scope.$on('$destroy', function () {
        $document.off('click', onDocumentClick);
      });

      //////////////////

      function onDocumentClick(e) {
        if (!vm.isOpen) return;

        var contains = false;

        if (window.jQuery) {
          contains = window.jQuery.contains(el[0], e.target);
        } else {
          contains = el[0].contains(e.target);
        }

        if (!contains) {
          closeDropdown();
          scope.$digest();
        }
      }

      function openDropdown() {
        vm.isOpen = true;
      }

      function closeDropdown() {
        vm.isOpen = false;
      }
    }

    function ReceiverServicePointController($log, $timeout, $window, ServicePointFactory, SERVICE_POINT_LOCATIONS) {
      var vm = this;

      vm.handleAddressChange = handleAddressChange;
      vm.getReceiverServicePoints = getReceiverServicePoints;
      vm.clearServicePoint = clearServicePoint;
      vm.selectServicePoint = selectServicePoint;

      vm.isLoadingServicePoints = false;

      var latestAddress = null;
      var isBuffering = false;

      function handleAddressChange(address) {
        latestAddress = address;

        if (!isBuffering) {
          isBuffering = true;
          $timeout(function () {
            isBuffering = false;
            getReceiverServicePoints(latestAddress);
          }, 1000);
        }
      }

      function getReceiverServicePoints(address) {
        if (address && address.street && address.zipCode && address.city) {
          vm.isLoadingServicePoints = true;

          ServicePointFactory.getServicePointsByAddress(
            { ...address, countryCode: 'DK' },
            SERVICE_POINT_LOCATIONS.PICKUP.DK,
            10
          ).then(function(data){
            vm.isLoadingServicePoints = false;
            vm.servicePoints = data;

            var alreadySelectedServicePoint = vm.servicePoint && _.find(data, {
              servicePointId: vm.servicePoint.servicePointId
            });

            vm.servicePoint = alreadySelectedServicePoint || null;
          }, function () {
            vm.isLoadingServicePoints = false;
            vm.servicePoints = [];
            vm.servicePoint = null;
          });
        } else {
          vm.servicePoints = [];
          vm.servicePoint = null;
        }
      }

      function selectServicePoint(servicePoint) {
        vm.servicePoint = servicePoint;
        vm.isOpen = false;

        if (vm.additionalService) {
          vm.additionalService.selected = true;

          var standardServicePointDelivery = _.find(vm.parcel.additionalServices, {type: 'deliveryOption', included: true});

          if (standardServicePointDelivery) {
            delete standardServicePointDelivery.selected;
            standardServicePointDelivery.override = true;
          }
        }
      }

      function clearServicePoint() {
        delete vm.servicePoint;
        vm.isOpen = false;

        if (vm.additionalService) {
          delete vm.additionalService.selected;

          var standardServicePointDelivery = _.find(vm.parcel.additionalServices, {type: 'deliveryOption', included: true});

          if (standardServicePointDelivery) {
            standardServicePointDelivery.selected = true;
            delete standardServicePointDelivery.override;
          }
        }
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.address')
        .directive ('letterNotification', letterNotification);

    function letterNotification($window, ServicePointFactory) {
        
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/dk/letter-notification/letter-notification.directive.html',
            scope: {
                parcel: '=',
            },
            controller: letterNotificationController,
            controllerAs: 'letterNotification',
            bindToController: true
        };
        return directive;


        letterNotificationController.$inject = [];

    function letterNotificationController() {
        var vm =  this;

        vm.isChecked = isChecked;

        activate();

        function activate(){
            vm.service  = _.find(vm.parcel.additionalServices, function(service){
            return service.additionalServiceId === "LetterNotification";
        });
        }

        function isChecked(service) {
            if(service.selected) {
                vm.parcel.selectedLetterNotification = true;
            } else {
                vm.parcel.selectedLetterNotification = false;
            }
            
            return service.selected || (service.included && !service.override);
        }
    }
    }
})();
(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('cmnReceiverPhoneFieldWithValidation', cmnReceiverPhoneFieldWithValidation);

    /* @ngInject */
    function cmnReceiverPhoneFieldWithValidation() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/common/phone-field-with-validation/phone-field-with-validation.directive.html',
            scope: {
                ngModel: '=',
                ngRequired: '=',
                hasHomeDelivery: '=',
                deliveryConfirmationPossible: '=',
                form: '=',
                isSubmitted: '=',
                countryCode: '='
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('cmnReceiverPhoneField', cmnReceiverPhoneField);

    /* @ngInject */
    function cmnReceiverPhoneField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/common/phone-field/phone-field.directive.html',
            scope: {
                ngModel: '=',
                ngRequired: '=',
                hasHomeDelivery: '=',
                deliveryConfirmationPossible: '=',
                form: '=',
                isSubmitted: '='
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('cmnReceiverEmailField', cmnReceiverEmailField);

    /* @ngInject */
    function cmnReceiverEmailField() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/common/email-field/email-field.directive.html',
            scope: {
                form: '=',
                ngModel: '=',
                ngRequired: '=',
                hasHomeDelivery: '=',
                deliveryConfirmationPossible: '=',
                isSubmitted: '='
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.receivers', []);
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.user.receivers')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.user.receivers', {
          url: '/receivers',
          templateUrl: 'components/user/receivers/receivers.html',
          controller: 'UserReceiversController',
          controllerAs: 'receivers'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.receivers')
        .factory('ReceiversFactory', ReceiversFactory);

    ReceiversFactory.$inject = ['$http'];

    /* @ngInject */
    function ReceiversFactory($http) {
        var service = {
            getReceivers: getReceivers,
            addReceiver: addReceiver,
            updateReceiver: updateReceiver,
            removeReceiver: removeReceiver,
            queryReceivers: queryReceivers
        };

        return service;

        function getReceivers() {
            var timestamp = Date.now();
            return $http.get(OnlineShippingTool.env.receiversUrl + '?' + timestamp).then(function (response) {
                return response.data && response.data.result ? formatReceivers(response.data.result) : [];
            });
        }

        function formatReceivers(receivers) {
            return _.map(receivers, function (receiver) {
                return receiver.address ? receiver : {
                    receiverId: receiver.receiverId.length > 0 ? receiver.receiverId : undefined,
                    name: receiver.name.length > 0 ? receiver.name : undefined,
                    company: receiver.company.length > 0 ? receiver.company : undefined,
                    attn: receiver.attn.length > 0 ? receiver.attn : undefined,
                    email: receiver.email.length > 0 ? receiver.email : undefined,
                    phone: receiver.phone.length > 0 ? receiver.phone : undefined,
                    address: {
                        street: receiver.street.length > 0 ? receiver.street : undefined,
                        zipCode: receiver.zipCode.length > 0 ? receiver.zipCode : undefined,
                        city: receiver.city.length > 0 ? receiver.city : undefined,
                        countryCode: receiver.countryCode.length > 0 ? receiver.countryCode : undefined
                    }
                }
            });
        }

        function addReceiver(receiver) {
             return $http.post(OnlineShippingTool.env.receiversUrl, receiver).then(function (response) {
                 return _.get(response, 'data.result.receiverId');
             });
        }

        function updateReceiver(receiver) {
            return $http.put(OnlineShippingTool.env.receiversUrl + '/' + receiver.receiverId, receiver);
        }

        function removeReceiver(receiver) {
            return $http.delete(OnlineShippingTool.env.receiversUrl + '/' + receiver.receiverId);
        }

        function queryReceivers(query) {
            return $http.get(OnlineShippingTool.env.receiversUrl + '/q?key=' + query).then(function (response) {
                return response.data && response.data.result ? formatReceivers(response.data.result) : [];
            });
        }
    }
})();

(function(){
    'use strict';

    angular
    .module('onlineShippingTool.user.receivers')
    .controller('UserReceiversController', UserReceiversController)

    UserReceiversController.$inject = ['$sessionStorage', 'OrderHistoryFactory', 'ReceiversFactory', '$mdDialog', '$state', 'CountryFactory', 'ResponsiveUtils', '$filter'];

    function UserReceiversController($sessionStorage, OrderHistoryFactory, ReceiversFactory, $mdDialog, $state, CountryFactory, ResponsiveUtils, $filter) {
        /* jshint validthis:true */
        var vm = this;

        var emptyReceiver = {
            name: undefined,
            company: undefined,
            attn: undefined,
            email: undefined,
            phone: undefined,
            address: {
                co: undefined,
                street: undefined,
                zipCode: undefined,
                city: undefined,
                countryCode: undefined
            }
        };

        vm.showReceiver = false;
        vm.isLoading = false;
        vm.isAddingReceiver = false;
        vm.newReceiver = angular.copy(emptyReceiver);

        vm.editReceiver = editReceiver;
        vm.saveReceiver = saveReceiver;
        vm.removeReceiver = removeReceiver;
        vm.addReceiver = addReceiver;
        vm.toggleReceiverDetails = toggleReceiverDetails;

        activate();

        //////////////

        function activate() {
            getReceivers()
                .then(groupReceiversByName);

            loadCountries();
        }

        function loadCountries() {
             CountryFactory.getCountries().then(function (countries) {
                vm.countrySelection = countries;
                vm.newReceiver.address.countryCode = 'SE';
                vm.newReceiver.country = _.find(countries, {countryCode: 'SE'});
            });
        }

        function getReceivers() {
            vm.isLoading = true;

            return ReceiversFactory.getReceivers().then(function (receivers) {
                vm.receivers = receivers;
                vm.isLoading = false;
                return receivers;
            });
        }

        function groupReceiversByName(receivers) {
            var groups = [
                {from: '0', to: '9'},
                {from: 'A', to: 'D'},
                {from: 'E', to: 'H'},
                {from: 'I', to: 'L'},
                {from: 'M', to: 'P'},
                {from: 'Q', to: 'T'},
                {from: 'U', to: 'X'},
                {from: 'Y', to: 'Ö'}
            ];

            vm.groupedReceivers = _.chain(receivers)
                .groupBy(function(receiver){
                    var group = _.find(groups, function(g) {
                        var name = receiver.name || receiver.company;
                        var firstletter = name && name.substring(0, 1).toUpperCase();
                        return firstletter >= g.from && firstletter <= g.to;
                    });
                    return group ? (group.from + '-' + group.to) : 'other';
                })
                .map(function(group, key){
                    var title = key === 'other' ? $filter('translate')('RECEIVERS_LIST_OTHER') : key;
                    return {
                        showLast: key === 'other',
                        title: title,
                        receivers: group
                    };
                })
                .sortByAll(['showLast', 'title'])
                .value();
        }

        function editReceiver(receiver) {
            receiver.edit = angular.copy(receiver);
            receiver.editing = true;
        }

        function saveReceiver(receiver, form) {
            form.$setSubmitted();
            form.duplicateUserError = false;

            if (form.$valid) {
                receiver.editing = false;
                if(!form.$pristine) {
                    ReceiversFactory.updateReceiver(receiver.edit).then(function() {
                        form.$setPristine();

                        vm.receivers = _.map(vm.receivers, function (r) {
                            if (r.receiverId === receiver.receiverId) {
                                return receiver.edit;
                            } else {
                                return r;
                            }
                        });

                        groupReceiversByName(vm.receivers);
                    }, function (errorResponse) {
                        if (errorResponse.data && errorResponse.data.errorMessage === 'Cannot add receiver with duplicate content.') {
                            receiver.editing = true;
                            form.duplicateUserError = true;
                        }
                    });
                }
            }
        }

        function addReceiver(receiver, form) {
            form.$setSubmitted();
            form.duplicateUserError = false;

            if (form.$valid) {
                vm.isAddingReceiver = true;

                ReceiversFactory.addReceiver(receiver).then(function(receiverId){
                    form.$setPristine();

                    receiver.receiverId = receiverId;

                    vm.showReceiver = false;
                    vm.isAddingReceiver = false;

                    vm.newReceiver = angular.copy(emptyReceiver);
                    vm.newReceiver.address.countryCode = 'SE';
                    vm.newReceiver.country = _.find(vm.countrySelection, {countryCode: 'SE'});

                    vm.receivers.push(receiver);
                    groupReceiversByName(vm.receivers);
                }, function (errorResponse) {
                    if (errorResponse.data && errorResponse.data.errorMessage === 'Cannot add receiver with duplicate content.') {
                        vm.isAddingReceiver = false;
                        form.duplicateUserError = true;
                    }
                });
            }
        }

        function removeReceiver(ev, receiver) {
            // Appending dialog to document.body to cover sidenav in docs app
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'components/user/receivers/deleteDialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function() {
                ReceiversFactory.removeReceiver(receiver).then(function() {
                    vm.receivers = _.without(vm.receivers, receiver);
                    groupReceiversByName(vm.receivers);
                });
            });
        };

        function toggleReceiverDetails(receiver) {
            if (ResponsiveUtils.isSmallOrSmaller()) {
                receiver.showDetails = !receiver.showDetails;
            }
        }

        function DialogController($scope, $mdDialog) {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.confirm = function() {
                $mdDialog.hide();
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.receivers')
        .directive('receiverTypeToggle', receiverTypeToggle);

    /* @ngInject */
    function receiverTypeToggle() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/user/receivers/receiver-type-toggle.html',
            scope: {
                isCompany: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.receivers')
        .directive('userReceiverForm', userReceiverForm);

    /* @ngInject */
    function userReceiverForm() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/user/receivers/receiver-form.html',
            scope: {
                receiver: '=',
                countries: '=',
                form: '=',
                saveFn: '&',
                removeFn: '&'
            },
            link: linkFunc,
            controller: UserReceiverFormController,
            controllerAs: 'userReceiverForm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.$watch('userReceiverForm.isCompany', scope.userReceiverForm.toggleReceiverType);

            scope.$watch('userReceiverForm.validationStatus', function(status) {
              if(status === 'invalid') {
                scope.userReceiverForm.form.zipCode.$setValidity('invalidPostalCode', false);
              } else if(status === 'valid') {
                scope.userReceiverForm.form.zipCode.$setValidity('invalidPostalCode', true);
              }
            })
        }
    }

    UserReceiverFormController.$inject = ['$sessionStorage'];

    /* @ngInject */
    function UserReceiverFormController($sessionStorage) {
        var vm = this;

        vm.selectCountry = selectCountry;
        vm.toggleReceiverType = toggleReceiverType;
        vm.isNordicCountry = isNordicCountry;
        vm.regexp = $sessionStorage.receiverCountry.postalCodeRegExp ? $sessionStorage.receiverCountry.postalCodeRegExp : '';
        
        var previousData = {
            name: undefined,
            address: { co: undefined },
            company: undefined,
            attn: undefined
        };

        activate();

        function activate() {
            var countryCode = _.get(vm.receiver, 'address.countryCode');

            if (countryCode && vm.countries) {
                vm.receiver.country = _.find(vm.countries, {countryCode: countryCode});
            }
            vm.isCompany = !!vm.receiver.company;
        }

        function selectCountry($item, $model, receiver) {
            receiver.address.countryCode = $item.countryCode;
        }

        function isNordicCountry(countryCode) {
          return ['SE', 'DK', 'NO', 'FI'].includes(countryCode)
        }

        function toggleReceiverType(isCompany) {
            if (isCompany) {
                vm.receiver.company = vm.receiver.company || previousData.company;
                vm.receiver.attn = vm.receiver.attn || previousData.attn;

                previousData.name = vm.receiver.name;
                previousData.address.co = vm.receiver.address.co;

                delete vm.receiver.name;
                delete vm.receiver.address.co;
            } else {
                vm.receiver.name = vm.receiver.name || previousData.name;
                vm.receiver.address.co = vm.receiver.address.co || previousData.address.co;

                previousData.company = vm.receiver.company;
                previousData.attn = vm.receiver.attn;

                delete vm.receiver.company;
                delete vm.receiver.attn;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history', [
            'onlineShippingTool.user.history.orderDetails'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history')
        .filter('ordersWithParcelType', ordersWithParcelType);

    function ordersWithParcelType() {
        return ordersWithParcelTypeFilter

        function ordersWithParcelTypeFilter(orders, type) {
            if (!orders || !type || !type.baseProductId) return orders;

            return _.filter(orders, function (order) {
                return _.filter(order.items, function (item) {
                    var parcel = item.content;
                    return type.baseProductId === parcel.baseProductId;
                }).length > 0;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history')
        .filter('orderItemsWithParcelType', orderItemsWithParcelType);

    function orderItemsWithParcelType() {
        return orderItemsWithParcelTypeFilter

        function orderItemsWithParcelTypeFilter(items, type) {
            if (!items || !type || !type.baseProductId) return items;

            return _.filter(items, function (item) {
                var parcel = item.content;
                return type.baseProductId === parcel.baseProductId;
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.user.history')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.user.history', {
          url: '/history',
          templateUrl: 'components/user/history/history.html',
          controller: 'UserHistoryController',
          controllerAs: 'history'
      });
  }

})();

(function(){
    'use strict';

    angular
    .module('onlineShippingTool.user.history')
    .controller('UserHistoryController', UserHistoryController)

    UserHistoryController.$inject = ['OrderHistoryFactory', '$filter', '$scope', '$state', '$sessionStorage', '$localStorage', 'PrintingFactory'];

    function UserHistoryController(OrderHistoryFactory, $filter, $scope, $state, $sessionStorage, $localStorage, PrintingFactory) {
        var vm = this;

        vm.calculateOrderPrice = calculateOrderPrice;
        vm.detailsParcelView = detailsParcelView;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        vm.getOrderStatusesForMonth = getOrderStatusesForMonth;
        vm.printReceipt = PrintingFactory.printReceipt;
        vm.changeMonth = changeMonth;
        vm.getNumberOfShipmentsFromOrdersWithOffset = getNumberOfShipmentsFromOrdersWithOffset;
        vm.getOrderPrice = getOrderPrice;
        vm.getOrderTax = getOrderTax;

        vm.products = [];
        vm.loadingHistory = false;
        vm.loadingStatuses = false;

        $scope.$watch('main.parcelTypes', setProducts);

        activate();

        ///////////////

        function activate() {
            vm.months = getMonths();
            vm.statuses = getStatuses();
            vm.selectedMonth = vm.months[0];

            getOrderHistory(vm.selectedMonth).then(function() {
                getOrderStatusesForMonth(vm.selectedMonth);
            });
        }

        function getOrderHistory(month) {
            vm.loadingHistory = true;
            vm.loadingStatuses = true;

            return OrderHistoryFactory.getOrderHistory(month).then(function(response) {
                vm.loadingHistory = false;
                vm.orderHistory = response;
                calculateOrderPrice(vm.orderHistory);
                return response;
            });
        }

        function getOrderStatusesForMonth(month) {
            return OrderHistoryFactory.getOrderStatusesForMonth(month).then(function(response) {
                vm.orderStatuses = response;
            }).then(function(statuses){
                _.each(vm.orderHistory, function(order){
                    _.each(order.items, function(item) {
                        _.each(vm.orderStatuses, function(route){
                            if(item.consignmentNumber === route.consignmentNumber) {
                                item.status = route.status;
                            }
                        });
                    });
                });

                vm.loadingStatuses = false;

                return statuses;
            });
        }

        function changeMonth(month) {
            getOrderHistory(month).then(function(orders) {
                getOrderStatusesForMonth(month).then(function () {
                    calculateOrderPrice(orders, month);
                });
            });
        }

        function calculateOrderPrice(orders) {
            vm.orderHistory.totalPrice = 0;
            vm.orderHistory.totalTax = 0;
            vm.orderHistory.totalItems = 0;

            var totalPrice = 0;
            var totalItems = 0;
            var totalTax = 0;
            var hiddenItems = 0;

            _.each(orders, function(order, index){
                totalItems += order.items.length;
                totalTax += order.totalTaxAmount;
                hiddenItems += index >= 3 ? order.items.length : 0;

                _.each(order.items, function(item){
                    totalPrice += item.content.itemAmount;
                });

                vm.orderHistory.totalPrice = totalPrice;
                vm.orderHistory.totalTax = totalTax;

                return order;
            });

            vm.orderHistory.totalItems = totalItems;
            vm.orderHistory.hiddenItems = hiddenItems;

            return vm.orderHistory;
        }

        function detailsParcelView(parcel) {
            $sessionStorage.detailsParcel = parcel;
            $state.go('main.user.orderDetails', {cartId: parcel.cartId, itemId: parcel.itemId});
        }

        function getMonths() {
            var now = moment().startOf('month');

            return [
                'last3days',
                'last5days',
                'last10days',
                now.format(),
                now.subtract(1, 'month').format(),
                now.subtract(1, 'month').format(),
                now.subtract(1, 'month').format(),
                now.subtract(1, 'month').format()
            ];
        }

        function getStatuses() {
            return [
                {'name':'SHOW_ALL','value':''},
                {'name':'EN_ROUTE','value':'EN_ROUTE'},
                {'name':'DELIVERED','value':'DELIVERED'},
                {'name':'AVAILABLE_FOR_DELIVERY','value':'AVAILABLE_FOR_PICKUP'},
                {'name':'INFORMED','value':'INFORMED'},
                {'name':'CREATED','value':'CREATED'}
            ];
        }

        function setProducts(newVal) {
            if (newVal) {
                var products = angular.copy(newVal);

                products = _.uniq(_.map(products, function (product) {
                    return {
                        name: product.baseProductName,
                        baseProductId: product.baseProductId,
                        maxWeight: product.maxWeight
                    };
                }), function(product) {
                    return product.name + product.baseProductId;
                });

                products.unshift({
                    name: $filter('translate')('SHOW_ALL')
                });

                vm.products = products;
            }
        }

        function getNumberOfShipmentsFromOrdersWithOffset(orders, offset) {
            var numberOfShipments = 0;

            for (var i = offset; i < orders.length; i++) {
                if (orders[i]) {
                    numberOfShipments += orders[i].items.length;
                }
            }

            return numberOfShipments;
        }

        function getOrderPrice(orders) {
            return orders
                ? orders.reduce(function(acc, order) {
                    return acc + order.totalAmount;
                }, 0)
                : 0;
        }

        function getOrderTax(orders) {
            return orders
                ? orders.reduce(function(acc, order) {
                    return acc + order.totalTaxAmount;
                }, 0)
                : 0;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user.history')
        .directive('userHistoryOrderRow', userHistoryOrderRow);

    /* @ngInject */
    function userHistoryOrderRow() {
        var directive = {
            restrict: 'A',
            templateUrl: 'components/user/history/history-order-row.html',
            scope: {
                order: '=',
                isCustomerCompany: '=',
                printReceipt: '=',
                filter: '='
            },
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('truncate', truncate);

    /* @ngInject */
    function truncate() {
        var directive = {
            restrict: 'A',
            transclude: true,
            template: '<span><span ng-transclude></span><span ng-transclude></span></span>',
            controller: controller,

        };

        function controller($element, $timeout) {
            $timeout(function () {
                $element[0] && $element[0].setAttribute('title', $element[0].innerText);
            });
        }

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .directive('toaster', toaster);

    /* @ngInject */
    function toaster() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/toaster/toaster.html',
            link: linkFunc,
            scope: {
                event: '<',
                type:'<'
            },
            controller: ToasterController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;

        function linkFunc() {
        }
    }
    ToasterController.$inject = ['$rootScope', '$timeout'];

    /* @ngInject */
    function ToasterController($rootScope, $timeout) {
        var vm = this
        $rootScope.$on(vm.event, function(event, message){
            vm.message = message;
            vm.showToaster = true;
            $timeout(function(){
                vm.showToaster = false;
            }, 7000);
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('shipmentStatus', shipmentStatus);

    shipmentStatus.$inject = ['$window'];

    function shipmentStatus($window) {
        // Usage:
        //     <directive></directive>
        // Creates:
        //
        var directive = {
            link: linkFunc,
            restrict: 'EA',
            templateUrl: 'components/shared/shipment-status/shipment-status.directive.html',
            scope: {
                parcel: '='
            },
            controller: ShipmentStatusController,
            controllerAs: 'shipmentStatus',
            bindToController: true
        };
        return directive;

        function linkFunc(scope, element, attrs) {
            var vm = scope.shipmentStatus;
        }
    }
    ShipmentStatusController.$inject = []
    function ShipmentStatusController() {
        var vm = this;
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('featureToggler', featureToggler);

    /* @ngInject */
    function featureToggler() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/feature-toggler/feature-toggler.html',
            scope: {
                isOpen: '='
            },
            link: linkFunc,
            controller: FeatureTogglerController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

        }
    }

    FeatureTogglerController.$inject = ['$localStorage', '$state', '$stateParams', '$timeout', '$window', 'FeatureToggleFactory'];

    /* @ngInject */
    function FeatureTogglerController($localStorage, $state, $stateParams, $timeout, $window, FeatureToggleFactory) {
        var vm = this;

        vm.close = close;
        vm.reload = reload;
        vm.toggleFeature = FeatureToggleFactory.toggleFeature;

        $window.openFeatureToggler = openFeatureToggler;

        activate();

        //////////////

        function activate() {
            vm.features = FeatureToggleFactory.getFeatures();

            if ($stateParams.toggleFeatures && $stateParams.toggleFeatures === 'true') {
                openFeatureToggler();
            }
        }

        function openFeatureToggler() {
            $timeout(function () {
                vm.isOpen = true;
            }, 0);
        }

        function close() {
            vm.isOpen = false;
        }

        function reload() {
            delete $stateParams.toggleFeatures;
            window.location.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('DisturbanceMessageFactory', DisturbanceMessageFactory);

    DisturbanceMessageFactory.$inject = ['$http', 'appOptions'];

    /* @ngInject */
    function DisturbanceMessageFactory($http, appOptions) {
        var service = {
            getMessage: getMessage
        };

        return service;

        function getMessage() {
            var baseUrl = OnlineShippingTool.env.baseUrls[appOptions.country.toLowerCase()];
            return $http.get(baseUrl + 'disturbance.json').then(function (response) {
                var messages = response.data;
                var message = _.find(messages, function (mes) {
                    var isCorrectMarket = mes.markets.indexOf(appOptions.country) !== -1;
                    var isCorrectInterval = (!mes.startTime || moment().isAfter(mes.startTime))
                        && (!mes.endTime || moment().isBefore(mes.endTime));

                    return isCorrectMarket && isCorrectInterval;
                });

                return message;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .component('disturbanceMessage', disturbanceMessage());

    /* @ngInject */
    function disturbanceMessage() {
        var component = {
            templateUrl: 'components/shared/disturbance-message/disturbance-message.html',
            controller: DisturbanceMessageController,
            bindings: {
                message: '<'
            }
        };

        return component;
    }

    /* @ngInject */
    function DisturbanceMessageController($element, $translate) {
        this.$onInit = $onInit;
        this.dismiss = dismiss;

        // /////////////////////

        function $onInit() {
            if (this.message) {
                var language = $translate.use();
                var translation = this.message.translations[language] || this.message.translations['en'];

                this.title = translation.title;
                this.text = translation.text;
                this.isDismissable = this.message.isDismissable;
            }
        }

        function dismiss() {
            $element.remove();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool')
        .directive ('cookieBar', cookieBar);

    function cookieBar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/shared/cookie-bar/cookie-bar.html',
            scope: {
                showCookieBar: '=isVisible'
            },
            controller: CookieBarController,
            controllerAs: 'cookiebar',
            bindToController: true
        };
        return directive;
    }

    CookieBarController.$inject = ['$localStorage'];
    function CookieBarController($localStorage) {
        var vm = this;
        vm.showCookieBar = true;
        vm.displayCookieBar = displayCookieBar;
        vm.closeCookieBar = closeCookieBar;

        displayCookieBar();

        function displayCookieBar() {
            if ($localStorage.hasApprovedCookies) {
                vm.showCookieBar = false;
                setCookie();
            }
        }

        function closeCookieBar() {
            $localStorage.hasApprovedCookies = true;
            vm.showCookieBar = false;
            setCookie();
        }

        function setCookie() {
            if (document.cookie.indexOf('acceptcookies=true') === -1) {
                document.cookie = 'acceptcookies=true';
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool') 
        .component('betaBannerLanding', betaBannerLanding());

    /* @ngInject */
    function betaBannerLanding() {
        var component = {
            templateUrl: 'components/shared/beta-banner-landing/beta-banner-landing.html',
            controller: BetaBannerLandingController,
            controllerAs: 'betaBannerLanding'
        };

        return component;
    }

    /* @ngInject */
    function BetaBannerLandingController($rootScope, $sessionStorage, $localStorage, UserFactory, FeatureToggleFactory) {
        console.log('Component loaded'); 
                var vm = this;

        vm.showBanner = randomizeBannerVisiblity() && FeatureToggleFactory.isFeatureEnabled('betaBanner') && !UserFactory.isLoggedIn();
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        handleNewBaseURL();

        function handleNewBaseURL() {
            if (vm.isCustomerCompany) {
                vm.newBaseURL = OnlineShippingTool.env.newBaseURL + '?customerType=BUSINESS';
            } else {
                vm.newBaseURL = OnlineShippingTool.env.newBaseURL + '?customerType=PRIVATE';
            }
        }

        function randomizeBannerVisiblity() {
            const percentageOfUsersToShowBanner = 100;
            const localStorageKey = 'betaBannerLandingRandomNumber';

            let randomNumber = $localStorage[localStorageKey];

            if (!randomNumber) {
                randomNumber = Math.floor(Math.random() * 100) + 1;
                $localStorage[localStorageKey] = randomNumber;
            }

            return randomNumber <= percentageOfUsersToShowBanner;
        }

        $rootScope.$on('main:customerTypeChanged', function() {
            vm.isCustomerCompany = $localStorage.isCustomerCompany;
            handleNewBaseURL();
         });
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool') 
        .component('betaBanner', betaBanner());

    /* @ngInject */
    function betaBanner() {
        var component = {
            templateUrl: 'components/shared/beta-banner/beta-banner.html',
            controller: BetaBannerController,
            controllerAs: 'betaBanner'
        };

        return component;
    }

    /* @ngInject */
    function BetaBannerController($rootScope, $sessionStorage, $localStorage, UserFactory, FeatureToggleFactory) {
        var vm = this;

        vm.showBanner = randomizeBannerVisiblity() && FeatureToggleFactory.isFeatureEnabled('betaBanner') && !UserFactory.isLoggedIn();
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        handleNewBaseURL();

        function handleNewBaseURL() {
            if (vm.isCustomerCompany) {
                vm.newBaseURL = OnlineShippingTool.env.newBaseURL + '?customerType=BUSINESS';
            } else {
                vm.newBaseURL = OnlineShippingTool.env.newBaseURL + '?customerType=PRIVATE';
            }
        }

        function randomizeBannerVisiblity() {
            const percentageOfUsersToShowBanner = 100;
            const localStorageKey = 'betaBannerRandomNumber';

            let randomNumber = $localStorage[localStorageKey];

            if (!randomNumber) {
                randomNumber = Math.floor(Math.random() * 100) + 1;
                $localStorage[localStorageKey] = randomNumber;
            }

            return randomNumber <= percentageOfUsersToShowBanner;
        }

        $rootScope.$on('main:customerTypeChanged', function() {
            vm.isCustomerCompany = $localStorage.isCustomerCompany;
            handleNewBaseURL();
         });
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.receipt')
        .directive ('seReceiptCodes', seReceiptCodes);

    function seReceiptCodes() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/receipt/se/se-receipt-codes.directive.html',
            scope: {
                letters: '<',
                isInternational: '<'
            },
            controller: seReceiptCodesController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }


    function seReceiptCodesController() {
        var vm = this;
        vm.hide = true;
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.receipt')
        .directive ('seReceiptInstructions', seReceiptInstructions);

    function seReceiptInstructions() {

        var directive = {
            restrict: 'E',
            templateUrl: 'components/receipt/se/receipt-instructions.directive.html',
            scope: {
                transactionId: '=',
                cart: '='
            },
            controller: seReceiptInstructionsController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }

    seReceiptInstructionsController.$inject = ['$log', '$http', '$sessionStorage', '$scope', '$state', '$stateParams', '$window', 'UserFactory', 'FeatureToggleFactory', 'PrintingFactory'];

    function seReceiptInstructionsController($log, $http, $sessionStorage, $scope, $state, $stateParams, $window, UserFactory, FeatureToggleFactory, PrintingFactory) {
        var vm = this;
        vm.loggedIn = UserFactory.isLoggedIn();
        vm.qrCodeHidden = false;
        vm.qrCodeEnabled = FeatureToggleFactory.isFeatureEnabled('qrCode') && $stateParams.printableAtServicePoint !== 'false';
        vm.qrData = vm.transactionId;
        vm.goTo = goTo;
        vm.qrCodeStatus = qrCodeStatus;
        vm.printWaybill = PrintingFactory.printWaybill;
        vm.internationalLetters = [];
        vm.nationalLetters = [];
        vm.parcels = [];
        vm.getDigitalStampsExpiryDate = getDigitalStampsExpiryDate;
        vm.downloadDigitalsStampsLink = OnlineShippingTool.env.digitalStampsUrl + '/?bookingId=' + vm.transactionId;
        vm.digitalStampsToggled = true;
        vm.labelsToggled = true;
        vm.showCN23Info = vm.cart[0].customsInformation?.type === 'CN 23';

        vm.walletUrl = OnlineShippingTool.env.appleWalletUrl
            .replace('{bookingId}', $sessionStorage.bookingId)
            .replace('{language}', localStorage.language);
        vm.nonTraceable = _.every(vm.cart, function (item) {
            return item.productCapabilities && item.productCapabilities.notificationFields && item.productCapabilities.notificationFields.notificationsPossible === false;
        });

        $http.get(OnlineShippingTool.env.googleWalletUrl + vm.cart[0].cartId).then(function(response) {
            window.gapi.savetoandroidpay.render("googlePay",{
                "jwt": response.data,
                "size": "large",
                "textsize": "small",
                "theme": "dark"
            });
        })

        activate();

        function activate() {
            setProductTypeLists();
            setToggleBoxState();
        }

        function setToggleBoxState() {
            if ((vm.nationalLetters.length || vm.internationalLetters.length) && vm.parcels.length) {
                vm.labelsToggled = false;
                vm.digitalStampsToggled = false;
            }
        }

        function setProductTypeLists() {
            _.each(vm.cart, function(item){
                if(!item.digitalStamps || !item.digitalStamps.length) {
                    vm.parcels.push(item);
                }

                _.each(item.digitalStamps, function(digitalStamp){
                    var services = _.filter(item.additionalServices, function(service) {
                        return service.selected === true;
                    })
                    var weightChoice = _.find(item.additionalServices, function (service) {
                        return service.selected && _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
                    });

                    var obj = {
                        name: item.name + ' - ' + weightChoice.additionalWeight.value + ' ' + weightChoice.additionalWeight.unit,
                        digitalStamp: digitalStamp,
                        services: services,
                        expiryDate: item.expiryDate,
                    };

                    if (item.toCountry.countryCode !== 'SE') {
                        vm.internationalLetters.push(obj);
                    } else {
                        vm.nationalLetters.push(obj);
                    }
                });
            })
        }

        function goTo(statePath) {
            $state.go(statePath);
        }

        function qrCodeStatus() {
            if ( vm.qrCodeHidden ) {
                vm.qrCodeHidden = false;
            } else {
                vm.qrCodeHidden = true;
            }
        }

        function getDigitalStampsExpiryDate() {
            if (vm.nationalLetters.length || vm.internationalLetters.length) {
                var letter = vm.nationalLetters[0] ? vm.nationalLetters[0] : vm.internationalLetters[0];
                return  moment(letter.expiryDate).format('LL');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.receipt')
        .directive ('dkReceiptInstructions', dkReceiptInstructions);



    function dkReceiptInstructions() {

        var directive = {
            restrict: 'E',
            templateUrl: 'components/receipt/dk/dk-receipt-instructions.directive.html',
            scope: {
                transactionId: '=',
                cart: '=',
            },
            controller: dkReceiptInstructionsController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;


    }
    dkReceiptInstructions.$inject = ['$log', '$translate', '$mdDialog', '$sessionStorage', '$window', 'PrintingFactory', 'Common', '$http', 'FeatureToggleFactory', '$stateParams'];

    function dkReceiptInstructionsController($log, $translate, $mdDialog, $sessionStorage, $window, PrintingFactory, Common, $http, FeatureToggleFactory, $stateParams) {
        var vm = this;
        vm.setActiveTab = setActiveTab;
        vm.printWaybill = PrintingFactory.printWaybill;
        vm.printReceipt = PrintingFactory.printReceipt;
        vm.qrCodeEnabled = FeatureToggleFactory.isFeatureEnabled('qrCodeDK');
        vm.qrData = vm.transactionId;
        vm.hasQuickletter = false;
        vm.hasPickUp = false;
        vm.hasInternationalReceiver = false;
        vm.walletUrl = OnlineShippingTool.env.appleWalletUrl
            .replace('{bookingId}', $sessionStorage.bookingId)
            .replace('{language}', localStorage.language);

        activate();

        ////////////////////////

        function activate() {
            _.each(vm.cart, function(o) {
                if (o.quickletter === true) {
                    vm.hasQuickletter = true;
                }

                if (o.receiver.address.countryCode !== 'DK') {
                    vm.hasInternationalReceiver = true;
                }

                _.each(o.additionalServices, function(service){
                    if(service.selected === true && service.additionalServiceId === 'Pickup') {
                        vm.hasPickUp = true;
                    }
                });
            });

            _.each(vm.cart, function(o) {
              var value = parseInt(o.selectedWeight.value);
              if(value > 20) {
                vm.description = {title: o.productCapabilities.handinAtDescription}
              } 
            });

            vm.tabs = [];

            if(_.some(vm.cart, { type: 'letter' })) {
                var obj = { name: 'letter', title: vm.hasInternationalReceiver ? $translate.instant('LETTER_DOCUMENTS') : $translate.instant('LETTER') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item){
                var itemDocuments = Common.getDocumentsForParcel(item);
                return !_.some(itemDocuments, {'region': 'nonEu'}) && item.type === 'untrackedInternationalLetter';
            })) {
                var obj = { name: 'untrackedInternationalLetter', title: $translate.instant('LETTER_GOODS') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item){
                var itemDocuments = Common.getDocumentsForParcel(item)
                return item.type === 'package' && !_.some(itemDocuments, { region : 'nonEu' })
            })) {
                var obj = { name: 'package', title: $translate.instant('PACKAGE') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item) {
                var itemDocuments = Common.getDocumentsForParcel(item);
                return !_.some(itemDocuments, { region: 'nonEu' }) && (isOldRekProduct(item) || isNewRekProduct(item));
            })) {
                var obj = { name: 'rekommanderet', title: $translate.instant('RECOMMENDED') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item) {
                var itemDocuments = Common.getDocumentsForParcel(item);
                return !_.some(itemDocuments, { region: 'nonEu' }) && (isOldValuePackageProduct(item) || isNewValuePackageProduct(item));
            })) {
                var obj = { name: 'valuables', title: $translate.instant('VALUABLES') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item){
                var itemDocuments = Common.getDocumentsForParcel(item);
                return _.some(itemDocuments, {'region': 'nonEu'}) && item.type !== 'untrackedInternationalLetter';
            })) {
                var obj = { name: 'shipmentsOutsideEu', title: $translate.instant('SHIPMENTSOUTSIDEEU') };
                vm.tabs.push(obj);
            }

            if(_.some(vm.cart, function(item){
                var itemDocuments = Common.getDocumentsForParcel(item);
                return _.some(itemDocuments, {'region': 'nonEu'}) && item.type === 'untrackedInternationalLetter';
            })) {
                var obj = { name: 'letterGoodsOutsideEu', title: $translate.instant('LETTER_GOODS_OUTSIDE_EU') };
                vm.tabs.push(obj);
            }

            vm.activeTab = vm.tabs.length > 0 ? vm.tabs[0].name : null;
            renderGooglePay();
        }

        function setActiveTab(tab) {
            if (['package', 'valuables'].indexOf(tab) !== -1) {
                renderGooglePay();
            }

            vm.activeTab = tab;
        }

        function renderGooglePay(){
            $http.get(OnlineShippingTool.env.googleWalletUrl + vm.cart[0].cartId).then(function(response) {
                window.gapi.savetoandroidpay.render("googlePay",{
                    "jwt": response.data,
                    "size": "large",
                    "textsize": "small",
                    "theme": "dark"
                });
            })
        }

        function isOldRekProduct(product) {
            var hasRekServiceSelected = _.chain(product.additionalServices)
                .filter({ selected: true })
                .map('additionalServiceId')
                .some(function (additionalServiceId) {
                    return ['144297', '144298', '144299'].indexOf(additionalServiceId) !== -1;
                })
                .value()
            return product.type === 'valuables' && hasRekServiceSelected;
        }

        function isNewRekProduct(product) {
            return product.type === 'registeredLetter';
        }

        function isOldValuePackageProduct(product) {
            return product.type === 'valuables' && _.some(product.additionalServices, {
                selected: true,
                additionalServiceId: '140172'
            });
        }

        function isNewValuePackageProduct(product) {
            return product.type === 'valuePackage';
        }
    }

})();

(function () {
    'use strict';

    angular
        .module ('onlineShippingTool.receipt')
        .directive ('dkReceiptCodes', dkReceiptCodes);



    function dkReceiptCodes() {

        var directive = {
            restrict: 'E',
            templateUrl: 'components/receipt/dk/dk-receipt-codes.directive.html',
            scope: {
                cart: '=',
            },
            controller: dkReceiptCodesController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;


    }
    dkReceiptCodesController.$inject = ['$log', '$sessionStorage'];

    function dkReceiptCodesController($log, $sessionStorage) {
        var vm = this;
        vm.printPortoCodes = printPortoCodes;
        vm.codes = [];

        activate();

        function activate() {
            _.each(vm.cart, function(item){
                _.each(item.portoCodes, function(portoCode){
                    var service = _.find(item.additionalServices, function(o) {
                        return o.selected === true;
                    })
                    var obj = {
                        name: item.name + ' - ' + item.selectedWeight.value + item.selectedWeight.unit,
                        portoCode: portoCode,
                        quickletter: item.quickletter,
                        service: service,
                        toCountry: item.toCountry
                    };
                    vm.codes.push(obj);
                });
            })
        }

        function canShowPrintDialog() {
            var ua = window.navigator.userAgent;

            // Chrome: Show print dialog by printing hidden iframe
            // Others: Open document directly since browser most likely wont allow printing hidden iframe

            return ua.indexOf("Chrome/") != -1 && ua.indexOf("Edge/") == -1 && ua.indexOf("Android") == -1;
        }

        function printPortoCodes() {
            $log.debug('Printing portocodes');

            if (canShowPrintDialog()) {
                document.getElementById("printFrame").src = OnlineShippingTool.env.fetchReceiptPortoCodesPrintPage +
                    "?bookingId=" + $sessionStorage.bookingId;
            } else {
                window.open(OnlineShippingTool.env.fetchReceiptPortoCodesHtmlUrl +
                    "?bookingId=" + $sessionStorage.bookingId);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('siteheader', siteHeader);

    function siteHeader() {
        var directive = {
            bindToController: true,
            templateUrl: 'components/layout/siteheader/siteheader.directive.html',
            controller: SiteheaderController,
            controllerAs: 'siteHeader',
            restrict: 'E',
            scope: {},
        };

        return directive;

    }
    /* @ngInject */
    SiteheaderController.$inject = ['$state', '$sessionStorage', '$scope', '$element', '$timeout', 'Common', '$translate'];

    function SiteheaderController($state, $sessionStorage, $scope, $element, $timeout, Common, $translate) {
        var vm = this;

        vm.loaded = false;
        vm.market = Common.getMarket().toLowerCase();
        vm.language = $translate.proposedLanguage() || $translate.use();
        vm.endpoint = OnlineShippingTool.env.marketwebEndpoint;
        vm.environment = OnlineShippingTool.env.marketwebEnvironment;

        activate();


        function handleReloadCart() {
            if ($sessionStorage.cart) {
                vm.cart = $sessionStorage.cart;
            } else {
                vm.cart = [];
            }
        }

        $scope.$on('main:reloadCart', handleReloadCart);

        function activate() {
            initObserver();

            if ($sessionStorage.cart) {
                vm.cart = $sessionStorage.cart;
            }
        }

        vm.cartClick = function() {
            if($sessionStorage.cart && $sessionStorage.cart.length > 0) {
                $state.go('main.payment')
            }
        }

        function initObserver () {
            var observer = new MutationObserver(function() {
                var loaded = $element[0].querySelector('header')?.childNodes.length;
                if (loaded) {
                    $timeout(() => vm.loaded = true, 0);
                    observer.disconnect()
                }

            });
            observer.observe($element[0], { childList: true, subtree: true });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('progressTracker', progressTracker);

    function progressTracker() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            templateUrl: 'components/layout/progress-tracker/progress-tracker.directive.html',
            controller: ProgressTrackerController,
            controllerAs: 'progressTracker',
            link: link,
            restrict: 'E',
            scope: {
                parcel: '=',
                stage: '=',
                cart: '=',
                hasPrintedShippinglabel: '=',
                editingFromState: '='
            }
        };
        return directive;

        function link(scope, element, attrs, el) {
            scope.$watch('progressTracker.parcel', scope.progressTracker.setCustomsDeclarationVisibility);
            scope.$watch('progressTracker.cart', scope.progressTracker.setCartHasOnlyLetters);
            scope.$watch('hasOnlyLetters');
        }
    }
    /* @ngInject */
    function ProgressTrackerController($log, FeatureToggleFactory, appOptions) {
        var vm = this;
        var stages = ['landing', 'address', 'customs', 'customsNew', 'payment', 'receipt', 'dropoff'];

        vm.country = appOptions.country;
        vm.setCustomsDeclarationVisibility = setCustomsDeclarationVisibility;
        vm.setCartHasOnlyLetters = setCartHasOnlyLetters;

        vm.isPreviousStage = function(stage) {
            return stages.indexOf(stage) < stages.indexOf(vm.stage);
        }

        vm.isCurrentStage = function(stage) {
            return vm.stage === stage;
        }

        function setCustomsDeclarationVisibility() {
            var hasCustomsDocument = _.get(vm.parcel, 'documents[0].type') === 'customsLabel';
            vm.showCustomsDeclarationsStep = (appOptions.country !== 'SE' || FeatureToggleFactory.isFeatureEnabled('swedishCustoms')) && hasCustomsDocument;
        }

        function setCartHasOnlyLetters() {
            vm.cartHasOnlyLetters = !_.some(vm.cart, function (product) {
                return product.type !== 'letter';
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('navigationMenu', navigationMenu);

    function navigationMenu() {
        var directive = {
            bindToController: true,
            templateUrl: 'components/layout/navigation-menu/navigation-menu.directive.html',
            controller: NavigationMenuController,
            controllerAs: 'navigationMenu',
            link: link,
            restrict: 'E',
            scope: {
                menuItems: '=',
            }
        };
        return directive;

        function link(scope, element, attr, ctrl) {
            function onClick(event){
                var isClickedOutside = element !== event.target && !element[0].contains(event.target);
                if (!isClickedOutside)
                    return;
        
                scope.$applyAsync(function(){
                    ctrl.navigationMenuExpanded = false;
                });
                
            }

            angular.element(window.document).bind('click', onClick);
            scope.$on('$destroy', function() {
                angular.element(window.document).off('click', onClick);
            });
        }
    }
    /* @ngInject */
    NavigationMenuController.$inject = ['$state', 'UserFactory', 'appOptions'];

    function NavigationMenuController($state, UserFactory, appOptions) {
        var vm = this;
        vm.navigationMenuExpanded = false;
        vm.toggleNavigationMenu = toggleNavigationMenu;
        vm.goToIfLoggedIn = goToIfLoggedIn;
        vm.signupPopupEnabled = signupPopupEnabled;
        vm.currentState = function() {
            setSelectedMenuItem();
            return $state.current.name;
        }

        setSelectedMenuItem();

        function setSelectedMenuItem(){
            vm.selectedMenuItem = vm.menuItems.filter(function(i) {
                return i.state === $state.current.name || i.extraStates.some(function(i){
                    return i === $state.current.name;
                });
            })[0];
        }

        function toggleNavigationMenu(){
            vm.navigationMenuExpanded = !vm.navigationMenuExpanded;
        }

        function goToIfLoggedIn(menuItem){
            vm.navigationMenuExpanded = false;
            if(!menuItem.loginRequired || UserFactory.isLoggedIn()){
                $state.go(menuItem.state);
                return;
            }

            $state.go('main.signup');
        }

        function signupPopupEnabled(state){
            return state.loginRequired && !UserFactory.isLoggedIn() && $state.current.name !== 'main.signup';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .service('floatingFaqInitializer', floatingFaqInitializer);

    floatingFaqInitializer.$inject = ['$q'];

    /* @ngInject */
    function floatingFaqInitializer($q) {
        var d = $q.defer();

        if (typeof Humany != "undefined") {
            Humany.configure(function (config) {
                config.navigationMode('hashless');

                Humany.ready(function () {
                    d.resolve();
                });
            });
        }

        return d.promise;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('floatingFaq', floatingFaq);

    /* @ngInject */
    function floatingFaq($translate, floatingFaqInitializer) {
        var directive = {
            restrict: 'E',
            link: linkFn
        };

        return directive;

        function linkFn(scope, element) {
            var widgetName;

            init();

            var changeLanguageListener = scope.$on('changeLanguage', function () {
                var humanyElement = document.querySelector('.humany-widget.humany-floating');

                if (humanyElement) {
                    var humanyTrigger = document.querySelector('.humany-floating-trigger').parentElement;

                    humanyElement.remove();

                    if (humanyTrigger) {
                        humanyTrigger.remove();
                    }
                }

                init();
            });

            function init() {
                var language = $translate.proposedLanguage() || $translate.use() || 'en';
                var prefix = OnlineShippingTool.env.humanyFloatingWidgetPrefixSE;
                widgetName = prefix + language;

                var openHumanyListener = scope.$on('humany:openFloatingWidget', function () {
                    open(element, widgetName);
                });

                floatingFaqInitializer.then(function () {
                    Humany.Widgets.Coordinator.trigger(element, { widgetName: widgetName, activate: false });
                });

                scope.$on('$destroy', function () {
                    window.Humany && Humany.ready && Humany.Widgets.Coordinator.destroy(widgetName);

                    openHumanyListener();
                });
            }
        }

        function open(element, widgetName) {
            Humany.Widgets.Coordinator.trigger(element, { widgetName: widgetName, activate: true });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('FeedbackButtonFactory', FeedbackButtonFactory);

    FeedbackButtonFactory.$inject = ['$translate', '$q'];
    function FeedbackButtonFactory($translate, $q) {

        var humanyLoaded = false;
        var currentPage = null;

        var service = {
            getHumanyWidget: getHumanyWidget,
            loadHumany: loadHumany,
            isHumanyLoaded: isHumanyLoaded,
            triggerHumany: triggerHumany
        };
        return service;

        function getHumanyWidget(state, country) {
            var widgetName = country === 'DK' ? 'st-feedback-lightbox-da' : 'st-feedback-lightbox-sv';
            currentPage = state;

            return {
                name: widgetName
            };
        }

        function isHumanyLoaded(){
            return humanyLoaded;
        }

        function humanyInitializer($q){
            var d = $q.defer();
            if (typeof Humany != "undefined") {
                Humany.configure(function (config) {
                    config.navigationMode("hashless");
                    Humany.ready(function () {
                        d.resolve(config);
                    });
                });
            }
            return d.promise;
        }

        function loadHumany(widgetName) {
            humanyLoaded = true;

            humanyInitializer($q).then(function(config){
                config(widgetName).registerPlugin({
                    init: function(data, context) {
                        var serviceClient = context.container.get("serviceClient");

                        serviceClient.parameters.set('st-current-page', currentPage);
                    }
                });
            });
        }

        function triggerHumany(element, widgetName) {
            Humany.Widgets.Coordinator.trigger(document, {widgetName: widgetName});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('feedbackButton', feedbackButton);

    /* @ngInject */
    function feedbackButton() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/layout/feedback-button/feedback-button.html',
            link: linkFunc,
            controller: FeedbackButtonController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {

        }
    }

    FeedbackButtonController.$inject = ['$rootScope', '$state', 'FeedbackButtonFactory', 'appOptions'];

    /* @ngInject */
    function FeedbackButtonController($rootScope, $state, FeedbackButtonFactory, appOptions) {
        var vm = this;

        vm.openModal = openModal;

        $rootScope.$on('$stateChangeSuccess', activate);

        activate();

        function activate() {
            var state = $state.current.name.replace('main.', '');
            vm.humanySettings = FeedbackButtonFactory.getHumanyWidget(state, appOptions.country);

            // Destory humany widget if already existing to reload it with current page
            if (FeedbackButtonFactory.isHumanyLoaded()){
                window.Humany && Humany.ready && Humany.Widgets.Coordinator.destroy(vm.humanySettings.name);
            }

            FeedbackButtonFactory.loadHumany(vm.humanySettings.name);
        }

        function openModal() {
            FeedbackButtonFactory.triggerHumany(document, vm.humanySettings.name)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.customsNew', []);
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool.customsNew')
        .controller('RemoveDocumentDialogController', RemoveDocumentDialogController)

    /** @ngInject */
    function RemoveDocumentDialogController($scope, $mdDialog, appOptions) {
        $scope.country = appOptions.country;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('customsDocuments', customsDocuments);

    /* @ngInject */
    function customsDocuments() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/customs/customs-documents/customs-documents.directive.html',
            scope: {
                documents: '=',
                agreement: '=',
                cn22error: '=',
            },
            controller: customsDocumentsController,
            controllerAs: 'ctrl',
            bindToController: true,
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {
            scope.$watch('ctrl.documents', scope.ctrl.activate);
        }
    }

    customsDocumentsController.$inject = ['$sessionStorage', '$scope'];

    function customsDocumentsController($sessionStorage, $scope) {

        var vm = this;

        vm.removeCustomsDocument = removeCustomsDocument;
        vm.editCustomsDocument = editCustomsDocument;

        activate();

        function activate() {
            if($sessionStorage.documentToEdit) {
                vm.documents.splice($sessionStorage.documentToEdit.index, 0, $sessionStorage.documentToEdit);
                delete $sessionStorage.documentToEdit;
            }
            if(vm.documents && vm.documents.type === 'CN 22' && vm.documents.items.length > 5) {
                vm.cn22error = true;
            }
            if(vm.documents && vm.documents.type === 'CN 22' && vm.documents.items.length <= 5) {
                vm.cn22error = false;
            }

        }

        function removeCustomsDocument(index) {
            vm.documents.items.splice(index, 1);

            if(vm.documents.type === 'CN 22' && vm.documents.items.length <= 5) {
                vm.cn22error = false;
            }
         }

         function editCustomsDocument(document, index, event) {
            $sessionStorage.documentToEditIndex = index;
            $sessionStorage.documentToEdit = document;
            $sessionStorage.isEditingDocument = true;
            $scope.$emit('EditDocument');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners', []);
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool.banners')
      .directive('skickaHemBanner', skickaHemBanner);

  /* @ngInject */
  function skickaHemBanner(BannersFactory, appOptions, FeatureToggleFactory) {
      var directive = {
          restrict: 'E',
          templateUrl: 'components/banners/skicka-hem/skicka-hem.directive.html',
          link: linkFunc
      };

      return directive;

      function linkFunc(scope, el, attr, ctrl) {
          scope.close = close;
          
          scope.qrCodeEnabled = FeatureToggleFactory.isFeatureEnabled('qrCode');

          activate();

          ////////////

          function activate() {
             
              if (BannersFactory.isBannerDismissed('skickaHem') || appOptions.country !== 'SE') {
                  el.remove();
              }
          }

          function close() {
              BannersFactory.dismissBanner('skickaHem');
              el.remove();
          }
      }
  }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool.banners')
      .directive('returnToDigitalAgentBanner', returnToDigitalAgentBanner);

  /* @ngInject */
  function returnToDigitalAgentBanner(BannersFactory, appOptions, FeatureToggleFactory, $sessionStorage) {
      var directive = {
          restrict: 'E',
          templateUrl: 'components/banners/return-to-digital-agent/return-to-digital-agent.directive.html',
          link: linkFunc
      };

      return directive;

      function linkFunc(scope, el, attr, ctrl) {
          scope.digitalAgentName = $sessionStorage.digitalAgent.agentName;
          scope.returnUrl = $sessionStorage.digitalAgent.returnUrl;
          scope.iconUrl = $sessionStorage.digitalAgent.iconUrl;

          activate();

          ////////////

          function activate() {
              if (BannersFactory.isBannerDismissed('returnToDigitalAgent') || appOptions.country !== 'SE' || !$sessionStorage.digitalAgent.agentId) {
                  el.remove();
              }
          }
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .directive('printAtServicepointBanner', printAtServicepointBanner);

    /* @ngInject */
    function printAtServicepointBanner(BannersFactory, appOptions, FeatureToggleFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/banners/print-at-servicepoint/print-at-servicepoint.directive.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.close = close;
            
            scope.qrCodeEnabled = FeatureToggleFactory.isFeatureEnabled('qrCode');

            activate();

            ////////////

            function activate() {
               
                if (BannersFactory.isBannerDismissed('printAtServicepoint') || appOptions.country !== 'SE') {
                    el.remove();
                }
            }

            function close() {
                BannersFactory.dismissBanner('printAtServicepoint');
                el.remove();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .directive('premiumSignUpBanner', premiumSignUpBanner);

    /* @ngInject */
    function premiumSignUpBanner(BannersFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/banners/premium-sign-up/premium-sign-up.directive.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.close = close;
            scope.goToLogin = goToLogin;

            activate();

            ////////////

            function activate() {
                if (BannersFactory.isBannerDismissed('premiumSignUp')) {
                    el.remove();
                }
            }

            function close() {
                BannersFactory.dismissBanner('premiumSignUp');
                el.remove();
            }

            function goToLogin() {
                if (typeof (pnTopbar) !== 'undefined') {
                    pnTopbar.login();
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .directive('loggedInModeBanner', loggedInModeBanner);

    /* @ngInject */
    function loggedInModeBanner(BannersFactory, UserFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/banners/logged-in-mode/logged-in-mode.directive.html',
            scope: {
                isLoggedIn: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.close = close;
            scope.goToLogin = goToLogin;

            activate();

            ////////////

            function activate() {
                if (BannersFactory.isBannerDismissed('loggedInMode') || UserFactory.isLoggedIn()) {
                    el.remove();
                }
            }

            function close() {
                BannersFactory.dismissBanner('loggedInMode');
                el.remove();
            }

            function goToLogin() {
                if (typeof (pnTopbar) !== 'undefined') {
                    pnTopbar.login();
                }
            }
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool.banners')
      .directive('dkBanner', dkBanner);

  /* @ngInject */
  function dkBanner(appOptions) {
      const directive = {
          restrict: 'E',
          templateUrl: 'components/banners/dk-banner/dk-banner.directive.html',
          link: linkFunc
      };

      return directive;

      function linkFunc(scope, el, attr, ctrl) {

          activate();

          ////////////

          function activate() {
             
              if (appOptions.country !== 'DK') {
                  el.remove();
              }
          }
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .directive('digitalStampsBanner', digitalStampsBanner);

    /* @ngInject */
    function digitalStampsBanner(BannersFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/banners/digital-stamps/digital-stamps.directive.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.close = close;

            activate();

            ////////////

            function activate() {

                if (BannersFactory.isBannerDismissed('digital-stamps')) {
                    el.remove();
                }
            }

            function close() {
                BannersFactory.dismissBanner('digital-stamps');
                el.remove();
            }
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool.banners')
      .directive('closedBanner', closedBanner);

  /* @ngInject */
  function closedBanner(BannersFactory, appOptions) {
      var directive = {
          restrict: 'E',
          templateUrl: 'components/banners/closed-banner/closed-banner.directive.html',
          link: linkFunc
      };

      return directive;

      function linkFunc(scope, el, attr, ctrl) {
          scope.close = close;

          activate();

          ////////////

          function activate() {
             
              if (BannersFactory.isBannerDismissed('closed') || appOptions.country !== 'DK') {
                  el.remove();
              }
          }

          function close() {
              BannersFactory.dismissBanner('closed');
              el.remove();
          }
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .directive('danishBanner', danishBanner);

    /* @ngInject */
    function danishBanner(BannersFactory) {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/banners/danish/danish.directive.html',
            scope: {
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            scope.close = close;

            activate();

            ////////////

            function activate() {
                if (BannersFactory.isBannerDismissed('danish')) {
                    el.remove();
                }
            }

            function close() {
                BannersFactory.dismissBanner('danish');
                el.remove();
            }
        }
    }
})();

;var SockWrap = function(io, forcedLongPolling) {
	var cs = {}
	, ack = function(what, args) {
		var cb;
		if (args.length == 0) return;
		cb = args[args.length-1];
		if (typeof cb !== 'function') return;
		cb(what);
	}
	;
	cs.io = io;
	cs.forcedLongPolling = forcedLongPolling;
	cs.encode = function(str) {
		return encodeURIComponent(str);
	};
	cs.decode = function (str) {
		return decodeURIComponent(str);
	};
	cs.on = function(what, callback) {
		cs.io.on(what, function() {
			callback.apply(null, arguments);
			ack('plain', arguments)
		});
	};
	cs.onString = function(what, callback) {
		cs.io.on(what, function(data) {
			arguments[0] = cs.decode(data)
			callback.apply(null, arguments);
			ack('onString', arguments)
		});
	};
	cs.onJson = function(what, callback) {
		cs.io.on(what, function(data) {
			var decoded, json;
			try {
				decoded = cs.decode(data);
			} catch (e) {
				console.log("ERROR SockWrap.decode(): error decoding data: [" + data + "]: " + e);
			}
			try {
				json = JSON.parse(decoded);
			} catch (e) {
				console.log("ERROR SockWrap.decode(): error parsing json `" + decoded + " `: " + e);
			}
			arguments[0] = json;
			callback.apply(null, arguments);
			ack('onJson', arguments)
		});
	};
	cs.emit = function(what, data) {
		switch (typeof data) {
			case "object":
				arguments[1] = cs.encode(JSON.stringify(data));
				break;
			case "string":
				arguments[1] = cs.encode(data);
				break;
		}
		cs.io.emit.apply(cs.io, arguments);
	};
	cs.connect = function() {
		cs.io.connect();
	};
	cs.disconnect = function() {
		cs.io.disconnect();
	};
	return cs;
};

var FOR_THIRD_PARTY_USE = true;
var socketio, sockwrap;
var CentionBaseURL;
if (typeof CentionBaseURL == "undefined") {
	CentionBaseURL = "";
}

if (FOR_THIRD_PARTY_USE) {
	var CentionChatStatus = {};
	socketio = "https://cdn.socket.io/socket.io-1.4.8.js";
	sockwrap = "ClearitChat/sockwrap.js";
} else {
	socketio = CentionBaseURL + "/cention/chat/js/socket.io.js";
	sockwrap = CentionBaseURL + "/cention/chat/js/sockwrap.js";
	if (typeof io === 'undefined') {
		var socketIOScript = document.createElement("script");
		socketIOScript.setAttribute("type", "text/javascript");
		socketIOScript.setAttribute("src", socketio);
		document.head.appendChild(socketIOScript);
	}
	if (typeof SockWrap === 'undefined') {
		var sockWrapScript = document.createElement("script");
		sockWrapScript.setAttribute("type", "text/javascript");
		sockWrapScript.setAttribute("src", sockwrap);
		document.head.appendChild(sockWrapScript);
	}
}

var _CentionChat = function() {
	var that = {};
	var Public = {};
	var chatSock = null;
	var actionHandlers = {};
	var SystemMessage;
	var JSON_ENCODED = "\x01JSON";

	Public.sessionSecret = '';
	Public.sessionId = '';
	Public.areaId = 0;
	Public.activeSession = false;
	that.queuePosition = -1;
	that.mcount = {};
	that.maxAcked = 0;
	// agentSeen keep track of whether the agent has seen the message sent by client.
	// It contains message ids that was sent by the client only.
	that.agentSeen = {};
	Public.baseURL = ""; // May be set by third party client.
	if (typeof I === 'function') {
		Public.I = I;
	} else {
		Public.I = function(text) { return text; };
	}

	function log() {
		if (window.console && console.log && typeof console.log === "function") {
			console.log.apply(console, arguments)
		}
	}

	function isInt(v) {
		return v === parseInt(v, 10);
	}

	// CentionChatAPI.go: bytesToSize()
	function bytesToSize(bytes) {
		var sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
		if (bytes == 0) return 'n/a';
		var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		if (i == 0) return bytes + ' ' + sizes[i];
		return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	}

	function isJSONPayload(text) {
		// returns true if text starts with "\x01JSON"
		return text.lastIndexOf(JSON_ENCODED, 0) === 0;
	}

	// CentionChatAPI.go: renderFileUploadMessage()
	function renderFileUploadMessage(j) {
		var html = '<a href="' + Public.baseURL + '/Cention/web/chat/client/download' + escape(j.fileDownload)
			+ '?t=' + Public.sessionSecret
			+ '">' + j.fileName +
			' <span>(' + bytesToSize(j.estimatedSize) + ')</span></a>';
		if (j.error) {
			html += '<span>Error: ' + j.error + '</span>';
		}
		return html
	}

	SystemMessage = {
		renderSetAgentsEvent: function(m) {
			var text = []
			, i
			, byName = function(a, b) {
				if (a < b) { return -1; }
				if (a > b) { return 1; }
				return 0;
			}
			, collectNames = function(a) {
				var i = 0
				, r = []
				;
				for(i=0; i<a.length; i++) {
					r.push(m.names[a[i]]);
				}
				return r;
			}
			, added = collectNames(m.added)
			, removed = collectNames(m.removed)
			;

			added.sort(byName);
			removed.sort(byName);

			if (removed.length > 0) {
				text.push(Public.I("Agent(s) removed: {AGENT_NAMES}")
					.replace('{AGENT_NAMES}', removed.join(", ")));
			}
			if (added.length > 0 && !m.byInvitation) {
				text.push(Public.I("Agent(s) added: {AGENT_NAMES}")
				       .replace('{AGENT_NAMES}', added.join(", ")));
			}
			if (text.length == 0) {
				return null;
			}
			return text.join(".<br>\n");
		},
		renderAgentLeftEvent: function(m) {
			return Public.I("{AGENT_NAME} has left the chat.").replace("{AGENT_NAME}", m.name);
		},
		renderClientEndsChat: function(m) {
			var text;
			if (m.name == "UNKNOWN") {
				text = Public.I("Client ended the chat.");
			} else {
				text = Public.I("{NAME} ended the chat.").replace("{NAME}", m.name);
			}
			return text;
		},
		renderAttachmentAdded: function(m) {
			var msg = "<a href=\"" +
					Public.baseURL + "/Cention/web/chat/client/download/" + m.file.download +
					"\">" + m.file.value +
					" <br /><span>(" + bytesToSize(m.file.estSize) + ")</span></a>";
			return msg;
		},
		renderForwardToAgent: function(m) {
			var text;

			text = Public.I("{FROM_AGENT} forwarded the chat to {TO_AGENT}")
				.replace("{FROM_AGENT}", m.from).replace("{TO_AGENT}", m.to)
				;

			return text;
		},
		renderForwardToArea: function(m) {
			var text;

			text = Public.I("{FROM_AGENT} forwarded the chat to area {AREA_NAME}")
				.replace("{FROM_AGENT}", m.from)
				.replace("{AREA_NAME}", m.areaName)
				;

			return text;
		},
		renderSendChatHistory: function(m) {
			var text = Public.I("A copy of the chat will be sent to {CLIENT_EMAIL}")
				.replace("{CLIENT_EMAIL}", m.to)
				;
			return text;
		},
		renderAcceptChat: function(m) {
			var text = Public.I("{AGENT_NAME} joins the chat.")
				.replace("{AGENT_NAME}", m.who)
				;
			return text;
		},
		renderRejectChat: function(m) {
			return null;
		},
		renderChatExpired: function(m) {
			return Public.I("This chat has expired.");
		},
		renderOwnerEndsChat: function(m) {
			return Public.I("{AGENT_NAME} ended the chat.")
				.replace("{AGENT_NAME}", m.who);
		},
		format: function(json,clientId,agents) {
			var m = JSON.parse(json.text);
			if (!m) {
				return json;
			}
			var sysMsg = {sender:'SYSTEM',fromClient: json.fromClient,text:json.text};
			switch (m.event) {
				case "SET_AGENTS":
					sysMsg.text = SystemMessage.renderSetAgentsEvent(m);
					break;
				case "AGENT_LEFT":
					sysMsg.text = SystemMessage.renderAgentLeftEvent(m);
					break;
				case "CLIENT_ENDS_CHAT":
					sysMsg.text = SystemMessage.renderClientEndsChat(m);
					break;
				case "ADD_ATTACHMENT":
					Array.prototype.contains = function(obj) {
						return this.indexOf(obj) > -1;
					};
					isAgent = agents.indexOf(m.who);
					if(isAgent > -1 ){
						sysMsg.fromClient = false;
					}else {
						sysMsg.fromClient = true;
					}
					sysMsg.sender = m.name;
					sysMsg.text = SystemMessage.renderAttachmentAdded(m);
					break;
				case "FORWARD_TO_AGENT":
					sysMsg.text = SystemMessage.renderForwardToAgent(m);
					break;
				case "FORWARD_TO_AREA":
					sysMsg.text = SystemMessage.renderForwardToArea(m);
					break;
				case "SEND_CHAT_HISTORY":
					sysMsg.text = SystemMessage.renderSendChatHistory(m);
					break;
				case "ACCEPT_CHAT":
					sysMsg.text = SystemMessage.renderAcceptChat(m);
					break;
				case "REJECT_CHAT":
					sysMsg.text = null;
					break;
				case "CHAT_EXPIRED":
					sysMsg.text = SystemMessage.renderChatExpired(m);
					break;
				case "OWNER_ENDS_CHAT":
					sysMsg.text = SystemMessage.renderOwnerEndsChat(m);
					break;
			}
			return sysMsg;
		}
	};

	that.maybeFormat = function (message) {
		var j
		, orig = message.text
		;
		if (!isJSONPayload(message.text)) return;
		try {
			j = that.parseJSONMessage(message.text);
			switch(j.event) {
				case "FILE_UPLOAD":
					message.text = renderFileUploadMessage(j);
					break;
			}
		} catch (e) {
			message.text = orig;
		}
	};

	that.bindEvents = function(socket, parameters) {
		socket.on('unsentmessages', function(){
			that.emitMessage();
		});
		socket.on('status', function(cb) {
			// Don't put any unicode characters in response - it
			// won't work on some versions of IE.
			var response = {
				forcelongpolling: socket.forcedLongPolling
			};
			cb(response);
		});
		socket.on('pong', function() {
			that.io.lastPong = (new Date()).getTime();
		});

		socket.on('connect_error',function(err){
			invokeAction('connect_error', err);
		});

		socket.on('connect',function(){
			if (!Public.sessionSecret) {
				that.register(parameters);
			} else {
				that.reconnect();
			}
		})

		socket.onJson('register', function (msg, cb) {
			that.connected = true;
			if (msg.status == 'OFFLINE') {
				Public.disconnect();
			} else if (msg.status == 'CLOSED') {
				invokeAction('chat closed');
			} else {
				Public.sessionSecret = msg.sessionSecret;
				Public.sessionId = msg.sessionId;
				Public.areaId = msg.areaId;
				Public.activeSession = true;
				Public.haveCookie = msg.haveCookie;

				invokeAction('connect', msg);
			}
			cb('client ' + msg.status);
		});

		socket.on('agent unavailable', function() {
			invokeAction('agent unavailable');
		});

		socket.on('queue full', function() {
			invokeAction('queue full');
		});

		socket.onJson('chat message', function(cm, ack) {
			var data
			, i
			, messageId
			, message
			, ackedids = []
			;
			if (!cm) return;

			data = cm.session;
			data.chat = cm.messages;
			var agentIds = cm.session.agentIds;
			for (i=0; i<cm.messages.length; i++) {
				message = cm.messages[i];
				if (message.fromClient) {
					if (!that.agentSeen.hasOwnProperty(message.id)) {
						that.agentSeen[message.id] = false;
					}
					message.sender = 'CLIENT';
					message.read = message.id <= data.amaxId;
					that.maybeFormat(message);
				} else if (message.aid > 0) {
					message.sender = 'AGENT';
					that.maybeFormat(message);
				} else {
					var oSysMsg = SystemMessage.format(message,data.clientId,agentIds);
					message.sender = oSysMsg.sender;
					message.text = oSysMsg.text;
					message.fromClient = oSysMsg.fromClient;
				}
			}
			actionHandlers['chat message'].call(null, data);
			for (i=0; i<cm.messages.length; i++) {
				messageId = cm.messages[i].id;
				// Remember that we have received this message
				if (isInt(messageId)) {
					that.mcount[messageId] = true;
				}

			}

			if (that.maxAcked < data.amaxId) {
				for (var id in that.agentSeen) {
					if (that.agentSeen[id]) {
						continue;
					}
					if (id <= data.amaxId) {
						that.agentSeen[id] = true;
						ackedids.push(id);
					}
				}
				that.maxAcked = data.amaxId;

				if (ackedids.length > 0) {
					invokeAction('message acked', {ids:ackedids});
				}
			}
			ack(Object.keys(that.mcount).length, cm.messages.length);
		});

		socket.onJson('agent preview', function(data) {
			invokeAction('agent preview', data);
		});

		socket.on('queue', function(n) {
			if (that.queuePosition == -1 || n < that.queuePosition) {
				that.queuePosition = n;
				invokeAction('queue', n);
			}
		});

		socket.on('finish chat session', function() {
			Public.activeSession = false;
			Public.disconnect();
			invokeAction('finish chat session');
		});

		socket.onJson('session reconnect', function(msg) {
			that.connected = true;
			switch (msg.status) {
				case 'TRY_AGAIN':
					setTimeout(function(){
						log('Reconnection failed, retry sending reconnect..');
						that.reconnect();
					},4000);
					break;
				case 'OFFLINE':
					invokeAction('chat closed');
					break;
			}
		});

		socket.onJson('message acked', function(msg) {
			var i;
			for (i=0;i<msg.ids.length;i++) {
				if (that.maxAcked < msg.ids[i]) {
					that.maxAcked = msg.ids[i];
				}
				that.agentSeen[msg.ids[i]] = true;
			}
			invokeAction('message acked', msg);
		});
	};

	function invokeAction( action ) {
		var handler = actionHandlers[action];
		if( handler ) {
			return handler.apply(self, Array.prototype.slice.apply(arguments, [1]), Array.prototype.slice.apply(arguments, [2]));
		}
	};

	Public.registerAction = function(action, handler) {
		actionHandlers[action] = handler;
		if (action === 'message sent') {
			that.updateUnsentMessage = handler;
		}
	};

	that.io = {
		forcelongpolling: false,
		pongTimeout: 60*1000,
		lastPong: 0,
		watchDogEnabled: false
	};
	that.forceLongPolling = function() {
		if (!that.io.forcelongpolling) {
			if (chatSock) {
				chatSock.disconnect();
				chatSock = null;
			}
			that.io.forcelongpolling = true;
			Public.connect();
		}
	};
	that.connected = false; // true when we have successfully registered or reconnected
	that.reconnectTimeoutId = null;

	that.watchDog = function() {
		var now;

		if (!Public.activeSession) {
			return;
		}

		if (that.io.forcelongpolling) {
			return;
		}

		now = (new Date()).getTime();
		if ((now - that.io.lastPong) > that.io.pongTimeout) {
			that.forceLongPolling();
		} else {
			setTimeout(that.watchDog, that.io.pongTimeout);
		}
	};

	Public.bytesToSize = function(bytes) { return bytesToSize(bytes);};
	Public.connect = function(parameters, ioparams) {
		var ioOpt
		    , forcedLongPolling = false
		    ;
		that.connected = false;
		if (!chatSock) {
			ioOpt = {
				path: '/socket/external.io'
			};
			if (ioparams) {
				if (ioparams.forcelongpolling || that.io.forcelongpolling) {
					forcedLongPolling = true;
					ioOpt.transports = ['polling'];
				}
				if (typeof ioparams.multiplex !== 'undefined') {
					ioOpt.multiplex = ioparams.multiplex;
				}
			}
			if (parameters) {
				if (!Public.areaId) {
					Public.areaId = parameters.area;
				}
				if (parameters.langCode) {
					Public.langCode = parameters.langCode;
				}
			}
			chatSock = SockWrap(io(Public.baseURL || window.location.origin, ioOpt), forcedLongPolling);
			that.bindEvents(chatSock, parameters);

			if (!that.io.forcelongpolling && !that.io.watchDogEnabled) {
				that.io.watchDogEnabled = true;
				setTimeout(that.watchDog, that.io.pongTimeout);
			}
		} else {
			chatSock.connect();
			if (!Public.sessionSecret) {
				that.register(parameters);
			} else {
				that.reconnect();
			}
		}

		clearTimeout(that.reconnectTimeoutId);
		that.reconnectTimeoutId = setTimeout(function() {
			if (that.connected) {
				return;
			}
			// TODO force long polling if there are many reconnection attempts
			that.forceLongPolling();
		}, 60*1000);
	};

	Public.tryResume = function(cb) {
		var url = Public.baseURL + "/socket/external.api/canresume";
		jQuery.ajax({
			url: url,
			type: 'GET',
			xhrFields: {withCredentials: true}
		})
		.done(function(msg){
			if (msg.error) {
				cb(msg);
			} else {
				Public.connect({ callback: cb, resume: true, area: -1 });
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			log("error loading " + url, textStatus, errorThrown);
			cb({'error':'resume failed'});
		});
	};

	Public.disconnect = function() {
		Public.activeSession = false;
		chatSock.disconnect();
		chatSock = null;
	};

	that.unsentMessageId = 0;
	that.unsentMessages = [];
	that.emitMessage = function() {
		var um;

		if (that.unsentMessages.length == 0) {
			return;
		}

		um = that.unsentMessages[0];
		chatSock.emit('chat message', {
			id: um.id,
			message: um.message,
			mcount: Object.keys(that.mcount).length
		}, function(ack) {
			if (ack.error) {
				switch(ack.error) {
					case 'ERR_NIL_CHAT':
						that.reconnect();
						// fall through
					case 'ERR_TRY_AGAIN':
						setTimeout(that.emitMessage, 4000);
						return;
					case 'ERR_INVALID_MESSAGE_ID':
						// This should not happen
						throw new Error("received ERR_INVALID_MESSAGE_ID: " + um.id);
					case 'ERR_ALREADY_SEEN':
						if (that.unsentMessages.length > 0 && um.id == that.unsentMessages[0].id) {
							um = that.unsentMessages.shift();
							um.messageId = 'already-seen-' + um.id;
							that.mcount[um.messageId] = true;
							that.updateUnsentMessage && that.updateUnsentMessage({
								id: um.messageId,
								umid: um.id,
								sentHuman: 'NN:NN' // FIXME make back end return the timestamp
							});
						}
						break;
					default:
						throw new Error("unhandled ack.error '" + ack.error + "'");
				}
			} else {
				um = that.unsentMessages.shift();
				if (um.id == ack.umid) {
					um.messageId = ack.id;
					um.sentHuman = ack.sentHuman;
					that.updateUnsentMessage && that.updateUnsentMessage({
						id: ack.id,
						umid: ack.umid,
						sentHuman: ack.sentHuman
					});
					if (!that.agentSeen.hasOwnProperty(ack.id)) {
						that.agentSeen[ack.id] = false;
					}
				}
			}

			if (that.unsentMessages.length > 0) {
				that.emitMessage();
			}
		});
	};

	that.getNewMessageId = function() {
		var timestamp = (new Date()).getTime();

		that.unsentMessageId++;
		return 'c-' + timestamp + '-' + that.unsentMessageId;
	};
	that.addUnsentMessage = function(message) {
		var um
		    , id = that.getNewMessageId()
		    ;
		um = {
			message: message,
			id: id
		};
		that.unsentMessages.push(um);
		if (Public.activeSession) {
			if (that.unsentMessages.length == 1) {
				that.emitMessage();
			}
		}
		return um;
	};

	Public.message = function(message) {
		return that.addUnsentMessage(message);
	};

	Public.preview = function(message) {
		if (Public.activeSession) {
			chatSock.emit('preview', message);
		}
	};
	
	that.reconnect = function() {
		chatSock.emit('session reconnect', {
			area: Public.areaId,
			sessionId: Public.sessionId,
			sessionSecret: Public.sessionSecret,
			langCode: Public.langCode
		});
	};
	
	Public.close = function() {
		chatSock.emit('close chat');
	};
	
	that.register = function(parameters) {
		if (parameters && parameters.resume) {
			chatSock.emit('resume', window.location.href, function(msg) {
				that.connected = true;
				if (msg.error) {
					chatSock.disconnect();
					chatSock = null;
					parameters.callback && parameters.callback(msg);
					return;
				}
				Public.sessionSecret = msg.sessionSecret;
				Public.sessionId = msg.sessionId;
				Public.areaId = msg.areaId;
				Public.activeSession = true;
				if (msg.langCode) {
					Public.langCode = msg.langCode;
				}
				parameters.callback && parameters.callback(msg);
				chatSock.emit('sendchat', "resume existing chat", function(ack) {
					if (ack.error) {
						log('sendchat error', ack.error);
					}
				});
			});
		} else {
			chatSock.emit('register', parameters);
		}
	};

	that.isWithinSizeLimit = function(estFileSize){
		var maxFileAllowed = CentionChatStatus.feature['chat.max-attachment-size'];
		if(typeof maxFileAllowed === 'undefined' || maxFileAllowed <= 0){
			return true // don't care about the file limits
		}
		if(estFileSize > maxFileAllowed) {
			return false;
		}
		return true;
	};

	that.JSONMessage = function(j) {
		return JSON_ENCODED + JSON.stringify(j);
	};

	that.parseJSONMessage = function(text) {
		return JSON.parse(text.replace(JSON_ENCODED, ''));
	};

	Public.attachFile = function(file,callback) {
			if(!file || typeof(file) === 'undefined') return;
			if(!that.isWithinSizeLimit(file.size)){
				alert(I("The uploaded file has exceeded the max allowed size."));
				return;
			}
			var xhr =[];
			var formData = new FormData();
			var boundary = Math.floor(Math.random() * 6)+ '0'+ Math.floor(''+new Date() / 1000) ;
			formData.append("uploadfile", file);
			formData.append( 'random', parseFloat(boundary));
			formData.append( 'session', Public.sessionId);
			formData.append( 'area', Public.areaId);
			formData.append('sessionSecret', Public.sessionSecret);
			xhr[0] = new XMLHttpRequest();
			xhr[0].open("POST", Public.baseURL + "/Cention/web/chat/client/uploadAttachment");
			xhr[0].onreadystatechange = function(ev){
				if (ev.target.readyState == 4 && ev.target.status == 200) {
					var ro = JSON.parse(ev.target.responseText);
					/*Send callback to parent for every file upload*/
					chatSock.emit('add attachment', {
						area: Public.areaId,
						sessionSecret: Public.sessionSecret,
						file:ro
					}, function(ack) {
						var j = {
							"event": "FILE_UPLOAD",
							"fileDownload": ack.file.download,
							"fileName": ack.file.value,
							"estimatedSize": ack.file.estSize,
							"error":ack.error
						}
						, um = Public.message(that.JSONMessage(j))
						;
						callback({
							unsent: true,
							text: renderFileUploadMessage(j),
							fromClient: true,
							sender: "CLIENT",
							id: "unsent-" + um.id
						});
					});
				}
			};
			xhr[0].send(formData);
	};

	Public.attachImage = function(fileData) {
		var fd = new FormData();
		var boundary = Math.floor(Math.random() * 6)+ ''+ 1 +''+ Math.floor(''+new Date() / 1000);
		fd.append( 'uploadfile', fileData );
		fd.append( 'random', boundary);
		fd.append( 'area', Public.areaId);
		fd.append( 'session', Public.sessionId);
		fd.append( 'sessionSecret', Public.sessionSecret);

		return jQuery.ajax({
			url: Public.baseURL + "/Cention/web/chat/client/uploadTempAttachment",
			data: fd,
			processData: false,
			contentType: false,
			type: 'POST',
		});
	};

	Public.moveImage = function(fileIds,fileNames) {
		var fd = new FormData();
		fd.append( 'fileIds', fileIds);
		fd.append( 'fileNames', fileNames);
		fd.append( 'session', Public.sessionId);

		return jQuery.ajax({
			url: Public.baseURL + "/Cention/web/chat/client/moveTempAttachment",
			data: fd,
			processData: false,
			contentType: false,
			type: 'POST',
		});
	};

	function areaQuery(areaId, path, callback) {
		var url = Public.baseURL + "/socket/external.api" + path;
		jQuery.ajax({
			url: url,
			data: {area: areaId},
			type: 'GET',
			xhrFields: {withCredentials: true}
		})
		.done(function(data){ callback(data); }.bind(this))
		.fail(function(jqXHR, textStatus, errorThrown) {
			log("error loading " + url, textStatus, errorThrown);
			callback({'error':'chat connection failed'});
		});
	}

	Public.canChat = function(handleData, areaId) {
		areaQuery(areaId, "/canchat", function(data) {
			if(FOR_THIRD_PARTY_USE) {
				CentionChatStatus.feature = data.feature;
			}
			handleData(data);
		});
	};

	Public.resetChat = function() {
		that.mcount = {};
	};
	
	return Public;
};

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.user', [
            'onlineShippingTool.user.history',
            'onlineShippingTool.user.receivers'
        ]);
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.user')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.user', {
          abstract: true,
          url: '/user',
          template: '<ui-view></ui-view>'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.signup', []);
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.signup')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.signup', {
        url: '/signup?oneTimeCode',
        templateUrl: 'components/signup/signup.html',
        controller: 'SignupController',
        controllerAs: 'signup',
        /* @ngInject */
        onEnter: ($state, $stateParams) => {
          if (!window.pnTopbar) return undefined;

          // If ?oneTimeCode is present in the URL, it means topbar hasn't consumed it yet,
          // and therefore won't indicate we're logged in properly, so we just redirect the
          // user to the start page since we know a login was made.
          if ($stateParams.oneTimeCode) {
            $state.go('main.landing', { type: $stateParams.type});
          } else {
            setTimeout(() => {
              window.pnTopbar.getAccessTokenAsync().then(token => {
                if (window.pnTopbar.isLoggedIn) {
                  $state.go('main.landing', { type: $stateParams.type});
                }
                return undefined;
              });
            }, 50);
          }
        }
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.signup')
        .controller('SignupController', SignupController);

    SignupController.$inject = ['Topbar'];

    /* @ngInject */
    function SignupController(Topbar) {
        var vm = this;
        vm.login = login;

        function login() {
            Topbar.login();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('ZipcodeCityFactory', ZipcodeCityFactory);

        ZipcodeCityFactory.$inject = ['$http'];

    /* @ngInject */
    function ZipcodeCityFactory($http) {
        var service = {
            getCityByZipcode: getCityByZipcode,
        };

        return service;

        function getCityByZipcode(countryCode, zipcode) {
          
          // To match API we only use the first two letters in the countrycode,
          // we have our own codes for subareas of a country like Northern Ireland GBNI eventhough it's in GB.
          
          countryCode = countryCode.substring(0,2);
            var zipcodeUrl = OnlineShippingTool.env.postalCodeValidationUrl;
            return $http({ method: 'POST', url: zipcodeUrl, headers: OnlineShippingTool.env.bap_key, data: [{countryCode: countryCode, postalCode: zipcode}], timeout: 3000});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('zipcodeCityAutocomplete', zipcodeCityAutocomplete);

    /* @ngInject */

    function zipcodeCityAutocomplete(ZipcodeCityFactory) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                validationStatus: '=?',
                nonPostalCodeCountry: '=?',
            },
            link: link,
        };

        function link(scope, element, attrs, ngModel) {
            attrs.$observe('zipcodeCityAutocomplete', function(zipcode) {
                scope.validationStatus = 'pending';
                scope.nonPostalCodeCountry = false;

                var trimmedZipcode = zipcode.replace(/[-|&;$%@"<>()+.,=!?#€`\s ]/gm, '');

                // If the zipcode is empty after trimming, use the original input
                // and let the normal validation handle the rest. If we send in an
                // empty zipcode, we won't get an error from the validation service.
                zipcode = trimmedZipcode.length > 0 ? trimmedZipcode : zipcode;

                ZipcodeCityFactory.getCityByZipcode(attrs.countryCode, zipcode)
                    .then(function (response) {
                        if (response.data && response.data[0].city){
                            var city = response.data[0].city.charAt(0) + response.data[0].city.slice(1).toLowerCase();
                            ngModel.$setViewValue(city);
                            ngModel.$render();
                            element.removeAttr('disabled');
                            element.removeAttr('readonly');
                            scope.nonPostalCodeCountry = false;
                            scope.validationStatus = 'valid';
                        } else if (
                            response.data &&
                            (response.data[0].postalCodeType === 'INVALID' || response.data[0].postalCodeType === 'INVALID_PATTERN')
                        ) {
                            element.removeAttr('placeholder');
                            element.removeAttr('disabled');
                            element.removeAttr('readonly');
                            scope.validationStatus = 'invalid';

                            // If we don't get any patterns for the postal code, the country does not use postal codes
                            if (response.data[0].postalCodePattern.length === 0) {
                                scope.nonPostalCodeCountry = true;
                            } else {
                                scope.nonPostalCodeCountry = false;
                            }
                        } else {
                            element.removeAttr('disabled');
                            element.removeAttr('readonly');
                            scope.nonPostalCodeCountry = false;
                            scope.validationStatus = 'valid';
                        }
                    }).catch(function(error){
                        element.removeAttr('placeholder');
                        element.removeAttr('disabled');
                        element.removeAttr('readonly');
                        scope.validationStatus = 'invalid';
                    });
            })
        }

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('weightInterval', weightInterval);

    function weightInterval() {
        return weightIntervalFilter

        function weightIntervalFilter(parcel) {
            if (!parcel) return;

            var res = '';
            var isEqual = _.isEqual(parcel.minWeight, parcel.maxWeight);

            res += (!parcel.maxWeight && parcel.minWeight) ? '<span>Min <\/span>' : '';
            res += (parcel.maxWeight && (!parcel.minWeight || isEqual)) ? '<span>Max <\/span>' : '';
            res += parcel.minWeight && !isEqual ? parcel.minWeight.value : '';
            res += (parcel.minWeight && _.get(parcel, 'minWeight.unit') !== _.get(parcel, 'maxWeight.unit')) ? ' ' + parcel.minWeight.unit + ' ' : '';
            res += (parcel.minWeight && parcel.maxWeight && !isEqual) ? '-' : '';
            res += (parcel.minWeight && _.get(parcel, 'minWeight.unit') !== _.get(parcel, 'maxWeight.unit')) ? ' ' : '';
            res += parcel.maxWeight ? parcel.maxWeight.value + ' ' + parcel.maxWeight.unit : '';

            return res;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('weightChoice', weightChoice);

    function weightChoice() {
        return weightChoiceFilter

        function weightChoiceFilter(services, returnWeightChoices) {
            return _.filter(services, function (service) {
                var isWeightChoice = _.get(service, 'multipleChoiceAddOn.name') === 'weightChoice';
                return returnWeightChoices ? isWeightChoice : !isWeightChoice;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('UserFactory', UserFactory);

    UserFactory.$inject = ['$http', '$log'];

    /* @ngInject */
    function UserFactory($http, $log) {
        var service = {
            isLoggedIn: isLoggedIn,
            updateUserInfo: updateUserInfo,
            getUserInfo: getUserInfo,
            getCompanyInfo: getCompanyInfo
        };

        return service;

        function isLoggedIn() {
            var hasStorage = (function() {
                try {
                    localStorage.setItem('mod', 'mod');
                    localStorage.removeItem('mod');
                    return true;
                } catch (exception) {
                    return false;
                }
            }());

            var user = hasStorage && localStorage.getItem('user');
            return user && user !== 'null';
        }

        function updateUserInfo(sender) {
            var body = {
                "street": sender.address.street,
                "postalCode": sender.address.zipCode,
            }
            return $http.put(OnlineShippingTool.env.updateUserInfoUrl, body, {});
        }

        function getUserInfo() {
            return $http.get(OnlineShippingTool.env.updateUserInfoUrl);
        }
        
        function getCompanyInfo() {
            return $http.get(OnlineShippingTool.env.updateCompanyInfoUrl);
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool')
      .filter("trustHtml", ['$sce', $sce => htmlCode => $sce.trustAsHtml(htmlCode)]);
})();


(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('translateArray', function($filter){
            return function(input){
                var $translate = $filter('translate');
                var result = [];
                angular.forEach(input, function(value){
                    var translated = $translate(value);
                    result.push(translated);   
                });
                return result;
            };
        });
})();
(function() {
'use strict';

    angular
        .module('onlineShippingTool')
        .factory('Topbar', Topbar);

    Topbar.inject = ['$stateParams', '$sessionStorage', 'Common', 'TOPBAR_PREFIXES'];
    function Topbar($stateParams, $sessionStorage, Common, TOPBAR_PREFIXES) {
        var service = {
            updateCart: updateCart,
            clearCart: clearCart,
            showMarketWebNavigation: showMarketWebNavigation,
            login: login,
        };

        return service;

        function updateCart() {
            if (typeof (pnTopbar) !== 'undefined' && $sessionStorage.cart != undefined) {
                pnTopbar.cartItems = $sessionStorage.cart.length;
            }
        }

        function clearCart() {
            if (typeof (pnTopbar) !== 'undefined') {
                pnTopbar.cartItems = 0;
            }
        }

        function showMarketWebNavigation($stateParams) {
            return $stateParams.type !== TOPBAR_PREFIXES.PORTAL;
        }

        function login() {
            if (showMarketWebNavigation($stateParams)) {
                const baseURL = OnlineShippingTool.env.baseUrls[Common.getMarket().toLowerCase()];
                const baseRedirectURL = baseURL === '/' ? window.location.origin : baseURL;
                const baseLoginURL = `${OnlineShippingTool.env.portalBaseUrl}/api/unified-login/backend/authorization?redirectionUrl=`;
                window.location.href = `${baseLoginURL}${baseRedirectURL}/${TOPBAR_PREFIXES.MARKET_WEB}`;
            } else {
                pnTopbar.login();
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('StoredSenderFactory', StoredSenderFactory);

    StoredSenderFactory.$inject = ['$localStorage'];

    /* @ngInject */
    function StoredSenderFactory($localStorage) {
        var service = {
            get: get,
            set: set,
            delete: deleteSender
        };

        return service;

        function get() {
            clearFailedMigration();
            if(!$localStorage.isCustomerCompany) {
                return $localStorage.sender && $localStorage.sender.private;
            } else {
                return $localStorage.sender && $localStorage.sender.business;
            }
        }

        function set(sender) {
            $localStorage.sender = $localStorage.sender || {};
            clearFailedMigration();
            if(!$localStorage.isCustomerCompany) {
                $localStorage.sender.private = sender;
            } else {
                $localStorage.sender.business = sender;
            }
        }

        function deleteSender() {
            if ($localStorage.sender) {
                if(!$localStorage.isCustomerCompany) {
                    delete $localStorage.sender.private;
                } else {
                    delete $localStorage.sender.business;
                }
            }
        }

        function clearFailedMigration() {
            if ($localStorage.sender && $localStorage.sender.private) {
                delete $localStorage.sender.private.private;
                delete $localStorage.sender.private.business;
            }
            if ($localStorage.sender && $localStorage.sender.business) {
                delete $localStorage.sender.business.private;
                delete $localStorage.sender.business.business;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('ShipmentFactory', ShipmentFactory);

    ShipmentFactory.$inject = ['$http', '$log', '$translate'];

    /* @ngInject */
    function ShipmentFactory($http, $log, $translate) {
        var service = {
            getEventsForShipment: getEventsForShipment,
            getShipment: getShipment
        };
        
        return service;

        function getShipment(shipmentId) {
            return $http.get(OnlineShippingTool.env.findByIdentifierURL, {
                params: {
                    id: shipmentId,
                    locale: $translate.use(),
                },
                headers: OnlineShippingTool.env.bap_key,
            })
            .then(function(response){
                $log.debug('ShipmentFactory : getShipment : response', response);
                var res = null;

                if(response.data.TrackingInformationResponse.shipments.length > 0) {
                    var shipment = response.data.TrackingInformationResponse.shipments[0];
                    var item = _.find(shipment.items, {itemId: shipmentId}) || shipment.items[0];
                    var events = item.events;

                    res = {
                        shipmentId: shipment.shipmentId,
                        events: formatEvents(events),
                        status: getStatus(shipment, item, events),
                        statusText: getStatusText(shipment, item, events)
                    };
                }

                return res;
            })
        }

        function getEventsForShipment(shipmentId) {
            return getShipment(shipmentId).then(function (shipment) {
                $log.debug('ShipmentFactory : getEventsForShipment : shipment', shipment);
                var events = [];

                if (shipment) {
                    events = shipment.events;
                }

                return events;
            });
        }

        function getStatus(shipment, item, events) {
            var status = null;

            if (item && item.status && item.status !== 'OTHER') {
                status = item.status;
            } else if (shipment && shipment.status && shipment.status !== 'OTHER') {
                status = shipment.status;
            } else if (events && events.length > 0) {
                var revEvents = events.reverse();

                for (var i = 0; i < revEvents.length; i++) {
                    var event = revEvents[i];

                    if (event && event.status && event.status !== 'OTHER') {
                        status = event.status;
                        break;
                    }
                }
            }

            return status;
        }


        function getStatusText(shipment, item, events) {
            return _.get(item, 'statusText.body')
                || _.get(shipment, 'statusText.body')
                || (events && events.length > 0 && _.last(events).eventDescription)
                || _.get(item, 'statusText.header')
                || _.get(shipment, 'statusText.header')
                || null;
        }


        function formatEvents(events) {
            $log.debug('ShipmentFactory : formatEvents : events', events);
            return _.map(events, function (event) {
                var location = event.location;

                var res = {
                    time: event.eventTime,
                    location: {
                        locationId: location.locationId || null,
                        locationType: location.locationType || null,
                        name: location.name || null,
                        city: location.city || null,
                        postalCode: location.postcode || null,
                        country: location.country || null,
                        countryCode: location.countryCode // three to two numbers?
                    },
                    status: event.status || null,
                    description: event.eventDescription || null
                }

                return res;
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool')
    .factory('ServicePointFactory', ServicePointFactory);

  ServicePointFactory.$inject = ['$http'];

  /* @ngInject */
  function ServicePointFactory($http) {
    var service = {
      getServicePointsByAddress,
      getServicePointByAddress,
    };

    const formatServicePoint = ({
      servicePointId,
      name,
      deliveryAddress,
      visitingAddress,
      openingHours,
      dropOff,
      routeDistance,
      coordinates
    }) => {
      return {
        servicePointId,
        name,
        deliveryAddress,
        visitingAddress,
        openingHours: formatOpeningHours(openingHours.postalServices),
        dropOffTimes: dropOff ?
          formatDropOffTimes(dropOff) :
          {},
        routeDistance,
        coordinates: coordinates && {
          lat: coordinates[0].northing,
          lng: coordinates[0].easting
        }
      }
    };

    return service;

    function getServicePointsByAddress(address, serviceId, numberOfServicePoints = 5) {
      var url = 'https://api2.postnord.com/rest/businesslocation/v5/servicepoints/nearest/byaddress'
      return $http({
        method: 'GET',
        headers: OnlineShippingTool.env.bap_key,
        url: url,
        params: {
          postalCode: address.zipCode,
          city: address.city,
          streetName: address.street,
          numberOfServicePoints,
          returnType: 'JSON',
          countryCode: address.countryCode,
          agreementCountry: address.countryCode,
          responseFilter: 'internal', // Needed to get dropoff times
          typeId: JSON.stringify(serviceId).replace(/[\[\]""]/g, ''),
        }
      }).then(function (response) {
        return response.data.servicePointInformationResponse.servicePoints.map(formatServicePoint);
      });
    }

    function getServicePointByAddress(address, serviceId) {
      return getServicePointsByAddress(address, serviceId)
        .then(function (servicePoints) {
          return servicePoints[0];
        });
    }

    function formatOpeningHours(openingHours) {
      var week = [
        { name: 'monday', hours: [] },
        { name: 'tuesday', hours: [] },
        { name: 'wednesday', hours: [] },
        { name: 'thursday', hours: [] },
        { name: 'friday', hours: [] },
        { name: 'saturday', hours: [] },
        { name: 'sunday', hours: [] }
      ];

      _.each(openingHours, function (d) {
        var day = _.findWhere(week, {name: d.openDay.toLowerCase()});
        day.hours.push({
          from: d.openTime,
          to: d.closeTime,
          string: d.openTime + ' - ' + d.closeTime
        })
      });

      week = _.groupBy(week, function(day) {
        return _.pluck(day.hours, 'string').join(', ') || 'closed';
      });

      return week;
    }

    function formatDropOffTimes({ products }) {
      if (!products || !products.find(p => p.name === 'Parcel' || p.name === 'All products')) {
        return {};
      }

      const { timeSlots } = products.find(p => p.name === 'Parcel' || p.name === 'All products');

      if (!timeSlots || timeSlots.length === 0 || !timeSlots[0].guaranteedDropOffTime) {
        return {};
      }

      return _.chain(timeSlots[0].guaranteedDropOffTime)
        .map(function ({ day, latestTime }) {
          return {
            name: day,
            latestTime
          }
        })
        .groupBy('latestTime')
        .value();
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('ResponsiveUtils', ResponsiveUtils);

    ResponsiveUtils.$inject = ['$window'];

    /* @ngInject */
    function ResponsiveUtils($window) {
        var service = {
            getScreenSizeString: getScreenSizeString,
            isXXSmall: isXXSmall,
            isXSmall: isXSmall,
            isSmall: isSmall,
            isMedium: isMedium,
            isXSmallOrSmaller: isXSmallOrSmaller,
            isSmallOrSmaller: isSmallOrSmaller,
            isMediumOrSmaller: isMediumOrSmaller
        };

        var XXSMALL = 320;
        var XSMALL = 480;
        var SMALL = 768;
        var MEDIUM = 992;

        return service;

        function isXXSmall() {
            return getScreenSizeString() === 'xxsmall';
        }

        function isXSmall() {
            return getScreenSizeString() === 'xsmall';
        }

        function isXSmallOrSmaller() {
            return $window.innerWidth <= XSMALL;
        }

        function isSmall() {
            return getScreenSizeString() === 'small';
        }

        function isSmallOrSmaller() {
            return $window.innerWidth <= SMALL;
        }

        function isMedium() {
            return getScreenSizeString() === 'medium';
        }

        function isMediumOrSmaller() {
            return $window.innerWidth <= MEDIUM;
        }

        function getScreenSizeString() {
            var width = $window.innerWidth;
            var string = 'large';

            if (width <= XXSMALL) {
                string = 'xxsmall';
            } else if (width > XXSMALL && width <= XSMALL) {
                string = 'xsmall';
            } else if (width > XSMALL && width <= SMALL) {
                string = 'small';
            } else if (width > SMALL && width <= MEDIUM) {
                string = 'medium';
            }

            return string;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('responsiveColspan', responsiveColspan);

    /* @ngInject */
    function responsiveColspan($window) {
        var directive = {
            restrict: 'A',
            scope: {
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            var defaultColspan = attr.colspan || 1;

            setColspan();

            function setColspan() {
                if ($window.innerWidth <= 768) {
                    el.attr('colspan', attr.responsiveColspan);
                } else {
                    el.attr('colspan', defaultColspan);
                }
            }

            function cleanUp() {
                angular.element($window).off('resize', setColspan);
            }

            angular.element($window).on('resize', setColspan);
            scope.$on('$destroy', cleanUp);
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('PrintingFactory', PrintingFactory)

    PrintingFactory.$inject = ['$http', '$sessionStorage'];

    function PrintingFactory($http, $sessionStorage) {
        var service = {
            checkWaybillAvailability: checkWaybillAvailability,
            printReceipt: printReceipt,
            printWaybill: printWaybill
        };

        return service;

        function checkWaybillAvailability(cartId) {
            return $http.get(OnlineShippingTool.env.fetchDocumentUrl + '?bookingId=' + cartId);
        }

        function canShowPrintDialog() {
            var ua = window.navigator.userAgent;

            // Chrome: Show print dialog by printing hidden iframe
            // Others: Open document directly since browser most likely wont allow printing hidden iframe

            return ua.indexOf("Chrome/") != -1 && ua.indexOf("Edge/") == -1 && ua.indexOf("Android") == -1;
        }

        function printWaybill(bookingId) {
            if (canShowPrintDialog()) {
                document.getElementById("printFrame").src = OnlineShippingTool.env.fetchPrintPageUrl +
                    "?bookingId=" + (bookingId || $sessionStorage.bookingId);
            } else {
                window.open(OnlineShippingTool.env.fetchDocumentUrl +
                    "?bookingId=" + (bookingId || $sessionStorage.bookingId));
            }
        }

        function printReceipt(bookingId) {
            if (canShowPrintDialog()) {
                document.getElementById("printFrame").src = OnlineShippingTool.env.fetchReceiptPrintPage +
                    "?bookingId=" + (bookingId || $sessionStorage.bookingId);
            } else {
                window.open(OnlineShippingTool.env.fetchReceiptHtmlUrl +
                    "?bookingId=" + (bookingId || $sessionStorage.bookingId));
            }
        }
    }
})();

(function() {
'use strict';

    angular
        .module('onlineShippingTool')
        .filter('printFollowingDays', printFollowingDays);

    function printFollowingDays($filter) {
        return printFollowingDaysFilter;

        ////////////////

        function printFollowingDaysFilter(days) {

            var followingDays = [];

            for (var i = 0; i < days.length; i++) {
                var day = days[i];

                var followingDaysArray = findArrayWithPreviousDaysForDay(followingDays, day);

                if(followingDaysArray !== undefined) {
                    followingDaysArray.push(day);
                } else {
                    followingDays.push([day]);
                }
            }

            var res = _.map(followingDays, function(dayArray) {
                var dayString = $filter('translate')(_.first(dayArray).name.toUpperCase());
                dayString += (dayArray.length > 1)
                    ? ' - ' + $filter('translate')(_.last(dayArray).name.toUpperCase())
                    : '';
                return dayString;
            }).join(', ');

            return res;
        }

        function findArrayWithPreviousDaysForDay(followingDays, day) {
            return _.find(followingDays, function(array) {
                return _.find(array, function(d) {

                   return moment(d.name, 'dddd', 'en').day() === (((moment(day.name, 'dddd', 'en').day() -1) +7) %7);
                })
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('price', price);

    function price($filter) {
        return priceFilter

        function priceFilter(input, forceZeros) {
            if(!_.isNumber(input)) return;

            // prices are integers to avoid float rounding errors, divide by 100 for presentation.
            input /= 100;

            if ((input + '').indexOf('.') !== -1 || !!forceZeros) {
                return $filter('number')(input, 2);
            } else {
                return $filter('number')(input, 0);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('prettifyCurrency', prettifyCurrency);

    function prettifyCurrency() {
        return prettifyCurrencyFilter

        function prettifyCurrencyFilter(input) {
            var res;

            switch (input) {
                case 'SEK':
                    res = 'kr'
                    break;
                default:
                    res = input;
            }

            return res;
        }
    }
})();

(function(){
    'use strict';
    angular
    .module('onlineShippingTool')
    .factory('PreloadFactory', PreloadFactory)
    PreloadFactory.$inject = ['$q', '$rootScope'];
    function PreloadFactory($q, $rootScope) {
        function Preloader( imageLocations ) {
            this.imageLocations = imageLocations;
            this.imageCount = this.imageLocations.length;
            this.loadCount = 0;
            this.errorCount = 0;
            this.states = {PENDING: 1, LOADING: 2, RESOLVED: 3, REJECTED: 4};
            this.state = this.states.PENDING;
            this.deferred = $q.defer();
            this.promise = this.deferred.promise;
        }
        Preloader.preloadImages = function( imageLocations ) {
            var preloader = new Preloader( imageLocations );
            return( preloader.load() );
        };
        Preloader.prototype = {
            constructor: Preloader,
            isInitiated: function isInitiated() {
                return( this.state !== this.states.PENDING );
            },
            isRejected: function isRejected() {
                return( this.state === this.states.REJECTED );
            },
            isResolved: function isResolved() {
                return( this.state === this.states.RESOLVED );
            },
            load: function load() {
                if ( this.isInitiated() ) {
                    return( this.promise );
                }
                this.state = this.states.LOADING;
                for ( var i = 0 ; i < this.imageCount ; i++ ) {
                    this.loadImageLocation( this.imageLocations[ i ] );
                }
                return( this.promise );
            },
            handleImageError: function handleImageError( imageLocation ) {
                this.errorCount++;
                if ( this.isRejected() ) {
                    return;
                }
                this.state = this.states.REJECTED;
                this.deferred.reject( imageLocation );
            },
            handleImageLoad: function handleImageLoad( imageLocation ) {
                this.loadCount++;
                if ( this.isRejected() ) {
                    return;
                }
                this.deferred.notify({
                    percent: Math.ceil( this.loadCount / this.imageCount * 100 ),
                    imageLocation: imageLocation
                });
                if ( this.loadCount === this.imageCount ) {
                    this.state = this.states.RESOLVED;
                    this.deferred.resolve( this.imageLocations );
                }
            },
            loadImageLocation: function loadImageLocation( imageLocation ) {
                var preloader = this;
                var image = new Image();
                image.onload = function (event) {
                    $rootScope.$apply(function () {
                        preloader.handleImageLoad(event.target.src);
                        preloader = image = event = null;
                    });
                };
                image.onerror = function (event) {
                    $rootScope.$apply(function () {
                        preloader.handleImageError(event.target.src);
                        preloader = image = event = null;
                    });
                };
                image.src = imageLocation;
            }
        };
        return Preloader;
    }
})();
(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('portocode', portocode)

    function portocode(){

        return portocodeFilter;

        function portocodeFilter(input){
            var first = input.slice(0,4);
            var second = input.slice(4,8);
            var third = input.slice(8,12);
            input = first + '\n' + second + '\n' + third;
            return input
        }
    }

}());
(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('ParcelTypes', ParcelTypes);

    ParcelTypes.$inject = ['$http', '$log', '$translate', '$q', 'FeatureToggleFactory'];

    /* @ngInject */
    function ParcelTypes($http, $log, $translate, $q, FeatureToggleFactory) {
        var service = {
            get: get
        };

        return service;

        function get(fromCountry, toCountry, language) {
            var from = fromCountry;
            var to = toCountry ? toCountry : "SE";
            var lang = language || "sv";

            var params = "?fromCountry=" + from + "&toCountry=" + to + "&language=" + lang;

            return $http.get(OnlineShippingTool.env.productsUrl + params).then(function (response) {
                var parcelTypes = filterFeatureToggledProducts(response.data.products, from, to);

                setTraceability(parcelTypes);
                $log.debug('ParcelTypes : get : response', parcelTypes);

               

                return parcelTypes;
            });
        }

        function isOldValuable(product) {
            return product.type === 'valuables' && (!product.group || product.group.type !== 'valuables');
        }

        function isNewValuable(product) {
            return product.group && product.group.type === 'valuables';
        }

        function filterFeatureToggledProducts(products, from, to) {
            return _.chain(products)
                .filter(isDanishValuablesEnabled)
                .filter(function (product) {
                    return product.type !== 'letter'
                        || from !== 'SE'
                        || FeatureToggleFactory.isFeatureEnabled('portokoder')
                        || (!FeatureToggleFactory.isFeatureEnabled('portokoder') && to !== 'SE');
                })
                .value();
        }

        function isDanishValuablesEnabled(product) {
            return product.validFrom !== 'DK' || product.type !== 'valuables' || FeatureToggleFactory.isFeatureEnabled('danishValuables');
        }

        function setTraceability(parcelTypes) {
            _.each(parcelTypes, function (type) {
                type.isTraceableByAdditionalServices = _.some(type.additionalServices, function (service) {
                    return typeof (service.nonTraceable) !== 'undefined' && !service.nonTraceable;
                });
                type.isNonTraceableByAdditionalServices = _.some(type.additionalServices, function (service) {
                    return typeof (service.nonTraceable) !== 'undefined' && !!service.nonTraceable;
                });
            });
        }
    }
})();

(function(){
    'use strict';

    angular
    .module('onlineShippingTool')
    .factory('OrderHistoryFactory', OrderHistoryFactory)

    OrderHistoryFactory.$inject = ['$http', '$log', '$q', '$state'];

    function OrderHistoryFactory($http, $log, $q, $state) {
        var service = {
            getOrderHistory: getOrderHistory,
            getOrderStatusesForMonth: getOrderStatusesForMonth,
            getConsignmentInfo: getConsignmentInfo
        };

        return service;

        function getOrderHistory(month) {
            month = _.contains(['last3days', 'last5days', 'last10days'], month) ? month : moment(month).format('YYYY-MM');

            return $http.get(OnlineShippingTool.env.cartsHistoryUrl + '/history/list/' + month + '?clientId=ST')
                .then(function (response) {
                    var orderHistory = response.data;
                    return orderHistory.message ? [] : orderHistory.consignments || orderHistory;
                });
        }

        function getOrderStatusesForMonth(month) {
            month = _.contains(['last3days', 'last5days', 'last10days'], month) ? month : moment(month).format('YYYY-MM');

            return $http.get(OnlineShippingTool.env.cartsHistoryUrl + '/status/' + month + '?clientId=ST')
                .then(function(response) {
                    return response.data.consignments;
                });
        }

        function getConsignmentInfo(cartId, itemId) {
            return $http.get(OnlineShippingTool.env.cartsHistoryUrl + '/history/single/' + cartId + '/' + itemId)
                .then(function (response) {
                    $log.debug('OrderHistoryFactory : getConsignmentInfo : response.data', response.data);
                    return response.data;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('onlyVisibleGroupings', onlyVisibleGroupings);

    function onlyVisibleGroupings() {
        return onlyVisibleGroupingsFilter

        function onlyVisibleGroupingsFilter(additionalServices) {
            return _.filter(additionalServices, function (service) {
                return !service.grouping || !service.hidden;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('nonRollService', nonRollService);

    function nonRollService() {
        return nonRollServiceFilter

        function nonRollServiceFilter(services, isRoll) {
            return !isRoll ? services : _.filter(services, function (service) {
                return ['Till-brevlada', 'Utkörning-till-företag', 'Utkörning-till-företag-09', 'Utkörning-till-företag-12'].indexOf(service.additionalServiceId) === -1;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('moment', momentFunc);

    function momentFunc() {
        momentFilter.$stateful = true;

        return momentFilter;

        function momentFilter(date, format) {
            if (!date) return;

            return moment(date).format(format);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('LocaleFactory', LocaleFactory);

    LocaleFactory.$inject = ['$translate'];

    /* @ngInject */
    function LocaleFactory($translate) {
        var service = {
            getLocale: getLocale,
            
        };

        return service;

        function getLocale() {
            var locale_ = $translate.use();
            if(locale_ === 'da') {
                locale_ = 'da_DK'
            } else if(locale_ === 'sv'){
                locale_ = 'sv_SE'
            } else {
                locale_ = 'en_GB'
            }
            return locale_;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('LocalCartFactory', LocalCartFactory);

    LocalCartFactory.$inject = ['$sessionStorage'];

    /* @ngInject */
    function LocalCartFactory($sessionStorage) {
        var service = {
            addProduct: addProduct,
            removeProduct: removeProduct,
            getCurrentLocalCartId: getCurrentLocalCartId,
            updateProduct: updateProduct,
            emptyCart: emptyCart
        };

        return service;

        function addProduct(product) {
            $sessionStorage.cart = _.isArray($sessionStorage.cart) ? $sessionStorage.cart : [];
            $sessionStorage.cart.push(product);
        }

        function removeProduct(product) {
            $sessionStorage.cart = _.without($sessionStorage.cart, product);
        }

        function updateProduct(product) {
            var index = _.findIndex($sessionStorage.cart, function(item) {
                return item.itemId === product.itemId;
            });
            $sessionStorage.cart.splice(index,1,product);
        }

        function getCurrentLocalCartId() {
            return ($sessionStorage.cart && $sessionStorage.cart[0] && $sessionStorage.cart[0].cartId) || null;
        }

        function emptyCart() {
            $sessionStorage.cart = [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .directive('isMobileNumber', isMobileNumber);

    /* @ngInject */
    function isMobileNumber($parse) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            ctrl.$parsers.unshift(function (value) {
                var valid = checkNumber(value);
                ctrl.$setValidity('isMobileNumber', valid);
                return valid ? value : undefined;
            });

            ctrl.$formatters.unshift(function (value) {
                var valid = checkNumber(value);
                ctrl.$setValidity('isMobileNumber', valid);
                return value;
            });

            function checkNumber(value) {
                var countryCode = $parse(attr.countryCode)(scope);
                var valid;
                if(value) {
                  value = value.split(' ').join('');
                }

                if(countryCode === 'SE' || countryCode === 'DK' || countryCode === 'NO' || countryCode === 'FI') {
                  try {
                    valid = (phoneUtils.getNumberType(value, countryCode) === 'MOBILE' || phoneUtils.getNumberType(value, countryCode) === 'FIXED_LINE_OR_MOBILE')
                        && phoneUtils.isValidNumber(value, countryCode);
                  } catch (e) {
                      valid = !value;
                  }
                } else {
                  try {
                    valid = phoneUtils.isPossibleNumber(value, countryCode);
                  } catch (e) {
                      valid = !value;
                  }
                }
                return valid;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('imagePath', imagePath);

    function imagePath() {
        return imagePathFilter

        function imagePathFilter(input) {
            if (!input) return;

            var localPath = 'assets/images/';

            return localPath + input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .filter('formatMaxDimensions', formatMaxDimensions);

    function formatMaxDimensions() {
        return formatMaxDimensionsFilter

        function formatMaxDimensionsFilter(input) {
            if (!input) return;

            return _.compact(_.pluck(input, 'max')).join(' × ');
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool')
      .filter('flagPath', flagPath);

  function flagPath() {
      return flagPathFilter

      function flagPathFilter(input) {
          if (!input) return;

          var localPath = 'assets/images/flags/';

          return localPath + input.slice(0,2) + '.svg';
      }
  }
})();
(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('FeatureToggleFactory', FeatureToggleFactory);

    FeatureToggleFactory.$inject = ['$localStorage', 'Common'];

    /* @ngInject */
    function FeatureToggleFactory($localStorage, Common) {
        var service = {
            isFeatureEnabled: isFeatureEnabled,
            toggleFeature: toggleFeature,
            getFeatures: getFeatures,
        };

        return service;

        function isFeatureEnabled(feature, market) {
            var featureEnabled = !!_.get($localStorage.enabledFeatures, feature);
            var marketEnabled = (market && Common.getMarket() === market) || typeof market === 'undefined';
            return marketEnabled && featureEnabled;
        }

        function toggleFeature(feature, value) {
            $localStorage.enabledFeatures[feature] = value;
        }

        function getFeatures() {
            $localStorage.enabledFeatures = $localStorage.enabledFeatures || {};
            var features = [
                { name: 'qrCode', title: 'SE: Qr code in receipt view'},
                { name: 'qrCodeDK', title: 'DK: Qr code in receipt view'},
                { name: 'portalMenu', title: 'Portal menu'},
                { name: 'swish', title: 'Swish' },
                { name: 'applePay', title: 'Apple Pay' },
                { name: 'googlePay', title: 'Google Pay' },
                { name: 'danishREK', title: 'Danish: REK' },
                { name: 'danishInternational', title: 'Danish: International Products' },
                { name: 'danishLoggedIn', title: 'Danish: Logged In Mode' },
                { name: 'danishValuables', title: 'Danish: Værdiforsendelser' },
                { name: 'danishPortoCodeImageUpload', title: 'Danish: PortoCode image upload' },
                { name: 'danishMobilePay', title: 'Danish: MobilePay' },
                { name: 'danishNewValuables', title: 'Danish: New Valuables' },
                { name: 'extraInternationalRecipientAddressFields', title: 'International: Extra address fields for recipients'},
                { name: 'swedishCustoms', title: 'Swedish Customs Declaration' },
                { name: 'danishNewCustoms', title: 'Danish Updated Customs Declaration' },
                { name: 'sePaymentSystemVersion2', title: 'SE payment system version 2' },
                { name: 'dkPaymentSystemVersion2', title: 'DK payment system version 2' },
                { name: 'portokoder', title: 'Portokoder' },
                { name: 'betaBanner', title: 'Base 2.0 beta banner' },
            ];

            features = _.map(features, function (feature) {
                return {
                    name: feature.name,
                    title: feature.title,
                    value: $localStorage.enabledFeatures[feature.name]
                };
            });

            return features;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('CountryFactory', CountryFactory)

    CountryFactory.$inject = ['$http', '$q', '$translate'];

    function CountryFactory($http, $q, $translate) {
        var service = {
            getCountries: getCountries,
            getCustomsCountries: getCustomsCountries,
        };

        var current = {};

        return service;

        function getCountries(language, fromCountry) {
            var lang = language || "sv";
            fromCountry = fromCountry || 'SE';

            var params = "?language=" + lang + '&fromCountry=' + fromCountry;

            return (lang === current.language && fromCountry === current.fromCountry) ?
                $q.when(current.countries) :
                $http.get(OnlineShippingTool.env.countriesUrl + params).then(function (response) {
                    var countries = _.get(response, 'data.countries');

                    current = {
                        language: lang,
                        fromCountry: fromCountry,
                        countries: countries
                    };

                    return countries;
                });
        }

        function getCustomsCountries() {
            var lang = $translate.use();
            var params = "?language=" + lang;

            return $http.get(OnlineShippingTool.env.customsCountriesUrl + params).then(function (response) {
                    return _.get(response, 'data.countries');
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('Common', Common);

    /* @ngInject */
    function Common($log, $window, appOptions) {
        var service = {
            getMarket: getMarket,
            getSupportedLanguagesForCountry: getSupportedLanguagesForCountry,
            calculateMorphTotalPrice: calculateMorphTotalPrice,
            getPriceForParcel: getPriceForParcel,
            getTotalPriceForParcels: getTotalPriceForParcels,
            getVatPriceForParcel: getVatPriceForParcel,
            getTotalVatPriceForParcels: getTotalVatPriceForParcels,
            groupSimilarParcels: groupSimilarParcels,
            getDocumentsForParcel: getDocumentsForParcel,
            getDocumentsForParcels: getDocumentsForParcels,
            getRequiredCustomsDeclarationType: getRequiredCustomsDeclarationType,
            getProductCapabilities: getProductCapabilities,
            calculatePriceForProduct: calculatePriceForProduct,
        };

        return service;

        ////////////////

        function getMarket() {
            var isSE = $window.location.href.indexOf('skickadirekt') !== -1;
            var isDK = $window.location.href.indexOf('onlineporto') !== -1;
            return isSE ? 'SE' : (isDK ? 'DK' : OnlineShippingTool.env.defaultCountry);
        }

        function getSupportedLanguagesForCountry(country) {
            var supportedLanguages;

            if (country === 'SE') {
                supportedLanguages = [
                    { key: "sv", name: "Svenska" },
                    { key: "en", name: "English" }
                ];
            } else if (country === 'DK') {
                supportedLanguages = [
                    { key: "da", name: "Dansk" },
                    { key: "en", name: "English" }
                ];
            }

            return supportedLanguages;
        }

        function getPriceForParcel(parcel) {
            if (!parcel) return;
            var prices = calculatePriceForProduct(parcel);
            var quantity = parcel.quantity || 1;
            return quantity * prices.totalPrice;
        }

        function getTotalPriceForParcels(parcels) {
            return _.reduce(parcels, function(sum, parcel) {
                return sum + getPriceForParcel(parcel)
            }, 0)
        }

        function getVatPriceForParcel(parcel) {
            if (!parcel) return;
            var prices = calculatePriceForProduct(parcel);
            var quantity = parcel.quantity || 1;
            return quantity * prices.totalPriceWithVAT;
        }

        function addVAT(price, vat) {
            return price * ((vat/10000) + 1);
        }

        function calculatePriceForProduct(product) {
            if (!product) return;
            var baseInfo = {
                baseVAT: product.vat,
                basePrice: product.price,
                basePriceWithVAT: addVAT(product.price, product.vat),
                totalPrice: 0,
                totalPriceWithVAT: 0,
            };
            _.each(product.additionalServices, function (additionalService) {
                if (additionalService.selected) {
                    if (additionalService.baseProductId) {
                        if (additionalService.vat >= baseInfo.baseVAT) {
                            baseInfo.baseVAT = additionalService.vat;
                        }
                        baseInfo.basePrice += additionalService.price;
                    }
                    if (!additionalService.baseProductId && !additionalService.ttxCode) {
                        baseInfo.basePrice += additionalService.price;
                    }
                }
            });

            baseInfo.totalPrice += baseInfo.basePrice;
            baseInfo.totalPriceWithVAT += addVAT(baseInfo.basePrice, baseInfo.baseVAT);

            if (product.additionalServices) {
              product.additionalServices.forEach(function(additionalService) {
                // Only include additional services that has ttxCode an no baseProductId
                if (additionalService.ttxCode && !additionalService.baseProductId && additionalService.selected) {
                  baseInfo.totalPrice += additionalService.price;
                  baseInfo.totalPriceWithVAT += addVAT(additionalService.price, additionalService.vat);
                }
              });
            }

            return baseInfo;
        }

        function getTotalVatPriceForParcels(parcels) {
            return _.reduce(parcels, function(sum, parcel) {
                return sum + getVatPriceForParcel(parcel)
            }, 0)
        }

        function groupSimilarParcels(parcels) {
            return _.chain(parcels)
                .groupBy(function (parcel) {
                    var selectedAdditionalServices = _.filter(parcel.additionalServices, {selected: true});
                    var name = parcel.name;
                    name += (selectedAdditionalServices.length > 0) ? ' | ' + _.pluck(selectedAdditionalServices, 'name') : '';
                    return name;
                })
                .map(function (parcels) {
                    var selectedAdditionalServices = _.filter(parcels[0].additionalServices, {selected: true});

                    return {
                        name: parcels[0].name,
                        parcels: parcels,
                        totalPrice: getTotalPriceForParcels(parcels),
                        additionalServiceNames: _.pluck(selectedAdditionalServices, 'name')
                    }
                })
                .value();
        }

        function calculateMorphTotalPrice(parcel, service) {
            if (!service || !parcel) return;

            var morphPrice;

            if(service.baseProductId) {
                var weightChoice = _.find(parcel.additionalServices, function (_service) {
                    return _service.selected && _.get(_service, 'multipleChoiceAddOn.name') === 'weightChoice';
                });
                var weightChoicePrice = weightChoice ? weightChoice.price : 0;
                if(service.vat <= parcel.vat) {
                    morphPrice = Math.round((parcel.price + service.price + weightChoicePrice) * (1 + (service.vat / 10000))) - (parcel.price * (1 + (parcel.vat / 10000))) - (weightChoicePrice * (1 + (parcel.vat / 10000)));
                } else {
                    morphPrice = Math.round((parcel.price + service.price + weightChoicePrice) * (1 + (service.vat / 10000))) - parcel.price - weightChoicePrice;
                }
            } else {
                morphPrice = Math.round((service.price * (1 + (service.vat / 10000))));

            }
            return morphPrice;
        }

        function getDocumentsForParcel(parcel) {
            var additionalServiceDocuments = _.get(_.find(parcel.additionalServices, function(service) {
                return (service.selected || (service.included && !service.override)) && service.documents;
            }), 'documents');
            return additionalServiceDocuments || _.get(parcel, 'documents');
        }

        function getDocumentsForParcels(parcels) {
            return _.chain(parcels)
                .map(getDocumentsForParcel)
                .flatten()
                .uniq('name')
                .compact()
                .value();
        }

        function getRequiredCustomsDeclarationType(product) {
            var documents = getDocumentsForParcel(product);
            return _.chain(documents)
                .find({type: 'customsLabel'})
                .get('name')
                .value();
        }

        function getProductCapabilities(product) {
            var productCapabilities = angular.copy(product.productCapabilities);

            _.each(product.additionalServices, function (service) {
                if (service.selected && service.productCapabilities) {
                    _.extend(productCapabilities, service.productCapabilities);
                }
            });

            return productCapabilities;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('CartFactory', CartFactory);

    CartFactory.$inject = ['$http', '$log', '$q', '$sessionStorage', '$translate', 'appOptions', 'CountryFactory', 'NCP_PUBLIC_KEY'];

    /* @ngInject */
    function CartFactory($http, $log, $q, $sessionStorage, $translate, appOptions, CountryFactory, NCP_PUBLIC_KEY) {
        var service = {
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            updateInvoiceInfo: updateInvoiceInfo,
            getCart: getCart
        };

        return service;

        function addProduct(product) {
            product.quantity = product.quantity || 1;

            return $http.post(OnlineShippingTool.env.cartsUrl + '/items/ST', product).then(function (response) {
                $log.debug('CartFactory : addProduct : response', response);
                return response.data;
            }, function (errorResponse) {
                $log.debug('CartFactory : addProduct : errorResponse', errorResponse);
                return $q.reject(errorResponse);
            });
        }

        function updateProduct(product) {
            return $http.put(OnlineShippingTool.env.cartsUrl + '/' + product.cartId + '/items/' + product.itemId, product);
        }

        function removeProduct(product) {
            return $http.delete(OnlineShippingTool.env.cartsUrl + '/' + product.cartId + '/items/' + product.itemId);
        }

        function updateInvoiceInfo(cartId, invoiceInfo) {
            $log.debug('CartFactory : updateInvoiceInfo : invoiceInfo', invoiceInfo);
            return $http.patch(OnlineShippingTool.env.cartsUrl + '/' + cartId + '/invoiceInfo', invoiceInfo);
        }

        function getCart(cartId) {
            return $http.get(OnlineShippingTool.env.publicCartsUrl + '/' + cartId, {
                headers: {
                    Authorization: NCP_PUBLIC_KEY
                }
            }).then(function (response) {
                return getCountries().then(function (countries) {
                    var items = _.get(response, 'data.items');

                    return _.map(items, function (item) {
                        var res = item.content;
                        var toCountryCode = _.get(res, 'receiver.address.countryCode');
                        res.itemId = item.itemId;
                        res.cartId = item.cartId;
                        res.toCountry = _.find(countries, {countryCode: toCountryCode});
                        return res;
                    });
                });
            });
        }

        function getCountries() {
            var language = $translate.proposedLanguage() || $translate.use();
            var fromCountry = appOptions.country;

            return CountryFactory.getCountries(language, fromCountry);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('onlineShippingTool')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        ////////////////
        
        function capitalizeFilter(input) {
            if(!input) return;
            return input.substring(0,1).toUpperCase()+input.substring(1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('AdditionalServiceHelper', AdditionalServiceHelper);

    AdditionalServiceHelper.$inject = [];

    /* @ngInject */
    function AdditionalServiceHelper() {
        var service = {
            isCompanyExpressService: isCompanyExpressService,
            isEveningHomeDeliveryService: isEveningHomeDeliveryService,
            isExpressDeliveryService: isExpressDeliveryService,
            isCashOnDeliveryService: isCashOnDeliveryService,
            isResponsibilityService: isResponsibilityService,
            getSelectedBaseProductIdForAdditionalServices: getSelectedBaseProductIdForAdditionalServices,
            hasSelectedAdditionalServiceId: hasSelectedAdditionalServiceId,
            getSelectedAdditionalServiceIds: getSelectedAdditionalServiceIds,
        };

        return service;

        function isCompanyExpressService(service) {
            return ['Utkörning-till-företag-09', 'Utkörning-till-företag-12'].indexOf(service.additionalServiceId) !== -1;
        }

        function isEveningHomeDeliveryService(service) {
            return ['2006741'].indexOf(service.additionalServiceId) !== -1;
        }

        function isExpressDeliveryService(service) {
            return ['Express_bas_company', 'Express_bas', '2003744', 'Expresspaket'].indexOf(service.additionalServiceId) !== -1;
        }

        function isCashOnDeliveryService(service) {
            return ['Postforskott_bas', '1001042', '2000695'].indexOf(service.additionalServiceId) !== -1;
        }

        function isResponsibilityService(service) {
            return ['2006850'].indexOf(service.additionalServiceId) !== -1;
        }

        function hasSelectedAdditionalServiceId(additionalServices, service) {
            return getSelectedAdditionalServiceIds(additionalServices).indexOf(service) >= 0;
        }

        function getSelectedBaseProductIdForAdditionalServices(services, product = {}) {
            if (!product || !services) return;
            return _.chain(services)
                .find(function (service) {
                    return service.selected && service.baseProductId;
                })
                .get('baseProductId')
                .value() || product.baseProductId || 'standardBase';
        }

        function getSelectedAdditionalServiceIds(additionalServices) {
            return _.chain(additionalServices)
                .filter({ selected: true })
                .map('additionalServiceId')
                .value();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.receipt')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.receipt', {
          url: '/receipt?transactionId&printableAtServicePoint',
          templateUrl: 'components/receipt/receipt.html',
          controller: 'ReceiptController',
          controllerAs: 'receipt'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.receipt')
        .controller('ReceiptController', ReceiptController);

    ReceiptController.$inject = ['$state', '$rootScope','$scope', '$log', '$localStorage', '$sessionStorage', 'Common', 'Topbar', '$stateParams', 'PrintingFactory', 'UserFactory'];

    /* @ngInject */
    function ReceiptController($state, $rootScope, $scope, $log, $localStorage, $sessionStorage, Common, Topbar, $stateParams, PrintingFactory, UserFactory) {
        var vm = this;
      
        vm.senderEmail = $localStorage.senderEmail || _.get($localStorage.sender, 'email');
        vm.printWaybill = PrintingFactory.printWaybill;
        vm.printReceipt = PrintingFactory.printReceipt;
        vm.cart = $sessionStorage.cart;
        vm.hasDigitalAgent = !!$sessionStorage.digitalAgent;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.getTotalPriceForParcels = Common.getTotalPriceForParcels;
        vm.getTotalVatPriceForParcels = Common.getTotalVatPriceForParcels;
        vm.transactionId = $stateParams.transactionId;
        vm.loggedIn = UserFactory.isLoggedIn();
        vm.goTo = goTo;


        if(vm.cart == undefined && $sessionStorage.lastPurchase != undefined) {
            vm.sender = $sessionStorage.lastPurchase[0].sender;
        } else {
            vm.sender = vm.cart[0].sender;
        }

        activate();

        function activate() {
            
            if($sessionStorage.cart != undefined) {
                $sessionStorage.lastPurchase = $sessionStorage.cart;
                 $sessionStorage.bookingId = $sessionStorage.cart[0].cartId;
                 delete $sessionStorage.cart;
                $rootScope.$broadcast('main:reloadCart');

            } else {
                vm.cart = $sessionStorage.lastPurchase;

            }
             Topbar.clearCart();
            // Save the cart id as booking id and delete the client side cart
            vm.showCustomsBox = _.some(vm.cart, function(item){
                return (item.customsLabels)
            })
            vm.customsLabels = Common.getDocumentsForParcels(vm.cart);
            
        }

        function goTo(statePath) {
            $state.go(statePath);
        }

        $scope.$on('$destroy', function() {
            $rootScope.$broadcast('main:receiptDestroyed')
            delete $sessionStorage.digitalAgent;
        });
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.payment')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.payment-redirect', {
          url: '/payment-redirect?cartId&transactionId&responseCode&paymentMethod&redirectResult',
          templateUrl: 'components/payment/payment-redirect.html',
          controller: 'PaymentRedirectController',
          controllerAs: 'paymentRedirect'
      })
      .state('main.payment', {
          // If transactionId and responseCode have values, this call is a redirect back
          // from the Nets Terminal
          url: '/payment?responseCode&referralId&agentId&returnUrl&iconUrl&agentName',
          templateUrl: 'components/payment/payment.html',
          controller: 'PaymentController',
          controllerAs: 'payment'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .factory('PaymentFactory', PaymentFactory);

    /* @ngInject */
    function PaymentFactory($http, $log, $q, $timeout, NCP_PUBLIC_KEY, $sessionStorage, FeatureToggleFactory) {
        var service = {
            getPaymentMethods: getPaymentMethods,
            initTransaction: initTransaction,
            verifyTransaction: verifyTransaction,
            bookCart: bookCart,
            getReferralCart: getReferralCart,
            setDigitalAgent: setDigitalAgent,
            cancelBookCartTimeout: cancelBookCartTimeout
        };

        var timeout;

        return service;

        function getUrl(type) {
            var prop = type;
            if (isPaymentSystemVersion2()) {
                prop += 'V2'
            }

            return OnlineShippingTool.env[prop];
        }

        function getPaymentMethods(country) {
            var url = getUrl('paymentMethodsUrl').replace('{countryCode}', country);
            var methodsParam = isPaymentSystemVersion2() ? 'methods' : 'availablePaymentMethods';

            return $http.get(url)
                .then(function (response) {
                    $log.debug('PaymentFactory : getPaymentMethods : response', response);
                    const methods = _.get(response, 'data.' + methodsParam);
                    return filterUnavailablePaymentMethods(methods);
                });
        }

        function initTransaction(cartId, params) {
            var url = getUrl('initializePaymentUrl').replace('{cartId}', cartId);

            return $http.post(url, params)
                .then(function(response) {
                    $log.debug(response);
                    var terminalUrl = _.get(response, 'data.terminalUrl');
                    var transactionId = _.get(response, 'data.paymentId') || _.get(response, 'data.paymentOrderId');
                    var threeDSData = _.get(response, 'data.threeDSData');
                    $log.debug('Transaction registered, terminal url = ', terminalUrl);
                    return { ok: true, terminalUrl: terminalUrl, transactionId: transactionId, threeDSData };
                }, function(error) {
                    $log.debug('Register transaction failed');
                    $log.debug(error);
                    return { ok: false, response: error };
                });
        }

        function verifyTransaction(cartId, redirectResult) {
            var url = OnlineShippingTool.env.verifyPaymentUrl.replace('{cartId}', cartId);

            return $http.post(url, { threeDSResultDetails: { redirectResult } })
                .then(function(response) {
                    const paymentStatus = _.get(response, 'data.paymentStatus');
                    const isPaid = paymentStatus === 'PAID';
                    return { ok: isPaid, paymentStatus };
                }, function(error) {
                    $log.debug('Verify transaction failed', error);
                    return { ok: false, response: error };
                });
        }

        function bookCart(cartId) {
            return $q(function (resolve, reject) {
                $http.post(OnlineShippingTool.env.bookingUrl, {
                    cartId: cartId
                }, {
                    headers: {
                        'X-API-Version': '2'
                    }
                }).then(function (response) {
                    $log.debug('PaymentFactory : bookCart : response', response);
                    var res = _.get(response, 'data');
                    $log.debug('PaymentFactory : bookCart : res', res);
                    var status = _.get(res, 'status');

                    if (status === 'DONE') {
                        timeout = null;
                        resolve(res)
                    } else if (status === 'WORKING') {
                        timeout = $timeout(function () {
                            resolve(bookCart(cartId));
                        }, 5000);
                    } else {
                        timeout = null;
                        reject(response);
                    }
                }, function (errorResponse) {
                    $log.debug('PaymentFactory : bookCart : errorResponse', errorResponse);
                    // Error status -1 is returned when a network error occurs
                    // If the users is to slow coming back from a Swish payment, this could happen
                    // In this case, we should retry the booking
                    if (errorResponse?.status === -1) {
                        timeout = $timeout(function () {
                            resolve(bookCart(cartId));
                        }, 5000);
                    } else {
                        reject(errorResponse);
                    }
                });
            });
        }

        function getReferralCart(referralId, agentId) {
            return $http.post(OnlineShippingTool.env.referralCartUrl,
                {
                    referralId: referralId,
                    agentId: agentId
                },
                {
                    headers: { Authorization: NCP_PUBLIC_KEY }
                }
            );
        }

        function setDigitalAgent(agent) {
            $sessionStorage.digitalAgent = {
                agentId: agent.agentId,
                referralId: agent.referralId,
                returnUrl: agent.returnUrl,
                iconUrl: agent.iconUrl,
                agentName: agent.agentName
            }
        }

        function isPaymentSystemVersion2() {
            return FeatureToggleFactory.isFeatureEnabled('sePaymentSystemVersion2', 'SE') || FeatureToggleFactory.isFeatureEnabled('dkPaymentSystemVersion2', 'DK');
        }

        function cancelBookCartTimeout() {
            if(timeout) {
                $timeout.cancel(timeout);
                timeout = null;
            }
        }

        function filterUnavailablePaymentMethods(paymentMethods) {
            const methods = [...paymentMethods];
            const applePayIndex = methods.findIndex(method => method.method === 'APPLE-PAY');

            if (applePayIndex !== -1 && !window.ApplePaySession) {
                methods.splice(applePayIndex, 1);
            }

            return methods;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool.payment')
        .controller('PaymentController', PaymentController);

    PaymentController.$inject = ['$anchorScroll', '$log', '$localStorage', '$scope', '$sessionStorage', '$timeout', '$rootScope', '$state', '$http', '$stateParams', '$window', 'NetsTransaction', 'CartFactory', 'Common', 'PaymentFactory', 'Topbar', 'appOptions', 'LocaleFactory', 'FeatureToggleFactory', 'StoredSenderFactory', 'AdditionalServiceHelper'];

    /* @ngInject */
    function PaymentController($anchorScroll, $log, $localStorage, $scope, $sessionStorage, $timeout, $rootScope, $state, $http, $stateParams, $window, NetsTransaction, CartFactory, Common, PaymentFactory, Topbar, appOptions, LocaleFactory, FeatureToggleFactory, StoredSenderFactory, AdditionalServiceHelper) {
        var vm = this;
        vm.adyenGooglePayCheckout;
        vm.hideBuyMore = false;
        vm.next = next;
        vm.isSubmitting = false;
        vm.initiatingTransaction = false;
        vm.backToLanding = backToLanding;


        $scope.$on('main:reloadCart', reloadCart);

        var unbindSenderUpdate = $rootScope.$on('sender:updated', setCart);
        $scope.$on('$destroy', function () {
            unbindSenderUpdate();
        })

        activate();

        function setCart() {
            vm.cart = [];
            if ($stateParams.referralId && $stateParams.agentId) {
                vm.hideBuyMore = true;
                PaymentFactory.setDigitalAgent($stateParams)
                PaymentFactory.getReferralCart($stateParams.referralId, $stateParams.agentId).then(function (response) {
                    $log.debug(response.data)
                    vm.cart = $sessionStorage.cart = _.map(response.data.items, function (item) {
                        item.content['cartId'] = item.cartId;
                        item.content['itemId'] = item.itemId;
                        return item.content;
                    });
                    vm.invoiceInfo = angular.copy(vm.cart[0].sender);
                })
            } else {
                vm.cart = $sessionStorage.cart;
                vm.invoiceInfo = angular.copy(vm.cart[0].sender);
            }
        }

        function activate() {
            setCart();
            clearPreviousStateData();
            getPaymentMethods();
            checkIfOnlyLetters();
            checkIfCartHasLetters();

            Topbar.updateCart();
            handlePaymentResponse($stateParams.responseCode);

            vm.portoCodeImageUploadEnabled = FeatureToggleFactory.isFeatureEnabled('danishPortoCodeImageUpload');
        }

        function checkIfOnlyLetters() {
            if(appOptions.country === 'DK') {
                vm.cartHasOnlyLetters = !_.some(vm.cart, function (product) {
                    return product.type !== 'letter';
                });
            } else if(appOptions.country === 'SE') {
                vm.cartHasOnlyLetters = _.every(vm.cart, function(product) {
                    return product.type === 'letter' && AdditionalServiceHelper.hasSelectedAdditionalServiceId(product.additionalServices, 'digitalStamps');
                });
            }
        }

        function reloadCart() {
            vm.cart = $sessionStorage.cart;
            checkIfCartHasLetters();
        }

        function checkIfCartHasLetters() {
            vm.cartHasLetters = _.some(vm.cart, function (product) {
                return product.type === 'letter';
            });
        }

        function getPaymentMethods() {
            var fromCountry = appOptions.country;
            PaymentFactory.getPaymentMethods(fromCountry).then(function (paymentMethods) {
                $log.debug('PaymentController : getPaymentMethods : paymentMethods', paymentMethods)
                vm.paymentMethods = paymentMethods;
            });
        }

        function handlePaymentResponse(responseCode) {
            switch (responseCode) {
                case 'WaybillFailedCardPayment':
                    vm.errorMessage = 'PAYMENT_PAGE_ERROR_WAYBILL_FAILED_PAYMENT_ANNULLED';
                    break;
                case 'WaybillFailedDirectBankPayment':
                    vm.errorMessage = 'PAYMENT_PAGE_ERROR_WAYBILL_FAILED_PAYMENT_CREDITED';
                    break;
                case 'Cancel':
                    vm.errorMessage = 'PAYMENT_PAGE_ERROR_PAYMENT_CANCELLED';
                    break;
                case 'ServerError':
                    vm.errorMessage = 'PAYMENT_PAGE_ERROR_PAYMENT_FAILED';
                    break;
            }

            if (vm.errorMessage) {
                vm.paymentFailed = true;
                vm.agreement = true;
                $timeout(function () {
                    $anchorScroll('payment-failed-message');
                }, 0);
            }
        }



        function clearPreviousStateData() {
            delete $sessionStorage.selected;
            delete $sessionStorage.editParcel;
            delete $sessionStorage.editingFromState;

            // Clear previous purchase offers email

            delete $localStorage.invoiceInfo;

            _.map($sessionStorage.cart, function (item) {
                item.isEditing = false;
            });
        }

        var paymentInfo = null

        function next(invoiceInfo, paymentMethod) {

            $localStorage.senderEmail = invoiceInfo.email;

            if (vm.form.$valid && paymentMethod) {
                vm.isSubmitting = true;
                invoiceInfo.wantsOffers = $localStorage.wantsOffers;

                var cartId = $sessionStorage.cart[0].cartId;

                var params = {
                    // redirectUrl: [location.protocol, '//', location.host, location.pathname, OnlineShippingTool.env.paymentRedirectUrl, '?cartId=', cartId].join(''),
                    redirectUrl: [location.protocol, '//', location.host, location.pathname, '-redirect', '?cartId=', cartId].join(''),
                    locale: LocaleFactory.getLocale(),
                    countryCode: appOptions.country,
                    invoiceInfo: invoiceInfo,
                    clientId: 'ST'
                };

                if (FeatureToggleFactory.isFeatureEnabled('sePaymentSystemVersion2', 'SE') || FeatureToggleFactory.isFeatureEnabled('dkPaymentSystemVersion2', 'DK')) {
                    params.paymentMethod = paymentMethod;
                    params.platform = 'web';
                } else {
                    params.paymentMethodId = paymentMethod;
                }

                $log.debug(params.redirectUrl);

                CartFactory.updateInvoiceInfo(cartId, invoiceInfo).then(function (response) {
                    if (paymentMethod === 'APPLE-PAY') {
                        const applePay = vm.paymentMethods.find(function(x) {
                            return x.method === 'APPLE-PAY'
                        })
                        paymentInfo = {params, paymentMethod};
                        initApplePay(applePay.paymentProviderConfiguration, invoiceInfo)
                    } else if (paymentMethod === 'GOOGLE-PAY') {
                        const googlePay = vm.paymentMethods.find(function(x) {
                            return x.method === 'GOOGLE-PAY'
                        })
                        paymentInfo = {params, paymentMethod};
                        initGooglePay(googlePay.paymentProviderConfiguration, invoiceInfo)
                    }
                    else {
                        initTransaction(cartId, params, paymentMethod)
                    }
                });


            }
        }

        function initTransaction(cartId, params, paymentMethod) {
            vm.initiatingTransaction = true;
            PaymentFactory.initTransaction(cartId, params).then(function (res) {
                if (res.ok) {
                    if (paymentMethod === 'SWISH-ECOMMERCE') {
                        $log.log('Swish payment! Redirect to complete payment page with SWISH param');
                        $state.go('main.payment-redirect', { paymentMethod: paymentMethod, transactionId: res.transactionId });
                    } else if (paymentMethod === 'APPLE-PAY') {
                        $log.log('Apple payment! Redirect to complete payment page');
                        $state.go('main.payment-redirect', { paymentMethod: paymentMethod, transactionId: res.transactionId });
                    } else if (paymentMethod === 'GOOGLE-PAY') {
                        $log.log('Google payment! Redirect to complete payment page');

                        // Needed since 3D Secure is not always applicable
                        if (res.threeDSData && res.threeDSData.type === 'redirect') {
                            openGooglePay3DSecure(res.threeDSData);
                        } else {
                          $state.go('main.payment-redirect', { paymentMethod: paymentMethod, transactionId: res.transactionId });
                        }
                    } else {
                        $log.log('Redirecting to Nets Terminal at url: ', res.terminalUrl);

                        // Fix for MobilePay when sessionStorage seems to be cleared
                        $localStorage.tempCart = angular.copy($sessionStorage.cart);

                        $window.location.href = res.terminalUrl;
                    }
                } else {
                    $state.go('main.payment', { responseCode: 'ServerError' });
                    vm.isSubmitting = false;
                    vm.initiatingTransaction = false;
                }
            }, function (errorResponse) {
                $log.debug('PaymentController : next : errorResponse', errorResponse);
                vm.isSubmitting = false;
                vm.initiatingTransaction = false;
            });
        }

        function backToLanding() {
            $state.go('main.landing');
        }

        // Docs for integrating Apple Pay with NOPS available at
        // https://pncorp.atlassian.net/wiki/spaces/NKB/pages/3200745670/Showing+available+payment+methods#Rendering-Adyen-Apple-pay-component(Web)
        function handleAppleAndGooglePayFailure(errorMessage) {
            vm.errorMessage = errorMessage;
            vm.paymentFailed = true;
            vm.isSubmitting = false;
            vm.initiatingTransaction = false;
            $timeout(function () {
                $anchorScroll('payment-failed-message');
            }, 0);
        }

        function handleApplePayChange(state, component) {
            if (!state.isValid) {
                $log.debug('PaymentController : invalidStateApplePay : error', state);
                handleAppleAndGooglePayFailure('PAYMENT_PAGE_ERROR_APPLE_PAY_INVALID_STATE');
                return
            }

            var cartId = $sessionStorage.cart[0].cartId;
            initTransaction(cartId, Object.assign({}, paymentInfo.params, {paymentStateData: state.data}), paymentInfo.paymentMethod);
        }
        function handleGooglePayChange(state, component) {
            if (!state.isValid) {
                $log.debug('PaymentController : invalidStateGooglePay : error', state);
                handleAppleAndGooglePayFailure('PAYMENT_PAGE_ERROR_GOOGLE_PAY_INVALID_STATE');
                return
            }

            var cartId = $sessionStorage.cart[0].cartId;
            initTransaction(cartId, Object.assign({}, paymentInfo.params, {paymentStateData: state.data}), paymentInfo.paymentMethod);
        }

        function initApplePay(applePayConfig, invoiceInfo) {
            const config = {
                clientKey: applePayConfig.clientKey,
                environment: applePayConfig.environment,
                paymentMethodsResponse: applePayConfig.paymentMethodsResponse,
                onChange: handleApplePayChange,
            }

            AdyenCheckout(config).then((adyenCheckout) => {
                const totalVatPrice = Common.getTotalVatPriceForParcels(vm.cart);
                const currency = vm.cart[0].priceUnit

                const applePayConfiguration = {
                    amount: {
                        value: totalVatPrice,
                        currency: currency,
                    },
                    countryCode: applePayConfig.merchantCountryCode
                };

                const applePayCheckout = adyenCheckout.create('applepay', applePayConfiguration);
                applePayCheckout.isAvailable().then(() => {
                    applePayCheckout.mount('#apple-pay-container');
                    vm.isPayingWithAppleOrGoogle = true;
                    $scope.$digest();
                }).catch((error) => {
                    $log.debug('PaymentController : initApplePay : error', error);
                    handleAppleAndGooglePayFailure('PAYMENT_PAGE_ERROR_APPLE_PAY_INIT_FAILURE');
                })
            })
        }
        // Docs for integrating Google Pay with NOPS available at
        // https://pncorp.atlassian.net/wiki/spaces/NKB/pages/3200745670/Showing+available+payment+methods#Rendering-Adyen-Apple-pay-component(Web)

        function initGooglePay(googlePayConfig, invoiceInfo) {
            const config = {
                clientKey: googlePayConfig.clientKey,
                environment: googlePayConfig.environment,
                paymentMethodsResponse: googlePayConfig.paymentMethodsResponse,
                onChange: handleGooglePayChange,
            }

            AdyenCheckout(config).then((adyenCheckout) => {
                vm.adyenGooglePayCheckout = adyenCheckout;
                const totalVatPrice = Common.getTotalVatPriceForParcels(vm.cart);
                const currency = vm.cart[0].priceUnit

                let googlePayConfiguration = {
                    amount: {
                        value: totalVatPrice,
                        currency: currency,
                    },
                    countryCode: googlePayConfig.merchantCountryCode,
                }

                if (googlePayConfig.merchantIdentifier) {
                    googlePayConfiguration.configuration = {
                        merchantName: 'PostNord',
                        gatewayMerchantId: googlePayConfig.merchantAccount,
                        merchantId: googlePayConfig.merchantIdentifier,
                    }
                }

                const googlePayCheckout = adyenCheckout.create('googlepay', googlePayConfiguration);
                googlePayCheckout.isAvailable().then(() => {
                    googlePayCheckout.mount('#google-pay-container');
                    vm.isPayingWithAppleOrGoogle = true;
                    $scope.$digest();
                }).catch((error) => {
                    $log.debug('PaymentController : initGooglePay : error', error);
                    handleAppleAndGooglePayFailure('PAYMENT_PAGE_ERROR_GOOGLE_PAY_INIT_FAILURE');
                })
         })
        }

        function openGooglePay3DSecure(threeDSData) {
            vm.adyenGooglePayCheckout.createFromAction(threeDSData).mount('#google-pay-container');
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('onlineShippingTool.payment')
      .controller('PaymentRedirectController', PaymentRedirectController);

  PaymentRedirectController.$inject = ['$http', '$scope', '$localStorage', '$log', '$q', '$sessionStorage', '$state', '$stateParams', '$timeout', '$window', 'NetsTransaction', 'CartFactory', 'Common', 'PaymentFactory', 'appOptions', 'FeatureToggleFactory'];

  /* @ngInject */
  function PaymentRedirectController($http, $scope, $localStorage, $log, $q, $sessionStorage, $state, $stateParams, $timeout, $window, NetsTransaction, CartFactory, Common, PaymentFactory, appOptions, FeatureToggleFactory) {
      var vm = this;

      activate();

      $scope.$on("$destroy", function() {
        PaymentFactory.cancelBookCartTimeout();
      });

      function activate() {
          $log.debug('Payment loading');
          var stateUrl = $state.href('main.payment-redirect', {}, {absolute: true});

          var transactionId = $stateParams.transactionId;
          var responseCode = $stateParams.responseCode;
          var redirectResult = $stateParams.redirectResult;
          vm.paymentMethod = $stateParams.paymentMethod;

          // We are redirected back to the payment page from Nets terminal
          if (redirectResult) {
            handleGoogle3DSecurePayment(redirectResult, transactionId);
          } else if (vm.paymentMethod === 'SWISH-ECOMMERCE' || vm.paymentMethod === 'APPLE-PAY' || vm.paymentMethod === 'GOOGLE-PAY') {
            handleSwishAndAppleAndGooglePayment(transactionId);
          } else if (transactionId) {
            handleTerminalRedirect(transactionId, responseCode);
          } else {
            $state.go('main.payment');
          }
      }

      function handleTerminalRedirect(transactionId, responseCode) {
          return getCart().then(function (cart) {
              if (responseCode === 'OK') {
                  var cartId = cart[0].cartId;
                  PaymentFactory.bookCart(cartId).then(function (res) {
                      if (!res.skipGA || appOptions.country !== 'DK') {
                          pushGtmPurchase(transactionId, cart, res);
                          pushPaymentMethod(res);
                      }
                      goToReceipt(res);
                  }, function (errorResponse) {
                      $state.go('main.payment', { responseCode: 'ServerError' });
                  });
              } else if(responseCode === 'Cancel') {
                  $log.debug('terminal canceled');
                  $state.go('main.payment', { responseCode: responseCode });
              } else {
                  $log.debug('terminal NOT OK');
                  $state.go('main.payment', { responseCode: 'ServerError' });
              }
          });
      }

      function handleSwishAndAppleAndGooglePayment(transactionId) {
          return getCart().then(function (cart) {
              var cartId = cart[0].cartId;
              PaymentFactory.bookCart(cartId).then(function (res) {
                  $log.log('Payment success!', res);
                  pushGtmPurchase(transactionId, cart, res);
                  pushPaymentMethod(res);
                  goToReceipt(res);
              }, function (errorResponse) {
                  $log.log('Payment error!', errorResponse);
                  $state.go('main.payment', { responseCode: 'ServerError' });
              });
          });
      }

      function handleGoogle3DSecurePayment(redirectResult, transactionId) {
        return getCart().then(function (cart) {
            var cartId = cart[0].cartId;
            PaymentFactory.verifyTransaction(cartId, redirectResult).then(function (res) {
                if (res.ok) {
                    handleSwishAndAppleAndGooglePayment(transactionId);
                } else {
                    $log.debug('Google Pay 3DSecure verification failed', res);
                    $state.go('main.payment', { responseCode: 'ServerError' });
                }
            })
        })
      }

      function getCart() {
          var cart = angular.copy($sessionStorage.cart);

          if (cart) {
              return $q.when(cart);
          } else if ($stateParams.cartId) {
              return CartFactory.getCart($stateParams.cartId).then(function (cart) {
                  $sessionStorage.cart = angular.copy(cart);
                  return cart;
              });
          } else {
              return $q.reject();
          }
      }

      function pushGtmPurchase(transactionId, cart, bookingResponse) {
          // Build transaction info
          var totalInclVat = Common.getTotalVatPriceForParcels(cart);
          var totalExclVat = Common.getTotalPriceForParcels(cart);
          var totalVat = totalInclVat - totalExclVat;

          // Google Standard Ecommerce tags (NEW FORMAT)
          // Build category (store name)
          var category;
          if (appOptions.country === 'SE') {
              category = 'Skicka Direkt';
          } else if (appOptions.country === 'DK') {
              category = 'Online Porto';
          }
    
          // Build products
          var products = _.chain(groupParcels(cart, bookingResponse))
              .map(function(groupedParcels) {
                  // Sample:
                  // id: 'Lätt (2000 SE), Standard Delivery, Ansvar',
                  // name: 'Skicka lätt',
                  // price: '63.00',
                  // variant: 'Lätt',
                  // category: 'Skicka Direkt',
                  // quantity: 1,
                  // dimension8: 'SE’,
                  // dimension9: 'Standard Delivery, Ansvar'
                  return {
                      id: groupedParcels.sku,
                      name: groupedParcels.name,
                      price: groupedParcels.price,
                      variant: groupedParcels.canonicalName,
                      category: category,
                      quantity: groupedParcels.quantity,
                      dimension8: groupedParcels.category,
                      dimension9: groupedParcels.additionalServices
                  }
              })
              .value();
    
          var transactionInfo = {
              event: 'transaction',
              ecommerce: {
                  currencyCode: cart[0].priceUnit,
                  wantsOffers: $localStorage.wantsOffers,
                  purchase: {
                      actionField: {
                          id: transactionId,
                          revenue: toDecimalPrice(totalExclVat),
                          tax: toDecimalPrice(totalInclVat - totalExclVat),
                          coupon: ''
                      },
                      products: products
                  }
              }
          };
    
          // Build digital agent data if it exist
          var itemWithDGA = _.find(cart, function(item){
              return item.digitalAgent !== undefined;
          });
          if (itemWithDGA) {
              transactionInfo.ecommerce.agentIdOrigin = itemWithDGA.digitalAgent.agentName;
          }
    
          // Push to GTM
          $log.debug('Pushing transaction info to GTM data layer:');
          $log.debug(transactionInfo);
          $window.dataLayer.push(transactionInfo);
      }

      function groupParcels(cart, bookingResponse) {
          return _.chain(cart)
              .map(function(parcel) {
                  var quantity = parcel.quantity || 1;
                  var unitPrice = Common.getVatPriceForParcel(parcel) / quantity;
                  var baseProduct = getBaseProduct(parcel);
                  var productDetails = getProductDetails(parcel, bookingResponse);

                  return {
                      name: productDetails.productName || baseProduct.name,
                      sku: productDetails.sku,
                      unitPrice: toDecimalPrice(unitPrice),
                      category: parcel.receiver.address.countryCode,
                      quantity: quantity,
                      canonicalName: parcel.canonicalName,
                      additionalServices: productDetails.additionalServices
                  }
              })
              .groupBy(function(parcel) {
                  return parcel.name + parcel.sku + parcel.unitPrice + parcel.category;
              })
              .map(function(groupedParcels) {
                  var quantity = 0;

                  for(var i = 0; i < groupedParcels.length; i++){
                    quantity += groupedParcels[i].quantity;
                  };

                  return {
                      name: groupedParcels[0].name,
                      sku: groupedParcels[0].sku,
                      price: groupedParcels[0].unitPrice,
                      quantity: quantity,
                      category: groupedParcels[0].category,
                      canonicalName: groupedParcels[0].canonicalName,
                      additionalServices: groupedParcels[0].additionalServices
                  }
              })
              .value();
      }

      function getProductDetails(parcel, bookingResponse) {
          var resultItem = _.find(bookingResponse.booking.items, { itemId: parcel.itemId });
          // Sample
          // sku: "Lätt (2000 SE), Express tillägg, Express delivery",
          // productName: "Expressbrev inrikes",
          // additionalServices: "Express tillägg, Express delivery"
          return {
              sku: resultItem.sku,
              productName: resultItem.productName,
              additionalServices: resultItem.additionalServices
          }
      }

      function mergeProductNames(parcel) {
          return _.chain(parcel.additionalServices)
              .where({ selected: true })
              .reduce(function(merged, service) {
                  return merged + ', ' + service.additionalServiceName;
              }, parcel.canonicalName + ' (' + parcel.productId + ' ' + parcel.receiver.address.countryCode + ')')
              .value();
      }

      function getBaseProduct(parcel) {
          var baseService = _.find(parcel.additionalServices, function(service) {
              return service.selected && service.baseProductId && service.baseProductName;
          });

          var baseServiceName = baseService && baseService.baseProductName;
          var baseServiceId = baseService && baseService.baseProductId;

          return {
              name: baseServiceName || parcel.baseProductName,
              id: baseServiceId || parcel.baseProductId
          }
      }

      function toDecimalPrice(price) {
          if(!_.isNumber(price))
              return 0;

          var decimal = price / 100;
          return _.round(decimal, 2);
      }

      function pushPaymentMethod(response) {
          var paymentMethod = _.get(response, 'payment.paymentMethod');

          if (paymentMethod) {
              $window.dataLayer.push({ paymentMethod: paymentMethod });
          }
      }

      function goToReceipt(response) {
          $log.debug('Proceeding to receipt', response);

          var resultItems = _.get(response, 'booking.items');
          $log.debug('PaymentRedirectController : goToReceipt : resultItems', resultItems);

          if (resultItems) {
              _.map($sessionStorage.cart, function(item) {
                  var resultItem = _.find(resultItems, { itemId: item.itemId });
                  if(resultItem !== undefined) {
                      item.consignmentNumber = resultItem.consignmentNumber;
                      item.portoCodes = resultItem.portoCodes;
                      item.quickletter = resultItem.quickletter;
                      item.digitalStamps = resultItem.digitalStamps;
                      item.expiryDate = resultItem.expiryDate;
                      item.servicePointTypes = resultItem.content?.productCapabilities?.servicePointTypes;
                  }
              });
          }

          $state.go('main.receipt', { transactionId: $stateParams.transactionId, printableAtServicePoint: response.printableAtServicePoint });
      }
  }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .factory('NetsTransaction', NetsTransaction);

    NetsTransaction.$inject = ['$http'];

    /* @ngInject */
    function NetsTransaction($http) {
        var service = {
            initTransaction: initTransaction,
            checkTransactionStatus: checkTransactionStatus,
            processTransaction: processTransaction
        };

        return service;

        function initTransaction(params) {
            console.log('init transaction called with params =', params);
            return $http.post(OnlineShippingTool.env.initTransactionUrl, params)
            .then(function(response) {
                console.dir(response);
                var terminalUrl = _.get(response, 'data.terminalUrl');
                console.log('Transaction registered, terminal url = ', terminalUrl);
                return { ok: true, terminalUrl: terminalUrl };
            }, function(error) {
                console.log('Register transaction failed');
                console.dir(error);
                return { ok: false, response: error };
            });
        }

        function checkTransactionStatus(params) {
            return $http.get(OnlineShippingTool.env.checkTransactionStatusUrl, params)
            .then(function(response) {
                console.log('Transaction status:');
                console.dir(response);
                return { ok: true, response: response };
            }, function(error) {
                console.log('Check transaction status failed:');
                console.dir(error);
                return { ok: false, response: error };
            });
        }

        function processTransaction(params) {
            return $http.post(OnlineShippingTool.env.processTransactionUrl, params)
            .then(function(response) {
                console.log('Transaction processed, response:');
                console.dir(response);
                var res = _.get(response, 'data.result');
                var paymentOk = res && res.paymentOk;
                var pabloOk = res && res.pabloOk;
                return {
                    ok: paymentOk && pabloOk,
                    response: response,
                    paymentOk: paymentOk,
                    pabloOk: pabloOk
                };
            }, function(error) {
                console.log('Process transaction failed:');
                console.dir(error);
                return { ok: false, response: error };
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool')
        .controller('MainController', MainController);

    MainController.$inject = ['$log', '$rootScope','$scope', '$sessionStorage', '$localStorage', '$state', '$stateParams', '$window', '$translate', 'DisturbanceMessageFactory', 'ParcelTypes', 'PreloadFactory', 'CountryFactory', 'appOptions', 'FeatureToggleFactory'];

    /* @ngInject */
    function MainController($log, $rootScope, $scope, $sessionStorage, $localStorage, $state, $stateParams, $window, $translate, DisturbanceMessageFactory, ParcelTypes, PreloadFactory, CountryFactory, appOptions, FeatureToggleFactory) {
        var vm = this;
        vm.getParcelTypesForCountry = getParcelTypesForCountry;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        vm.hasPrintedShippinglabel = false;
        vm.isSmallScreen = false;
        vm.setCustomerType = setCustomerType;
        vm.getCurrentStage = getCurrentStage;
        vm.openHumanyContact = openHumanyContact;
        vm.setPrintedShippinglabel = setPrintedShippinglabel;
        vm.cart = $sessionStorage.cart;
        vm.country = appOptions.country;
        vm.loadingProducts = false;
        vm.navigationMenuItems = [];
        vm.showNavigationMenu = showNavigationMenu;
        vm.language = $translate.proposedLanguage() || $translate.use();
        vm.marketwebEndpoint = OnlineShippingTool.env.marketwebEndpoint;
        vm.marketwebEnvironment = OnlineShippingTool.env.marketwebEnvironment;

        if(!$sessionStorage.receiverCountryCode) {
            $sessionStorage.receiverCountryCode = appOptions.country;
        }

        $scope.$on('changeLanguage', handleChangeLanguage);
        $scope.$on('main:reloadCart', handleReloadCart);
        $scope.$on('main:loadParcelTypes', handleLoadParcelTypes);
        $scope.$on('main:receiptDestroyed', handleReceiptDestroyed);

        activate();

        //////////////////////////

        function activate() {

            if(!$rootScope.localStorageDisabled && localStorage.user !== 'null') {
                vm.loggedin = true;
            } else {
                vm.loggedin = false;
            }
            getDisturbanceMessage();


            // Old product implementation
            getParcelTypes($sessionStorage.receiverCountryCode).then(preloadImages);
            // New product implementation
            getProducts($sessionStorage.receiverCountryCode);

            initResizeListener();
            vm.isSmallScreen = checkIfScreenSizeIsSmall();
            vm.isDanishUser = checkIfDanishUser();

            initCustomerType();

            if (typeof $localStorage.isCustomerCompany !== 'undefined'){
                // Push Page Load info to GTM
                gtmPushPageLoadInfo();
            }

            setNavigationMenuItems();

        }

        function gtmPushPageLoadInfo() {
            $window.dataLayer.push({ userSegment: getUserSegment() });
        }

        function getCurrentStage() {
            return $state.current.name.replace('main.', '');
        }

        function getParcelTypes(countryCode, language) {
            vm.parcelTypes = [];
            language = language || $translate.proposedLanguage() || $translate.use();
            return ParcelTypes.get(appOptions.country, countryCode, language).then(function (parcelTypes) {
                vm.parcelTypes = parcelTypes;
                return parcelTypes;
            });
        }

        function getParcelTypesForCountry(country) {
            // Blur the search field for the country selector to prevent the mobile keyboard for showing up

            if (document && document.activeElement) {
                document.activeElement.blur();
            }

            $sessionStorage.receiverCountryCode = country.countryCode;
            getParcelTypes(country.countryCode);
            getProducts(country.countryCode);
            $rootScope.$emit('changedCountry');
        }

        function getProducts(countryCode, language) {
            vm.productGroups = [];
            vm.loadingProducts = true;

            language = language || $translate.proposedLanguage() || $translate.use();
            return ParcelTypes.get(appOptions.country, countryCode, language).then(function (products) {
                vm.loadingProducts = false;
                vm.productGroups = _.chain(products)
                    .groupBy(function (product, index) {
                        var group;

                        product.index = index;

                        if (product.group) {
                            group = product.group.name;
                            group += '_' + product.minWeight.value + product.minWeight.unit;
                            group += '_' + product.maxWeight.value + product.maxWeight.unit;
                        } else {
                            group = index;
                        }

                        return group;
                    })
                    .map(function (group) {
                        return {
                            minWeight: group[0].minWeight,
                            maxWeight: group[0].maxWeight,
                            products: group
                        }
                    })
                    .sortBy(function (group) {
                        if (countryCode.toLowerCase() === 'dk') {
                            if (group.products[0].type === 'letter') {
                                // Put letters at the end to promote parcels
                                return group.products[0].index + products.length;
                            }
                        }
                        return group.products[0].index;
                    })
                    .value();
            });
        }

        function preloadImages() {
            var imageLocations = [];

            _.each(vm.parcelTypes, function(obj) {
                if (obj.description) {
                    var imgUrl = 'assets/images/' + obj.description.imageUrl
                    imageLocations.push(imgUrl);
                }
            });

            PreloadFactory.preloadImages( imageLocations ).then(
                function handleResolve( imageLocations ) {
                    // Loading was successful.
                    console.info( "Preload Successful" );
                },
                function handleReject( imageLocation ) {
                    // Loading failed on at least one image.
                    console.error( "Image Failed", imageLocation );
                    console.info( "Preload Failure" );
                },
                function handleNotify( event ) {
                    console.info( "Images being loaded.");
                }
            );
        }

        function initCustomerType() {
            if((vm.country === 'DK' && !vm.isCustomerCompany) || $stateParams.customerType) {
                var value = vm.country !== 'DK' && $stateParams.customerType === 'company';

                $localStorage.isCustomerCompany = value;
                vm.isCustomerCompany = value;

                //Update for GTM aswell
                gtmPushPageLoadInfo();
            }
        }

        function setCustomerType(value) {
            $localStorage.isCustomerCompany = value;
            vm.isCustomerCompany = value;
            $rootScope.$broadcast('main:customerTypeChanged');

            //Update for GTM aswell
            gtmPushPageLoadInfo();
        }

        function getUserSegment() {
            return $localStorage.isCustomerCompany ? 'business' : 'private';
        }

        function handleReloadCart() {
            vm.cart = $sessionStorage.cart;
        }

        function setPrintedShippinglabel() {
            vm.hasPrintedShippinglabel = true;
        }

        function checkIfScreenSizeIsSmall() {
            var w = $window.innerWidth;
            return w < 768;
        }

        function checkIfDanishUser() {
            var userLanguage = navigator.languages
                ? navigator.languages[0]
                : (navigator.language || navigator.userLanguage);

            return userLanguage && userLanguage.toLowerCase() === 'da';
        }

        function initResizeListener() {
            angular.element($window).bind('resize', function () {
                vm.isSmallScreen = checkIfScreenSizeIsSmall();
                $scope.$digest();
            });
        }

        function handleChangeLanguage(events, language) {
            vm.language = language;
            getParcelTypes($sessionStorage.receiverCountryCode, language);
            getProducts($sessionStorage.receiverCountryCode, language);
        }

        function handleLoadParcelTypes(events, countryCode) {
            getParcelTypes(countryCode);
            getProducts(countryCode);
        }

        function handleReceiptDestroyed() {
            vm.hasPrintedShippinglabel = false;
        }

        function getDisturbanceMessage() {
            DisturbanceMessageFactory.getMessage().then(function (message) {
                vm.disturbanceMessage = message;
            });
        }

        function openHumanyContact() {
            $scope.$broadcast('humany:openFloatingWidget');
        }

        function setNavigationMenuItems(){
            vm.navigationMenuItems = [
                {state: 'main.user.history', extraStates: [], class: 'my-shipments', name: 'MY_SHIPMENTS', loginRequired: true},
                {state: 'main.user.receivers', extraStates: [], class: 'my-receivers', name: 'MY_RECEIVERS', loginRequired: true},
                {state: 'main.landing', extraStates: ['main.address', 'main.payment', 'main.receipt'], class: 'new-shipment', name: 'NEW_SHIPMENT', loginRequired: false}
            ];
        }

        function showNavigationMenu(currentState){
            return vm.navigationMenuItems.some(function(i){
                return i.state === currentState || i.extraStates.some(function(es){
                    return es === currentState;
                })
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.landing')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.landing', {
          url: '/?toCountry&productId&additionalServiceIds',
          templateUrl: 'components/landing/landing.html',
          controller: 'LandingController',
          controllerAs: 'landing'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.landing')
        .controller('LandingController', LandingController);

    /* @ngInject */
    function LandingController($log, $q, $scope, $rootScope, $sessionStorage, $state, $stateParams, $timeout, $translate, AdditionalServiceHelper, CartFactory, Common, CountryFactory, FeatureToggleFactory, LocalCartFactory, ParcelTypes, OrderHistoryFactory, Topbar, appOptions) {
        var vm = this;

        vm.isEditingParcel = false;
        vm.isHeaderSubExpanded = false;
        vm.toggleHeaderSubExpanded = toggleHeaderSubExpanded;
        vm.loadingOrderHistory = false;
        vm.selectedWeight = undefined;

        vm.next = next;
        vm.loadCountries = loadCountries;
        vm.getPriceForParcel = Common.getPriceForParcel;
        vm.getVatPriceForParcel = Common.getVatPriceForParcel;
        vm.isProductValid = isProductValid;
        vm.isProcessing = false;
        vm.isSubmitted = false;

        vm.currentMonth = {
            name: moment().format('MMM YYYY'),
            value: moment().format('YYYY-MM')
        };

        $scope.$on('changeLanguage', function(events, language) {
            loadCountries(language);
        });
        $rootScope.$on('changedCountry', function() {
          selectStoredSelection();
        })

        activate();

        function activate() {

            loadCountries()
                .then(selectProductFromUrlParams);

            loadUserData();

            selectStoredSelection();

            if ($sessionStorage.cart) {
                vm.cart = $sessionStorage.cart;
            }
        }
        function selectStoredSelection() {
          var country = appOptions.country;
          if ($sessionStorage.editParcel && $sessionStorage.editParcel.validFrom === country && isSameCountry($sessionStorage.editParcel.receiverCountryCode)) {
            vm.selectedType = angular.copy($sessionStorage.editParcel);
            vm.editParcel = angular.copy($sessionStorage.editParcel);
            vm.isEditingParcel = true;
            vm.editingFromState = $sessionStorage.editingFromState;
        } else if ($sessionStorage.selected && $sessionStorage.selected.validFrom === country && isSameCountry($sessionStorage.selected.receiverCountryCode)) {
            vm.selectedType = $sessionStorage.selected;
        } else if ($sessionStorage.preferred && $sessionStorage.preferred.validFrom === country && isSameCountry($sessionStorage.preferred.receiverCountryCode)) {
            vm.selectedType = _.omit($sessionStorage.preferred, 'itemId', 'cartId', 'isEditing', 'receiver', 'sender', 'cashOnDelivery');
        } else {
          vm.selectedType = null;
        }
        }
        function isSameCountry(receiverCountry) {
          return receiverCountry === $sessionStorage.receiverCountryCode;
        }
        function loadCountries(language) {
            language = language || $translate.proposedLanguage() || $translate.use();
            var fromCountry = appOptions.country;

            return CountryFactory.getCountries(language, fromCountry).then(function (countries) {
                if (fromCountry === 'DK' && !FeatureToggleFactory.isFeatureEnabled('danishInternational')) {
                    countries = _.filter(countries, {countryCode: 'DK'});
                }

                vm.countrySelection = countries;
                vm.selectedCountry = _.find(countries, { countryCode: $sessionStorage.receiverCountryCode }) || countries[0];
                $sessionStorage.receiverCountryCode = vm.selectedCountry.countryCode;
                $sessionStorage.receiverCountry = vm.selectedCountry;
                return countries;
            });
        }

        function loadUserData() {
            if(!$rootScope.localStorageDisabled && localStorage.user !== 'null') {
                vm.loadingOrderHistory = true;

                getOrderHistory()
                    .then(getOrderStatusesForMonth)
                    .then(setHistoryLoaded);
            }
        }

        function getOrderHistory() {
            return OrderHistoryFactory.getOrderHistory(vm.currentMonth.value).then(function(response) {
                vm.orderHistory = response;
            });
        }

        function getOrderStatusesForMonth() {
            return OrderHistoryFactory.getOrderStatusesForMonth(vm.currentMonth.value).then(function(response) {
                vm.orderStatuses = response;
            });
        }

        function setHistoryLoaded() {
            vm.loadingOrderHistory = false;
        }

        function toggleHeaderSubExpanded() {
            vm.isHeaderSubExpanded = !vm.isHeaderSubExpanded;
        }

        function logQuantityToGtm(quantity){
            if (dataLayer) {
                dataLayer.push({
                    event: 'label_quantity',
                    quantity: quantity
                });
            }
        }

        function selectProductFromUrlParams(countries) {
            var selectedCountry = _.find(countries, {countryCode: $stateParams.toCountry});
            if (selectedCountry && selectedCountry !== vm.selectedCountry) {
                vm.selectedCountry = selectedCountry;
                $sessionStorage.receiverCountryCode = $stateParams.toCountry;
                $sessionStorage.receiverCountry = vm.selectedCountry;
                $rootScope.$broadcast('main:loadParcelTypes', $stateParams.toCountry);
            }
        }

        function next(parcelType, isValid) {
            vm.isSubmitted = true;

            if (isValid !== false) {
                vm.isProcessing = true;

                if(parcelType.cashOnDelivery && parcelType.cashOnDelivery.amount) {
                   parcelType.cashOnDelivery.amount = parcelType.cashOnDelivery.amount * 100;
                }

                if (vm.selectedWeight) {
                    parcelType.selectedWeight = angular.copy(vm.selectedWeight);
                }
                
                $q.when(parcelType)
                    .then(verifyAdditionalServicesForProduct)
                    .then(setCountryToProduct)
                    .then(storeProductAsPreferred)
                    .then(repopulateProductIfEditing)
                    .then(saveProduct)
                    .then(logQuantityToGtm(parcelType.quantity))
                    .then(finishProcessing);
            }
        }



        /**
         * Functions used in save product flow
         */

        function verifyAdditionalServicesForProduct(product) {
            _.each(product.additionalServices, function (service) {
                if (isServiceWithInvalidZipCode(service) && !service.hidden) {
                    service.selected = false;
                    resetInsuranceServices(product);
                }

                if (AdditionalServiceHelper.isExpressDeliveryService(service)) {
                    if (!service.isValidZipCode) {
                        resetGroupedServicesForService(product, service);
                    } else if (service.selected) {
                        resetExtraSizeServices(product);
                    }
                }

                if (AdditionalServiceHelper.isCashOnDeliveryService(service)) {
                    service.selected = product.cashOnDelivery ? service.selected : false;
                    product.cashOnDelivery = service.selected ? product.cashOnDelivery : null;
                }

                if (AdditionalServiceHelper.isResponsibilityService(service)) {
                    service.selected = product.responsibilityValue ? service.selected : false;
                }

                // If we're sending a roll, the "To mailbox" service is not available
                if (service.additionalServiceId === 'Till-brevlada' && parcelType.isRoll) {
                    service.selected = false;
                }

                if (service.included && (service.override == 'undefined' || !service.override)) {
                    service.selected = true;
                }

                if (service.included && service.override) {
                    service.selected = false;
                }

                // Override included valuableTypeInsurance if valuableType is Rek
                if (service.selected && ['144297', '144298', '144299'].indexOf(service.additionalServiceId) !== -1) {
                    var includedInsuranceService = _.find(product.additionalServices, {type: 'valuableTypeInsurance', included: true});
                    if (includedInsuranceService) {
                        includedInsuranceService.override = true;
                    }
                }
            });

            return product;
        }

        function isServiceWithInvalidZipCode(service) {
            var isEveningHomeDeliveryService = AdditionalServiceHelper.isEveningHomeDeliveryService(service);
            var isExpressDeliveryService = AdditionalServiceHelper.isExpressDeliveryService(service);
            var isCompanyExpressService = AdditionalServiceHelper.isCompanyExpressService(service);
            return service.selected && !service.isValidZipCode && (isEveningHomeDeliveryService || isExpressDeliveryService || isCompanyExpressService);
        }

        function resetInsuranceServices(product) {
            _.each(product.additionalServices, function (service) {
                if (service.additionalServiceId === 'Varuforsakring') {
                    delete service.override;
                }

                if (service.additionalServiceId === 'Varuansvar') {
                    service.override = true;
                }
            });
        }

        function resetGroupedServicesForService(product, service) {
            _.each(product.additionalServices, function (_service) {
                if (typeof _service.grouping !== 'undefined' && _service.grouping === service.grouping) {
                    _service.selected = service.selected;
                }
            });
        }

        function resetExtraSizeServices(product) {
            _.each(product.additionalServices, function (_service) {
                if(_service.additionalServiceId === "1001051") {
                    _service.selected = false;
                }
            });
        }

        function setCountryToProduct(product) {
            product.toCountry = vm.selectedCountry;
            product.receiverCountry = vm.selectedCountry.name;
            product.receiverCountryCode = vm.selectedCountry.countryCode;
            return product;
        }

        function storeProductAsPreferred(product) {
            $sessionStorage.preferred = angular.copy(_.omit(product, 'itemId', 'cartId', 'isEditing', 'receiver', 'sender', 'cashOnDelivery'));
            return product;
        }

        function repopulateProductIfEditing(product) {
            if (vm.isEditingParcel) {
                var newProduct = angular.copy(product);

                // If user switched to a new parcel that does not have Home delivery or Express addt'l service, remove doorCode in receiver info
                if (!_.some(newProduct.additionalServices, function(service) {
                    return ['2007690','2006740','2003744'].indexOf(service.baseProductId) >= 0 && service.selected;
                })) {
                    // Delete door code only if receiver address exist
                    if ($sessionStorage.editParcel.receiver && $sessionStorage.editParcel.receiver.address)
                        delete $sessionStorage.editParcel.receiver.address.doorCode;
                }

                var newReceiverZipCode = _.get(newProduct, 'receiver.address.zipCode');
                var newPickupLocation = _.get(newProduct, 'sender.pickup.locationInstruction');

                newProduct.sender = $sessionStorage.editParcel.sender;
                newProduct.receiver = $sessionStorage.editParcel.receiver;
                newProduct.invoice = $sessionStorage.editParcel.invoice;
                newProduct.cartId = $sessionStorage.editParcel.cartId;
                newProduct.itemId = $sessionStorage.editParcel.itemId;

                var requiredCustomsDeclarationType = Common.getRequiredCustomsDeclarationType(newProduct);
                newProduct.customsInformation = requiredCustomsDeclarationType && $sessionStorage.editParcel.customsInformation;

                if (newReceiverZipCode) {
                    _.set(newProduct, 'receiver.address.zipCode', newReceiverZipCode);
                }

                if (newPickupLocation) {
                    _.set(newProduct, 'sender.pickup.locationInstruction', newPickupLocation);
                }

                newProduct.isEditing = false;

                if (newProduct.receiver && newProduct.receiver.address) {
                    newProduct.receiver.address.countryCode = newProduct.receiverCountryCode;
                }

                return newProduct;
            } else {
                return product;
            }
        }

        function saveProduct(product) {
            var productExistsInCart = _.findWhere($sessionStorage.cart, { itemId: product.itemId });

            if (vm.isEditingParcel && productExistsInCart) {
                return saveProductToCart(product);
            } else if (isLetterOrDigitalStamps(product, appOptions.country)) {
                return saveLetterToCart(product, appOptions.country);
            } else {
                return saveProductToLocalStorage(product)
            }
        }

        function isLetterOrDigitalStamps(product, countryCode) {
            return (countryCode === 'DK' && product.type === 'letter')
                || (countryCode === 'SE' && AdditionalServiceHelper.hasSelectedAdditionalServiceId(product.additionalServices, 'digitalStamps'));
        }

        function saveProductToCart(product) {
            return CartFactory.updateProduct(product).then(function (response) {
                var productIndex = _.findIndex($sessionStorage.cart, {itemId: product.itemId});

                if (productIndex !== -1) {
                    $sessionStorage.cart[productIndex] = product;
                } else {
                    $sessionStorage.selected = angular.copy(product);
                }

                var requiredCustomsDeclarationType = Common.getRequiredCustomsDeclarationType(product);

                if (requiredCustomsDeclarationType && (appOptions.country !== 'SE' || FeatureToggleFactory.isFeatureEnabled('swedishCustoms')) && requiredCustomsDeclarationType !== _.get(product, 'customsInformation.type')) {
                    $sessionStorage.editParcel = angular.copy(product);
                    $state.go('main.customsNew');
                    // $state.go('main.customs');
                } else {
                    $state.go($sessionStorage.editingFromState);

                    delete $sessionStorage.editParcel;
                    delete $sessionStorage.editingFromState;
                }

                return product;
            });
        }

        function saveLetterToCart(product, countryCode) {
            product.cartId = LocalCartFactory.getCurrentLocalCartId();

            delete product.sender;
            delete product.receiver;

            _.set(product, 'sender.address.countryCode', countryCode);
            _.set(product, 'receiver.address.countryCode', product.receiverCountryCode);

            return CartFactory.addProduct(product).then(function (response) {
                // Save cartId and itemId that we got from server in the client side product
                if(!product.itemId) {
                    product.cartId = response.cartId;
                    product.itemId = response.itemId;
                }

                LocalCartFactory.addProduct(product);

                $rootScope.$broadcast('main:reloadCart');

                // Report number of items to topbar
                Topbar.updateCart();

                $state.go('main.payment');
            });
        }

        function saveProductToLocalStorage(product) {
            delete $sessionStorage.editParcel;
            $sessionStorage.selected = angular.copy(product);

            $state.go('main.address');

            return $q.when(product);
        }

        function finishProcessing(product) {
            vm.isProcessing = false;
            return product;
        }

        function isProductValid(product) {
            return product && _.every(product.additionalServices, function (service) {
                return !service.selected || service.isValid !== false;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
      .module('onlineShippingTool.customsNew')
      .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('main.customsNew', {
            url: '/customs-declaration?from',
            templateUrl: 'components/customs-new/customs.html',
            controller: 'CustomsNewController',
            controllerAs: 'customs',
        });
    }

  })();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool.customsNew')
        .controller('CustomsNewController', CustomsNewController)

    /** @ngInject */
    function CustomsNewController($log, $mdDialog, $scope, $sessionStorage, $state, $stateParams, $rootScope, appOptions, CartFactory, Common, CountryFactory, LocalCartFactory, Topbar) {
        var vm = this,
            productCustomsType,
            completed = false;
        vm.country = appOptions.country;
        vm.countries = [];
        vm.currency = appOptions.country === 'SE' ? 'SEK' : 'DKK';
        vm.itemLimit = appOptions.country === 'SE' ? 4 : 10;
        vm.okToProceed = false;

        vm.options = {
            exportTypes: ['DOCUMENTS', 'GIFT', 'RETURN', 'SAMPLE', 'SALE_OF_GOODS', 'OTHER'],
            currencies: ['SEK', 'EUR', 'USD', 'GBP'],
        };

        vm.updateCustomsType = updateCustomsType;
        vm.showExtendedForm = showExtendedForm;
        vm.addDocument = addDocument;
        vm.saveDocument = saveDocument;
        vm.editDocument = editDocument;
        vm.removeDocument = removeDocument;
        vm.addAndProceed = addAndProceed;
        vm.proceed = proceed;

        activate();

        $rootScope.$on('$stateChangeStart', function (event) {
            if (!vm.isEditingParcel && !completed && !vm.okToProceed) {
                event.preventDefault();
                vm.approveError = true;
                window.scrollTo(0,document.body.scrollHeight);
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'components/customs-new/leave.dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                });
            }
        });
        ///////////////////////
        function activate() {
            vm.isEditingParcel = false;
            vm.product = getProduct();
            vm.fromPayment = !!$stateParams.from;

            if (vm.product) {
                vm.documents = _.get(vm.product, 'customsInformation.items') || [];
                vm.document = vm.documents.length === 1 ? vm.documents[0] : {};
                vm.eori = vm.document.eori || undefined;

                productCustomsType = Common.getRequiredCustomsDeclarationType(vm.product);
                initIds(vm.documents);
                getCountries();
                updateCustomsType();
                vm.extendedFormVisible = !_.isEmpty(vm.document) || vm.documents.length > 0;
            } else {
                completed = true;
                $state.go($stateParams.from ? 'main.' + $stateParams.from : 'main.landing');
            }
        }

        function getProduct() {
            var product = $sessionStorage.selected;

            if (!product && $sessionStorage.editParcel && $sessionStorage.editParcel.itemId && $sessionStorage.editParcel.cartId) {
                product = $sessionStorage.editParcel;
                vm.isEditingParcel = true;
            }

            return angular.copy(product);
        }

        function initIds(documents) {
            _.each(documents, function (document, i) {
                document.id = i;
            });
        }

        function getCountries() {
            return CountryFactory.getCustomsCountries().then(function (countries) {
                $log.debug('CustomsNewController : getCountries : countries', countries);
                vm.options.countries = countries;
            });
        }

        function updateCustomsType() {
            vm.isCN23 = productCustomsType === 'CN 23' || vm.document.customsValue > 2000 || $sessionStorage.receiverCountryCode === 'CN';
        }

        function showExtendedForm() {
            vm.extendedFormVisible = true;
        }

        function getNextId() {
            return _.reduce(vm.documents, function (acc, document) {
                return Math.max(acc, document.id);
            }, 0) + 1;
        }

        function addDocument(document) {
            document.id = getNextId();
            document.currency = vm.currency;
            vm.documents.push(angular.copy(document));
            updateCustomsType();
            clearDocument();
        }

        function saveDocument(document) {
            var documentIdx = _.indexOf(vm.documents, _.find(vm.documents, { id: document.id }));
            vm.documents[documentIdx] = angular.copy(document);
            vm.isEditing = false;
            updateCustomsType();
            clearDocument();
        }

        function clearDocument() {
            vm.document = {};
            vm.valueForm.$setUntouched();
            vm.extendedForm.$setUntouched();
        }

        function editDocument(document) {
            vm.document = angular.copy(document);
            vm.isEditing = true;
        }

        function removeDocument(document) {
            $mdDialog.show({
                controller: 'RemoveDocumentDialogController',
                templateUrl: 'components/customs-new/remove-document-dialog/remove-document-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
            }).then(function () {
                vm.documents = _.without(vm.documents, _.find(vm.documents, { id: document.id }));
                updateCustomsType();
            });
        }

        function proceed(documents, state) {
          if(state === 'main.landing') {
            vm.isSubmittingLanding = true;
          }
            vm.product.customsInformation = {
                type: vm.isCN23 ? 'CN 23' : 'CN 22',
                items: _.map(documents, function (document) {
                    document.eori = vm.eori;
                    return angular.copy(_.omit(document, 'id'));
                })
            };

            if(state !== 'main.landing') {
                vm.isSubmitting = true;
            }

            LocalCartFactory.updateProduct(vm.product);
            CartFactory.updateProduct(vm.product).then(function (response) {
                completed = true;
                vm.isSubmitting = false;
                vm.isSubmittingLanding = false;

                if(state === 'main.landing') {
                    delete $sessionStorage.selected;
                    delete $sessionStorage.editParcel;
                    delete $sessionStorage.editingFromState;
                }
                
                $state.go(state);
            });
        }

        function addAndProceed(document) {
            vm.approveError = false;
            document.currency = vm.currency;
            vm.documents = [document];
            proceed(vm.documents);
        }

        function reloadCart() {
            $rootScope.$broadcast('main:reloadCart');
            Topbar.updateCart();
        }
        function DialogController($scope, $mdDialog, appOptions) {
          $scope.country = appOptions.country;

          $scope.cancel = function() {
            $mdDialog.hide();
          }
          $scope.confirm = function() {
            vm.okToProceed = true;
            var deleteProduct = _.find($sessionStorage.cart, function(item) {
              return item.itemId === vm.product.itemId;
            });
            CartFactory.removeProduct(deleteProduct).then(function () {
              $rootScope.$broadcast('product-removed');
              LocalCartFactory.removeProduct(deleteProduct);
              $sessionStorage.cart = _.without($sessionStorage.cart, deleteProduct);
              $rootScope.$broadcast('main:reloadCart');
              Topbar.updateCart();
              $state.go('main.landing');
            })
            $mdDialog.hide();
            $state.go('main.landing');
          };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.customs', []);
})();

(function() {
    'use strict';

    angular
      .module('onlineShippingTool.customs')
      .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('main.customs', {
            url: '/customs',
            templateUrl: 'components/customs/customs.html',
            controller: 'CustomsController',
            controllerAs: 'customs',
        });
    }

  })();

(function(){
    'use strict';

    angular
        .module('onlineShippingTool.customs')
        .controller('CustomsController', CustomsController)

    CustomsController.$inject = ['$log', '$mdDialog', '$sessionStorage', '$state', '$scope', 'CartFactory', 'Common', 'LocalCartFactory', '$rootScope', 'Topbar', 'CountryFactory'];

    function CustomsController($log, $mdDialog, $sessionStorage, $state, $scope, CartFactory, Common, LocalCartFactory, $rootScope, Topbar, CountryFactory ) {
        var vm = this;
        vm.addCustomsDocuments = addCustomsDocuments;
        vm.parcel = $sessionStorage.selected;
        vm.editParcel = editParcel;
        vm.addToCart = addToCart;
        vm.onlyFiveItemsAllowed = false;
        vm.cn22error = Boolean;
        vm.customsDocuments = {type: '', items: []}
        $scope.isDK = function() {
            return Common.getMarket() === 'DK';
        };

        $scope.$on('EditDocument', function(){
            vm.isEditingDocument = true;
            vm.docs = $sessionStorage.documentToEdit;
        });

        $scope.$on('$stateChangeStart', confirmLeave);

        activate();

        function activate() {
            vm.exportOptions = ['Documents', 'Gift', 'Return', 'Sample', 'Other'];
            vm.currencyOptions = ['DKK','EUR','USD','GBP'];
            CountryFactory.getCustomsCountries().then(function(countries){
                vm.originCountry = countries;
            })

            if($sessionStorage.editParcel && $sessionStorage.editParcel.itemId && $sessionStorage.editParcel.cartId) {
                vm.parcel = angular.copy($sessionStorage.editParcel);
                vm.parcel.isEditing = true;
                vm.editingFromState = $sessionStorage.editingFromState;
                vm.customsDocuments = vm.parcel.customsInformation || vm.customsDocuments;

            } else {
                if(vm.parcel && vm.parcel.customsInformation) {
                    vm.customsDocuments = vm.parcel.customsInformation;
                }
            }
            // Redirect to landing page if we don't have any parcel
            if (!vm.parcel) {
                $state.go('main.landing');
            }

            if (vm.customsDocuments.items.length > 1 && isCN22()) {
                vm.customsDocuments.type = 'CN 22';
            }
         }

         function isCN22() {
             var documents = Common.getDocumentsForParcel(vm.parcel);
             return _.chain(documents).find({ type: 'customsLabel' }).get('name').value() === 'CN 22';
         }

         function addCustomsDocuments(obj) {

            vm.form.$setSubmitted();
            if(vm.form.$valid && !vm.isEditingDocument && isCN22() && vm.customsDocuments.items.length >= 5) {
                vm.onlyFiveItemsAllowed = true;
            } else if(vm.form.$valid) {
                if($sessionStorage.documentToEditIndex >= 0){
                    vm.customsDocuments.items.splice($sessionStorage.documentToEditIndex, 1);
                    vm.customsDocuments.items.splice($sessionStorage.documentToEditIndex, 0, obj);
                } else {
                    vm.customsDocuments.items.push(obj);
                }
                vm.parcel.customsInformation = vm.customsDocuments;
                vm.docs = {};
                vm.isEditingDocument = false;
                vm.form.$setPristine();
                vm.form.$setUntouched();
                delete $sessionStorage.documentToEdit;
                delete $sessionStorage.documentToEditIndex;
            }

         }

         function editParcel(parcel) {
            $sessionStorage.editParcel = parcel;
            $sessionStorage.editingFromState = 'main.customs';
            $state.go('main.landing');
        }

        function addToCart(parcel, nextstate) {
            vm.nextState = nextstate;
            vm.isSubmitting = true;
            vm.parcel.isEditing = false;

            if(_.some(vm.parcel.additionalServices, function (service) {
                return service.selected && _.some(service.documents, { name: 'CN 22'})
            })) {
                parcel.customsInformation.type = 'CN 22';
            } else {
                parcel.customsInformation.type = parcel.documents[0].name;
            }

            LocalCartFactory.updateProduct(parcel);
            CartFactory.updateProduct(parcel).then(function (response) {
                // Save cartId and itemId that we got from server in the client side parcel

                delete $sessionStorage.selected;

                if ($sessionStorage.editParcel) {
                    delete $sessionStorage.editParcel;
                }

                if ($sessionStorage.editingFromState) {
                    delete $sessionStorage.isEditingDocument;
                    delete $sessionStorage.editingFromState;
                }

                $rootScope.$broadcast('main:reloadCart');

                vm.isSubmitting = false;
                vm.isCompleted = true;
                // Report number of items to topbar
                Topbar.updateCart();

                $state.go(vm.nextState);


            }).catch(function (response) {
                vm.errorWhenAdding = true;

                console.log("Error adding item to cart");
                console.dir(response);
            });
        }

        function confirmLeave(e) {
            if (!vm.parcel.isEditing && !vm.isCompleted) {
                e.preventDefault();
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'components/customs/leave.dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                });
            }
        }

        function DialogController($scope, $mdDialog, appOptions) {
            $scope.country = appOptions.country;

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.confirm = function() {
                $mdDialog.hide();
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.banners')
        .factory('BannersFactory', BannersFactory);

    BannersFactory.$inject = ['$localStorage'];

    /* @ngInject */
    function BannersFactory($localStorage) {
        var service = {
            isBannerDismissed: isBannerDismissed,
            dismissBanner: dismissBanner
        };

        return service;

        function isBannerDismissed(name) {
            return _.get($localStorage, 'dismissedBanners[' + name + ']') === true;
        }

        function dismissBanner(name) {
            $localStorage.dismissedBanners = $localStorage.dismissedBanners || {};
            $localStorage.dismissedBanners[name] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .factory('UnsupportedEmailFactory', UnsupportedEmailFactory);

    UnsupportedEmailFactory.$inject = [];

    /* @ngInject */
    function UnsupportedEmailFactory() {
        var service = {
            getDomains: getDomains
        };

        return service;

        function getDomains() {
            return [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('unsupportedEmail', unsupportedEmail);

    /* @ngInject */
    function unsupportedEmail(UnsupportedEmailFactory) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                unsupportedEmail: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attrs, ctrl) {
            var unsupportedDomains = UnsupportedEmailFactory.getDomains();

            // Check when user changes input
            ctrl.$parsers.push(checkEmail);

            // Check when input is changed programmatically
            ctrl.$formatters.push(checkEmail);

            function checkEmail(value) {
                scope.unsupportedEmail = _.find(unsupportedDomains, function (domain) {
                    return value && value.indexOf('@' + domain) !== -1;
                });

                return value;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('senderForm', senderForm);

    /* @ngInject */
    function senderForm() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/sender-form.directive.html',
            scope: {
                form: '=',
                sender: '=',
                product: '=',
                isSubmitted: '=',
            },
            link: linkFunc,
            controller: SenderFormController,
            controllerAs: 'senderForm',
            bindToController: true
        };

        function linkFunc(scope, element, attrs, $localStorage) {
            scope.name = attrs.name;
            scope.senderForm.country = attrs.country;

            var isCompany = $localStorage.isCustomerCompany;
            var loaded = false;

            scope.$watch('senderForm.validationStatus', function(status) {
              if(status === 'invalid') {
                scope.senderForm.form.senderPostalCode.$setValidity('invalidPostalCode', false);
              } else if(status === 'valid') {
                scope.senderForm.form.senderPostalCode.$setValidity('invalidPostalCode', true);
              }
            })
            scope.$watch('senderForm.sender.name', function(newVal){
                if (!!newVal && isCompany && !loaded) {
                    if (scope.senderForm && scope.senderForm.sender) {
                        scope.senderForm.sender.name = null;
                        loaded = true;
                    }
                }
            })
        }

        return directive;
    }

    SenderFormController.$inject = ['$log', '$localStorage', 'Common', 'REGEX_VALID_ADDRESS_CHARACTERS'];

    /* @ngInject */
    function SenderFormController($log, $localStorage, Common, REGEX_VALID_ADDRESS_CHARACTERS) {
        var vm = this;

        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        vm.regex = REGEX_VALID_ADDRESS_CHARACTERS;

        vm.productCapabilities = Common.getProductCapabilities(vm.product);
        vm.deliveryConfirmationPossible = _.get(vm.productCapabilities, 'notificationFields.notificationsPossible') !== false;
    }
})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .directive('receiverForm', receiverForm);

    /* @ngInject */
    function receiverForm() {
        var directive = {
            restrict: 'E',
            templateUrl: 'components/address/receiver-form.directive.html',
            scope: {
                receiver: '=',
                form: '=',
                isSubmitted: '=',
                parcel: '=',
                country: '=',
                editParcelCallback: '&',
            },
            link: linkFunc,
            controller: ReceiverFormController,
            controllerAs: 'receiverForm',
            bindToController: true,
        };

        function linkFunc(scope, element, attrs) {
            var vm = scope.receiverForm;
            scope.name = attrs.name;

            scope.$watch('receiverForm.receiver', function (receiver) {
                vm.setRequiredFields(scope.receiverForm.parcel);
            }, true);
            scope.$watch('receiverForm.validationStatus', function(status) {
              if(status === 'invalid') {
                vm.form.receiverPostalCode.$setValidity('invalidPostalCode', false);
              } else if(status === 'valid') {
                vm.form.receiverPostalCode.$setValidity('invalidPostalCode', true);
              }
            })
            scope.$watch('receiverForm.parcel', function(parcel){
                vm.checkForHomeDelivery(parcel);
                vm.checkForLetterNotification(parcel);
                vm.checkForExpress(parcel);
                vm.checkForDeliveryToCompany(parcel);
                vm.checkForDanishREK(parcel);
                vm.checkForDanishValuePackage(parcel);
                vm.setCustomServicePointService(parcel);

                vm.setRequiredFields(parcel);
            }, true);
        }

        return directive;
    }

    /* @ngInject */
    function ReceiverFormController($log, $rootScope, $scope, $sessionStorage, Common, FeatureToggleFactory, ReceiversFactory, UserFactory, REGEX_VALID_ADDRESS_CHARACTERS) {
        var vm = this;

        vm.regexp = $sessionStorage.receiverCountry.postalCodeRegExp ? $sessionStorage.receiverCountry.postalCodeRegExp : '';
        vm.receiverCountryCode = $sessionStorage.receiverCountryCode;
        vm.phoneRequired = false;
        vm.emailRequired = false;
        vm.regex = REGEX_VALID_ADDRESS_CHARACTERS;
        vm.zipCodeRegex = '([a-zA-Z0-9][- ]*){1,9}';

        vm.checkForHomeDelivery = checkForHomeDelivery;
        vm.checkForLetterNotification = checkForLetterNotification;
        vm.checkForExpress = checkForExpress;
        vm.checkForDeliveryToCompany = checkForDeliveryToCompany;
        vm.checkForDanishREK = checkForDanishREK;
        vm.checkForDanishValuePackage = checkForDanishValuePackage;
        vm.setCustomServicePointService = setCustomServicePointService;
        vm.queryStoredReceivers = queryStoredReceivers;
        vm.importPhoneContacts = importPhoneContacts;
        vm.supportsPhoneContactsImport = supportsPhoneContactsImport;
        vm.selectStoredReceiver = selectStoredReceiver;
        vm.changeToCountryWithBlockedPostalCode = changeToCountryWithBlockedPostalCode;
        vm.setRequiredFields = setRequiredFields;
        vm.allowBusinessReceiver = true;
        vm.allowPrivateReceiver = true;
        vm.toggleBusinessReceiver = toggleBusinessReceiver;
        vm.isNordicCountry = isNordicCountry;
        vm.hasCustomsDocuments = hasCustomsDocuments;

        activate();

        ////////////////////

        function activate() {
            vm.loggedIn = UserFactory.isLoggedIn();
            vm.isLockedZipCode = checkIfZipCodeIsLocked(vm.receiver, vm.parcel);
            vm.extraAddressFieldsEnabled = FeatureToggleFactory.isFeatureEnabled('extraInternationalRecipientAddressFields');
            vm.isBusinessReceiver = !!vm.receiver && !!vm.receiver.company;
            vm.market = Common.getMarket();

            vm.productCapabilities = Common.getProductCapabilities(vm.parcel);
            vm.deliveryConfirmationPossible = _.get(vm.productCapabilities, 'notificationFields.notificationsPossible') !== false;

            // Always initialize to default behavior: show both "Private" and "Company" receiver tab
            vm.allowPrivateReceiver = true;
            vm.allowCompanyReceiver = true;

            // If selected parcel has "Delivery To Company" service
            // Do not allow private individual recipients
            if (isParcelForBusinessReceiverOnly(vm.parcel)) {
                vm.isBusinessReceiver = true;
                vm.allowBusinessReceiver = true;
                vm.allowPrivateReceiver = false;
            }

            // If selected parcel has "Home Delivery" service
            // Do not allow company recipients
            if (isParcelForPrivateReceiverOnly(vm.parcel)) {
                vm.isBusinessReceiver = false;
                vm.allowBusinessReceiver = false;
                vm.allowPrivateReceiver = true;
            }

            setNotificationFields(vm.parcel);
        }
        function isNordicCountry(countryCode) {
          return ['SE', 'DK', 'NO', 'FI'].includes(countryCode)
        }
        function checkIfZipCodeIsLocked(receiver, parcel) {
            if(receiver && parcel) {
                var hasZipCode = !!_.get(receiver, 'address.zipCode');
                var hasValidatedZipCode = _.some(parcel.additionalServices, function(service){
                    return service.selected && ['Expresspaket','Utkörning-till-företag-09','Utkörning-till-företag-12','Express_bas','2003744'].indexOf(service.additionalServiceId) !== -1;
                })
                return hasZipCode && hasValidatedZipCode;
            }
        }
        function checkForHomeDelivery(parcel) {
            if (parcel) {
                vm.parcel.hasHomeDelivery = _.some(parcel.additionalServices, function(service){
                    return ((service.baseProductId === '2007690' || service.baseProductId === '2006740' || service.additionalServiceId === 'HomeDelivery' ) && service.selected)
                });
            }
        }

        function checkForLetterNotification(parcel) {
            if (parcel) {
                vm.parcel.hasLetterNotification = _.some(parcel.additionalServices, function (service) {
                    return service.additionalServiceId === '2009466' && service.selected;
                });
            }
        }

        function checkForExpress(parcel) {
            if (parcel) {
                vm.parcel.hasExpress = _.some(parcel.additionalServices, function(service){
                    return (((service.baseProductId === '2007110') || (service.baseProductId === '1001019')) && service.selected)
                });
            }
        }

        function checkForDeliveryToCompany(parcel) {
            if (parcel) {
                vm.parcel.hasDeliveryToCompany = _.some(parcel.additionalServices, function(service){
                    // Delivery To Company: PostNord Parcel, PostNord Parcel 09, PostNord Parcel 12
                    return (_.indexOf(['1001003', '1001014', '1001002'], service.baseProductId) >= 0 && service.selected)
                });
            }
        }

        function checkForDanishREK(parcel) {
            vm.isDanishREK = _.some(parcel.additionalServices, function (service) {
                return service.selected && ['144299', '144297'].indexOf(service.additionalServiceId) !== -1;
            });

        }

        function checkForDanishValuePackage(parcel) {
            vm.isDanishValuePackage = _.some(parcel.additionalServices, function (service) {
                return service.selected && service.type === 'valuePackage'
            });
        }

        function supportsPhoneContactsImport() {
            return !!navigator.contacts;
        }

        function importPhoneContacts() {
            if (!supportsPhoneContactsImport()) {
                return;
            }
            var props = ['name', 'email', 'tel'/*, 'address'*/];
            var opts = { multiple: true };
            navigator.contacts.select(props, opts).then(function(contacts) {
                if (contacts.length > 0) {
                    var mapped = mapPhoneContacts(contacts);
                    $scope.$apply(function() {
                        vm.selectStoredReceiver(mapped[0]);
                    });
                }
            });
        }

        function mapPhoneContacts(contacts) {
            return _.map(contacts, function (contact) {
                var address = contact.address && contact.address.length > 0 ? contact.address[0] : {};
                return {
                    name: contact.name && contact.name.length > 0 ? contact.name[0] : undefined,
                    phone: ((vm.notificationFields && vm.notificationFields.sms) || vm.country !== 'DK') && contact.tel && contact.tel.length > 0 ? contact.tel[0] : undefined,
                    address: {
                        street: address.addressLine,
                        zipCode: address.postalCode,
                        city: address.city,
                        countryCode: address.country
                    },
                    email: vm.deliveryConfirmationPossible && contact.email && contact.email.length > 0 ? contact.email[0] : undefined
                };
            });
        }

        function queryStoredReceivers(query) {
            return ReceiversFactory.queryReceivers(query).then(function (receivers) {
                return receivers;
            });
        }

        function selectStoredReceiver($item, $model, $label, $event) {
            vm.receiver = _.omit($item, 'receiverId');
            vm.isBusinessReceiver = $item.company && $item.company.length > 0;
            vm.searchString = null;
        }

        function setCustomServicePointService(parcel) {
            vm.customServicePointService = _.find(parcel.additionalServices, {additionalServiceId: 'CustomServicePointDelivery'});
        }

        function changeToCountryWithBlockedPostalCode(countryCode) {
            $sessionStorage.receiverCountryCode = countryCode;
            $rootScope.$broadcast('main:loadParcelTypes', countryCode);
            vm.editParcelCallback()(vm.parcel);
        }

        function setNotificationFields(product) {
            vm.productCapabilities = Common.getProductCapabilities(vm.parcel);

            var atleastOneRequired = _.get(vm.productCapabilities, 'notificationFields.atleastOneRequired');
            var optional = _.get(vm.productCapabilities, 'notificationFields.optional');
            if ((atleastOneRequired && atleastOneRequired.length) || (optional && optional.length)) {
                vm.notificationFields = {};
                _.each(atleastOneRequired, function (field) {
                    vm.notificationFields[field] = true;
                });
                _.each(optional, function (field) {
                    vm.notificationFields[field] = true;
                });
            } else if (hasCustomsDocuments(vm.parcel)) {
                vm.notificationFields = {
                    sms: true,
                    email: true
                };
            } else {
                vm.notificationFields = null;
            }
        }

        function hasCustomsDocuments(product) {
            var documents = Common.getDocumentsForParcel(product);
            return _.chain(documents).find({ type: 'customsLabel' }).value();
        }

        function setRequiredFields(product) {
            var atleastOneRequired = _.get(vm.productCapabilities, 'notificationFields.atleastOneRequired');
            vm.notificationFieldRequired = atleastOneRequired && atleastOneRequired.length && _.every(atleastOneRequired, function (field) {
                switch (field) {
                    case 'letter':
                        return !product.selectedLetterNotification;
                    case 'sms':
                        return !vm.receiver || !vm.receiver.phone;
                    case 'email':
                        return !vm.receiver || !vm.receiver.email;
                }
            });

            var isLetterNotificationAvailable = _.some(product.additionalServices, function (service) {
                return service.additionalServiceId === '2009466'
            });

            if (!product.phoneRequired && product.receiverCountryCode !== 'SE' && product.receiverCountryCode !== 'DK') {
                vm.emailRequired = false;
            }

            if (!product.phoneRequired && product.receiverCountryCode === 'SE') {
                vm.emailRequired = (!vm.receiver || !vm.receiver.phone) && (product.hasHomeDelivery || (isLetterNotificationAvailable && !product.hasLetterNotification ))
            }

            if (product.receiverCountryCode !== 'SE' && product.type !== 'package') {
                vm.phoneRequired = product.phoneRequired;
            }

            if (product.receiverCountryCode === 'SE') {
                vm.phoneRequired = (!vm.receiver || !vm.receiver.email) && (product.hasHomeDelivery || (isLetterNotificationAvailable && !product.hasLetterNotification ))
            }
        }


        function isParcelForBusinessReceiverOnly(parcel){
            return _.some(parcel.additionalServices, function(service){
                // Delivery To Company: PostNord Parcel, PostNord Parcel 09, PostNord Parcel 12
                return Boolean((_.indexOf(['1001003', '1001014', '1001002'], service.baseProductId) >= 0) && service.selected);
            });
        }

        function isParcelForPrivateReceiverOnly(parcel){
            return _.some(parcel.additionalServices, function(service){
                // MyPack Home and MyPack Home Small
                return Boolean((_.indexOf(['2006740', '2007690'], service.baseProductId) >= 0) && service.selected);
            });
        }

        function toggleBusinessReceiver(isBusinessReceiver) {
            vm.isBusinessReceiver = isBusinessReceiver;

            if (vm.receiver) {
                if (isBusinessReceiver) {
                    vm.receiver.name = undefined;

                    if (vm.receiver.address) {
                        vm.receiver.address.co = undefined;
                    }
                } else {
                    vm.receiver.company = undefined;
                    vm.receiver.attn = undefined;
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
    .module('onlineShippingTool')
    .directive('blockedPostalCode', blockedPostalCode);

    /* @ngInject */
    function blockedPostalCode($parse) {
        var directive = {
            restrict: 'A',
            scope: {
                blockedPostalCode: '=',
                blockedPostalCodes: '='
            },
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            ctrl.$parsers.unshift(function (value) {
                var valid = validatePostalCode(value);
                ctrl.$setValidity('blockedPostalCode', valid);
                return valid ? value : undefined;
            });

            ctrl.$formatters.unshift(function (value) {
                var valid = validatePostalCode(value);
                ctrl.$setValidity('blockedPostalCode', valid);
                return value;
            });

            function validatePostalCode(value) {
                var blockedPostalCode = _.find(scope.blockedPostalCodes, function(blockedCode) {
                    var regEx = new RegExp(blockedCode.regExp);

                    if(value) {
                        value = value.toUpperCase();
                    }

                    return regEx.test(value);
                });

                if(blockedPostalCode) {
                    scope.blockedPostalCode = blockedPostalCode;
                    return false;
                } else {
                    scope.blockedPostalCode = null;
                    return true;
                }
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool.address')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.address', {
          url: '/address',
          templateUrl: 'components/address/address.html',
          controller: 'AddressController',
          controllerAs: 'address'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.address')
        .controller('AddressController', AddressController);

    AddressController.$inject = ['$localStorage', '$log', '$rootScope', '$sessionStorage', '$state', 'CartFactory', 'FeatureToggleFactory', 'LocalCartFactory', 'Topbar', 'UnsupportedEmailFactory', 'appOptions', 'StoredSenderFactory', '$translate', '$filter', 'UserFactory', 'ZipcodeCityFactory', '$scope'];

    /* @ngInject */
    function AddressController($localStorage, $log, $rootScope, $sessionStorage, $state, CartFactory, FeatureToggleFactory, LocalCartFactory, Topbar, UnsupportedEmailFactory, appOptions, StoredSenderFactory, $translate, $filter, UserFactory, ZipcodeCityFactory, $scope) {
        var vm = this;
        vm.isCustomerCompany = $localStorage.isCustomerCompany;
        vm.addToCart = addToCart;
        vm.editParcel = editParcel;
        vm.editParcelInCart = editParcelInCart;
        vm.cancelEdit = cancelEdit;
        vm.setCustomsDocumentsAvailability = setCustomsDocumentsAvailability;

        vm.cart = $sessionStorage.cart;
        vm.showSenderForm = true;
        vm.errorWhenAdding = false;
        vm.isLoggedInUser = UserFactory.isLoggedIn();
        vm.isUserAccountMissingInfo = isUserAccountMissingInfo;
        document.body.onscroll = onScroll;
        vm.stickyProductYposition = 0;
        vm.scrollToProductSelector = scrollToProductSelector;

        activate();

        ///////////////////////

        function activate() {
            if($sessionStorage.editParcel && $sessionStorage.editParcel.itemId && $sessionStorage.editParcel.cartId) {
                vm.parcel = angular.copy($sessionStorage.editParcel);
                vm.parcel.isEditing = true;
                vm.editingFromState = $sessionStorage.editingFromState;
            } else {
                vm.parcel = $sessionStorage.selected;
            }
            setCustomsDocumentsAvailability(vm.parcel);
            // Redirect to landing page if we don't have any parcel
            if (!vm.parcel) {
                $state.go('main.landing');
            }

            $log.debug('AddressController : activate : selected', $sessionStorage.selected);

            if (vm.parcel !== undefined && (vm.parcel.sender || vm.parcel.receiver)) {
                vm.sender = vm.parcel.sender;
                vm.saveSenderInformation = true;
                vm.receiver = vm.parcel.receiver;
            } else if (UserFactory.isLoggedIn() || $localStorage.sender) {
                populateAccountData();
            }

            vm.saveSenderInformation = true;
            vm.showSenderForm = !isSenderFormValid(vm.sender);

            $rootScope.$on('userLogin', loginChanged);
            $rootScope.$on('userLogout', loginChanged);
        }

        function setCustomsDocumentsAvailability(parcel) {
            var hasCustomsDocumentInProduct = _.some(parcel.documents, { type: 'customsLabel'});
            var hasCustomsDocumentInAdditionalServices = _.some(parcel.additionalServices, function (service) {
                return service.selected && _.some(service.documents, { type: 'customsLabel' });
            });
            vm.parcelHasCustomsDocument = (appOptions.country !== 'SE' || FeatureToggleFactory.isFeatureEnabled('swedishCustoms')) && (hasCustomsDocumentInProduct || hasCustomsDocumentInAdditionalServices);
        }

        function addToCart(parcel, sender, receiver, saveSenderInformation, addMore) {
            vm.errorWhenAdding = false;
            sender.address.zipCode = sender.address.zipCode.replace(/\s/g, '');
            receiver.address.zipCode = receiver.address.zipCode.replace(/\s/g, '');
            vm.addressForm.$setSubmitted();

            if (vm.addressForm.$valid) {
                vm.isSubmitting = true;
                parcel.isEditing = false;

                // Take the cartId from the first parcel in the cart, if it exists
                if ($sessionStorage.cart && $sessionStorage.cart[0] && $sessionStorage.cart[0].cartId) {
                    $log.debug("Adding previously generated cartId to parcel");
                    parcel.cartId = $sessionStorage.cart[0].cartId;
                } else {
                    $log.debug("First parcel, setting cartId to null");
                    parcel.cartId = null;
                }

                if (receiver.phone && $sessionStorage.receiverCountryCode === 'SE') {
                    receiver.phone = phoneUtils.formatE164(receiver.phone, 'SE').replace('+46', 0);
                }

                sender.address.countryCode = appOptions.country;
                receiver.address.countryCode = $sessionStorage.receiverCountryCode;
                parcel.sender = sender;
                parcel.receiver = receiver;

                if(vm.isLoggedInUser && saveSenderInformation && isUserAccountMissingInfo()){
                    UserFactory.updateUserInfo(vm.sender)
                }

                StoredSenderFactory.set(vm.sender);

                if (!!addMore) {
                    vm.nextState = 'main.landing';
                    sendParcelAddedToCartEvent(parcel)
                } else if((appOptions.country !== 'SE' || FeatureToggleFactory.isFeatureEnabled('swedishCustoms')) && vm.parcelHasCustomsDocument) {
                    vm.nextState = appOptions.country === 'DK' && !FeatureToggleFactory.isFeatureEnabled('danishNewCustoms') ? 'main.customs' : 'main.customsNew';
                } else {
                    vm.nextState = 'main.payment';
                }

                CartFactory.addProduct(parcel).then(function (response) {
                    $log.debug('AddressController : addToCart : response', response);
                    // Save cartId and itemId that we got from server in the client side parcel
                    if(!parcel.itemId) {
                        parcel.cartId = response.cartId;
                        parcel.itemId = response.itemId;
                    }

                    vm.isSubmitting = false;

                    LocalCartFactory.addProduct(parcel);

                    if (vm.nextState === 'main.customs' || vm.nextState === 'main.customsNew') {
                        $sessionStorage.selected = parcel;
                    } else {
                        delete $sessionStorage.selected;
                    }

                    $rootScope.$broadcast('main:reloadCart');

                    // Report number of items to topbar
                    Topbar.updateCart();

                    $state.go(vm.nextState);

                    vm.nextState = undefined;
                }).catch(function (response) {
                    vm.isSubmitting = false;
                    vm.nextState = undefined;
                    vm.errorWhenAdding = true;

                    $log.debug("Error adding item to cart");
                    $log.debug(response);
                });
            } else if (vm.senderForm.$invalid) {
                vm.showSenderForm = true;
            }
        }

        function editParcelInCart (parcel, sender, receiver, saveSenderInformation) {
            if (vm.addressForm.$valid) {
                vm.isSubmitting = true;

                if (receiver.phone && $sessionStorage.receiverCountryCode === 'SE') {
                    receiver.phone = phoneUtils.formatE164(receiver.phone, 'SE').replace('+46', 0);
                }

                parcel.sender = sender;
                parcel.receiver = receiver;

                CartFactory.updateProduct(parcel).then(function (response) {
                    vm.isSubmitting = false;
                    parcel.isEditing = false;
                    if ($sessionStorage.cart && $sessionStorage.cart.length > 0 && $sessionStorage.editingFromState) {
                        for (var i = 0; i < $sessionStorage.cart.length; i++) {
                            if ($sessionStorage.cart[i].itemId === parcel.itemId) {
                                $sessionStorage.cart[i] = parcel;
                                $sessionStorage.cart[i].cartId = parcel.cartId;
                                $state.go($sessionStorage.editingFromState);
                                delete $sessionStorage.editingFromState;
                                delete $sessionStorage.editParcel;
                            }
                        }
                    }
                });
            } else if (vm.senderForm.$invalid) {
                vm.showSenderForm = true;
            }
        }

        function cancelEdit(parcel) {
            var cartParcel = _.find($sessionStorage.cart, {itemId: parcel.itemId});
            cartParcel.isEditing = false;
            $rootScope.$broadcast('main:reloadCart');

            $state.go($sessionStorage.editingFromState);
            delete $sessionStorage.editingFromState;
            delete $sessionStorage.editParcel;
        }

        function editParcel(parcel) {
            parcel.sender = vm.sender;
            parcel.receiver = vm.receiver;
            $sessionStorage.editParcel = parcel;
            $sessionStorage.editingFromState = 'main.address';
            $state.go('main.landing');
        }

        function isSenderFormValid(sender) {
            var unsupportedDomains = UnsupportedEmailFactory.getDomains();
            var requiredProperties = ['address.zipCode', 'address.city', 'email'];

            if (vm.isCustomerCompany) {
                requiredProperties = _.union(requiredProperties, ['company.name', 'company.organizationNumber']);
            } else {
                requiredProperties = _.union(requiredProperties, ['name', 'address.street']);
            }

            var res = _.every(requiredProperties, function (p) {
                return _.has(sender, p);
            });

            var isUnsupportedEmail = _.some(unsupportedDomains, function (domain) {
                return sender && sender.email && sender.email.indexOf('@' + domain) !== -1;
            });

            return res && !isUnsupportedEmail;
        }

        function sendParcelAddedToCartEvent(parcel){
            var price = $filter('price')(parcel.price);
            var currency = appOptions.country === 'SE' ? 'SEK' : 'DKK';
            currency = $filter('prettifyCurrency')(currency);
            $translate('LANDING_PAGE_PRODUCT_ADDED_MESSAGE', {name: parcel.canonicalName, price: price, currency: currency}).then(function(translatedMessage){
                $rootScope.$broadcast('parcelAddedToCart', translatedMessage);
            });
        }

        function getStickyProductYposition() {
            var topbar = document.getElementById('pnSideMenuContent');
            if(topbar) {
                return topbar.offsetHeight;
            }
            return 0;
        }
        function onScroll() {
            var selectedProduct = document.getElementsByClassName('selected-product')[0];
            if(!!selectedProduct){
                var selectedProductBottomY = selectedProduct.offsetHeight + selectedProduct.offsetTop;
                $scope.$apply(function() {
                    vm.productSticky = document.scrollingElement.scrollTop > selectedProductBottomY;
                    if(vm.stickyProductYposition === 0){
                        vm.stickyProductYposition = getStickyProductYposition();
                    }
                });
            }
        }
        function scrollToProductSelector(){
            var selectedProduct = document.getElementsByClassName('selected-product')[0];
            if(!!selectedProduct){
                scrollTo({ top: selectedProduct.offsetTop - 15, behavior: 'smooth'});
            }
        }

        function loginChanged(){
            vm.isLoggedInUser = UserFactory.isLoggedIn();
        }

        function populateCompanyData(){
            return tryPrefillCompanyInfo().then(function(companyData){
                if(companyData){            
                    if(companyData.legalName){
                        vm.sender.company.name = companyData.legalName;
                    }

                    if(companyData.registrationNumber){
                        vm.sender.company.organizationNumber = companyData.registrationNumber;
                    }
                }
            })

            function tryPrefillCompanyInfo(userObj){
                return UserFactory.getCompanyInfo().then(function(response){
                    if(response && response.data){
                        var companyData = angular.copy(response.data);
                        return companyData[0];
                    }
                });
            }
        }

        function populateAccountData(){
            vm.isLoadingUserInfo = true;

            if ($localStorage.sender) {
                vm.sender = angular.copy(StoredSenderFactory.get());
                vm.isLoadingUserInfo = false;
                return;
            }

            getUserData().then(function(userData){
                if(userData){
                    vm.userData = userData;
                    mapUser(userData);
                }

                if(!vm.isCustomerCompany) {
                    vm.isLoadingUserInfo = false;
                }
            }).then(function(){
                if(vm.isCustomerCompany){
                    populateCompanyData().finally(function(){ vm.isLoadingUserInfo = false; });
                }
            }).finally(function(){
                vm.showSenderForm = !isSenderFormValid(vm.sender);
            });

            function mapUser(userData) {
                vm.sender = {
                    email: userData.mail.value,
                    name: userData.firstName + ' ' + userData.lastName,
                    address: {},
                    company: {}
                };
                if(userData.street){
                    vm.sender.address.street = userData.street;
                }
                if(userData.postalCode){
                    vm.sender.address.zipCode = userData.postalCode;
                }
                if(userData.city){
                    vm.sender.address.city = userData.city;
                }
            }

            function getUserData(){
                return UserFactory.getUserInfo()
                .then(function(user) {
                    if(user && user.data){
                        var userData = angular.copy(user.data);
                        if(userData.postalCode){
                            return ZipcodeCityFactory.getCityByZipcode(appOptions.country, userData.postalCode)
                            .then(function(response) {
                                if (response.data && response.data[0].city){
                                    var city = response.data[0].City;
                                    userData.city = city;
                                }
                                return userData;
                            })
                            .catch(function() {
                                return userData;
                            });
                        }
                        return userData;
                    } else {
                        return null;
                    }
                })
                .catch(function() {
                    return null;
                });
            }
        }

        function isUserAccountMissingInfo() {
            return vm.userData && (!vm.userData.street || !vm.userData.postalCode);
        }
    }
})();

"use strict";

var OnlineShippingTool = OnlineShippingTool || {};
var exports = exports || {};

OnlineShippingTool.env = {
    appleWalletUrl: "https://portal.postnord.com/api/document/wallet-pass/{bookingId}?locale={language}",
    googleWalletUrl: "https://portal.postnord.com/api/document/google-pay-pass/",
    giroValidationUrl: "https://portal.postnord.com/api/validation/validateGiro",
    countriesUrl: "https://portal.postnord.com/api/pricing/countries",
    customsCountriesUrl: "https://portal.postnord.com/api/pricing/customsCountries",
    productsUrl: "https://portal.postnord.com/api/pricing/products",
    cartsUrl: "https://portal.postnord.com/api/cart/carts",
    cartsHistoryUrl: "https://portal.postnord.com/api/shipment-history/carts",
    referralCartUrl: "https://portal.postnord.com/api/digital-agent/prefilled-cart/get",
    publicCartsUrl: "https://portal.postnord.com/api/cart/carts/public",
    receiversUrl: "https://portal.postnord.com/api/receiver/receivers",
    fetchDocumentUrl: "https://portal.postnord.com/api/document/fetchDocument",
    fetchPrintPageUrl: "https://portal.postnord.com/api/document/fetchPrintPage",
    fetchReceiptHtmlUrl: "https://portal.postnord.com/api/document/fetchPdfReceipt",
    fetchReceiptPrintPage: "https://portal.postnord.com/api/document/fetchReceiptPrintPage",
    fetchReceiptPortoCodesPrintPage: "https://portal.postnord.com/api/document/fetchPortoCodesPrintPage",
    fetchReceiptPortoCodesHtmlUrl: "https://portal.postnord.com/api/document/fetchPdfPortoCodes",
    portoCodeImageUrl: "https://portal.postnord.com/api/document/portocode",
    topBarUrl: "https://portal.postnord.com/pntopbar/shippingtool",
    marketwebEndpoint: "https://com-prod.postnord.com",
    marketwebEnvironment: 'production',
    paymentMethodsUrl: "https://portal.postnord.com/api/payment/v1/clients/ST/countries/{countryCode}/paymentmethods",
    paymentMethodsUrlV2: "https://portal.postnord.com/api/checkout/clients/ST/countries/{countryCode}/platforms/web/paymentmethods",
    initializePaymentUrl: "https://portal.postnord.com/api/payment/v1/carts/{cartId}/payments",
    initializePaymentUrlV2: "https://portal.postnord.com/api/checkout/carts/{cartId}/payments",
    verifyPaymentUrl: "https://portal.postnord.com/api/checkout/carts/{cartId}/payments/verification",
    postalCodeValidationUrl: 'https://api2.postnord.com/rest/shipment/v1/sac/postalcode/validate',
    bookingUrl: "https://portal.postnord.com/api/booking/bookings/book",
    digitalStampsUrl: "https://portal.postnord.com/api/document/digitalStamps",
    paymentRedirectUrl: "#/payment-redirect",
    claimsUrl: 'https://portal.postnord.com/claimspublic/#/claims',
    newBaseURL: 'https://kopfrakt.postnord.se/',
    userUrl: 'https://gate.ess.postnord.com/scim/Me',
    transitTimeURL: 'https://ostbase.aws.postnord.com/rest/customer/v1/ostb/os/service/postalcodes/validate', // this is an api from OST v2. the new transit time url needs an api key which we dont want to expose here
    findByIdentifierURL: 'https://api2.postnord.com/rest/shipment/v4/trackandtrace/findByIdentifier.json',
    bap_key: {'x-bap-key' : 'ost-base'},
    topBarUrls: {
        se: 'https://portal.postnord.com/pntopbar/skickadirekt',
        dk: 'https://portal.postnord.com/pntopbar/onlineporto'
    },
    portalMenuUrls: {
        se: 'https://portal.postnord.com/portalmenu/menu.js',
        dk: 'https://portal.postnord.com/portalmenu/menu.js'
    },
    baseUrls: {
        se: 'https://portal.postnord.com/skickadirekt/',
        dk: 'https://portal.postnord.com/onlineporto/'
    },
    portalBaseUrl: 'https://portal.postnord.com',
    updateUserInfoUrl: 'https://inm965msrj.execute-api.eu-west-1.amazonaws.com/prod/userdata',
    updateCompanyInfoUrl: 'https://portal.postnord.com/api/company-info',
    humanyFloatingWidgetPrefixSE: "st-floating-",
    enabledFeatures: {
        qrCode: true,
        danishPortoCodeImageUpload: true,
        danishREK: true,
        danishValuables: true,
        danishInternational: true,
        danishNewValuables: true,
        extraInternationalRecipientAddressFields: true,
        swish: true,
        swedishCustoms: true,
        sePaymentSystemVersion2: true,
        dkPaymentSystemVersion2: true,
        portokoder: true,
        googlePay: true,
        applePay: true,
        betaBanner: true
    },
    gtmId: "GTM-MKQSVP",
    defaultCountry: 'SE',
    enableDebugLogging: false,
    stage: "prod"
};

exports.env = {
    topBarUrl: OnlineShippingTool.env.topBarUrl,
    topBarUrls: OnlineShippingTool.env.topBarUrls,
    portalBaseUrl: OnlineShippingTool.env.portalBaseUrl,
    portalMenuUrls: OnlineShippingTool.env.portalMenuUrls,
    baseUrls: OnlineShippingTool.env.baseUrls,
    gtmId: OnlineShippingTool.env.gtmId,
};

(function() {
  'use strict';

  angular
    .module('onlineShippingTool')
        .value('appOptions', {
            country: 'SE'
        });

})();

(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .run(isFeatureEnabled)
        .run(checkBrowserSupport)
        .run(checkLocalStorageAvailability)
        .run(initTopbarCart)
        .run(initEnvironmentSettings)
        .run(initTopbarLoginUrl)
        .run(fixHashUrls)
        .run(initMarket)
        .run(runBlock)
        .run(migrateStoredSender);

    checkBrowserSupport.$inject = ['$rootScope'];
    /** @ngInject */
    function checkBrowserSupport($rootScope) {
        $rootScope.unsupportedBrowser = isIE() && isIE() <= 9; isIE() && isIE() <= 9;
    }

    isFeatureEnabled.$inject = ['$rootScope', 'FeatureToggleFactory'];
    /** @ngInject */
    function isFeatureEnabled($rootScope, FeatureToggleFactory) {
        $rootScope.isFeatureEnabled = FeatureToggleFactory.isFeatureEnabled
    }

    checkLocalStorageAvailability.$inject = ['$localStorage', '$rootScope'];
    /** @ngInject */
    function checkLocalStorageAvailability($localStorage, $rootScope) {
        var hasStorage = (function () {
            try {
                localStorage.setItem('mod', 'mod');
                localStorage.removeItem('mod');
                return true;
            } catch (exception) {
                return false;
            }
        }());
        $rootScope.localStorageDisabled = !hasStorage;
    }

    migrateStoredSender.$inject = ['$localStorage', 'appOptions'];
    /** @ngInject */
    function migrateStoredSender($localStorage, appOptions) {
        if (appOptions.country === 'SE' && $localStorage.sender && !$localStorage.sender.private) {
            var company = $localStorage.sender;
            delete company.company;

            var sender = {
                business: $localStorage.sender,
                private: _.omit($localStorage.sender, 'company')
            }

            $localStorage.sender = sender;
        }
    }


    runBlock.$inject = ['$log', '$rootScope', '$sessionStorage', '$localStorage', '$state', '$stateParams', '$translate', '$timeout', '$document', '$window', 'appOptions', 'Common', 'Topbar'];
    /** @ngInject */
    function runBlock($log, $rootScope, $sessionStorage, $localStorage, $state, $stateParams, $translate, $timeout, $document, $window, appOptions, Common, Topbar) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            var stateName = toState.name;
            var loggedInStates = ['main.user.history', 'main.user.orderDetails', 'main.user.receivers'];
            var storedUser = !$rootScope.localStorageDisabled && JSON.parse(localStorage.getItem('user'));
            if (loggedInStates.indexOf(stateName) !== -1 && storedUser === null && typeof (pnTopbar) !== 'undefined') {
                event.preventDefault();
                $state.go('main.landing', { type: toParams.type });
            }

            if (toParams.language) {
                var supportedLanguages = Common.getSupportedLanguagesForCountry(appOptions.country);

                var supportedParamLanguage = _.find(supportedLanguages, function (lang) {
                    return toParams.language.indexOf(lang.key) !== -1;
                });

                if (supportedParamLanguage) {
                    $translate.use(supportedParamLanguage.key);
                    moment.locale(supportedParamLanguage.key);

                    if (typeof (pnTopbar) !== 'undefined') {
                        pnTopbar.language = supportedParamLanguage.key || 'en';
                    }
                }
            }
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
            $rootScope.currentState = toState.name;

            if (toState.name === 'main.payment' && (!$sessionStorage.cart || $sessionStorage.cart.length === 0) && !($stateParams.referralId || $stateParams.agentId)) {
                event.preventDefault();
                $state.go('main.landing');
            }
        });

        var handleChangeLanguage = function (language) {
            var usedLanguage = $translate.proposedLanguage() || $translate.use();
            if (language !== usedLanguage) {
                $timeout(function () {
                    console.log("Run: Switching to language " + language);
                    $translate.use(language);
                    moment.locale(language);
                    $localStorage.language = language;

                    // Update humany widget
                    $rootScope.$broadcast("changeLanguage", language);
                });
            }
        };

        var siteHeader = document.querySelector('pn-marketweb-siteheader')
        if (siteHeader) {
            if (typeof(initialLanguage) !== undefined) {
                handleChangeLanguage(initialLanguage)
            } else {
                // Note: if Wezz Balk triggers languagechange event on mount, this observer can be removed
                var observer = new MutationObserver(function() {
                    var initialLanguage = siteHeader.getAttribute('language')
                    if (initialLanguage !== null) {
                        handleChangeLanguage(initialLanguage)
                        observer.disconnect()
                    }

                });
                observer.observe(siteHeader, { attributes: true });
            }
        }
        window.addEventListener('marketweb-languagechange', (e) => {
           handleChangeLanguage(e.detail)
        });

        var loadWebComponents = function () {
            var script = document.createElement( "script" );
            script.src = "https://cdn.jsdelivr.net/npm/@postnord/pn-marketweb-components@3.4.5/umd/pn-marketweb-init.js?inject=";

            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(script, firstScript);
        };

        $rootScope.$on('routeEnter', (event, params) => {
            if (Topbar.showMarketWebNavigation(params)) {
                $timeout(loadWebComponents, 0, false);
                $rootScope.showMarketWebNavigation = true;
            } else {
                document.getElementById('pn-topbar').classList.remove('hidden');
            }
        })

        // TODO: remove if old topbar no longer used
        if (typeof (pnTopbar) !== 'undefined') {
            pnTopbar.onChangeLanguage = function (language) {
                var usedLanguage = $translate.proposedLanguage() || $translate.use();
                if (language !== usedLanguage) {
                    $timeout(function () {
                        console.log("Run: Switching to language " + language);
                        $translate.use(language);
                        moment.locale(language);

                        // Update humany widget
                        $rootScope.$broadcast("changeLanguage", language);
                    });
                }
            };

            pnTopbar.onChangeMarket = function (market) {
                var marketUrl = OnlineShippingTool.env.baseUrls[market.toLowerCase()];
                if(marketUrl === '/'){
                    console.log("In dev mode. Not able to switch market");
                    return;
                }
                if (marketUrl && marketUrl !== $window.location.href) {
                    $window.location.href = `${marketUrl}/${$stateParams.type}`;
                }
            };

            pnTopbar.onCartClick = function () {
                if($sessionStorage.cart.length > 0) {
                    $state.go('main.payment')
                }
            }

            pnTopbar.onLogout = function () {
                var stateName = _.get($state, 'current.name');
                if (stateName.indexOf('main.user') !== -1) {
                    $state.go('main.landing');
                }
                $rootScope.$broadcast("userLogout");
            };

            pnTopbar.onLogin = function () {
                $rootScope.$broadcast("userLogin");
            };
        }
        $log.debug('runBlock end');
    }

    initMarket.$inject = ['appOptions', 'Common'];
    /** @ngInject */
    function initMarket(appOptions, Common) {
        appOptions.country = Common.getMarket();

        if (typeof (pnTopbar) !== 'undefined') {
            var markets = _.keys(OnlineShippingTool.env.baseUrls)
                .map(function (market) {
                    return market.toUpperCase();
                });
            if(pnTopbar.market !== appOptions.country){
                pnTopbar.market = appOptions.country;
            }
            pnTopbar.markets = markets;
        }
    }


    initTopbarCart.$inject = ['Topbar'];
    /** @ngInject */
    function initTopbarCart(Topbar) {
        Topbar.updateCart();
    }

    /** @ngInject */
    function initEnvironmentSettings($localStorage) {
        $localStorage.enabledFeatures = $localStorage.enabledFeatures || {};
        var envFeatures = _.get(OnlineShippingTool.env, 'enabledFeatures');

        if (envFeatures) {
            for (var feature in envFeatures) {
                if (envFeatures.hasOwnProperty(feature) && typeof ($localStorage.enabledFeatures[feature]) === 'undefined') {
                    $localStorage.enabledFeatures[feature] = envFeatures[feature];
                }
            }
        }
    }


    initTopbarLoginUrl.$inject = ['Common'];
    /** @ngInject */
    function initTopbarLoginUrl(Common) {
        var loginButton = document.getElementById('topbarLogin');
        var cartButton = document.getElementById('topbarCart');
        var country = Common.getMarket();

        if (loginButton && country === 'DK') {
            var loginHref = loginButton.getAttribute('href');

            if (loginHref) {
                loginHref = loginHref.replace('skickadirektFJPCFDLG', 'onlineportoHBCZHWDW');
                loginHref = loginHref.replace('skickadirekt', 'onlineporto');
                loginButton.setAttribute('href', loginHref);
            }

            var cartHref = cartButton.getAttribute('href');

            if (cartHref) {
                cartHref = cartHref.replace('skickadirektFJPCFDLG', 'onlineportoHBCZHWDW');
                cartHref = cartHref.replace('skickadirekt', 'onlineporto');
                cartButton.setAttribute('href', cartHref);
            }
        }
    }

    /** @ngInject */
    function fixHashUrls($location) {
        var hash = $location.hash();

        if (hash) {
            var hashSplit = hash.split('?');
            $location.hash('');

            if (hashSplit[1]) {
                $location.search(hashSplit[1]);
            }
            $location.path(hashSplit[0]);
        }
    }

    function isIE() {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') !== -1) ? parseInt(myNav.split('msie')[1]) : false;
    }

})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, TOPBAR_PREFIXES, DEFAULT_TOPBAR_PREFIX) {
      $stateProvider
          .state('main', {
              abstract: true,
              url: `/{type:[${TOPBAR_PREFIXES.PORTAL}|${TOPBAR_PREFIXES.MARKETWEB}]}?toggleFeatures&customerType&language`,
              templateUrl: 'components/layout/base.html',
              controller: 'MainController',
              controllerAs: 'main',
              onEnter: ($state, $rootScope, $stateParams) => {
                $rootScope.$broadcast('routeEnter', $stateParams);
              }
          });

      $urlRouterProvider.when('/products/{toCountry}/{productId}', redirectToLanding);
      $urlRouterProvider.when('/products/{toCountry}/{productId}/', redirectToLanding);

      $urlRouterProvider.otherwise(($injector, $location) => {
          const path = $location.path();
          const topbarPrefixes = Object.values(TOPBAR_PREFIXES);
          const urlHasTopbarPrefixWithTrailingSlash = topbarPrefixes.some((prefix) => path.includes(`/${prefix}/`));
          const urlHasTopbarPrefixWithoutTrailingSlash = topbarPrefixes.some((prefix) => path.includes(`/${prefix}`));

          if (urlHasTopbarPrefixWithoutTrailingSlash && path.length <= 2) {
            return `${path}/${location.search}`;
          } else if (urlHasTopbarPrefixWithTrailingSlash) {
            if (path.substring(0, 3) === `/${TOPBAR_PREFIXES.PORTAL}/`) {
              return `/${TOPBAR_PREFIXES.PORTAL}/`;
            } else {
              return `/${TOPBAR_PREFIXES.MARKETWEB}/`;
            }
          } else {
            return `/${DEFAULT_TOPBAR_PREFIX + path}${location.search}`;
          }
      });
  }

  /** @ngInject */
  function redirectToLanding($injector, $match) {
      $injector.get('$state').go('main.landing', $match);
  }

})();

/* global _, moment:false, tv4, PostNordFlexChangeNordic */
(function () {
    'use strict';

    angular
        .module('onlineShippingTool')
        .constant('REGEX_VALID_ADDRESS_CHARACTERS', /^[A-Za-zÀ-ÿ\d\u0118\u0119\u0143\u0144 .,-_&\/\'´`°!#\$%\*()]*$/)
        .constant('NCP_PUBLIC_KEY', 'Eg5jgQjS89BEFKqHIQmldNyzmOixE84t')
        .constant('SERVICE_POINT_LOCATIONS', {
            DROPOFF: {
                DK: '4,6,46'
            },
            PICKUP: {
                SE: '24,25,54',
                DK: '2,4,6,44'
            }
        })
        .constant('TOPBAR_PREFIXES', {
            PORTAL: 'p',
            MARKETWEB: 'm',
        })
        .constant('DEFAULT_TOPBAR_PREFIX', 'm');
})();

(function() {
  'use strict';

  angular
    .module('onlineShippingTool')
    .config(config)
    .config(configStorage)
    .config(configTranslations)
    .config(configPopovers);

  /** @ngInject */
  function config($localStorageProvider, $locationProvider, $logProvider, $mdGestureProvider, $sessionStorageProvider, $translateProvider, $httpProvider, CommonProvider) {
      // Control logs
      $logProvider.debugEnabled(OnlineShippingTool.env.enableDebugLogging || false);

      // Config router
      $locationProvider.html5Mode(true).hashPrefix('!');
      $mdGestureProvider.skipClickHijack();

      // Config interceptor to add Authorization header
      $httpProvider.interceptors.push(function() {
          return {
              request: function(config) {
                  // Only add header if request to specific services below
                  if ((config.url.indexOf(OnlineShippingTool.env.productsUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.cartsUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.cartsHistoryUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.initTransactionUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.receiversUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.updateUserInfoUrl) !== -1 ||
                      config.url.indexOf(OnlineShippingTool.env.updateCompanyInfoUrl) !== -1) &&
                      (config.url.indexOf(OnlineShippingTool.env.publicCartsUrl) === -1)
                  ) {
                      var token = null;

                      var hasStorage = (function() {
                          try {
                              localStorage.setItem('mod', 'mod');
                              localStorage.removeItem('mod');
                              return true;
                          } catch (exception) {
                              return false;
                          }
                      }());

                      // Get token from top bar if available
                      var pnUserAccessToken = sessionStorage.getItem('pn-user-accessToken')
                      if (pnUserAccessToken) {
                        token = pnUserAccessToken
                      } else if (typeof (pnTopbar) !== 'undefined') {
                        token = pnTopbar.access_token;
                      }

                      if (token == "") {token = null} // Do not allow empty string

                      config.headers.Authorization = String(token); // Always send a non-empty string
                  }

                  return config;
              }
          };
      });

  }



  configStorage.$inject = ['$localStorageProvider', '$sessionStorageProvider', 'CommonProvider'];
  /** @ngInject */
  function configStorage($localStorageProvider, $sessionStorageProvider, CommonProvider) {
      var country = CommonProvider.$get().getMarket();
      var prefix = country.toLowerCase() + '-onlineShippingTool-';

      // Config storage
      $localStorageProvider.setKeyPrefix(prefix);
      $sessionStorageProvider.setKeyPrefix(prefix);
  }



  configTranslations.$inject = ['$translateProvider', 'CommonProvider', '$localStorageProvider'];
  /** @ngInject */
  function configTranslations($translateProvider, CommonProvider, $localStorageProvider) {
      var country = CommonProvider.$get().getMarket();

      // Config translations
      $translateProvider.useStaticFilesLoader({
        prefix: "assets/translations/" + country.toLowerCase() + "/",
        suffix: ".json"
      }).determinePreferredLanguage();

      $translateProvider.useSanitizeValueStrategy("escapeParameters");

      var siteHeader = document.querySelector('pn-marketweb-siteheader');
      var headerLangauge = siteHeader ? siteHeader.getAttribute('language') : null;
      var storedLanguage = $localStorageProvider.get('language');

      var language = storedLanguage || $translateProvider.preferredLanguage();
      var topbarLanguage = (typeof (pnTopbar) !== 'undefined') ? pnTopbar.language : null;

      var supportedLanguages = CommonProvider.$get().getSupportedLanguagesForCountry(country);

      var supportedUserLanguage = _.find(supportedLanguages, function (lang) {
          return !!storedLanguage && storedLanguage
            || siteHeader
            ? headerLangauge && headerLangauge.indexOf(lang.key) !== -1
            : topbarLanguage && topbarLanguage.indexOf(lang.key) !== -1;
      }) || _.find(supportedLanguages, function (lang) {
          return language.indexOf(lang.key) !== -1;
      });

      if (!supportedUserLanguage) {
          console.log("Unimplemented language: " + language + ". Setting default language en");
          $translateProvider.preferredLanguage("en");
      } else {
          $translateProvider.preferredLanguage(supportedUserLanguage.key);
      }

      $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

      // TODO: remove if old topbar not used anymore
      if (typeof (pnTopbar) !== 'undefined') {
          pnTopbar.languages = supportedLanguages;
          pnTopbar.language = supportedUserLanguage ? supportedUserLanguage.key : 'en';
      }

      moment.locale($translateProvider.preferredLanguage());
  }





  function configPopovers($uibTooltipProvider) {
      $uibTooltipProvider.options({
          placement: 'auto right',
          appendToBody: true,
          trigger: 'outsideClick'
      });
  }

})();

(function() {
    'use strict';

    angular
        .module('onlineShippingTool.sidebar', [
            'onlineShippingTool.sidebar.measurement',
            'onlineShippingTool.sidebar.addressSelectedProduct',
            'onlineShippingTool.sidebar.selectedProduct',
            'onlineShippingTool.sidebar.cart',
            'onlineShippingTool.sidebar.dropoffMap',
            'onlineShippingTool.sidebar.measurementLimits',
            'onlineShippingTool.sidebar.productDetails',
            'onlineShippingTool.sidebar.dkmeasurements',
            'onlineShippingTool.sidebar.dkClimateCompensation',
            'onlineShippingTool.sidebar.overview',

        ]);
})();

angular.module("onlineShippingTool").run(["$templateCache", function($templateCache) {$templateCache.put("index.html","<!DOCTYPE html>\n<html lang=META_LANG>\n    <head>\n        <meta charset=utf-8>\n\n        <meta name=theme-color content=#00a0d6>\n        <meta name=viewport content=\"width=device-width,initial-scale=1\">\n        <meta name=description content=META_DESCRIPTION>\n        <meta name=google content=notranslate>\n        <meta name=robots content=INDEX_RESTRICTION>\n        <title>META_TITLE</title>\n        <!-- optimizely.js -->\n        <script src=PORTAL_MENU_URL></script>\n        <base href=BASE_URL>\n\n        <link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=stylesheet>\n        <link rel=stylesheet href=https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/tiny-slider.css>\n        <script type=text/javascript src=https://cdn.socket.io/socket.io-1.4.8.js></script>\n        <script src=https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/min/tiny-slider.js></script>\n\n        <!-- <link href=\"base.css?rev=@@hash\" rel=\"stylesheet\"> -->\n        <!-- <script src=\"scripts.min.js?rev=dea1b1b15fb7a5f53aeae1eec514d4a2\"></script> -->\n\n        <!-- build:css({.tmp/serve,app}) styles/base.css -->\n        <!-- inject:css -->\n        <!-- css files will be automatically insert here -->\n        <!-- endinject -->\n        <!-- endbuild -->\n        <!-- Google Tag Manager Data Layer -->\n        <script>\n            var dataLayer = dataLayer || [];\n        </script>\n        <!-- End Google Tag Manager Data Layer -->\n\n        <!-- Google Tag Manager -->\n        <script>\n            (function(w, d, s, l, i) {\n                w[l] = w[l] || [];\n                w[l].push({\n                    \"gtm.start\": new Date().getTime(),\n                    event: \"gtm.js\"\n                });\n                var f = d.getElementsByTagName(s)[0],\n                    j = d.createElement(s),\n                    dl = l != \"dataLayer\" ? \"&l=\" + l : \'\';\n                j.async = true;\n                j.src = \"//www.googletagmanager.com/gtm.js?id=\" + i + dl;\n                f.parentNode.insertBefore(j, f);\n            })(window, document, \"script\", \"dataLayer\", \"GTM-ID\");\n        </script>\n        <!-- End Google Tag Manager -->\n    </head>\n    <body ng-app=onlineShippingTool>\n        <pn-topbar id=pn-topbar class=hidden ng-if=!showMarketWebNavigation>\n            <script src=TOP_BAR_URL></script>\n        </pn-topbar>\n        <div ng-class=\"{\'pn-page-container\': !showMarketWebNavigation}\">\n            <pn-side-menu ng-show=!showMarketWebNavigation type=base></pn-side-menu>\n            <div id=background_wrap></div>\n            <div ui-view class=notranslate></div>\n        </div>\n\n        <!-- Google Tag Manager -->\n        <noscript>\n        <iframe src=\"//www.googletagmanager.com/ns.html?id=GTM-ID\" height=0 width=0 style=display:none;visibility:hidden></iframe>\n        </noscript>\n        <!-- End Google Tag Manager -->\n\n        <script async defer src=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyA8DVvTmMQCV65ijEtIvmqpTdeCj5uWA2w\"></script>\n\n        <!-- Google Pay API for Passes -->\n        <script src=https://apis.google.com/js/platform.js type=text/javascript></script>\n\n        <!-- build:js scripts/vendors.min.js -->\n            <script src=app/vendors.min.js></script>\n        <!-- endbuild -->\n\n        <!-- build:js({.tmp/serve,.tmp/partials,app}) scripts/app.js -->\n        <!-- inject:js -->\n        <!-- js files will be automatically insert here -->\n        <!-- endinject -->\n\n        <!-- inject:partials -->\n        <!-- angular templates will be automatically converted in js and inserted here -->\n        <!-- endinject -->\n        <!-- endbuild -->\n\n        <script>\n            const CentionChat = _CentionChat();\n            CentionChat.baseURL = \'https://chat-postnord.clearinteract.se\';\n            window.CentionChat = CentionChat;\n        </script>\n\n        <!-- Start Humany - implementation: \"Shipping Tool\" -->\n        <script>\n          (function(n,t,i,r,u,f,e){for(var o,s=/[?&]{1}(humany[^=]*)=([^&#]*)/g;o=s.exec(n.location.search);)i+=(i.indexOf(\"?\")>-1?\"&\":\"?\")+o[1]+\"=\"+o[2];\n          f=t.createElement(u);f.async=!0;f.src=i;e=t.getElementsByTagName(u)[0];e.parentNode.insertBefore(f,e);n[r]=n[r]||{_c:[],configure:function(t){n[r]._c.push(t)}}})\n          (window,document,\"//postnord.humany.net/shipping-tool/embed.js\",\"Humany\",\"script\");\n        </script>\n        <!-- End Humany -->\n        <!-- Start Postnord components-->\n        <script type=module src=PORTAL_BASE_URL/webcomponents/pn-web-components.esm.js></script>\n        <script nomodule src=PORTAL_BASE_URL/webcomponents/pn-web-components.js></script>\n        <!-- End Postnord components-->\n    </body>\n</html>\n");
$templateCache.put("redirect.html","<!DOCTYPE html>\n<html>\n    <head>\n        <meta charset=utf-8>\n        <title>PostNord</title>\n\n        <script>\n            var params = [];\n            var hashSplit = window.location.hash.replace(\'#\', \'\').split(\'&\');\n            var searchSplit = window.location.search.replace(\'?\', \'\').split(\'&\');\n            var basePaths = [\n                \'skickadirekt\',\n                \'onlineporto\',\n                \'skickadirektFJPCFDLG\',\n                \'onlineportoHBCZHWDW\'\n            ];\n\n            for (var i = 0; i < searchSplit.length; i++) {\n                if (searchSplit[i] !== \'\') {\n                    params.push(searchSplit[i]);\n                }\n            }\n\n            for (var j = 0; j < hashSplit.length; j++) {\n                if (hashSplit[j] !== \'\') {\n                    params.push(hashSplit[j]);\n                }\n            }\n\n            var path = window.location.pathname;\n            var pathSplit = path.substr(1).split(\'/\');\n            var basePath = pathSplit[0];\n            var basePathIdx = basePaths.indexOf(basePath);\n            if (basePathIdx !== -1) {\n                path = \'/\' + basePaths[basePathIdx] + \'/#!/\' + pathSplit.slice(1).join(\'/\');\n            } else {\n                path = \'/#!\' + path;\n            }\n\n            var redirectionUrl = window.location.protocol + \'//\' + window.location.host + path + \'?\' + params.join(\'&\');\n            console.log(\'redirectionUrl\', redirectionUrl);\n\n            window.location.href = redirectionUrl;\n        </script>\n    </head>\n    <body>\n\n    </body>\n</html>\n");
$templateCache.put("components/address/address.content.html","<div class=\"main-content__box address\">\n  <form name=address.addressForm class=\"form address__form\" novalidate>\n    <cmn-sidebar-selected-product class=\"visible-xs selected-product\" ng-show=\"address.parcel && !address.parcel.isEditing\" product=address.parcel selected-weight=address.parcel.selectedWeight edit-callback=address.editParcel is-customer-company=main.isCustomerCompany ng-class=\"{\'has-cart\': main.cart.length > 0}\">\n    </cmn-sidebar-selected-product>\n\n    <div class=box>\n      <div class=box__header>\n        <div class=box__header__title>\n          {{ \'ADDRESS_PAGE_SENDER_TITLE\' | translate}} <span ng-if=\"main.country === \'DK\'\" class=title-description>{{ \'DK_ADDRESS_PAGE_SENDER_DESCRIPTION\' | translate}}</span>\n        </div>\n      </div>\n      <div class=\"box__content address__sender\">\n        <div class=spinner-container ng-if=address.isLoadingUserInfo>\n          <pn-spinner color=blue700 size=large></pn-spinner>\n        </div>\n        <sender-form sender=address.sender country={{main.country}} form=address.senderForm name=single is-submitted=address.addressForm.$submitted product=address.parcel ng-show=\"address.showSenderForm && !address.isLoadingUserInfo\">\n        </sender-form>\n\n        <div ng-hide=\"address.showSenderForm || address.isLoadingUserInfo\" class=address__information>\n          <div class=address__information__title>\n            <div>{{ address.isCustomerCompany ? address.sender.company.name : address.sender.name}}</div>\n            <button class=\"btn btn--header btn--header--edit\" type=button ng-disabled=address.isSubmitting ng-click=\"address.showSenderForm = true\">\n              <span>{{ \'COD_CHANGE\' | translate }}</span>\n            </button>\n          </div>\n          <div ng-show=\"address.isCustomerCompany && address.sender.company.organizationNumber\" class=address__information__row>{{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}}:\n            {{address.sender.company.organizationNumber}}</div>\n          <div ng-show=address.sender.address.street class=address__information__row>\n            {{address.sender.address.street}}</div>\n          <div ng-show=address.sender.address.zipCode class=address__information__row>\n            {{address.sender.address.zipCode}} {{address.sender.address.city}}</div>\n          <div ng-show=address.sender.email class=address__information__row>{{address.sender.email}}</div>\n        </div>\n\n        <div class=form__row ng-if=\"address.isLoggedInUser && !address.isLoadingUserInfo && address.isUserAccountMissingInfo()\">\n          <div class=\"clearfix address__agreement\">\n            <input id=checkbox_agreement type=checkbox ng-model=address.saveSenderInformation>\n            <label class=checkbox-label for=checkbox_agreement></label>\n\n            <div class=address__agreement__label>\n              <label for=checkbox_agreement>{{ \'ADDRESS_PAGE_SENDER_SAVEINFO\' | translate}}</label>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n\n    <div class=box>\n      <header>\n        <h2>{{ \'ADDRESS_PAGE_RECIEVER_TITLE\' | translate}}</h2>\n      </header>\n\n      <div class=box__content>\n        <receiver-form receiver=address.receiver is-submitted=address.addressForm.$submitted country=main.country parcel=address.parcel form=address.receiverForm edit-parcel-callback=address.editParcel>\n        </receiver-form>\n      </div>\n    </div>\n\n\n\n    <div class=center>\n      <div class=error-bubble ng-show=\"!address.missingEmailOrPhone && address.addressForm.$submitted && address.addressForm.$invalid && address.addressForm.$error.required\">\n        {{ \'ADDRESS_PAGE_ERROR_GENERAL\' | translate }}\n      </div>\n      <div class=error-bubble ng-show=address.errorWhenAdding>\n        {{ \'ADDRESS_PAGE_ERROR_ADDING_ERROR\' | translate }}\n      </div>\n    </div>\n\n    <div class=address__btns ng-show=!address.parcel.isEditing>\n      <button ng-if=!address.parcelHasCustomsDocument id=btn-add-and-buy-more ng-disabled=address.isSubmitting ng-click=\"address.addToCart(address.parcel, address.sender, address.receiver, address.saveSenderInformation, true)\" class=\"btn btn--not-filled\" type=button ng-class=\"{\'btn--loading\': address.nextState === \'main.landing\'}\">\n        {{ \'BUTTON_ADDMORE_PARCELS\' | translate}}\n      </button>\n      <button ng-if=!address.parcelHasCustomsDocument id=btn-add-and-pay ng-disabled=address.isSubmitting ng-click=\"address.addToCart(address.parcel, address.sender, address.receiver, address.saveSenderInformation, false)\" class=\"btn btn--blue\" type=submit ng-class=\"{\'btn--loading\': address.nextState === \'main.payment\'}\">\n        {{ \'BUTTON_ADDMORE_PAY\' | translate}}\n      </button>\n      <button ng-if=address.parcelHasCustomsDocument id=btn-customs-declaration ng-disabled=address.isSubmitting ng-click=\"address.addToCart(address.parcel, address.sender, address.receiver, address.saveSenderInformation, false)\" class=\"btn btn--blue btn--block\" type=submit ng-class=\"{\'btn--loading\': address.nextState === \'main.customs\' || address.nextState === \'main.customsNew\'}\">\n        {{ \'BUTTON_TO_CUSTOMS_DECLARATION\' | translate}}\n      </button>\n    </div>\n\n    <div class=address__btns ng-show=address.parcel.isEditing>\n      <button ng-disabled=address.isSubmitting ng-click=address.cancelEdit(address.parcel) type=button class=\"btn btn--blue\">\n        {{ \'BUTTON_CANCEL_EDIT\' | translate}}\n      </button>\n\n      <button ng-disabled=address.isSubmitting ng-click=\"address.editParcelInCart(address.parcel, address.sender, address.receiver, address.saveSenderInformation)\" class=\"btn btn--blue\" type=submit ng-class=\"{\'btn--loading\': address.nextState === \'main.payment\'}\">\n        {{ \'BUTTON_SAVE_EDIT\' | translate}}\n      </button>\n    </div>\n  </form>\n  <div class=sticky-product ng-if=address.productSticky ng-style=\"{\'top\': address.stickyProductYposition+\'px\'}\" ng-click=address.scrollToProductSelector()>\n    <span class=sticky-product__name>\n      <img ng-src=\"{{address.parcel.imageUrl | imagePath}}\">\n      {{address.parcel.name | translate}}\n    </span>\n    <span class=sticky-product__price>\n      {{address.parcel.price | price}}{{address.parcel.priceUnit | prettifyCurrency}}\n      <pn-icon symbol=edit-2 color=blue700 size=medium solid ng-click=address.editParcel(address.parcel)></pn-icon>\n    </span>\n  </div>\n</div>");
$templateCache.put("components/address/address.html","<div class=page-header>\n    <h1 class=page-header__title ng-if=!address.parcel.isEditing>{{ \'PAGE_HEADER_ADDRESS\' | translate}}</h1>\n    <h1 class=page-header__title ng-if=address.parcel.isEditing>{{ \'PAGE_HEADER_ADDRESS_EDIT\' | translate}}</h1>\n</div>\n\n<progress-tracker stage=\"\'address\'\" parcel=address.parcel editing-from-state=address.editingFromState></progress-tracker>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/address/address.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/address/address.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n");
$templateCache.put("components/address/address.sidebar.html","<div class=hidden-xs>\n    <!-- <cmn-address-sidebar-selected-product\n        ng-show=\"address.parcel && !address.parcel.isEditing\"\n        product=\"address.parcel\"\n        edit-parcel-callback=\"address.editParcel\"\n        country=\"{{main.country}}\">\n    </cmn-address-sidebar-selected-product> -->\n\n    <cmn-sidebar-selected-product ng-show=\"address.parcel && !address.parcel.isEditing\" product=address.parcel selected-weight=address.parcel.selectedWeight edit-callback=address.editParcel is-customer-company=main.isCustomerCompany ng-class=\"{\'has-cart\': main.cart.length > 0}\">\n    </cmn-sidebar-selected-product>\n</div>\n\n\n<cmn-sidebar-cart cart=main.cart is-customer-company=main.isCustomerCompany ng-show=\"main.cart.length > 0\">\n</cmn-sidebar-cart>\n\n<dk-climate-compensation ng-show=\"main.country === \'DK\'\" product=address.parcel></dk-climate-compensation>\n");
$templateCache.put("components/address/receiver-form.directive.html","<div ng-if=\"receiverForm.loggedIn || receiverForm.supportsPhoneContactsImport()\" class=search-receiver>\n  <div>\n    <material-icon>search</material-icon>\n    <img ng-if=receiverForm.supportsPhoneContactsImport() class=phone-import ng-click=receiverForm.importPhoneContacts() src=assets/images/icon-mobile.svg>\n    \n    <input type=text ng-model=receiverForm.searchString placeholder=\"{{ \'SEARCH\' | translate }} {{ \'RECEIVER\' | translate | lowercase }}\" uib-typeahead=\"receiver.name as receiver for receiver in receiverForm.queryStoredReceivers($viewValue)\" typeahead-min-length=2 typeahead-popup-template-url=storedReceiversPopup.html typeahead-template-url=storedReceiver.html typeahead-on-select=\"receiverForm.selectStoredReceiver($item, $model, $label, $event)\" typeahead-append-to-body=true ng-model-options=\"{ debounce: 500 }\">\n  </div>\n</div>\n<ul class=pills>\n  <li ng-if=receiverForm.allowPrivateReceiver ng-class=\"{active: !receiverForm.isBusinessReceiver}\" ng-click=receiverForm.toggleBusinessReceiver(false)>\n    {{ \'PRIVATE_RECEIVER\' | translate}}\n  </li>\n  <li ng-if=receiverForm.allowBusinessReceiver ng-class=\"{active: receiverForm.isBusinessReceiver}\" ng-click=receiverForm.toggleBusinessReceiver(true)>\n    {{ \'COMPANY_RECEIVER\' | translate}}\n  </li>\n</ul>\n<ng-form name=receiverForm.form autocomplete=off>\n  <div class=\"form__row form__row--first\" ng-if=!receiverForm.isBusinessReceiver>\n    <label for=receiverForm_{{$id}}_name class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_NAME\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_name autocomplete=receiverName name=receiverName maxlength=30 class=form__input type=text ng-if=!receiverForm.loggedIn ng-model=receiverForm.receiver.name ng-pattern=receiverForm.regex required>\n    <input id=receiverForm_{{$id}}_name autocomplete=receiverName name=receiverName maxlength=30 class=form__input type=text ng-if=receiverForm.loggedIn ng-model=receiverForm.receiver.name ng-pattern=receiverForm.regex required>\n\n    <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverName.$error\">\n      <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_NAME\' | translate}}</div>\n      <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n    </div>\n  </div>\n\n  <div class=\"form__row form__row--first\" ng-if=receiverForm.isBusinessReceiver>\n    <label for=receiverForm_{{$id}}_company class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_COMPANY\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_company name=receiverCompany class=form__input type=text maxlength=30 ng-if=!receiverForm.loggedIn ng-model=receiverForm.receiver.company ng-pattern=receiverForm.regex required>\n    <input id=receiverForm_{{$id}}_company autocomplete=receiverCompany name=receiverCompany type=text class=form__input ng-if=receiverForm.loggedIn ng-model=receiverForm.receiver.company ng-pattern=receiverForm.regex required>\n\n    <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverCompany.$error\">\n      <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_COMPANY\' | translate}}</div>\n      <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n    </div>\n  </div>\n\n  <div class=form__row ng-show=receiverForm.isBusinessReceiver>\n    <label for=receiverForm_{{$id}}_attn class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_COMPANY_ATTN\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_attn name=receiverAttn class=form__input type=text maxlength=30 ng-model=receiverForm.receiver.attn ng-pattern=receiverForm.regex>\n\n    <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverAttn.$error\">\n      <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n    </div>\n  </div>\n\n  <div class=form__row ng-show=\"!receiverForm.isBusinessReceiver && (receiverForm.receiverCountryCode === \'SE\' || receiverForm.receiverCountryCode === \'DK\')\">\n    <label for=receiverForm_{{$id}}_co class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_CO\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_co name=receiverCo class=form__input maxlength=35 type=text ng-model=receiverForm.receiver.address.co ng-pattern=receiverForm.regex>\n\n    <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverCo.$error\">\n      <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n    </div>\n  </div>\n\n  <div class=form__row>\n    <label for=receiverForm_{{$id}}_streetAddress class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_ADDRESS\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_streetAddress autocomplete=receiverAddress-line1 maxlength=35 name=streetAddress class=form__input type=text ng-model=receiverForm.receiver.address.street ng-pattern=receiverForm.regex required>\n\n    <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.streetAddress.$error\">\n      <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ADDRESS\' | translate}}</div>\n      <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n    </div>\n\n    <div ng-if=\"receiverForm.receiverCountryCode !== \'SE\' && receiverForm.receiverCountryCode !== \'DK\'\">\n      <input id=receiverForm_{{$id}}_extraStreet1 name=receiverStreet2 class=form__input maxlength=35 type=text ng-model=receiverForm.receiver.address.extraStreet1 ng-pattern=receiverForm.regex>\n\n      <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverStreet2.$error\">\n        <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n      </div>\n\n      <div ng-if=\"receiverForm.country === \'DK\' && receiverForm.extraAddressFieldsEnabled && receiverForm.receiverCountryCode !== \'SE\' && receiverForm.receiverCountryCode !== \'DK\'\">\n        <input id=receiverForm_{{$id}}_extraStreet2 name=receiverStreet3 class=form__input maxlength=35 type=text ng-model=receiverForm.receiver.address.extraStreet2 ng-pattern=receiverForm.regex>\n\n        <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverStreet3.$error\">\n          <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n        </div>\n\n        <input id=receiverForm_{{$id}}_extraStreet3 name=receiverStreet4 class=form__input maxlength=35 type=text ng-model=receiverForm.receiver.address.extraStreet3 ng-pattern=receiverForm.regex>\n\n        <div class=form__row__errors ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverStreet4.$error\">\n          <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n  <div ng-if=\"receiverForm.receiverCountryCode === \'SE\' && (receiverForm.parcel.hasHomeDelivery || receiverForm.parcel.hasExpress || receiverForm.parcel.hasDeliveryToCompany)\" class=form__row>\n    <label for=receiverForm_{{$id}}_doorCode class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_DOORCODE\' | translate}}</label>\n    <input id=receiverForm_{{$id}}_doorCode class=form__input type=text maxlength=24 ng-model=receiverForm.receiver.address.doorCode>\n  </div>\n\n  <!-- Postal code and area for NORDIC COUNTRIES -->\n  <div class=form__row style=\"position: relative\" ng-if=receiverForm.isNordicCountry(receiverForm.receiverCountryCode)>\n    <div class=form__row__inline>\n      <label for=receiverForm_{{$id}}_zipCode class=\"form__label form__label--required\">\n        {{ \'ADDRESS_PAGE_RECIEVER_ZIPCODE\' | translate}}\n      </label>\n\n      <input ng-if=\"receiverForm.receiverCountryCode !== \'DK\'\" id=receiverForm_{{$id}}_zipCode name=receiverPostalCode autocomplete=receiverPostal-code class=\"form__input form__input--half\" type=text ng-disabled=receiverForm.isLockedZipCode ng-model=receiverForm.receiver.address.zipCode blocked-postal-code=receiverForm.blockedPostalCode blocked-postal-codes=receiverForm.parcel.toCountry.blockedPostalCodes ng-model-options=\"{ debounce: 250 }\" ng-class=\"{\'form__input--invalid\': receiverForm.form.receiverPostalCode.$error.invalidPostalCode, \'form__input--disabled\': receiverForm.isLockedZipCode}\" required>\n\n      <input ng-if=\"receiverForm.receiverCountryCode === \'DK\'\" id=receiverForm_{{$id}}_zipCode name=receiverPostalCode autocomplete=receiverPostal-code class=\"form__input form__input--half\" type=text ng-model=receiverForm.receiver.address.zipCode ng-model-options=\"{ debounce: 250 }\" ng-class=\"{\'form__input--invalid\': receiverForm.form.receiverPostalCode.$error.invalidPostalCode}\" required>\n\n      <div class=\"form__row__errors form__input--half\" ng-messages-multiple ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverPostalCode.$error\">\n        <div ng-message=invalidPostalCode ng-if=\"receiverForm.country !== \'DK\'\" ng-bind-html=\"\'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ZIPAREA\' | translate\">\n        </div>\n\n        <div ng-message=invalidPostalCode ng-if=\"receiverForm.country === \'DK\'\" ng-bind-html=\"\'FIELD_POSTCODE_INVALID_CODE\' | translate: {country: receiverForm.parcel.toCountry.name, example: receiverForm.parcel.toCountry.postalCodeExample}\">\n        </div>\n      </div>\n    </div>\n\n    <div class=form__row__inline>\n      <label for=receiverForm_{{$id}}_city class=\"form__label form__label--required\">\n        {{ \'ADDRESS_PAGE_RECIEVER_ZIPAREA\' | translate}}\n      </label>\n\n      <input id=receiverForm_{{$id}}_city name=receiverCity class=\"form__input form__input--half\" type=text ng-model=receiverForm.receiver.address.city zipcode-city-autocomplete={{receiverForm.receiver.address.zipCode}} country-code={{receiverForm.receiverCountryCode}} validation-status=receiverForm.validationStatus placeholder=\"{{ \'ADDRESS_PAGE_SENDER_ZIPAREA_PLACEHOLDER\' | translate}}\" maxlength=34 ng-pattern=receiverForm.regex disabled required readonly>\n    </div>\n  </div>\n\n  <!-- Postal code and area for NON-NORDIC COUNTRIES -->\n  <div class=\"form__row form__row--flex\" ng-if=!receiverForm.isNordicCountry(receiverForm.receiverCountryCode)>\n    <div class=form__row__inline>\n      <label for=receiverForm_{{$id}}_zipCode class=\"form__label form__label--required\">\n        {{ \'ADDRESS_PAGE_RECIEVER_ZIPCODE\' | translate}}\n      </label>\n\n      <input id=receiverForm_{{$id}}_zipCode style=\"text-transform: uppercase\" name=receiverPostalCode autocomplete=postal-code blocked-postal-code=receiverForm.blockedPostalCode blocked-postal-codes=receiverForm.parcel.toCountry.blockedPostalCodes class=\"form__input form__input--half\" ng-class=\"{\'postalcode--invalid\': receiverForm.blockedPostalCode}\" type=text ng-model-options=\"{ debounce: 250 }\" ng-model=receiverForm.receiver.address.zipCode ng-pattern=receiverForm.regexp required>\n\n      <div class=\"form__row__errors form__input--half\" ng-messages-multiple ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverPostalCode.$error\" ng-hide=receiverForm.nonPostalCodeCountry>\n        <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n\n        <div ng-message=invalidPostalCode ng-bind-html=\"\'FIELD_POSTCODE_INVALID_CODE\' | translate: {country: receiverForm.parcel.toCountry.name, example: receiverForm.parcel.toCountry.postalCodeExample}\">\n        </div>\n      </div>\n    </div>\n\n    <div class=form__row__inline>\n      <label for=receiverForm_{{$id}}_city class=\"form__label form__label--required\">\n        {{ \'ADDRESS_PAGE_RECIEVER_ZIPAREA\' | translate}}\n      </label>\n\n      <div class=form__input-group>\n        <input id=receiverForm_{{$id}}_city name=receiverCity class=\"form__input form__input--half\" type=text maxlength=34 ng-model=receiverForm.receiver.address.city country-code={{receiverForm.receiverCountryCode}} validation-status=receiverForm.validationStatus non-postal-code-country=receiverForm.nonPostalCodeCountry zipcode-city-autocomplete={{receiverForm.receiver.address.zipCode}} required>\n      </div>\n\n      <div class=\"form__row__errors form__input--half\" ng-messages=\"receiverForm.isSubmitted && receiverForm.form.receiverCity.$error\">\n        <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n      </div>\n    </div>\n  </div>\n\n  <div class=form__disclaimer ng-show=receiverForm.blockedPostalCode>\n    <!-- In Denmark, Northern Ireland is part of the same price group as UK which render the\n      normal message for blocked postal codes irrelevant. However, when sending to Northern\n      Ireland you don\'t need to attach customs declaration, so instead of the pricing message\n      we should show a message about that.\n\n      This is a hardcoded solution for this case specifically.\n      If there are more cases like this, a more general solution should be applied instead.\n    -->\n    <p ng-if=\"receiverForm.market === \'DK\' && receiverForm.blockedPostalCode.countryCode === \'GBNI\'\" ng-bind-html=\"\'ADDRESS_PAGE_CUSTOMS_WARNING_BLOCKED_POSTAL_CODE\' | translate:{area: receiverForm.blockedPostalCode.description, country: receiverForm.parcel.toCountry.name}\">\n    >\n    </p>\n    <p ng-if=\"receiverForm.market !== \'DK\' || receiverForm.blockedPostalCode.countryCode !== \'GBNI\'\" ng-bind-html=\"\'ADDRESS_PAGE_WARNING_BLOCKED_POSTAL_CODE\' | translate:{area: receiverForm.blockedPostalCode.description, country: receiverForm.parcel.toCountry.name}\">\n    </p>\n    <a ng-click=receiverForm.changeToCountryWithBlockedPostalCode(receiverForm.blockedPostalCode.countryCode)>{{ \'ADDRESS_PAGE_WARNING_BLOCKED_POSTAL_CODE_LINK\' | translate }}</a>\n  </div>\n\n  <div class=form__disclaimer ng-show=receiverForm.nonPostalCodeCountry ng-bind-html=\"\'ADDRESS_PAGE_NON_POSTAL_CODE_COUNTRY\' | translate:{country: receiverForm.parcel.toCountry.name, fallbackPostalCode: receiverForm.parcel.toCountry.postalCodeExample}\">\n  </div>\n\n  <receiver-service-point ng-if=\"receiverForm.parcel.receiverCountryCode === \'DK\' && receiverForm.country === \'DK\' && receiverForm.parcel.type === \'package\' && receiverForm.parcel.hasHomeDelivery !== true\" address=receiverForm.receiver.address parcel=receiverForm.parcel additional-service=receiverForm.customServicePointService service-point=receiverForm.parcel.customServicePoint>\n  </receiver-service-point>\n\n  <div class=form__row>\n    <div class=form__row__inline>\n      <label for=receiverForm_{{$id}}_country class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_COUNTRY\' | translate}}</label>\n      <input id=receiverForm_{{$id}}_country name=receiver-country class=\"form__input form__input--half form__input--disabled\" type=text value={{receiverForm.parcel.receiverCountry}} disabled readonly>\n    </div>\n  </div>\n\n  <!-- Start of notification fields for package sent from Denmark -->\n  <div ng-if=\"receiverForm.country === \'DK\' && receiverForm.notificationFields\">\n    <div class=\"form__row form__row__contact-info\" ng-if=\"receiverForm.notificationFields.email && receiverForm.notificationFields.sms\">\n      <div class=form__row__contact-info__header>\n        {{ \'DK_RECIPIENT_CONTACT_HEADER\' | translate}}\n        <span ng-if=receiverForm.notificationFieldRequired>*</span>\n      </div>\n      <div ng-if=receiverForm.hasCustomsDocuments(receiverForm.parcel) class=form__row__contact-info__text>\n        {{ \'DK_RECIPIENT_CONTACT_TEXT_CUSTOMS\' | translate}}\n      </div>\n      <div ng-if=!receiverForm.hasCustomsDocuments(receiverForm.parcel) class=form__row__contact-info__text>\n        {{ \'DK_RECIPIENT_CONTACT_TEXT\' | translate}}\n      </div>\n    </div>\n\n\n    <cmn-receiver-email-field form=receiverForm.form ng-if=receiverForm.notificationFields.email ng-model=receiverForm.receiver.email ng-required=receiverForm.notificationFieldRequired has-home-delivery=receiverForm.parcel.hasHomeDelivery is-submitted=receiverForm.isSubmitted>\n    </cmn-receiver-email-field>\n\n    <cmn-receiver-phone-field form=receiverForm.form ng-if=receiverForm.notificationFields.sms ng-model=receiverForm.receiver.phone ng-required=receiverForm.notificationFieldRequired has-home-delivery=receiverForm.parcel.hasHomeDelivery is-submitted=receiverForm.isSubmitted>\n    </cmn-receiver-phone-field>\n\n    <letter-notification parcel=receiverForm.parcel ng-if=receiverForm.notificationFields.letter>\n    </letter-notification>\n  </div>\n  <!-- END notification fields for package sent from Denmark -->\n\n\n  <!-- Start of notification fields for package sent from Sweden -->\n  <div ng-if=\"receiverForm.country === \'SE\'\">\n    <cmn-receiver-email-field form=receiverForm.form ng-model=receiverForm.receiver.email ng-required=receiverForm.emailRequired has-home-delivery=receiverForm.parcel.hasHomeDelivery ng-if=!receiverForm.parcel.hasLetterNotification delivery-confirmation-possible=receiverForm.deliveryConfirmationPossible is-submitted=receiverForm.isSubmitted>\n    </cmn-receiver-email-field>\n\n    <cmn-receiver-phone-field-with-validation form=receiverForm.form ng-model=receiverForm.receiver.phone ng-if=!receiverForm.parcel.hasLetterNotification ng-required=receiverForm.phoneRequired has-home-delivery=receiverForm.parcel.hasHomeDelivery delivery-confirmation-possible=receiverForm.deliveryConfirmationPossible is-submitted=receiverForm.isSubmitted country-code=receiverForm.parcel.receiverCountryCode>\n    </cmn-receiver-phone-field-with-validation>\n  </div>\n  <!-- END notification fields for package sent from Sweden -->\n</ng-form>\n\n\n\n\n\n\n\n\n<script type=text/ng-template id=storedReceiversPopup.html>\n<div class=\"address__stored-receivers\"\n    ng-style=\"{top: position().top + \'px\', left: position().left + \'px\'}\"\n    style=\"display: block;\"\n    ng-show=\"isOpen() && !moveInProgress\"\n    aria-hidden=\"{{!isOpen}}\">\n\n    <ul class=\"address__stored-receivers__dropdown\" role=\"listbox\">\n        <li class=\"address__stored-receivers__dropdown__item\"\n            ng-repeat=\"match in matches track by $index\"\n            ng-class=\"{\'address__stored-receivers__dropdown__item--active\': isActive($index)}\"\n            ng-mouseenter=\"selectActive($index)\"\n            ng-click=\"selectMatch($index)\"\n            role=\"option\"\n            id=\"{{::match.id}}\">\n\n            <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n        </li>\n    </ul>\n</div>\n</script>\n\n<script type=text/ng-template id=storedReceiver.html>\n<a>\n    <div class=\"address__stored-receivers__dropdown__item__name\" ng-bind-html=\"(match.label.name || match.label.company) | uibTypeaheadHighlight:query\"></div>\n    <div class=\"address__stored-receivers__dropdown__item__address\">\n        {{match.label.address.street}}, {{match.label.address.zipCode}} {{match.label.address.city}}\n    </div>\n</a>\n</script>\n");
$templateCache.put("components/address/sender-form.directive.html","<ng-form name=senderForm.form>\n    <div class=\"form__row form__row--first\" ng-if=senderForm.isCustomerCompany>\n        <label for=senderForm_{{$id}}_companyName class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_SENDER_COMPANY_NAME\' | translate}}</label>\n        <input id=senderForm_{{$id}}_companyName autocomplete=organization name=companyName class=form__input maxlength=30 type=text ng-model=senderForm.sender.company.name ng-pattern=senderForm.regex required>\n\n        <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.companyName.$error\">\n            <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n            <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_COMPANY_NAME\' | translate}}</div>\n        </div>\n    </div>\n\n    <div class=form__row ng-if=\"senderForm.isCustomerCompany && senderForm.country === \'SE\'\">\n        <label for=senderForm_{{$id}}_organizationNumber class=form__label>{{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}}</label>\n        <input id=senderForm_{{$id}}_organizationNumber name=organizationNumber class=form__input maxlength=30 type=text ng-model=senderForm.sender.company.organizationNumber ng-pattern=senderForm.regex>\n\n        <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.organizationNumber.$error\">\n            <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n            <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ORGANIZATION_NUMBER\' | translate}}</div>\n        </div>\n    </div>\n    <div class=form__row ng-if=\"senderForm.isCustomerCompany && senderForm.country === \'DK\'\">\n            <label for=senderForm_{{$id}}_organizationNumber class=\"form__label form__label\">{{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}}</label>\n            <input id=senderForm_{{$id}}_organizationNumber name=organizationNumber class=form__input maxlength=30 type=text ng-pattern=senderForm.regex ng-model=senderForm.sender.company.organizationNumber>\n\n            <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.organizationNumber.$error\">\n                <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n                <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ORGANIZATION_NUMBER\' | translate}}</div>\n            </div>\n        </div>\n\n    <div class=form__row ng-class=\"{\'form__row--first\': !senderForm.isCustomerCompany}\">\n        <label for=senderForm_{{$id}}_name class=form__label ng-class=\"{\'form__label--required\': !senderForm.isCustomerCompany}\">{{ \'ADDRESS_PAGE_SENDER_NAME\' | translate}}</label>\n        <input id=senderForm_{{$id}}_name class=form__input maxlength=30 autocomplete=name name=name type=text ng-model=senderForm.sender.name ng-pattern=senderForm.regex ng-required=!senderForm.isCustomerCompany>\n\n        <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.name.$error\">\n            <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n            <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_NAME\' | translate}}</div>\n        </div>\n    </div>\n    <div class=form__row>\n        <label for=senderForm_{{$id}}_streetAddress class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_SENDER_ADDRESS\' | translate}}</label>\n        <input id=senderForm_{{$id}}_streetAddress class=form__input maxlength=30 autocomplete=address-line1 name=address_line1 type=text ng-model=senderForm.sender.address.street ng-pattern=senderForm.regex required>\n\n        <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.address_line1.$error\">\n            <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n            <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ADDRESS\' | translate}}</div>\n        </div>\n    </div>\n    <div class=form__row style=\"position: relative\" ng-if=\"senderForm.country === \'SE\' || senderForm.country === \'DK\'\">\n        <div class=form__row__inline>\n            <label for=senderForm_{{$id}}_zipCode class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_SENDER_ZIPCODE\' | translate}}</label>\n            <input id=senderForm_{{$id}}_zipCode name=senderPostalCode autocomplete=postal-code class=\"form__input form__input--half\" type=text ng-model=senderForm.sender.address.zipCode ng-model-options=\"{ debounce: 250 }\" ng-class=\"{\'form__input--invalid\': senderForm.form.senderPostalCode.$error.invalidPostalCode}\" required>\n\n            <div class=form__row__errors>\n                <div ng-messages=\"senderForm.isSubmitted && senderForm.form.senderPostalCode.$error\">\n                    <div ng-message=senderPostalCode>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ZIPCODE\' | translate}}</div>\n                </div>\n\n                <div class=form__input--half ng-messages=\"senderForm.isSubmitted && senderForm.form.senderPostalCode.$error\" ng-show=senderForm.form.senderPostalCode.$error.invalidPostalCode>\n                  <div ng-message=invalidPostalCode ng-bind-html=\"\'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ZIPAREA\' | translate\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=form__row__inline>\n            <label for=senderForm_{{$id}}_city class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_SENDER_ZIPAREA\' | translate}}</label>\n            <input id=senderForm_{{$id}}_city name=city class=\"form__input form__input--half\" type=text ng-model=senderForm.sender.address.city ng-pattern=senderForm.regex zipcode-city-autocomplete={{senderForm.sender.address.zipCode}} country-code={{senderForm.country}} validation-status=senderForm.validationStatus placeholder=\"{{ \'ADDRESS_PAGE_SENDER_ZIPAREA_PLACEHOLDER\' | translate}}\" maxlength=34 disabled required readonly>\n\n            <div class=form__row__errors>\n                <div ng-messages=\"senderForm.isSubmitted && senderForm.form.city.$error\" ng-show=!senderForm.form.zipCode.$error.required>\n                    <div ng-message=pattern>{{ \'ADDRESS_PAGE_ERROR_INVALID_CHARACTERS\' | translate}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=postcode__failed ng-show=\"!senderForm.isSubmitted && senderForm.validationStatus === \'invalid\' && !senderForm.sender.address.city && senderForm.sender.address.zipCode.length === 5\">\n            {{ \'ZIPCODE_NOT_FOUND_SENDER\' | translate}}\n        </div>\n    </div>\n\n    <div class=form__row>\n        <label for=senderForm_{{$id}}_email class=\"form__label form__label--required\">\n            {{ (senderForm.deliveryConfirmationPossible ? \'ADDRESS_PAGE_SENDER_EMAIL\' : \'ADDRESS_PAGE_SENDER_EMAIL_NO_CONFIRMATION\') | translate}}\n        </label>\n        <div class=form__input-group>\n            <input id=senderForm_{{$id}}_email autocomplete=email minlength=6 maxlength=64 name=email type=email class=form__input ng-model=senderForm.sender.email unsupported-email=senderForm.unsupportedEmail required ng-pattern=/^\\S+@\\S+\\.\\S+$/ >\n            <div class=form__input-group__description>{{ (senderForm.deliveryConfirmationPossible ? \'ADDRESS_PAGE_SENDER_NOTIFICATION_EMAIL\' : \'ADDRESS_PAGE_SENDER_NOTIFICATION_EMAIL_NO_CONFIRMATION\') | translate}}</div>\n        </div>\n\n        <div class=form__row__errors ng-messages=\"senderForm.isSubmitted && senderForm.form.email.$error\">\n            <div ng-message=minlength>{{ \'ADDRESS_PAGE_ERROR_EMAIL_MINLENGTH\' | translate}}</div>\n            <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_EMAIL\' | translate}}</div>\n            <div ng-message=email>{{ \'ADDRESS_PAGE_ERROR_EMAIL_SENDER_EMAIL\' | translate}}</div>\n        </div>\n\n        <div class=form__disclaimer ng-show=senderForm.unsupportedEmail ng-bind-html=\"(\'ADDRESS_PAGE_WARNING_UNSUPPORTED_EMAIL\' | translate:{domain: senderForm.unsupportedEmail}:\'messageformat\')\"></div>\n    </div>\n</ng-form>\n");
$templateCache.put("components/customs/customs.content.html","<div class=\"main-content__box customs\">\n  <ng-form name=customs.form>\n    <div class=box>\n      <div class=box__header>\n        <div class=box__header__title>\n          {{ \'CUSTOMS_PAGE_CONTENT_TITLE\' | translate}}\n        </div>\n      </div>\n      <div class=box__content>\n        <div class=\"form__row form__row--first\">\n          <label class=\"form__label form__label--required\" for=typeOfExport>{{ \'CUSTOMS_INPUT_TYPE\' | translate}}</label>\n          <ui-select name=typeOfExport class=customs__input-group__input ng-class=\"{\'dropdown-error\': customs.form.$submitted && !customs.docs.typeOfExport}\" ng-model=customs.docs.typeOfExport on-select=\"\" theme=selectize required skip-focusser=true search-enabled=false>\n          <ui-select-match allow-clear=true placeholder=\"{{\'SELECT\' | translate}}\">\n            <strong>{{$select.selected}}</strong>\n          </ui-select-match>\n          <ui-select-choices repeat=\"option in customs.exportOptions\">\n            <span>{{option}}</span>\n          </ui-select-choices>\n          \n          <div class=form__input-group__description ng-bind-html=\"\'CUSTOMS_INPUT_TYPE_DESCRIPTION\' | translate\"></div>\n\n        </div>\n        <div class=form__row>\n          <label class=\"form__label form__label--required\" for=currency>{{ \'CUSTOMS_INPUT_CURRENCY\' | translate}}</label>\n          <ui-select name=currency class=customs__input-group__input ng-class=\"{\'dropdown-error\': customs.form.$submitted && !customs.docs.currency}\" ng-model=customs.docs.currency on-select=\"\" required theme=selectize skip-focusser=true search-enabled=false>\n            <ui-select-match allow-clear=true placeholder=\"{{\'SELECT\' | translate}}\">\n              <strong>{{$select.selected}}</strong>\n            </ui-select-match>\n            <ui-select-choices repeat=\"option in customs.currencyOptions\">\n              <span>{{option}}</span>\n            </ui-select-choices>\n          </ui-select>\n          <div class=form__input-group__description>{{ \'CUSTOMS_INPUT_CURRENCY_DESCRIPTION\' | translate}}</div>\n        </div>\n      </div>\n    </div>\n    <div class=box>\n      <div class=box__header>\n        <div class=box__header__title>\n          {{ \'CUSTOMS_PAGE_ITEM_TITLE\' | translate}}\n        </div>\n      </div>\n      <div class=box__content>\n        <div class=\"form__row form__row--first\">\n          <label class=\"form__label form__label--required\" for=quantity>{{ \'CUSTOMS_INPUT_QUANTITY\' | translate}}</label>\n          <div class=form__input-group>\n            <input class=\"form__input customs-width customs-width__number\" name=quantity min=1 type=number required ng-model=customs.docs.quantity>\n            <div class=form__input-group__description>{{ \'CUSTOMS_INPUT_QUANTITY_DESCRIPTION\' | translate}}</div>\n          </div>\n        </div>\n\n        <div class=form__row ng-if=isDK()>\n          <label for=weight class=\"form__label form__label--required\">{{ \'CUSTOMS_INPUT_WEIGHT\' | translate }}</label>\n          <div class=form__input-group>\n            <input class=\"form__input customs-width customs-width__number\" id=weight name=weight type=number ng-model=customs.docs.weight min=0.001 step=0.1 required class=\"form__input customs-width customs-width__number\">\n            <div class=form__input-group__description>{{ \'CUSTOMS_INPUT_WEIGHT_DESCRIPTION\' | translate }}</div>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label class=\"form__label form__label--required\" for=description>{{ \'CUSTOMS_INPUT_DESCRIPTION\' | translate}}</label>\n          <div class=form__input-group>\n            <input class=\"form__input customs-width\" name=description type=text required placeholder=\"Max 30 characters\" maxlength=30 ng-model=customs.docs.description>\n            <div class=form__input-group__description>{{ \'CUSTOMS_INPUT_DESCRIPTION_DESCRIPTION\' | translate}}</div>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label class=\"form__label form__label--required\" for=countryOfOrigin>{{ \'CUSTOMS_INPUT_COUNTRY_OF_ORIGIN\' | translate}}</label>\n          <ui-select id=countryOfOrigin name=countryOfOrigin class=customs__input-group__input ng-class=\"{\'dropdown-error\': customs.form.$submitted && !customs.docs.countryOfOrigin}\" ng-model=customs.docs.countryOfOrigin on-select=\"\" required theme=selectize skip-focusser=true search-enabled=false>\n            <ui-select-match allow-clear=true placeholder=\"{{\'SELECT\' | translate}}\">\n              <strong>{{$select.selected.name}}</strong>\n            </ui-select-match>\n            <ui-select-choices repeat=\"option in customs.originCountry\">\n              <span>{{option.name}}</span>\n            </ui-select-choices>\n          </ui-select>\n          <div class=form__input-group__description>{{ \'CUSTOMS_INPUT_COUNTRY_OF_ORIGIN_DESCRIPTION\' | translate}}\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label class=form__label for=hsTariff>{{ \'CUSTOMS_INPUT_HSTARIFF\' | translate}}</label>\n          <div class=form__input-group>\n            <input class=\"form__input customs-width\" id=hsTariff name=hsTariff type=text ng-pattern=/(^[A-Z]{2}[0-9]{4,10}$)|(^[0-9]{4,12}$)/ ng-model=customs.docs.hsTariffNumber>\n            <div class=form__input-group__description ng-bind-html=\"\'CUSTOMS_INPUT_HSTARIFF_DESCRIPTION\' | translate\">\n            </div>\n          </div>\n        </div>\n        <div class=form__row>\n          <label class=\"form__label form__label--required\" for=customsValue>{{ \'CUSTOMS_INPUT_VALUE\' | translate}}</label>\n          <div class=\"form__input-group value-after\" currency={{customs.docs.currency}}>\n            <input class=\"form__input customs-width customs-value\" name=customsValue ng-pattern=/^\\d{1,7}(\\.\\d{1,2})?$/ required ng-model=customs.docs.customsValue>\n          </div>\n        </div>\n        <div class=form__row>\n          <button class=\"btn btn--blue customs-add-button\" type=submit ng-click=customs.addCustomsDocuments(customs.docs)><span ng-if=!customs.isEditingDocument>{{ \'CUSTOMS_BUTTON_ADD\' | translate}}</span><span ng-if=customs.isEditingDocument>{{ \'CUSTOMS_BUTTON_SAVE\' | translate}}</span>\n          </button>\n          <button class=\"btn btn--outlined btn--small customs-button-outlined\" ng-if=customs.isEditingDocument type=submit ng-click=customs.addCustomsDocuments(customs.docs)>{{ \'BUTTON_CANCEL_EDIT\' | translate}}\n          </button>\n        </div>\n        <div class=customs-error ng-if=customs.onlyFiveItemsAllowed>{{ \'CUSTOMS_ONLY_FIVE_ITEMS_ALLOWED\' | translate}}\n        </div>\n      </div>\n\n    </div>\n  </ng-form>\n  <customs-documents cn22error=customs.cn22error documents=customs.customsDocuments agreement=customs.agreement>\n  </customs-documents>\n  <div class=address__btns ng-show=\"customs.customsDocuments.items.length > 0\">\n    <button ng-disabled=\"customs.isSubmitting || !customs.agreement || customs.cn22error === true\" ng-click=\"customs.addToCart(customs.parcel, \'main.landing\')\" class=\"btn btn--blue\" type=button ng-class=\"{\'btn--loading\': customs.nextState === \'main.landing\'}\">\n      {{ \'CUSTOMS_BUTTON_SAVE_MORE\' | translate}}\n    </button>\n\n    <button ng-disabled=\"customs.isSubmitting || !customs.agreement || customs.cn22error === true\" ng-click=\"customs.addToCart(customs.parcel, \'main.payment\')\" class=\"btn btn--blue\" type=submit ng-class=\"{\'btn--loading\': customs.nextState === \'main.payment\'}\">\n      {{ \'CUSTOMS_BUTTON_SAVE_PAY\' | translate}}\n    </button>\n  </div>\n\n</div>\n");
$templateCache.put("components/customs/customs.html","<div class=page-header>\n    <h1 class=page-header__title ng-if=!customs.parcel.isEditing>{{ \'PAGE_HEADER_ADDRESS\' | translate}}</h1>\n    <h1 class=page-header__title ng-if=customs.parcel.isEditing>{{ \'PAGE_HEADER_ADDRESS_EDIT\' | translate}}</h1>\n</div>\n\n<progress-tracker stage=\"\'customs\'\" parcel=customs.parcel></progress-tracker>\n\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/customs/customs.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/customs/customs.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n");
$templateCache.put("components/customs/customs.sidebar.html","<div class=hidden-xs>\n    <cmn-sidebar-selected-product ng-show=\"customs.parcel && !customs.parcel.isEditing\" product=customs.parcel edit-parcel-callback=customs.editParcel country={{main.country}}>\n    </cmn-sidebar-selected-product>\n</div>\n\n\n<cmn-sidebar-cart cart=main.cart is-customer-company=main.isCustomerCompany show-button=customs.parcel.isEditing ng-show=\"main.cart.length > 0\">\n</cmn-sidebar-cart>\n");
$templateCache.put("components/customs/leave.dialog.html","<md-dialog class=leave-dialog aria-label=\"Delete error\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3>{{\'CUSTOMS_LEAVE_DIALOG_HEADER\' | translate}}</h3>\n            <p>{{\'CUSTOMS_LEAVE_DIALOG_TEXT\' | translate}}</p>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=column>\n        <md-button class=md-cancel-button ng-click=confirm()>\n            {{ \'CUSTOMS_LEAVE_DIALOG_BUTTON\' | translate}}\n        </md-button>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/customs-new/customs.content.html","<div class=\"main-content__box customs-new\">\n  <form name=customs.form class=form novalidate>\n    <ng-form name=customs.valueForm class=box>\n      <header>\n        <h2>{{\'CUSTOMS_PAGE_CONTENT_TITLE\' | translate}}</h2>\n      </header>\n\n      <p ng-if=!customs.isEditingParcel>\n        <material-icon>info</material-icon>\n        <span>\n          {{ \'CUSTOMS_LANGUAGE_DESCRIPTION\' | translate }}<br><br>\n          {{ customs.country === \'SE\' ? \'CUSTOMS_CANT_PRINT_AT_SERVICE_POINT\' : \'\' | translate }}\n        </span>\n      </p>\n\n      <fieldset class=box__content ng-disabled=\"customs.documents.length &gt;= customs.itemLimit &amp;&amp; !customs.isEditing\">\n        <div class=\"form__row first\">\n          <label for=typeOfExport class=required>{{ \'CUSTOMS_INPUT_TYPE\' | translate }}</label>\n          <div class=group>\n            <select id=typeOfExport name=typeOfExport ng-model=customs.document.typeOfExport ng-options=\"(\'CUSTOMS_TYPE_OF_EXPORT_\' + type | translate) for type in customs.options.exportTypes\" required>\n              <option value=\"\" disabled>{{ \'CUSTOMS_INPUT_TYPE_EMPTY\' | translate }}</option>\n            </select>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_TYPE_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row ng-if=\"customs.document.typeOfExport === \'OTHER\'\">\n          <label for=typeOfExportExplanation class=required>{{ \'CUSTOMS_INPUT_TYPE_EXPLANATION\' | translate }}</label>\n          <div class=group>\n            <input id=typeOfExportExplanation name=typeOfExportExplanation type=text ng-model=customs.document.typeOfExportExplanation required>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_TYPE_EXPLANATION_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <!-- <label for=\"customsValue\" class=\"required\">{{ \'CUSTOMS_INPUT_VALUE\' | translate }}</label> -->\n          <label for=customsValue class=required>{{ \'CUSTOMS_INPUT_VALUE_IN_CURRENCY\' | translate:{ currency: customs.currency } }}</label>\n          <div class=group>\n            <input id=customsValue name=customsValue type=number ng-model=customs.document.customsValue ng-change=customs.updateCustomsType() min=1 max=9999999 step=1 required>\n          </div>\n        </div>\n      </fieldset>\n    </ng-form>\n\n    <ng-form name=customs.extendedForm class=box ng-show=customs.extendedFormVisible>\n      <header>\n        <h2>{{\'CUSTOMS_PAGE_ITEM_TITLE\' | translate}}</h2>\n      </header>\n\n      <fieldset class=box__content ng-disabled=\"customs.documents.length &gt;= customs.itemLimit &amp;&amp; !customs.isEditing\">\n        <div class=\"form__row first\" ng-if=\"customs.country === \'SE\'\">\n          <label for=eori ng-class=\"{required: customs.isCN23}\">{{ \'CUSTOMS_INPUT_EORI\' | translate }}</label>\n          <div class=group>\n            <input id=eori name=eori type=text ng-model=customs.eori ng-required=customs.isCN23>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_EORI_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row ng-class=\"{ first: customs.country !== \'SE\' }\">\n          <label for=quantity class=required>{{ \'CUSTOMS_INPUT_QUANTITY\' | translate }}</label>\n          <div class=group>\n            <input id=quantity name=quantity type=number ng-model=customs.document.quantity min=1 step=1 ng-pattern=/^\\d{1,6}$/ required>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_QUANTITY_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label for=weight class=required>{{ \'CUSTOMS_INPUT_WEIGHT\' | translate }}</label>\n          <div class=group>\n            <input id=weight name=weight type=number ng-model=customs.document.weight min=0.001 step=0.1 required>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_WEIGHT_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label for=description class=required>{{ \'CUSTOMS_INPUT_DESCRIPTION\' | translate }}</label>\n          <div class=group>\n            <input id=description name=description type=text ng-model=customs.document.description placeholder=\"{{\'CUSTOMS_INPUT_DESCRIPTION_PLACEHOLDER\' | translate}}\" maxlength=30 required>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_DESCRIPTION_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label for=countryOfOrigin class=required>{{ \'CUSTOMS_INPUT_COUNTRY_OF_ORIGIN\' | translate }}</label>\n          <div class=group>\n            <select id=countryOfOrigin name=countryOfOrigin ng-model=customs.document.countryOfOrigin ng-options=\"country.name as country.name for country in customs.options.countries\" required>\n              <option value=\"\" disabled>{{ \'CUSTOMS_INPUT_COUNTRY_OF_ORIGIN_EMPTY\' | translate }}</option>\n            </select>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_COUNTRY_OF_ORIGIN_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <label for=hsTariffNumber>{{ \'CUSTOMS_INPUT_HSTARIFF\' | translate }}</label>\n          <div class=group>\n            <input id=hsTariffNumber name=hsTariffNumber type=text ng-model=customs.document.hsTariffNumber ng-pattern=/(^[A-Z]{2}[0-9]{4,10}$)|(^[0-9]{4,12}$)/ maxlength=14>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_HSTARIFF_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row ng-if=customs.isCN23>\n          <label for=invoiceNumber>{{ \'CUSTOMS_INPUT_INVOICE_NUMBER\' | translate }}</label>\n          <div class=group>\n            <input id=invoiceNumber name=invoiceNumber type=text ng-model=customs.document.invoiceNumber>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_INVOICE_NUMBER_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row ng-if=customs.isCN23>\n          <label for=comments>{{ \'CUSTOMS_INPUT_COMMENTS\' | translate }}</label>\n          <div class=group>\n            <textarea id=comments name=comments ng-model=customs.document.comments></textarea>\n            <p ng-bind-html=\"\'CUSTOMS_INPUT_COMMENTS_DESCRIPTION\' | translate\"></p>\n          </div>\n        </div>\n\n        <div class=form__row>\n          <button type=submit class=\"btn btn--blue\" ng-click=customs.addDocument(customs.document) ng-if=\"customs.extendedFormVisible && customs.document.id === undefined\" ng-disabled=\"customs.valueForm.$invalid || customs.extendedForm.$invalid\">\n            <material-icon class=before>add</material-icon> {{\'CUSTOMS_BUTTON_ADD\' | translate}}\n          </button>\n          <button type=submit class=\"btn btn--blue\" ng-click=customs.saveDocument(customs.document) ng-if=\"customs.extendedFormVisible && customs.document.id !== undefined\" ng-disabled=\"customs.valueForm.$invalid || customs.extendedForm.$invalid\">\n            <material-icon class=before>add</material-icon> {{\'CUSTOMS_BUTTON_SAVE\' | translate}}\n          </button>\n        </div>\n      </fieldset>\n    </ng-form>\n\n    <ng-form name=customs.approveTermsForm class=\"box documents-table\" ng-if=customs.extendedFormVisible>\n      <header>\n        <h2>{{\'CUSTOMS_PAGE_YOUR_DECLARATION_TITLE\' | translate}}</h2>\n        <span>{{customs.documents.length}}/{{customs.itemLimit}} {{\'CUSTOMS_ITEMS\' | translate}}</span>\n      </header>\n\n      <div class=box__content>\n        <table>\n          <thead>\n            <tr>\n              <th></th>\n              <th>{{\'CUSTOMS_TABLE_QUANTITY\' | translate}}</th>\n              <th>{{\'CUSTOMS_TABLE_CONTENT\' | translate}}</th>\n              <th>{{\'CUSTOMS_TABLE_VALUE\' | translate}}</th>\n              <th>{{\'CUSTOMS_TABLE_COUNTRY\' | translate}}</th>\n              <th>{{\'CUSTOMS_TABLE_HSTARIFF\' | translate}}</th>\n              <th></th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-repeat=\"document in customs.documents\" ng-class=\"{ active: customs.document.id === document.id }\">\n              <td></td>\n              <td>{{document.quantity}}</td>\n              <td truncate>{{document.description}}</td>\n              <td>{{document.customsValue}} {{document.currency}}</td>\n              <td truncate>{{document.countryOfOrigin}}</td>\n              <td truncate>{{document.hsTariffNumber}}</td>\n              <td class=actions>\n                <button type=button class=edit ng-click=customs.editDocument(document)></button>\n                <button type=button class=remove ng-click=customs.removeDocument(document)></button>\n              </td>\n              <td></td>\n            </tr>\n            <tr ng-if=\"customs.documents.length === 0\">\n              <td></td>\n              <td class=empty colspan=6>{{\'CUSTOMS_TABLE_EMPTY\' | translate}}</td>\n              <td></td>\n            </tr>\n          </tbody>\n        </table>\n\n        <ul ng-repeat=\"document in customs.documents\">\n          <li>\n            <h5>{{\'CUSTOMS_TABLE_QUANTITY\' | translate}}</h5>\n            <p>{{document.quantity}}</p>\n            <div class=actions>\n              <button type=button class=edit ng-click=customs.editDocument(document)></button>\n              <button type=button class=remove ng-click=customs.removeDocument(document)></button>\n            </div>\n          </li>\n          <li>\n            <h5>{{\'CUSTOMS_TABLE_CONTENT\' | translate}}</h5>\n            <p>{{document.description}}</p>\n          </li>\n          <li>\n            <h5>{{\'CUSTOMS_TABLE_VALUE\' | translate}}</h5>\n            <p>{{document.customsValue}} {{document.currency}}</p>\n          </li>\n          <li>\n            <h5>{{\'CUSTOMS_TABLE_COUNTRY\' | translate}}</h5>\n            <p>{{document.countryOfOrigin}}</p>\n          </li>\n          <li ng-if=documents.hsTariffNumber>\n            <h5>{{\'CUSTOMS_TABLE_HSTARIFF\' | translate}}</h5>\n            <p>{{document.hsTariffNumber}}</p>\n          </li>\n        </ul>\n\n        <p class=empty-text ng-if=\"customs.documents.length === 0\">{{\'CUSTOMS_TABLE_EMPTY\' | translate}}</p>\n\n        <p class=customs-notice ng-if=\"customs.documents.length &gt;= customs.itemLimit\">\n          <material-icon>error</material-icon>\n          {{\'CUSTOMS_TABLE_QUOTA_MESSAGE\' | translate:{ limit: customs.itemLimit } }}\n        </p>\n        <label class=checkbox ng-class=\"{\'error\': customs.approveError && !customs.hasApprovedTerms}\">\n          <input type=checkbox ng-model=customs.hasApprovedTerms required>\n          <p>{{\'CUSTOMS_AGREEMENT\' | translate}}</p>\n        </label>\n      </div>\n    </ng-form>\n\n    <button type=button class=\"btn btn--blue btn--block\" ng-click=customs.showExtendedForm() ng-if=!customs.extendedFormVisible ng-disabled=customs.valueForm.$invalid>{{\'CUSTOMS_BUTTON_CONTINUE\' | translate}} <material-icon>\n        keyboard_arrow_down</material-icon></button>\n\n    <div>\n      <button type=submit class=\"btn btn--blue btn--block\" ng-class=\"{ \'btn--loading\': customs.isSubmittingLanding }\" ng-click=\"customs.proceed(customs.documents, \'main.landing\')\" ng-if=\"customs.extendedFormVisible && !customs.fromPayment\" ng-disabled=\"customs.approveTermsForm.$invalid || customs.documents.length === 0 || customs.isSubmitting || customs.isSubmittingLanding\">\n        {{\'BUTTON_ADDMORE_PARCELS\' | translate}} <material-icon>chevron_right</material-icon>\n      </button>\n\n      <button type=submit class=\"btn btn--blue btn--block\" ng-class=\"{ \'btn--loading\': customs.isSubmitting }\" ng-click=\"customs.proceed(customs.documents, \'main.payment\')\" ng-if=customs.extendedFormVisible ng-disabled=\"customs.approveTermsForm.$invalid || customs.documents.length === 0 || customs.isSubmitting || customs.isSubmittingLanding\">\n        {{\'CUSTOMS_BUTTON_ADD_AND_CONTINUE\' | translate}} <material-icon>chevron_right</material-icon>\n      </button>\n    </div>\n  </form>\n</div>");
$templateCache.put("components/customs-new/customs.html","<div class=page-header>\n    <h1 class=page-header__title ng-if=!customs.parcel.isEditing>{{ \'PAGE_HEADER_CUSTOMS\' | translate}}</h1>\n    <h1 class=page-header__title ng-if=customs.parcel.isEditing>{{ \'PAGE_HEADER_CUSTOMS_EDIT\' | translate}}</h1>\n</div>\n\n<progress-tracker stage=\"\'customs\'\" parcel=customs.product></progress-tracker>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/customs-new/customs.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/customs-new/customs.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n");
$templateCache.put("components/customs-new/customs.sidebar.html","<div class=hidden-xs>\n    <cmn-sidebar-selected-product ng-show=\"customs.product && !customs.product.isEditing\" product=customs.product edit-parcel-callback=customs.editParcel country={{main.country}}>\n    </cmn-sidebar-selected-product>\n</div>\n\n<cmn-sidebar-cart cart=main.cart is-customer-company=main.isCustomerCompany show-button=customs.product.isEditing ng-show=\"main.cart.length > 0\">\n</cmn-sidebar-cart>\n");
$templateCache.put("components/customs-new/leave.dialog.html","<md-dialog class=leave-dialog aria-label=\"Delete error\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3>{{\'CUSTOMS_LEAVE_DIALOG_HEADER\' | translate}}</h3>\n            <p>{{\'CUSTOMS_LEAVE_DIALOG_TEXT_WARNING\' | translate}}</p>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions>\n      <md-button class=md-confirm-button ng-click=confirm()>\n          {{ \'CUSTOMS_LEAVE_DIALOG_BUTTON_CONFIRM\' | translate}}\n      </md-button>\n      <md-button class=md-cancel-button ng-click=cancel()>\n        {{ \'CUSTOMS_LEAVE_DIALOG_BUTTON_CANCEL\' | translate}}\n    </md-button>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/landing/landing.content.html","<!-- <logged-in-mode-banner ng-if=\"!main.isDanishUser && main.country === \'SE\'\"></logged-in-mode-banner> -->\n<danish-banner ng-if=\"main.isDanishUser && main.country === \'SE\'\"></danish-banner>\n<!-- <print-at-servicepoint-banner></print-at-servicepoint-banner> -->\n<div class=main-content__box>\n  <div class=\"box box--gray landing-box\">\n    <div class=countryselection ng-class=\"{\'dk-margin-bottom\': main.country === \'DK\'}\">\n      <div class=countryselection__title>\n        {{ \'WHERE_TO_COUNTRY\' | translate}}\n      </div>\n\n      <cmn-country-selector is-editing=landing.isEditingParcel selected-country=landing.selectedCountry on-select=main.getParcelTypesForCountry countries=landing.countrySelection>\n      </cmn-country-selector>\n    </div>\n\n    <div class=\"box__content box__content--no-padding-top box__content--main\">\n      <div class=landing-box__parcel-selector>\n        <div class=landing-box__parcel-selector__title ng-if=\"main.country === \'SE\'\">\n          {{ \'WHERE_TO\' | translate}}\n        </div>\n\n        <se-product-selector ng-if=\"main.country === \'SE\'\" selected-product=landing.selectedType products=main.parcelTypes is-customer-company=main.isCustomerCompany is-editing-product=landing.isEditingParcel>\n        </se-product-selector>\n\n        <!-- <dk-product-selector\n                    ng-if=\"main.country === \'DK\'\"\n                    products=\"main.parcelTypes\"\n                    selected-product=\"landing.selectedType\"\n                    selected-weight=\"landing.selectedWeight\"\n                    is-editing-product=\"landing.isEditingParcel\"\n                    is-customer-company=\"main.isCustomerCompany\"\n                    receiver-country-code=\"landing.selectedCountry.countryCode\">\n                </dk-product-selector> -->\n\n        <dk-product-group-selector ng-if=\"main.country === \'DK\'\" is-customer-company=main.isCustomerCompany product-groups=main.productGroups selected-product-group=landing.selectedProductGroup selected-product=landing.selectedType selected-weight=landing.selectedWeight to-country=landing.selectedCountry>\n        </dk-product-group-selector>\n      </div>\n\n      <dk-product-information ng-if=\"main.country === \'DK\'\" product=landing.selectedType product-group=landing.selectedProductGroup selected-weight=landing.selectedWeight is-customer-company=main.isCustomerCompany number-of-services=landing.numberOfAdditionalServices editing-product=landing.editParcel is-submit-disabled=\"landing.isProcessing || !landing.isProductValid(landing.selectedType) || main.loadingProducts\" is-submitting=landing.isProcessing on-submit=landing.next is-submitted=landing.isSubmitted receiver-country=landing.selectedCountry>\n      </dk-product-information>\n\n      <se-product-information ng-if=\"main.country === \'SE\'\" product=landing.selectedType is-customer-company=main.isCustomerCompany number-of-services=landing.numberOfAdditionalServices editing-product=landing.editParcel is-submit-disabled=\"landing.isProcessing || main.loadingProducts\" is-submitting=landing.isProcessing is-submitted=landing.isSubmitted on-submit=landing.next selected-country=landing.selectedCountry>\n      </se-product-information>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/landing/landing.html","<div class=page-header ng-if=!landing.isEditingParcel>\n    <h1 class=page-header__title ng-if=\"main.country === \'SE\'\">{{ \'PAGE_HEADER_LANDING_SE\' | translate}}</h1>\n    <h1 class=page-header__title ng-if=\"main.country === \'DK\'\">{{ \'PAGE_HEADER_LANDING_DK\' | translate}}</h1>\n\n    <p class=page-header__text ng-class=\"{\'expanded\': landing.isHeaderSubExpanded}\" ng-if=\"main.country === \'SE\'\">{{ \'PAGE_HEADER_LANDING_SUB_SE\' | translate}}</p>\n    <p class=page-header__text ng-class=\"{\'expanded\': landing.isHeaderSubExpanded}\" ng-if=\"main.country === \'DK\'\">{{ \'PAGE_HEADER_LANDING_SUB_DK\' | translate}}</p>\n \n    <a class=page-header__expand ng-if=!landing.isHeaderSubExpanded ng-click=landing.toggleHeaderSubExpanded()>{{\'PAGE_HEADER_LANDING_READ_MORE\' | translate}}</a>\n    <a class=page-header__expand ng-if=landing.isHeaderSubExpanded ng-click=landing.toggleHeaderSubExpanded()>{{\'PAGE_HEADER_LANDING_READ_LESS\' | translate}}</a>\n</div>\n\n<div class=page-header ng-if=landing.isEditingParcel>\n    <h1 class=page-header__title>{{ \'PAGE_HEADER_LANDING_EDIT\' | translate}}</h1>\n</div>\n\n<progress-tracker stage=\"\'landing\'\" editing-from-state=landing.editingFromState parcel=landing.selectedType></progress-tracker>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/landing/landing.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/landing/landing.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n\n<div class=customer-type-selector>\n    <div class=customer-type-selector__actions>\n        <button class=customer-type-selector__button ng-class=\"{\'active\': main.isCustomerCompany === false}\" ng-click=main.setCustomerType(false)>\n            {{ \'I_AM\' | translate}} {{ \'PRIVATE\' | translate}}\n        </button>\n        <button class=customer-type-selector__button ng-class=\"{\'active\': main.isCustomerCompany === true}\" ng-click=main.setCustomerType(true)>\n            {{ \'I_AM\' | translate}} {{ \'COMPANY\' | translate}}\n        </button>\n    </div>\n    <p class=customer-type-selector__text>{{ \'PRICES_SHOWN\' | translate}} <strong>{{ (main.isCustomerCompany ? \'EXCL_VAT\' : \'INCL_VAT\') | translate}}</strong></p>\n</div>\n");
$templateCache.put("components/landing/landing.sidebar.html","<cmn-sidebar-selected-product ng-show=landing.selectedType product=landing.selectedType selected-weight=landing.selectedWeight is-customer-company=main.isCustomerCompany>\n</cmn-sidebar-selected-product>\n\n<cmn-sidebar-cart cart=main.cart is-customer-company=main.isCustomerCompany ng-show=\"main.cart.length > 0\">\n</cmn-sidebar-cart>\n\n<se-sidebar-measurement ng-if=\"main.country === \'SE\'\"></se-sidebar-measurement>\n\n<dk-measurements ng-show=\"main.country === \'DK\'\"></dk-measurements>\n<dk-climate-compensation ng-show=\"main.country === \'DK\'\" product=landing.selectedType></dk-climate-compensation>\n");
$templateCache.put("components/layout/base.html","<div class=unsupported-browser-message ng-cloak ng-if=unsupportedBrowser>\n    Tyvärr stödjer vi inte din version av webbläsare. Var vänlig uppgradera till senaste versionen eller använd en annan webbläsare.\n</div>\n\n<div ng-if=!unsupportedBrowser>\n    <div class=vatselection_overlay ng-show=\"main.isCustomerCompany === undefined && !localStorageDisabled && main.country === \'SE\'\">\n        <div class=selection__box>\n            <div class=selection__box__image ng-if=\"main.country === \'SE\'\">\n                <img src=assets/images/graphics-popup@2x.png width=200px>\n                <h2>{{ \'CUSTOMER_SELECTION_WELCOME\' | translate}} <span>{{ \'CUSTOMER_SELECTION_TITLE\' | translate}}</span></h2>\n                <p>{{ \'CUSTOMER_SELECTION_SUBHEADER\' | translate}}</p>\n            </div>\n            <div class=selection__box__container>\n                <div class=selection__box__container__private id=btn-private-customer-selection ng-click=main.setCustomerType(false)>\n                    <p>{{ \'I_AM\' | translate}}<b> {{ \'PRIVATE\' | translate}}</b></p>\n                    <p class=subtext>{{ \'PRICES_SHOWS_INCL_VAT\' | translate}}</p>\n                </div>\n                <div class=selection__box__container__company id=btn-business-customer-selection ng-click=main.setCustomerType(true)>\n                    <p>{{ \'I_AM\' | translate}}<b> {{ \'COMPANY\' | translate}}</b></p>\n                    <p class=subtext>{{ \'PRICES_SHOWS_EXCL_VAT\' | translate}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=localstorage-disabled-modal ng-if=localStorageDisabled>\n        <div class=localstorage-disabled-modal__dialog>\n            <div class=localstorage-disabled-modal__dialog__title>{{\'LOCALSTORAGE_DISABLED_TITLE\' | translate}}</div>\n            <div class=localstorage-disabled-modal__dialog__text ng-bind-html=\"\'LOCALSTORAGE_DISABLED_TEXT\' | translate\"></div>\n        </div>\n    </div>\n\n    <feature-toggler is-open=main.featureTogglerOpen></feature-toggler>\n\n    <disturbance-message message=main.disturbanceMessage ng-if=main.disturbanceMessage></disturbance-message>\n    <siteheader ng-if=showMarketWebNavigation></siteheader>\n    <navigation-menu ng-if=\"!!main.navigationMenuItems && main.showNavigationMenu(currentState)\" menu-items=main.navigationMenuItems></navigation-menu>\n    <beta-banner ng-if=\"currentState !== \'main.landing\' && main.country === \'SE\' && showMarketWebNavigation\"></beta-banner>\n\n    <div class=\"outer-container center\" ng-class=\"{\n        \'blurred\': main.isCustomerCompany === undefined || localStorageDisabled || main.featureTogglerOpen || main.pabloDownMessage || main.netsMaintenanceMessage,\n        \'outer-container--has-cookie-bar\': main.cookieBarVisible,\n        \'container\': currentState !== \'main.signup\'}\">\n        <!-- <closed-banner ng-if=\"main.country === \'DK\'\"></closed-banner> -->\n        <beta-banner-landing ng-if=\"currentState === \'main.landing\' && main.country === \'SE\' && showMarketWebNavigation\"></beta-banner-landing>\n        <div ui-view></div>\n        <div class=parcel-added-toaster>\n            <toaster event=\"\'parcelAddedToCart\'\" type=\"\'success\'\"></toaster>\n        </div>\n\n        <div ng-if=!showMarketWebNavigation>\n            <div class=customerservice ng-if=\"main.country === \'SE\'\">\n                {{ \'CUSTOMERSERVICE_TEXT_SE\' | translate}} <a class=underline ng-click=main.openHumanyContact()>{{ \'CUSTOMERSERVICE_ACTION_SE\' | translate }}</a> <br>\n            </div>\n            <div class=customerservice ng-if=\"main.country === \'DK\'\">\n                {{ \'CUSTOMERSERVICE_TEXT_DK\' | translate}} <a class=underline href=tel:70102050>70102050</a><br>\n                {{ \'CUSTOMERSERVICE_EMAIL_DK\' | translate}}: <a href=mailto:onlineporto@postnord.com>onlineporto@postnord.com</a>\n            </div>\n\n            <div class=privacy-policy ng-hide=\"currentState === \'main.payment-redirect\'\">\n                <a href=\"{{\'PRIVACY_LINK_URL\' | translate}}\" class=privacy-policy__link target=_blank>{{\'PRIVACY_LINK_TEXT\' | translate}}</a>\n                &nbsp;&nbsp;\n                <a href=\"{{\'COOKIE_BAR_READ_MORE_URL\' | translate}}\" class=privacy-policy__link target=_blank>{{\'COOKIE_BAR_READ_MORE\' | translate}}</a>\n            </div>\n        </div>\n    </div>\n\n    <pn-marketweb-sitefooter class=site-footer endpoint={{main.marketwebEndpoint}} environment={{main.marketwebEnvironment}} market={{main.country.toLowerCase()}} language={{main.language}} site-domain-in-urls=true>\n\n    <feedback-button></feedback-button>\n    <floating-faq ng-if=\"main.country !== \'DK\'\"></floating-faq>\n</div>\n");
$templateCache.put("components/payment/payment-redirect.html","<progress-tracker stage=\"\'payment\'\" cart=paymentRedirect.cart></progress-tracker>\n\n<div class=main-container>\n    <div class=payment-redirect>\n        <div ng-if=\"paymentRedirect.paymentMethod !== \'SWISH-ECOMMERCE\'\">\n            <div class=payment-redirect__spinner></div>\n            <div class=payment-redirect__message>\n                <div class=payment-redirect__message__title>{{ \'TRANSACTION_PROCESSING\' | translate }}</div>\n                <div class=payment-redirect__message__text>{{ \'TRANSACTION_DONT_LEAVE\' | translate }}</div>\n            </div>\n        </div>\n        <div ng-if=\"paymentRedirect.paymentMethod === \'SWISH-ECOMMERCE\'\">\n            <div class=payment-redirect__swish-logo></div>\n            <div class=payment-redirect__message>\n                <div class=payment-redirect__message__title>{{\'SWISH_OPEN_APP\' | translate}}</div>\n                <div class=payment-redirect__message__text>{{ \'SWISH_DONT_LEAVE\' | translate }}</div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/payment.content.html","<div class=main-content__box>\n    <form name=payment.form novalidate>\n        <div class=box>\n            <div class=box__header>\n                <div class=box__header__title>{{ \'PAYMENT_YOUR_CART\' | translate}} ({{payment.cart.length}})</div>\n                <button type=button class=\"btn btn--header\" ng-if=!payment.hideBuyMore ng-disabled=payment.isSubmitting ng-click=payment.backToLanding()>\n                    + <span>{{ \'BUTTON_BUY_MORE\' | translate}}</span>\n                </button>\n            </div>\n\n            <div class=\"box__content box__content--no-padding\">\n                <dk-product-table cart=payment.cart is-customer-company=main.isCustomerCompany is-submitting=payment.isSubmitting ng-if=\"main.country === \'DK\'\">\n                </dk-product-table>\n                <se-product-table cart=payment.cart is-customer-company=main.isCustomerCompany ng-if=\"main.country === \'SE\'\">\n                </se-product-table>\n\n\n                <div ng-show=\"payment.cart.length > 0\">\n                    <cmn-payment-sum cart=payment.cart is-customer-company=main.isCustomerCompany>\n                    </cmn-payment-sum>\n                </div>\n\n                <div class=payment__empty-cart ng-show=\"payment.cart.length === 0\">\n                    <div class=payment__empty-cart__text>{{ \'PAYMENT_EMPTY_CART\' | translate }}</div>\n\n                    <button type=button class=\"btn btn--blue payment__empty-cart__button\" ui-sref=main.landing>\n                        {{ \'PAYMENT_CONTINUE_SHOPPING\' | translate }}\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=visible-xs>\n            <se-sidebar-measurement-limits cart=payment.cart ng-show=\"payment.cart.length > 0\" collapsible=true></se-sidebar-measurement-limits>\n        </div>\n\n        <dk-letter-code-settings cart-id=payment.cart[0].cartId ng-if=\"main.country === \'DK\' && payment.portoCodeImageUploadEnabled && payment.cartHasLetters\">\n        </dk-letter-code-settings>\n\n        <cmn-address-email ng-if=payment.cartHasOnlyLetters invoice-address=payment.invoiceInfo cart=payment.cart>\n        </cmn-address-email>\n\n        <div ng-show=\"payment.cart.length > 0\">\n            <cmn-invoice-address ng-if=!payment.cartHasOnlyLetters invoice-address=payment.invoiceInfo form=payment.form is-customer-company=main.isCustomerCompany>\n            </cmn-invoice-address>\n\n            <payment-method payment-form=payment.form payment-methods=payment.paymentMethods selected-payment-method=payment.selectedPaymentMethod invoice-info=payment.invoiceInfo>\n            </payment-method>\n\n            <cmn-terms agreement=payment.agreement form=payment.form receivercountry=main.country cart=payment.cart>\n            </cmn-terms>\n            <div class=center>\n                <div class=\"error-bubble payment__error\" ng-show=\"payment.form.$submitted && payment.form.agreement.$invalid\">\n                    {{ \'PAYMENT_PAGE_ERROR_MISSING_AGREEMENT_BUBBLE\' | translate }}\n                </div>\n\n                <div class=\"error-bubble payment__error\" ng-show=\"payment.form.$submitted && payment.form.agreement.$valid && payment.form.$invalid\">\n                    {{\'PAYMENT_PAGE_ERROR_FORM\' | translate}}\n                </div>\n\n                <div id=payment-failed-message class=\"error-bubble payment__error\" ng-show=payment.paymentFailed>\n                    {{ payment.errorMessage | translate }}\n                </div>\n            </div>\n\n            <div class=\"center payment__btn\" ng-class=\"{ \'payment__btn--disabled\': payment.initiatingTransaction }\">\n                <div class=apple-pay-container id=apple-pay-container></div>\n                <div class=google-pay-container id=google-pay-container></div>\n            </div>\n\n            <div class=payment__btn ng-hide=\"payment.isPayingWithAppleOrGoogle \">\n                <button type=submit class=\"btn btn--blue btn--block\" ng-disabled=payment.isSubmitting ng-click=\"payment.next(payment.invoiceInfo, payment.selectedPaymentMethod)\" ng-class=\"{\'btn--loading\': payment.isSubmitting}\">\n                    {{ \'PAYMENT_CONTINUE_TO_PAYMENT\' | translate}}\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n");
$templateCache.put("components/payment/payment.html","<div class=page-header>\n    <h1 class=page-header__title>{{ \'PAGE_HEADER_PAYMENT\' | translate}}</h1>\n</div>\n\n<progress-tracker stage=\"\'payment\'\" cart=payment.cart></progress-tracker>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/payment/payment.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/payment/payment.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/payment.sidebar.html","<cmn-sidebar-selected-product heading=\"\'SIDEBAR_OVERVIEW_TITLE\' | translate\" ng-if=\"payment.cart.length === 1\" product=payment.cart[0] selected-weight=payment.cart[0].selectedWeight is-customer-company=main.isCustomerCompany>\n</cmn-sidebar-selected-product>\n\n<cmn-sidebar-overview ng-if=\"payment.cart.length > 1\" cart=payment.cart is-customer-company=main.isCustomerCompany>\n</cmn-sidebar-overview>\n\n<cmn-sidebar-measurement-limits class=hidden-xs cart=payment.cart ng-if=\"payment.cart.length > 1\">\n</cmn-sidebar-measurement-limits>\n\n<dk-climate-compensation ng-show=\"main.country === \'DK\'\" products=payment.cart></dk-climate-compensation>\n");
$templateCache.put("components/payment/termsandconditions.html","<md-dialog aria-label=\"terms conditions\" class=terms_conditions>\n    <md-dialog-content>\n        <div class=\"md-dialog-content terms_conditions__content\">\n            <img src=assets/images/icon-60-parcel@2x.png height=54px width=54px>\n            <h2>{{\'PAYMENT_TERMSANDCONDITIONS_TITLE\' | translate}}</h2>\n            <p> {{\'PAYMENT_TERMSANDCONDITIONS_SUBTEXT\' | translate}}</p>\n        </div>\n\n        <div class=terms_conditions__links>\n            <ul>\n                <li><span>{{\'PAYMENT_TERMSANDCONDITIONS_PRODUCT\' | translate}}</span><span class=right>{{\'PAYMENT_TERMSANDCONDITIONS_TERMS\' | translate}}</span></li>\n                <li ng-repeat=\"parcel in parcelsArray\">\n                    <span>{{parcel.name}}</span>\n\n                    <span class=\"right right__parcel\">\n                        <a href={{parcel.productTerms}} target=_blank>{{parcel.baseProductName}}</a>\n                        <img src=assets/images/icon-16-download@2x.png height=16px width=16px>\n                    </span>\n\n                    <span class=payment__table__title__delivery-option-icon ng-style=\"{\'background-image\': \'url(\' + (parcel.iconUrl | imagePath) + \')\'}\" ng-if=parcel.iconUrl>\n                    </span>\n\n                    <p ng-if=parcel.serviceName>\n                        {{parcel.serviceName}}\n                    </p>\n                </li>\n            </ul>\n        </div>\n\n        <div class=terms_conditions__dismiss>\n            <span ng-click=cancel()>{{\'DISMISS\' | translate}}</span>\n        </div>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("components/receipt/receipt.content.html","<div class=main-content__box>\n    <!-- <div class=\"box\" ng-if=\"main.country === \'DK\'\">\n        <div class=\"box__header\">\n            <div class=\"box__header__title\">\n                    {{ \'RECEIPT_DK_HEADER_TITLE\' | translate}}\n            </div>\n            <button\n                type=\"button\"\n                class=\"btn btn--header\"\n                ng-disabled=\"payment.isSubmitting\"\n                ui-sref=\"main.landing\">\n                + <span>{{ \'BUTTON_BUY_MORE\' | translate}}</span>\n            <button\n                ng-if=\"receipt.loggedIn\"\n                type=\"button\"\n                class=\"btn btn--header\"\n                ng-click=\"receipt.goTo(\'main.user.history\')\">\n                <span class=\"history-btn\">{{ \'RECEIPT_ORDER_HISTORY\' | translate}} </span>\n            </button>    \n        </div>\n        <div class=\"box__content\" ng-bind-html=\"(\'RECEIPT_DK_HEADER_INFO\' | translate:{receiveremail: receipt.senderEmail})\">\n\n        </div>\n    </div> -->\n\n    <se-receipt-instructions ng-if=\"main.country === \'SE\'\" transaction-id=receipt.cart[0].cartId cart=receipt.cart></se-receipt-instructions>\n    <dk-receipt-instructions ng-if=\"main.country === \'DK\'\" transaction-id=receipt.cart[0].cartId cart=receipt.cart></dk-receipt-instructions>\n\n    <div class=box ng-if=receipt.showCustomsBox>\n        <div class=box__header>\n            <div class=box__header__title>\n                {{ \'CUSTOMS_RECEIPT_TITLE\' | translate}}:\n            </div>\n        </div>\n        <div class=\"box__content box__content--receipt-padding\">\n            <div class=receipt__sections>\n                <div>\n                    <img src=assets/images/graphics-instructions-customs-declaration@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'CUSTOMS_RECEIPT_INFO_TITLE\' | translate}}</span>\n                        <span class=head-text-info>{{ \'CUSTOMS_RECEIPT_INFO\' | translate}} <a href=http://www.postnord.se/foretag/skicka/utrikes/tullinformation/frakthandlingar-och-tulldokument target=_blank>{{ \'SIDEBAR_FAQ_READ_MORE\' | translate}}</a></span>\n                    </span>\n                </div>\n                <div class=receipt__customs>\n                    <div class=receipt__customs__url ng-repeat=\"customsLabel in receipt.customsLabels\">\n                        <a href={{customsLabel.url}} target=_blank>{{customsLabel.name}}</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <sidebar-dropoff-map ng-if=main.isSmallScreen></sidebar-dropoff-map>\n    <div class=box>\n        <div class=\"box__content box__content--no-padding\">\n            <se-product-table ng-if=\"main.country === \'SE\'\" cart=receipt.cart is-customer-company=main.isCustomerCompany is-receipt=true>\n            </se-product-table>\n            <dk-product-table ng-if=\"main.country === \'DK\'\" cart=receipt.cart is-customer-company=main.isCustomerCompany is-receipt=true>\n            </dk-product-table>\n\n            <cmn-receipt-sum country=main.country cart=receipt.cart is-customer-company=main.isCustomerCompany>\n            </cmn-receipt-sum>\n\n            <div class=\"padding center\">\n                <div>{{ \'RECEIPT_ORDER_NUMBER\' | translate}}: <strong>{{receipt.cart[0].cartId}}</strong></div>\n                <div>{{ \'RECEIPT_ORDER_CONFIRM\' | translate}} <strong>{{receipt.cart[0].senderEmail || receipt.senderEmail}}</strong></div>\n            </div>\n        </div>\n    </div>\n    <div class=receipt__btns>\n        <button class=\"btn btn--blue\" id=btn-buy-more ng-click=\"receipt.goTo(\'main.landing\')\">{{ \'BUTTON_BUY_MORE\' | translate}}</button>\n        <button class=\"btn btn--not-filled\" id=btn-print-receipt ng-click=receipt.printReceipt()>{{ \'RECEIPT_BUTTON_PRINT\' | translate}}</button>\n        <button ng-if=receipt.loggedIn type=button class=\"btn btn--not-filled\" ng-click=\"receipt.goTo(\'main.user.history\')\">\n            {{ \'RECEIPT_ORDER_HISTORY\' | translate}}\n        </button>\n    </div>\n</div>\n\n<iframe id=printFrame width=0 height=0 frameborder=0></iframe>\n");
$templateCache.put("components/receipt/receipt.html","<return-to-digital-agent-banner ng-if=receipt.hasDigitalAgent></return-to-digital-agent-banner>\n<div class=page-header ng-class=\"{\'extra-top-margin\': receipt.hasDigitalAgent}\">\n    <h1 class=page-header__title>{{ \'PAGE_HEADER_PRINT\' | translate}}</h1>\n    <p>{{ \'RECEIPT_ORDER_CONFIRM\'| translate}} <strong>{{receipt.cart[0].senderEmail || receipt.senderEmail}}</strong></p>\n</div>\n\n<progress-tracker stage=\"\'receipt\'\" has-printed-shippinglabel=main.hasPrintedShippinglabel></progress-tracker>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div ng-include=\"\'components/receipt/receipt.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/receipt/receipt.sidebar.html\'\" class=sidebar ng-if=receipt.sender.address.zipCode></div>\n    </div>\n</div>\n");
$templateCache.put("components/receipt/receipt.sidebar.html","<div ng-if=!main.isSmallScreen>\n    <cmn-sidebar-dropoff-map></cmn-sidebar-dropoff-map>\n</div>\n");
$templateCache.put("components/signup/signup.html","<div class=signup>\n    <div class=signup__top>\n        <img class=container src=assets/images/graphics-create-account@3x.png>\n    </div>\n    <div class=signup__content>\n        <h1>{{\'SIGNUP_PAGE_HEADER\' | translate}}</h1>\n        <p class=signup__content__description>\n            {{\'SIGNUP_PAGE_DESCRIPTION\' | translate}}\n        </p>\n        <button class=\"btn btn--block btn--blue\" ng-click=signup.login()>\n            {{\'SIGNUP_PAGE_CREATE_ACCOUNT_BUTTON_TEXT\' | translate}}\n        </button>\n        <div class=signup__content__login>\n            {{\'SIGNUP_PAGE_ALREADY_CUSTOMER_TEXT\' | translate}}\n            <a class=signup__content__login__link ng-click=signup.login()>\n                {{\'SIGNUP_PAGE_LOGIN_TEXT\' | translate}}\n            </a>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/banners/closed-banner/closed-banner.directive.html","<div class=\"banner banner--blue closed-banner\">\n\n  <div class=banner__title>{{\'CLOSED_BANNER_TITLE\' | translate}}</div>\n\n  <div class=\"banner__content closed-banner__content\">\n      <div class=banner__content__text>{{\'CLOSED_BANNER_TEXT\' | translate}}</div>\n  </div>\n</div>");
$templateCache.put("components/banners/danish/danish.directive.html","<div class=\"banner banner--blue danish-banner\">\n    <div class=banner__close ng-click=close()></div>\n\n    <div class=banner__title>Do you want to send parcels from Denmark?</div>\n\n    <div class=\"banner__content danish-banner__content\">\n        <div class=banner__content__text>\n            This is a service where you can only send shipments from <strong>Sweden</strong> to the rest of the world. If you would like to send shipments from Denmark use the services below:\n        </div>\n\n        <div class=danish-banner__links>\n            <a href=http://www.postnord.dk/erhverv/kob-og-bestil/kob-pakkeporto-online target=_blank class=danish-banner__link>\n                <span class=danish-banner__link__label>Pakkelabels</span>\n                <span class=danish-banner__link__description>Buy shipping for packages</span>\n            </a>\n\n            <a href=http://www.postnord.dk/erhverv/kob-og-bestil/kob-online-brevporto target=_blank class=danish-banner__link>\n                <span class=danish-banner__link__label>Online Brevporto</span>\n                <span class=danish-banner__link__description>Buy digital stamps</span>\n            </a>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/banners/digital-stamps/digital-stamps.directive.html","<div class=\"banner banner--blue digital-stamps-banner\">\n    <div class=banner__close ng-click=close()></div>\n\n    <div class=banner__title>{{\'BANNER_DIGITAL_STAMPS_TITLE\' | translate}}</div>\n\n    <div class=\"banner__content digital-stamps-banner__content\">\n        <div class=banner__content__text>{{\'BANNER_DIGITAL_STAMPS_TEXT\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/banners/dk-banner/dk-banner.directive.html","<div class=\"banner banner--blue vat-banner\">\n\n  <div class=banner__title>{{\'LANDING_DK_QUICKBREV_BANNER_HEADING\' | translate}}</div>\n\n  <div class=\"banner__content vat-banner__content\">\n      <div class=banner__content__text>{{\'LANDING_DK_QUICKBREV_BANNER_DESCRIPTION\' | translate}}</div>\n  </div>\n</div>");
$templateCache.put("components/banners/logged-in-mode/logged-in-mode.directive.html","<div class=\"banner banner--blue logged-in-mode-banner\">\n    <div class=banner__close ng-click=close()></div>\n\n    <div class=banner__title>{{\'BANNER_LOGGED_IN_MODE_TITLE\' | translate}}</div>\n\n    <div class=\"banner__content logged-in-mode-banner__content\">\n        <div class=banner__content__text>{{\'BANNER_LOGGED_IN_MODE_TEXT\' | translate}}</div>\n        <a ng-click=goToLogin() class=banner__content__link>{{\'BANNER_LOGGED_IN_MODE_LINK\' | translate}}</a>\n    </div>\n</div>\n");
$templateCache.put("components/banners/premium-sign-up/premium-sign-up.directive.html","<div class=\"banner banner--blue premium-sign-up-banner\">\n    <div class=banner__close ng-click=close()></div>\n\n    <div class=banner__title>{{\'BANNER_PREMIUM_SIGN_UP_TITLE\' | translate}}</div>\n\n    <div class=\"banner__content premium-sign-up-banner__content\">\n        <div class=banner__content__text>{{\'BANNER_PREMIUM_SIGN_UP_TEXT\' | translate}}</div>\n        <a href=\"{{\'BANNER_PREMIUM_SIGN_UP_URL\' | translate}}\" target=_blank class=banner__content__link>{{\'BANNER_PREMIUM_SIGN_UP_LINK\' | translate}}</a>\n    </div>\n</div>\n");
$templateCache.put("components/banners/print-at-servicepoint/print-at-servicepoint.directive.html","<div class=\"banner banner--blue print-at-servicepoint-banner\" ng-if=qrCodeEnabled>\n    <div class=banner__close ng-click=close()></div>\n\n    <div class=banner__title>{{\'BANNER_PRINT_AT_SERVICEPOINT_TITLE\' | translate}}</div>\n\n    <div class=\"banner__content print-at-servicepoint-banner__content\">\n        <div class=banner__content__text>{{\'BANNER_PRINT_AT_SERVICEPOINT_TEXT\' | translate}}</div>\n    </div>\n</div>");
$templateCache.put("components/banners/return-to-digital-agent/return-to-digital-agent.directive.html","<div class=\"banner banner--blue return-to-digital-agent-banner\">\n    <span class=container>\n        <img src={{iconUrl}}> \n        <div class=banner__content__text ng-bind-html=\"(\'BANNER_RETURN_TO_DIGITAL_AGENT_TEXT\' | translate:{name: digitalAgentName, returnUrl: returnUrl})\"></div>\n    </span>\n</div>");
$templateCache.put("components/banners/skicka-hem/skicka-hem.directive.html","<div class=\"banner banner--blue skicka-hem-banner\">\n  <div class=banner__close ng-click=close()></div>\n\n  <div class=banner__title>{{\'BANNER_SKICKA_HEM_TITLE\' | translate}}</div>\n\n  <div class=\"banner__content skicka-hem-banner__content\">\n      <div class=banner__content__text>{{\'BANNER_SKICKA_HEM_TEXT\' | translate}}</div>\n  </div>\n</div>");
$templateCache.put("components/customs/customs-documents/customs-documents.directive.html","\n<div class=\"box box--last\">\n    <div class=\"box__header customs-background\">\n        <div class=box__header__title>\n            {{ \'CUSTOMS_PAGE_YOUR_DECLARATION_TITLE\' | translate}}\n        </div>\n    </div>\n    <div class=customs-error ng-if=\"ctrl.cn22error === true\">{{ \'CUSTOMS_ONLY_FIVE_ITEMS_ALLOWED_DOCUMENTS\' | translate}}</div>\n    <div class=\"box__content box__content--no-padding\">\n        <table class=customs-table>\n            <tr class=customs-table__header>\n                <th></th>\n                <th>{{ \'CUSTOMS_TABLE_QUANTITY\' | translate}}</th>\n                <th>{{ \'CUSTOMS_TABLE_CONTENT\' | translate}}</th>\n                <th>{{ \'CUSTOMS_TABLE_VALUE\' | translate}}</th>\n                <th>{{ \'CUSTOMS_TABLE_COUNTRY\' | translate}}</th>\n                <th>{{ \'CUSTOMS_TABLE_HSTARIFF\' | translate}}</th>\n                <th></th>\n                <th></th>\n            </tr>\n            <tbody class=customs-table__body>\n\n                <tr ng-repeat=\"document in ctrl.documents.items track by $index\">\n                    <td></td>\n                    <td>{{document.quantity}}</td>\n                    <td>{{document.description}}</td>\n                    <td>{{document.customsValue}} {{document.currency}}</td>\n                    <td>{{document.countryOfOrigin.name}}</td>\n                    <td>{{document.hsTariffNumber}}</td>\n                    <td class=buttons>\n                        <button type=button class=\"product-table__action product-table__action--edit-custom\" ng-click=\"ctrl.editCustomsDocument(document, $index, $event)\">\n                        </button>\n                        <button type=button class=\"product-table__action product-table__action--remove-custom\" ng-click=\"ctrl.removeCustomsDocument(document, $index)\">\n                        </button>\n\n                    </td>\n                    <td></td>\n                </tr>\n            </tbody>\n        </table>\n\n        <ul ng-repeat=\"document in ctrl.documents.items track by $index\">\n            <li>\n                <h5>{{\'CUSTOMS_TABLE_QUANTITY\' | translate}}</h5>\n                <p>{{document.quantity}}</p>\n\n                <div>\n                    <button type=button class=\"product-table__action product-table__action--edit-custom\" ng-click=\"ctrl.editCustomsDocument(document, $index, $event)\">\n                    </button>\n                    <button type=button class=\"product-table__action product-table__action--remove-custom\" ng-click=\"ctrl.removeCustomsDocument(document, $index)\">\n                    </button>\n                </div>\n            </li>\n            <li>\n                <h5>{{\'CUSTOMS_TABLE_CONTENT\' | translate}}</h5>\n                <p>{{document.description}}</p>\n            </li>\n            <li>\n                <h5>{{\'CUSTOMS_TABLE_VALUE\' | translate}}</h5>\n                <p>{{document.customsValue}} {{document.currency}}</p>\n            </li>\n            <li>\n                <h5>{{\'CUSTOMS_TABLE_COUNTRY\' | translate}}</h5>\n                <p>{{document.countryOfOrigin.name}}</p>\n            </li>\n            <li ng-if=document.hsTariffNumber>\n                <h5>{{\'CUSTOMS_TABLE_HSTARIFF\' | translate}}</h5>\n                <p>{{document.hsTariffNumber}}</p>\n            </li>\n        </ul>\n\n        <div class=customs-no-items ng-if=\"!ctrl.documents || ctrl.documents.items.length === 0\">{{ \'CUSTOMS_NO_DOCUMENT\' | translate}}</div>\n        <div class=\"payment__agreement no-border\">\n                <input id=customsAgree name=customsAgree ng-model=ctrl.agreement type=checkbox>\n                <label class=\"payment__agreement__checkbox-label payment__agreement__checkbox-label--auto-align\" for=customsAgree></label>\n\n                <div class=customs__agreement__label>\n                    <label for=customsAgree ng-bind-html=\"\'CUSTOMS_AGREEMENT\' | translate \"></label>\n                </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/customs-new/remove-document-dialog/remove-document-dialog.html","<md-dialog aria-label=\"Confirm Delete\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3>{{ \'CUSTOMS_REMOVE_DOCUMENT_DIALOG_HEADER\' | translate}}</h3>\n            <p>{{ \'CUSTOMS_REMOVE_DOCUMENT_DIALOG_TEXT\' | translate}}</p>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=row>\n        <md-button class=md-confirm-button ng-click=confirm()>\n            {{ \'CUSTOMS_REMOVE_DOCUMENT_DIALOG_CONFIRM\' | translate}}\n        </md-button>\n        <md-button class=md-cancel-button ng-click=cancel()>\n            {{ \'CUSTOMS_REMOVE_DOCUMENT_DIALOG_CANCEL\' | translate}}\n        </md-button>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/layout/feedback-button/feedback-button.html","<a class=feedback-button ng-click=vm.openModal()>{{\'FEEDBACK_BUTTON_TEXT\' | translate}}</a>\n");
$templateCache.put("components/layout/navigation-menu/navigation-menu.directive.html","<div class=\"visible-xs mobile-navigation-menu\" ng-class=\"{\'mobile-navigation-menu--expanded\' : navigationMenu.navigationMenuExpanded}\">\n    <div class=mobile-navigation-menu__item--selected ng-click=navigationMenu.toggleNavigationMenu()>\n            <div class=\"mobile-navigation-menu__item mobile-navigation-menu__item--active\">\n                <div class=\"mobile-navigation-menu__item__icon {{navigationMenu.selectedMenuItem.class}}\"></div>\n                <span class=mobile-navigation-menu__item__name>\n                    {{navigationMenu.selectedMenuItem.name | translate}}\n                </span>\n                <pn-icon class=mobile-navigation-menu__item__expand-button ng-attr-symbol=\"{{navigationMenu.navigationMenuExpanded ? \'angle-small-up\' : \'angle-small-down\'}}\" color=blue700 size=small solid>\n            </pn-icon>\n            </div>\n    </div>\n\n    <div ng-if=navigationMenu.navigationMenuExpanded class=mobile-navigation-menu__items>\n        <li ng-repeat=\"item in navigationMenu.menuItems\" class=mobile-navigation-menu__item ng-class=\"[{\'mobile-navigation-menu__item--active\': $state.current.name === item.state}]\" ng-click=navigationMenu.goToIfLoggedIn(item)>\n            <div class=\"mobile-navigation-menu__item__icon {{item.class}}\"></div>\n            <span class=mobile-navigation-menu__item__name>\n                {{item.name | translate}}\n            </span>\n        </li>\n    </div>\n</div>\n\n<div class=\"navigation-menu hidden-xs\">\n    <li ng-repeat=\"item in navigationMenu.menuItems\" class=\"navigation-menu__item {{item.class}}\" ng-class=\"[{\'active\': navigationMenu.currentState() === item.state}]\" ng-click=navigationMenu.goToIfLoggedIn(item)>\n        <span uib-popover=\"{{\'SIGNUP_MENU_TOOLTIP\' | translate }}\" popover-enable={{navigationMenu.signupPopupEnabled(item)}} popover-trigger=\"\'mouseenter\'\" popover-placement=bottom popover-class=popover-light>\n            {{item.name | translate}}\n        </span>\n    </li>\n</div>\n     ");
$templateCache.put("components/layout/progress-tracker/progress-tracker.directive.html","<div class=progress-tracker>\n    <div class=progress-tracker__bar>\n        <div class=menu-item-container>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--parcel\" ng-class=\"{\'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'landing\'), \'progress-tracker__bar__stage--parcel--active\': progressTracker.isCurrentStage(\'landing\')}\">\n            </div>\n            <div class=progress-tracker__bar__text ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'landing\')}\">{{ \'PROGRESSBAR_LANDING\' | translate}}</div>\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--done\': progressTracker.isPreviousStage(\'landing\'), \'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'landing\')}\"></div>\n        </div>\n\n\n        <div class=menu-item-container ng-hide=\"progressTracker.parcel.type === \'letter\' && progressTracker.cartHasOnlyLetters\">\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--address\" ng-class=\"{\n                    \'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'address\') || (progressTracker.isCurrentStage(\'landing\') && progressTracker.editingFromState === \'main.payment\'),\n                    \'progress-tracker__bar__stage--address--active\': progressTracker.isCurrentStage(\'address\')\n                }\">\n            </div>\n            <div class=progress-tracker__bar__text ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'address\')}\">{{ \'PROGRESSBAR_ADDRESS\' | translate}}</div>\n\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--done\': progressTracker.isPreviousStage(\'address\'), \'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'address\')}\"></div>\n        </div>\n\n\n        <div class=menu-item-container ng-if=progressTracker.showCustomsDeclarationsStep>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--customs\" ng-class=\"{\n                    \'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'customs\') || (progressTracker.isCurrentStage(\'landing\') && progressTracker.editingFromState === \'main.payment\'),\n                    \'progress-tracker__bar__stage--customs--active\': progressTracker.isCurrentStage(\'customs\')\n                }\">\n            </div>\n            <div class=progress-tracker__bar__text ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'customs\')}\">{{ \'PROGRESSBAR_CUSTOMS\' | translate}}</div>\n\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--done\': progressTracker.isPreviousStage(\'customs\'), \'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'customs\')}\"></div>\n        </div>\n\n\n        <div class=menu-item-container>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--payment\" ng-class=\"{\n                    \'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'payment\'),\n                    \'progress-tracker__bar__stage--in-progress\': progressTracker.editingFromState === \'main.payment\',\n                    \'progress-tracker__bar__stage--payment--active\': progressTracker.isCurrentStage(\'payment\')\n                }\">\n            </div>\n            <div class=progress-tracker__bar__text ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'payment\')}\">{{ \'PROGRESSBAR_PAYMENT\' | translate}}</div>\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--done\': progressTracker.isPreviousStage(\'payment\'), \'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'payment\')}\"></div>\n        </div>\n\n\n        <div class=menu-item-container>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--print\" ng-if=\"progressTracker.country === \'SE\'\" ng-class=\"{\n                    \'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'receipt\') || progressTracker.hasPrintedShippinglabel,\n                    \'progress-tracker__bar__stage--print--active\': progressTracker.isCurrentStage(\'receipt\')\n                }\">\n            </div>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--label\" ng-if=\"progressTracker.country === \'DK\'\" ng-class=\"{\n                    \'progress-tracker__bar__stage--done\': progressTracker.isPreviousStage(\'receipt\') || progressTracker.hasPrintedShippinglabel,\n                    \'progress-tracker__bar__stage--label--active\': progressTracker.isCurrentStage(\'receipt\')\n                }\">\n            </div>\n            <div class=progress-tracker__bar__text ng-if=\"progressTracker.country === \'DK\'\" ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'receipt\')}\">{{ \'PROGRESSBAR_RECEIPT_DK\' | translate}}</div>\n            <div class=progress-tracker__bar__text ng-if=\"progressTracker.country === \'SE\'\" ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'receipt\')}\">{{ \'PROGRESSBAR_RECEIPT\' | translate}}</div>\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--done\': progressTracker.isPreviousStage(\'payment\'), \'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'receipt\')}\"></div>\n        </div>\n\n        \n        <div class=menu-item-container>\n            <div class=\"progress-tracker__bar__stage progress-tracker__bar__stage--p\" ng-class=\"{\'progress-tracker__bar__stage--p--active\': progressTracker.isCurrentStage(\'receipt\')}\">\n            </div>\n            <div class=progress-tracker__bar__text ng-class=\"{\'progress-tracker__bar__text--active\': progressTracker.isCurrentStage(\'receipt\')}\">{{ \'PROGRESSBAR_DROPOFF\' | translate}}</div>\n            <div class=progress-tracker__bar__divider ng-class=\"{\'progress-tracker__bar__divider--active\': progressTracker.isCurrentStage(\'receipt\')}\"></div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/layout/siteheader/siteheader.directive.html","<div>\n    <pn-marketweb-siteheader class=site-header endpoint={{siteHeader.endpoint}} environment={{siteHeader.environment}} spa-mode=true market={{siteHeader.market}} language={{siteHeader.language}} site-domain-in-urls=true hide-site-selector=\"{{siteHeader.market === \'dk\'}}\" hide-search=\"{{siteHeader.market === \'se\'}}\" show-unified-login=true>\n      <a href=\"\" slot=toprightend class=\"header-cart hidden-xs\" ng-click=siteHeader.cartClick() ng-if=\"siteHeader.market !== \'dk\'\" ng-show=siteHeader.loaded>\n        <span ng-attr-data-cart-countindicator1={{siteHeader.cart.length}}></span>\n        <span>{{ \'PAYMENT_YOUR_CART\' | translate }}</span>\n        <pn-icon symbol=shop color=blue700 class=pn-icon></pn-icon>\n      </a>\n    </pn-marketweb-siteheader>\n</div>\n");
$templateCache.put("components/receipt/dk/dk-receipt-codes.directive.html","<div class=dk-receipt-codes>\n    <ul class=dk-receipt-codes__list>\n        <li class=dk-receipt-codes__list__item ng-repeat=\"item in ctrl.codes | limitTo: 3\">\n            <div class=dk-receipt-codes__list__item__name>{{item.name}}</div>\n            <div class=dk-receipt-codes__list__item__code ng-class=\"{\'--quickCode\': item.quickletter === true}\">{{item.portoCode | portocode}}</div>\n            <div class=dk-receipt-codes__list__item__code__service ng-if=\"item.toCountry.countryCode !== \'DK\'\">{{ \'INTERNATIONAL\' | translate}}</div>\n            <div class=dk-receipt-codes__list__item__code__service>{{ item.service.shortName }}</div>\n            <div class=dk-receipt-codes__list__item__code__quick ng-if=\"item.toCountry.countryCode !== \'DK\'\">{{\'DK_RECEIPT_PRINT_PRIORITY_TEXT\' | translate}}</div>\n            <div class=dk-receipt-codes__list__item__code__quick ng-if=\"item.quickletter === true\">{{\'DK_RECEIPT_PRINT_QUICK_TEXT\' | translate}}</div>\n        </li>\n        <li class=dk-receipt-codes__list__item ng-repeat=\"item in ctrl.codes\" ng-if=\"hide && $index >= 3\">\n            <div class=dk-receipt-codes__list__item__name>{{item.name}}</div>\n            <div class=dk-receipt-codes__list__item__code>{{item.portoCode | portocode}}</div>\n            <div class=dk-receipt-codes__list__item__code__service ng-if=\"item.toCountry.countryCode !== \'DK\'\">{{ \'INTERNATIONAL\' | translate}}</div>\n            <div class=dk-receipt-codes__list__item__code__service>{{ item.service.shortName }}</div>\n            <div class=dk-receipt-codes__list__item__code__quick ng-if=\"item.toCountry.countryCode !== \'DK\'\">{{\'DK_RECEIPT_PRINT_PRIORITY_TEXT\' | translate}}</div>\n            <div class=dk-receipt-codes__list__item__code__quick ng-if=\"item.quickletter === true\">{{\'DK_RECEIPT_PRINT_QUICK_TEXT\' | translate}}</div>\n         </li>\n    </ul>\n    <div class=dk-receipt-codes__more ng-click=\"hide = !hide\" ng-show=\"ctrl.codes.length > 3\">\n        <span class=dk-receipt-codes__more__caret ng-if=!hide>{{\'DK_SHOW_ALL_CODES\' | translate}}</span>\n        <span class=\"dk-receipt-codes__more__caret dk-receipt-codes__more__caret--rotate\" ng-if=hide>{{\'DK_HIDE_CODES\' | translate}}</span>\n    </div>\n</div>\n\n<div class=dk-receipt-codes-printing-instructions>\n    <h3 class=receipt__sections__section__subtitle>{{\'DK_RECEIPT_PRINT_CODES_TITLE\' | translate}}</h3>\n    <ol>\n        <li>{{\'DK_RECEIPT_PRINT_CODES_INSTRUCTIONS_1\' | translate}}</li>\n        <li>{{\'DK_RECEIPT_PRINT_CODES_INSTRUCTIONS_2\' | translate}}</li>\n        <li>{{\'DK_RECEIPT_PRINT_CODES_INSTRUCTIONS_3\' | translate}}</li>\n    </ol>\n\n    <div class=dk-receipt-codes-printing-instructions__labels>\n        <h4 class=dk-receipt-codes-printing-instructions__labels__title ng-bind-html=\"\'DK_RECEIPT_PRINT_CODES_LABEL_TITLE\' | translate\"></h4>\n        <ul>\n            <li>{{\'DK_RECEIPT_PRINT_CODES_LABEL_TYPES_1\' | translate}}</li>\n            <li>{{\'DK_RECEIPT_PRINT_CODES_LABEL_TYPES_2\' | translate}}</li>\n        </ul>\n        <p>{{\'DK_RECEIPT_PRINT_CODES_LABEL_TEXT\' | translate}}</p>\n    </div>\n</div>\n\n<button class=\"btn btn--blue\" ng-click=ctrl.printPortoCodes();>{{\'DK_PRINT_CODES\' | translate}}</button>\n");
$templateCache.put("components/receipt/dk/dk-receipt-instructions.directive.html","<div class=\"box receipt-dk\">\n        <div class=box__header>\n            <div class=box__header__title ng-if=\"ctrl.tabs.length > 1\">\n               {{ \'DK_RECEIPT_HEADER_TITLE\' | translate}}\n            </div>\n        </div>\n        <div class=box__header__tabs ng-if=\"ctrl.tabs.length > 1\">\n            <span class=box__header__tabs__tab ng-repeat=\"tab in ctrl.tabs\" ng-click=ctrl.setActiveTab(tab.name) ng-class=\"{\'box__header__tabs__tab--active\': ctrl.activeTab === tab.name}\">{{ tab.title}}</span>\n        </div>\n        <div class=box__content>\n            <div class=receipt__sections>\n                <div ng-show=\"[\'package\', \'valuables\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-print-pakkeboks-merged@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_LABELS\' | translate}}</span>\n                        <div class=mobile-reverse-container>\n                            <span class=head-text-info>{{ \'DK_RECEIPT_PRINT_LABELS_INFO\' | translate}}</span>\n                            <qrcode ng-if=ctrl.qrCodeEnabled data={{ctrl.qrData}} size=200 error-correction-level=H></qrcode>\n                            <div class=\"button-span mobile-reverse-container\">\n                                <button class=\"btn btn--blue\" id=btn-print-labels ng-click=main.setPrintedShippinglabel();ctrl.printWaybill()>{{ \'RECEIPT_PRINT_LABELS\' | translate }}</button>\n                                <span ng-show=ctrl.qrCodeEnabled>\n                                    <div id=googlePay></div>  \n                                    <a href={{ctrl.walletUrl}} download><img ng-src=\"{{\'WALLET_IMG_URL\' | translate}}\"></a>\n                                </span>\n                            </div>\n                        </div>\n                    </span>\n                </div>\n                <div ng-if=\"[\'letterGoodsOutsideEu\', \'shipmentsOutsideEu\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-print@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_SHIPMENTOUTSIDEEU_PRINT_LABELS\' | translate}}</span>\n                        <span class=head-text-info>{{ \'DK_RECEIPT_SHIPMENTOUTSIDEEU_PRINT_LABELS_INFO\' | translate}}</span>\n                        <div class=button-span>\n                            <button class=\"btn btn--blue\" ng-click=main.setPrintedShippinglabel();ctrl.printWaybill()>{{ \'RECEIPT_SHIPMENTOUTSIDEEU_PRINT_DOCUMENTS\' | translate}}</button>\n                        </div>\n                    </span>\n                </div>\n                <div ng-if=\"[\'untrackedInternationalLetter\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-print@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_SHIPMENTINSIDEEU_PRINT_LABELS\' | translate}}</span>\n                        <span class=head-text-info>{{ \'DK_RECEIPT_SHIPMENTINSIDEEU_PRINT_LABELS_INFO\' | translate}}</span>\n                        <div class=button-span>\n                            <button class=\"btn btn--blue\" ng-click=main.setPrintedShippinglabel();ctrl.printWaybill()>{{ \'RECEIPT_SHIPMENTOUTSIDEEU_PRINT_DOCUMENTS\' | translate}}</button>\n                        </div>\n                    </span>\n                </div>\n                <div ng-if=\"ctrl.activeTab === \'rekommanderet\'\">\n                    <img src=assets/images/graphics-instructions-print@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_LABELS_REKOMMANDERET\' | translate}}</span>\n                        <span class=head-text-info>{{ \'DK_RECEIPT_PRINT_LABELS_INFO_REKOMMANDERET\' | translate}}</span>\n                        <div class=button-span>\n                            <button class=\"btn btn--blue\" ng-click=main.setPrintedShippinglabel();ctrl.printWaybill()>{{ \'RECEIPT_PRINT_LABELS\' | translate}}</button>\n                        </div>\n                    </span>\n                </div>\n                <div ng-if=\"[\'letterGoodsOutsideEu\', \'package\', \'rekommanderet\', \'valuables\', \'untrackedInternationalLetter\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-attach@2x.png ng-if=\"[\'package\', \'valuables\', \'untrackedInternationalLetter\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-attach-letter@2x.png ng-if=\"ctrl.activeTab === \'rekommanderet\'\">\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_INSTRUCTION\' | translate}}</span>\n                        <span class=head-text-info> {{ \'DK_RECEIPT_PRINT_INSTRUCTION_INFO\' | translate}}</span>\n                    </span>\n                </div>\n                <div ng-if=\"[\'shipmentsOutsideEu\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-attach@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_SHIPMENTOUTSIDEEU_PRINT_INSTRUCTION\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_SHIPMENTOUTSIDEEU_PRINT_INSTRUCTION_INFO\' | translate\"></span>\n                    </span>\n                </div>\n                <div ng-if=\"[\'valuables\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_VALUABLES\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_VALUABLES_INFO\' | translate\"></span>\n                    </span>\n                    <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n                </div>\n                <div ng-if=\"[\'package\'].indexOf(ctrl.activeTab) !== -1 && !ctrl.hasPickUp\">\n                    <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n                    <span>\n                        <span class=head-text ng-if=!ctrl.description.title>{{ \'DK_RECEIPT_PRINT_DROPOFF\' | translate}}</span>\n                        <span class=head-text ng-if=ctrl.description.title>{{ctrl.description.title}}</span>\n                        <span class=head-text-info ng-if=!ctrl.description.title ng-bind-html=\"\'DK_RECEIPT_PRINT_DROPOFF_INFO\' | translate\"></span>\n                    </span>\n                    <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n                </div>\n                <div ng-if=\"[\'rekommanderet\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_REK_DROPOFF\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_REK_DROPOFF_INFO\' | translate\"></span>\n                    </span>\n                    <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n                </div>\n                <div ng-if=\"[\'letterGoodsOutsideEu\', \'untrackedInternationalLetter\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_UNTRACKED_LETTER_DROPOFF\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_UNTRACKED_LETTER_DROPOFF_INFO\' | translate\"></span>\n                    </span>\n                    <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n                </div>\n                <div ng-if=\"[\'shipmentsOutsideEu\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_SHIPMENTOUTSIDEEU_DROPOFF\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_SHIPMENTOUTSIDEEU_DROPOFF_INFO\' | translate\"></span>\n                    </span>\n                    <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n                </div>\n                <div ng-if=\"[\'package\'].indexOf(ctrl.activeTab) !== -1 && ctrl.hasPickUp\">\n                    <img src=assets/images/graphics-instructions-pickup@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_PICKUP\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_PICKUP_INFO\' | translate\"></span>\n                    </span>\n                </div>\n\n                <!-- Step 4 -->\n                <div ng-if=\"[\'package\', \'valuables\'].indexOf(ctrl.activeTab) !== -1\">\n                    <img src=assets/images/graphics-instructions-track@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_TRACK\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_TRACK_INFO\' | translate\"></span>\n                    </span>\n                </div>\n                <div ng-if=\"ctrl.activeTab === \'shipmentsOutsideEu\'\">\n                    <img src=assets/images/graphics-instructions-track@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_SHIPMENTOUTSIDEEU_TRACK\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_SHIPMENTOUTSIDEEU_TRACK_INFO\' | translate\"></span>\n                    </span>\n                </div>\n                <div ng-if=\"ctrl.activeTab === \'rekommanderet\'\">\n                    <img src=assets/images/graphics-instructions-track-letter@2x.png>\n                    <span>\n                        <span class=head-text>{{ \'DK_RECEIPT_PRINT_REK_TRACK\' | translate}}</span>\n                        <span class=head-text-info ng-bind-html=\"\'DK_RECEIPT_PRINT_REK_TRACK_INFO\' | translate\"></span>\n                    </span>\n                </div>\n                <!-- letters -->\n                <ol>\n                    <li class=receipt__sections__section ng-if=\"ctrl.activeTab === \'letter\'\">\n                        <div>\n                            <span class=receipt__sections__section__header>\n                                <h2 class=head-text>{{ \'DK_RECEIPT_LETTER_CODES_TITLE\' | translate}}</h2>\n                                <h3 class=receipt__sections__section__subtitle>{{ \'DK_RECEIPT_WRITE_CODES_TITLE\' | translate}}</h3>\n                                <span class=head-text-info>{{ \'DK_RECEIPT_WRITE_CODES_DESCRIPTION\' | translate}}\n                                    <span class=head-text-info__quick ng-if=ctrl.hasInternationalReceiver ng-bind-html=\"\'DK_RECEIPT_PRINT_PRIORITY_INSTRUCTION_POST\' | translate\"></span>\n                                </span>\n                            </span>\n                            <img src=assets/images/graphics-instructions-letter@2x.png>\n                        </div>\n                        <div class=dk-receipt-codes-container>\n                            <dk-receipt-codes cart=ctrl.cart></dk-receipt-codes>\n                        </div>\n                    </li>\n                    <li class=receipt__sections__section ng-if=\"ctrl.activeTab === \'letter\'\">\n                        <div>\n                            <span class=receipt__sections__section__header>\n                                <h2 class=head-text>{{ \'DK_RECEIPT_PRINT_POST\' | translate}}</h2>\n                                <span class=head-text-info>{{\'DK_RECEIPT_PRINT_POST_INFO\' | translate}}\n                                    <span class=head-text-info__quick ng-if=ctrl.hasQuickletter ng-bind-html=\"\'DK_RECEIPT_PRINT_QUICK_INSTRUCTION_POST\' | translate\"></span>\n                                </span>\n                            </span>\n                            <img src=assets/images/graphics-instructions-postbox@2x.png>\n                        </div>\n                    </li>\n                </ol>\n            </div>\n        </div>\n    </div>\n");
$templateCache.put("components/receipt/se/receipt-instructions.directive.html","\n\n\n<div ng-if=\"ctrl.nationalLetters.length || ctrl.internationalLetters.length\" class=box>\n    <div class=toggle-box ng-class=\"{ \'toggle-box--toggled\' : ctrl.digitalStampsToggled }\" ng-click=\"ctrl.digitalStampsToggled = !ctrl.digitalStampsToggled\">\n        <div class=toggle-box__section>\n            <img class=toggle-box__image src=assets/images/graphics-letter-digital-stamp@2x.png>\n            <strong class=toggle-box__title>{{ \'DIGITAL_STAMPS_RECEIPT_TITLE\' | translate }}</strong>\n            <span class=toggle-box__count>x{{ ctrl.nationalLetters.length + ctrl.internationalLetters.length }}</span>\n        </div>\n\n        <div class=toggle-box__section>\n            <button class=toggle-box__toggle ng-class=\"{ \'toggle-box__toggle--up\' : ctrl.digitalStampsToggled, \'toggle-box__toggle---down\' : !ctrl.digitalStampsToggled }\">\n                <span class=toggle-box__toggle__text>{{ \'RECEIPT_TOGGLE_ACTION_DIGITAL_STAMPS\' | translate }}</span>\n            </button>\n        </div>\n    </div>\n    <div ng-show=ctrl.digitalStampsToggled class=\"instructions instructions--digital-stamps\">\n        <div class=instructions__section>\n            <div class=instructions__section__content>\n                <div class=instructions__section__title>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_TITLE\' | translate }}</div>\n                <div class=instructions__section__description>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_DESCRIPTION\' | translate }}</div>\n                <se-receipt-codes ng-if=\"ctrl.nationalLetters.length > 0\" letters=ctrl.nationalLetters></se-receipt-codes>\n                <se-receipt-codes ng-if=\"ctrl.internationalLetters.length > 0\" letters=ctrl.internationalLetters is-international=true></se-receipt-codes>\n                <div class=instructions__section__info>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_INFO\' | translate:{ expiryDate: ctrl.getDigitalStampsExpiryDate() } }}</div>\n                <a class=\"btn btn--blue btn--download-digital-stamps\" href={{ctrl.downloadDigitalsStampsLink}} download>{{ \'DIGITAL_STAMPS_RECEIPT_DOWNLOAD_PDF\' | translate }}</a>\n            </div>\n        </div>\n        <div class=instructions__section>\n            <div class=instructions__section__content>\n                <div class=instructions__section__title>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_ADDRESS_TITLE\' | translate }}</div>\n                <div class=instructions__section__description ng-bind-html=\"\'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_ADDRESS_DESCRIPTION\' | translate\"></div>\n            </div>\n        </div>\n        <div class=instructions__section>\n            <div class=instructions__section__content>\n                <div class=instructions__section__title>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_MAIL_TITLE\' | translate }}</div>\n                <div class=instructions__section__description ng-bind-html=\"\'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_MAIL_DESCRIPTION\' | translate\"></div>\n                <a class=instructions__section__link href=\"{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_MAIL_LINK\' | translate }}\" target=_blank rel=\"noopener noreferrer\">\n                    {{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_MAIL_LINK_TEXT\' | translate }}\n                </a>\n            </div>\n            <img src=assets/images/graphics-instructions-postbox-yellow.svg>\n        </div>\n        <div class=instructions__section>\n            <div class=instructions__section__content>\n                <div class=instructions__section__title>{{ \'DIGITAL_STAMPS_RECEIPT_FOOTER\' | translate }}</div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div ng-if=ctrl.parcels.length class=box>\n    <div class=toggle-box ng-if=ctrl.parcels.length ng-class=\"{ \'toggle-box--toggled\' : ctrl.labelsToggled }\" ng-click=\"ctrl.labelsToggled = !ctrl.labelsToggled\">\n        <div class=toggle-box__section>\n            <img class=toggle-box__image src=assets/images/graphics-parcel-label@2x.png>\n            <strong class=toggle-box__title>{{ \'PARCELS_RECEIPT_TITLE\' | translate }}</strong>\n            <span class=toggle-box__count>x {{ ctrl.parcels.length }}</span>\n        </div>\n\n        <div class=toggle-box__section>\n            <button class=toggle-box__toggle ng-class=\"{ \'toggle-box__toggle--up\' : ctrl.labelsToggled, \'toggle-box__toggle---down\' : !ctrl.labelsToggled }\">\n                <span class=toggle-box__toggle__text>{{ \'RECEIPT_TOGGLE_ACTION\' | translate }}</span>\n            </button>\n        </div>\n    </div>\n    <div ng-show=ctrl.labelsToggled class=\"instructions receipt__sections\">\n        <div>\n            <img src=assets/images/graphics-instructions-print@2x.png>\n            <span>\n                <span class=head-text>{{ \'RECEIPT_PRINT_LABELS\' | translate}}</span>\n                <div class=mobile-reverse-container>\n                    <span class=head-text-info>{{ ctrl.qrCodeEnabled ? \'RECEIPT_PRINT_LABELS_BARCODE_INFO\' : \'RECEIPT_PRINT_LABELS_INFO\' | translate}}</span>\n                    <qrcode ng-if=ctrl.qrCodeEnabled data={{ctrl.qrData}} size=200 error-correction-level=H></qrcode>\n                    <pn-toast ng-show=ctrl.showCN23Info closable=false ng-bind=\"\'RECEIPT_PRINT_CN23_CUSTOMS_DECLARATION_INFO\' | translate\">\n                    </pn-toast>\n                    <div class=\"button-span mobile-reverse-container\">\n                        <button class=\"btn btn--blue\" id=btn-print-labels ng-click=main.setPrintedShippinglabel();ctrl.printWaybill()>{{ \'RECEIPT_PRINT_LABELS_BUTTON\' | translate }}</button>\n                        <span>\n                            <div id=googlePay></div>\n                            <a ng-if=ctrl.qrCodeEnabled href={{ctrl.walletUrl}} download><img ng-src=\"{{\'WALLET_IMG_URL\' | translate}}\"></a>\n                        </span>\n                    </div>\n                </div>\n            </span>\n        </div>\n        <div>\n            <img src=assets/images/graphics-instructions-attach@2x.png>\n            <span>\n                <span class=head-text>{{ \'RECEIPT_PRINT_INSTRUCTION\' | translate}}</span>\n            <span class=head-text-info> {{ \'RECEIPT_PRINT_INSTRUCTION_INFO\' | translate}}</span>\n            </span>\n        </div>\n        <div>\n            <img src=assets/images/graphics-instructions-servicepoint@2x.png>\n            <span>\n                <span class=head-text>{{ \'RECEIPT_PRINT_DROPOFF\' | translate}}</span>\n            <span class=head-text-info ng-bind-html=\"\'RECEIPT_PRINT_DROPOFF_INFO\' | translate\"></span>\n            </span>\n            <cmn-sidebar-dropoff-map class=visible-xs></cmn-sidebar-dropoff-map>\n        </div>\n        <div ng-if=!ctrl.nonTraceable>\n            <img src=assets/images/graphics-instructions-track@2x.png>\n            <span>\n                <span class=head-text>{{ \'RECEIPT_PRINT_TRACK\' | translate}}</span>\n            <span class=head-text-info ng-bind-html=\"\'RECEIPT_PRINT_TRACK_INFO\' | translate\"></span>\n            </span>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/receipt/se/se-receipt-codes.directive.html","<div class=receipt-codes>\n    <ul class=receipt-codes__list>\n        <li class=receipt-codes__list__item>\n            <div class=receipt-codes__list__item__header>\n                <div>{{ (ctrl.isInternational ? \'LETTER_INTERNATIONAL\' : \'LETTER_NATIONAL\') | translate}} </div>\n                <div class=receipt-codes__list__item__info ng-if=ctrl.isInternational>\n                    <img src=assets/images/icon-alert-exclamation-circle.svg>\n                    <span>{{\'PRIORITAIRE_SWEDEN\' | translate}}</span>\n                </div>\n            </div>\n            <div class=receipt-codes__list__item__code-header>\n                {{\'DIGITAL_STAMPS_CODE_HEADER\' | translate}}\n            </div>\n        </li>\n        <li class=receipt-codes__list__item ng-repeat=\"letter in ctrl.letters | limitTo: ctrl.hide ? 3 : undefined\">\n            <div>\n                <div class=receipt-codes__list__item__name>{{letter.name}}</div>\n                <div class=receipt-codes__list__item__services>\n                    <div ng-if=ctrl.isInternational>{{ \'International\' | translate}}</div>\n                    <div ng-repeat=\"deliveryOption in (deliveryOptions = (letter.services | filter: {type: \'deliveryOption\' } | onlyVisibleGroupings))\">\n                        {{deliveryOption.shortName || deliveryOption.name}}\n                    </div>\n                </div>\n            </div>\n            <div class=receipt-codes__list__item__code ng-class=\"{\'receipt-codes__list__item__code--international\': ctrl.isInternational}\">\n                {{letter.digitalStamp | portocode}}\n            </div>\n        </li>\n    </ul>\n    <div class=receipt-codes__more ng-click=\"ctrl.hide = !ctrl.hide\" ng-show=\"ctrl.letters.length > 3\">\n        <span class=receipt-codes__more__caret ng-if=ctrl.hide>{{\'DK_SHOW_ALL_CODES\' | translate}}</span>\n        <span class=\"receipt-codes__more__caret receipt-codes__more__caret--rotate\" ng-if=!ctrl.hide>{{\'DK_HIDE_CODES\' | translate}}</span>\n    </div>\n</div>\n");
$templateCache.put("components/shared/beta-banner/beta-banner.html","<div ng-if=betaBanner.showBanner class=beta-banner>\n  <span class=beta-banner__tag>{{ \'BETA_BANNER_TAG\' | translate }}</span>\n  <span class=beta-banner__wrapper>\n    {{\'BETA_BANNER_TEXT\' | translate}}\n    <a class=beta-banner__link href={{betaBanner.newBaseURL}}>\n      {{\'BETA_BANNER_LINK\' | translate }}\n      <img class=beta-banner__arrow src=assets/images/icon-16-arrow-blue@2x.png width=24px height=24px alt=\"\">\n    </a>\n  </span>\n</div>");
$templateCache.put("components/shared/beta-banner-landing/beta-banner-landing.html","<div ng-if=betaBannerLanding.showBanner class=beta-banner-landing>\n  <div class=beta-banner-landing__content>\n    <div class=beta-banner-landing__header>\n      <h2 class=beta-banner-landing__heading>{{ \'BETA_BANNER_HEADER\' | translate }}</h2>\n      <p class=beta-banner-landing__description>{{ \'BETA_BANNER_DESCRIPTION\' | translate }}</p>\n    </div>\n    <button class=\"btn btn--blue beta-banner-landing__button\">\n      <a class=beta-banner-landing__link href={{betaBannerLanding.newBaseURL}}>\n        {{ \'BETA_BANNER_BUTTON\' | translate }}       \n        <img class=beta-banner-landing__arrow src=assets/images/icon-16-arrow-white@2x-1.svg alt=\"\">\n      </a>\n    </button>\n  </div>\n  <img src=assets/images/mailbox.svg alt=\"\" aria-hidden=true class=beta-banner-landing__illustration>\n</div>\n");
$templateCache.put("components/shared/cookie-bar/cookie-bar.html","<div class=cookie-bar ng-show=cookiebar.showCookieBar>\n    <div class=container>\n        <div class=cookie-bar__content>\n            <div class=cookie-bar__text>{{\'COOKIE_BAR_TEXT\' | translate}}</div>\n            <div class=cookie-bar__actions>\n                <a class=cookie-bar__actions__action ng-click=cookiebar.closeCookieBar() ng-bind-html=\"\'COOKIE_BAR_ACCEPT\' | translate\"></a>\n                <a class=cookie-bar__actions__action href=\"{{\'COOKIE_BAR_READ_MORE_URL\' | translate}}\" target=_blank>{{\'COOKIE_BAR_READ_MORE\' | translate}}</a>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("components/shared/disturbance-message/disturbance-message.html","<div>\n    <h2>{{$ctrl.title}}</h2>\n    <p>{{$ctrl.text}}</p>\n    <button ng-click=$ctrl.dismiss() ng-if=$ctrl.isDismissable class=\"btn btn--blue btn--block btn--small\">\n        {{\'DISMISS\' | translate}}\n    </button>\n</div>\n");
$templateCache.put("components/shared/feature-toggler/feature-toggler.html","<div class=\"feature-toggler ng-hide\" ng-show=vm.isOpen>\n    <div class=feature-toggler__overlay ng-click=vm.close()></div>\n    <div class=feature-toggler__box>\n        <div class=feature-toggler__box__title>Features</div>\n        <div class=feature-toggler__features>\n            <div class=feature-toggler__features__feature ng-repeat=\"feature in vm.features\">\n                <label class=feature-toggler__features__feature__name for=feature_{{feature.name}}>{{feature.title}}</label>\n                <div class=feature-toggler__features__feature__checkbox>\n                    <input id=feature_{{feature.name}} type=checkbox ng-model=feature.value ng-change=\"vm.toggleFeature(feature.name, feature.value)\">\n                </div>\n            </div>\n        </div>\n        <button class=\"feature-toggler__button btn btn--block btn--blue btn--small\" ng-click=vm.reload()>Reload</button>\n    </div>\n</div>\n");
$templateCache.put("components/shared/shipment-status/shipment-status.directive.html","<div ng-if=shipmentStatus.parcel.status class=\"shipment__status shipment__status--{{shipmentStatus.parcel.status}}\">\n    <strong>{{ \'HISTORY_STATUS_\' + shipmentStatus.parcel.status | translate}}</strong>\n</div>\n");
$templateCache.put("components/shared/toaster/toaster.html","<pn-toaster type={{ctrl.type}} show-close ng-if=ctrl.showToaster style=\"margin-bottom: 0\">\n    <span>{{ctrl.message}}</span> \n</pn-toaster>");
$templateCache.put("components/user/history/history-order-row.html","<tr class=history__box__table__order>\n    <td colspan=3 class=history__box__table__order__date>\n        <div class=history__box__table__order__date__label>{{order.createdDate | date: \'yyyy-MM-dd\'}}</div>\n        <div class=history__box__table__order__date__sublabel>\n            <span class=history__box__table__order__id>{{order.cartId}}</span>\n\n            <span class=history__box__table__order__price>\n                <strong>{{(isCustomerCompany ? order.totalAmountNoVAT : (order.totalAmountNoVAT + order.totalTaxAmount)) | price}}</strong> kr\n            </span>\n        </div>\n    </td>\n    <td>\n        <div class=hidden-xs>\n            <strong>{{(isCustomerCompany ? order.totalAmountNoVAT : (order.totalAmountNoVAT + order.totalTaxAmount)) | price}}</strong> kr\n        </div>\n    </td>\n    <td colspan=2>\n        <a class=history__box__table__order__link ng-click=printReceipt(order.cartId)>\n            Skriv ut kvitto\n        </a>\n    </td>\n</tr>\n<tr ng-repeat=\"item in order.items | filter: filter.status | orderItemsWithParcelType:filter.product | filter: filter.search\" class=history__box__table__order__tr ui-sref=\"main.user.orderDetails({cartId: item.cartId, itemId: item.itemId})\">\n    <td style=\"width: 20px\"></td>\n    <td class=hidden-xs>\n        <div class=history__box__table__order__tr__name>\n            {{item.content.name}} <span ng-repeat=\"s in item.content.additionalServices | filter: { selected: true, type: \'!deliveryOption\' } | onlyVisibleGroupings\">*</span>\n        </div>\n        <div class=history__box__table__order__tr__consignment>{{item.consignmentNumber}}</div>\n    </td>\n    <td><strong>{{item.content.receiver.name || item.content.receiver.company}}</strong></td>\n    <td class=\"hidden-xs history__box__table__order__tr__price\">\n        <strong>{{(isCustomerCompany ? item.content.itemAmountNoVAT : item.content.itemAmount) | price}}</strong> kr\n    </td>\n    <td>\n        <shipment-status parcel=item></shipment-status>\n    </td>\n    <td>\n        <a ui-sref=\"main.user.orderDetails({cartId: item.cartId, itemId: item.itemId})\" class=\"order-link hidden-xs\">\n            <img src=assets/images/icon-network-blue@2x.png>\n        </a>\n    </td>\n</tr>\n");
$templateCache.put("components/user/history/history.content.html","<div class=\"box history__box\">\n    <div class=\"box__content history__box__input\">\n\n        <div class=search-input>\n            <input class=search-box ng-model=history.filter.search placeholder=\"{{\'HISTORY_SEARCH_PLACEHOLDER\' | translate}}\" type=text>\n            <span class=search-box__button></span>\n        </div>\n        <ui-select class=history__box__input__month ng-model=history.selectedMonth on-select=\"\" theme=selectize ng-change=history.changeMonth(history.selectedMonth) skip-focusser=true search-enabled=false>\n            <ui-select-match selected>\n                <strong>\n                    {{$select.selected === \'last3days\' ? (\'HISTORY_LAST_3_DAYS\' | translate) : $select.selected === \'last5days\' ? (\'HISTORY_LAST_5_DAYS\' | translate) : $select.selected === \'last10days\' ? (\'HISTORY_LAST_10_DAYS\' | translate) : ($select.selected | moment:\'MMM YYYY\')}}\n                </strong>\n            </ui-select-match>\n            <ui-select-choices repeat=\"month in history.months | filter:$select.search\">\n                {{month === \'last3days\' ? (\'HISTORY_LAST_3_DAYS\' | translate) : month === \'last5days\' ? (\'HISTORY_LAST_5_DAYS\' | translate) : month === \'last10days\' ? (\'HISTORY_LAST_10_DAYS\' | translate) : (month | moment:\'MMM YYYY\')}}\n            </ui-select-choices>\n        </ui-select>\n        <div class=history__box__input__status>\n                <ui-select name=status ng-model=history.filter.status on-select=\"\" theme=selectize skip-focusser=true search-enabled=false>\n                    <ui-select-match placeholder=\"{{ \'STATUS\' | translate}}\" selected>\n                        <strong>{{($select.selected.name === \'SHOW_ALL\' ? \'SHOW_ALL\' : \'HISTORY_STATUS_\' + $select.selected.name) | translate}}</strong>\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"status.value as status in history.statuses\">\n                        {{(status.name === \'SHOW_ALL\' ? \'SHOW_ALL\' : \'HISTORY_STATUS_\' + status.name) | translate}}\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div class=history__box__input__product>\n                <ui-select name=product ng-model=history.filter.product on-select=\"\" theme=selectize skip-focusser=true search-enabled=false>\n                    <ui-select-match allow-clear=true placeholder=\"{{ \'PRODUCT\' | translate}}\">\n                        <strong>{{$select.selected.name}}</strong>\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"product in history.products\">\n                        <span>{{product.name}}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n    </div>\n    <div class=\"box__content box__content--no-padding\">\n        <div ng-show=\"history.filteredOrders.length > 0 && !history.loadingHistory\">\n            <table class=history__box__table>\n                <tr class=history__box__table__header>\n                    <th style=\"width: 20px\"></th>\n                    <th class=hidden-xs>{{ \'CONSIGNMENT\' | translate}}</th>\n                    <th>{{ \'RECEIVER\' | translate}}</th>\n                    <th class=hidden-xs>{{ \'PRICE\' | translate}}</th>\n                    <th>{{ \'STATUS\' | translate}}</th>\n                    <th></th>\n                </tr>\n                <tbody ng-repeat=\"order in history.filteredOrders = (history.orderHistory | filter: history.filter.status | ordersWithParcelType:history.filter.product | filter: history.filter.search | orderBy: \'createdDate\': true) | limitTo: \'3\'\" user-history-order-row order=order filter=history.filter is-customer-company=main.isCustomerCompany print-receipt=history.printReceipt>\n                </tbody>\n\n                <tbody ng-show=history.showMoreOrders ng-repeat=\"order in history.orderHistory | filter: history.filter.status | ordersWithParcelType:history.filter.product | filter: history.filter.search | orderBy: \'createdDate\': true | limitTo: history.orderHistory.length : \'3\'\" user-history-order-row order=order filter=history.filter is-customer-company=main.isCustomerCompany print-receipt=history.printReceipt>\n                </tbody>\n\n                <tr class=history__box__table__order__divider ng-if=\"history.filteredOrders.length > 3\">\n                    <td colspan=6 ng-click=\"history.showMoreOrders = !history.showMoreOrders\">\n                        <span class=\"history__box__table__order__divider__content history__box__table__order__divider__content--open\" ng-if=!history.showMoreOrders>\n                            {{ \'HISTORY_SHOW_MORE_ORDERS\' | translate:{\n                                numOrders: (history.filteredOrders.length - 3),\n                                numShipments: history.getNumberOfShipmentsFromOrdersWithOffset(history.filteredOrders, 3)\n                            }:\'messageformat\' }}\n                        </span>\n                        <span class=\"history__box__table__order__divider__content history__box__table__order__divider__content--closed\" ng-if=history.showMoreOrders>\n                            {{ \'HISTORY_SHOW_LESS_ORDERS\' | translate:{\n                                numOrders: (history.filteredOrders.length - 3),\n                                numShipments: history.getNumberOfShipmentsFromOrdersWithOffset(history.filteredOrders, 3)\n                            }:\'messageformat\' }}\n                        </span>\n                    </td>\n                </tr>\n\n                <tbody class=history__box__summary>\n                    <tr class=history__box__summary__details>\n                        <td></td>\n                        <td colspan=1>\n                            {{(history.orderHistory | filter: history.filter.status | ordersWithParcelType:history.filter.product | filter: history.filter.search).length}} {{ \'ORDERS\' | translate | lowercase}}\n                        </td>\n                        <td colspan=2>\n                        </td>\n                        <td colspan=2 class=history__box__summary__details__vat>\n                            <span class=history__box__summary__details__vat__total>\n                                <strong>{{history.getOrderPrice((history.orderHistory | filter: history.filter.status | ordersWithParcelType:history.filter.product | filter: history.filter.search)) | price}}</strong> kr</span><br>\n                            <span>\n                                {{\'PRIVATE_VAT\' | translate}}: <strong>{{history.getOrderTax((history.orderHistory | filter: history.filter.status | ordersWithParcelType:history.filter.product | filter: history.filter.search)) | price}}</strong> kr\n                            </span>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <div class=history__box__empty ng-show=\"history.filteredOrders.length === 0 && !history.loadingHistory\">\n            {{\'HISTORY_NO_RESULTS\' | translate}}\n        </div>\n\n        <div class=history__box__loading ng-show=history.loadingHistory>\n            <div class=history__box__loading__spinner></div>\n        </div>\n    </div>\n</div>\n\n<iframe id=printFrame width=0 height=0 frameborder=0 style=\"display: none\"></iframe>\n");
$templateCache.put("components/user/history/history.html","<div class=main-container-wrapper>\n    <div class=\"main-container history\">\n        <div ng-include=\"\'components/user/history/history.content.html\'\"></div>\n    </div>\n</div>\n\n<div class=customer-type-selector>\n    <div class=customer-type-selector__actions>\n        <button class=customer-type-selector__button ng-class=\"{\'active\': main.isCustomerCompany === false}\" ng-click=main.setCustomerType(false)>\n            {{ \'I_AM\' | translate}} {{ \'PRIVATE\' | translate}}\n        </button>\n        <button class=customer-type-selector__button ng-class=\"{\'active\': main.isCustomerCompany === true}\" ng-click=main.setCustomerType(true)>\n            {{ \'I_AM\' | translate}} {{ \'COMPANY\' | translate}}\n        </button>\n    </div>\n    <p class=customer-type-selector__text>{{ \'PRICES_SHOWN\' | translate}} <strong>{{ (main.isCustomerCompany ? \'EXCL_VAT\' : \'INCL_VAT\') | translate}}</strong></p>\n</div>\n");
$templateCache.put("components/user/receivers/deleteDialog.html","\n<md-dialog aria-label=\"Confirm Delete\">\n\n    <md-dialog-content>\n      <div class=md-dialog-content>\n          <h3>{{ \'HISTORY_USER_RECEIVERS_DELETE\' | translate}}</h3>\n       {{ \'PAYMENT_DIALOG_SUBHEADER\' | translate}}\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=row>\n      <md-button class=md-confirm-button ng-click=confirm()>\n       {{ \'PAYMENT_DIALOG_CONFIRM\' | translate}}\n      </md-button>\n      <md-button class=md-cancel-button ng-click=cancel()>\n        {{ \'PAYMENT_DIALOG_CANCEL\' | translate}}\n      </md-button>\n    </md-dialog-actions>\n \n</md-dialog>\n\n\n");
$templateCache.put("components/user/receivers/receiver-form.html","<ng-form name=userReceiverForm.form class=\"form user-receiver-form\" novalidate>\n    <div class=\"form__row form__row--first\">\n        <receiver-type-toggle is-company=userReceiverForm.isCompany></receiver-type-toggle>\n    </div>\n    <div class=form__row>\n        <div class=\"form__row__inline form__row__inline--full-xs\" ng-if=!userReceiverForm.isCompany>\n            <label for=receiverName_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_NAME\' | translate}}</label>\n            <input id=receiverName_{{$id}} name=name class=form__input type=text ng-model=userReceiverForm.receiver.name maxlength=40 required>\n\n            <div class=form__row__errors ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.name.$error\">\n                <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_NAME\' | translate}}</div>\n            </div>\n        </div>\n        <div class=\"form__row__inline form__row__inline--full-xs\" ng-if=userReceiverForm.isCompany>\n            <label for=receiverCompany_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_COMPANY\' | translate}}</label>\n            <input id=receiverCompany_{{$id}} name=company class=form__input type=text ng-model=userReceiverForm.receiver.company maxlength=40 required>\n\n            <div class=form__row__errors ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.company.$error\">\n                <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_COMPANY\' | translate}}</div>\n            </div>\n        </div>\n        <div class=\"form__row__inline form__row__inline--full-xs\" ng-if=!userReceiverForm.isCompany>\n          <label for=receiverCo_{{$id}} class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_CO\' | translate}}</label>\n          <input id=receiverCo_{{$id}} class=form__input type=text ng-model=userReceiverForm.receiver.address.co maxlength=40>\n          </div>\n        <div class=\"form__row__inline form__row__inline--full-xs\" ng-if=userReceiverForm.isCompany>\n            <label for=receiverAttn class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_COMPANY_ATTN\' | translate}}</label>\n            <input id=receiverAttn class=\"form__input form__input--half\" type=text ng-model=userReceiverForm.receiver.attn maxlength=40>\n        </div>\n      </div>\n        <div class=form__row>\n          <div class=\"form__row__inline form__row__inline--full-xs\">\n                  <label for=receiverCountry_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_COUNTRY\' | translate }}</label>\n                  <ui-select id=receiverCountry_{{$id}} ng-if=\"userReceiverForm.countries.length > 1\" class=receivers__country-selector ng-model=userReceiverForm.receiver.country theme=selectize search-enabled=true skip-focusser=true search-enabled=false on-select=\"userReceiverForm.selectCountry($item, $model, userReceiverForm.receiver)\">\n                      <ui-select-match placeholder=\"{{ \'SEARCH\' | translate}}...\">\n                          <img ng-src=\"{{$select.selected.countryCode | flagPath}}\">\n                          <strong>{{$select.selected.name}}</strong>\n                      </ui-select-match>\n                      <ui-select-choices repeat=\"country as country in userReceiverForm.countries | filter:$select.search\">\n                          <img ng-src=\"{{country.countryCode | flagPath}}\">\n                          <span>{{country.name}}</span>\n                      </ui-select-choices>\n                  </ui-select>\n          </div>\n        </div>\n        <div class=form__row>\n          <div class=\"form__row__inline form__row__inline--full-xs\">\n              <label for=receiverStreet_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_ADDRESS\' | translate}}</label>\n              <input id=receiverStreet_{{$id}} name=streetAddress class=form__input type=text ng-model=userReceiverForm.receiver.address.street maxlength=40 required>\n\n              <div class=form__row__errors ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.streetAddress.$error\">\n                  <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ADDRESS\' | translate}}</div>\n              </div>\n          </div>\n        </div>\n    \n\n    <div class=form__row>\n\n        <div>\n            <div class=form__row__inline>\n                <label for=receiverZipCode_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_ZIPCODE\' | translate}}</label>\n                <input id=receiverZipCode_{{$id}} name=zipCode class=\"form__input form__input--half\" type=text ng-model=userReceiverForm.receiver.address.zipCode required>\n\n                <div class=\"form__row__errors form__input--half\" ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.zipCode.$error\">\n                    <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ZIPCODE\' | translate}}</div>\n                    <div ng-message=invalidPostalCode ng-if=userReceiverForm.isNordicCountry(userReceiverForm.receiver.country.countryCode) ng-bind-html=\"\'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_ZIPAREA\' | translate\"></div>\n                    <div ng-message=invalidPostalCode ng-if=!userReceiverForm.isNordicCountry(userReceiverForm.receiver.country.countryCode)>{{\'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ZIPAREA\' | translate}}</div>\n                  </div>\n            </div>\n            <div class=form__row__inline>\n                <label for=receiverCity_{{$id}} class=\"form__label form__label--required\">{{ \'ADDRESS_PAGE_RECIEVER_ZIPAREA\' | translate}}</label>\n                <input id=receiverCity_{{$id}} name=city class=\"form__input form__input--half\" type=text ng-model=userReceiverForm.receiver.address.city zipcode-city-autocomplete={{userReceiverForm.receiver.address.zipCode}} country-code={{userReceiverForm.receiver.address.countryCode}} validation-status=userReceiverForm.validationStatus placeholder=\"{{ \'ADDRESS_PAGE_SENDER_ZIPAREA_PLACEHOLDER\' | translate}}\" maxlength=34 disabled required readonly>\n\n                <div class=form__row__errors ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.city.$error\">\n                    <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_RECEIVER_CITY\' | translate}}</div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=form__row>\n      \n        <label for=receiverDoorcode_{{$id}} class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_DOORCODE\' | translate }}</label>\n        <input id=receiverDoorcode_{{$id}} name=doorcode class=form__input type=text ng-model=userReceiverForm.receiver.doorcode maxlength=30>\n    </div>\n    <div class=form__row>\n      \n          <label for=receiverEmail_{{$id}} class=form__label>{{ \'ADDRESS_PAGE_RECIEVER_EMAIL\' | translate }}</label>\n          <input id=receiverEmail_{{$id}} name=email class=form__input type=email ng-model=userReceiverForm.receiver.email maxlength=40>\n\n          <div class=form__row__errors ng-messages=\"userReceiverForm.form.$submitted && userReceiverForm.form.email.$error\">\n              <div ng-message=email>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_EMAIL\' | translate}}</div>\n          </div>\n    </div>\n    <cmn-receiver-phone-field-with-validation form=userReceiverForm.form ng-model=userReceiverForm.receiver.phone is-submitted=userReceiverForm.isSubmitted country-code=userReceiverForm.receiver.country.countryCode>\n    </cmn-receiver-phone-field-with-validation>\n\n    <div class=form__row ng-show=userReceiverForm.form.duplicateUserError>\n        <div class=form__row__errors>\n            {{\'RECEIVERS_DUPLICATE_RECEIVER_ERROR\' | translate}}\n        </div>\n    </div>\n\n    <div class=\"form__row user-receiver-form__actions visible-xs\" ng-hide=!userReceiverForm.receiver.receiverId>\n        <button class=\"user-receiver-form__action user-receiver-form__action--save\" ng-click=userReceiverForm.saveFn()></button>\n        <button class=\"user-receiver-form__action user-receiver-form__action--remove\" ng-click=userReceiverForm.removeFn()></button>\n    </div>\n</ng-form>\n");
$templateCache.put("components/user/receivers/receiver-type-toggle.html","<div class=receiver-type-toggle>\n    <div class=receiver-type-toggle__option ng-click=\"isCompany = false\">\n        <div class=receiver-type-toggle__option__radio-button>\n            <div ng-if=!isCompany class=receiver-type-toggle__option__radio-button--active></div>\n        </div>\n        <div class=receiver-type-toggle__option__label>{{\'PRIVATE_PERSON_RECEIVER\' | translate}}</div>\n    </div>\n    <div class=receiver-type-toggle__option ng-click=\"isCompany = true\">\n        <div class=receiver-type-toggle__option__radio-button>\n            <div ng-if=isCompany class=receiver-type-toggle__option__radio-button--active></div>\n        </div>\n        <div class=receiver-type-toggle__option__label>{{\'COMPANY_RECEIVER\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/user/receivers/receivers.content.html","<div class=\"box receivers__box\">\n  <div class=\"box__header receivers__box__header\">\n    <div ng-show=receivers.showReceiver>\n      <div class=receivers__add-form>\n        <user-receiver-form receiver=receivers.newReceiver countries=receivers.countrySelection form=receivers.newReceiverForm></user-receiver-form>\n\n        <div class=receivers__add-form__actions>\n          <button class=\"btn btn--blue\" ng-class=\"{\'btn--loading\': receivers.isAddingReceiver}\" ng-click=\"receivers.addReceiver(receivers.newReceiver, receivers.newReceiverForm)\">\n            {{\'RECEIVERS_SAVE_RECEIVER\' | translate}}\n          </button>\n\n          <button class=\"btn btn--gray\" ng-click=\"receivers.showReceiver = !receivers.showReceiver\">\n            {{\'RECEIVERS_CANCEL\' | translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <div class=receivers__search ng-show=!receivers.showReceiver>\n      <input class=receivers__search__input ng-model=searchFilter placeholder=\"{{\'RECEIVERS_SEARCH_PLACEHOLDER\' | translate}}\" type=text>\n      <button class=receivers__search__button></button>\n    </div>\n\n    <button class=receivers__add-button ng-if=!receivers.showReceiver ng-click=\"receivers.showReceiver = !receivers.showReceiver\">\n      {{\'RECEIVERS_ADD_RECEIVER\' | translate}}\n    </button>\n  </div>\n\n  <div class=\"box__content box__content--no-padding\">\n    <table class=receivers__table>\n      <thead class=\"receivers__table__head hidden-xs\">\n        <tr>\n          <th class=\"receivers__table__col receivers__table__col--padding\"></th>\n          <th>{{\'NAME\' | translate}}</th>\n          <th class=hidden-xs>{{\'ADDRESS\' | translate}}</th>\n          <th class=hidden-xs>{{\'EMAIL_SHORT\' | translate}}</th>\n          <th class=hidden-xs>{{\'PHONE_NUMBER_MOBILE\' | translate}}</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody class=receivers__table__group-header ng-repeat-start=\"group in receivers.groupedReceivers | orderBy:\'name\'\" ng-hide=\"group.filteredReceivers.length === 0\">\n        <tr>\n          <th class=\"receivers__table__col receivers__table__col--padding\"></th>\n          <th colspan=4 class=first>{{group.title}}</th>\n          <th class=\"receivers__table__col receivers__table__col--actions\">\n            <button class=receivers__table__action ng-class=\"{\n                                \'receivers__table__action--expand\': !group.collapsed,\n                                \'receivers__table__action--collapse\': group.collapsed\n                            }\" ng-click=\"group.collapsed = !group.collapsed\"></button>\n          </th>\n        </tr>\n      </tbody>\n      <tbody class=receivers__table__group-content ng-hide=group.collapsed ng-repeat-end>\n        <tr class=\"receivers__table__group-content__row receivers__receiver\" ng-class=\"{\'receivers__table__group-content__row--odd\': $odd}\" ng-click=receivers.toggleReceiverDetails(receiver) ng-if=!receiver.editing ng-repeat-start=\"receiver in group.filteredReceivers = (group.receivers | filter: searchFilter) | orderBy:\'name\'\">\n          <td class=\"receivers__table__col receivers__table__col--padding\"></td>\n          <td class=first responsive-colspan=4>\n            <strong>{{receiver.name || receiver.company}}</strong>\n            <div class=receivers__receiver__details uib-collapse=!receiver.showDetails>\n              <div ng-if=receiver.address.street>\n                {{receiver.address.street}}\n              </div>\n              <div ng-if=\"receiver.address.zipCode && receiver.address.city\">\n                {{receiver.address.zipCode}}, {{receiver.address.city}}\n              </div>\n              <div ng-if=receiver.email>{{receiver.email}}</div>\n              <div ng-if=receiver.phone>{{receiver.phone}}</div>\n            </div>\n          </td>\n          <td class=hidden-xs>\n            <span style=\"color: #000\">{{receiver.address.street}}</span><br><span>{{receiver.address.zipCode}}, {{receiver.address.city}}</span>\n          </td>\n          <td class=hidden-xs>{{receiver.email}}</td>\n          <td class=hidden-xs>{{receiver.phone}}</td>\n          <td class=\"receivers__table__col receivers__table__col--actions\">\n            <button class=\"receivers__table__action receivers__table__action--remove hidden-xs\" ng-click=\"receivers.removeReceiver($event, receiver)\"></button>\n            <button class=\"receivers__table__action receivers__table__action--edit hidden-xs\" ng-click=receivers.editReceiver(receiver)></button>\n            <button class=\"receivers__table__action receivers__table__action--edit\" ng-show=receiver.showDetails ng-click=receivers.editReceiver(receiver)></button>\n          </td>\n        </tr>\n        <tr class=receivers__table__group-content__row ng-class=\"{\'receivers__table__group-content__row--odd\': $odd}\" ng-if=receiver.editing ng-repeat-end>\n          <td class=\"receivers__table__col receivers__table__col--padding\"></td>\n          <td colspan=4 responsive-colspan=5>\n            <user-receiver-form receiver=receiver.edit countries=receivers.countrySelection form=editReceiverForm[$parent.$index][$index] save-fn=\"receivers.saveReceiver(receiver, editReceiverForm[$parent.$index][$index])\" remove-fn=\"receivers.removeReceiver($event, receiver)\">\n            </user-receiver-form>\n          </td>\n          <td class=\"receivers__table__col receivers__table__col--actions hidden-xs\">\n            <button class=\"receivers__table__action receivers__table__action--remove\" ng-click=\"receivers.removeReceiver($event, receiver)\"></button>\n\n            <button class=\"receivers__table__action receivers__table__action--save\" ng-click=\"receivers.saveReceiver(receiver, editReceiverForm[$parent.$index][$index])\"></button>\n          </td>\n        </tr>\n      </tbody>\n\n      <tbody ng-if=\"!receivers.receivers || receivers.receivers.length === 0\">\n        <tr ng-if=receivers.isLoading>\n          <td class=receivers__loading colspan=7>\n            <div class=receivers__loading__spinner></div>\n          </td>\n        </tr>\n        <tr class=receivers__empty ng-if=!receivers.isLoading>\n          <td colspan=7>{{\'RECEIVERS_EMPTY_LIST\' | translate}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n");
$templateCache.put("components/user/receivers/receivers.html","\n<div class=main-container-wrapper>\n    <div class=\"main-container receivers\">\n        <div ng-include=\"\'components/user/receivers/receivers.content.html\'\"></div>\n    </div>\n</div>\n");
$templateCache.put("components/address/common/email-field/email-field.directive.html","<div class=form__row>\n    <label for=receiverForm_email_{{$id}} class=form__label ng-class=\"{\'form__label--required\': ngRequired}\">\n        {{ (deliveryConfirmationPossible ? \'ADDRESS_PAGE_RECIEVER_EMAIL\' : \'ADDRESS_PAGE_RECIEVER_EMAIL_NO_CONFIRMATION\') | translate}}\n    </label>\n\n    <div class=form__input-group>\n        <input id=receiverForm_email_{{$id}} autocomplete=receiverEmail name=receiverEmail minlength=6 maxlength=64 class=form__input type=email ng-model=ngModel ng-required=ngRequired>\n\n        <div class=form__input-group__description ng-if=deliveryConfirmationPossible>\n            {{\n                (hasHomeDelivery\n                ? \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_EMAIL_ALT\'\n                : \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_EMAIL\') | translate\n            }}\n        </div>\n    </div>\n\n    <div class=form__row__errors ng-messages=\"isSubmitted && form.receiverEmail.$error\">\n        <div ng-message=minlength>{{ \'ADDRESS_PAGE_ERROR_EMAIL_MINLENGTH\' | translate}}</div>\n        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_EMAIL\' | translate}}</div>\n        <div ng-message=email>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_EMAIL\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/address/common/phone-field/phone-field.directive.html","<div class=form__row>\n    <label for=receiverForm_phone_{{$id}} class=form__label ng-class=\"{\'form__label--required\': ngRequired}\">\n        {{ (deliveryConfirmationPossible ? \'ADDRESS_PAGE_RECIEVER_MOBILENUMBER\' : \'ADDRESS_PAGE_RECIEVER_MOBILENUMBER_NO_CONFIRMATION\') | translate}}\n    </label>\n\n    <div class=form__input-group>\n        <input id=receiverForm_phone_{{$id}} name=receiverTel class=form__input type=tel autocomplete=receiverTel ng-model=ngModel minlength=8 maxlength=25 ng-required=ngRequired>\n\n        <div class=form__input-group__description ng-if=deliveryConfirmationPossible>\n            {{\n                (hasHomeDelivery\n                ? \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_MOBILENUMBER_ALT\'\n                : \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_MOBILENUMBER\') | translate\n            }}\n        </div>\n    </div>\n\n    <div class=form__row__errors ng-messages=\"isSubmitted && form.receiverTel.$error\">\n        <div ng-message=minlength>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_MOBILE\' | translate}}</div>\n        <div ng-message=maxlength>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_MOBILE\' | translate}}</div>\n        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_MOBILE\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/address/common/phone-field-with-validation/phone-field-with-validation.directive.html","<div class=form__row>\n    <label for=receiverForm_phone_{{$id}} class=form__label ng-class=\"{\'form__label--required\': ngRequired}\">\n        {{ (deliveryConfirmationPossible ? \'ADDRESS_PAGE_RECIEVER_MOBILENUMBER\' : \'ADDRESS_PAGE_RECIEVER_MOBILENUMBER_NO_CONFIRMATION\') | translate}}\n    </label>\n\n    <div class=form__input-group>\n        <input id=receiverForm_phone_{{$id}} name=receiverTel class=form__input type=phone autocomplete=receiverTel ng-model=ngModel ng-required=ngRequired ng-pattern=\"/^[0-9 +]+$/\" is-mobile-number country-code=countryCode>\n\n        <div class=form__input-group__description ng-if=deliveryConfirmationPossible>\n            {{\n                (hasHomeDelivery\n                ? \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_MOBILENUMBER_ALT\'\n                : \'ADDRESS_PAGE_RECIEVER_NOTIFICATION_MOBILENUMBER\') | translate\n            }}\n        </div>\n    </div>\n\n    <div class=form__row__errors ng-messages=\"isSubmitted && form.receiverTel.$error\">\n        <div ng-message=isMobileNumber>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_MOBILE\' | translate}}</div>\n        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_EMAIL_RECEIVER_MOBILE\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/address/dk/letter-notification/letter-notification.directive.html","<div class=letter-notification-selector ng-if=letterNotification.service>\n    <div class=\"letter-notification-selector__col letter-notification-selector__col--checkbox\">\n        <input id={{letterNotification.service.additionalServiceId}}_additional_{{$id}} type=checkbox class=letter-notification-selector__checkbox ng-class=\"{\'letter-notification-selector__checkbox--pending\': letterNotification.isPending(letterNotification.product, letterNotification.service)}\" ng-checked=letterNotification.isChecked(letterNotification.service) ng-model=letterNotification.service.selected>\n    </div>\n\n\n    <div class=\"letter-notification-selector__col letter-notification-selector__col--name\">\n        <div class=letter-notification-selector__content ng-class=\"{\'letter-notification-selector__content--has-description\': letterNotification.service.description && !letterNotification.multipleChoice}\">\n            <label for={{letterNotification.service.additionalServiceId}}_additional_{{$id}} class=letter-notification-selector__name>\n                {{letterNotification.service.name}}\n            </label>\n\n            <additional-service-price class=letter-notification-selector__price product=letterNotification.parcel additional-service=letterNotification.service>\n            </additional-service-price>\n\n        </div>\n    </div>\n\n    <div class=letter-notification-selector__tooltip>\n        {{letterNotification.service.description}}\n    </div>\n</div>\n");
$templateCache.put("components/address/dk/receiver-service-point/receiver-service-point.directive.html","<div class=receiver-service-point>\n    <label class=receiver-service-point__label>{{\'ADDRESS_PAGE_RECEIVER_SERVICE_POINT\' | translate}}</label>\n\n    <div class=form__input-group>\n        <div class=receiver-service-point__input-wrapper>\n            <div class=receiver-service-point__input ng-click=\"receiverServicePoint.isOpen = !receiverServicePoint.isOpen\" ng-class=\"{\n                    \'receiver-service-point__input--disabled\': receiverServicePoint.isLoadingServicePoints || receiverServicePoint.servicePoints.length === 0,\n                    \'receiver-service-point__input--is-loading\': receiverServicePoint.isLoadingServicePoints\n                }\">\n                <div class=receiver-service-point__input__truncate-container ng-if=receiverServicePoint.servicePoint>\n                    <div class=receiver-service-point__input__truncate-content ng-if=receiverServicePoint.servicePoint.name>\n                        {{receiverServicePoint.servicePoint.name}},\n                        {{receiverServicePoint.servicePoint.deliveryAddress.streetName}}\n                        {{receiverServicePoint.servicePoint.deliveryAddress.streetNumber}}\n                    </div>\n                    <div class=receiver-service-point__input__distance ng-if=receiverServicePoint.servicePoint.routeDistance>\n                        {{receiverServicePoint.servicePoint.routeDistance}}m\n                    </div>\n                </div>\n\n                <div class=receiver-service-point__input__truncate-container ng-if=!receiverServicePoint.servicePoint>\n                    {{\'ADDRESS_PAGE_RECEIVER_SERVICE_POINT_DEFAULT_OPTION\' | translate}}\n                </div>\n            </div>\n\n            <div class=receiver-service-point__spinner ng-show=receiverServicePoint.isLoadingServicePoints></div>\n        </div>\n\n        <div>\n            <ul class=receiver-service-point__list ng-show=receiverServicePoint.isOpen>\n                <li class=receiver-service-point__list__item ng-class=\"{\'receiver-service-point__list__item--selected\': !receiverServicePoint.servicePoint.servicePointId}\" ng-click=receiverServicePoint.clearServicePoint()>\n                    {{\'ADDRESS_PAGE_RECEIVER_SERVICE_POINT_DEFAULT_OPTION\' | translate}}\n                </li>\n\n                <li class=receiver-service-point__list__item ng-repeat=\"option in receiverServicePoint.servicePoints\" ng-click=receiverServicePoint.selectServicePoint(option) ng-class=\"{\n                        \'receiver-service-point__list__item--selected\': receiverServicePoint.servicePoint.servicePointId === option.servicePointId\n                    }\">\n                    <span class=receiver-service-point__list__item__name>{{option.name}},</span>\n                    <span class=receiver-service-point__list__item__street>{{option.deliveryAddress.streetName}} {{option.deliveryAddress.streetNumber}}</span>\n                    <span class=receiver-service-point__list__item__distance>{{option.routeDistance}}m</span>\n                </li>\n\n            </ul>\n        </div>\n\n        <div class=form__input-group__description> {{\'DK_RECEIVER_SERVICEPOINT_DESCRIPTION\' | translate}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/additional-service-selector.directive.html","<div class=additional-service-selector ng-show=\"(additionalServiceSelector.hiddenServices | filter:false).length > 0\">\n    <label class=additional-service-selector__label>\n        {{ \'LANDING_PAGE_CHOOSE_EXTRAS\' | translate}}:\n    </label>\n\n    <ul class=additional-service-selector__list>\n        <additional-service class=additional-service-selector__list__item ng-repeat=\"group in additionalServiceSelector.groupedServices\" multiple-choice=\"group.services.length > 1\" product=additionalServiceSelector.selectedType additional-service-group=group is-customer-company=additionalServiceSelector.isCustomerCompany on-select=additionalServiceSelector.checkAdditionalServices on-multiple-choice-select=additionalServiceSelector.setSelectedServiceInGroup is-hidden=additionalServiceSelector.hiddenServices[$index]>\n        </additional-service>\n    </ul>\n</div>\n");
$templateCache.put("components/landing/common/country-selector/country-selector.directive.html","<div class=cmn-country-selector ng-keydown=onKeyDown($event) ng-class=\"{\'cmn-country-selector__disabled\': isEditing, \'selected\': isOpen}\">\n    <div class=cmn-country-selector__current ng-show=\"selectedCountry && !isOpen\" ng-click=openDropdown()>\n        <img class=cmn-country-selector__flag ng-src=\"{{selectedCountry.countryCode | flagPath}}\">\n        <div class=cmn-country-selector__country-name>\n            {{ \'TO\' | translate}} <strong>{{selectedCountry.name}}</strong>\n        </div>\n        <pn-icon class=cmn-country-selector__arrow symbol=angle-small-down color=blue700 size=small solid></pn-icon>\n    </div>\n\n    <div class=\"cmn-country-selector__search ng-hide\" ng-show=\"!selectedCountry || isOpen\">\n        <input type=text class=cmn-country-selector__search__input ng-model=searchString placeholder=\"{{ \'SEARCH\' | translate}}...\">\n        <pn-icon symbol=angle-small-up color=blue700 size=small solid ng-click=close()></pn-icon>\n    </div>\n\n    <div class=\"cmn-country-selector__dropdown ng-hide\" ng-show=\"isOpen && filteredCountries.length > 0\">\n        <ul class=cmn-country-selector__dropdown__list>\n            <li class=cmn-country-selector__dropdown__country ng-repeat=\"country in filteredCountries\" ng-click=selectCountry(country) ng-class=\"{\'cmn-country-selector__dropdown__country--active\': country.countryCode === selectedCountry.countryCode,\n                \'cmn-country-selector__dropdown__country--marked\': country.countryCode === countryToSelect.countryCode}\">\n                <img class=cmn-country-selector__dropdown__country__flag ng-src=\"{{country.countryCode | flagPath}}\">\n                <div class=cmn-country-selector__dropdown__country__name ng-bind-html=getCountryNameWithDecoration(country.name)></div>\n                <i>\n                    <pn-icon symbol=check color=blue700 size=small solid></pn-icon>\n                </i>\n            </li>\n        </ul>\n    </div>\n</div>\n\n");
$templateCache.put("components/landing/common/delivery-option-selector/delivery-option-selector.directive.html","<div class=delivery-option-selector ng-show=\"deliveryOptionSelector.deliveryOptionsRender.length > 0\">\n    <div class=delivery-option-selector__label>{{\'DELIVERY_OPTION_SELECTOR_TITLE\' | translate}}</div>\n    <div class=delivery-option-selector__option ng-class=\"{\n            \'delivery-option-selector__option--single\': deliveryOptionSelector.deliveryOptionsRender.length === 1,\n            \'delivery-option-selector__option--disabled\': option.disabled\n        }\" ng-repeat=\"option in deliveryOptionSelector.deliveryOptionsRender\" ng-click=deliveryOptionSelector.selectOption(option)>\n        <div class=delivery-option-selector__option__checkbox-wrapper>\n            <div class=delivery-option-selector__option__checkbox ng-class=\"{\'delivery-option-selector__option__checkbox--active\': option.selected}\"></div>\n        </div>\n        <div class=delivery-option-selector__option__content>\n            <div class=delivery-option-selector__option__title>\n                {{option.name}}\n\n                <additional-service-price class=delivery-option-selector__option__price ng-if=\"!option.included && option.price !== 0\" is-customer-company=deliveryOptionSelector.isCustomerCompany product=deliveryOptionSelector.product additional-service=option>\n                </additional-service-price>\n\n                <div class=delivery-option-selector__option__tooltip ng-if=option.helpText tabindex=1 ng-click=$event.stopPropagation(); uib-popover-html=option.helpText>\n                </div>\n            </div>\n            <div class=delivery-option-selector__option__description>{{option.description}}</div>\n        </div>\n    </div>\n</div>\n\n<next-weekday-validator ng-show=\"deliveryOptionSelector.selectedOption.additionalServiceId === \'faster_delivery\' && deliveryOptionSelector.deliveryOptions.length > 0\" product-code=deliveryOptionSelector.selectedOption.productCode></next-weekday-validator>\n");
$templateCache.put("components/landing/common/delivery-point-selector/delivery-point-selector.directive.html","<div class=delivery-point-selector ng-show=\"deliveryPointSelector.deliveryPoints.length > 0\">\n    <div class=delivery-point-selector__title>{{\'DELIVERY_POINT_SELECTOR_TITLE\' | translate}}</div>\n\n    <ul class=delivery-point-selector__points>\n        <li class=delivery-point-selector__point ng-class=\"{\'delivery-point-selector__point--single\': deliveryPointSelector.deliveryPoints.length === 1}\" ng-repeat=\"point in deliveryPointSelector.deliveryPoints\" ng-click=deliveryPointSelector.selectPoint(point)>\n            <div class=delivery-point-selector__point__checkbox-wrapper>\n                <div class=delivery-point-selector__point__checkbox ng-class=\"{\'delivery-point-selector__point__checkbox--active\': point.selected}\"></div>\n            </div>\n            <div class=delivery-point-selector__point__content>\n                <div class=delivery-point-selector__point__title>\n                    {{point.shortName}}\n\n                    <additional-service-price class=delivery-point-selector__point__price ng-if=\"!point.included && (point.price !== 0 || point.displayPrice)\" is-customer-company=deliveryPointSelector.isCustomerCompany product=deliveryPointSelector.product additional-service=point>\n                    </additional-service-price>\n                </div>\n                <div class=delivery-point-selector__point__description>{{point.description}}</div>\n            </div>\n        </li>\n    </ul>\n</div>\n");
$templateCache.put("components/landing/common/delivery-time/delivery-time.directive.html","<div class=delivery-time>\n    <div class=delivery-time__content>\n        <div class=\"delivery-time__col delivery-time__col--label\">\n            <div class=delivery-time__label>{{\'EMS_DELIVERYTIME\' | translate}}</div>\n        </div>\n\n        <div class=delivery-time__col>\n            <div class=delivery-time__value>\n                {{ctrl.selectedType.shipmentDays}}\n                <span ng-if=\"ctrl.selectedType.shipmentDays === \'1\'\">{{\'EMS_SHIPMENTDAY\' | translate}}</span>\n                <span ng-if=\"ctrl.selectedType.shipmentDays !== \'1\'\">{{\'EMS_SHIPMENTDAYS\' | translate}}</span>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("components/landing/common/delivery-time-option-selector/delivery-time-option-selector.directive.html","<div class=delivery-time-option-selector ng-show=\"deliveryTimeOptionSelector.deliveryTimeOptions.length > 0\">\n    <div class=delivery-time-option-selector__title>{{\'DELIVERY_TIME_OPTION_SELECTOR_TITLE\' | translate}}</div>\n\n    <ul class=delivery-time-option-selector__options>\n        <li class=delivery-time-option-selector__option ng-class=\"{\'delivery-time-option-selector__option--single\': deliveryTimeOptionSelector.deliveryTimeOptions.length === 1}\" ng-repeat=\"option in deliveryTimeOptionSelector.deliveryTimeOptions\" ng-click=deliveryTimeOptionSelector.selectOption(option)>\n            <div class=delivery-time-option-selector__option__checkbox-wrapper>\n                <div class=delivery-time-option-selector__option__checkbox ng-class=\"{\'delivery-time-option-selector__option__checkbox--active\': option.selected}\"></div>\n            </div>\n            <div class=delivery-time-option-selector__option__content>\n                <div class=delivery-time-option-selector__option__title>\n                    {{option.shipmentDays}} {{(option.shipmentDays ===\'1\' ? \'DELIVERY_TIME_OPTION_SELECTOR_DAY\' : \'DELIVERY_TIME_OPTION_SELECTOR_DAYS\') | translate}}\n\n                    <additional-service-price class=delivery-time-option-selector__option__price ng-if=!option.included is-customer-company=deliveryTimeOptionSelector.isCustomerCompany product=deliveryTimeOptionSelector.product additional-service=option>\n                    </additional-service-price>\n                </div>\n                <div class=delivery-time-option-selector__option__description>{{option.description}}</div>\n            </div>\n        </li>\n    </ul>\n</div>\n");
$templateCache.put("components/landing/common/product-documents/product-documents.directive.html"," <div class=product-documents ng-if=\"productDocumentsCtrl.documents.length >= 1\">\n    <label class=product-documents__label>{{productDocumentsCtrl.label}}</label>\n    <div class=product-documents__description>{{productDocumentsCtrl.description}}</div>\n\n    <div>\n        <a href={{productDocumentsCtrl.readMoreUrl}} target=_blank>{{ \'SIDEBAR_FAQ_READ_MORE\' | translate}}</a>\n    </div>\n<!-- \n    <div class=\"product-documents__links\" ng-repeat=\"label in productDocumentsCtrl.documents\">\n        <a class=\"product-documents__links__url\" href=\"{{label.url}}\" target=\"_blank\">{{label.name}}</a>\n    </div> -->\n<div>\n</div></div>");
$templateCache.put("components/landing/common/product-price/product-price.directive.html","<div class=product-price>\n    <div class=product-price__label>\n        {{productPrice.label | translate}}\n    </div>\n    <div class=product-price__price>\n        <div class=product-price__price__value>{{productPrice.price | price}}</div>\n        <div class=product-price__price__currency>{{productPrice.currency}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/product-quantity/product-quantity.directive.html","<div class=product-quantity>\n    <label for=product-quantity-input class=product-quantity__label>{{\'PRODUCT_AMOUNT_LABEL\' | translate}}:</label>\n    <div class=product-quantity__form>\n        <input id=product-quantity-input class=product-quantity__form__input type=number step=1 value=1 min=1 max=999 ng-model=ctrl.quantity ng-blur=ctrl.onBlur()>\n        <button class=\"product-quantity__form__button product-quantity__form__button--decrease\" ng-disabled=\"ctrl.quantity <= 1\" ng-click=ctrl.decrease(ctrl.quantity)>\n        </button>\n        <button class=\"product-quantity__form__button product-quantity__form__button--increase\" ng-click=ctrl.increase(ctrl.quantity)>\n        </button>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/return-option-selector/return-option-selector.directive.html","<div class=return-option-selector ng-if=vm.returnOption ng-class=\"{\'se\': vm.market === \'SE\'}\">\n    <div class=return-option-selector__title>{{\'DK_RETURN_OPTION_SELECTOR_TITLE\' | translate}}</div>\n\n    <ul class=return-option-selector__options>\n        <li class=return-option-selector__option ng-click=vm.setOption(false)>\n            <div class=return-option-selector__option__checkbox-wrapper>\n                <div class=return-option-selector__option__checkbox ng-class=\"{\n                        \'return-option-selector__option__checkbox--active\': vm.returnOption.selected === false,\n                        \'return-option-selector__option__checkbox--invalid\': !vm.isValid && vm.isProductSubmitted\n                    }\">\n                </div>\n            </div>\n            <div class=return-option-selector__option__content>\n                <div class=return-option-selector__option__title>\n                    {{\'DK_RETURN_OPTION_SELECTOR_NO_RETURN_LABEL\' | translate}}\n                </div>\n            </div>\n        </li>\n\n        <li class=return-option-selector__option ng-click=vm.setOption(true)>\n            <div class=return-option-selector__option__checkbox-wrapper>\n                <div class=return-option-selector__option__checkbox ng-class=\"{\n                        \'return-option-selector__option__checkbox--active\': vm.returnOption.selected === true,\n                        \'return-option-selector__option__checkbox--invalid\': !vm.isValid && vm.isProductSubmitted\n                    }\">\n                </div>\n            </div>\n            <div class=return-option-selector__option__content>\n                <div class=return-option-selector__option__title>\n                    {{vm.returnOption.name}}\n                </div>\n                <div class=return-option-selector__option__description>{{vm.returnOption.description}}</div>\n            </div>\n        </li>\n    </ul>\n\n    <div class=return-option-selector__error ng-show=\"!vm.isValid && vm.isProductSubmitted\">\n        {{\'DK_RETURN_OPTION_SELECTOR_SELECTION_REQUIRED\' | translate}}\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/sidebar-product-price/sidebar-product-price.directive.html","<div class=product-price>\n    <div class=product-price__label>\n        {{productPrice.label | translate}}\n        <span class=product-price__label__sublabel>({{productPrice.sublabel | translate}})</span>\n    </div>\n    <div class=product-price__price>\n        <div class=product-price__price__value>{{productPrice.price | price}}</div>\n        <div class=product-price__price__currency>{{productPrice.currency}}</div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/dk/customs-text/customs-text.directive.html","<div class=customs-text ng-if=\"vm.documents.length > 0\">\n    <div class=customs-text__label>{{ \'DK_LANDING_PAGE_CUSTOMS_TITLE\' | translate }}</div>\n    <div class=customs-text__description>{{ \'DK_LANDING_PAGE_CUSTOMS_INFO\' | translate }}</div>\n</div>\n");
$templateCache.put("components/landing/dk/product-description/product-description.directive.html","<div class=product-description>{{productDescription.text}}</div>\n");
$templateCache.put("components/landing/dk/product-group-product-selector/product-group-product-delivery-time.html","<label ng-if=$ctrl.hasCustomsDocuments($ctrl.product)>{{ \'DELIVERY_TIME_EXCL_CUSTOMS_HANDLING\' | translate }}</label>\n<label ng-if=!$ctrl.hasCustomsDocuments($ctrl.product)>{{ \'DELIVERY_TIME\' | translate }}</label>\n<ul ng-if=\"$ctrl.product.additionalServices[0].type === \'valuablesDeliveryTime\'\">\n    <li ng-repeat=\"service in $ctrl.product.additionalServices | filter:{ type: \'valuablesDeliveryTime\' }\" ng-class=\"{ active: service.selected || (service.included && !service.override) }\" ng-click=\"$ctrl.selectDeliveryTime($ctrl.product, service)\">\n        {{ service.name }}\n\n        <additional-service-price ng-if=\"!service.included && service.price !== 0 && !$first\" is-customer-company=$ctrl.isCustomerCompany product=$ctrl.product additional-service=service>\n        </additional-service-price>\n    </li>\n</ul>\n\n<ul ng-if=$ctrl.product.shipmentDays>\n    <li class=active>{{$ctrl.product.shipmentDays}} {{\'DELIVERY_TIME_OPTION_SELECTOR_DAYS\' | translate}}</li>\n</ul>\n");
$templateCache.put("components/landing/dk/product-group-product-selector/product-group-product-dimensions.html","<ul class=dimensions>\n    <li ng-repeat=\"dimension in $ctrl.product.dimensions.dimensionDescriptions\">\n        <label>{{ dimension.description }}:</label>\n        {{ dimension.text ? dimension.text : (\'MAX\' | translate) + \' \' + dimension.maxValue + \' \' + dimension.unit }}\n    </li>\n</ul>\n");
$templateCache.put("components/landing/dk/product-group-product-selector/product-group-product-price.html","<span ng-if=\"$ctrl.basePrice !== $ctrl.price\">\n    (+{{($ctrl.price - $ctrl.basePrice) | price}} {{$ctrl.product.priceUnit}})\n</span>\n");
$templateCache.put("components/landing/dk/product-group-product-selector/product-group-product-selector.html","<ul>\n    <li ng-repeat=\"product in $ctrl.productGroup.products\" ng-class=\"{ single: $ctrl.productGroup.products.length === 1 }\">\n        <div class=checkbox ng-click=$ctrl.selectProduct(product) ng-class=\"{\n                active: $ctrl.product.productId === product.productId,\n                pending: $ctrl.product.productId === product.productId && !$ctrl.isValid\n            }\">\n        </div>\n\n        <header ng-click=$ctrl.selectProduct(product)>\n            <h4>\n                {{ product.group.productName || product.name }}\n\n                <product-group-product-price base-price=$ctrl.basePrice product=product is-customer-company=$ctrl.isCustomerCompany>\n                </product-group-product-price>\n            </h4>\n\n            <div class=tooltip ng-if=product.helpText ng-click=$event.stopPropagation() tabindex=1 uib-popover=\"{{ product.helpText }}\">\n            </div>\n        </header>\n\n        <p>{{ product.group.productDescription || product.description.insuranceText || product.additionalServices[0].description }}</p>\n\n        <dk-product-group-product-delivery-time ng-if=\"product.group.type === \'valuables\' && (product.additionalServices[0].type === \'valuablesDeliveryTime\' || product.shipmentDays)\" product=product is-customer-company=$ctrl.isCustomerCompany select-product=$ctrl.selectProduct(product)>\n        </dk-product-group-product-delivery-time>\n\n        <dk-product-group-product-dimensions ng-if=\"product.group.type === \'valuables\'\" product=product>\n        </dk-product-group-product-dimensions>\n\n        <dk-product-group-product-parcel-value ng-if=\"product.type === \'valuePackage\' && $ctrl.product.productId === product.productId\" is-valid=$ctrl.isParcelValueValid is-product-submitted=$ctrl.isProductSubmitted product=product select-product=$ctrl.selectProduct(product)>\n        </dk-product-group-product-parcel-value>\n    </li>\n</ul>\n");
$templateCache.put("components/landing/dk/product-group-selector/product-group-selector.html","<dk-slider weight=$ctrl.selectedWeight receiver-country-code=$ctrl.toCountry.countryCode>\n</dk-slider>\n\n<dk-product-list is-customer-company=$ctrl.isCustomerCompany product-groups=$ctrl.productGroups selected-product=$ctrl.selectedProduct selected-product-group=$ctrl.selectedProductGroup selected-weight=$ctrl.selectedWeight>\n</dk-product-list>\n");
$templateCache.put("components/landing/dk/product-information/product-information.directive.html","<div class=landing-box__product-information>\n    <dk-product-information-header selected-weight=ctrl.selectedWeight product=ctrl.product receiver-country=ctrl.receiverCountry>\n    </dk-product-information-header>\n\n    <cmn-delivery-option-selector product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </cmn-delivery-option-selector>\n\n    <cmn-delivery-time-option-selector product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </cmn-delivery-time-option-selector>\n\n    <dk-valuable-type-selector ng-if=\"ctrl.product.type === \'valuables\'\" product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany is-valid=ctrl.isValuableTypeValid is-product-submitted=ctrl.isProductSubmitted>\n    </dk-valuable-type-selector>\n\n    <dk-product-group-product-selector ng-if=\"ctrl.productGroup.products.length > 1 || ctrl.product.group.type === \'valuables\'\" product-group=ctrl.productGroup product=ctrl.product is-customer-company=ctrl.isCustomerCompany is-valid=ctrl.isProductGroupProductValid is-product-submitted=ctrl.isProductSubmitted>\n    </dk-product-group-product-selector>\n\n    <cmn-additional-service-selector additional-services=ctrl.product.additionalServices selected-type=ctrl.product is-customer-company=ctrl.isCustomerCompany number-of-services=ctrl.numberOfServices is-roll=ctrl.product.isRoll>\n    </cmn-additional-service-selector>\n\n    <cmn-return-option-selector additional-services=ctrl.product.additionalServices is-valid=ctrl.isInternationalReturnValid is-product-submitted=ctrl.isProductSubmitted>\n    </cmn-return-option-selector>\n\n    <cmn-product-quantity ng-if=\"ctrl.product.type === \'letter\'\" quantity=ctrl.product.quantity>\n    </cmn-product-quantity>\n\n    <dk-product-description product=ctrl.product receiver-country=ctrl.receiverCountry>\n    </dk-product-description>\n\n    <cmn-product-price product=ctrl.product is-customer-company=ctrl.isCustomerCompany currency=\"ctrl.product.priceUnit | prettifyCurrency\">\n    </cmn-product-price>\n\n    <dk-send-product-button product=ctrl.product editing-product=ctrl.editingProduct weight=ctrl.selectedWeight is-disabled=ctrl.isSubmitDisabled is-submitting=ctrl.isSubmitting on-click=\"ctrl.onSubmit(ctrl.product, ctrl.isValid)\">\n    </dk-send-product-button>\n</div>\n");
$templateCache.put("components/landing/dk/product-information-header/product-information-header.directive.html","<div class=product-information-header>\n    <div class=product-information-header__content>\n        <div class=product-information-header__header>\n            {{ctrl.product.group ? ctrl.product.group.name : ctrl.product.name}} &ndash; {{ctrl.selectedWeight.value}} {{ctrl.selectedWeight.unit}}\n        </div>\n\n        <div class=product-information-header__dimensions>\n            <div class=product-information-header__dimensions__part ng-if=\"ctrl.product.group.type !== \'valuables\'\" ng-repeat=\"dimensions in ctrl.product.dimensions.dimensionDescriptions\">\n                <span class=product-information-header__dimensions__part__label>{{dimensions.description}}:</span>\n                <span class=product-information-header__dimensions__part__value>\n                    {{ dimensions.text ? dimensions.text : (\'Max \' + dimensions.maxValue + \' \' + dimensions.unit)}}\n                </span>\n            </div>\n        </div>\n        <div class=product-information-header__deliverytime ng-if=\"ctrl.deliveryTime && ctrl.product.group.type !== \'valuables\'\">\n            <label ng-if=ctrl.hasCustomsDocuments(ctrl.product)>{{ \'DELIVERY_TIME_EXCL_CUSTOMS_HANDLING\' | translate }}</label>\n            <label ng-if=!ctrl.hasCustomsDocuments(ctrl.product)>{{ \'DELIVERY_TIME\' | translate }}</label>\n            <span class=product-information-header__deliverytime__time> {{ctrl.deliveryTime}}</span>\n        </div>\n        <div class=product-information-header__list ng-if=\"ctrl.product.group.type === \'valuables\' && ctrl.product.description.list\">\n            <li class=product-information-header__list__item ng-repeat=\"item in ctrl.product.description.list\">{{item.text || item}}</li>\n        </div>\n        <div class=\"product-information-header__description product-information-header__description--int-letter\" ng-if=\"ctrl.product.type === \'letter\' && ctrl.receiverCountry.countryCode !== \'DK\'\">\n            {{\'LANDING_PAGE_INT_LETTER\' | translate}}\n        </div>\n    </div>\n    \n</div>\n");
$templateCache.put("components/landing/dk/product-selector/product-selector.directive.html","<dk-slider weight=productSelector.selectedWeight receiver-country-code=productSelector.receiverCountryCode></dk-slider>\n<!-- \n<dk-product-viewer\n    weight=\"productSelector.selectedWeight\"\n    products=\"productSelector.products\"\n    selected-product=\"productSelector.selectedProduct\"\n    is-customer-company=\"productSelector.isCustomerCompany\">\n</dk-product-viewer> -->\n");
$templateCache.put("components/landing/dk/send-product-button/send-product-button.directive.html","<div class=landing-box__product-information__btn>\n    <button ng-disabled=isDisabled id=btn-selected-product ng-class=\"{\'btn--loading\': isSubmitting}\" class=\"btn btn--block btn--blue\" ng-click=onClick()>\n        {{ (editingProduct && (editingProduct.maxWeight.value !== product.maxWeight.value) ? \'CHANGE_TO\' : \'SEND\') | translate}}&nbsp;\n        {{ (product.quantity && product.quantity > 1) ? product.quantity + \' x \' : \'\' }}\n        {{weight.value}} {{weight.unit}} {{product.name}} <img src=assets/images/icon-16-arrow-white@2x.png width=16px height=16px>\n    </button>\n</div>\n");
$templateCache.put("components/landing/dk/valuable-type-selector/valuable-type-selector.directive.html","<div class=valuable-type-selector ng-if=\"(ctrl.additionalServices | filter:{type: \'valuableType\'}).length > 0\">\n    <div class=valuable-type-selector__type ng-class=\"{\'valuable-type-selector__type--single\': ctrl.valuableTypes.length === 1}\" ng-repeat=\"group in ctrl.valuableTypes\">\n        <div class=valuable-type-selector__type__checkbox-wrapper>\n            <div class=valuable-type-selector__type__checkbox ng-click=ctrl.selectType(group) ng-class=\"{\n                    \'valuable-type-selector__type__checkbox--active\': group.selected,\n                    \'valuable-type-selector__type__checkbox--pending\': ctrl.isTypePending(group, group.services[0])\n                }\">\n            </div>\n        </div>\n        <div class=valuable-type-selector__type__content>\n            <div class=valuable-type-selector__type__select ng-click=ctrl.selectType(group)>\n                <div class=valuable-type-selector__type__title>\n                    {{group.services[0].name}}\n\n                    <additional-service-price class=valuable-type-selector__type__price ng-if=\"(group.services | filter:{included: true}).length === 0 && group.services[0].price !== 0\" is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=group.services[0]>\n                    </additional-service-price>\n\n                    <div class=valuable-type-selector__type__tooltip ng-if=group.services[0].helpText ng-click=$event.stopPropagation() tabindex=1 uib-popover=\"{{ group.services[0].helpText }}\">\n                    </div>\n                </div>\n\n                <div class=valuable-type-selector__type__description>{{group.services[0].description}}</div>\n            </div>\n\n            <div class=valuable-type-selector__type__options ng-if=group.services[0].multipleChoiceAddOn>\n                <div class=valuable-type-selector__type__options__label>{{group.services[0].multipleChoiceAddOn.title}}</div>\n                <ul class=valuable-type-selector__type__options__list>\n                    <li class=valuable-type-selector__type__options__list__item ng-class=\"{\n                            \'valuable-type-selector__type__options__list__item--active\': ctrl.isOptionActive(service, group, $first),\n                            \'valuable-type-selector__type__options__list__item--disabled\': ctrl.isOptionAlone(group)\n                        }\" ng-click=\"ctrl.selectTypeOption(service, group)\" ng-repeat=\"service in group.services\">\n                        <span class=valuable-type-selector__type__options__list__item__name>\n                            {{service.multipleChoiceAddOn.value}}\n                        </span>\n\n                        <additional-service-price class=valuable-type-selector__type__options__list__item__price ng-if=\"!service.included && service.price !== 0 && (!$first || group.services.length > 1)\" is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=service>\n                        </additional-service-price>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=valuable-type-selector__type__dimensions>\n                <div class=valuable-type-selector__type__dimensions__row ng-repeat=\"dimension in group.services[0].dimensions.dimensionDescriptions\">\n                    <span class=valuable-type-selector__type__dimensions__label>{{dimension.description}}:</span>\n                    <span class=valuable-type-selector__type__dimensions__value>\n                        {{dimension.text ? dimension.text : (\'MAX\' | translate) + \' \' + dimension.maxValue + \' \' + dimension.unit }}\n                    </span>\n                </div>\n            </div>\n\n            <div class=valuable-type-selector__type__parcel-value ng-if=\"group.services[0].type === \'valuePackage\' && group.selected\">\n                <div class=valuable-type-selector__type__parcel-value__label>{{\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_LABEL\' | translate}}:</div>\n\n                <ng-form class=valuable-type-selector__type__parcel-value__form>\n                    <div class=valuable-type-selector__type__parcel-value__form__input-group ng-class=\"{\'valuable-type-selector__type__parcel-value__form__input-group--invalid\': !ctrl.isValid && ctrl.isProductSubmitted}\">\n                        <input type=text class=valuable-type-selector__type__parcel-value__form__input-group__input placeholder=\"10 000\" ng-model=group.services[0].parcelValue ng-change=ctrl.handleParcelValueChange(group.services[0]) ng-disabled=!group.selected>\n                        <div class=valuable-type-selector__type__parcel-value__form__input-group__addon>DKK</div>\n                    </div>\n\n                    <button class=\"btn btn--blue valuable-type-selector__type__parcel-value__form__button\" ng-class=\"{\'btn--loading\': ctrl.isVerifyingParcelValue}\" ng-click=ctrl.verifyParcelValue(group.services[0]) ng-disabled=\"ctrl.isParcelValueButtonDisabled(group, group.services[0])\">\n                        {{\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_BUTTON\' | translate}}\n                    </button>\n                </ng-form>\n\n                <div class=valuable-type-selector__type__parcel-value__verification-message ng-show=\"group.services[0].hasVerifiedParcelValue && !ctrl.isTooExpensive\">\n                    <span ng-if=!ctrl.insurancePrice>{{\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_INSURANCE_INCLUDED\' | translate}}</span>\n                    <span ng-if=ctrl.insurancePrice>\n                        {{ \'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_INSURANCE_COSTS\' | translate:{cost: (ctrl.insurancePrice | price) + \' DKK\'} }}\n                    </span>\n                </div>\n\n                <div class=valuable-type-selector__type__parcel-value__error-message ng-show=\"group.services[0].hasVerifiedParcelValue && ctrl.isTooExpensive\" ng-bind-html=\"\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_MAX_INSURANCE_MESSAGE\' | translate:{maxInsuranceAmount: (ctrl.highestInsuranceAmount | number)}\">\n                </div>\n\n                <div class=valuable-type-selector__type__parcel-value__error-message ng-show=\"!ctrl.isValid && ctrl.isProductSubmitted\">\n                    {{\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_REQUIRED_MESSAGE\' | translate}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/se/ems-express-selector/ems-express-selector.directive.html","<div class=ems-express-selector>\n    <label>{{\'EMS_SELECT_DELIVERY\' | translate}}:</label>\n\n    <ul ng-class=\"{disabled: ctrl.disabled}\">\n        <li ng-click=ctrl.selectExpress(false)>\n            <header>\n                <input type=radio name=selector id=normal ng-click=ctrl.selectExpress(false) ng-checked=\"!ctrl.service.selected && !ctrl.disabled\" ng-disabled=ctrl.disabled>\n\n                <label for=normal>\n                    <span></span>\n                    {{ctrl.product.shipmentDays}} {{(ctrl.service.shipmentDays === \'1\' ? \'EMS_SHIPMENTDAY\' : \'EMS_SHIPMENTDAYS\') | translate}}\n                </label>\n            </header>\n\n            <p>{{\'EMS_NORMAL\' | translate}}</p>\n        </li>\n\n        <li ng-click=ctrl.selectExpress(true)>\n            <header>\n                <input type=radio name=selector id=express ng-click=ctrl.selectExpress(true) ng-checked=\"ctrl.service.selected && !ctrl.disabled\" ng-disabled=ctrl.disabled>\n\n                <label for=express>\n                    <span></span>\n                    {{ctrl.service.shipmentDays}} {{(ctrl.service.shipmentDays === \'1\' ? \'EMS_SHIPMENTDAY\' : \'EMS_SHIPMENTDAYS\') | translate}}\n                </label>\n\n                <additional-service-price is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=ctrl.service>\n                </additional-service-price>\n\n                <span class=tooltip ng-if=ctrl.service.description tabindex=1 ng-click=$event.stopPropagation(); uib-popover=\"{{ ctrl.service.description }}\">\n                </span>\n            </header>\n\n            <p>{{\'EMS_PRIORITIZED\' | translate}}</p>\n       </li>\n    </ul>\n</div>\n");
$templateCache.put("components/landing/se/product-information/product-information.directive.html","<div class=landing-box__product-information>\n    <se-product-information-header product=ctrl.product is-sending-roll=ctrl.product.isRoll>\n    </se-product-information-header>\n\n    <cmn-delivery-point-selector ng-if=ctrl.deliveryToMailbox product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </cmn-delivery-point-selector>\n\n    <rek-option-selector product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </rek-option-selector>\n\n    <cmn-delivery-option-selector ng-show=\"!ctrl.deliveryToMailboxSelected && ctrl.showDeliveryOptions()\" product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </cmn-delivery-option-selector>\n\n    <se-ems-express-selector ng-if=\"ctrl.selectedCountry.countryCode !== \'SE\' && ctrl.productHasEms && ctrl.product.shipmentDays\" product=ctrl.product is-customer-company=ctrl.isCustomerCompany>\n    </se-ems-express-selector>\n\n    <delivery-time ng-if=\"ctrl.selectedCountry.countryCode !== \'SE\' && !ctrl.productHasEms && ctrl.product.shipmentDays\" selected-type=ctrl.product>\n    </delivery-time>\n\n    <cmn-delivery-time-option-selector product=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </cmn-delivery-time-option-selector>\n\n    <se-weight-choice-selector ng-hide=\"!ctrl.deliveryToMailboxSelected && ctrl.deliveryToMailbox\" selected-type=ctrl.product additional-services=ctrl.product.additionalServices is-customer-company=ctrl.isCustomerCompany>\n    </se-weight-choice-selector>\n\n    <cmn-additional-service-selector additional-services=ctrl.product.additionalServices selected-type=ctrl.product is-customer-company=ctrl.isCustomerCompany number-of-services=ctrl.numberOfServices is-roll=ctrl.product.isRoll>\n    </cmn-additional-service-selector>\n\n    <cmn-return-option-selector ng-if=!ctrl.isEms additional-services=ctrl.product.additionalServices is-valid=ctrl.isInternationalReturnValid is-product-submitted=ctrl.isProductSubmitted>\n    </cmn-return-option-selector>\n\n    <se-traceability-indicator ng-if=\"ctrl.selectedCountry.countryCode !== \'SE\'\" selected-type=ctrl.product>\n    </se-traceability-indicator>\n\n    <cmn-product-documents ng-if=!ctrl.customsEnabled label=\"{{ \'LANDING_PAGE_CUSTOMS_TITLE\' | translate}}:\" description=\"{{ \'LANDING_PAGE_CUSTOMS_INFO\' | translate}}\" parcel=ctrl.product filter=customsLabel is-customer-company=ctrl.isCustomerCompany>\n    </cmn-product-documents>\n\n    <cmn-product-documents ng-if=!ctrl.customsEnabled label=\"{{ \'LANDING_PAGE_CUSTOMS_TITLE_EU\' | translate}}:\" description=\"{{ \'LANDING_PAGE_CUSTOMS_INFO_EU\' | translate}}\" parcel=ctrl.product filter=securityDeclaration is-customer-company=ctrl.isCustomerCompany>\n    </cmn-product-documents>\n\n    <cmn-product-quantity ng-if=ctrl.productHasDigitalStamps quantity=ctrl.product.quantity>\n    </cmn-product-quantity>\n\n    <cmn-product-price product=ctrl.product is-customer-company=ctrl.isCustomerCompany currency=\"ctrl.product.priceUnit | prettifyCurrency\">\n    </cmn-product-price>\n\n    <se-send-product-button product=ctrl.product editing-product=ctrl.editingProduct is-disabled=ctrl.isSubmitDisabled is-submitting=ctrl.isSubmitting on-click=\"ctrl.onSubmit(ctrl.product, ctrl.isValid)\">\n    </se-send-product-button>\n</div>\n");
$templateCache.put("components/landing/se/product-information-header/product-information-header.directive.html","<div class=product-information-header>\n    <div class=product-information-header__image>\n        <img ng-src=\"{{(ctrl.isSendingRoll ? ctrl.product.description.roll.imageUrl : ctrl.product.description.imageUrl) | imagePath}}\">\n    </div>\n\n    <div class=product-information-header__content>\n        <div class=product-information-header__header>\n            {{ctrl.product.name}} &ndash; <span ng-bind-html=\"ctrl.product | weightInterval\"></span>\n\n            <div class=product-information-header__header__roll-selector ng-if=ctrl.showRollOption>\n                <div class=product-information-header__header__roll-selector__option ng-click=ctrl.setRollOption(false) ng-class=\"{\'product-information-header__header__roll-selector__option--active\': !ctrl.isSendingRoll}\">\n                    {{\'PARCEL\' | translate}}\n                </div>\n                <div class=product-information-header__header__roll-selector__option ng-click=ctrl.setRollOption(true) ng-class=\"{\'product-information-header__header__roll-selector__option--active\': ctrl.isSendingRoll}\">\n                    {{\'ROLL\' | translate}}\n                </div>\n            </div>\n        </div>\n\n        <div class=product-information-header__dimensions ng-if=ctrl.showDimensions>\n            <div class=product-information-header__dimensions__part ng-repeat=\"dimensions in ctrl.dimensions.dimensionDescriptions\">\n                <span class=product-information-header__dimensions__part__label>{{dimensions.description}}:</span>\n                <span class=product-information-header__dimensions__part__value>{{\'MAX\' | translate}} {{dimensions.maxValue}} {{dimensions.unit}}</span>\n            </div>\n        </div>\n\n        <div class=product-information-header__description ng-bind-html=\"ctrl.isSendingRoll ? ctrl.product.description.roll.text : ctrl.product.description.text\">\n        </div>\n        <div class=\"product-information-header__description product-information-header__description--not-printable\" ng-if=\"ctrl.product.printableAtServicePoint === false\">\n            {{\'LANDING_PAGE_NOT_PRINTABLE_SERVICEPOINT\' | translate}}\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/se/product-selector/product-selector.directive.html","<div class=product-selector>\n    <div id=buttons-container>\n        <button class=\"product-selector__handle product-selector__handle--left\" ng-class=\"{\'product-selector__handle--left--inactive\': productSelector.isFurthestLeft}\"></button>\n        <button class=\"product-selector__handle product-selector__handle--right\" ng-class=\"{\'product-selector__handle--right--inactive\': productSelector.isFurthestRight}\"></button>\n    </div>\n\n    <div id=productSelector class=product-selector__products-wrapper>\n        <div class=my-slider>\n            <div class=tns-item ng-repeat=\"product in productSelector.products\">\n                <div class=\"product-selector__product product-selector__product--{{product.name | lowercase}}\" ng-class=\"{\'product-selector__product--active\': product.name === productSelector.selectedProduct.name}\" ng-click=productSelector.selectProduct(product) tabindex=-1>\n                    <div class=product-selector__product__header>\n                        <div class=\"product-selector__product__header__cell product-selector__product__weight\">\n                            <span ng-bind-html=\"product | weightInterval\"></span>\n    \n                            <span ng-if=\"product.nonTraceable && !product.isTraceableByAdditionalServices\" class=product-selector__product__nontraceable>\n                                {{ \'PARCEL_SELECTOR_NON_TRACEABLE\' | translate }}\n                            </span>\n                        </div>\n                    </div>\n                    <div class=product-selector__product__image-wrapper>\n                        <img class=product-selector__product__image ng-src=\"{{product.imageUrl | imagePath}}\">\n                    </div>\n                    <div class=product-selector__product__footer>\n                        <div class=product-selector__product__footer__content>\n                            <div class=\"product-selector__product__footer__content__cell product-selector__product__name\">{{product.name}}</div>\n                            <div class=\"product-selector__product__footer__content__cell product-selector__product__footer__content__cell--right product-selector__product__price\">\n                                <span ng-if=\"product.minWeight && product.maxWeight\" class=product-selector__product__price__from>{{\'PARCEL_SELECTOR_FROM\' | translate }}</span>\n                                <span ng-if=productSelector.isCustomerCompany>{{product.price | price}}</span>\n                                <span ng-if=!productSelector.isCustomerCompany>{{(product.price * (1 + (product.vat / 10000)) | price)}}</span>\n                                <span class=product-selector__product__price__currency>kr</span>\n                            </div>\n                        </div>\n                   </div>\n                </div>\n           </div>\n        </div>\n        <div class=product-selector__loading ng-if=\"!productSelector.products || productSelector.products.length === 0\"></div>\n    </div>\n</div>\n<div class=sticky-product ng-if=productSelector.productSticky ng-style=\"{\'top\': productSelector.stickyProductYposition+\'px\'}\">\n    <button class=\"sticky-product__button sticky-product__button--left\" ng-class=\"{\'sticky-product__button--inactive\': productSelector.isPrevDisabled}\" ng-click=productSelector.prevProduct()>\n        <pn-icon symbol=angle-left ng-attr-color=\"{{productSelector.isPrevDisabled ? \'grey-06-rock\' : \'grey-01-white\'}}\" size=small solid></pn-icon>\n    </button>\n    <div class=sticky-product__name>{{productSelector.selectedProduct.name | translate}} - {{\'MAX\' | translate}} {{productSelector.selectedProduct.maxWeight.value}} {{productSelector.selectedProduct.maxWeight.unit}}</div>\n    <button class=\"sticky-product__button sticky-product__button--right\" ng-class=\"{\'sticky-product__button--inactive\': productSelector.isNextDisabled}\" ng-click=productSelector.nextProduct()>\n        <pn-icon symbol=angle-right ng-attr-color=\"{{productSelector.isNextDisabled ? \'grey-06-rock\' : \'grey-01-white\'}}\" size=small solid></pn-icon>\n    </button>\n</div>");
$templateCache.put("components/landing/se/rek-option-selector/rek-option-selector.directive.html","<div class=rek-option-selector ng-show=\"rekOptionSelector.rekOptions.length > 0\">\n        <div class=rek-option-selector__label>{{\'LANDING_PAGE_REK_HEADER\' | translate}}</div>\n        <div class=rek-option-selector__option ng-class=\"{\n                \'rek-option-selector__option--single\': rekOptionSelector.rekOptions.length === 1,\n                \'rek-option-selector__option--disabled\': option.disabled\n            }\" ng-repeat=\"option in rekOptionSelector.rekOptions\" ng-click=rekOptionSelector.selectOption(option)>\n            <div class=rek-option-selector__option__checkbox-wrapper>\n                <div class=rek-option-selector__option__checkbox ng-class=\"{\'rek-option-selector__option__checkbox--active\': option.selected}\"></div>\n            </div>\n            <div class=rek-option-selector__option__content>\n                <div class=rek-option-selector__option__title>\n                    {{option.name}} {{\'LANDING_PAGE_REK_OPTION_FROM\' | translate }} <strong>{{option.fromPrice | price}} {{option.priceUnit | prettifyCurrency}}</strong>\n                    <additional-service-price class=rek-option-selector__option__price ng-if=\"!option.included && option.price !== 0\" product=rekOptionSelector.product additional-service=option>\n                    </additional-service-price>\n    \n                    <div class=rek-option-selector__option__tooltip ng-if=option.helpText tabindex=1 ng-click=$event.stopPropagation(); uib-popover-html=option.helpText>\n                    </div>\n                </div>\n                <div class=rek-option-selector__option__description>{{option.description}}</div>\n                <div class=rek-option-selector__option__dimensions>\n                    <div class=rek-option-selector__option__part ng-repeat=\"dimensions in (rekOptionSelector.product.isRoll && option.dimensions.roll ? option.dimensions.roll.dimensionDescriptions : option.dimensions.dimensionDescriptions)\">\n                        <span class=rek-option-selector__option__dimensions__part__label>{{dimensions.description}}:</span>\n                        <span class=rek-option-selector__option__dimensions__part__value>{{\'MAX\' | translate}} {{dimensions.maxValue}} {{dimensions.unit}}</span>\n                    </div>\n                    <div class=rek-option-selector__option__dimensions__part>\n                        <span class=rek-option-selector__option__dimensions__part__label>{{\'WEIGHT\' | translate}}:</span>\n                        <span class=rek-option-selector__option__dimensions__part__value>{{\'MAX\' | translate}} {{option.maxWeight.value}}{{option.maxWeight.unit}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    ");
$templateCache.put("components/landing/se/send-product-button/send-product-button.directive.html","<div class=landing-box__product-information__btn>\n    <button ng-disabled=isDisabled id=btn-selected-product ng-class=\"{\'btn--loading\': isSubmitting}\" class=\"btn btn--block btn--blue\" ng-click=onClick()>\n        <span ng-if=editingProduct>{{\'CHANGE_TO\' | translate}} {{product.name}}</span>\n        <span ng-if=!editingProduct>{{\'NEXT\' | translate}}</span>\n        <img src=assets/images/icon-16-arrow-white@2x.png width=16px height=16px>\n    </button>\n</div>\n");
$templateCache.put("components/landing/se/traceability-indicator/traceability-indicator.directive.html","<div class=traceability-indicator>\n    <div class=traceability-indicator__content>\n        <div class=\"traceability-indicator__col traceability-indicator__col--label\">\n            <div class=traceability-indicator__label>{{\'LANDING_PAGE_TRACEABILITY_SELECTOR_LABEL\' | translate}}</div>\n        </div>\n\n        <div class=traceability-indicator__col>\n            <div class=traceability-indicator__value ng-class=\"{\'traceability-indicator__value--active\': isTraceable}\">\n                {{isTraceable ? (\'YES\' | translate) : (\'NO\' | translate)}}\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/se/weight-choice-selector/weight-choice-selector.directive.html","<div class=weight-choice-selector ng-if=\"weightChoiceSelector.weightChoices.length > 0 && weightChoiceSelector.hasVisibleWeightChoices\">\n    <div class=weight-choice-selector__label>{{\'WEIGHT_CHOICE_SELECTOR_LABEL\' | translate}}:</div>\n\n    <div class=weight-choice-selector__list>\n        <div class=weight-choice-selector__list__item ng-repeat=\"weightChoice in weightChoiceSelector.weightChoices\" ng-class=\"{\'weight-choice-selector__list__item--active\': weightChoice.selected}\" ng-click=weightChoiceSelector.selectWeightChoice(weightChoice)>\n            <span class=weight-choice-selector__list__item__weight>\n                <span class=weight-choice-selector__list__item__weight__value>{{weightChoice.additionalWeight.value}}</span>\n                <span class=weight-choice-selector__list__item__weight__unit>{{weightChoice.additionalWeight.unit}}</span>\n            </span>\n\n            <span class=weight-choice-selector__list__item__price>\n                <span class=weight-choice-selector__list__item__price__value ng-if=!weightChoiceSelector.isCustomerCompany>\n                    ({{(weightChoiceSelector.selectedType.price + weightChoice.price) * (1 + (weightChoice.vat / 10000)) | price}}\n                </span>\n                <span class=weight-choice-selector__list__item__price__value ng-if=weightChoiceSelector.isCustomerCompany>\n                    ({{(weightChoiceSelector.selectedType.price + weightChoice.price) | price}}\n                </span>\n                <span class=weight-choice-selector__list__item__price__unit>kr)</span>\n            </span>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/common/address-email/address-email.directive.html","<div class=address-email>\n    <div class=box>\n        <div class=box__header>\n            <div class=box__header__title>{{ \'EMAIL_ADDRESS\' | translate}}</div>\n        </div>\n        <div class=box__content>\n            <label for=letter_email class=\"form__label form__label--required\">{{ \'EMAIL_ADDRESS\' | translate}}</label>\n            <div class=form__input-group>\n                <input id=letter_email class=form__input type=email ng-model=ctrl.invoiceAddress.email unsupported-email=ctrl.unsupportedEmail ng-pattern=/^\\S+@\\S+\\.\\S+$/ required>\n                <div class=form__input-group__description>{{ \'ADDRESS_EMAIL_DESCRIPTION\' | translate}}</div>\n            </div>\n\n            <div class=form__disclaimer ng-show=ctrl.unsupportedEmail ng-bind-html=\"(\'ADDRESS_PAGE_WARNING_UNSUPPORTED_EMAIL\' | translate:{domain: ctrl.unsupportedEmail}:\'messageformat\')\"></div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/common/invoice-address/invoice-address.directive.html","<div class=invoice-address>\n    <div class=\"box box--margin\">\n        <div class=box__header>\n            <div class=box__header__title>\n                {{ \'PAYMENT_INVOICE_ADDRESS\' | translate}}\n            </div>\n        </div>\n\n        \n        <div class=box__content>\n            <div ng-show=!ctrl.showInvoiceForm class=invoice-address__summary>\n                    <button type=button class=\"btn btn--header btn--header--edit\" ng-click=\"ctrl.showInvoiceForm = true\">\n                    <span>{{ \'COD_CHANGE\' | translate }}</span>\n                    </button>\n    \n                <div class=invoice-address__summary__info>\n                    <div class=invoice-address__summary__info__title ng-if=ctrl.isCustomerCompany>\n                        {{ctrl.invoiceAddress.company.name}}\n                    </div>\n\n                    <div ng-if=ctrl.isCustomerCompany>\n                        {{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}}: {{ctrl.invoiceAddress.company.organizationNumber}}\n                    </div>\n\n                    <div class=invoice-address__summary__info__title ng-if=!ctrl.isCustomerCompany>\n                        {{ctrl.invoiceAddress.name}}\n                    </div>\n\n                    <div>{{ctrl.invoiceAddress.address.street}}</div>\n                    <div>{{ctrl.invoiceAddress.address.zipCode}} {{ctrl.invoiceAddress.address.city}}</div>\n                    <div>{{ctrl.invoiceAddress.email}}</div>\n                </div>\n            </div>\n\n\n\n            <div ng-show=ctrl.showInvoiceForm>\n                <div class=\"form__row form__row--first\" ng-if=ctrl.isCustomerCompany>\n                    <label for=invoiceForm_{{$id}}_companyName class=\"form__label form__label--required\">\n                        {{ \'ADDRESS_PAGE_SENDER_COMPANY_NAME\' | translate}}\n                    </label>\n\n                    <input id=invoiceForm_{{$id}}_companyName name=companyName class=form__input type=text ng-model=ctrl.invoiceAddress.company.name required>\n\n                    <div class=form__row__errors ng-messages=\"ctrl.form.$submitted && ctrl.form.companyName.$error\">\n                        <div ng-message=required>\n                            {{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_COMPANY_NAME\' | translate}}\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=form__row ng-if=ctrl.isCustomerCompany>\n                    <label for=invoiceForm_{{$id}}_organizationNumber class=form__label ng-class=\"{\'form__label--required\': !ctrl.isSE}\">\n                        {{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER\' | translate}}\n                    </label>\n\n                    <input id=invoiceForm_{{$id}}_organizationNumber name=organizationNumber class=form__input type=text ng-model=ctrl.invoiceAddress.company.organizationNumber ng-required=!ctrl.isSE>\n\n                    <div class=form__row__errors ng-messages=\"ctrl.form.$submitted && ctrl.form.organizationNumber.$error\">\n                        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ORGANIZATION_NUMBER\' | translate}}</div>\n                    </div>\n                </div>\n\n\n                <div class=form__row ng-class=\"{\'form__row--first\': !ctrl.isCustomerCompany}\">\n                    <label for=invoiceForm_{{$id}}_name class=form__label>\n                        {{ \'ADDRESS_PAGE_SENDER_NAME\' | translate}}\n                    </label>\n\n                    <input id=invoiceForm_{{$id}}_name class=form__input type=text ng-model=ctrl.invoiceAddress.name>\n                </div>\n\n\n                <div class=form__row>\n                    <label for=invoiceForm_{{$id}}_streetAddress class=form__label--required>\n                        {{ \'ADDRESS_PAGE_SENDER_ADDRESS\' | translate}}\n                    </label>\n\n                    <input id=invoiceForm_{{$id}}_streetAddress name=streetAddress class=form__input type=text ng-model=ctrl.invoiceAddress.address.street required>\n\n                    <div class=form__row__errors ng-messages=\"ctrl.form.$submitted && ctrl.form.streetAddress.$error\">\n                        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ADDRESS\' | translate}}</div>\n                    </div>\n                </div>\n\n\n                <div class=form__row>\n                    <div class=form__row__inline>\n                        <label for=invoiceForm_{{$id}}_zipCode class=\"form__label form__label--required\">\n                            {{ \'ADDRESS_PAGE_SENDER_ZIPCODE\' | translate}}\n                        </label>\n\n                        <input ng-if=\"ctrl.country === \'SE\'\" id=invoiceForm_{{$id}}_zipCode name=zipCode ui-mask=\"999 99\" class=\"form__input form__input--half\" type=text ng-model=ctrl.invoiceAddress.address.zipCode ng-class=\"{\'form__input--invalid\': ctrl.form.city.$error.invalidZipCode}\" required>\n\n                            <input ng-if=\"ctrl.country === \'DK\'\" id=receiverForm_{{$id}}_zipCode name=receiverPostal-code autocomplete=receiverPostal-code ui-mask=9999 class=\"form__input form__input--half\" type=text ng-model=ctrl.invoiceAddress.address.zipCode ng-class=\"{\'form__input--invalid\': receiverForm.form.city.$error.invalidZipCode}\" required>\n\n                        <div class=form__row__errors>\n                            <div ng-messages=\"ctrl.form.$submitted && ctrl.form.zipCode.$error\">\n                                <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ZIPCODE\' | translate}}</div>\n                            </div>\n\n                            <div ng-messages=\"ctrl.form.$submitted && ctrl.form.city.$error\" ng-show=!ctrl.form.zipCode.$error.required>\n                                <div ng-message=invalidZipCode>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_ZIPAREA\' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div class=form__row__inline>\n                        <label for=invoiceForm_{{$id}}_city class=\"form__label form__label--required\">\n                            {{ \'ADDRESS_PAGE_SENDER_ZIPAREA\' | translate}}\n                        </label>\n\n                        <input id=invoiceForm_{{$id}}_city name=city class=\"form__input form__input--half form__input--always-valid\" type=text ng-model=ctrl.invoiceAddress.address.city zipcode-city-autocomplete={{ctrl.invoiceAddress.address.zipCode}} country-code={{ctrl.country}} disabled required readonly>\n                    </div>\n                </div>\n\n\n                <div class=form__row>\n                    <label for=invoiceForm_{{$id}}_email class=\"form__label form__label--required\">\n                        {{ \'EMAIL\' | translate}}\n                    </label>\n\n                    <div class=form__input-group>\n                        <input id=invoiceForm_{{$id}}_email name=email type=email class=form__input ng-model=ctrl.invoiceAddress.email ng-pattern=/^\\S+@\\S+\\.\\S+$/ required>\n                    </div>\n\n                    <div class=form__row__errors ng-messages=\"ctrl.form.$submitted && ctrl.form.email.$error\">\n                        <div ng-message=required>{{ \'ADDRESS_PAGE_ERROR_REQUIRED_SENDER_EMAIL\' | translate}}</div>\n                        <div ng-message=email>{{ \'ADDRESS_PAGE_ERROR_EMAIL_SENDER_EMAIL\' | translate}}</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/common/payment-method/payment-method.directive.html","<div class=payment-method>\n    <div class=\"box box--margin\">\n        <div class=box__header>\n            <div class=box__header__title>\n                    {{ \'PAYMENT_CHOOSE_METHOD\' | translate}}\n            </div>\n        </div>\n\n\n        <div class=\"box__content box__content--no-padding\">\n\n            <!-- <div class=\"payment-method__radio-box\" ng-repeat=\"method in ctrl.paymentMethods\" ng-if=\"method.name && method.iconUrls\" ng-click=\"ctrl.checkMethod(method.paymentMethodId)\">\n                <div>\n                    <input id=\"{{method.paymentMethodId}}\" type=\"radio\" name=\"paymentmethod\" value=\"{{method.paymentMethodId}}\" ng-model=\"ctrl.selectedPaymentMethod\"/>\n                    <label for=\"{{method.paymentMethodId}}\"><div><span></span></div>{{ method.name }}</label>\n                </div>\n                <div class=\"method__card\" ng-class=\"{\'--selected\': ctrl.selectedPaymentMethod === \'CARD\'}\" ng-if=\"method.paymentMethodId === \'CARD\'\">\n                    <img ng-repeat=\"card in method.iconUrls\" src=\"{{card}}\" />\n                </div>\n                <div class=\"method__bank\" ng-class=\"{\'--selected\': ctrl.selectedPaymentMethod === \'DIRECT-BANK\'}\"ng-if=\"method.paymentMethodId === \'DIRECT-BANK\'\">\n                    <img ng-repeat=\"bank in method.iconUrls\" src=\"{{bank}}\" />\n                </div>\n                <div class=\"method__bank\" ng-class=\"{\'--selected\': ctrl.selectedPaymentMethod === \'MOBILE-PAY\'}\" ng-if=\"method.paymentMethodId === \'MOBILE-PAY\'\">\n                    <img ng-repeat=\"bank in method.iconUrls\" src=\"{{bank}}\" />\n                </div>\n                <div class=\"method__bank\" ng-class=\"{\'--selected\': ctrl.selectedPaymentMethod === \'SWISH-ECOMMERCE\'}\" ng-if=\"method.paymentMethodId === \'SWISH-ECOMMERCE\'\">\n                    <img ng-repeat=\"bank in method.iconUrls\" src=\"{{bank}}\" />\n                </div>\n                <div class=\"method__bank\" ng-class=\"{\'--selected\': ctrl.selectedPaymentMethod === \'SWISH-MCOMMERCE\'}\" ng-if=\"method.paymentMethodId === \'SWISH-MCOMMERCE\'\">\n                    <img ng-repeat=\"bank in method.iconUrls\" src=\"{{bank}}\" />\n                </div>\n                <div ng-if=\"method.paymentMethodId === \'SWISH-MCOMMERCE\' && ctrl.selectedPaymentMethod === \'SWISH-MCOMMERCE\'\">\n                    <input type=\"text\" ng-model=\"ctrl.invoiceInfo.telephoneNo\">\n                </div>\n            </div> -->\n\n            <ul class=payment-methods>\n                <li ng-repeat=\"paymentMethod in ctrl.validPaymentMethods\" ng-class=\"{active: ctrl.selectedPaymentMethod === paymentMethod.paymentMethodId}\">\n                    <header ng-click=ctrl.selectMethod(paymentMethod.paymentMethodId)>\n                        <div class=radio>\n                            <input id={{paymentMethod.paymentMethodId}}_ type=radio class=radio-button name=paymentMethod-{{paymentMethod.paymentMethodId}} value={{paymentMethod.paymentMethodId}} ng-model=ctrl.selectedPaymentMethod ng-checked=\"ctrl.selectedPaymentMethod === paymentMethod.paymentMethodId\">\n                        </div>\n                        <label for={{paymentMethod.paymentMethodId}}_>{{paymentMethod.name}}</label>\n\n                        <ul class=icons>\n                            <li ng-repeat=\"icon in paymentMethod.icons\">\n                                <img ng-src={{icon}} height={{paymentMethod.iconHeight}}>\n                            </li>\n                        </ul>\n                    </header>\n                    <main ng-if=\"paymentMethod.paymentMethodId === \'SWISH-ECOMMERCE\' && ctrl.selectedPaymentMethod === paymentMethod.paymentMethodId\">\n                        <div class=form>\n                            <label for=SWISH-EMOMMERCE-PHONE-NUMBER class=\"form__label form__label--required\">{{\'PAYMENT_SWISH_PHONE_NUMBER_LABEL\' | translate}}</label>\n                            <div class=form__input-group>\n                                <input id=SWISH-EMOMMERCE-PHONE-NUMBER name=swishPhoneNumber class=form__input type=tel ng-model=ctrl.invoiceInfo.telephoneNo ng-minlength=8 ng-maxlength=15 ng-pattern=/^(07\\d{8,}|\\+\\d{10,})$/ required>\n                                <p class=form__input-group__description>{{\'PAYMENT_SWISH_PHONE_NUMBER_DESCRIPTION\' | translate}}</p>\n                            </div>\n                            <div class=form__row__errors ng-show=\"ctrl.paymentForm.$submitted && ctrl.paymentForm.swishPhoneNumber.$invalid\">\n                                <div>{{ \'PAYMENT_SWISH_PHONE_NUMBER_VALIDATION\' | translate}}</div>\n                            </div>\n                            <div class=form__row__errors ng-messages=\"ctrl.paymentForm.$submitted && ctrl.paymentForm.swishPhoneNumber.$error\">\n                                <div ng-message=required>{{ \'PAYMENT_SWISH_PHONE_NUMBER_REQUIRED\' | translate}}</div>\n                            </div>\n                        </div>\n                    </main>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/payment/common/sum/sum.directive.html","<div class=payment-sum>\n    <div class=\"payment-sum__row payment-sum__row--first\" ng-if=ctrl.isCustomerCompany>\n        <div class=payment-sum__col>\n            <div class=payment-sum__subrow>\n                <strong>{{\'TOTAL_AMOUNT_EXCL_VAT\' | translate}}</strong>\n            </div>\n            <div class=payment-sum__subrow>\n                {{\'VAT\' | translate}}\n            </div>\n        </div>\n        <div class=\"payment-sum__col payment-sum__col--right\">\n            <div class=payment-sum__subrow>\n                <strong>{{ctrl.totalPriceForParcels | price: true}}</strong> {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n            <div class=payment-sum__subrow>\n                {{(ctrl.totalVatPriceForParcels - ctrl.totalPriceForParcels)  | price: true}} {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n        </div>\n    </div>\n\n    <div class=payment-sum__row ng-class=\"{\'payment-sum__row--first\': !ctrl.isCustomerCompany}\">\n        <div class=payment-sum__col>\n            <div class=\"payment-sum__subrow payment-sum__subrow--large\" ng-if=!ctrl.isCustomerCompany>\n                <strong>{{\'AMOUNT_TO_PAY_INCL_VAT_PRIVATE\' | translate}}</strong>\n            </div>\n            <div class=\"payment-sum__subrow payment-sum__subrow--large\" ng-if=ctrl.isCustomerCompany>\n                <strong>{{\'AMOUNT_TO_PAY_INCL_VAT\' | translate}}</strong>\n            </div>\n            <div class=payment-sum__subrow ng-if=!ctrl.isCustomerCompany>\n                {{\'PRIVATE_VAT\' | translate}}\n            </div>\n        </div>\n        <div class=\"payment-sum__col payment-sum__col--right\">\n            <div class=\"payment-sum__subrow payment-sum__subrow--large\">\n                <strong>{{ctrl.totalVatPriceForParcels | price: true}}</strong> {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n            <div class=payment-sum__subrow ng-if=!ctrl.isCustomerCompany>\n                {{(ctrl.totalVatPriceForParcels - ctrl.totalPriceForParcels) | price:true}} {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n        </div>\n    </div>\n</div>\n<div class=sticky-sum ng-if=ctrl.sumSticky ng-style=\"{\'top\': ctrl.stickySumYposition+\'px\'}\" ng-click=ctrl.scrollToCart()>\n        <span ng-if=ctrl.isCustomerCompany>\n            {{\'AMOUNT_TO_PAY_INCL_VAT\' | translate}}\n        </span>\n        <span ng-if=!ctrl.isCustomerCompany>\n            {{\'AMOUNT_TO_PAY_INCL_VAT_PRIVATE\' | translate}}\n        </span>\n        <span class=sticky-sum__price>\n            {{ctrl.totalVatPriceForParcels | price: true}} {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n        </span>\n</div>\n");
$templateCache.put("components/payment/common/terms/terms.directive.html","<div class=\"box box--margin\">\n  <div class=box__header>\n    <div class=box__header__title>\n      {{ \'PAYMENT_TERMS_CONDITIONS\' | translate}}\n    </div>\n  </div>\n\n  <div class=\"box__content box__content--no-padding\">\n    <div class=payment__agreement>\n      <input id=checkbox_agreement name=agreement ng-model=ctrl.agreement type=checkbox required>\n      <label class=payment__agreement__checkbox-label for=checkbox_agreement></label>\n\n      <div class=payment__agreement__label ng-if=\"ctrl.receivercountry === \'SE\'\">\n        <label for=checkbox_agreement>\n          {{\'PAYMENT_APPROVE_TERMS\' | translate}}\n          <a ng-click=ctrl.showTerms(ctrl.cart)>{{\'PAYMENT_APPROVE_TERMS_TERMS\' | translate}}</a>,\n          <a href=https://www.postnord.se/skicka-forsandelser/priser-och-villkor target=_blank>\n            {{\'PAYMENT_APPROVE_PURCHASETERMS\' | translate}}\n          </a>\n          {{\'AND\' | translate}}\n          <a href=https://www.postnord.se/skicka-forsandelser/priser-och-villkor target=_blank>\n            {{\'PAYMENT_APPROVE_GENERALTERMS\' | translate}}.\n          </a>\n        </label>\n      </div>\n\n      <div class=payment__agreement__label ng-if=\"ctrl.receivercountry === \'DK\'\">\n        <label for=checkbox_agreement ng-bind-html=\"\'PAYMENT_APPROVE_TERMS\' | translate\"></label>\n      </div>\n\n      <div class=payment__agreement__error ng-show=\"ctrl.form.$submitted && ctrl.form.agreement.$invalid\">\n        {{ \'PAYMENT_PAGE_ERROR_MISSING_AGREEMENT\' | translate }}\n      </div>\n    </div>\n\n    <div class=payment__agreement ng-if=\"ctrl.fromCountry !== \'DK\'\">\n      <!-- <input id=\"checkbox_offers\" name=\"offers\" ng-model=\"ctrl.wantsOffers\" ng-change=\"ctrl.wantsOffersToggle()\" type=\"checkbox\" /> -->\n      <!-- <label class=\"payment__agreement__checkbox-label payment__agreement__checkbox-label--auto-align\" for=\"checkbox_offers\"></label> -->\n      <div class=payment__agreement__label>\n        <label for=checkbox_offers ng-bind-html=\"\'PERSONAL_OFFERS\' | translate \"></label>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("components/payment/dk/letter-code-settings/letter-code-settings.html","<div class=box class=letter-code-settings>\n    <div class=box__header>\n        <div class=box__header__title>{{\'DK_LETTER_CODE_SETTINGS_TITLE\' | translate}}</div>\n    </div>\n\n    <div class=\"box__content letter-code-settings__content\">\n        <div class=letter-code-settings__layout-selector>\n            <label class=letter-code-settings__layout-selector__option>\n                <input type=radio class=letter-code-settings__layout-selector__option__radio-button value=standard ng-model=ctrl.layout>\n                <div class=letter-code-settings__layout-selector__option__title>\n                    {{\'DK_LETTER_CODE_SETTINGS_OPTION_STANDARD_TITLE\' | translate}}</div>\n                <div class=letter-code-settings__layout-selector__option__description>\n                    {{\'DK_LETTER_CODE_SETTINGS_OPTION_STANDARD_DESCRIPTION\' | translate}}</div>\n                <div class=\"letter-code-settings__layout-selector__option__illustration letter-code-settings__layout-selector__option__illustration--standard\">\n                </div>\n            </label>\n\n            <label class=letter-code-settings__layout-selector__option>\n                <input type=radio class=letter-code-settings__layout-selector__option__radio-button value=image ng-model=ctrl.layout>\n                <div class=letter-code-settings__layout-selector__option__title>\n                    {{\'DK_LETTER_CODE_SETTINGS_OPTION_IMAGE_TITLE\' | translate}}</div>\n                <div class=letter-code-settings__layout-selector__option__description>\n                    {{\'DK_LETTER_CODE_SETTINGS_OPTION_IMAGE_DESCRIPTION\' | translate}}</div>\n                <div class=\"letter-code-settings__layout-selector__option__illustration letter-code-settings__layout-selector__option__illustration--image\">\n                </div>\n            </label>\n        </div>\n\n        <div class=letter-code-settings__image-selector ng-show=\"ctrl.layout === \'image\'\">\n            <ng-form name=ctrl.portoCodeImageUpload>\n                <div class=letter-code-settings__image-selector__title>\n                    {{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_TITLE\' | translate}}</div>\n\n                <div class=letter-code-settings__image-selector__row>\n                    <div class=letter-code-settings__image-selector__preview-wrapper>\n                        <div class=letter-code-settings__image-selector__preview>\n                            <div class=letter-code-settings__image-selector__preview__image-wrapper ng-class=\"{\n                                    \'letter-code-settings__image-selector__preview__image-wrapper--loading\': ctrl.isLoading,\n                                    \'letter-code-settings__image-selector__preview__image-wrapper--has-image\': ctrl.imageUrl\n                                }\">\n                                <div class=letter-code-settings__image-selector__preview__image-wrapper__loading-indicator ng-show=ctrl.isLoading>\n                                    <div class=letter-code-settings__image-selector__preview__image-wrapper__loading-indicator__spinner>\n                                    </div>\n                                </div>\n                                <img ng-src={{ctrl.imageUrl}} class=letter-code-settings__image-selector__preview__image ng-if=ctrl.imageUrl>\n                            </div>\n                        </div>\n\n                        <div class=letter-code-settings__image-selector__preview-caption>\n                            <span ng-if=ctrl.imageUrl>{{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_CAPTION_CUSTOM\' | translate}}</span>\n                            <span ng-if=!ctrl.imageUrl>{{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_CAPTION_DEFAULT\' | translate}}</span>\n                        </div>\n                    </div>\n\n                    <div class=letter-code-settings__image-selector__description>\n                        {{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_DESCRIPTION\' | translate}}\n                    </div>\n                </div>\n\n                <div class=letter-code-settings__image-selector__errors ng-if=ctrl.portoCodeImageUpload.file.$error.maxSize>\n                    {{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_ERROR_MAX_SIZE\' | translate}}\n                </div>\n\n                <div class=letter-code-settings__image-selector__actions>\n                    <button type=button name=file class=\"btn btn--blue letter-code-settings__image-selector__actions__btn\" ngf-select=ctrl.uploadImage($file) ngf-multiple=false ngf-pattern=\"\'image/jpeg,image/png,image/gif\'\" ngf-max-size=5MB ng-model=ctrl.imageData accept=\"image/jpeg, image/png, image/gif\">\n                        {{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_ACTION_UPLOAD\' | translate}}\n                    </button>\n\n                    <button type=button class=\"btn letter-code-settings__image-selector__actions__btn letter-code-settings__image-selector__actions__btn--outlined\" ng-click=ctrl.reset()>\n                        {{\'DK_LETTER_CODE_SETTINGS_IMAGE_SELECTOR_ACTION_RESET\' | translate}}\n                    </button>\n                </div>\n            </ng-form>\n        </div>\n    </div>\n</div>");
$templateCache.put("components/receipt/common/sum/sum.directive.html","<div class=receipt-sum>\n    <div class=\"receipt-sum__row receipt-sum__row--first\" ng-if=ctrl.isCustomerCompany>\n        <div class=receipt-sum__col>\n            <div class=receipt-sum__subrow>\n                <strong>{{\'TOTAL_AMOUNT_EXCL_VAT\' | translate}}</strong>\n            </div>\n            <div class=receipt-sum__subrow>\n                {{\'VAT\' | translate}}\n            </div>\n        </div>\n        <div class=\"receipt-sum__col receipt-sum__col--right\">\n            <div class=receipt-sum__subrow>\n                <strong>{{ctrl.totalPriceForParcels | price: true}}</strong> {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n            <div class=receipt-sum__subrow>\n                {{(ctrl.totalVatPriceForParcels - ctrl.totalPriceForParcels)  | price: true}} {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n            </div>\n        </div>\n    </div>\n\n    <div class=receipt-sum__row ng-class=\"{\'receipt-sum__row--first\': !ctrl.isCustomerCompany}\">\n        <div class=receipt-sum__col>\n            <div class=\"receipt-sum__subrow receipt-sum__subrow--large\">\n                <strong>{{\'TOTAL_AMOUNT_PAYED\' | translate}}</strong>\n            </div>\n            <div class=receipt-sum__subrow ng-if=!ctrl.isCustomerCompany>\n                {{\'PRIVATE_VAT\' | translate}}\n            </div>\n        </div>\n        <div class=\"receipt-sum__col receipt-sum__col--right\">\n                <div class=\"receipt-sum__subrow receipt-sum__subrow--large\">\n                    <strong>{{ctrl.totalVatPriceForParcels | price: true}}</strong> {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n                </div>\n                <div class=receipt-sum__subrow ng-if=!ctrl.isCustomerCompany>\n                    {{(ctrl.totalVatPriceForParcels - ctrl.totalPriceForParcels) | price:true}} {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n                </div>\n            </div>\n    </div>\n</div>\n");
$templateCache.put("components/shared/common/product-table/delete-error.dialog.html","<md-dialog class=delete-error-dialog aria-label=\"Delete error\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3>{{\'PAYMENT_DIALOG_DELETE_ERROR_HEADER\' | translate}}</h3>\n            <p>{{\'PAYMENT_DIALOG_DELETE_ERROR_TEXT\' | translate}}</p>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=column>\n        <md-button class=md-confirm-button ng-click=confirm()>\n            {{\'PAYMENT_DIALOG_DELETE_ERROR_EMPTY_CART\' | translate}}\n        </md-button>\n        <a ng-click=cancel()>{{\'BUTTON_CANCEL_EDIT\' | translate}}</a>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/shared/common/product-table/delete.dialog.html","<md-dialog aria-label=\"Confirm Delete\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3 ng-if=\"country === \'SE\'\">{{ \'PAYMENT_DIALOG_HEADER_SE\' | translate}}</h3>\n            <h3 ng-if=\"country === \'DK\'\">{{ \'PAYMENT_DIALOG_HEADER_DK\' | translate}}</h3>\n            <span style=\"color: #5e554a\">{{ \'PAYMENT_DIALOG_SUBHEADER\' | translate}}</span>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=row>\n        <md-button class=md-confirm-button ng-click=confirm()>\n            {{ \'PAYMENT_DIALOG_CONFIRM\' | translate}}\n        </md-button>\n        <md-button class=md-cancel-button ng-click=cancel()>\n            {{ \'PAYMENT_DIALOG_CANCEL\' | translate}}\n        </md-button>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/shared/common/product-table/update-error.dialog.html","<md-dialog class=delete-error-dialog aria-label=\"Delete error\">\n    <md-dialog-content>\n        <div class=md-dialog-content>\n            <h3>{{\'PAYMENT_DIALOG_DELETE_ERROR_HEADER\' | translate}}</h3>\n            <p>{{\'PAYMENT_DIALOG_UPDATE_ERROR_TEXT\' | translate}}</p>\n        </div>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=column>\n        <md-button class=md-confirm-button ng-click=confirm()>\n            {{\'PAYMENT_DIALOG_DELETE_ERROR_EMPTY_CART\' | translate}}\n        </md-button>\n        <a ng-click=cancel()>{{\'BUTTON_CANCEL_EDIT\' | translate}}</a>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("components/shared/dk/change-receiver-modal/change-receiver-modal.html","<md-dialog class=change-receiver-modal>\n        <div class=change-receiver-modal__header>\n            <h3>{{\'CHANGE_RECEIVER\' | translate}}</h3>\n            <span>{{\'CHANGE_FOR\' | translate}} {{ctrl.parcel.name}} <strong>({{ctrl.getVatPriceForParcel(ctrl.parcel)| price }}{{ctrl.parcel.priceUnit | prettifyCurrency}})</strong></span>\n        </div>\n        <div class=change-receiver-modal__content>\n            <receiver-form receiver=ctrl.receiver country=ctrl.country form=ctrl.receiverForm is-submitted=false parcel=ctrl.parcel>\n            </receiver-form>\n        </div>\n\n    <div class=change-receiver-modal__buttons layout=row>\n        <button class=\"btn btn--not-filled\" ng-click=cancel()>\n                {{ \'BUTTON_CANCEL_EDIT\' | translate}}\n        </button>\n        <button class=\"btn btn--blue\" ng-click=confirm() type=submit>\n            {{ \'BUTTON_SAVE_EDIT\' | translate}}\n        </button>\n    </div>\n</md-dialog>\n    ");
$templateCache.put("components/shared/dk/change-sender-modal/change-sender-modal.html","<md-dialog class=change-sender-modal>\n        <div class=change-sender-modal__header>\n            <h3>{{\'CHANGE_SENDER\' | translate}}</h3>\n            <span>{{\'CHANGE_FOR\' | translate}} {{ctrl.product.name}} <strong>({{ctrl.getVatPriceForParcel(ctrl.product)| price }}{{ctrl.product.priceUnit | prettifyCurrency}})</strong></span>\n        </div>\n        <div class=change-sender-modal__content>\n            <sender-form sender=ctrl.sender country={{ctrl.country}} form=ctrl.senderForm name=single is-submitted=false product=ctrl.product>\n            </sender-form>\n        </div>\n\n    <div class=change-sender-modal__buttons layout=row>\n        <button class=\"btn btn--not-filled\" ng-click=cancel()>\n                {{ \'BUTTON_CANCEL_EDIT\' | translate}}\n        </button>\n        <button class=\"btn btn--blue\" ng-click=confirm() type=submit>\n            {{ \'BUTTON_SAVE_EDIT\' | translate}}\n        </button>\n    </div>\n</md-dialog>\n    ");
$templateCache.put("components/shared/dk/product-table/product-table.directive.html","<product-table-letters ng-if=\"productTable.letters.length > 0\" letters=productTable.letters is-submitting=productTable.isSubmitting is-customer-company=productTable.isCustomerCompany is-receipt=productTable.isReceipt confirm-delete=productTable.confirmDelete show-error-dialog=productTable.showErrorDialog></product-table-letters>\n\n<table class=product-table ng-show=\"productTable.packages.length > 0\" ng-class=\"{\'product-table--receipt\': productTable.isReceipt}\">\n\n    <tr class=product-table__header>\n        <th></th>\n        <th>{{ \'PRODUCT\' | translate}}</th>\n        <th class=hidden-xs>{{ \'SENDER\' | translate}}</th>\n        <th class=hidden-xs>{{ \'RECEIVER\' | translate}}</th>\n        <th>{{ \'PRICE\' | translate}}</th>\n        <th></th>\n    </tr>\n    <tbody ng-repeat=\"product in productTable.packages\">\n\n        <tr class=product-table__label>\n            <td></td>\n\n\n            <td class=product-table__bold>\n                <div class=product-table__title>\n                    {{product.name}} - {{product.selectedWeight.value}}{{product.selectedWeight.unit}}\n\n                    <span ng-repeat=\"stars in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | filter: { type: \'!valuableTypeInsurance\' } | onlyVisibleGroupings\">*</span>\n\n                    <span ng-repeat=\"deliveryOption in product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings\" class=product-table__title__delivery-option-icon ng-style=\"{\'background-image\': \'url(\' + (deliveryOption.iconUrl | imagePath) + \')\'}\" ng-if=deliveryOption.iconUrl>\n                    </span>\n                    \n                    <span class=\"visible-xs product-table__title__recipient\" ng-if=!product.expand>{{\'TO\' | translate}}: {{product.receiver.name || product.receiver.company }}</span>\n                    <div class=\"visible-xs product-table__title__delivery\">\n                        <span class=product-table__title__delivery-time ng-if=!product.expand ng-repeat=\"deliveryOption in (deliveryOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings))\">\n                                {{deliveryOption.shortName}}\n                        </span>\n                        <span class=product-table__title__separator>, </span>\n                        <span class=product-table__title__delivery-point ng-if=!product.expand ng-repeat=\"deliveryPointOption in (deliveryPointOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryPointOption\' } | onlyVisibleGroupings))\">\n                                {{deliveryPointOption.shortName}}\n                        </span>\n                    </div>\n                </div>\n\n                <div ng-show=product.expand class=product-table__subrow>\n                    <div ng-repeat=\"deliveryOption in (deliveryOptions = (product.additionalServices | filter: { included: \'!true\', selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings))\">\n                        <span>{{deliveryOption.shortName}}</span>\n                    </div>\n                    <div ng-repeat=\"included in product.additionalServices | filter: { included: true, selected: true } | onlyVisibleGroupings\">\n                        <span>{{included.shortName}}</span>\n                    </div>\n                    <div ng-repeat=\"service in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | filter: {type: \'!valuableTypeInsurance\'} | onlyVisibleGroupings\">\n                        <span>*</span>\n                        <span>{{service.shortName || service.name}}</span>\n                    </div>\n                    <div ng-repeat=\"service in product.additionalServices | filter: { selected: true, type: \'valuableTypeInsurance\' } | onlyVisibleGroupings\" ng-if=\"productTable.country === \'DK\'\">\n                        <span>{{ \'SIDEBAR_PARCEL_INSURED\' | translate}} {{service.parcelValue | number}} DKK</span>\n                    </div>\n                </div>\n            </td>\n\n\n            <td class=hidden-xs>\n                <div class=product-table__title>\n                    {{productTable.isCustomerCompany ? product.sender.company.name : product.sender.name}}\n                </div>\n\n                <product-table-sender ng-show=product.expand sender=product.sender is-customer-company=productTable.isCustomerCompany>\n                </product-table-sender>\n            </td>\n\n\n            <td class=hidden-xs>\n                <div class=product-table__title>\n                    {{product.receiver.name || product.receiver.company}}\n                </div>\n\n                <product-table-receiver ng-show=product.expand product=product country=productTable.country>\n                </product-table-receiver>\n            </td>\n\n\n            <td>\n                <div class=product-table__price>\n                    {{(productTable.isCustomerCompany ? productTable.getPriceForParcel(product) : productTable.getVatPriceForParcel(product)) | price}}\n                    <small>{{product.priceUnit | prettifyCurrency}}</small>\n                </div>\n            </td>\n\n\n            <td>\n                <button type=button ng-click=\"product.expand = !product.expand\" class=product-table__action ng-class=\"{\'product-table__action--collapse\': product.expand, \'product-table__action--expand\': !product.expand}\">\n                </button>\n            </td>\n        </tr>\n\n\n        <!-- <tr class=\"no-border-top actions visible-xs\" ng-show=\"!productTable.isReceipt && product.expand\">\n            <td></td>\n            <td class=\"product-table__customs\" colspan=\"3\">\n                <button type=\"button\" class=\"btn\" ng-click=\"productTable.editProduct(product, \'main.landing\')\">{{ \'CHANGE_PRODUKT\' | translate}}</button>\n            </td>\n        </tr> -->\n\n        <tr ng-show=product.expand class=\"visible-xs visible-xs--table-row no-border-top\">\n            <td class=no-padding-top></td>\n\n            <td colspan=3 class=no-padding-top>\n                <div>\n                    <div class=mobile-table>\n                        <div class=mobile-table__header>{{ \'SENDER\' | translate}}</div>\n                        <div>{{productTable.isCustomerCompany ? product.sender.company.name : product.sender.name}}</div>\n\n                        <product-table-sender sender=product.sender is-customer-company=productTable.isCustomerCompany>\n                        </product-table-sender>\n\n                        <button type=button ng-show=!productTable.isReceipt class=\"btn mobile-table__button visible-xs\" ng-click=productTable.changeSender(product)>\n                            {{ \'COD_CHANGE\' | translate}}\n                        </button>\n                    </div>\n                    <div class=\"mobile-table mobile-receiver\">\n                        <div class=mobile-table__header>{{ \'RECEIVER\' | translate}}</div>\n                        <div>{{product.receiver.company || product.receiver.name}}</div>\n\n                        <product-table-receiver product=product country=productTable.country>\n                        </product-table-receiver>\n                        <button type=button ng-show=!productTable.isReceipt class=\"btn mobile-table__button visible-xs\" ng-click=productTable.changeReceiver(product)>\n                            {{ \'COD_CHANGE\' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </td>\n        </tr>\n\n\n        <tr class=\"no-border-top actions\" ng-show=\"!productTable.isReceipt && product.expand\" ng-if=product.customsInformation>\n            <td></td>\n            <td class=product-table__customs colspan=3>\n                <button type=button class=\"btn customs\" ng-click=\"productTable.editProduct(product, productTable.customsState)\">{{ \'CHANGE_CUSTOMS_DECLARATION\' | translate }}</button>\n            </td>\n        </tr>\n\n\n        <!-- <tr class=\"no-border-top actions\" ng-show=\"!productTable.isReceipt && product.expand\">\n            <td></td>\n\n            <td colspan=\"3\">\n                <button type=\"button\" class=\"btn hidden-xs\" ng-click=\"productTable.editProduct(product, \'main.landing\')\">{{ \'CHANGE_PRODUKT\' | translate}}</button>\n                <button type=\"button\" class=\"btn\" ng-click=\"productTable.editProduct(product, \'main.address\')\">{{ \'CHANGE_SENDER-RECEIVER\' | translate}}</button>\n                <button type=\"button\" class=\"btn remove\" ng-click=\"productTable.confirmDelete($event, product)\">{{ \'REMOVE_PRODUCT\' | translate}}</button>\n            </td>\n\n            <td ></td>\n        </tr> -->\n\n        <tr class=\"no-border-top actions\" ng-show=\"!productTable.isReceipt && product.expand\">\n                <td></td>\n    \n                <td colspan=3 class=actions__buttons>\n                    <pn-icon class=\"visible-xs actions__buttons__icon\" symbol=rotate color=blue700 size=medium solid></pn-icon>\n                    <button type=button class=\"btn actions__buttons__change\" id=btn-change-product ng-click=\"productTable.editProduct(product, \'main.landing\')\">{{ \'CHANGE_PRODUKT\' | translate}}</button>\n                    <div class=\"actions__buttons__break visible-xs\"></div>\n                    <button type=button class=\"btn hidden-xs\" id=btn-change-sender-receiver ng-click=\"productTable.editProduct(product, \'main.address\')\">{{ \'CHANGE_SENDER-RECEIVER\' | translate}}</button>\n                    <pn-icon class=\"visible-xs actions__buttons__icon\" symbol=trash-can color=blue700 size=medium solid></pn-icon>\n                    <button type=button class=\"btn remove actions__buttons__remove\" ng-click=\"productTable.confirmDelete($event, product)\">{{ \'REMOVE_PRODUCT\' | translate}}</button>\n                </td>\n    \n                <td></td>\n            </tr>\n\n        <tr ng-show=\"productTable.isReceipt && product.expand\" class=\"no-border-top hidden-xs\">\n            <td class=no-padding-top></td>\n            <td class=no-padding-top colspan=5>\n                <strong>{{ \'RECEIPT_SHIPMENT_ID\' | translate}}:</strong>\n                <a href=https://portal.postnord.com/tracking/details/{{product.consignmentNumber}} target=_blank>{{product.consignmentNumber}}</a>\n            </td>\n        </tr>\n    </tbody>\n</table>\n");
$templateCache.put("components/shared/se/change-receiver-modal/change-receiver-modal.html","<md-dialog class=change-receiver-modal>\n        <div class=change-receiver-modal__header>\n            <h3>{{\'CHANGE_RECEIVER\' | translate}}</h3>\n            <span>{{\'CHANGE_FOR\' | translate}} {{ctrl.parcel.name}} <strong>({{ctrl.getVatPriceForParcel(ctrl.parcel)| price }}{{ctrl.parcel.priceUnit | prettifyCurrency}})</strong></span>\n        </div>\n        <div class=change-receiver-modal__content>\n            <receiver-form receiver=ctrl.receiver country=ctrl.country form=ctrl.receiverForm is-submitted=false parcel=ctrl.parcel>\n            </receiver-form>\n        </div>\n\n    <div class=change-receiver-modal__buttons layout=row>\n        <button class=\"btn btn--not-filled\" ng-click=cancel()>\n                {{ \'BUTTON_CANCEL_EDIT\' | translate}}\n        </button>\n        <button class=\"btn btn--blue\" ng-click=confirm() type=submit>\n            {{ \'BUTTON_SAVE_EDIT\' | translate}}\n        </button>\n    </div>\n</md-dialog>\n    ");
$templateCache.put("components/shared/se/change-sender-modal/change-sender-modal.html","<md-dialog class=change-sender-modal>\n        <div class=change-sender-modal__header>\n            <h3>{{\'CHANGE_SENDER\' | translate}}</h3>\n            <span>{{\'CHANGE_FOR\' | translate}} {{ctrl.product.name}} <strong>({{ctrl.getVatPriceForParcel(ctrl.product)| price }}{{ctrl.product.priceUnit | prettifyCurrency}})</strong></span>\n        </div>\n        <div class=change-sender-modal__content>\n            <sender-form sender=ctrl.sender country={{ctrl.country}} form=ctrl.senderForm name=single is-submitted=false product=ctrl.product>\n            </sender-form>\n        </div>\n\n    <div class=change-sender-modal__buttons layout=row>\n        <button class=\"btn btn--not-filled\" ng-click=cancel()>\n                {{ \'BUTTON_CANCEL_EDIT\' | translate}}\n        </button>\n        <button class=\"btn btn--blue\" ng-click=confirm() type=submit>\n            {{ \'BUTTON_SAVE_EDIT\' | translate}}\n        </button>\n    </div>\n</md-dialog>\n    ");
$templateCache.put("components/shared/se/product-table/product-table.directive.html","<product-table-letters ng-if=\"ctrl.letters.length > 0\" letters=ctrl.letters is-submitting=ctrl.isSubmitting is-customer-company=ctrl.isCustomerCompany is-receipt=ctrl.isReceipt confirm-delete=ctrl.confirmDelete show-error-dialog=ctrl.showErrorDialog></product-table-letters>\n\n<table class=product-table ng-show=\"ctrl.packages.length > 0\" ng-class=\"{\'product-table--receipt\': ctrl.isReceipt}\">\n    <tr class=product-table__header>\n        <th></th>\n        <th>{{ \'PRODUCT\' | translate}}</th>\n        <th class=hidden-xs>{{ \'SENDER\' | translate}}</th>\n        <th class=hidden-xs>{{ \'RECEIVER\' | translate}}</th>\n        <th>{{ \'PRICE\' | translate}}</th>\n        <th></th>\n        <th class=visible-xs></th>\n    </tr>\n\n    <tbody ng-repeat=\"product in ctrl.packages\">\n        <tr class=product-table__label>\n            <td></td>\n\n            <td class=product-table__bold>\n                <div class=product-table__title>\n                    {{product.name}}\n\n                    <span ng-repeat=\"stars in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | onlyVisibleGroupings\">\n                        *\n                    </span>\n\n                    <span ng-repeat=\"deliveryOption in product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings\" class=product-table__title__delivery-option-icon ng-style=\"{\'background-image\': \'url(\' + (deliveryOption.iconUrl | imagePath) + \')\'}\" ng-if=deliveryOption.iconUrl>\n                    </span>\n                    <span class=\"visible-xs product-table__title__recipient\" ng-if=!product.expand>{{\'TO\' | translate}}: {{product.receiver.company || product.receiver.name}}</span>\n                    <div class=\"visible-xs product-table__title__delivery\">\n                        <span class=product-table__title__delivery-time ng-if=!product.expand ng-repeat=\"deliveryOption in (deliveryOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings))\">\n                                {{deliveryOption.shortName}}\n                        </span>\n                        <span class=product-table__title__separator>, </span>\n                        <span class=product-table__title__delivery-point ng-if=!product.expand ng-repeat=\"deliveryPointOption in (deliveryPointOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryPointOption\' } | onlyVisibleGroupings))\">\n                                {{deliveryPointOption.shortName}}\n                        </span>\n                    </div>\n                </div>\n\n                <div ng-show=product.expand class=product-table__subrow>\n                    <div ng-repeat=\"deliveryOption in (deliveryOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings))\" class=product-table__subrow__delivery-option>\n                        <span>{{deliveryOption.shortName}}</span>\n                    </div>\n                    <div ng-repeat=\"included in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: true } | onlyVisibleGroupings\">\n                        <span>{{included.shortName}}</span>\n                    </div>\n                    <div ng-repeat=\"service in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | onlyVisibleGroupings\">\n                        <span>*</span>\n                        <span>{{service.shortName || service.name}}</span>\n                    </div>\n                </div>\n            </td>\n\n\n            <td class=hidden-xs>\n                <div class=product-table__title>\n                    {{ctrl.isCustomerCompany ? product.sender.company.name : product.sender.name}}\n                </div>\n\n                <product-table-sender ng-show=product.expand sender=product.sender is-customer-company=ctrl.isCustomerCompany>\n                </product-table-sender>\n            </td>\n\n\n            <td class=hidden-xs>\n                <div class=product-table__title>\n                    {{product.receiver.name || product.receiver.company}}\n                </div>\n\n                <product-table-receiver ng-show=product.expand product=product country=ctrl.country>\n                </product-table-receiver>\n            </td>\n\n\n            <td>\n                <div class=product-table__price>\n                    {{(ctrl.isCustomerCompany ? ctrl.getPriceForParcel(product) : ctrl.getVatPriceForParcel(product)) | price}}\n                    <small>{{product.priceUnit | prettifyCurrency}}</small>\n                </div>\n            </td>\n\n\n            <td>\n                <button type=button ng-click=\"product.expand = !product.expand\" class=product-table__action ng-class=\"{\'product-table__action--collapse\': product.expand, \'product-table__action--expand\': !product.expand}\">\n                </button>\n            </td>\n            <td class=visible-xs></td>\n        </tr>\n\n\n        <tr ng-show=product.expand class=\"mobile-row visible-xs visible-xs--table-row no-border-top\">\n            <td class=no-padding-top></td>\n\n            <td colspan=3 class=no-padding-top>\n                <div>\n                    <div class=mobile-table>\n                        <div class=mobile-table__header>{{ \'SENDER\' | translate}}</div>\n                        <div>{{ctrl.isCustomerCompany ? product.sender.company.name : product.sender.name}}</div>\n\n                        <product-table-sender sender=product.sender is-customer-company=ctrl.isCustomerCompany>\n                        </product-table-sender>\n                        <button type=button ng-show=!ctrl.isReceipt class=\"btn mobile-table__button visible-xs\" ng-click=ctrl.changeSender(product)>\n                            {{ \'COD_CHANGE\' | translate}}\n                        </button>\n                    </div>\n                    <div class=\"mobile-table mobile-receiver\">\n                        <div class=mobile-table__header>{{ \'RECEIVER\' | translate}}</div>\n                        <div>{{product.receiver.company || product.receiver.name}}</div>\n\n                        <product-table-receiver product=product country=ctrl.country>\n                        </product-table-receiver>\n                        <button type=button ng-show=!ctrl.isReceipt class=\"btn mobile-table__button visible-xs\" ng-click=ctrl.changeReceiver(product)>\n                            {{ \'COD_CHANGE\' | translate}}\n                        </button>\n                    </div>\n\n                    <div ng-if=ctrl.isReceipt>\n                        <strong>{{ \'RECEIPT_SHIPMENT_ID\' | translate}}:</strong>\n                        <a href=https://portal.postnord.com/tracking/details/{{product.consignmentNumber}} target=_blank>{{product.consignmentNumber}}</a>\n                    </div>\n                </div>\n            </td>\n        </tr>\n\n\n        <tr class=\"no-border-top actions\" ng-show=\"!ctrl.isReceipt && product.expand\" ng-if=product.customsInformation>\n            <td></td>\n            <td class=product-table__customs colspan=3>\n                <button type=button class=\"btn customs\" ng-click=\"ctrl.editProduct(product, \'main.customsNew\')\">{{ \'CHANGE_CUSTOMS_DECLARATION\' | translate }}</button>\n            </td>\n        </tr>\n\n\n        <tr class=\"no-border-top actions\" ng-show=\"!ctrl.isReceipt && product.expand\">\n            <td></td>\n\n            <td colspan=3 class=actions__buttons>\n                <pn-icon class=\"visible-xs actions__buttons__icon\" symbol=rotate color=blue700 size=medium solid></pn-icon>\n                <button type=button class=\"btn actions__buttons__change\" id=btn-change-product ng-click=\"ctrl.editProduct(product, \'main.landing\')\">{{ \'CHANGE_PRODUKT\' | translate}}</button>\n                <div class=\"actions__buttons__break visible-xs\"></div>\n                <button type=button class=\"btn hidden-xs\" id=btn-change-sender-receiver ng-click=\"ctrl.editProduct(product, \'main.address\')\">{{ \'CHANGE_SENDER-RECEIVER\' | translate}}</button>\n                <pn-icon class=\"visible-xs actions__buttons__icon\" symbol=trash-can color=blue700 size=medium solid></pn-icon>\n                <button type=button class=\"btn remove actions__buttons__remove\" ng-click=\"ctrl.confirmDelete($event, product)\">{{ \'REMOVE_PRODUCT\' | translate}}</button>\n            </td>\n\n            <td></td>\n        </tr>\n\n        <tr ng-show=\"ctrl.isReceipt && product.expand\" class=\"no-border-top hidden-xs\">\n            <td class=no-padding-top></td>\n            <td class=no-padding-top colspan=5>\n                <strong>{{ \'RECEIPT_SHIPMENT_ID\' | translate}}:</strong>\n                <a href=https://portal.postnord.com/tracking/details/{{product.consignmentNumber}} target=_blank>{{product.consignmentNumber}}</a>\n            </td>\n        </tr>\n    </tbody>\n</table>\n");
$templateCache.put("components/sidebar/common/address-selected-product/address-selected-product.directive.html","<div class=\"box sidebar__box sidebar__selected-product\">\n    <header>\n        <h2>{{ \'SIDEBAR_PARCEL_TITLE\' | translate}}</h2>\n        <button class=\"icon edit\" ng-if=selectedProduct.editParcelCallback ng-click=selectedProduct.editParcel(selectedProduct.product)></button>\n    </header>\n\n    <div class=\"box__content box__content--no-padding\">\n        <ul class=sidebar__selected-product__list>\n            <li class=\"sidebar__selected-product__list__item sidebar__selected-product__product\">\n                <div class=sidebar__selected-product__product__header>\n                    <div class=sidebar__selected-product__product__header__col>\n                        <div class=sidebar__selected-product__product__name>\n                            {{selectedProduct.product.name}}\n                            <span ng-if=\"selectedProduct.country === \'DK\'\">&ndash; {{selectedProduct.product.selectedWeight.value}} {{selectedProduct.product.selectedWeight.unit}}</span>\n                            <span ng-if=\"selectedProduct.country === \'DK\'\" ng-repeat=\"star in selectedProduct.product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | filter: {type: \'!valuableType\'} | onlyVisibleGroupings\">\n                                *\n                            </span>\n\n                        </div>\n\n                        <div class=sidebar__selected-product__product__flag ng-if=\"selectedProduct.product.receiverCountryCode !== selectedProduct.country\">\n                            <img ng-src=\"{{selectedProduct.product.toCountry.countryCode | flagPath}}\" width=21px height=15px>\n                            {{ \'TO\' | translate}} {{selectedProduct.product.receiverCountry}}\n                        </div>\n\n                        <!-- <div class=\"sidebar__selected-product__product__delivery-option\"\n                            ng-repeat=\"deliveryOption in deliveryOptions = (selectedProduct.product.additionalServices | filter: { selected: true, type: \'deliveryOption\' })\"\n                            ng-if=\"deliveryOptions.length > 0\">\n                            {{deliveryOption.shortName || deliveryOption.name}}\n                        </div> -->\n\n                        <div class=sidebar__selected-product__product__valuable-type ng-repeat=\"valuableType in valuableTypes = (selectedProduct.product.additionalServices | filter: { selected: true, type: \'valuableType\' } | filter: {type: \'!valuableTypeInsurance\'})\" ng-if=\"valuableTypes.length > 0\">\n                            {{valuableType.shortName}}\n                        </div>\n\n                        <div ng-repeat=\"included in selectedProduct.product.additionalServices | filter: { included: true, selected: true } | onlyVisibleGroupings\" ng-if=\"selectedProduct.country === \'DK\' && selectedProduct.product.type !== \'valuables\'\" class=sidebar__selected-product__product__additional-services>\n                            <span>{{included.shortName || included.name}}</span>\n                        </div>\n\n                        <div ng-repeat=\"service in selectedProduct.product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | onlyVisibleGroupings\" ng-if=\"selectedProduct.product.type !== \'valuables\'\" class=sidebar__selected-product__product__additional-services>\n                            <span>* {{service.shortName || service.name}}</span>\n                        </div>\n                        <div ng-repeat=\"service in selectedProduct.product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | filter: {type: \'!valuableTypeInsurance\'} | filter: {type: \'!valuableType\'} | onlyVisibleGroupings\" ng-if=\"selectedProduct.product.type === \'valuables\'\" class=sidebar__selected-product__product__additional-services>\n                            <span>* {{service.shortName || service.name}}</span>\n                        </div>\n                        <div ng-repeat=\"service in selectedProduct.product.additionalServices | filter: { selected: true, type: \'valuableTypeInsurance\' } | onlyVisibleGroupings\" ng-if=\"selectedProduct.country === \'DK\'\" class=sidebar__selected-product__product__additional-services>\n                            <span>{{ \'SIDEBAR_PARCEL_INSURED\' | translate}} {{service.parcelValue | number}} DKK</span>\n                        </div>\n                    </div>\n\n                    <div class=\"sidebar__selected-product__product__header__col sidebar__selected-product__product__header__col--price\">\n                        <div class=sidebar__selected-product__product__price>\n                            <span class=sidebar__selected-product__product__price__value>{{selectedProduct.totalPrice | price:false}}</span>\n                            <span class=sidebar__selected-product__product__price__unit>{{selectedProduct.product.priceUnit}}</span>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=sidebar__selected-product__product__measurements>\n                    <div class=sidebar__selected-product__product__measurements__row ng-class=\"{\'sidebar__selected-product__product__measurements__row--first\': $first}\" ng-repeat=\"measurement in selectedProduct.measurements.dimensionDescriptions\" ng-if=measurement.maxValue>\n                        <div class=sidebar__selected-product__product__measurements__row__col>\n                            <div class=sidebar__selected-product__product__measurements__label>{{measurement.description}}</div>\n                            <div class=sidebar__selected-product__product__measurements__value>\n                                {{\'MAX\' | translate}} <strong>{{measurement.maxValue}}</strong> {{measurement.unit}}\n                            </div>\n                        </div>\n                        <div class=\"sidebar__selected-product__product__measurements__row__col sidebar__selected-product__product__measurements__row__col--right\" ng-if=$first>\n                            <div class=sidebar__selected-product__product__measurements__label>{{ \'WEIGHT\' | translate}}</div>\n                            <div class=sidebar__selected-product__product__measurements__value>\n                                {{\'MAX\' | translate}} <strong>{{selectedProduct.maxWeight.value}}</strong> {{selectedProduct.maxWeight.unit}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n");
$templateCache.put("components/sidebar/common/cart/sidebar-cart.directive.html","<header>\n    <h2>{{ \'SIDEBAR_SHOPPINGBASKET_TITLE\' | translate}}</h2>\n</header>\n\n<main>\n    <ul>\n       <li ng-repeat=\"item in sidebarCart.items\">\n            <label ng-if=item.receiverName>{{\'RECEIVER\' | translate}}</label>\n\n            <div class=receiver>\n                <h3 ng-if=item.receiverName>{{item.receiverName}}</h3>\n\n                <span class=price>\n                    <strong>{{item.price | price}}</strong> {{item.priceUnit | prettifyCurrency}}\n                </span>\n            </div>\n\n            <div class=product>\n                <h2 ng-if=!item.receiverName ng-bind-html=item.name></h2>\n                <span ng-if=item.receiverName ng-bind-html=item.name></span>\n            </div>\n\n            <ul>\n                <li ng-repeat=\"service in item.additionalServices\" ng-if=\"service.selected && !service.included && !service.hidden\">\n                    {{service.shortName || service.name}}\n                </li>\n            </ul>\n       </li>\n   </ul>\n\n   <!-- Total price -->\n   <section>\n        <cmn-sidebar-product-price is-customer-company=sidebarCart.isCustomerCompany currency=\"sidebarCart.cart[0].priceUnit | prettifyCurrency\" cart=sidebarCart.cart cart-items=sidebarCart.items>\n        </cmn-sidebar-product-price>\n   </section>\n</main>\n\n<footer ng-if=\"sidebarCart.showButton !== false\">\n    <a ui-sref=main.payment>\n        <span class=arrow>{{ \'SIDEBAR_SHOPPINGBASKET_TO_SHOPPINGCART\' | translate}}</span>\n    </a>\n</footer>\n");
$templateCache.put("components/sidebar/common/dropoff-map/sidebar-dropoff-map.directive.html","<div ng-if=sidebarDropoffMap.sender.address.zipCode class=\"box sidebar__box\">\n    <div class=box__header>\n        <div class=box__header__title>{{ \'SIDEBAR_DROPOFFMAP_TITLE\' | translate}}</div>\n        <div class=\"visible-xs box__header__info\">{{ \'SIDEBAR_DROPOFFMAP_INFO\' | translate}}</div>\n    </div>\n    <div ng-show=sidebarDropoffMap.loading class=\"box__content rotate\"><img src=../assets/images/spinner-circle-large.png></div>\n    <div ng-show=!sidebarDropoffMap.loading class=\"box__content box__content--no-padding\">\n        <div id=dropoffMap class=dropoff__map></div>\n        <div class=\"box__content dropoff\">\n            <div class=hidden-xs>{{ \'SIDEBAR_DROPOFFMAP_INFO\' | translate}}</div>\n            <div class=\"dropoff__info dropoff__info--block\">\n                <div class=dropoff__info__header>{{sidebarDropoffMap.servicepoint.name}}</div>\n                <span>{{sidebarDropoffMap.servicepoint.visitingAddress.streetName}} {{sidebarDropoffMap.servicepoint.visitingAddress.streetNumber}}, {{sidebarDropoffMap.servicepoint.visitingAddress.postalCode}} {{sidebarDropoffMap.servicepoint.visitingAddress.city}}</span>\n            </div>\n            <!-- <div class=\"dropoff__info\">\n                <div class=\"dropoff__info__header\">\n                    {{ \'SIDEBAR_DROPOFFMAP_OPENINGHOURS\' | translate}}\n                    <span class=\"hidden-xs dropoff__info__open\" ng-if=\"sidebarDropoffMap.isOpen\">{{ \'OPEN\' | translate}}</span>\n                    <span class=\"hidden-xs dropoff__info__open\" ng-if=\"!sidebarDropoffMap.isOpen\">{{ \'CLOSED\' | translate}}</span>\n                </div>\n            </div> -->\n            <div class=dropoff__info>\n                <div class=dropoff__info__header>\n                    {{ \'SIDEBAR_DROPOFFMAP_OPENINGHOURS\' | translate}}\n                    <span class=\"hidden-xs dropoff__info__open\" ng-if=sidebarDropoffMap.isOpen>{{ \'OPEN\' | translate}}</span>\n                    <span class=\"hidden-xs dropoff__info__open\" ng-if=!sidebarDropoffMap.isOpen>{{ \'CLOSED\' | translate}}</span>\n                </div>\n                <div class=dropoff__info__opening-hours>\n                    <div class=dropoff__info__opening-hours__row ng-repeat=\"days in sidebarDropoffMap.servicepoint.openingHours\" ng-show=\"days[0].hours.length > 0\">\n                        <div class=dropoff__info__opening-hours__days>{{days | printFollowingDays}}</div>\n                        <div class=dropoff__info__opening-hours__hours>\n                            <div class=dropoff__info__opening-hours__hours__row ng-repeat=\"hours in days[0].hours\">\n                                <span>{{hours.string}}</span><span ng-if=\"days[0].hours.length -1 < $index\">, </span>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"visible-xs dropoff__info__open\" ng-if=sidebarDropoffMap.isOpen>{{ \'OPEN\' | translate}}</span>\n                    <span class=\"visible-xs dropoff__info__open\" ng-if=!sidebarDropoffMap.isOpen>{{ \'CLOSED\' | translate}}</span>\n                </div>\n            </div>\n            <div class=dropoff__info ng-if=sidebarDropoffMap.servicepoint.dropOffTimes>\n                <div class=dropoff__info__header>{{ \'POSTNORD_PICKUP\' | translate}}</div>\n                <div class=dropoff__info__opening-hours>\n                    <div class=dropoff__info__opening-hours__row ng-repeat=\"days in sidebarDropoffMap.servicepoint.dropOffTimes\">\n                        <div class=dropoff__info__opening-hours__days>{{days | printFollowingDays}}</div>\n                        <div class=dropoff__info__opening-hours__hours>\n                            <div class=dropoff__info__opening-hours__hours__row>\n                                {{days[0].latestTime}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=dropoff__info--dkextra ng-if=\"main.country === \'DK\'\" ng-bind-html=\"\'DROPOFFMAP_DK_EXTRAINFO\' | translate\">\n\n            </div>\n        </div>\n        <div class=\"dropoff__get-directions visible-xs\">\n            <a ng-click=sidebarDropoffMap.showInGoogleMaps()>{{\'SIDEBAR_DROPOFFMAP_GET_DIRECTIONS\' | translate}}</a>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/sidebar/common/measurement-limits/measurement-limits.directive.html","<header>\n    <h2>{{\'SIDEBAR_MEASUREMENTINFO_TITLE\' | translate}}</h2>\n</header>\n\n<main>\n    <ul>\n        <li ng-repeat=\"info in ctrl.parcelInfo\">\n            <h3 ng-bind-html=info.name></h3>\n            <h4 ng-if=\"info.dimensionModifyingService || info.isRoll\">\n                * {{info.dimensionModifyingService ? info.dimensionModifyingService.shortName : (\'ROLL\' | translate)}}\n            </h4>\n\n            <div>\n                <ul>\n                    <li ng-repeat=\"dimension in info.dimensions.dimensionDescriptions track by $index\">\n                        <label>{{dimension.description}}</label>\n                        <span ng-if=!dimension.text>{{ \'MAX\' | translate}} <strong>{{dimension.maxValue}}</strong> {{dimension.unit}}</span>\n                        <span ng-if=dimension.text>{{dimension.text}}</span>\n                    </li>\n                </ul>\n\n                <ul>\n                    <li>\n                        <label>{{\'WEIGHT\' | translate}}</label>\n                        <span>{{ \'MAX\' | translate}} <strong>{{info.maxWeight.value}}</strong> {{info.maxWeight.unit}}</span>\n                    </li>\n                </ul>\n            </div>\n        </li>\n    </ul>\n</main>\n");
$templateCache.put("components/sidebar/common/overview/overview.directive.html","<header>\n    <h2>{{ \'SIDEBAR_OVERVIEW_TITLE\' | translate }}</h2>\n</header>\n\n<main>\n    <ul>\n       <li ng-repeat=\"item in ctrl.items\">\n            <label ng-if=item.receiverName>{{\'RECEIVER\' | translate}}</label>\n\n            <h3 ng-if=item.receiverName>{{item.receiverName}}</h3>\n\n            <div class=product>\n                <h2 ng-if=!item.receiverName ng-bind-html=item.name></h2>\n                <span ng-if=item.receiverName ng-bind-html=item.name></span>\n\n                <span class=price>\n                    <strong>{{item.price | price}}</strong> {{item.priceUnit | prettifyCurrency}}\n                </span>\n            </div>\n\n            <ul>\n                <li ng-repeat=\"service in item.additionalServices\" ng-if=\"service.selected && !service.included && !service.hidden\">\n                    {{service.shortName || service.name}}\n                </li>\n            </ul>\n       </li>\n   </ul>\n\n   <!-- Total price -->\n   <section class=total-price>\n       <div>\n           <span><strong>{{ \'LANDING_PAGE_YOUR_PRICE_INCL_VAT\' | translate}}</strong></span>\n           <span class=muted>({{(ctrl.isCustomerCompany ? \'EXCL_VAT\' : \'INCL_VAT\') | translate}})</span>\n       </div>\n       <span class=price>\n           <strong>{{ctrl.totalPriceForParcels | price}}</strong>\n           {{ctrl.cart[0].priceUnit | prettifyCurrency}}\n       </span>\n   </section>\n</main>\n");
$templateCache.put("components/sidebar/common/product-details/sidebar-product-details.directive.html","<div class=\"box sidebar__box sidebar__product-details\">\n    <div class=box__header>\n        <div class=box__header__title>{{ \'SIDEBAR_PARCEL_DETAILS_TITLE\' | translate}}</div>\n    </div>\n    <div class=sidebar__product-details__product-img ng-show=ctrl.product.content.imageUrl>\n        <img ng-src=\"{{ctrl.product.content.imageUrl | imagePath}}\">\n    </div>\n    <div class=sidebar__product-details__info>\n        <div class=sidebar__product-details__info__row ng-class=\"{\'sidebar__product-details__info__row--first\': $first}\" ng-repeat=\"dimension in ctrl.measurements.dimensionDescriptions\">\n            <div class=sidebar__product-details__info__row__col>\n                <div class=sidebar__product-details__info__label>{{dimension.description}}</div>\n                <div class=sidebar__product-details__info__value>\n                    {{\'MAX\' | translate}} <strong>{{dimension.maxValue}}</strong> {{dimension.unit}}\n                </div>\n            </div>\n            <div class=\"sidebar__product-details__info__row__col sidebar__product-details__info__row__col--right\" ng-if=$first>\n                <div class=sidebar__product-details__info__label>{{ \'WEIGHT\' | translate}}</div>\n                <div class=sidebar__product-details__info__value>\n                    {{\'MAX\' | translate}} <strong>{{ctrl.maxWeight.value}}</strong> {{ctrl.maxWeight.unit}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/sidebar/common/selected-product/selected-product.directive.html","<header>\n    <h2>{{vm.heading || (\'SIDEBAR_PARCEL_TITLE\' | translate)}}</h2>\n\n    <button class=\"btn btn--header btn--header--edit\" type=button ng-if=vm.editCallback ng-click=vm.editCallback()(vm.product)>\n    <span>{{ \'COD_CHANGE\' | translate }}</span>\n    </button>\n</header>\n\n<main ng-class=\"{\'expanded\': vm.expanded}\">\n    <!-- Base product information -->\n    <header>\n        <h2>\n            <span class=product-image>\n                <img ng-src=\"{{vm.product.imageUrl | imagePath}}\">\n            </span>\n            <div class=product-name>\n                <span ng-bind-html=vm.productName></span>\n                <div class=base-product-name ng-if=\"vm.country === \'SE\'\">{{vm.baseProductName}}</div>\n            </div>\n            <span class=price>\n                <strong>{{vm.productPrice | price}}</strong>\n                {{vm.product.priceUnit | prettifyCurrency}}\n            </span>\n            <span class=expand>\n                <pn-icon class=cmn-country-selector__arrow ng-attr-symbol=\"{{vm.expanded ? \'angle-small-up\' : \'angle-small-down\'}}\" ng-click=\"vm.expanded = !vm.expanded\" color=blue700 size=medium solid>\n                </pn-icon>\n            </span>\n        </h2>\n\n\n        <div class=receiver-country ng-if=\"vm.product.toCountry && vm.country !== vm.product.toCountry.countryCode\">\n           <img ng-src=\"{{vm.product.toCountry.countryCode | flagPath}}\" alt=\"Flag of {{vm.product.toCountry.name}}\">\n           <span>{{ \'TO\' | translate}} {{vm.product.toCountry.name}}</span>\n        </div>\n\n        <div class=dimensions>\n            <ul>\n                <li ng-repeat=\"dimension in vm.productDimensions.dimensionDescriptions\">\n                    <label>{{dimension.description}}</label>\n                    <span ng-if=!dimension.text>{{ \'MAX\' | translate}} <span class=max-value>{{dimension.maxValue}}</span> {{dimension.unit}}</span>\n                    <span ng-if=dimension.text>{{dimension.text}}</span>\n                </li>\n            </ul>\n\n            <ul>\n                <li>\n                    <label>{{\'WEIGHT\' | translate}}</label>\n                    <span ng-if=!vm.selectedWeight>{{ \'MAX\' | translate}} <span class=max-value>{{vm.productWeight.value}}</span> {{vm.productWeight.unit}}</span>\n                    <span ng-if=vm.selectedWeight>{{ \'MAX\' | translate}} <span class=max-value>{{vm.selectedWeight.value}}</span> {{vm.selectedWeight.unit}}</span>\n                </li>\n            </ul>\n        </div>\n    </header>\n\n    <!-- Additional services -->\n    <div class=section-container>\n        <section class=additional-services ng-if=\"vm.deliveryTime || (vm.additionalServices && vm.additionalServices.length > 0)\">\n            <ul>\n                <li ng-if=vm.deliveryTime>\n                    <label>\n                        <span class=title>\n                            <span ng-if=\"vm.market === \'DK\' && vm.hasCustomsDocuments(vm.product)\"> {{\'DELIVERY_TIME_EXCL_CUSTOMS_HANDLING\' | translate}}</span>\n                            <span ng-if=\"vm.market !== \'DK\' || !vm.hasCustomsDocuments(vm.product)\" class=text>{{\'DELIVERY_TIME\' | translate}}</span>\n                            <span class=tooltip ng-if=\"vm.country === \'SE\'\" uib-popover-html=\"\'DELIVERY_TIME_INFORMATION\' | translate\"></span>\n                        </span>\n                        <span class=value>{{vm.deliveryTime.text}}</span>\n                    </label>\n                    <span class=price ng-if=vm.deliveryTime.price>\n                        <strong>{{vm.deliveryTime.price | price}}</strong>\n                        {{vm.deliveryTime.currency | prettifyCurrency}}\n                    </span>\n                </li>\n                <li ng-repeat=\"additionalService in vm.additionalServices\" ng-if=\"!additionalService.hidden && vm.product.type !== \'letter\'\">\n                    <label>\n                        <div>{{additionalService.title}}</div>\n                        <small ng-if=additionalService.subtitle>{{additionalService.subtitle | capitalize}}</small>\n                        <small ng-if=additionalService.parcelValue>{{additionalService.parcelValue}} {{additionalService.currency | prettifyCurrency}}</small>\n                    </label>\n                    <span class=price ng-if=\"additionalService.included || additionalService.price === 0\"><span class=included>{{\'INCLUDED\' | translate | capitalize}}</span></span>\n                    <span class=price ng-if=\"!additionalService.included && additionalService.price\">\n                        <strong>{{additionalService.price | price}}</strong>\n                        {{additionalService.currency | prettifyCurrency}}\n                    </span>\n                </li>\n            </ul>\n        </section>\n\n        <!-- Total price -->\n        <section>\n            <cmn-sidebar-product-price product=vm.product is-customer-company=vm.isCustomerCompany currency=\"vm.product.priceUnit | prettifyCurrency\">\n            </cmn-sidebar-product-price>\n        </section>\n    </div>\n</main>\n");
$templateCache.put("components/sidebar/dk/climate-compensation/climate-compensation.directive.html","<div ng-show=vm.climateCompensatedProduct class=\"green-box sidebar__box sidebar__climate-compensation\">\n  <div class=icon-container>\n    <img ng-if=vm.isDk src=assets/images/climate-compensation.svg alt=\"\" aria-hidden=true>\n    <img ng-if=!vm.isDk src=assets/images/climate-compensation-en.svg alt=\"\" aria-hidden=true>\n  </div>\n  <div class=description>\n      <span>{{\'SIDEBAR_CLIMATE_COMPENSATION_DESCRIPTION\' | translate}}</span>\n  </div> \n</div>\n");
$templateCache.put("components/sidebar/dk/measurements/measurements.directive.html","\n<div class=\"box sidebar__box sidebar__measurement\">\n        <div class=box__header>\n            <div class=box__header__tabs>\n                <span class=box__header__tabs__tab ng-click=\"measurements.setActiveTab(\'measure\')\" ng-class=\"{\'box__header__tabs__tab--active\': measurements.activeTab === \'measure\'}\">{{ \'SIDEBAR_MEASUREMENT_MEASURE\' | translate}}</span>\n                <span class=box__header__tabs__tab ng-click=\"measurements.setActiveTab(\'weight\')\" ng-class=\"{\'box__header__tabs__tab--active\': measurements.activeTab === \'weight\'}\">{{ \'SIDEBAR_MEASUREMENT_WEIGH\' | translate}}</span>\n            </div>\n        </div>\n        <div class=box__content ng-if=\"measurements.activeTab === \'measure\'\">\n            <div class=sidebar__measurement__package>\n                <span class=girth>{{ \'GIRTH\' | translate}}</span>\n                <span class=length>{{ \'LENGTH\' | translate}}</span>\n                <span class=width>{{ \'WIDTH\' | translate}}</span>\n                <span class=height>{{ \'HEIGHT\' | translate}}</span>\n            </div>\n            <div class=sidebar__measurement__package__info>\n                <strong>{{ \'LENGTH\' | translate}}</strong><span>: {{ \'SIDEBAR_MEASUREMENTINFO_LENGTH\' | translate}}</span>\n            </div>\n            <div class=sidebar__measurement__package__info>\n                 <strong>{{ \'GIRTH\' | translate}}</strong><span>: {{ \'SIDEBAR_MEASUREMENTINFO_GIRTH\' | translate}}</span>\n            </div>\n        </div>\n\n\n\n        <div class=box__content ng-if=\"measurements.activeTab === \'weight\'\">\n            <div class=sidebar__measurement__weight></div>\n            <div class=sidebar__measurement__weight__info>\n                <p>{{ \'SIDEBAR_MEASUREMENT_WEIGHT\' | translate}}</p>\n            </div>\n        </div>\n</div>\n");
$templateCache.put("components/sidebar/se/measurement/sidebar-measurement.directive.html","<div class=\"box sidebar__box sidebar__measurement\">\n        <div class=box__header__tabs>\n            <span class=box__header__tabs__tab ng-click=\"sidebarMeasurement.setActiveTab(\'measure\')\" ng-class=\"{\'box__header__tabs__tab--active\': sidebarMeasurement.activeTab === \'measure\'}\">{{ \'SIDEBAR_MEASUREMENT_MEASURE\' | translate}}</span>\n            <span class=box__header__tabs__tab ng-click=\"sidebarMeasurement.setActiveTab(\'weight\')\" ng-class=\"{\'box__header__tabs__tab--active\': sidebarMeasurement.activeTab === \'weight\'}\">{{ \'SIDEBAR_MEASUREMENT_WEIGH\' | translate}}</span>\n        </div>\n    <div class=box__content ng-if=\"sidebarMeasurement.activeTab === \'measure\'\">\n        <div ng-if=!landing.selectedType.isRoll>\n        <div class=sidebar__measurement__package>\n            <span class=girth>{{ \'GIRTH\' | translate}}</span>\n            <span class=length>{{ \'LENGTH\' | translate}}</span>\n            <span class=width>{{ \'WIDTH\' | translate}}</span>\n            <span class=height>{{ \'HEIGHT\' | translate}}</span>\n        </div>\n        <div class=sidebar__measurement__package__info>\n            <strong>{{ \'LENGTH\' | translate}}</strong><span>: {{ \'SIDEBAR_MEASUREMENTINFO_LENGTH\' | translate}}</span>\n        </div>\n        <div class=sidebar__measurement__package__info>\n             <strong>{{ \'GIRTH\' | translate}}</strong><span>: {{ \'SIDEBAR_MEASUREMENTINFO_GIRTH\' | translate}}</span>\n        </div>\n         <div class=sidebar__measurement__package__info__min>\n             <div class=header_grey>\n                 <div><span>{{ \'MIN\' | translate}}. {{ \'LENGTH\' | translate | lowercase}}<br><span>{{\'14\' | number}} cm</span></span></div>\n                 <div><span>{{ \'MIN\' | translate}}. {{ \'WIDTH\' | translate | lowercase}}<br><span>{{\'9\' | number}} cm</span></span></div>\n                 <div ng-hide=\"landing.selectedType.baseProductId === \'2006980\' || landing.selectedType.baseProductId === \'2003742\'\">\n                     <span>{{ \'MIN\' | translate}}. {{ \'HEIGHT\' | translate | lowercase}}<br><span>{{\'1.5\' | number}} cm</span></span>\n                 </div>\n             </div>\n\n        </div>\n        </div>\n\n    <!-- ROLL -->\n        <div ng-if=landing.selectedType.isRoll>\n            <div class=sidebar__measurement__roll>\n                <span class=diameter>{{ \'DIAMETER\' | translate}}</span>\n                <span class=length>{{ \'LENGTH\' | translate}}</span>\n            </div>\n            <div class=sidebar__measurement__package__info__min>\n                <div class=header_grey>\n                    <div><span>{{ \'MIN\' | translate}}. {{ \'LENGTH\' | translate | lowercase}}<br><span>{{\'10\' | number}} cm</span></span></div>\n                    <div class=roll_diameter><span>{{ \'MIN\' | translate}}. {{ \'DIAMETER\' | translate | lowercase}}<br><span>{{\'3.5\' | number}} cm</span></span></div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n\n    <!-- END ROLL -->\n    <div class=box__content ng-if=\"sidebarMeasurement.activeTab === \'weight\'\">\n        <div class=sidebar__measurement__weight></div>\n        <div class=sidebar__measurement__weight__info>\n            <p>{{ \'SIDEBAR_MEASUREMENT_WEIGHT\' | translate}}</p>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/user/history/order-details/order-details.content.html","<div class=\"box parcel-details\">\n    <header ng-if=orderDetails.shipment.status>\n        <h2>{{ \'STATUS\' | translate}}</h2>\n        <div class=parcel-details__status-box>\n            <h2 class=\"parcel-details__status-box__status parcel-details__status-box__status--{{orderDetails.shipment.status}}\">\n                {{(\'HISTORY_STATUS_\' + orderDetails.shipment.status) | translate}}\n            </h2>\n            <div class=parcel-details__status-box__text ng-if=orderDetails.shipment.statusText>{{orderDetails.shipment.statusText}}</div>\n        </div>\n    </header>\n    <div class=parcel-details__row>\n        <div class=parcel-details__col>\n            <div class=parcel-details__col__title>{{ \'PRODUCT\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>\n                    {{orderDetails.parcel.content.name}}\n                    <span ng-repeat=\"addition in orderDetails.parcel.content.additionalServices | filter: { selected: true, type: \'!deliveryOption\' } | onlyVisibleGroupings\">*</span>\n                </div>\n            </div>\n            <div class=parcel-details__col__content__details ng-if=\"orderDetails.parcel.content.additionalServices.length > 0\">\n                <div ng-repeat=\"addition in orderDetails.parcel.content.additionalServices | filter: { selected: true, type: \'!deliveryOption\' } | onlyVisibleGroupings\">\n                    <div ng-show=addition.selected>* {{addition.name}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"parcel-details__col parcel-details__col--last\">\n            <div class=parcel-details__col__title>{{ \'RECEIPT_SHIPMENT_ID\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=\"parcel-details__col__content__label parcel-details__col__content__label--blue\">{{orderDetails.parcel.consignmentNumber}}</div>\n            </div>\n        </div>\n    </div>\n   \n    <div class=parcel-details__row ng-if=\"orderDetails.parcel.content.digitalStamps && orderDetails.parcel.content.digitalStamps.stamps.length\">\n        <div class=parcel-details__row__title>{{ \'DIGITAL_STAMPS_RECEIPT_TITLE\' | translate }}</div>\n        <div class=parcel-details__row__stamp ng-repeat=\"stamp in orderDetails.parcel.content.digitalStamps.stamps\">\n            {{stamp.stampCode | portocode}}\n        </div>\n        <div class=parcel-details__row__expiry-date>{{ \'DIGITAL_STAMPS_RECEIPT_INSTRUCTION_INFO\' | translate:{ expiryDate: orderDetails.getDigitalStampsExpiryDate() } }}</div>\n    </div>\n\n    <div class=parcel-details__row>\n        <div class=parcel-details__col>\n            <div class=parcel-details__col__title>{{ \'SENDER\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>{{orderDetails.parcel.content.sender.company.name || orderDetails.parcel.content.sender.name}}</div>\n                <div class=parcel-details__col__content__details>\n                    <div ng-show=orderDetails.parcel.content.sender.company>{{ \'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}} {{orderDetails.parcel.content.sender.company.organizationNumber}}</div>\n                    <div>{{orderDetails.parcel.content.sender.address.street}}</div>\n                    <div>{{orderDetails.parcel.content.sender.address.zipCode}} {{orderDetails.parcel.content.sender.address.city}}</div>\n                    <div>{{orderDetails.parcel.content.sender.email}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=parcel-details__col>\n            <div class=parcel-details__col__title>{{ \'RECEIVER\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>{{orderDetails.parcel.content.receiver.name || orderDetails.parcel.content.receiver.company}}</div>\n                <div class=parcel-details__col__content__details>\n                    <div>{{orderDetails.parcel.content.receiver.address.street}}</div>\n                    <div>{{orderDetails.parcel.content.receiver.address.zipCode}} {{orderDetails.parcel.content.receiver.address.city}}</div>\n                    <div>{{orderDetails.parcel.content.receiver.country.name}}</div>\n                    <div>{{orderDetails.parcel.content.receiver.email}}</div>\n                    <div>{{orderDetails.parcel.content.receiver.phone}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=parcel-details__row>\n        <div class=parcel-details__col>\n            <div class=parcel-details__col__title>{{ \'ORDERDATE\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>{{orderDetails.parcel.createdDate | date: \'yyyy-MM-dd\'}}</div>\n            </div>\n        </div>\n\n        <div class=\"parcel-details__col parcel-details__col--last\">\n            <div class=parcel-details__col__title>{{ \'ORDERING\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>{{orderDetails.parcel.cartId}}</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"parcel-details__row parcel-details__row--last\">\n        <div class=parcel-details__col>\n            <div class=parcel-details__col__title>{{ \'PRICE\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>\n                    <span ng-show=main.isCustomerCompany>{{orderDetails.parcel.content.itemAmountNoVAT | price:true}} kr</span>\n                    <span ng-show=!main.isCustomerCompany>{{(orderDetails.parcel.content.itemAmountNoVAT + orderDetails.parcel.content.itemTaxAmount| price:true)}} kr</span>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"parcel-details__col parcel-details__col--last\">\n            <div class=parcel-details__col__title>{{ \'VAT\' | translate}}</div>\n            <div class=parcel-details__col__content>\n                <div class=parcel-details__col__content__label>{{orderDetails.parcel.content.itemTaxAmount | price:true}} kr</div>\n            </div>\n        </div>\n    </div>\n\n    <div class=parcel-details__action-box>\n        <div class=\"parcel-details__action-box__action parcel-details__action-box__action--print\" ng-show=orderDetails.waybillIsAvailable>\n            <a ng-click=orderDetails.printWaybill(orderDetails.parcel.cartId)>{{ \'HISTORY_PRINT_WAYBILL\' | translate}}</a>\n        </div>\n        <div class=\"parcel-details__action-box__action parcel-details__action-box__action--reclaim parcel-details__action-box__action--last\">\n            <a href={{orderDetails.claimsUrl}}>{{ \'HISTORY_CLAIMS\' | translate}}</a>\n        </div>\n    </div>\n</div>\n\n<iframe id=printFrame width=0 height=0 frameborder=0 style=\"display: none\"></iframe>\n");
$templateCache.put("components/user/history/order-details/order-details.html","<div class=page-header>\n    <h1 class=page-header__title>{{ \'PAGE_HEADER_ORDER_DETAILS\' | translate}}</h1>\n</div>\n\n<div class=main-container-wrapper>\n    <div class=main-container>\n        <div class=main-container__navigation>\n            <a class=main-container__navigation__back ui-sref=main.user.history>{{\'NAVIGATION_BACK_TO_HISTORY\' | translate}}</a>\n        </div>\n\n        <div ng-include=\"\'components/user/history/order-details/order-details.content.html\'\" class=main-content></div>\n        <div ng-include=\"\'components/user/history/order-details/order-details.sidebar.html\'\" class=sidebar></div>\n    </div>\n</div>\n");
$templateCache.put("components/user/history/order-details/order-details.sidebar.html","<cmn-sidebar-product-details product=orderDetails.parcel></cmn-sidebar-product-details>\n\n<event-box ng-hide=\"!orderDetails.shipment.events || orderDetails.shipment.events.length === 0\" events=orderDetails.shipment.events loading=orderDetails.loadingEvents>\n</event-box>\n");
$templateCache.put("components/landing/common/additional-service-selector/additional-service/additional-service-dropdown.directive.html","<ui-select class=additional-service-selector__additional-service-dropdown ng-model=$parent.ctrl.additionalServiceGroup.selectedService skip-focusser=true theme=selectize on-select=\"ctrl.setSelectedServiceInGroup(ctrl.additionalServiceGroup, ctrl.additionalServiceGroup.selectedService)\" search-enabled=false>\n    <ui-select-match>\n        <div class=additional-service-selector__additional-service-dropdown__item>\n            <span class=additional-service-selector__additional-service-dropdown__value truncate>\n                {{$select.selected.multipleChoiceAddOn.value}}\n            </span>\n\n            <additional-service-price class=additional-service-selector__additional-service-dropdown__price is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=$select.selected>\n            </additional-service-price>\n        </div>\n    </ui-select-match>\n    <ui-select-choices repeat=\"service in ctrl.additionalServiceGroup.services\">\n        <div class=additional-service-selector__additional-service-dropdown__item>\n            <span class=additional-service-selector__additional-service-dropdown__value truncate>\n                {{service.multipleChoiceAddOn.value}}\n            </span>\n\n            <additional-service-price class=additional-service-selector__additional-service-dropdown__price is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=service>\n            </additional-service-price>\n        </div>\n    </ui-select-choices>\n</ui-select>\n");
$templateCache.put("components/landing/common/additional-service-selector/additional-service/additional-service.directive.html","<div class=additional-service-selector__additional-service ng-class=\"{\'additional-service-selector__additional-service--disabled\': ctrl.isDisabledVisually(ctrl.product, ctrl.service)}\" ng-hide=ctrl.hidden ng-if=ctrl.service>\n  <div class=\"additional-service-selector__additional-service__col additional-service-selector__additional-service__col--checkbox\">\n    <input id={{ctrl.service.additionalServiceId}}_additional_{{$id}} type=checkbox class=additional-service-selector__additional-service__checkbox ng-class=\"{\'additional-service-selector__additional-service__checkbox--pending\': ctrl.isPending(ctrl.product, ctrl.service)}\" ng-checked=ctrl.isChecked(ctrl.service) ng-disabled=ctrl.isDisabled(ctrl.service) ng-change=ctrl.onSelect()(ctrl.service) ng-model=ctrl.service.selected>\n  </div>\n\n  <div class=\"additional-service-selector__additional-service__col additional-service-selector__additional-service__col--name\">\n    <div class=additional-service-selector__additional-service__content ng-class=\"{\'additional-service-selector__additional-service__content--has-description\': ctrl.service.description && !ctrl.multipleChoice}\">\n      <label for={{ctrl.service.additionalServiceId}}_additional_{{$id}} class=additional-service-selector__additional-service__name>\n        {{ctrl.multipleChoice ? ctrl.service.multipleChoiceAddOn.title : ctrl.service.name}}\n      </label>\n\n      <additional-service-price ng-if=!ctrl.multipleChoice class=additional-service-selector__additional-service__price is-customer-company=ctrl.isCustomerCompany product=ctrl.product additional-service=ctrl.service>\n      </additional-service-price>\n\n      <div class=additional-service-selector__additional-service__tooltip ng-if=\"!ctrl.multipleChoice && ctrl.service.description\" tabindex=1 uib-popover-html=ctrl.service.description>\n      </div>\n    </div>\n  </div>\n\n\n  <div ng-if=ctrl.multipleChoice class=\"additional-service-selector__additional-service__col additional-service-selector__additional-service__col--dropdown\">\n    <div class=additional-service-selector__additional-service__content ng-class=\"{\'additional-service-selector__additional-service__content--has-description\': ctrl.service.description}\">\n      <additional-service-dropdown product=ctrl.product additional-service-group=ctrl.additionalServiceGroup is-customer-company=ctrl.isCustomerCompany on-select=ctrl.onMultipleChoiceSelect>\n      </additional-service-dropdown>\n\n      <div class=\"additional-service-selector__additional-service__tooltip additional-service-selector__additional-service__tooltip--dropdown\" ng-if=ctrl.service.description tabindex=1 uib-popover=\"{{ ctrl.service.description }}\">\n      </div>\n    </div>\n  </div>\n\n\n  <div ng-if=\"!ctrl.multipleChoice && ctrl.service.dimensions.dimensionDescriptions && ctrl.service.additionalServiceId === \'Expresspaket\'\" class=additional-service-selector__additional-service__description>\n    <div class=additional-service-selector__additional-service__description__dimensions ng-repeat=\"dimension in ctrl.service.dimensions.dimensionDescriptions\">\n      <span class=additional-service-selector__additional-service__description__dimensions__label>{{dimension.description}}:</span>\n      <span class=additional-service-selector__additional-service__description__dimensions__value>\n        {{\'MAX\' | translate}} {{dimension.maxValue}} {{dimension.unit}}\n      </span>\n    </div>\n  </div>\n  \n  <div ng-if=ctrl.service.link class=additional-service-selector__additional-service__description>\n    <a href={{ctrl.service.link.href}} target=_blank>\n      {{ctrl.service.link.text}}\n    </a>\n  </div>\n\n  <home-delivery-zipcode-validator ng-if=ctrl.isEveningHomeDeliveryService(ctrl.service) is-valid=ctrl.service.isValidZipCode zip-code=ctrl.product.receiver.address.zipCode>\n  </home-delivery-zipcode-validator>\n\n  <express-letter-delivery-validator ng-if=\"ctrl.service.selected && (ctrl.service.additionalServiceId === \'Express_bas\' || ctrl.service.additionalServiceId === \'Express_bas_company\' || ctrl.service.additionalServiceId === \'2003744\')\" is-valid=ctrl.service.isValidZipCode zip-code=ctrl.product.receiver.address.zipCode>\n  </express-letter-delivery-validator>\n\n  <express-delivery-validator ng-if=\"ctrl.service.selected && (ctrl.service.additionalServiceId === \'Expresspaket\' || ctrl.isCompanyExpressService(ctrl.service))\" is-valid=ctrl.service.isValidZipCode zip-code=ctrl.product.receiver.address.zipCode product-code=ctrl.service.productCode>\n  </express-delivery-validator>\n\n  <cash-on-delivery ng-if=ctrl.isCashOnDeliveryService(ctrl.service) product=ctrl.product max-amount-input=ctrl.service.maxAmountInput>\n  </cash-on-delivery>\n\n  <responsibility ng-if=ctrl.isResponsibilityService(ctrl.service) product=ctrl.product max-amount-input=ctrl.service.insuranceMaxValue>\n  </responsibility>\n\n  <home-pickup ng-if=\"ctrl.service.selected && ctrl.service.additionalServiceId === \'Pickup\'\" is-valid=ctrl.service.isValid product=ctrl.product>\n  </home-pickup>\n\n  <div class=additional-service-selector__additional-service__traceability-text>\n    <span ng-if=\"ctrl.product.nonTraceable && ctrl.service.nonTraceable === false\">{{\'LANDING_PAGE_TRACEABILITY_TEXT_TRACEABLE\' | translate}}</span>\n    <span ng-if=\"!ctrl.product.nonTraceable && ctrl.service.nonTraceable === true\">{{\'LANDING_PAGE_TRACEABILITY_TEXT_NOT_TRACEABLE\' | translate}}</span>\n  </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/additional-service-price/additional-service-price.directive.html","<span ng-if=\"!isCustomerCompany && !showTotalPrice && !additionalService.included && (additionalService.price !== 0 || additionalService.displayPriceVat)\">\n    (+{{(additionalService.displayPriceVat || calculateMorphTotalPrice(product, additionalService)) | price}} {{additionalService.priceUnit | prettifyCurrency}})\n</span>\n<span ng-if=\"isCustomerCompany && !showTotalPrice && !additionalService.included && (additionalService.price !== 0 || additionalService.displayPrice)\">\n    (+{{(additionalService.displayPrice || additionalService.price) | price}} {{additionalService.priceUnit | prettifyCurrency}})\n</span>\n<span ng-if=\"showTotalPrice && !additionalService.included && additionalService.price !== 0\">\n    ({{totalPrice | price}} {{additionalService.priceUnit | prettifyCurrency}})\n</span>\n<span ng-if=\"additionalService.included || (additionalService.price === 0 && !additionalService.displayPriceVat && !additionalService.displayPrice)\">({{ \'INCLUDED\' | translate }}!)</span>\n");
$templateCache.put("components/landing/common/additional-service-selector/cash-on-delivery/cash-on-delivery.directive.html","<div class=cashondelivery>\n    <div class=cashondelivery__content>\n        <span ng-if=cashOnDelivery.codIsAdded class=cashondelivery__change ng-click=cashOnDelivery.changeCOD()>{{ \'COD_CHANGE\' | translate}}</span>\n        <form name=cashOnDelivery.form>\n\n            <label ng-class=\"{\'disabled\': cashOnDelivery.codIsAdded}\" for=accountNr>{{ \'COD_ACCOUNT_NUMBER\' | translate}} *</label>\n            <input ng-readonly=cashOnDelivery.isValidating ng-if=!cashOnDelivery.codIsAdded id=accountNr type=text required ng-model=cashOnDelivery.cod.accountNumber>\n            <div ng-if=cashOnDelivery.accountError class=cashondelivery__accounterror>{{ \'COD_ACCOUNT_ERROR_MESSAGE\' | translate}}</div>\n            <div ng-if=\"cashOnDelivery.cod.accountNumber && cashOnDelivery.codIsAdded\" class=cashondelivery__codAdded>{{cashOnDelivery.cod.accountNumber}}</div>\n            <div ng-if=\"cashOnDelivery.cod.accountHolder && cashOnDelivery.codIsAdded\" class=\"cashondelivery__codAdded cashondelivery__codAdded__accountHolder\">{{cashOnDelivery.cod.accountHolder}}</div>\n\n            <label ng-class=\"{\'disabled\': cashOnDelivery.codIsAdded}\" for=reference>{{ \'COD_REFERENCE\' | translate}} *</label>\n            <input ng-readonly=cashOnDelivery.isValidating ng-if=!cashOnDelivery.codIsAdded id=reference type=text required ng-model=cashOnDelivery.cod.reference>\n            <div ng-if=\"cashOnDelivery.cod.reference && cashOnDelivery.codIsAdded\" class=cashondelivery__codAdded>{{cashOnDelivery.cod.reference}}</div>\n            <div ng-if=cashOnDelivery.referenceError class=cashondelivery__accounterror>{{ \'COD_REFERENCE_ERROR_MESSAGE\' | translate}}</div>\n\n            <label ng-class=\"{\'disabled\': cashOnDelivery.codIsAdded}\" for=amount>{{ \'COD_AMOUNT\' | translate}} *</label>\n            <input ng-readonly=cashOnDelivery.isValidating ng-if=!cashOnDelivery.codIsAdded ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ng-model=cashOnDelivery.cod.amount ng-change=cashOnDelivery.amountChanged() name=amount id=amount type=number required>\n            <div ng-if=\"cashOnDelivery.cod.amount && cashOnDelivery.codIsAdded\" class=cashondelivery__codAdded>{{cashOnDelivery.displayedAmount | currency : \'kr\'}}</div>\n            <div ng-messages=cashOnDelivery.form.amount.$error>\n                <div class=cashondelivery__amounterror ng-message=pattern>{{ \'COD_DECIMAL_LIMIT_ERROR_MESSAGE\' | translate }}</div>\n                <div class=cashondelivery__amounterror ng-message=max>{{ \'COD_MAX_AMOUNT_ERROR_MESSAGE\' | translate}}</div>\n            </div>\n        </form>\n        <button ng-class=\"{\'disabled\': cashOnDelivery.form.$invalid, \'hidden\': cashOnDelivery.codIsAdded, \'--loading\': cashOnDelivery.isValidating}\" ng-disabled=cashOnDelivery.isValidating ng-click=cashOnDelivery.checkAccountNumberValidity(cashOnDelivery.cod)>{{ \'COD_ADD\' | translate}}</button>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/company-express-validator/company-express-validator.directive.html","<div class=zipcodevalidator>\n    <div class=zipcodevalidator__container>\n        <div class=zipcodevalidator__container__content>\n            <p>{{ \'ZIPCODE_VALIDATION_TEXT\' | translate}}</p>\n            <ng-form name=zipValid>\n            <input type=text ng-model=companyExpressValidator.zipCode minlength=5 maxlength=5>\n            \n            <button ng-class=\"{\'btn--loading\': companyExpressValidator.isValidating}\" ng-disabled=\"zipValid.$invalid && pattern\" ng-click=companyExpressValidator.validateZipcode(companyExpressValidator.zipCode)>{{ \'VALIDATE\' | translate}}</button>\n            </ng-form>\n        </div>\n        <p ng-if=\"companyExpressValidator.isSubmitted && companyExpressValidator.isValid\" class=zipcodevalidator__container__ok>{{\'COMPANYEXPRESS_VALID\' | translate}}</p>\n        <p ng-if=\"companyExpressValidator.isSubmitted && !companyExpressValidator.isValid\" class=zipcodevalidator__container__error>{{ \'COMPANYEXPRESS_INVALID\' | translate}}</p>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/expressdelivery-validator/express-letter-delivery-validator.directive.html","<div class=expressvalidator>\n    <div class=expressvalidator__container>\n        <div class=expressvalidator__container__content>\n            <p>{{ \'LETTER_ZIPCODE_VALIDATION_TEXT\' | translate}}</p>\n\n            <ng-form class=expressvalidator__form name=zipValid>\n                <input type=text class=expressvalidator__form__input ng-model=expressValidator.zipCode minlength=5 maxlength=5>\n\n                <button ng-class=\"{\'btn--loading\': expressValidator.isValidating}\" class=\"btn btn--blue expressvalidator__form__btn\" ng-disabled=zipValid.$invalid ng-click=expressValidator.validateExpress(expressValidator.zipCode)>\n                    {{ \'VALIDATE\' | translate}}\n                </button>\n            </ng-form>\n        </div>\n\n        <div ng-if=expressValidator.isSubmitted>\n            <p ng-if=\"expressValidator.isValid && expressValidator.validatedData === undefined\" class=expressvalidator__container__valid>\n                {{ \'EXPRESS_LETTER_VALID\' | translate}}\n            </p>\n\n            <p ng-if=\"expressValidator.isValid && expressValidator.validatedData.deliverytime.length === 0\" class=expressvalidator__container__valid>\n                {{\'EXPRESS_LETTER_VALID_WITH_PLACE\' | translate:{name: expressValidator.validatedData.name} }}\n            </p>\n\n            <p ng-if=\"expressValidator.isValid && expressValidator.validatedData.deliverytime.length > 0\" class=expressvalidator__container__valid>\n                {{\'EXPRESS_LETTER_VALID_WITH_PLACE_AND_TIME\' | translate:{name: expressValidator.validatedData.name, time: expressValidator.validatedData.deliverytime} }}\n            </p>\n\n            <p ng-if=!expressValidator.isValid class=expressvalidator__container__error>\n                {{ \'EXPRESS_LETTER_INVALID\' | translate}}\n            </p>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/expressdelivery-validator/expressdelivery-validator.directive.html","<div class=expressvalidator>\n    <div class=expressvalidator__container>\n        <div class=expressvalidator__container__content>\n            <p>{{ \'ZIPCODE_VALIDATION_TEXT\' | translate}}</p>\n\n            <ng-form class=expressvalidator__form name=zipValid>\n                <input type=text class=expressvalidator__form__input placeholder=\"{{ \'ZIPCODE_VALIDATION_PLACEHOLDER_FROM\' | translate}}\" ng-model=expressValidator.fromzipCode minlength=5 maxlength=5>\n\n                <div class=expressvalidator__form__separator>&mdash;</div>\n\n                <input type=text class=expressvalidator__form__input placeholder=\"{{ \'ZIPCODE_VALIDATION_PLACEHOLDER_TO\' | translate}}\" ng-model=expressValidator.zipCode minlength=5 maxlength=5>\n\n                <button class=\"btn btn--blue expressvalidator__form__btn\" ng-class=\"{\'btn--loading\': expressValidator.isValidating}\" ng-disabled=zipValid.$invalid ng-click=\"expressValidator.validateExpress(expressValidator.fromzipCode, expressValidator.zipCode, expressValidator.productCode)\">\n                    {{ \'VALIDATE\' | translate}}\n                </button>\n            </ng-form>\n        </div>\n\n        <div ng-if=expressValidator.isSubmitted>\n            <p ng-if=\"expressValidator.isValid && expressValidator.validatedData\" class=\"expressvalidator__container__valid expressvalidator__container__valid--first\">\n                {{ \'EXPRESS_VALID\' | translate}}\n            </p>\n\n            <p ng-if=expressValidator.isValid class=expressvalidator__container__valid ng-bind-html=\"\'EXPRESS_VALID_WITH_DROPOFFTIME_AND_DELIVERYTIME\' | translate:{\n                    dropofftime: expressValidator.validatedData.dropOffTime,\n                    dropoffText: expressValidator.validatedData.dropOffText,\n                    deliveryText: expressValidator.validatedData.deliveryText,\n                    deliveryTime: expressValidator.validatedData.deliveryTime\n                }\">\n            </p>\n\n            <p ng-if=!expressValidator.isValid class=expressvalidator__container__error>\n                {{ \'EXPRESS_INVALID\' | translate}}\n            </p>\n        </div>\n    </div>\n</div>");
$templateCache.put("components/landing/common/additional-service-selector/home-delivery-zipcode-validator/home-delivery-zipcode-validator.directive.html","<div class=zipcodevalidator>\n    <div class=zipcodevalidator__container>\n        <div class=zipcodevalidator__container__content>\n            <p>{{ \'ZIPCODE_VALIDATION_TEXT\' | translate}}</p>\n            <ng-form name=zipValid>\n            <input type=text ng-model=zipcodeValidator.zipCode minlength=5 maxlength=5>\n            <button ng-class=\"{\'btn--loading\': zipcodeValidator.isValidating}\" ng-disabled=zipValid.$invalid ng-click=zipcodeValidator.validateZipcode(zipcodeValidator.zipCode)>{{ \'VALIDATE\' | translate}}</button>\n            </ng-form>\n        </div>\n        <p ng-if=\"zipcodeValidator.isSubmitted && zipcodeValidator.isValid\" class=zipcodevalidator__container__ok>{{\'HOMEDELIVERY_EVENING_VALID\' | translate}}</p>\n        <p ng-if=\"zipcodeValidator.isSubmitted && !zipcodeValidator.isValid\" class=zipcodevalidator__container__error>{{ \'HOMEDELIVERY_EVENING_INVALID\' | translate}}</p>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/home-pickup/home-pickup.directive.html","<div class=home-pickup>\n    <div class=home-pickup__container>\n        <div class=home-pickup__container__content>\n            <p>{{ \'HOMEPICKUP_HEADER_TEXT\' | translate}} *</p>\n            <ng-form name=homePickup.homepickupForm>\n                <input class=home-pickup__input placeholder=\"{{ \'HOMEPICKUP_PLACEHOLDER_TEXT\' | translate}}\" type=text ng-model=homePickup.locationInstruction required>\n            </ng-form>\n        </div>\n   </div>\n</div>\n");
$templateCache.put("components/landing/common/additional-service-selector/responsibility/responsibility.directive.html","<div class=responsibility>\n    <div class=responsibility__content>\n        <span ng-if=responsibility.hasValue class=responsibility__change ng-click=responsibility.changeValue()>{{ \'COD_CHANGE\' | translate}}</span>\n        <form name=responsibility.form>\n\n            <label ng-class=\"{\'disabled\': responsibility.hasValue}\" for=value>{{ \'COD_AMOUNT\' | translate}} *</label>\n            <input ng-if=!responsibility.hasValue ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ ng-model=responsibility.value ng-change=responsibility.valueChanged() name=value id=value type=number required>\n            <div ng-if=\"responsibility.value && responsibility.hasValue\" class=responsibility__valueAdded>{{responsibility.value | currency : \'kr\'}}</div>\n            <div ng-messages=responsibility.form.value.$error>\n                <div class=responsibility__valueerror ng-message=pattern>{{ \'COD_DECIMAL_LIMIT_ERROR_MESSAGE\' | translate }}</div>\n                <div class=responsibility__valueerror ng-message=max>{{ \'COD_MAX_AMOUNT_ERROR_MESSAGE\' | translate}}</div>\n            </div>\n        </form>\n        <button ng-class=\"{\'disabled\': responsibility.form.$invalid, \'hidden\': responsibility.hasValue}\" ng-click=responsibility.validate(responsibility.value)>{{ \'COD_ADD\' | translate}}</button>\n    </div>\n</div>\n");
$templateCache.put("components/landing/common/delivery-option-selector/next-weekday-validator/next-weekday-validator.directive.html","<div class=next-weekday-validator>\n    <div class=next-weekday-validator__container>\n        <div class=next-weekday-validator__container__content>\n            <p>{{ \'ZIPCODE_VALIDATION_TEXT\' | translate}}</p>\n\n            <ng-form class=next-weekday-validator__form name=zipValid>\n                <input type=text class=next-weekday-validator__form__input placeholder=\"{{ \'ZIPCODE_VALIDATION_PLACEHOLDER_FROM\' | translate}}\" ng-model=nextWeekdayValidator.fromzipCode minlength=5 maxlength=5>\n\n                <div class=next-weekday-validator__form__separator>&mdash;</div>\n\n                <input type=text class=next-weekday-validator__form__input placeholder=\"{{ \'ZIPCODE_VALIDATION_PLACEHOLDER_TO\' | translate}}\" ng-model=nextWeekdayValidator.zipCode minlength=5 maxlength=5>\n\n                <button class=\"btn btn--blue next-weekday-validator__form__btn\" ng-class=\"{\'btn--loading\': nextWeekdayValidator.isValidating}\" ng-disabled=zipValid.$invalid ng-click=\"nextWeekdayValidator.validateNextWeekday(nextWeekdayValidator.fromzipCode, nextWeekdayValidator.zipCode, nextWeekdayValidator.productCode)\">\n                    {{ \'VALIDATE\' | translate}}\n                </button>\n            </ng-form>\n        </div>\n\n        <div ng-if=nextWeekdayValidator.isSubmitted>\n            <p ng-if=\"nextWeekdayValidator.isValid && nextWeekdayValidator.validatedData\" class=next-weekday-validator__container__valid>\n                {{ \'NEXT_WEEKDAY_VALID\' | translate:{ dropofftime: nextWeekdayValidator.validatedData.latestTimeForDropOff } }}\n            </p>\n\n            <p ng-if=!nextWeekdayValidator.isValid class=next-weekday-validator__container__error>\n                {{ \'NEXT_WEEKDAY_INVALID\' | translate}}\n            </p>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/dk/product-group-product-selector/parcel-value/parcel-value.html","<label>{{ \'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_LABEL\' | translate }}:</label>\n\n<ng-form>\n    <div ng-class=\"{ invalid: !$ctrl.isValid && $ctrl.isProductSubmitted }\">\n        <input type=text pattern=\\d+ placeholder={{$ctrl.insuranceInputPlaceholder}} ng-model=$ctrl.product.parcelValue ng-change=$ctrl.handleParcelValueChange($ctrl.product)>\n        <span>DKK</span>\n    </div>\n\n    <button class=\"btn btn--blue\" ng-class=\"{ \'btn--loading\': $ctrl.isVerifyingParcelValue }\" ng-click=$ctrl.verifyParcelValue($ctrl.product) ng-disabled=!$ctrl.product.parcelValue>\n        {{ \'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_BUTTON\' | translate }}\n    </button>\n</ng-form>\n\n<p ng-show=\"$ctrl.product.hasVerifiedParcelValue && !$ctrl.isTooExpensive\">\n    <span ng-if=$ctrl.insurancePrice>\n        {{ \'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_INSURANCE_COSTS\' | translate:{cost: ($ctrl.insurancePrice | price) + \' DKK\'} }}\n    </span>\n    <span ng-if=!$ctrl.insurancePrice>{{ \'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_INSURANCE_INCLUDED\' | translate }}</span>\n</p>\n\n<p class=error ng-show=\"$ctrl.product.hasVerifiedParcelValue && $ctrl.isTooExpensive\" ng-bind-html=\"\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_MAX_INSURANCE_MESSAGE\' | translate:{ maxInsuranceAmount: ($ctrl.highestInsuranceAmount | number) }\">\n</p>\n\n<p class=error ng-show=\"!$ctrl.isValid && $ctrl.isProductSubmitted\">\n    {{\'DK_VALUABLE_TYPE_SELECTOR_PARCEL_VALUE_REQUIRED_MESSAGE\' | translate}}\n</p>\n");
$templateCache.put("components/landing/dk/product-group-selector/product-list/product-list.html","<ul>\n    <li ng-repeat=\"productGroup in $ctrl.filteredProductGroups\">\n        <dk-product-list-product is-customer-company=$ctrl.isCustomerCompany product-group=productGroup ng-class=\"{active: productGroup.selected}\" ng-click=$ctrl.selectProduct(productGroup)>\n        </dk-product-list-product>\n    </li>\n</ul>\n");
$templateCache.put("components/landing/dk/product-group-selector/product-list/product.html","<header>\n    <h3>{{$ctrl.product.name}}</h3>\n\n    <span>\n        {{ ($ctrl.product.isTraceable ? \'PARCEL_SELECTOR_TRACEABLE\' : \'PARCEL_SELECTOR_NON_TRACEABLE\') | translate}}\n    </span>\n</header>\n\n<main>\n    <img ng-src=\"{{$ctrl.product.imageUrl | imagePath}}\" alt={{$ctrl.product.name}}>\n    <span ng-if=\"$ctrl.product.type === \'valuables\' || $ctrl.product.group.type === \'valuables\'\">{{ \'SECURE\' | translate}}</span>\n</main>\n\n<footer>\n    {{ \'PARCEL_SELECTOR_FROM\' | translate }}\n    <strong>{{ $ctrl.product.price | price }}</strong>\n    {{ $ctrl.product.priceUnit }}\n</footer>\n");
$templateCache.put("components/landing/dk/product-selector/dk-product-viewer/dk-product-viewer.directive.html","<div class=dk-product-viewer>\n    <div class=dk-product-viewer__product ng-repeat=\"product in productViewer.filteredProducts\" ng-class=\"{\'dk-product-viewer__product--active\': product.productId === productViewer.selectedProduct.productId}\" ng-click=productViewer.selectProduct(product)>\n        <div class=dk-product-viewer__product__header>\n            <div class=dk-product-viewer__product__header__title>{{product.name}}</div>\n            <div class=dk-product-viewer__product__header__info>\n                <span ng-if=!product.nonTraceable>{{ \'PARCEL_SELECTOR_TRACEABLE\' | translate}}</span>\n                <span ng-if=product.nonTraceable>{{ \'PARCEL_SELECTOR_NON_TRACEABLE\' | translate}}</span>\n            </div>\n        </div>\n        <div class=dk-product-viewer__product__image ng-class=\"{\'--secure\': product.type === \'valuables\'}\" secure-content=\"{{ \'SECURE\' | translate}}\">\n            <img ng-src=\"{{product.imageUrl | imagePath }}\">\n        </div>\n        <div class=dk-product-viewer__product__footer>\n            <div class=dk-product-viewer__product__footer__price>\n                {{ \'PARCEL_SELECTOR_FROM\' | translate}}\n                <span ng-if=productViewer.isCustomerCompany>{{product.price | price}}</span>\n                <span ng-if=!productViewer.isCustomerCompany>{{(product.price * (1 + (product.vat / 10000)) | price)}}</span>\n                DKK\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("components/landing/dk/product-selector/dk-slider/dk-slider.directive.html","<div class=dk-slider>\n    <div class=dk-slider__header>\n        <label for=dkSliderWeightInput class=dk-slider__header__title>{{\'DK_PRODUCT_SELECTOR_LABEL\' | translate}}:</label>\n\n        <dk-slider-input class=dk-slider__header__input weight=slider.weight></dk-slider-input>\n        <span class=slider-info ng-if=\"slider.weight.value > 20 && slider.weight.unit === \'kg\'\" ng-bind-html=\"\'DK_PRODUCT_SELECTOR_20KG_INFO\' | translate | trustHtml\"></span>\n\n    </div>\n\n    <div class=dk-slider__slider>\n        <md-slider-container>\n            <md-slider aria-label=\"Choose weight\" ng-model=slider.selectedIndex ng-change=slider.updateIndex(slider.selectedIndex) min=0 max=\"{{slider.slideroptions.length - 1}}\" step=1>\n            </md-slider>\n        </md-slider-container>\n\n        <ul class=dk-slider__slider__labels>\n            <li class=dk-slider__slider__labels__label ng-class=\"{\'dk-slider__slider__labels__label--international\': slider.receiverCountryCode !== \'DK\',\n                           \'dk-slider__slider__labels__label--domestic\': slider.receiverCountryCode === \'DK\'}\" id=slider-list ng-repeat=\"tick in slider.slideroptions\" ng-hide=\"$odd && slider.receiverCountryCode === \'DK\'\">\n                <span class=dk-slider__slider__labels__value>{{tick.label}}</span>\n                <span class=dk-slider__slider__labels__unit>{{tick.unit}}</span>\n            </li>\n        </ul>\n    </div>\n</div>\n");
$templateCache.put("components/landing/dk/product-selector/dk-slider/slider-input.directive.html","<div class=slider-input>\n    <input type=text id=dkSliderWeightInput class=slider-input__value ng-model=ctrl._weight.value ng-change=ctrl.onChange(ctrl._weight.value) ng-focus=ctrl.onFocus(ctrl._weight.value) ng-keydown=ctrl.onKeydown($event) ng-blur=ctrl.onBlur(ctrl._weight.value)>\n    <div class=slider-input__unit ng-class=\"{\'slider-input__unit--faded\': ctrl.isFocussed}\" ng-hide=ctrl.hasUnitInValue>\n        {{ctrl._weight.unit}}\n    </div>\n</div>\n");
$templateCache.put("components/shared/common/product-table/letters/letters.directive.html","<table class=product-table ng-show=\"ctrl.letters.length > 0\" ng-class=\"{\'product-table--receipt\': ctrl.isReceipt}\">\n\n    <tr class=product-table__header>\n        <th></th>\n        <th>{{ \'PRODUCT\' | translate}}</th>\n        <th class=hidden-xs>{{ \'QUANTITY\' | translate}}</th>\n        <th class=hidden-xs></th>\n        <th>{{ \'PRICE\' | translate}}</th>\n        <th></th>\n    </tr>\n    <tbody ng-repeat=\"product in ctrl.letters track by $index\">\n\n        <tr class=product-table__label>\n            <td></td>\n            <td class=product-table__bold>\n                <div class=product-table__title>\n                    {{product.name}}\n                    <span ng-if=product.selectedWeight.value> - {{product.selectedWeight.value}}{{product.selectedWeight.unit}}</span>\n\n                    <span ng-repeat=\"stars in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | onlyVisibleGroupings\">*</span>\n\n                    <span ng-repeat=\"deliveryOption in product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings\" class=product-table__title__delivery-option-icon ng-style=\"{\'background-image\': \'url(\' + (deliveryOption.iconUrl | imagePath) + \')\'}\" ng-if=deliveryOption.iconUrl>\n                    </span>\n                </div>\n\n                <div class=product-table__subrow>\n                    <span ng-if=\"product.receiver.address.countryCode !== product.sender.address.countryCode\">{{ \'INTERNATIONAL\' | translate}}</span>\n                    <div ng-repeat=\"deliveryOption in (deliveryOptions = (product.additionalServices | filter: { selected: true, type: \'deliveryOption\' } | onlyVisibleGroupings))\">\n                        <span>{{deliveryOption.shortName || deliveryOption.name}}</span>\n                    </div>\n                    <div ng-repeat=\"included in product.additionalServices | filter: { included: true, selected: true, type: \'!deliveryOption\' } | onlyVisibleGroupings\">\n                        <span>{{included.shortName}}</span>\n                    </div>\n                    <div ng-repeat=\"service in product.additionalServices | filter: { selected: true, type: \'!deliveryOption\', included: \'!true\' } | onlyVisibleGroupings\">\n                        <span>*</span>\n                        <span>{{service.shortName || service.name}}</span>\n                    </div>\n                </div>\n\n                <div class=\"product-table__form visible-xs\" ng-if=\"\'main.payment\' | isState\">\n                    <button class=\"product-table__form__button product-table__form__button--decrease\" type=button ng-disabled=ctrl.isSubmitting ng-click=\"ctrl.decrease($event, product)\">\n                    </button>\n                    <input class=product-table__form__input type=number step=1 min=1 max=999 ng-disabled=ctrl.isSubmitting o ng-model=product.quantity ng-blur=ctrl.onBlur(product)>\n                    <button type=button ng-disabled=ctrl.isSubmitting class=\"product-table__form__button product-table__form__button--increase\" ng-click=ctrl.increase(product)>\n                    </button>\n                </div>\n            </td>\n\n            <td colspan=2 class=\"product-table__quantity hidden-xs\">\n                    <div class=product-table__form ng-if=\"\'main.receipt\' | isState\">\n                     <span class=product-table__form__quantity>x {{product.quantity}}</span>\n                    </div>\n                <div class=product-table__form ng-if=\"\'main.payment\' | isState\">\n                    <button class=\"product-table__form__button product-table__form__button--decrease\" type=button ng-disabled=ctrl.isSubmitting ng-click=\"ctrl.decrease($event, product)\">\n                    </button>\n                    <input class=product-table__form__input type=number step=1 min=1 max=999 ng-disabled=ctrl.isSubmitting ng-model=product.quantity ng-blur=ctrl.onBlur(product)>\n                    <button type=button ng-disabled=ctrl.isSubmitting class=\"product-table__form__button product-table__form__button--increase\" ng-click=ctrl.increase(product)>\n                    </button>\n                </div>\n            </td>\n\n            <td>\n                <div class=product-table__price>\n                    {{(ctrl.isCustomerCompany ? ctrl.getPriceForParcel(product) : ctrl.getVatPriceForParcel(product)) | price }}\n                    <small>{{product.priceUnit | prettifyCurrency}}</small>\n                </div>\n            </td>\n            <td>\n            </td>\n        </tr>\n    </tbody>\n</table>\n");
$templateCache.put("components/shared/common/product-table/receiver/receiver.directive.html","<div class=product-table__subrow>\n    <div>{{product.receiver.attn}}</div>\n    <div ng-if=\"countryCode === \'SE\'\">{{product.receiver.address.co}}</div>\n    <div>{{product.receiver.address.street}}</div>\n    <div ng-if=\"isInternational && product.receiver.address.co\">{{product.receiver.address.co}}</div>\n    <div ng-if=\"isInternational && product.receiver.address.extraStreet1\">{{product.receiver.address.extraStreet1}}</div>\n    <div ng-if=\"isInternational && product.receiver.address.extraStreet2\">{{product.receiver.address.extraStreet2}}</div>\n    <div ng-if=\"isInternational && product.receiver.address.extraStreet3\">{{product.receiver.address.extraStreet3}}</div>\n    <div>{{product.receiver.address.doorCode}}</div>\n    <div>{{product.receiver.address.zipCode}} {{product.receiver.address.city}}</div>\n    <div ng-if=isInternational>{{product.toCountry.name}}</div>\n    <div>{{product.receiver.email}}</div>\n    <div>{{product.receiver.phone}}</div>\n</div>\n");
$templateCache.put("components/shared/common/product-table/sender/sender.directive.html","<div class=product-table__subrow>\n    <div ng-if=isCustomerCompany>{{sender.name}}</div>\n    <div ng-if=\"isCustomerCompany && sender.company.organizationNumber\">{{\'ADDRESS_PAGE_SENDER_ORGANIZATION_NUMBER_SHORT\' | translate}}: {{sender.company.organizationNumber}}</div>\n    <div>{{sender.address.street}}</div>\n    <div>{{sender.address.zipCode}} {{sender.address.city}}</div>\n    <div>{{sender.email}}</div>\n</div>\n");
$templateCache.put("components/user/history/order-details/event-box/event-box.html","<div class=\"box sidebar__box event-box\">\n      <div class=box__header>\n        <div class=box__header__title>{{ \'SIDEBAR_EVENTBOX_JOURNEY\' | translate}}</div>\n    </div>\n    <div class=box__content--no-padding>\n        <div ng-class=\"{\'event-box__event--spinner\': loading }\"></div>\n        <div class=event-box__events>\n            <div class=event-box__event ng-class=\"{\n                    \'event-box__event--first\': $first,\n                    \'event-box__event--last\': $last,\n                    \'event-box__event--delivered\': event.status === \'DELIVERED\',\n                    \'event-box__event--enroute\': event.status === \'EN_ROUTE\',\n                    \'event-box__event--returned\': event.status === \'RETURNED\',\n                    \'event-box__event--package\': event.status === \'AVAILABLE_FOR_DELIVERY\',\n                    \'event-box__event--info\': event.status === \'OTHER\' || event.status === \'INFORMED\',\n                    \'event-box__event--delayed\': event.status === \'DELAYED\' || event.status === \'EXPECTED_DELAY\',\n                    \'event-box__event--stopped\': event.status === \'STOPPED\' || event.status === \'DELIVERY_REFUSED\' || event.status === \'DELIVERY_IMPOSSIBLE\'\n                }\" ng-repeat=\"event in events | orderBy:\'-\'\">\n                <div ng-include=\"\'event-content.html\'\"></div>\n            </div>\n        </div>\n    </div>\n   \n</div>\n\n<script type=text/ng-template id=event-content.html>\n    <div class=\"event-box__event__content\">\n        <div class=\"event-box__event__country\">{{event.location.countryCode}}</div>\n        <div class=\"event-box__event__location\" ng-if=\"event.location.name\">{{event.location.name}}</div>\n        <div class=\"event-box__event__time\">{{event.time | date:\'yyyy-MM-dd HH:mm\'}}</div>\n        <div class=\"event-box__event__description\" ng-if=\"event.description\">{{event.description}}</div>\n    </div>\n</script>\n");}]);